webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function() {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		var result = [];
		for(var i = 0; i < this.length; i++) {
			var item = this[i];
			if(item[2]) {
				result.push("@media " + item[2] + "{" + item[1] + "}");
			} else {
				result.push(item[1]);
			}
		}
		return result.join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};


/***/ },
/* 15 */,
/* 16 */
/***/ function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
var stylesInDom = {},
	memoize = function(fn) {
		var memo;
		return function () {
			if (typeof memo === "undefined") memo = fn.apply(this, arguments);
			return memo;
		};
	},
	isOldIE = memoize(function() {
		return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
	}),
	getHeadElement = memoize(function () {
		return document.head || document.getElementsByTagName("head")[0];
	}),
	singletonElement = null,
	singletonCounter = 0,
	styleElementsInsertedAtTop = [];

module.exports = function(list, options) {
	if(typeof DEBUG !== "undefined" && DEBUG) {
		if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};
	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (typeof options.singleton === "undefined") options.singleton = isOldIE();

	// By default, add <style> tags to the bottom of <head>.
	if (typeof options.insertAt === "undefined") options.insertAt = "bottom";

	var styles = listToStyles(list);
	addStylesToDom(styles, options);

	return function update(newList) {
		var mayRemove = [];
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			domStyle.refs--;
			mayRemove.push(domStyle);
		}
		if(newList) {
			var newStyles = listToStyles(newList);
			addStylesToDom(newStyles, options);
		}
		for(var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];
			if(domStyle.refs === 0) {
				for(var j = 0; j < domStyle.parts.length; j++)
					domStyle.parts[j]();
				delete stylesInDom[domStyle.id];
			}
		}
	};
}

function addStylesToDom(styles, options) {
	for(var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];
		if(domStyle) {
			domStyle.refs++;
			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}
			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];
			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}
			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles(list) {
	var styles = [];
	var newStyles = {};
	for(var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};
		if(!newStyles[id])
			styles.push(newStyles[id] = {id: id, parts: [part]});
		else
			newStyles[id].parts.push(part);
	}
	return styles;
}

function insertStyleElement(options, styleElement) {
	var head = getHeadElement();
	var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
	if (options.insertAt === "top") {
		if(!lastStyleElementInsertedAtTop) {
			head.insertBefore(styleElement, head.firstChild);
		} else if(lastStyleElementInsertedAtTop.nextSibling) {
			head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			head.appendChild(styleElement);
		}
		styleElementsInsertedAtTop.push(styleElement);
	} else if (options.insertAt === "bottom") {
		head.appendChild(styleElement);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement(styleElement) {
	styleElement.parentNode.removeChild(styleElement);
	var idx = styleElementsInsertedAtTop.indexOf(styleElement);
	if(idx >= 0) {
		styleElementsInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement(options) {
	var styleElement = document.createElement("style");
	styleElement.type = "text/css";
	insertStyleElement(options, styleElement);
	return styleElement;
}

function createLinkElement(options) {
	var linkElement = document.createElement("link");
	linkElement.rel = "stylesheet";
	insertStyleElement(options, linkElement);
	return linkElement;
}

function addStyle(obj, options) {
	var styleElement, update, remove;

	if (options.singleton) {
		var styleIndex = singletonCounter++;
		styleElement = singletonElement || (singletonElement = createStyleElement(options));
		update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
		remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
	} else if(obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function") {
		styleElement = createLinkElement(options);
		update = updateLink.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
			if(styleElement.href)
				URL.revokeObjectURL(styleElement.href);
		};
	} else {
		styleElement = createStyleElement(options);
		update = applyToTag.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
		};
	}

	update(obj);

	return function updateStyle(newObj) {
		if(newObj) {
			if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
				return;
			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;
		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag(styleElement, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (styleElement.styleSheet) {
		styleElement.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = styleElement.childNodes;
		if (childNodes[index]) styleElement.removeChild(childNodes[index]);
		if (childNodes.length) {
			styleElement.insertBefore(cssNode, childNodes[index]);
		} else {
			styleElement.appendChild(cssNode);
		}
	}
}

function applyToTag(styleElement, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		styleElement.setAttribute("media", media)
	}

	if(styleElement.styleSheet) {
		styleElement.styleSheet.cssText = css;
	} else {
		while(styleElement.firstChild) {
			styleElement.removeChild(styleElement.firstChild);
		}
		styleElement.appendChild(document.createTextNode(css));
	}
}

function updateLink(linkElement, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	if(sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = linkElement.href;

	linkElement.href = URL.createObjectURL(blob);

	if(oldSrc)
		URL.revokeObjectURL(oldSrc);
}


/***/ },
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var store_1 = __webpack_require__(80);
var app_catalog_service_1 = __webpack_require__(62);
var app_actions_1 = __webpack_require__(439);
var debug, debugOff = function () {
    var any = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        any[_i] = arguments[_i];
    }
};
"production" !== 'production' && (debug = __webpack_require__(4)('app:AppService'));
var AppService = (function () {
    function AppService(_store, _appCatalogService) {
        this._store = _store;
        this._appCatalogService = _appCatalogService;
        this.state = {
            app: null,
            catalog: null,
            router: null,
            prodOptionsDropdownIsOpened: false,
            spaFrameIsVisible: false,
            standardGeneratorIsVisible: false,
            selectedControl: null,
        };
        this.events = {
            previewVisibilityChanged: new core_1.EventEmitter()
        };
        this._subscribeToAppStateChanges();
        this._appCatalogService.init(this);
    }
    AppService.prototype.selectProduct = function (product) {
        this.selectedProduct = product;
    };
    AppService.prototype.init = function () {
        var self = this;
        this._appCatalogService.getCatalogDataAsync();
        window.setTimeout(function () {
            return self.state.app.startArrowIsOpened === false && self.displayStartArrow();
        }, 2000);
    };
    AppService.prototype._subscribeToAppStateChanges = function () {
        var self = this;
        var catalogState = this._store.select('catalog'), appState = this._store.select('app'), routerState = this._store.select('router');
        catalogState.subscribe(function (response) { return self.state.catalog = response; });
        appState.subscribe(function (response) { return self.state.app = response; });
        routerState.subscribe(function (response) { return self.state.router = response; });
    };
    AppService.prototype.toggleNavigationMenu = function () {
        debugOff('Toggle navigation menu');
        if (this.state.app.navigationMenuIsVisible === true) {
            this.hideNavigationMenu();
        }
        else {
            this.displayNavigationMenu();
        }
    };
    AppService.prototype.displayNavigationMenu = function () {
        if (this.state.app.navigationMenuIsVisible === false) {
            debugOff('Display navigation menu');
            this._store.dispatch({ type: app_actions_1.DISPLAY_NAVIGATION_MENU });
        }
    };
    AppService.prototype.hideNavigationMenu = function () {
        if (this.state.app.navigationMenuIsVisible === true) {
            debugOff('Hide navigation menu');
            this._store.dispatch({ type: app_actions_1.HIDE_NAVIGATION_MENU });
        }
    };
    AppService.prototype.displayStartArrow = function () {
        if (this.state.app.startArrowIsVisible === false) {
            debugOff('Display start arrow');
            this._store.dispatch({ type: app_actions_1.DISPLAY_START_ARROW });
        }
    };
    AppService.prototype.hideStartArrow = function () {
        if (this.state.app.startArrowIsVisible === true) {
            debugOff('Hide start arrow');
            this._store.dispatch({ type: app_actions_1.HIDE_START_ARROW });
        }
    };
    AppService.prototype.displayProductDetailsModal = function (product) {
        if (this.state.app.productDetailsModalIsVisible === false) {
            debugOff('Display product details modal');
            product && (this.selectedProduct = product);
            this._store.dispatch({ type: app_actions_1.DISPLAY_PRODUCT_DETAILS_MODAL });
        }
    };
    AppService.prototype.hideProductDetailsModal = function () {
        if (this.state.app.productDetailsModalIsVisible === true) {
            debugOff('Hide product details modal');
            this._store.dispatch({ type: app_actions_1.HIDE_PRODUCT_DETAILS_MODAL });
        }
    };
    AppService.prototype.displayPrintSummaryModal = function () {
        if (this.state.app.printSummaryModalIsVisible === false) {
            debugOff('Display print summary modal');
            this._store.dispatch({ type: app_actions_1.DISPLAY_PRINT_SUMMARY_MODAL });
        }
    };
    AppService.prototype.hidePrintSummaryModal = function () {
        if (this.state.app.printSummaryModalIsVisible === true) {
            debugOff('Hide print summary modal');
            this._store.dispatch({ type: app_actions_1.HIDE_PRINT_SUMMARY_MODAL });
        }
    };
    AppService.prototype.displayEmailSummaryModal = function () {
        if (this.state.app.emailSummaryModalIsVisible === false) {
            debugOff('Display email summary modal');
            this._store.dispatch({ type: app_actions_1.DISPLAY_EMAIL_SUMMARY_MODAL });
        }
    };
    AppService.prototype.hideEmailSummaryModal = function () {
        if (this.state.app.emailSummaryModalIsVisible === true) {
            debugOff('Hide email summary modal');
            this._store.dispatch({ type: app_actions_1.HIDE_EMAIL_SUMMARY_MODAL });
        }
    };
    AppService.prototype.displayAlertModal = function () {
        if (this.state.app.alertModalIsVisible === false) {
            debugOff('Display email summary modal');
            this._store.dispatch({ type: app_actions_1.DISPLAY_ALERT_MODAL });
        }
    };
    AppService.prototype.hideAlertModal = function () {
        if (this.state.app.alertModalIsVisible === true) {
            debugOff('Hide email summary modal');
            this._store.dispatch({ type: app_actions_1.HIDE_ALERT_MODAL });
        }
    };
    AppService.prototype.displayOnlyDropdown = function () {
        if (this.state.app.onlyDropdownIsVisible === false) {
            debugOff('Display only dropdown');
            this._store.dispatch({ type: app_actions_1.DISPLAY_ONLY_DROPDOWN });
        }
    };
    AppService.prototype.displayAllContent = function () {
        if (this.state.app.onlyDropdownIsVisible === true) {
            debugOff('Display all content');
            this._store.dispatch({ type: app_actions_1.DISPLAY_ALL_CONTENT });
        }
    };
    AppService.prototype.displayOptionsMenu = function () {
        if (this.state.app.optionsMenuIsVisible === false) {
            debugOff('Display options menu');
            this._store.dispatch({ type: app_actions_1.DISPLAY_OPTIONS_MENU });
        }
    };
    AppService.prototype.hideOptionsMenu = function () {
        if (this.state.app.optionsMenuIsVisible === true) {
            debugOff('Hide options menu');
            this._store.dispatch({ type: app_actions_1.HIDE_OPTIONS_MENU });
        }
    };
    AppService.prototype.togglePreview = function () {
        debugOff('Toggle preview');
        if (this.state.app.previewIsVisible === true) {
            this.hidePreview();
        }
        else {
            this.displayPreview();
        }
    };
    AppService.prototype.displayPreview = function () {
        if (this.state.app.previewIsVisible === false) {
            debugOff('Display preview');
            this._store.dispatch({ type: app_actions_1.DISPLAY_PREVIEW });
            this.events.previewVisibilityChanged.emit(true);
        }
    };
    AppService.prototype.hidePreview = function () {
        if (this.state.app.previewIsVisible === true) {
            debugOff('Hide preview');
            this._store.dispatch({ type: app_actions_1.HIDE_PREVIEW });
            this.events.previewVisibilityChanged.emit(false);
        }
    };
    return AppService;
}());
AppService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [store_1.Store,
        app_catalog_service_1.AppCatalogService])
], AppService);
exports.AppService = AppService;


/***/ },
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var Observable_1 = __webpack_require__(1);
var product_categories_service_1 = __webpack_require__(433);
var products_service_1 = __webpack_require__(435);
var cart_service_1 = __webpack_require__(35);
var scene_service_1 = __webpack_require__(199);
var generators_service_1 = __webpack_require__(99);
var debug, debugOff = function () {
    var any = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        any[_i] = arguments[_i];
    }
};
"production" !== 'production' && (debug = __webpack_require__(4)('app:CatalogService'));
var CatalogService = (function () {
    function CatalogService(_productCategoriesService, _productsService, _cartService, _sceneService, _generatorsService, _applicationRef) {
        this._productCategoriesService = _productCategoriesService;
        this._productsService = _productsService;
        this._cartService = _cartService;
        this._sceneService = _sceneService;
        this._generatorsService = _generatorsService;
        this._applicationRef = _applicationRef;
        this._globals = {
            selectedGenerator: null,
            selectedTowelWarmer: null,
            selectedControl: null
        };
        this.imgPaths = {
            categories: 'media/categories/',
            products: 'media/products/',
            options: 'media/options/',
            scene: 'media/scene/',
        };
        this.events = {
            catalogDataLoadedAsync: new core_1.EventEmitter(),
            categorySelected: new core_1.EventEmitter()
        };
        this._state = {
            catalogDataIsLoaded: false
        };
        this.getProductCategoriesList = this._productCategoriesService.getProductCategoriesList
            .bind(this._productCategoriesService);
        this.getProductCategoryById = this._productCategoriesService.getProductCategoryById
            .bind(this._productCategoriesService);
        this.getRootCategory = this._productCategoriesService.getRootCategory
            .bind(this._productCategoriesService);
        this.getFeaturedProductThumb = this._productCategoriesService.getFeaturedProductThumb
            .bind(this._productCategoriesService);
        this.getCategoryThumbnailPath = this._productCategoriesService.getCategoryThumbnailPath
            .bind(this._productCategoriesService);
        this.shallowCloneSubcategories = this._productCategoriesService.shallowCloneSubcategories
            .bind(this._productCategoriesService);
        this.shallowCloneCategory = this._productCategoriesService.shallowCloneCategory
            .bind(this._productCategoriesService);
        this.getAllProducts = this._productCategoriesService.getAllProducts
            .bind(this._productCategoriesService);
        this.getProductsList = this._productsService.getProductsList
            .bind(this._productsService);
        this.getProductsByCategoryId = this._productsService.getProductsByCategoryId
            .bind(this._productsService);
        this.getProductById = this._productsService.getProductById
            .bind(this._productsService);
        this.getProductOptionImage = this._productsService.getProductOptionImage
            .bind(this._productsService);
        this.getProductOptionName = this._productsService.getProductOptionName
            .bind(this._productsService);
    }
    CatalogService.prototype.init = function (AppService) {
        var _this = this;
        this._appService = AppService;
        this._productsService.init(this, AppService);
        this._productCategoriesService.init(this);
        this._cartService.init(this, this.applyVspaProdAddLogic, this.applyVspaProdRemoveLogic);
        this._sceneService.init(this);
        this._productsService.events.productStateRefreshed.subscribe(function (event) {
            _this.applyVspaProdStateRefreshLogic(event.product);
        });
    };
    CatalogService.prototype.getCatalogDataAsync = function () {
        var self = this;
        var observable = Observable_1.Observable.forkJoin(this._productCategoriesService.getAllCategoriesAsync(), this._productsService.getAllProductsAsync());
        observable.subscribe(function (response) { return self._handleCatalogData(response); }, function (error) { return console.error(error); });
        return observable;
    };
    CatalogService.prototype.getGlobals = function () {
        return this._globals;
    };
    CatalogService.prototype.checkCatalogDataIsLoaded = function () {
        debugOff('Check catalog data is loaded:', this._state.catalogDataIsLoaded);
        return this._state.catalogDataIsLoaded;
    };
    CatalogService.prototype.checkCurrentCategoryChanged = function (changes) {
        debugOff('Check if current products category has changed');
        var currentCategoryId = changes.catalogState.currentValue.currentCategoryId, previousCategoryId = changes.catalogState.previousValue.currentCategoryId;
        if (changes.catalogState !== undefined &&
            previousCategoryId !== currentCategoryId) {
            debugOff('Current products category changed');
            debugOff('Previous category id:', previousCategoryId);
            debugOff('Current category id:', currentCategoryId);
            return currentCategoryId;
        }
        return false;
    };
    CatalogService.prototype.checkRenderModeChanged = function (changes) {
        debugOff('Check if catalog render mode has changed');
        var currentRenderMode = changes.catalogState.currentValue.renderMode, previousRenderMode = changes.catalogState.previousValue.renderMode;
        if (changes.catalogState !== undefined &&
            previousRenderMode !== currentRenderMode) {
            debugOff('Current products category changed');
            debugOff('Previous category id:', previousRenderMode);
            debugOff('Current category id:', currentRenderMode);
            return currentRenderMode;
        }
        return false;
    };
    CatalogService.prototype._handleCatalogData = function (response) {
        debugOff('Catalog data:', response);
        this._normaliseCatalogData();
        this._state.catalogDataIsLoaded = true;
        this.events.catalogDataLoadedAsync.emit({
            productCategoriesList: this._productCategoriesService.getProductCategoriesList(),
            rootCategory: this._productCategoriesService.getRootCategory()
        });
    };
    CatalogService.prototype._normaliseCatalogData = function () {
        var products = this.getProductsList();
        this._productCategoriesService.generateCategoriesThree();
        this._productCategoriesService.updateCategoriesSortOrder();
        this._productCategoriesService.appendProductAPI(products);
        this._productsService.initProducts(products, this._globals);
        this._productsService.appendProductAPI(products);
        this._cartService.appendProductAPI(products);
        this._sceneService.appendProductAPI(products);
        this._sortProductsInCategories();
        this._updateProductsSortOrder();
    };
    CatalogService.prototype._sortProductsInCategories = function () {
        var self = this;
        var prodCategsList = this._productCategoriesService.getProductCategoriesList();
        debugOff('Product categories:', prodCategsList);
        prodCategsList.forEach(function (category) {
            category.products = self.getProductsByCategoryId(category.id);
            debugOff('"' + category.id + '" products:', category.products);
        });
    };
    CatalogService.prototype._updateProductsSortOrder = function () {
        var prodCategsList = this._productCategoriesService.getProductCategoriesList();
        debugOff('Product categories:', prodCategsList);
        prodCategsList.forEach(function (category) {
            if (category.products === undefined ||
                category.products.length === 0) {
                return;
            }
            category.products.forEach(function (product) {
                if (product.taxonomy === undefined) {
                    product.taxonomy = {};
                }
                if (product.taxonomy.sortOrder === undefined) {
                    product.taxonomy.sortOrder = {};
                    product.taxonomy.sortOrder[category.id] = 0;
                }
            });
            category.products.sort(function (a, b) {
                return a.taxonomy.sortOrder[category.id] - b.taxonomy.sortOrder[category.id];
            });
        });
    };
    CatalogService.prototype.applyVspaProdStateRefreshLogic = function (product) {
        if (product.taxonomy &&
            product.taxonomy.categories[0] === 'towel-warmers-200' &&
            product.isAddedToCart === true) {
        }
    };
    CatalogService.prototype.applyVspaProdAddLogic = function (product) {
        var _this = this;
        if (product.taxonomy.currentCategoryId === 'isteamx-touch-screen-controls' ||
            product.taxonomy.currentCategoryId === 'airtempo-wireless-controls' ||
            product.taxonomy.currentCategoryId === 'itempo-controls' ||
            product.taxonomy.currentCategoryId === 'itempo-plus-controls') {
            var iSteamTouchScreenControls = this.getProductCategoryById('isteamx-touch-screen-controls');
            this._cartService.removeProductsByCategory(iSteamTouchScreenControls);
            var airTempoWirelessControls = this.getProductCategoryById('airtempo-wireless-controls');
            this._cartService.removeProductsByCategory(airTempoWirelessControls);
            var itempocontrols = this.getProductCategoryById('itempo-controls');
            this._cartService.removeProductsByCategory(itempocontrols);
            var itempopluscontrols = this.getProductCategoryById('itempo-plus-controls');
            this._cartService.removeProductsByCategory(itempopluscontrols);
        }
        if (product.taxonomy.currentCategoryId === 'isteamx-touch-screen-controls' ||
            product.taxonomy.currentCategoryId === 'airtempo-wireless-controls' ||
            product.taxonomy.currentCategoryId === 'itempo-controls' ||
            product.taxonomy.currentCategoryId === 'itempo-plus-controls') {
            if (product.code.toUpperCase() !== 'ISTEAMX_PACKAGE' &&
                product.code.toUpperCase() !== 'AIRTEMPO_PACKAGE' &&
                product.code.toUpperCase() !== 'ITEMPO_PACKAGE' &&
                product.code.toUpperCase() !== 'ITEMPO_PLUS_PACKAGE') {
                var linearSteamHead = this.getProductById('LINEAR_STEAMHEAD');
                linearSteamHead.isVisible = false;
            }
            if (product.code.toUpperCase() !== 'ISTEAMX_PACKAGE' &&
                product.code.toUpperCase() !== 'AIRTEMPO_PACKAGE' &&
                product.code.toUpperCase() !== 'ITEMPO_PACKAGE' &&
                product.code.toUpperCase() !== 'ITEMPO_PLUS_PACKAGE') {
                var linearSteamHead = this.getProductById('LINEAR_STEAMHEAD');
                linearSteamHead.isVisible = false;
            }
        }
        if (product.taxonomy.currentCategoryId === 'control-packages') {
            var individualControls = this.getProductCategoryById('individual-controls');
            this._cartService.removeProductsByCategory(individualControls);
        }
        if (product.taxonomy.currentCategoryId === 'individual-controls') {
            var controlPackages = this.getProductCategoryById('control-packages');
            this._cartService.removeProductsByCategory(controlPackages);
        }
        if (product.code.toUpperCase() === 'ISTEAMX_PACKAGE' ||
            product.code.toUpperCase() === 'AIRTEMPO_PACKAGE' ||
            product.code.toUpperCase() === 'ITEMPO_PLUS_PACKAGE' ||
            product.code.toUpperCase() === 'ITEMPO_PACKAGE') {
            var controlsAccessories = this.getProductCategoryById('controls-accessories');
            controlsAccessories.isVisible = true;
        }
        if (product.code.toUpperCase() === 'BASIC_BUTLER_PACKAGE') {
            var controlsAccessories = this.getProductCategoryById('controls-accessories-2');
            controlsAccessories.isVisible = true;
        }
        if (product.code.toUpperCase() === 'ISTEAMX_PACKAGE') {
            var twaccesory2 = this.getProductById('CHROMASTEAMX');
            twaccesory2.isVisible = true;
            var twaccesory3 = this.getProductById('AUDIOX');
            twaccesory3.isVisible = false;
            var twaccesory4 = this.getProductById('CHROMASTEAM');
            twaccesory4.isVisible = false;
            var twaccesory5 = this.getProductById('CHROMASTEAMDUOX');
            twaccesory5.isVisible = true;
        }
        else {
            var twaccesory5 = this.getProductById('CHROMASTEAMDUOX');
            twaccesory5.isVisible = false;
        }
        if (product.code.toUpperCase() === 'XBUTLER_PACKAGE') {
            var twaccesory2 = this.getProductById('CHROMASTEAMX');
            twaccesory2.isVisible = true;
            var twaccesory3 = this.getProductById('AUDIOX');
            twaccesory3.isVisible = true;
            var twaccesory4 = this.getProductById('CHROMASTEAM');
            twaccesory4.isVisible = false;
        }
        else if (product.code.toUpperCase() === 'XDREAM_PACKAGE') {
            var twaccesory2 = this.getProductById('CHROMASTEAMX');
            twaccesory2.isVisible = false;
            var twaccesory3 = this.getProductById('AUDIOX');
            twaccesory3.isVisible = false;
            var twaccesory4 = this.getProductById('CHROMASTEAM');
            twaccesory4.isVisible = true;
            var twaccesory8 = this.getProductById('AROMASTEAM');
            twaccesory8.isVisible = false;
            var twaccesory9 = this.getProductById('AROMA_STEAM_OIL_1L');
            twaccesory9.isVisible = true;
        }
        if (product.code.toUpperCase() === 'XDREAM_PACKAGE' ||
            product.code.toUpperCase() === 'BLISS_PACKAGE') {
            var twaccesory2 = this.getProductById('CHROMASTEAMX');
            twaccesory2.isVisible = false;
            var twaccesory3 = this.getProductById('AUDIOX');
            twaccesory3.isVisible = false;
            var twaccesory8 = this.getProductById('AROMASTEAM');
            twaccesory8.isVisible = false;
        }
        else {
            var twaccesory2 = this.getProductById('CHROMASTEAMX');
            twaccesory2.isVisible = true;
            var twaccesory3 = this.getProductById('AUDIOX');
            twaccesory3.isVisible = true;
            var twaccesory8 = this.getProductById('AROMASTEAM');
            twaccesory8.isVisible = true;
        }
        if (product.code.toUpperCase() === 'AIRTEMPO_PACKAGE') {
            var twaccesory2 = this.getProductById('CHROMASTEAMX');
            twaccesory2.isVisible = false;
            var twaccesory3 = this.getProductById('AUDIOX');
            twaccesory3.isVisible = true;
            var twaccesory4 = this.getProductById('CHROMASTEAM');
            twaccesory4.isVisible = true;
        }
        if (product.code.toUpperCase() === 'AIRBUTLER_PACKAGE') {
            var twaccesory2 = this.getProductById('CHROMASTEAMX');
            twaccesory2.isVisible = false;
            var twaccesory3 = this.getProductById('AUDIOX');
            twaccesory3.isVisible = true;
            var twaccesory4 = this.getProductById('CHROMASTEAM');
            twaccesory4.isVisible = true;
            var twaccesory7 = this.getProductById('AROMASTEAM');
            twaccesory7.isVisible = true;
            var twaccesory8 = this.getProductById('AROMA_STEAM_OIL_1L');
            twaccesory8.isVisible = true;
        }
        if (product.code.toUpperCase() === 'BUTLER_PACKAGE') {
            var twaccesory2 = this.getProductById('CHROMASTEAMX');
            twaccesory2.isVisible = false;
            var twaccesory3 = this.getProductById('AUDIOX');
            twaccesory3.isVisible = true;
            var twaccesory4 = this.getProductById('CHROMASTEAM');
            twaccesory4.isVisible = true;
        }
        if (product.code.toUpperCase() === 'ITEMPO_PACKAGE') {
            var twaccesory2 = this.getProductById('CHROMASTEAMX');
            twaccesory2.isVisible = false;
            var twaccesory3 = this.getProductById('AUDIOX');
            twaccesory3.isVisible = true;
            var twaccesory4 = this.getProductById('CHROMASTEAM');
            twaccesory4.isVisible = true;
        }
        if (product.code.toUpperCase() === 'ITEMPO_PLUS_PACKAGE') {
            var twaccesory2 = this.getProductById('CHROMASTEAMX');
            twaccesory2.isVisible = false;
            var twaccesory3 = this.getProductById('AUDIOX');
            twaccesory3.isVisible = true;
            var twaccesory4 = this.getProductById('CHROMASTEAM');
            twaccesory4.isVisible = true;
        }
        if (product.code.toUpperCase() === 'BASIC_BUTLER_PACKAGE') {
            var twaccesory2 = this.getProductById('CHROMASTEAMX');
            twaccesory2.isVisible = false;
            var twaccesory3 = this.getProductById('AUDIOX');
            twaccesory3.isVisible = true;
            var twaccesory4 = this.getProductById('CHROMASTEAM');
            twaccesory4.isVisible = false;
            var twaccesory8 = this.getProductById('AROMASTEAM');
            twaccesory8.isVisible = false;
            var twaccesory9 = this.getProductById('AROMA_STEAM_OIL_1L');
            twaccesory9.isVisible = false;
        }
        if (product.code.toUpperCase() === 'XDREAM_PACKAGE' ||
            product.code.toUpperCase() === 'XBUTLER_PACKAGE' ||
            product.code.toUpperCase() === 'AIRBUTLER_PACKAGE' ||
            product.code.toUpperCase() === 'BUTLER_PACKAGE') {
            var controlsAccessories = this.getProductCategoryById('controls-accessories');
            controlsAccessories.isVisible = false;
            this._cartService.removeProductsByCategory(controlsAccessories);
        }
        if (product.code.toUpperCase() === 'VALET_PACKAGE') {
            var towelWarmersAccessories = this.getProductCategoryById('towel-warmers-accessories');
            this._cartService.removeProductsByCategory(towelWarmersAccessories);
        }
        if (product.taxonomy.currentCategoryId === 'towel-warmers-200') {
            var towelWarmerAccessories = this.getProductCategoryById('towel-warmers-accessories');
            towelWarmerAccessories.isVisible = true;
        }
        if (product.taxonomy.currentCategoryId === 'towel-warmers-200' ||
            product.taxonomy.currentCategoryId === 'towel-warmers-300' ||
            product.taxonomy.currentCategoryId === 'towel-warmers-500' ||
            product.taxonomy.currentCategoryId === 'towel-warmers-800') {
            var towelWarmers200 = this.getProductCategoryById('towel-warmers-200');
            product.taxonomy.currentCategoryId !== 'towel-warmers-200' &&
                this._cartService.removeProductsByCategory(towelWarmers200);
            var towelWarmers300 = this.getProductCategoryById('towel-warmers-300');
            product.taxonomy.currentCategoryId !== 'towel-warmers-300' &&
                this._cartService.removeProductsByCategory(towelWarmers300);
            var towelWarmers500 = this.getProductCategoryById('towel-warmers-500');
            product.taxonomy.currentCategoryId !== 'towel-warmers-500' &&
                this._cartService.removeProductsByCategory(towelWarmers500);
            var towelWarmers800 = this.getProductCategoryById('towel-warmers-800');
            product.taxonomy.currentCategoryId !== 'towel-warmers-800' &&
                this._cartService.removeProductsByCategory(towelWarmers800);
        }
        if (product.taxonomy.currentCategoryId === 'towel-warmers-200') {
            var twaccesory2 = this.getProductById('DIGITAL_TIMER');
            twaccesory2.isVisible = false;
        }
        if (product.taxonomy.currentCategoryId === 'towel-warmers-300' ||
            product.taxonomy.currentCategoryId === 'towel-warmers-500') {
            var twaccesory4 = this.getProductById('DIGITAL_TIMER');
            twaccesory4.isVisible = false;
        }
        var generatorsList = ['MX4EC1', 'MX5EC1', 'MX6EC1'];
        generatorsList.forEach(function (generator) {
            if (product.code.toUpperCase() === generator) {
                "1  ";
                var basicbutler = _this.getProductById('BASIC_BUTLER_PACKAGE');
                basicbutler.isVisible = false;
                _this._cartService.removeProduct(basicbutler);
                var itempocontrols = _this.getProductCategoryById('itempo-controls');
                itempocontrols.isVisible = false;
                _this._cartService.removeProductsByCategory(itempocontrols);
            }
        });
        if (product.taxonomy.currentCategoryId === 'individual-controls' ||
            product.taxonomy.currentCategoryId === 'control-packages') {
            this._appService.state.selectedControl = product;
        }
        if (product.vSpa.standardGeneratorIsVisible === true) {
            this._appService.state.standardGeneratorIsVisible = true;
        }
        this._cartService.cartProducts.forEach(function (cartProduct) {
            if (cartProduct.vSpa.standardGeneratorIsVisible === true) {
                _this._appService.state.standardGeneratorIsVisible = true;
            }
        });
        this._appService.state.standardGeneratorIsVisible === true &&
            setTimeout(function () {
                _this._applicationRef.tick();
            }, 10);
    };
    CatalogService.prototype.applyVspaProdRemoveLogic = function (product) {
        var _this = this;
        if (product.code.toUpperCase() === 'XDREAM') {
            var spaTherapies = this.getProductCategoryById('spa-therapies');
            spaTherapies.isVisible = true;
        }
        if (product.code.toUpperCase() === 'ISTEAMX_PACKAGE' ||
            product.code.toUpperCase() === 'AIRTEMPO_PACKAGE' ||
            product.code.toUpperCase() === 'ITEMPO_PLUS_PACKAGE' ||
            product.code.toUpperCase() === 'ITEMPO_PACKAGE') {
            var controlsAccessories = this.getProductCategoryById('controls-accessories');
            controlsAccessories.isVisible = false;
            this._cartService.removeProductsByCategory(controlsAccessories);
        }
        if (product.code.toUpperCase() === 'BASIC_BUTLER_PACKAGE') {
            var controlsAccessories = this.getProductCategoryById('controls-accessories-2');
            controlsAccessories.isVisible = false;
            this._cartService.removeProductsByCategory(controlsAccessories);
        }
        if (product.code.toUpperCase() === 'XDREAM_PACKAGE') {
            var spaTherapies = this.getProductCategoryById('spa-therapies');
            spaTherapies.isVisible = true;
        }
        if (product.taxonomy.currentCategoryId === 'towel-warmers-200') {
            if (product.code.toUpperCase() === 'ISTEAMX_PACKAGE' || product.code.toUpperCase() === 'XDREAM_PACKAGE' || product.code.toUpperCase() === 'XBUTLER_PACKAGE' || product.code.toUpperCase() === 'AIRTEMPO_PACKAGE' || product.code.toUpperCase() === 'AIRBUTLER_PACKAGE' || product.code.toUpperCase() === 'BUTLER_PACKAGE' || product.code.toUpperCase() === 'ITEMPO_PACKAGE' || product.code.toUpperCase() === 'ITEMPO_PLUS_PACKAGE') {
                var twaccesory2 = this.getProductById('CHROMASTEAMX');
                twaccesory2.isVisible = true;
                var twaccesory3 = this.getProductById('AUDIOX');
                twaccesory3.isVisible = true;
                var twaccesory4 = this.getProductById('CHROMASTEAM');
                twaccesory4.isVisible = true;
            }
            var towelWarmerAccessoriesCat = this.getProductCategoryById('towel-warmers-accessories');
            towelWarmerAccessoriesCat.isVisible = false;
        }
        if (product.taxonomy.currentCategoryId === 'isteamx-touch-screen-controls' ||
            product.taxonomy.currentCategoryId === 'airtempo-wireless-controls' ||
            product.taxonomy.currentCategoryId === 'itempo-controls' ||
            product.taxonomy.currentCategoryId === 'itempo-plus-controls') {
            var linearSteamHead = this.getProductById('LINEAR_STEAMHEAD');
            linearSteamHead.isVisible = true;
        }
        var generatorsList = ['MSSUPER1EC1', 'MSSUPER2EC1', 'MSSUPER3EC1', 'MX4EC1', 'MX5EC1', 'MX6EC1'];
        generatorsList.forEach(function (generator) {
            if (product.code.toUpperCase() === generator) {
                var iTempoPack = _this.getProductById('ITEMPO_PACKAGE');
                iTempoPack.isVisible = true;
                _this._cartService.removeProduct(iTempoPack);
            }
        });
        if (product.taxonomy.currentCategoryId === 'individual-controls' ||
            product.taxonomy.currentCategoryId === 'control-packages') {
            this._appService.state.selectedControl = null;
        }
        this._appService.state.standardGeneratorIsVisible = false;
        setTimeout(function () {
            _this._applicationRef.tick();
        }, 10);
    };
    return CatalogService;
}());
CatalogService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [product_categories_service_1.ProductCategoriesService,
        products_service_1.ProductsService,
        cart_service_1.CartService,
        scene_service_1.SceneService,
        generators_service_1.GeneratorsService,
        core_1.ApplicationRef])
], CatalogService);
exports.CatalogService = CatalogService;


/***/ },
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var debug, debugOff = function () {
    var any = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        any[_i] = arguments[_i];
    }
};
"production" !== 'production' && (debug = __webpack_require__(4)('app:CartService'));
var CartService = (function () {
    function CartService() {
        this.cartProducts = [];
        this.productEvent = new core_1.EventEmitter();
        this.replacementProduct = null;
        this.state = {
            totalPrice: 0,
            isEmpty: true,
        };
        this.events = {
            cartUpdated: new core_1.EventEmitter(),
        };
    }
    CartService.prototype.init = function (catalogService, applyVspaProdAddLogic, applyVspaProdRemoveLogic) {
        this._catalogService = catalogService;
        this._productsService = catalogService._productsService;
        this._applyVspaProdAddLogic = applyVspaProdAddLogic.bind(catalogService);
        this._applyVspaProdRemoveLogic = applyVspaProdRemoveLogic.bind(catalogService);
    };
    CartService.prototype._addProduct = function (product, categoryId) {
        product.taxonomy.currentCategoryId = categoryId;
        debugOff('Taxonomy current category id:', categoryId);
        this.state.isEmpty === false && (this.state.isEmpty = true);
        var prodCateg = product.getCurrentCategory();
        debugOff('Product category:', prodCateg);
        if (prodCateg.allowInCartMultipleProds === false) {
            this.replacementProduct = product;
            this.removeProductsByCategory(prodCateg);
            this.replacementProduct = null;
        }
        if (product.taxonomy.currentCategoryId === 'generators') {
            this._catalogService._globals.selectedGenerator = product.code;
            this._productsService.refreshAllProducts();
        }
        if (product.taxonomy.currentCategoryId === 'towel-warmers-200' ||
            product.taxonomy.currentCategoryId === 'towel-warmers-300' ||
            product.taxonomy.currentCategoryId === 'towel-warmers-500') {
            this._catalogService._globals.selectedTowelWarmer = product.code;
            this._productsService.refreshAllProducts();
        }
        product.refreshState();
        this._applyVspaProdAddLogic(product);
        this.cartProducts.push(product);
        product.isAddedToCart = true;
        this._updateProductsSortOrder();
        this.updateTotalPrice();
        this.events.cartUpdated.emit(null);
    };
    CartService.prototype.removeProduct = function (product) {
        var index = this.cartProducts.indexOf(product);
        index >= 0 && this.cartProducts.splice(index, 1);
        if (this.cartProducts.length === 0 &&
            this.state.isEmpty === true) {
            this.state.isEmpty = false;
        }
        product.isAddedToCart = false;
        if (product.taxonomy.currentCategoryId === 'generators') {
            this._catalogService._globals.selectedGenerator = null;
            this._productsService.refreshAllProducts();
        }
        if (product.taxonomy.currentCategoryId === 'towel-warmers-200' ||
            product.taxonomy.currentCategoryId === 'towel-warmers-300' ||
            product.taxonomy.currentCategoryId === 'towel-warmers-500') {
            this._catalogService._globals.selectedTowelWarmer = null;
            this._productsService.refreshAllProducts();
        }
        this._applyVspaProdRemoveLogic(product);
        this.updateTotalPrice();
        this.events.cartUpdated.emit(null);
    };
    CartService.prototype._checkProductIsInCart = function (product) {
        return this.cartProducts.indexOf(product) !== -1;
    };
    CartService.prototype.emptyCart = function () {
        var tempCartProdsList = [];
        this.cartProducts.forEach(function (cartProduct) { return tempCartProdsList.push(cartProduct); });
        tempCartProdsList.forEach(function (cartProduct) { return cartProduct.removeFromCart(); });
        console.log('Empty cart - Cart produts', this.cartProducts);
    };
    CartService.prototype.updateTotalPrice = function () {
        var _this = this;
        this.state.totalPrice = 0;
        this.cartProducts.forEach(function (product) {
            _this.state.totalPrice += product.getPrice();
        });
    };
    CartService.prototype.getCartProducts = function () {
        debugOff('Get cart products');
        return this.cartProducts;
    };
    CartService.prototype.getCartProductsByCategory = function (category) {
        debugOff('Get cart products by "' + category.id + '"');
        return this.cartProducts.filter(function (product) {
            return product.taxonomy.categories.indexOf(category.id) !== -1;
        });
    };
    CartService.prototype.removeProductsByCategory = function (category) {
        debugOff('Remove products from cart by "' + category.id + '" category');
        var products = this.getCartProductsByCategory(category);
        debugOff('Cart category products:', products);
        products.forEach(function (product) {
            product.removeFromCart();
        });
    };
    CartService.prototype._updateProductsSortOrder = function () {
        var self = this;
        this.cartProducts.sort(function (a, b) {
            var prodACat = a.getCurrentCategory();
            var prodBCat = b.getCurrentCategory();
            var sortValue;
            if (prodACat.sortOrder === prodBCat.sortOrder) {
                sortValue = a.taxonomy.sortOrder[prodACat.id] - b.taxonomy.sortOrder[prodBCat.id];
            }
            else {
                sortValue = prodACat.sortOrder - prodBCat.sortOrder;
            }
            return sortValue;
        });
    };
    CartService.prototype.appendProductAPI = function (products) {
        var _this = this;
        products.forEach(function (product) {
            product.toggleInCart = function (categoryId) {
                debugOff('Toggle add/remove "' + product.code + '" product in cart');
                var isInCart = product.isAddedToCart;
                if (isInCart === true) {
                    product.removeFromCart();
                }
                else {
                    product.addToCart(categoryId);
                }
            };
            product.addToCart = function (categoryId) {
                debugOff('Add "' + product.code + '" product in cart');
                _this._addProduct(product, categoryId);
            };
            product.removeFromCart = function () {
                debugOff('Remove "' + product.code + '" product from cart');
                _this.removeProduct(product);
            };
            product.getPrice = function () {
                debugOff('Get "' + product.code + '" product price');
                return product.price || 0;
            };
        });
    };
    return CartService;
}());
CartService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [])
], CartService);
exports.CartService = CartService;


/***/ },
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _ = __webpack_require__(68);
var cls = __webpack_require__(213);
var defaultSettings = __webpack_require__(871);
var dom = __webpack_require__(107);
var EventManager = __webpack_require__(868);
var guid = __webpack_require__(869);

var instances = {};

function Instance(element) {
  var i = this;

  i.settings = _.clone(defaultSettings);
  i.containerWidth = null;
  i.containerHeight = null;
  i.contentWidth = null;
  i.contentHeight = null;

  i.isRtl = dom.css(element, 'direction') === "rtl";
  i.isNegativeScroll = (function () {
    var originalScrollLeft = element.scrollLeft;
    var result = null;
    element.scrollLeft = -1;
    result = element.scrollLeft < 0;
    element.scrollLeft = originalScrollLeft;
    return result;
  })();
  i.negativeScrollAdjustment = i.isNegativeScroll ? element.scrollWidth - element.clientWidth : 0;
  i.event = new EventManager();
  i.ownerDocument = element.ownerDocument || document;

  function focus() {
    cls.add(element, 'ps-focus');
  }

  function blur() {
    cls.remove(element, 'ps-focus');
  }

  i.scrollbarXRail = dom.appendTo(dom.e('div', 'ps-scrollbar-x-rail'), element);
  i.scrollbarX = dom.appendTo(dom.e('div', 'ps-scrollbar-x'), i.scrollbarXRail);
  i.scrollbarX.setAttribute('tabindex', 0);
  i.event.bind(i.scrollbarX, 'focus', focus);
  i.event.bind(i.scrollbarX, 'blur', blur);
  i.scrollbarXActive = null;
  i.scrollbarXWidth = null;
  i.scrollbarXLeft = null;
  i.scrollbarXBottom = _.toInt(dom.css(i.scrollbarXRail, 'bottom'));
  i.isScrollbarXUsingBottom = i.scrollbarXBottom === i.scrollbarXBottom; // !isNaN
  i.scrollbarXTop = i.isScrollbarXUsingBottom ? null : _.toInt(dom.css(i.scrollbarXRail, 'top'));
  i.railBorderXWidth = _.toInt(dom.css(i.scrollbarXRail, 'borderLeftWidth')) + _.toInt(dom.css(i.scrollbarXRail, 'borderRightWidth'));
  // Set rail to display:block to calculate margins
  dom.css(i.scrollbarXRail, 'display', 'block');
  i.railXMarginWidth = _.toInt(dom.css(i.scrollbarXRail, 'marginLeft')) + _.toInt(dom.css(i.scrollbarXRail, 'marginRight'));
  dom.css(i.scrollbarXRail, 'display', '');
  i.railXWidth = null;
  i.railXRatio = null;

  i.scrollbarYRail = dom.appendTo(dom.e('div', 'ps-scrollbar-y-rail'), element);
  i.scrollbarY = dom.appendTo(dom.e('div', 'ps-scrollbar-y'), i.scrollbarYRail);
  i.scrollbarY.setAttribute('tabindex', 0);
  i.event.bind(i.scrollbarY, 'focus', focus);
  i.event.bind(i.scrollbarY, 'blur', blur);
  i.scrollbarYActive = null;
  i.scrollbarYHeight = null;
  i.scrollbarYTop = null;
  i.scrollbarYRight = _.toInt(dom.css(i.scrollbarYRail, 'right'));
  i.isScrollbarYUsingRight = i.scrollbarYRight === i.scrollbarYRight; // !isNaN
  i.scrollbarYLeft = i.isScrollbarYUsingRight ? null : _.toInt(dom.css(i.scrollbarYRail, 'left'));
  i.scrollbarYOuterWidth = i.isRtl ? _.outerWidth(i.scrollbarY) : null;
  i.railBorderYWidth = _.toInt(dom.css(i.scrollbarYRail, 'borderTopWidth')) + _.toInt(dom.css(i.scrollbarYRail, 'borderBottomWidth'));
  dom.css(i.scrollbarYRail, 'display', 'block');
  i.railYMarginHeight = _.toInt(dom.css(i.scrollbarYRail, 'marginTop')) + _.toInt(dom.css(i.scrollbarYRail, 'marginBottom'));
  dom.css(i.scrollbarYRail, 'display', '');
  i.railYHeight = null;
  i.railYRatio = null;
}

function getId(element) {
  return element.getAttribute('data-ps-id');
}

function setId(element, id) {
  element.setAttribute('data-ps-id', id);
}

function removeId(element) {
  element.removeAttribute('data-ps-id');
}

exports.add = function (element) {
  var newId = guid();
  setId(element, newId);
  instances[newId] = new Instance(element);
  return instances[newId];
};

exports.remove = function (element) {
  delete instances[getId(element)];
  removeId(element);
};

exports.get = function (element) {
  return instances[getId(element)];
};


/***/ },
/* 40 */,
/* 41 */,
/* 42 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return NG_VALUE_ACCESSOR; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * Used to provide a {@link ControlValueAccessor} for form controls.
 *
 * See {@link DefaultValueAccessor} for how to implement one.
 * @stable
 */
var /** @type {?} */ NG_VALUE_ACCESSOR = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["OpaqueToken"]('NgValueAccessor');
//# sourceMappingURL=control_value_accessor.js.map

/***/ },
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_operator_toPromise__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_operator_toPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_operator_toPromise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__facade_collection__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__facade_lang__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__private_import_core__ = __webpack_require__(393);
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return NG_VALIDATORS; });
/* harmony export (binding) */ __webpack_require__.d(exports, "c", function() { return NG_ASYNC_VALIDATORS; });
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return Validators; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */





/**
 * @param {?} value
 * @return {?}
 */
function isEmptyInputValue(value) {
    // we don't check for string here so it also works with arrays
    return value == null || value.length === 0;
}
/**
 * Providers for validators to be used for {@link FormControl}s in a form.
 *
 * Provide this using `multi: true` to add validators.
 *
 * ### Example
 *
 * {@example core/forms/ts/ng_validators/ng_validators.ts region='ng_validators'}
 * @stable
 */
var /** @type {?} */ NG_VALIDATORS = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["OpaqueToken"]('NgValidators');
/**
 * Providers for asynchronous validators to be used for {@link FormControl}s
 * in a form.
 *
 * Provide this using `multi: true` to add validators.
 *
 * See {@link NG_VALIDATORS} for more details.
 *
 * @stable
 */
var /** @type {?} */ NG_ASYNC_VALIDATORS = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["OpaqueToken"]('NgAsyncValidators');
/**
 * Provides a set of validators used by form controls.
 *
 * A validator is a function that processes a {\@link FormControl} or collection of
 * controls and returns a map of errors. A null map means that validation has passed.
 *
 * ### Example
 *
 * ```typescript
 * var loginControl = new FormControl("", Validators.required)
 * ```
 *
 * \@stable
 */
var Validators = (function () {
    function Validators() {
    }
    /**
     * Validator that requires controls to have a non-empty value.
     * @param {?} control
     * @return {?}
     */
    Validators.required = function (control) {
        return isEmptyInputValue(control.value) ? { 'required': true } : null;
    };
    /**
     * Validator that requires control value to be true.
     * @param {?} control
     * @return {?}
     */
    Validators.requiredTrue = function (control) {
        return control.value === true ? null : { 'required': true };
    };
    /**
     * Validator that requires controls to have a value of a minimum length.
     * @param {?} minLength
     * @return {?}
     */
    Validators.minLength = function (minLength) {
        return function (control) {
            if (isEmptyInputValue(control.value)) {
                return null; // don't validate empty values to allow optional controls
            }
            var /** @type {?} */ length = control.value ? control.value.length : 0;
            return length < minLength ?
                { 'minlength': { 'requiredLength': minLength, 'actualLength': length } } :
                null;
        };
    };
    /**
     * Validator that requires controls to have a value of a maximum length.
     * @param {?} maxLength
     * @return {?}
     */
    Validators.maxLength = function (maxLength) {
        return function (control) {
            var /** @type {?} */ length = control.value ? control.value.length : 0;
            return length > maxLength ?
                { 'maxlength': { 'requiredLength': maxLength, 'actualLength': length } } :
                null;
        };
    };
    /**
     * Validator that requires a control to match a regex to its value.
     * @param {?} pattern
     * @return {?}
     */
    Validators.pattern = function (pattern) {
        if (!pattern)
            return Validators.nullValidator;
        var /** @type {?} */ regex;
        var /** @type {?} */ regexStr;
        if (typeof pattern === 'string') {
            regexStr = "^" + pattern + "$";
            regex = new RegExp(regexStr);
        }
        else {
            regexStr = pattern.toString();
            regex = pattern;
        }
        return function (control) {
            if (isEmptyInputValue(control.value)) {
                return null; // don't validate empty values to allow optional controls
            }
            var /** @type {?} */ value = control.value;
            return regex.test(value) ? null :
                { 'pattern': { 'requiredPattern': regexStr, 'actualValue': value } };
        };
    };
    /**
     * No-op validator.
     * @param {?} c
     * @return {?}
     */
    Validators.nullValidator = function (c) { return null; };
    /**
     * Compose multiple validators into a single function that returns the union
     * of the individual error maps.
     * @param {?} validators
     * @return {?}
     */
    Validators.compose = function (validators) {
        if (!validators)
            return null;
        var /** @type {?} */ presentValidators = validators.filter(__WEBPACK_IMPORTED_MODULE_3__facade_lang__["c" /* isPresent */]);
        if (presentValidators.length == 0)
            return null;
        return function (control) {
            return _mergeErrors(_executeValidators(control, presentValidators));
        };
    };
    /**
     * @param {?} validators
     * @return {?}
     */
    Validators.composeAsync = function (validators) {
        if (!validators)
            return null;
        var /** @type {?} */ presentValidators = validators.filter(__WEBPACK_IMPORTED_MODULE_3__facade_lang__["c" /* isPresent */]);
        if (presentValidators.length == 0)
            return null;
        return function (control) {
            var /** @type {?} */ promises = _executeAsyncValidators(control, presentValidators).map(_convertToPromise);
            return Promise.all(promises).then(_mergeErrors);
        };
    };
    return Validators;
}());
/**
 * @param {?} obj
 * @return {?}
 */
function _convertToPromise(obj) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__private_import_core__["a" /* isPromise */])(obj) ? obj : __WEBPACK_IMPORTED_MODULE_1_rxjs_operator_toPromise__["toPromise"].call(obj);
}
/**
 * @param {?} control
 * @param {?} validators
 * @return {?}
 */
function _executeValidators(control, validators) {
    return validators.map(function (v) { return v(control); });
}
/**
 * @param {?} control
 * @param {?} validators
 * @return {?}
 */
function _executeAsyncValidators(control, validators) {
    return validators.map(function (v) { return v(control); });
}
/**
 * @param {?} arrayOfErrors
 * @return {?}
 */
function _mergeErrors(arrayOfErrors) {
    var /** @type {?} */ res = arrayOfErrors.reduce(function (res, errors) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__facade_lang__["c" /* isPresent */])(errors) ? __WEBPACK_IMPORTED_MODULE_2__facade_collection__["a" /* StringMapWrapper */].merge(res, errors) : res;
    }, {});
    return Object.keys(res).length === 0 ? null : res;
}
//# sourceMappingURL=validators.js.map

/***/ },
/* 55 */,
/* 56 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return PRIMARY_OUTLET; });
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return NavigationCancelingError; });
/* harmony export (immutable) */ exports["c"] = defaultUrlMatcher;
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * @whatItDoes Name of the primary outlet.
 *
 * @stable
 */
var /** @type {?} */ PRIMARY_OUTLET = 'primary';
var NavigationCancelingError = (function (_super) {
    __extends(NavigationCancelingError, _super);
    /**
     * @param {?} message
     */
    function NavigationCancelingError(message) {
        _super.call(this, message);
        this.message = message;
        this.stack = (new Error(message)).stack;
    }
    /**
     * @return {?}
     */
    NavigationCancelingError.prototype.toString = function () { return this.message; };
    return NavigationCancelingError;
}(Error));
function NavigationCancelingError_tsickle_Closure_declarations() {
    /** @type {?} */
    NavigationCancelingError.prototype.stack;
    /** @type {?} */
    NavigationCancelingError.prototype.message;
}
/**
 * @param {?} segments
 * @param {?} segmentGroup
 * @param {?} route
 * @return {?}
 */
function defaultUrlMatcher(segments, segmentGroup, route) {
    var /** @type {?} */ path = route.path;
    var /** @type {?} */ parts = path.split('/');
    var /** @type {?} */ posParams = {};
    var /** @type {?} */ consumed = [];
    var /** @type {?} */ currentIndex = 0;
    for (var /** @type {?} */ i = 0; i < parts.length; ++i) {
        if (currentIndex >= segments.length)
            return null;
        var /** @type {?} */ current = segments[currentIndex];
        var /** @type {?} */ p = parts[i];
        var /** @type {?} */ isPosParam = p.startsWith(':');
        if (!isPosParam && p !== current.path)
            return null;
        if (isPosParam) {
            posParams[p.substring(1)] = current;
        }
        consumed.push(current);
        currentIndex++;
    }
    if (route.pathMatch === 'full' &&
        (segmentGroup.hasChildren() || currentIndex < segments.length)) {
        return null;
    }
    else {
        return { consumed: consumed, posParams: posParams };
    }
}
//# sourceMappingURL=shared.js.map

/***/ },
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__abstract_control_directive__ = __webpack_require__(261);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return ControlContainer; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

/**
 * A directive that contains multiple {\@link NgControl}s.
 *
 * Only used by the forms module.
 *
 * \@stable
 */
var ControlContainer = (function (_super) {
    __extends(ControlContainer, _super);
    function ControlContainer() {
        _super.apply(this, arguments);
    }
    Object.defineProperty(ControlContainer.prototype, "formDirective", {
        /**
         * Get the form to which this container belongs.
         * @return {?}
         */
        get: function () { return null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ControlContainer.prototype, "path", {
        /**
         * Get the path to this container.
         * @return {?}
         */
        get: function () { return null; },
        enumerable: true,
        configurable: true
    });
    return ControlContainer;
}(__WEBPACK_IMPORTED_MODULE_0__abstract_control_directive__["a" /* AbstractControlDirective */]));
function ControlContainer_tsickle_Closure_declarations() {
    /** @type {?} */
    ControlContainer.prototype.name;
}
//# sourceMappingURL=control_container.js.map

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_observable_fromPromise__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_observable_fromPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_observable_fromPromise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_observable_of__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_observable_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_observable_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_operator_concatAll__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_operator_concatAll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_operator_concatAll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_every__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_every___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_operator_every__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_last__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_operator_last__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_operator_map__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_rxjs_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_mergeAll__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_mergeAll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs_operator_mergeAll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__private_import_core__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared__ = __webpack_require__(56);
/* harmony export (immutable) */ exports["h"] = shallowEqualArrays;
/* harmony export (immutable) */ exports["c"] = shallowEqual;
/* harmony export (immutable) */ exports["a"] = flatten;
/* unused harmony export first */
/* harmony export (immutable) */ exports["i"] = last;
/* unused harmony export and */
/* harmony export (immutable) */ exports["g"] = merge;
/* harmony export (immutable) */ exports["d"] = forEach;
/* harmony export (immutable) */ exports["e"] = waitForMap;
/* harmony export (immutable) */ exports["f"] = andObservables;
/* harmony export (immutable) */ exports["b"] = wrapIntoObservable;
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */









/**
 * @param {?} a
 * @param {?} b
 * @return {?}
 */
function shallowEqualArrays(a, b) {
    if (a.length !== b.length)
        return false;
    for (var /** @type {?} */ i = 0; i < a.length; ++i) {
        if (!shallowEqual(a[i], b[i]))
            return false;
    }
    return true;
}
/**
 * @param {?} a
 * @param {?} b
 * @return {?}
 */
function shallowEqual(a, b) {
    var /** @type {?} */ k1 = Object.keys(a);
    var /** @type {?} */ k2 = Object.keys(b);
    if (k1.length != k2.length) {
        return false;
    }
    var /** @type {?} */ key;
    for (var /** @type {?} */ i = 0; i < k1.length; i++) {
        key = k1[i];
        if (a[key] !== b[key]) {
            return false;
        }
    }
    return true;
}
/**
 * @param {?} a
 * @return {?}
 */
function flatten(a) {
    var /** @type {?} */ target = [];
    for (var /** @type {?} */ i = 0; i < a.length; ++i) {
        for (var /** @type {?} */ j = 0; j < a[i].length; ++j) {
            target.push(a[i][j]);
        }
    }
    return target;
}
/**
 * @param {?} a
 * @return {?}
 */
function first(a) {
    return a.length > 0 ? a[0] : null;
}
/**
 * @param {?} a
 * @return {?}
 */
function last(a) {
    return a.length > 0 ? a[a.length - 1] : null;
}
/**
 * @param {?} bools
 * @return {?}
 */
function and(bools) {
    return !bools.some(function (v) { return !v; });
}
/**
 * @param {?} m1
 * @param {?} m2
 * @return {?}
 */
function merge(m1, m2) {
    var /** @type {?} */ m = {};
    for (var attr in m1) {
        if (m1.hasOwnProperty(attr)) {
            m[attr] = m1[attr];
        }
    }
    for (var attr in m2) {
        if (m2.hasOwnProperty(attr)) {
            m[attr] = m2[attr];
        }
    }
    return m;
}
/**
 * @param {?} map
 * @param {?} callback
 * @return {?}
 */
function forEach(map, callback) {
    for (var prop in map) {
        if (map.hasOwnProperty(prop)) {
            callback(map[prop], prop);
        }
    }
}
/**
 * @param {?} obj
 * @param {?} fn
 * @return {?}
 */
function waitForMap(obj, fn) {
    var /** @type {?} */ waitFor = [];
    var /** @type {?} */ res = {};
    forEach(obj, function (a, k) {
        if (k === __WEBPACK_IMPORTED_MODULE_8__shared__["a" /* PRIMARY_OUTLET */]) {
            waitFor.push(__WEBPACK_IMPORTED_MODULE_5_rxjs_operator_map__["map"].call(fn(k, a), function (_) {
                res[k] = _;
                return _;
            }));
        }
    });
    forEach(obj, function (a, k) {
        if (k !== __WEBPACK_IMPORTED_MODULE_8__shared__["a" /* PRIMARY_OUTLET */]) {
            waitFor.push(__WEBPACK_IMPORTED_MODULE_5_rxjs_operator_map__["map"].call(fn(k, a), function (_) {
                res[k] = _;
                return _;
            }));
        }
    });
    if (waitFor.length > 0) {
        var /** @type {?} */ concatted$ = __WEBPACK_IMPORTED_MODULE_2_rxjs_operator_concatAll__["concatAll"].call(__WEBPACK_IMPORTED_MODULE_1_rxjs_observable_of__["of"].apply(void 0, waitFor));
        var /** @type {?} */ last$ = __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_last__["last"].call(concatted$);
        return __WEBPACK_IMPORTED_MODULE_5_rxjs_operator_map__["map"].call(last$, function () { return res; });
    }
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_rxjs_observable_of__["of"])(res);
}
/**
 * @param {?} observables
 * @return {?}
 */
function andObservables(observables) {
    var /** @type {?} */ merged$ = __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_mergeAll__["mergeAll"].call(observables);
    return __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_every__["every"].call(merged$, function (result) { return result === true; });
}
/**
 * @param {?} value
 * @return {?}
 */
function wrapIntoObservable(value) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__private_import_core__["a" /* isObservable */])(value)) {
        return value;
    }
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__private_import_core__["b" /* isPromise */])(value)) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_rxjs_observable_fromPromise__["fromPromise"])(value);
    }
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_rxjs_observable_of__["of"])(value);
}
//# sourceMappingURL=collection.js.map

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var store_1 = __webpack_require__(80);
var catalog_service_1 = __webpack_require__(28);
var catalog_actions_1 = __webpack_require__(436);
var debug, debugOff = function () {
    var any = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        any[_i] = arguments[_i];
    }
};
"production" !== 'production' && (debug = __webpack_require__(4)('app:AppCatalogService'));
var AppCatalogService = (function () {
    function AppCatalogService(_store, _catalogService) {
        this._store = _store;
        this._catalogService = _catalogService;
        this.getCatalogDataAsync = this._catalogService.getCatalogDataAsync.bind(this._catalogService);
        this.globals = this._catalogService.getGlobals();
    }
    AppCatalogService.prototype.init = function (AppService) {
        this._catalogService.init(AppService);
    };
    AppCatalogService.prototype.selectCategory = function (event) {
        if (typeof event === 'string') {
            event = {
                category: this._catalogService.getProductCategoryById(event)
            };
            debugOff('Update event from string to ProductCategory');
        }
        this._store.dispatch({
            type: catalog_actions_1.SELECT_PRODUCT_CATEGORY,
            payload: event.category
        });
    };
    AppCatalogService.prototype.selectRenderMode = function (renderMode) {
        debugOff('Select catalog render mode:', renderMode);
        this._store.dispatch({
            type: catalog_actions_1.SELECT_RENDER_MODE,
            payload: renderMode
        });
    };
    return AppCatalogService;
}());
AppCatalogService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [store_1.Store,
        catalog_service_1.CatalogService])
], AppCatalogService);
exports.AppCatalogService = AppCatalogService;


/***/ },
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var cls = __webpack_require__(213);
var dom = __webpack_require__(107);

var toInt = exports.toInt = function (x) {
  return parseInt(x, 10) || 0;
};

var clone = exports.clone = function (obj) {
  if (!obj) {
    return null;
  } else if (obj.constructor === Array) {
    return obj.map(clone);
  } else if (typeof obj === 'object') {
    var result = {};
    for (var key in obj) {
      result[key] = clone(obj[key]);
    }
    return result;
  } else {
    return obj;
  }
};

exports.extend = function (original, source) {
  var result = clone(original);
  for (var key in source) {
    result[key] = clone(source[key]);
  }
  return result;
};

exports.isEditable = function (el) {
  return dom.matches(el, "input,[contenteditable]") ||
         dom.matches(el, "select,[contenteditable]") ||
         dom.matches(el, "textarea,[contenteditable]") ||
         dom.matches(el, "button,[contenteditable]");
};

exports.removePsClasses = function (element) {
  var clsList = cls.list(element);
  for (var i = 0; i < clsList.length; i++) {
    var className = clsList[i];
    if (className.indexOf('ps-') === 0) {
      cls.remove(element, className);
    }
  }
};

exports.outerWidth = function (element) {
  return toInt(dom.css(element, 'width')) +
         toInt(dom.css(element, 'paddingLeft')) +
         toInt(dom.css(element, 'paddingRight')) +
         toInt(dom.css(element, 'borderLeftWidth')) +
         toInt(dom.css(element, 'borderRightWidth'));
};

exports.startScrolling = function (element, axis) {
  cls.add(element, 'ps-in-scrolling');
  if (typeof axis !== 'undefined') {
    cls.add(element, 'ps-' + axis);
  } else {
    cls.add(element, 'ps-x');
    cls.add(element, 'ps-y');
  }
};

exports.stopScrolling = function (element, axis) {
  cls.remove(element, 'ps-in-scrolling');
  if (typeof axis !== 'undefined') {
    cls.remove(element, 'ps-' + axis);
  } else {
    cls.remove(element, 'ps-x');
    cls.remove(element, 'ps-y');
  }
};

exports.env = {
  isWebKit: 'WebkitAppearance' in document.documentElement.style,
  supportsTouch: (('ontouchstart' in window) || window.DocumentTouch && document instanceof window.DocumentTouch),
  supportsIePointer: window.navigator.msMaxTouchPoints !== null
};


/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _ = __webpack_require__(68);
var cls = __webpack_require__(213);
var dom = __webpack_require__(107);
var instances = __webpack_require__(39);
var updateScroll = __webpack_require__(87);

function getThumbSize(i, thumbSize) {
  if (i.settings.minScrollbarLength) {
    thumbSize = Math.max(thumbSize, i.settings.minScrollbarLength);
  }
  if (i.settings.maxScrollbarLength) {
    thumbSize = Math.min(thumbSize, i.settings.maxScrollbarLength);
  }
  return thumbSize;
}

function updateCss(element, i) {
  var xRailOffset = {width: i.railXWidth};
  if (i.isRtl) {
    xRailOffset.left = i.negativeScrollAdjustment + element.scrollLeft + i.containerWidth - i.contentWidth;
  } else {
    xRailOffset.left = element.scrollLeft;
  }
  if (i.isScrollbarXUsingBottom) {
    xRailOffset.bottom = i.scrollbarXBottom - element.scrollTop;
  } else {
    xRailOffset.top = i.scrollbarXTop + element.scrollTop;
  }
  dom.css(i.scrollbarXRail, xRailOffset);

  var yRailOffset = {top: element.scrollTop, height: i.railYHeight};
  if (i.isScrollbarYUsingRight) {
    if (i.isRtl) {
      yRailOffset.right = i.contentWidth - (i.negativeScrollAdjustment + element.scrollLeft) - i.scrollbarYRight - i.scrollbarYOuterWidth;
    } else {
      yRailOffset.right = i.scrollbarYRight - element.scrollLeft;
    }
  } else {
    if (i.isRtl) {
      yRailOffset.left = i.negativeScrollAdjustment + element.scrollLeft + i.containerWidth * 2 - i.contentWidth - i.scrollbarYLeft - i.scrollbarYOuterWidth;
    } else {
      yRailOffset.left = i.scrollbarYLeft + element.scrollLeft;
    }
  }
  dom.css(i.scrollbarYRail, yRailOffset);

  dom.css(i.scrollbarX, {left: i.scrollbarXLeft, width: i.scrollbarXWidth - i.railBorderXWidth});
  dom.css(i.scrollbarY, {top: i.scrollbarYTop, height: i.scrollbarYHeight - i.railBorderYWidth});
}

module.exports = function (element) {
  var i = instances.get(element);

  i.containerWidth = element.clientWidth;
  i.containerHeight = element.clientHeight;
  i.contentWidth = element.scrollWidth;
  i.contentHeight = element.scrollHeight;

  var existingRails;
  if (!element.contains(i.scrollbarXRail)) {
    existingRails = dom.queryChildren(element, '.ps-scrollbar-x-rail');
    if (existingRails.length > 0) {
      existingRails.forEach(function (rail) {
        dom.remove(rail);
      });
    }
    dom.appendTo(i.scrollbarXRail, element);
  }
  if (!element.contains(i.scrollbarYRail)) {
    existingRails = dom.queryChildren(element, '.ps-scrollbar-y-rail');
    if (existingRails.length > 0) {
      existingRails.forEach(function (rail) {
        dom.remove(rail);
      });
    }
    dom.appendTo(i.scrollbarYRail, element);
  }

  if (!i.settings.suppressScrollX && i.containerWidth + i.settings.scrollXMarginOffset < i.contentWidth) {
    i.scrollbarXActive = true;
    i.railXWidth = i.containerWidth - i.railXMarginWidth;
    i.railXRatio = i.containerWidth / i.railXWidth;
    i.scrollbarXWidth = getThumbSize(i, _.toInt(i.railXWidth * i.containerWidth / i.contentWidth));
    i.scrollbarXLeft = _.toInt((i.negativeScrollAdjustment + element.scrollLeft) * (i.railXWidth - i.scrollbarXWidth) / (i.contentWidth - i.containerWidth));
  } else {
    i.scrollbarXActive = false;
  }

  if (!i.settings.suppressScrollY && i.containerHeight + i.settings.scrollYMarginOffset < i.contentHeight) {
    i.scrollbarYActive = true;
    i.railYHeight = i.containerHeight - i.railYMarginHeight;
    i.railYRatio = i.containerHeight / i.railYHeight;
    i.scrollbarYHeight = getThumbSize(i, _.toInt(i.railYHeight * i.containerHeight / i.contentHeight));
    i.scrollbarYTop = _.toInt(element.scrollTop * (i.railYHeight - i.scrollbarYHeight) / (i.contentHeight - i.containerHeight));
  } else {
    i.scrollbarYActive = false;
  }

  if (i.scrollbarXLeft >= i.railXWidth - i.scrollbarXWidth) {
    i.scrollbarXLeft = i.railXWidth - i.scrollbarXWidth;
  }
  if (i.scrollbarYTop >= i.railYHeight - i.scrollbarYHeight) {
    i.scrollbarYTop = i.railYHeight - i.scrollbarYHeight;
  }

  updateCss(element, i);

  if (i.scrollbarXActive) {
    cls.add(element, 'ps-active-x');
  } else {
    cls.remove(element, 'ps-active-x');
    i.scrollbarXWidth = 0;
    i.scrollbarXLeft = 0;
    updateScroll(element, 'left', 0);
  }
  if (i.scrollbarYActive) {
    cls.add(element, 'ps-active-y');
  } else {
    cls.remove(element, 'ps-active-y');
    i.scrollbarYHeight = 0;
    i.scrollbarYTop = 0;
    updateScroll(element, 'top', 0);
  }
};


/***/ },
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__facade_lang__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validators__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__checkbox_value_accessor__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__default_value_accessor__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__normalize_validator__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__number_value_accessor__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__radio_control_value_accessor__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__range_value_accessor__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__select_control_value_accessor__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__select_multiple_control_value_accessor__ = __webpack_require__(192);
/* harmony export (immutable) */ exports["a"] = controlPath;
/* harmony export (immutable) */ exports["d"] = setUpControl;
/* harmony export (immutable) */ exports["h"] = cleanUpControl;
/* harmony export (immutable) */ exports["e"] = setUpFormContainer;
/* harmony export (immutable) */ exports["b"] = composeValidators;
/* harmony export (immutable) */ exports["c"] = composeAsyncValidators;
/* harmony export (immutable) */ exports["g"] = isPropertyUpdated;
/* unused harmony export isBuiltInAccessor */
/* harmony export (immutable) */ exports["f"] = selectValueAccessor;
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */










/**
 * @param {?} name
 * @param {?} parent
 * @return {?}
 */
function controlPath(name, parent) {
    return parent.path.concat([name]);
}
/**
 * @param {?} control
 * @param {?} dir
 * @return {?}
 */
function setUpControl(control, dir) {
    if (!control)
        _throwError(dir, 'Cannot find control with');
    if (!dir.valueAccessor)
        _throwError(dir, 'No value accessor for form control with');
    control.validator = __WEBPACK_IMPORTED_MODULE_1__validators__["a" /* Validators */].compose([control.validator, dir.validator]);
    control.asyncValidator = __WEBPACK_IMPORTED_MODULE_1__validators__["a" /* Validators */].composeAsync([control.asyncValidator, dir.asyncValidator]);
    dir.valueAccessor.writeValue(control.value);
    // view -> model
    dir.valueAccessor.registerOnChange(function (newValue) {
        dir.viewToModelUpdate(newValue);
        control.markAsDirty();
        control.setValue(newValue, { emitModelToViewChange: false });
    });
    // touched
    dir.valueAccessor.registerOnTouched(function () { return control.markAsTouched(); });
    control.registerOnChange(function (newValue, emitModelEvent) {
        // control -> view
        dir.valueAccessor.writeValue(newValue);
        // control -> ngModel
        if (emitModelEvent)
            dir.viewToModelUpdate(newValue);
    });
    if (dir.valueAccessor.setDisabledState) {
        control.registerOnDisabledChange(function (isDisabled) { dir.valueAccessor.setDisabledState(isDisabled); });
    }
    // re-run validation when validator binding changes, e.g. minlength=3 -> minlength=4
    dir._rawValidators.forEach(function (validator) {
        if (((validator)).registerOnValidatorChange)
            ((validator)).registerOnValidatorChange(function () { return control.updateValueAndValidity(); });
    });
    dir._rawAsyncValidators.forEach(function (validator) {
        if (((validator)).registerOnValidatorChange)
            ((validator)).registerOnValidatorChange(function () { return control.updateValueAndValidity(); });
    });
}
/**
 * @param {?} control
 * @param {?} dir
 * @return {?}
 */
function cleanUpControl(control, dir) {
    dir.valueAccessor.registerOnChange(function () { return _noControlError(dir); });
    dir.valueAccessor.registerOnTouched(function () { return _noControlError(dir); });
    dir._rawValidators.forEach(function (validator) {
        if (validator.registerOnValidatorChange) {
            validator.registerOnValidatorChange(null);
        }
    });
    dir._rawAsyncValidators.forEach(function (validator) {
        if (validator.registerOnValidatorChange) {
            validator.registerOnValidatorChange(null);
        }
    });
    if (control)
        control._clearChangeFns();
}
/**
 * @param {?} control
 * @param {?} dir
 * @return {?}
 */
function setUpFormContainer(control, dir) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["f" /* isBlank */])(control))
        _throwError(dir, 'Cannot find control with');
    control.validator = __WEBPACK_IMPORTED_MODULE_1__validators__["a" /* Validators */].compose([control.validator, dir.validator]);
    control.asyncValidator = __WEBPACK_IMPORTED_MODULE_1__validators__["a" /* Validators */].composeAsync([control.asyncValidator, dir.asyncValidator]);
}
/**
 * @param {?} dir
 * @return {?}
 */
function _noControlError(dir) {
    return _throwError(dir, 'There is no FormControl instance attached to form control element with');
}
/**
 * @param {?} dir
 * @param {?} message
 * @return {?}
 */
function _throwError(dir, message) {
    var /** @type {?} */ messageEnd;
    if (dir.path.length > 1) {
        messageEnd = "path: '" + dir.path.join(' -> ') + "'";
    }
    else if (dir.path[0]) {
        messageEnd = "name: '" + dir.path + "'";
    }
    else {
        messageEnd = 'unspecified name attribute';
    }
    throw new Error(message + " " + messageEnd);
}
/**
 * @param {?} validators
 * @return {?}
 */
function composeValidators(validators) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["c" /* isPresent */])(validators) ? __WEBPACK_IMPORTED_MODULE_1__validators__["a" /* Validators */].compose(validators.map(__WEBPACK_IMPORTED_MODULE_4__normalize_validator__["a" /* normalizeValidator */])) : null;
}
/**
 * @param {?} validators
 * @return {?}
 */
function composeAsyncValidators(validators) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["c" /* isPresent */])(validators) ? __WEBPACK_IMPORTED_MODULE_1__validators__["a" /* Validators */].composeAsync(validators.map(__WEBPACK_IMPORTED_MODULE_4__normalize_validator__["b" /* normalizeAsyncValidator */])) :
        null;
}
/**
 * @param {?} changes
 * @param {?} viewModel
 * @return {?}
 */
function isPropertyUpdated(changes, viewModel) {
    if (!changes.hasOwnProperty('model'))
        return false;
    var /** @type {?} */ change = changes['model'];
    if (change.isFirstChange())
        return true;
    return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["e" /* looseIdentical */])(viewModel, change.currentValue);
}
var /** @type {?} */ BUILTIN_ACCESSORS = [
    __WEBPACK_IMPORTED_MODULE_2__checkbox_value_accessor__["a" /* CheckboxControlValueAccessor */],
    __WEBPACK_IMPORTED_MODULE_7__range_value_accessor__["a" /* RangeValueAccessor */],
    __WEBPACK_IMPORTED_MODULE_5__number_value_accessor__["a" /* NumberValueAccessor */],
    __WEBPACK_IMPORTED_MODULE_8__select_control_value_accessor__["a" /* SelectControlValueAccessor */],
    __WEBPACK_IMPORTED_MODULE_9__select_multiple_control_value_accessor__["a" /* SelectMultipleControlValueAccessor */],
    __WEBPACK_IMPORTED_MODULE_6__radio_control_value_accessor__["a" /* RadioControlValueAccessor */],
];
/**
 * @param {?} valueAccessor
 * @return {?}
 */
function isBuiltInAccessor(valueAccessor) {
    return BUILTIN_ACCESSORS.some(function (a) { return valueAccessor.constructor === a; });
}
/**
 * @param {?} dir
 * @param {?} valueAccessors
 * @return {?}
 */
function selectValueAccessor(dir, valueAccessors) {
    if (!valueAccessors)
        return null;
    var /** @type {?} */ defaultAccessor;
    var /** @type {?} */ builtinAccessor;
    var /** @type {?} */ customAccessor;
    valueAccessors.forEach(function (v) {
        if (v.constructor === __WEBPACK_IMPORTED_MODULE_3__default_value_accessor__["a" /* DefaultValueAccessor */]) {
            defaultAccessor = v;
        }
        else if (isBuiltInAccessor(v)) {
            if (builtinAccessor)
                _throwError(dir, 'More than one built-in value accessor matches form control with');
            builtinAccessor = v;
        }
        else {
            if (customAccessor)
                _throwError(dir, 'More than one custom value accessor matches form control with');
            customAccessor = v;
        }
    });
    if (customAccessor)
        return customAccessor;
    if (builtinAccessor)
        return builtinAccessor;
    if (defaultAccessor)
        return defaultAccessor;
    _throwError(dir, 'No valid value accessor for form control with');
    return null;
}
//# sourceMappingURL=shared.js.map

/***/ },
/* 79 */,
/* 80 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_dispatcher__ = __webpack_require__(420);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "Dispatcher", function() { return __WEBPACK_IMPORTED_MODULE_0__src_dispatcher__["a"]; });
Object.defineProperty(exports, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_ng2__ = __webpack_require__(644);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "INITIAL_REDUCER", function() { return __WEBPACK_IMPORTED_MODULE_1__src_ng2__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "INITIAL_STATE", function() { return __WEBPACK_IMPORTED_MODULE_1__src_ng2__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "_INITIAL_REDUCER", function() { return __WEBPACK_IMPORTED_MODULE_1__src_ng2__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "_INITIAL_STATE", function() { return __WEBPACK_IMPORTED_MODULE_1__src_ng2__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "_initialReducerFactory", function() { return __WEBPACK_IMPORTED_MODULE_1__src_ng2__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "_initialStateFactory", function() { return __WEBPACK_IMPORTED_MODULE_1__src_ng2__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "_storeFactory", function() { return __WEBPACK_IMPORTED_MODULE_1__src_ng2__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "_stateFactory", function() { return __WEBPACK_IMPORTED_MODULE_1__src_ng2__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "_reducerFactory", function() { return __WEBPACK_IMPORTED_MODULE_1__src_ng2__["i"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "provideStore", function() { return __WEBPACK_IMPORTED_MODULE_1__src_ng2__["j"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "StoreModule", function() { return __WEBPACK_IMPORTED_MODULE_1__src_ng2__["k"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_reducer__ = __webpack_require__(421);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "Reducer", function() { return __WEBPACK_IMPORTED_MODULE_2__src_reducer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_state__ = __webpack_require__(422);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "State", function() { return __WEBPACK_IMPORTED_MODULE_3__src_state__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_store__ = __webpack_require__(423);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "Store", function() { return __WEBPACK_IMPORTED_MODULE_4__src_store__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_utils__ = __webpack_require__(424);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "combineReducers", function() { return __WEBPACK_IMPORTED_MODULE_5__src_utils__["a"]; });






//# sourceMappingURL=index.js.map

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(115);
var store_1 = __webpack_require__(80);
var app_service_1 = __webpack_require__(23);
var debug, debugOff = function () {
    var any = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        any[_i] = arguments[_i];
    }
};
"production" !== 'production' && (debug = __webpack_require__(4)('app:NavigationService'));
var NavigationService = (function () {
    function NavigationService(_store, _appService, _router) {
        this._store = _store;
        this._appService = _appService;
        this._router = _router;
        this.state = {
            currentPage: 'catalog'
        };
    }
    NavigationService.prototype.openSummaryPage = function () {
        this._router.navigate(['/summary']);
        this.state.currentPage = 'summary';
    };
    NavigationService.prototype.openCatalogPage = function () {
        this._router.navigate(['/catalog']);
        this.state.currentPage = 'catalog';
    };
    return NavigationService;
}());
NavigationService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [store_1.Store,
        app_service_1.AppService,
        router_1.Router])
], NavigationService);
exports.NavigationService = NavigationService;


/***/ },
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var instances = __webpack_require__(39);

var lastTop;
var lastLeft;

var createDOMEvent = function (name) {
  var event = document.createEvent("Event");
  event.initEvent(name, true, true);
  return event;
};

module.exports = function (element, axis, value) {
  if (typeof element === 'undefined') {
    throw 'You must provide an element to the update-scroll function';
  }

  if (typeof axis === 'undefined') {
    throw 'You must provide an axis to the update-scroll function';
  }

  if (typeof value === 'undefined') {
    throw 'You must provide a value to the update-scroll function';
  }

  if (axis === 'top' && value <= 0) {
    element.scrollTop = value = 0; // don't allow negative scroll
    element.dispatchEvent(createDOMEvent('ps-y-reach-start'));
  }

  if (axis === 'left' && value <= 0) {
    element.scrollLeft = value = 0; // don't allow negative scroll
    element.dispatchEvent(createDOMEvent('ps-x-reach-start'));
  }

  var i = instances.get(element);

  if (axis === 'top' && value >= i.contentHeight - i.containerHeight) {
    // don't allow scroll past container
    value = i.contentHeight - i.containerHeight;
    if (value - element.scrollTop <= 1) {
      // mitigates rounding errors on non-subpixel scroll values
      value = element.scrollTop;
    } else {
      element.scrollTop = value;
    }
    element.dispatchEvent(createDOMEvent('ps-y-reach-end'));
  }

  if (axis === 'left' && value >= i.contentWidth - i.containerWidth) {
    // don't allow scroll past container
    value = i.contentWidth - i.containerWidth;
    if (value - element.scrollLeft <= 1) {
      // mitigates rounding errors on non-subpixel scroll values
      value = element.scrollLeft;
    } else {
      element.scrollLeft = value;
    }
    element.dispatchEvent(createDOMEvent('ps-x-reach-end'));
  }

  if (!lastTop) {
    lastTop = element.scrollTop;
  }

  if (!lastLeft) {
    lastLeft = element.scrollLeft;
  }

  if (axis === 'top' && value < lastTop) {
    element.dispatchEvent(createDOMEvent('ps-scroll-up'));
  }

  if (axis === 'top' && value > lastTop) {
    element.dispatchEvent(createDOMEvent('ps-scroll-down'));
  }

  if (axis === 'left' && value < lastLeft) {
    element.dispatchEvent(createDOMEvent('ps-scroll-left'));
  }

  if (axis === 'left' && value > lastLeft) {
    element.dispatchEvent(createDOMEvent('ps-scroll-right'));
  }

  if (axis === 'top') {
    element.scrollTop = lastTop = value;
    element.dispatchEvent(createDOMEvent('ps-scroll-y'));
  }

  if (axis === 'left') {
    element.scrollLeft = lastLeft = value;
    element.dispatchEvent(createDOMEvent('ps-scroll-x'));
  }

};


/***/ },
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__abstract_control_directive__ = __webpack_require__(261);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return NgControl; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

/**
 * @return {?}
 */
function unimplemented() {
    throw new Error('unimplemented');
}
/**
 * A base class that all control directive extend.
 * It binds a {\@link FormControl} object to a DOM element.
 *
 * Used internally by Angular forms.
 *
 * \@stable
 * @abstract
 */
var NgControl = (function (_super) {
    __extends(NgControl, _super);
    function NgControl() {
        _super.apply(this, arguments);
        /** @internal */
        this._parent = null;
        this.name = null;
        this.valueAccessor = null;
        /** @internal */
        this._rawValidators = [];
        /** @internal */
        this._rawAsyncValidators = [];
    }
    Object.defineProperty(NgControl.prototype, "validator", {
        /**
         * @return {?}
         */
        get: function () { return (unimplemented()); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgControl.prototype, "asyncValidator", {
        /**
         * @return {?}
         */
        get: function () { return (unimplemented()); },
        enumerable: true,
        configurable: true
    });
    /**
     * @abstract
     * @param {?} newValue
     * @return {?}
     */
    NgControl.prototype.viewToModelUpdate = function (newValue) { };
    return NgControl;
}(__WEBPACK_IMPORTED_MODULE_0__abstract_control_directive__["a" /* AbstractControlDirective */]));
function NgControl_tsickle_Closure_declarations() {
    /**
     * \@internal
     * @type {?}
     */
    NgControl.prototype._parent;
    /** @type {?} */
    NgControl.prototype.name;
    /** @type {?} */
    NgControl.prototype.valueAccessor;
    /**
     * \@internal
     * @type {?}
     */
    NgControl.prototype._rawValidators;
    /**
     * \@internal
     * @type {?}
     */
    NgControl.prototype._rawAsyncValidators;
}
//# sourceMappingURL=ng_control.js.map

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_collection__ = __webpack_require__(61);
/* harmony export (immutable) */ exports["f"] = createEmptyUrlTree;
/* harmony export (immutable) */ exports["g"] = containsTree;
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return UrlTree; });
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return UrlSegmentGroup; });
/* harmony export (binding) */ __webpack_require__.d(exports, "c", function() { return UrlSegment; });
/* harmony export (immutable) */ exports["d"] = equalSegments;
/* unused harmony export equalPath */
/* harmony export (immutable) */ exports["e"] = mapChildrenIntoArray;
/* harmony export (binding) */ __webpack_require__.d(exports, "h", function() { return UrlSerializer; });
/* harmony export (binding) */ __webpack_require__.d(exports, "i", function() { return DefaultUrlSerializer; });
/* unused harmony export serializePaths */
/* unused harmony export encode */
/* unused harmony export decode */
/* unused harmony export serializePath */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


/**
 * @return {?}
 */
function createEmptyUrlTree() {
    return new UrlTree(new UrlSegmentGroup([], {}), {}, null);
}
/**
 * @param {?} container
 * @param {?} containee
 * @param {?} exact
 * @return {?}
 */
function containsTree(container, containee, exact) {
    if (exact) {
        return equalQueryParams(container.queryParams, containee.queryParams) &&
            equalSegmentGroups(container.root, containee.root);
    }
    return containsQueryParams(container.queryParams, containee.queryParams) &&
        containsSegmentGroup(container.root, containee.root);
}
/**
 * @param {?} container
 * @param {?} containee
 * @return {?}
 */
function equalQueryParams(container, containee) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_collection__["c" /* shallowEqual */])(container, containee);
}
/**
 * @param {?} container
 * @param {?} containee
 * @return {?}
 */
function equalSegmentGroups(container, containee) {
    if (!equalPath(container.segments, containee.segments))
        return false;
    if (container.numberOfChildren !== containee.numberOfChildren)
        return false;
    for (var c in containee.children) {
        if (!container.children[c])
            return false;
        if (!equalSegmentGroups(container.children[c], containee.children[c]))
            return false;
    }
    return true;
}
/**
 * @param {?} container
 * @param {?} containee
 * @return {?}
 */
function containsQueryParams(container, containee) {
    return Object.keys(containee).length <= Object.keys(container).length &&
        Object.keys(containee).every(function (key) { return containee[key] === container[key]; });
}
/**
 * @param {?} container
 * @param {?} containee
 * @return {?}
 */
function containsSegmentGroup(container, containee) {
    return containsSegmentGroupHelper(container, containee, containee.segments);
}
/**
 * @param {?} container
 * @param {?} containee
 * @param {?} containeePaths
 * @return {?}
 */
function containsSegmentGroupHelper(container, containee, containeePaths) {
    if (container.segments.length > containeePaths.length) {
        var /** @type {?} */ current = container.segments.slice(0, containeePaths.length);
        if (!equalPath(current, containeePaths))
            return false;
        if (containee.hasChildren())
            return false;
        return true;
    }
    else if (container.segments.length === containeePaths.length) {
        if (!equalPath(container.segments, containeePaths))
            return false;
        for (var c in containee.children) {
            if (!container.children[c])
                return false;
            if (!containsSegmentGroup(container.children[c], containee.children[c]))
                return false;
        }
        return true;
    }
    else {
        var /** @type {?} */ current = containeePaths.slice(0, container.segments.length);
        var /** @type {?} */ next = containeePaths.slice(container.segments.length);
        if (!equalPath(container.segments, current))
            return false;
        if (!container.children[__WEBPACK_IMPORTED_MODULE_0__shared__["a" /* PRIMARY_OUTLET */]])
            return false;
        return containsSegmentGroupHelper(container.children[__WEBPACK_IMPORTED_MODULE_0__shared__["a" /* PRIMARY_OUTLET */]], containee, next);
    }
}
/**
 * \@whatItDoes Represents the parsed URL.
 *
 * \@howToUse
 *
 * ```
 * \@Component({templateUrl:'template.html'})
 * class MyComponent {
 *   constructor(router: Router) {
 *     const tree: UrlTree =
 *       router.parseUrl('/team/33/(user/victor//support:help)?debug=true#fragment');
 *     const f = tree.fragment; // return 'fragment'
 *     const q = tree.queryParams; // returns {debug: 'true'}
 *     const g: UrlSegmentGroup = tree.root.children[PRIMARY_OUTLET];
 *     const s: UrlSegment[] = g.segments; // returns 2 segments 'team' and '33'
 *     g.children[PRIMARY_OUTLET].segments; // returns 2 segments 'user' and 'victor'
 *     g.children['support'].segments; // return 1 segment 'help'
 *   }
 * }
 * ```
 *
 * \@description
 *
 * Since a router state is a tree, and the URL is nothing but a serialized state, the URL is a
 * serialized tree.
 * UrlTree is a data structure that provides a lot of affordances in dealing with URLs
 *
 * \@stable
 */
var UrlTree = (function () {
    /**
     * \@internal
     * @param {?} root
     * @param {?} queryParams
     * @param {?} fragment
     */
    function UrlTree(root, queryParams, fragment) {
        this.root = root;
        this.queryParams = queryParams;
        this.fragment = fragment;
    }
    /**
     * \@docsNotRequired
     * @return {?}
     */
    UrlTree.prototype.toString = function () { return new DefaultUrlSerializer().serialize(this); };
    return UrlTree;
}());
function UrlTree_tsickle_Closure_declarations() {
    /**
     * The root segment group of the URL tree
     * @type {?}
     */
    UrlTree.prototype.root;
    /**
     * The query params of the URL
     * @type {?}
     */
    UrlTree.prototype.queryParams;
    /**
     * The fragment of the URL
     * @type {?}
     */
    UrlTree.prototype.fragment;
}
/**
 * \@whatItDoes Represents the parsed URL segment group.
 *
 * See {\@link UrlTree} for more information.
 *
 * \@stable
 */
var UrlSegmentGroup = (function () {
    /**
     * @param {?} segments
     * @param {?} children
     */
    function UrlSegmentGroup(segments, children) {
        var _this = this;
        this.segments = segments;
        this.children = children;
        /** The parent node in the url tree */
        this.parent = null;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_collection__["d" /* forEach */])(children, function (v, k) { return v.parent = _this; });
    }
    /**
     * Wether the segment has child segments
     * @return {?}
     */
    UrlSegmentGroup.prototype.hasChildren = function () { return this.numberOfChildren > 0; };
    Object.defineProperty(UrlSegmentGroup.prototype, "numberOfChildren", {
        /**
         * Number of child segments
         * @return {?}
         */
        get: function () { return Object.keys(this.children).length; },
        enumerable: true,
        configurable: true
    });
    /**
     * \@docsNotRequired
     * @return {?}
     */
    UrlSegmentGroup.prototype.toString = function () { return serializePaths(this); };
    return UrlSegmentGroup;
}());
function UrlSegmentGroup_tsickle_Closure_declarations() {
    /**
     * \@internal
     * @type {?}
     */
    UrlSegmentGroup.prototype._sourceSegment;
    /**
     * \@internal
     * @type {?}
     */
    UrlSegmentGroup.prototype._segmentIndexShift;
    /**
     * The parent node in the url tree
     * @type {?}
     */
    UrlSegmentGroup.prototype.parent;
    /**
     * The URL segments of this group. See {\@link UrlSegment} for more information
     * @type {?}
     */
    UrlSegmentGroup.prototype.segments;
    /**
     * The list of children of this group
     * @type {?}
     */
    UrlSegmentGroup.prototype.children;
}
/**
 * \@whatItDoes Represents a single URL segment.
 *
 * \@howToUse
 *
 * ```
 * \@Component({templateUrl:'template.html'})
 * class MyComponent {
 *   constructor(router: Router) {
 *     const tree: UrlTree = router.parseUrl('/team;id=33');
 *     const g: UrlSegmentGroup = tree.root.children[PRIMARY_OUTLET];
 *     const s: UrlSegment[] = g.segments;
 *     s[0].path; // returns 'team'
 *     s[0].parameters; // returns {id: 33}
 *   }
 * }
 * ```
 *
 * \@description
 *
 * A UrlSegment is a part of a URL between the two slashes. It contains a path and the matrix
 * parameters associated with the segment.
 *
 * \@stable
 */
var UrlSegment = (function () {
    /**
     * @param {?} path
     * @param {?} parameters
     */
    function UrlSegment(path, parameters) {
        this.path = path;
        this.parameters = parameters;
    }
    /**
     * \@docsNotRequired
     * @return {?}
     */
    UrlSegment.prototype.toString = function () { return serializePath(this); };
    return UrlSegment;
}());
function UrlSegment_tsickle_Closure_declarations() {
    /**
     * The path part of a URL segment
     * @type {?}
     */
    UrlSegment.prototype.path;
    /**
     * The matrix parameters associated with a segment
     * @type {?}
     */
    UrlSegment.prototype.parameters;
}
/**
 * @param {?} a
 * @param {?} b
 * @return {?}
 */
function equalSegments(a, b) {
    if (a.length !== b.length)
        return false;
    for (var /** @type {?} */ i = 0; i < a.length; ++i) {
        if (a[i].path !== b[i].path)
            return false;
        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_collection__["c" /* shallowEqual */])(a[i].parameters, b[i].parameters))
            return false;
    }
    return true;
}
/**
 * @param {?} a
 * @param {?} b
 * @return {?}
 */
function equalPath(a, b) {
    if (a.length !== b.length)
        return false;
    for (var /** @type {?} */ i = 0; i < a.length; ++i) {
        if (a[i].path !== b[i].path)
            return false;
    }
    return true;
}
/**
 * @param {?} segment
 * @param {?} fn
 * @return {?}
 */
function mapChildrenIntoArray(segment, fn) {
    var /** @type {?} */ res = [];
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_collection__["d" /* forEach */])(segment.children, function (child, childOutlet) {
        if (childOutlet === __WEBPACK_IMPORTED_MODULE_0__shared__["a" /* PRIMARY_OUTLET */]) {
            res = res.concat(fn(child, childOutlet));
        }
    });
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_collection__["d" /* forEach */])(segment.children, function (child, childOutlet) {
        if (childOutlet !== __WEBPACK_IMPORTED_MODULE_0__shared__["a" /* PRIMARY_OUTLET */]) {
            res = res.concat(fn(child, childOutlet));
        }
    });
    return res;
}
/**
 * \@whatItDoes Serializes and deserializes a URL string into a URL tree.
 *
 * \@description The url serialization strategy is customizable. You can
 * make all URLs case insensitive by providing a custom UrlSerializer.
 *
 * See {\@link DefaultUrlSerializer} for an example of a URL serializer.
 *
 * \@stable
 * @abstract
 */
var UrlSerializer = (function () {
    function UrlSerializer() {
    }
    /**
     * Parse a url into a {\@link UrlTree}
     * @abstract
     * @param {?} url
     * @return {?}
     */
    UrlSerializer.prototype.parse = function (url) { };
    /**
     * Converts a {\@link UrlTree} into a url
     * @abstract
     * @param {?} tree
     * @return {?}
     */
    UrlSerializer.prototype.serialize = function (tree) { };
    return UrlSerializer;
}());
/**
 * \@whatItDoes A default implementation of the {\@link UrlSerializer}.
 *
 * \@description
 *
 * Example URLs:
 *
 * ```
 * /inbox/33(popup:compose)
 * /inbox/33;open=true/messages/44
 * ```
 *
 * DefaultUrlSerializer uses parentheses to serialize secondary segments (e.g., popup:compose), the
 * colon syntax to specify the outlet, and the ';parameter=value' syntax (e.g., open=true) to
 * specify route specific parameters.
 *
 * \@stable
 */
var DefaultUrlSerializer = (function () {
    function DefaultUrlSerializer() {
    }
    /**
     * Parses a url into a {\@link UrlTree}
     * @param {?} url
     * @return {?}
     */
    DefaultUrlSerializer.prototype.parse = function (url) {
        var /** @type {?} */ p = new UrlParser(url);
        return new UrlTree(p.parseRootSegment(), p.parseQueryParams(), p.parseFragment());
    };
    /**
     * Converts a {\@link UrlTree} into a url
     * @param {?} tree
     * @return {?}
     */
    DefaultUrlSerializer.prototype.serialize = function (tree) {
        var /** @type {?} */ segment = "/" + serializeSegment(tree.root, true);
        var /** @type {?} */ query = serializeQueryParams(tree.queryParams);
        var /** @type {?} */ fragment = tree.fragment !== null && tree.fragment !== undefined ? "#" + encodeURI(tree.fragment) : '';
        return "" + segment + query + fragment;
    };
    return DefaultUrlSerializer;
}());
/**
 * @param {?} segment
 * @return {?}
 */
function serializePaths(segment) {
    return segment.segments.map(function (p) { return serializePath(p); }).join('/');
}
/**
 * @param {?} segment
 * @param {?} root
 * @return {?}
 */
function serializeSegment(segment, root) {
    if (segment.hasChildren() && root) {
        var /** @type {?} */ primary = segment.children[__WEBPACK_IMPORTED_MODULE_0__shared__["a" /* PRIMARY_OUTLET */]] ?
            serializeSegment(segment.children[__WEBPACK_IMPORTED_MODULE_0__shared__["a" /* PRIMARY_OUTLET */]], false) :
            '';
        var /** @type {?} */ children_1 = [];
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_collection__["d" /* forEach */])(segment.children, function (v, k) {
            if (k !== __WEBPACK_IMPORTED_MODULE_0__shared__["a" /* PRIMARY_OUTLET */]) {
                children_1.push(k + ":" + serializeSegment(v, false));
            }
        });
        if (children_1.length > 0) {
            return primary + "(" + children_1.join('//') + ")";
        }
        else {
            return "" + primary;
        }
    }
    else if (segment.hasChildren() && !root) {
        var /** @type {?} */ children = mapChildrenIntoArray(segment, function (v, k) {
            if (k === __WEBPACK_IMPORTED_MODULE_0__shared__["a" /* PRIMARY_OUTLET */]) {
                return [serializeSegment(segment.children[__WEBPACK_IMPORTED_MODULE_0__shared__["a" /* PRIMARY_OUTLET */]], false)];
            }
            else {
                return [(k + ":" + serializeSegment(v, false))];
            }
        });
        return serializePaths(segment) + "/(" + children.join('//') + ")";
    }
    else {
        return serializePaths(segment);
    }
}
/**
 * @param {?} s
 * @return {?}
 */
function encode(s) {
    return encodeURIComponent(s);
}
/**
 * @param {?} s
 * @return {?}
 */
function decode(s) {
    return decodeURIComponent(s);
}
/**
 * @param {?} path
 * @return {?}
 */
function serializePath(path) {
    return "" + encode(path.path) + serializeParams(path.parameters);
}
/**
 * @param {?} params
 * @return {?}
 */
function serializeParams(params) {
    return pairs(params).map(function (p) { return (";" + encode(p.first) + "=" + encode(p.second)); }).join('');
}
/**
 * @param {?} params
 * @return {?}
 */
function serializeQueryParams(params) {
    var /** @type {?} */ strParams = Object.keys(params).map(function (name) {
        var /** @type {?} */ value = params[name];
        return Array.isArray(value) ? value.map(function (v) { return (encode(name) + "=" + encode(v)); }).join('&') :
            encode(name) + "=" + encode(value);
    });
    return strParams.length ? "?" + strParams.join("&") : '';
}
var Pair = (function () {
    /**
     * @param {?} first
     * @param {?} second
     */
    function Pair(first, second) {
        this.first = first;
        this.second = second;
    }
    return Pair;
}());
function Pair_tsickle_Closure_declarations() {
    /** @type {?} */
    Pair.prototype.first;
    /** @type {?} */
    Pair.prototype.second;
}
/**
 * @param {?} obj
 * @return {?}
 */
function pairs(obj) {
    var /** @type {?} */ res = [];
    for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
            res.push(new Pair(prop, obj[prop]));
        }
    }
    return res;
}
var /** @type {?} */ SEGMENT_RE = /^[^\/()?;=&#]+/;
/**
 * @param {?} str
 * @return {?}
 */
function matchSegments(str) {
    SEGMENT_RE.lastIndex = 0;
    var /** @type {?} */ match = str.match(SEGMENT_RE);
    return match ? match[0] : '';
}
var /** @type {?} */ QUERY_PARAM_RE = /^[^=?&#]+/;
/**
 * @param {?} str
 * @return {?}
 */
function matchQueryParams(str) {
    QUERY_PARAM_RE.lastIndex = 0;
    var /** @type {?} */ match = str.match(SEGMENT_RE);
    return match ? match[0] : '';
}
var /** @type {?} */ QUERY_PARAM_VALUE_RE = /^[^?&#]+/;
/**
 * @param {?} str
 * @return {?}
 */
function matchUrlQueryParamValue(str) {
    QUERY_PARAM_VALUE_RE.lastIndex = 0;
    var /** @type {?} */ match = str.match(QUERY_PARAM_VALUE_RE);
    return match ? match[0] : '';
}
var UrlParser = (function () {
    /**
     * @param {?} url
     */
    function UrlParser(url) {
        this.url = url;
        this.remaining = url;
    }
    /**
     * @param {?} str
     * @return {?}
     */
    UrlParser.prototype.peekStartsWith = function (str) { return this.remaining.startsWith(str); };
    /**
     * @param {?} str
     * @return {?}
     */
    UrlParser.prototype.capture = function (str) {
        if (!this.remaining.startsWith(str)) {
            throw new Error("Expected \"" + str + "\".");
        }
        this.remaining = this.remaining.substring(str.length);
    };
    /**
     * @return {?}
     */
    UrlParser.prototype.parseRootSegment = function () {
        if (this.remaining.startsWith('/')) {
            this.capture('/');
        }
        if (this.remaining === '' || this.remaining.startsWith('?') || this.remaining.startsWith('#')) {
            return new UrlSegmentGroup([], {});
        }
        return new UrlSegmentGroup([], this.parseChildren());
    };
    /**
     * @return {?}
     */
    UrlParser.prototype.parseChildren = function () {
        if (this.remaining.length == 0) {
            return {};
        }
        if (this.peekStartsWith('/')) {
            this.capture('/');
        }
        var /** @type {?} */ paths = [];
        if (!this.peekStartsWith('(')) {
            paths.push(this.parseSegments());
        }
        while (this.peekStartsWith('/') && !this.peekStartsWith('//') && !this.peekStartsWith('/(')) {
            this.capture('/');
            paths.push(this.parseSegments());
        }
        var /** @type {?} */ children = {};
        if (this.peekStartsWith('/(')) {
            this.capture('/');
            children = this.parseParens(true);
        }
        var /** @type {?} */ res = {};
        if (this.peekStartsWith('(')) {
            res = this.parseParens(false);
        }
        if (paths.length > 0 || Object.keys(children).length > 0) {
            res[__WEBPACK_IMPORTED_MODULE_0__shared__["a" /* PRIMARY_OUTLET */]] = new UrlSegmentGroup(paths, children);
        }
        return res;
    };
    /**
     * @return {?}
     */
    UrlParser.prototype.parseSegments = function () {
        var /** @type {?} */ path = matchSegments(this.remaining);
        if (path === '' && this.peekStartsWith(';')) {
            throw new Error("Empty path url segment cannot have parameters: '" + this.remaining + "'.");
        }
        this.capture(path);
        var /** @type {?} */ matrixParams = {};
        if (this.peekStartsWith(';')) {
            matrixParams = this.parseMatrixParams();
        }
        return new UrlSegment(decode(path), matrixParams);
    };
    /**
     * @return {?}
     */
    UrlParser.prototype.parseQueryParams = function () {
        var /** @type {?} */ params = {};
        if (this.peekStartsWith('?')) {
            this.capture('?');
            this.parseQueryParam(params);
            while (this.remaining.length > 0 && this.peekStartsWith('&')) {
                this.capture('&');
                this.parseQueryParam(params);
            }
        }
        return params;
    };
    /**
     * @return {?}
     */
    UrlParser.prototype.parseFragment = function () {
        if (this.peekStartsWith('#')) {
            return decodeURI(this.remaining.substring(1));
        }
        return null;
    };
    /**
     * @return {?}
     */
    UrlParser.prototype.parseMatrixParams = function () {
        var /** @type {?} */ params = {};
        while (this.remaining.length > 0 && this.peekStartsWith(';')) {
            this.capture(';');
            this.parseParam(params);
        }
        return params;
    };
    /**
     * @param {?} params
     * @return {?}
     */
    UrlParser.prototype.parseParam = function (params) {
        var /** @type {?} */ key = matchSegments(this.remaining);
        if (!key) {
            return;
        }
        this.capture(key);
        var /** @type {?} */ value = '';
        if (this.peekStartsWith('=')) {
            this.capture('=');
            var /** @type {?} */ valueMatch = matchSegments(this.remaining);
            if (valueMatch) {
                value = valueMatch;
                this.capture(value);
            }
        }
        params[decode(key)] = decode(value);
    };
    /**
     * @param {?} params
     * @return {?}
     */
    UrlParser.prototype.parseQueryParam = function (params) {
        var /** @type {?} */ key = matchQueryParams(this.remaining);
        if (!key) {
            return;
        }
        this.capture(key);
        var /** @type {?} */ value = '';
        if (this.peekStartsWith('=')) {
            this.capture('=');
            var /** @type {?} */ valueMatch = matchUrlQueryParamValue(this.remaining);
            if (valueMatch) {
                value = valueMatch;
                this.capture(value);
            }
        }
        var /** @type {?} */ decodedKey = decode(key);
        var /** @type {?} */ decodedVal = decode(value);
        if (params.hasOwnProperty(decodedKey)) {
            // Append to existing values
            var /** @type {?} */ currentVal = params[decodedKey];
            if (!Array.isArray(currentVal)) {
                currentVal = [currentVal];
                params[decodedKey] = currentVal;
            }
            currentVal.push(decodedVal);
        }
        else {
            // Create a new value
            params[decodedKey] = decodedVal;
        }
    };
    /**
     * @param {?} allowPrimary
     * @return {?}
     */
    UrlParser.prototype.parseParens = function (allowPrimary) {
        var /** @type {?} */ segments = {};
        this.capture('(');
        while (!this.peekStartsWith(')') && this.remaining.length > 0) {
            var /** @type {?} */ path = matchSegments(this.remaining);
            var /** @type {?} */ next = this.remaining[path.length];
            // if is is not one of these characters, then the segment was unescaped
            // or the group was not closed
            if (next !== '/' && next !== ')' && next !== ';') {
                throw new Error("Cannot parse url '" + this.url + "'");
            }
            var /** @type {?} */ outletName = void 0;
            if (path.indexOf(':') > -1) {
                outletName = path.substr(0, path.indexOf(':'));
                this.capture(outletName);
                this.capture(':');
            }
            else if (allowPrimary) {
                outletName = __WEBPACK_IMPORTED_MODULE_0__shared__["a" /* PRIMARY_OUTLET */];
            }
            var /** @type {?} */ children = this.parseChildren();
            segments[outletName] = Object.keys(children).length === 1 ? children[__WEBPACK_IMPORTED_MODULE_0__shared__["a" /* PRIMARY_OUTLET */]] :
                new UrlSegmentGroup([], children);
            if (this.peekStartsWith('//')) {
                this.capture('//');
            }
        }
        this.capture(')');
        return segments;
    };
    return UrlParser;
}());
function UrlParser_tsickle_Closure_declarations() {
    /** @type {?} */
    UrlParser.prototype.remaining;
    /** @type {?} */
    UrlParser.prototype.url;
}
//# sourceMappingURL=url_tree.js.map

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var debug, debugOff = function () {
    var any = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        any[_i] = arguments[_i];
    }
};
"production" !== 'production' && (debug = __webpack_require__(4)('app:GeneratorsService'));
var GeneratorsService = (function () {
    function GeneratorsService() {
        this.state = {
            generatorCfg: {
                selectedGenerator: null,
                showerDimensionsExceeded: false,
                lengthFtIsValid: false,
                widthFtIsValid: false,
                heightFtIsValid: false,
                materialIsValid: false,
            },
            roomDimensions: {
                lengthFt: null,
                lengthIn: null,
                widthFt: null,
                widthIn: null,
                heightFt: null,
                heightIn: null,
                wallType: null,
                cubicFeet: null,
                cubicFeetAdjusted: null
            }
        };
    }
    GeneratorsService.prototype.resetCalculatorInputs = function () {
        this.state.roomDimensions.lengthFt = null;
        this.state.roomDimensions.widthFt = null;
        this.state.roomDimensions.heightFt = null;
        this.state.roomDimensions.lengthIn = null;
        this.state.roomDimensions.widthIn = null;
        this.state.roomDimensions.heightIn = null;
        this.state.roomDimensions.wallType = 'stone';
        this.state.roomDimensions.cubicFeet = null;
        this.state.roomDimensions.cubicFeetAdjusted = null;
        this.state.generatorCfg.selectedGenerator = null;
    };
    return GeneratorsService;
}());
GeneratorsService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [])
], GeneratorsService);
exports.GeneratorsService = GeneratorsService;


/***/ },
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

module.exports = __webpack_require__(870);


/***/ },
/* 107 */
/***/ function(module, exports) {

"use strict";
'use strict';

var DOM = {};

DOM.e = function (tagName, className) {
  var element = document.createElement(tagName);
  element.className = className;
  return element;
};

DOM.appendTo = function (child, parent) {
  parent.appendChild(child);
  return child;
};

function cssGet(element, styleName) {
  return window.getComputedStyle(element)[styleName];
}

function cssSet(element, styleName, styleValue) {
  if (typeof styleValue === 'number') {
    styleValue = styleValue.toString() + 'px';
  }
  element.style[styleName] = styleValue;
  return element;
}

function cssMultiSet(element, obj) {
  for (var key in obj) {
    var val = obj[key];
    if (typeof val === 'number') {
      val = val.toString() + 'px';
    }
    element.style[key] = val;
  }
  return element;
}

DOM.css = function (element, styleNameOrObject, styleValue) {
  if (typeof styleNameOrObject === 'object') {
    // multiple set with object
    return cssMultiSet(element, styleNameOrObject);
  } else {
    if (typeof styleValue === 'undefined') {
      return cssGet(element, styleNameOrObject);
    } else {
      return cssSet(element, styleNameOrObject, styleValue);
    }
  }
};

DOM.matches = function (element, query) {
  if (typeof element.matches !== 'undefined') {
    return element.matches(query);
  } else {
    if (typeof element.matchesSelector !== 'undefined') {
      return element.matchesSelector(query);
    } else if (typeof element.webkitMatchesSelector !== 'undefined') {
      return element.webkitMatchesSelector(query);
    } else if (typeof element.mozMatchesSelector !== 'undefined') {
      return element.mozMatchesSelector(query);
    } else if (typeof element.msMatchesSelector !== 'undefined') {
      return element.msMatchesSelector(query);
    }
  }
};

DOM.remove = function (element) {
  if (typeof element.remove !== 'undefined') {
    element.remove();
  } else {
    if (element.parentNode) {
      element.parentNode.removeChild(element);
    }
  }
};

DOM.queryChildren = function (element, selector) {
  return Array.prototype.filter.call(element.childNodes, function (child) {
    return DOM.matches(child, selector);
  });
};

module.exports = DOM;


/***/ },
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Subject__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Subject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Subject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__);
/* unused harmony reexport Observable */
/* unused harmony reexport Subject */
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return EventEmitter; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};



/**
 * Use by directives and components to emit custom Events.
 *
 * ### Examples
 *
 * In the following example, `Zippy` alternatively emits `open` and `close` events when its
 * title gets clicked:
 *
 * ```
 * \@Component({
 *   selector: 'zippy',
 *   template: `
 *   <div class="zippy">
 *     <div (click)="toggle()">Toggle</div>
 *     <div [hidden]="!visible">
 *       <ng-content></ng-content>
 *     </div>
 *  </div>`})
 * export class Zippy {
 *   visible: boolean = true;
 *   \@Output() open: EventEmitter<any> = new EventEmitter();
 *   \@Output() close: EventEmitter<any> = new EventEmitter();
 *
 *   toggle() {
 *     this.visible = !this.visible;
 *     if (this.visible) {
 *       this.open.emit(null);
 *     } else {
 *       this.close.emit(null);
 *     }
 *   }
 * }
 * ```
 *
 * The events payload can be accessed by the parameter `$event` on the components output event
 * handler:
 *
 * ```
 * <zippy (open)="onOpen($event)" (close)="onClose($event)"></zippy>
 * ```
 *
 * Uses Rx.Observable but provides an adapter to make it work as specified here:
 * https://github.com/jhusain/observable-spec
 *
 * Once a reference implementation of the spec is available, switch to it.
 * \@stable
 */
var EventEmitter = (function (_super) {
    __extends(EventEmitter, _super);
    /**
     * Creates an instance of [EventEmitter], which depending on [isAsync],
     * delivers events synchronously or asynchronously.
     * @param {?=} isAsync
     */
    function EventEmitter(isAsync) {
        if (isAsync === void 0) { isAsync = false; }
        _super.call(this);
        this.__isAsync = isAsync;
    }
    /**
     * @param {?=} value
     * @return {?}
     */
    EventEmitter.prototype.emit = function (value) { _super.prototype.next.call(this, value); };
    /**
     * @param {?=} generatorOrNext
     * @param {?=} error
     * @param {?=} complete
     * @return {?}
     */
    EventEmitter.prototype.subscribe = function (generatorOrNext, error, complete) {
        var /** @type {?} */ schedulerFn;
        var /** @type {?} */ errorFn = function (err) { return null; };
        var /** @type {?} */ completeFn = function () { return null; };
        if (generatorOrNext && typeof generatorOrNext === 'object') {
            schedulerFn = this.__isAsync ? function (value) {
                setTimeout(function () { return generatorOrNext.next(value); });
            } : function (value) { generatorOrNext.next(value); };
            if (generatorOrNext.error) {
                errorFn = this.__isAsync ? function (err) { setTimeout(function () { return generatorOrNext.error(err); }); } :
                    function (err) { generatorOrNext.error(err); };
            }
            if (generatorOrNext.complete) {
                completeFn = this.__isAsync ? function () { setTimeout(function () { return generatorOrNext.complete(); }); } :
                    function () { generatorOrNext.complete(); };
            }
        }
        else {
            schedulerFn = this.__isAsync ? function (value) { setTimeout(function () { return generatorOrNext(value); }); } :
                function (value) { generatorOrNext(value); };
            if (error) {
                errorFn =
                    this.__isAsync ? function (err) { setTimeout(function () { return error(err); }); } : function (err) { error(err); };
            }
            if (complete) {
                completeFn =
                    this.__isAsync ? function () { setTimeout(function () { return complete(); }); } : function () { complete(); };
            }
        }
        return _super.prototype.subscribe.call(this, schedulerFn, errorFn, completeFn);
    };
    return EventEmitter;
}(__WEBPACK_IMPORTED_MODULE_0_rxjs_Subject__["Subject"]));
function EventEmitter_tsickle_Closure_declarations() {
    /** @type {?} */
    EventEmitter.prototype.__isAsync;
}
//# sourceMappingURL=async.js.map

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export scheduleMicroTask */
/* unused harmony export global */
/* unused harmony export getTypeNameForDebugging */
/* harmony export (immutable) */ exports["c"] = isPresent;
/* harmony export (immutable) */ exports["f"] = isBlank;
/* unused harmony export isStrictStringMap */
/* unused harmony export stringify */
/* unused harmony export NumberWrapper */
/* harmony export (immutable) */ exports["e"] = looseIdentical;
/* harmony export (immutable) */ exports["a"] = isJsObject;
/* unused harmony export print */
/* unused harmony export warn */
/* unused harmony export setValueOnPath */
/* harmony export (immutable) */ exports["b"] = getSymbolIterator;
/* harmony export (immutable) */ exports["d"] = isPrimitive;
/* unused harmony export escapeRegExp */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var /** @type {?} */ globalScope;
if (typeof window === 'undefined') {
    if (typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope) {
        // TODO: Replace any with WorkerGlobalScope from lib.webworker.d.ts #3492
        globalScope = (self);
    }
    else {
        globalScope = (global);
    }
}
else {
    globalScope = (window);
}
/**
 * @param {?} fn
 * @return {?}
 */
function scheduleMicroTask(fn) {
    Zone.current.scheduleMicroTask('scheduleMicrotask', fn);
}
// Need to declare a new variable for global here since TypeScript
// exports the original value of the symbol.
var /** @type {?} */ _global = globalScope;

/**
 * @param {?} type
 * @return {?}
 */
function getTypeNameForDebugging(type) {
    return type['name'] || typeof type;
}
// TODO: remove calls to assert in production environment
// Note: Can't just export this and import in in other files
// as `assert` is a reserved keyword in Dart
_global.assert = function assert(condition) {
    // TODO: to be fixed properly via #2830, noop for now
};
/**
 * @param {?} obj
 * @return {?}
 */
function isPresent(obj) {
    return obj != null;
}
/**
 * @param {?} obj
 * @return {?}
 */
function isBlank(obj) {
    return obj == null;
}
var /** @type {?} */ STRING_MAP_PROTO = Object.getPrototypeOf({});
/**
 * @param {?} obj
 * @return {?}
 */
function isStrictStringMap(obj) {
    return typeof obj === 'object' && obj !== null && Object.getPrototypeOf(obj) === STRING_MAP_PROTO;
}
/**
 * @param {?} token
 * @return {?}
 */
function stringify(token) {
    if (typeof token === 'string') {
        return token;
    }
    if (token == null) {
        return '' + token;
    }
    if (token.overriddenName) {
        return "" + token.overriddenName;
    }
    if (token.name) {
        return "" + token.name;
    }
    var /** @type {?} */ res = token.toString();
    var /** @type {?} */ newLineIndex = res.indexOf('\n');
    return newLineIndex === -1 ? res : res.substring(0, newLineIndex);
}
var NumberWrapper = (function () {
    function NumberWrapper() {
    }
    /**
     * @param {?} text
     * @return {?}
     */
    NumberWrapper.parseIntAutoRadix = function (text) {
        var /** @type {?} */ result = parseInt(text);
        if (isNaN(result)) {
            throw new Error('Invalid integer literal when parsing ' + text);
        }
        return result;
    };
    /**
     * @param {?} value
     * @return {?}
     */
    NumberWrapper.isNumeric = function (value) { return !isNaN(value - parseFloat(value)); };
    return NumberWrapper;
}());
/**
 * @param {?} a
 * @param {?} b
 * @return {?}
 */
function looseIdentical(a, b) {
    return a === b || typeof a === 'number' && typeof b === 'number' && isNaN(a) && isNaN(b);
}
/**
 * @param {?} o
 * @return {?}
 */
function isJsObject(o) {
    return o !== null && (typeof o === 'function' || typeof o === 'object');
}
/**
 * @param {?} obj
 * @return {?}
 */
function print(obj) {
    // tslint:disable-next-line:no-console
    console.log(obj);
}
/**
 * @param {?} obj
 * @return {?}
 */
function warn(obj) {
    console.warn(obj);
}
/**
 * @param {?} global
 * @param {?} path
 * @param {?} value
 * @return {?}
 */
function setValueOnPath(global, path, value) {
    var /** @type {?} */ parts = path.split('.');
    var /** @type {?} */ obj = global;
    while (parts.length > 1) {
        var /** @type {?} */ name_1 = parts.shift();
        if (obj.hasOwnProperty(name_1) && obj[name_1] != null) {
            obj = obj[name_1];
        }
        else {
            obj = obj[name_1] = {};
        }
    }
    if (obj === undefined || obj === null) {
        obj = {};
    }
    obj[parts.shift()] = value;
}
var /** @type {?} */ _symbolIterator = null;
/**
 * @return {?}
 */
function getSymbolIterator() {
    if (!_symbolIterator) {
        if (((globalScope)).Symbol && Symbol.iterator) {
            _symbolIterator = Symbol.iterator;
        }
        else {
            // es6-shim specific logic
            var /** @type {?} */ keys = Object.getOwnPropertyNames(Map.prototype);
            for (var /** @type {?} */ i = 0; i < keys.length; ++i) {
                var /** @type {?} */ key = keys[i];
                if (key !== 'entries' && key !== 'size' &&
                    ((Map)).prototype[key] === Map.prototype['entries']) {
                    _symbolIterator = key;
                }
            }
        }
    }
    return _symbolIterator;
}
/**
 * @param {?} obj
 * @return {?}
 */
function isPrimitive(obj) {
    return !isJsObject(obj);
}
/**
 * @param {?} s
 * @return {?}
 */
function escapeRegExp(s) {
    return s.replace(/([.*+?^=!:${}()|[\]\/\\])/g, '\\$1');
}
//# sourceMappingURL=lang.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(48)))

/***/ },
/* 114 */,
/* 115 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony reexport (binding) */ __webpack_require__.d(exports, "RouterOutletMap", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_index__ = __webpack_require__(627);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "RouterLink", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "RouterLinkWithHref", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "RouterLinkActive", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "RouterOutlet", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "RouteReuseStrategy", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "NavigationCancel", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "NavigationEnd", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "NavigationError", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["i"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "NavigationStart", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["j"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "Router", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["k"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "RoutesRecognized", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["l"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "ROUTER_CONFIGURATION", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["m"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "ROUTER_INITIALIZER", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["n"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "RouterModule", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["o"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "provideRoutes", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["p"]; });
Object.defineProperty(exports, "__esModule", { value: true });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "NoPreloading", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["q"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "PreloadAllModules", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["r"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "PreloadingStrategy", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["s"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "RouterPreloader", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["t"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "ActivatedRoute", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["u"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "ActivatedRouteSnapshot", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["v"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "RouterState", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["w"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "RouterStateSnapshot", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["x"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "PRIMARY_OUTLET", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["y"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "UrlHandlingStrategy", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["z"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "DefaultUrlSerializer", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["A"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "UrlSegment", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["B"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "UrlSegmentGroup", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["C"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "UrlSerializer", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["D"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "UrlTree", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["E"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "VERSION", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["F"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "__router_private__", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["G"]; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @module
 * @description
 * Entry point for all public APIs of the router package.
 */

//# sourceMappingURL=index.js.map

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_BehaviorSubject__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_BehaviorSubject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_BehaviorSubject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__url_tree__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_collection__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_tree__ = __webpack_require__(281);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return RouterState; });
/* harmony export (immutable) */ exports["f"] = createEmptyState;
/* unused harmony export createEmptyStateSnapshot */
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return ActivatedRoute; });
/* harmony export (immutable) */ exports["e"] = inheritedParamsDataResolve;
/* harmony export (binding) */ __webpack_require__.d(exports, "c", function() { return ActivatedRouteSnapshot; });
/* harmony export (binding) */ __webpack_require__.d(exports, "d", function() { return RouterStateSnapshot; });
/* harmony export (immutable) */ exports["h"] = advanceActivatedRoute;
/* harmony export (immutable) */ exports["g"] = equalParamsAndUrlSegments;
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};





/**
 * \@whatItDoes Represents the state of the router.
 *
 * \@howToUse
 *
 * ```
 * \@Component({templateUrl:'template.html'})
 * class MyComponent {
 *   constructor(router: Router) {
 *     const state: RouterState = router.routerState;
 *     const root: ActivatedRoute = state.root;
 *     const child = root.firstChild;
 *     const id: Observable<string> = child.params.map(p => p.id);
 *     //...
 *   }
 * }
 * ```
 *
 * \@description
 * RouterState is a tree of activated routes. Every node in this tree knows about the "consumed" URL
 * segments,
 * the extracted parameters, and the resolved data.
 *
 * See {\@link ActivatedRoute} for more information.
 *
 * \@stable
 */
var RouterState = (function (_super) {
    __extends(RouterState, _super);
    /**
     * \@internal
     * @param {?} root
     * @param {?} snapshot
     */
    function RouterState(root, snapshot) {
        _super.call(this, root);
        this.snapshot = snapshot;
        setRouterStateSnapshot(this, root);
    }
    /**
     * @return {?}
     */
    RouterState.prototype.toString = function () { return this.snapshot.toString(); };
    return RouterState;
}(__WEBPACK_IMPORTED_MODULE_4__utils_tree__["a" /* Tree */]));
function RouterState_tsickle_Closure_declarations() {
    /**
     * The current snapshot of the router state
     * @type {?}
     */
    RouterState.prototype.snapshot;
}
/**
 * @param {?} urlTree
 * @param {?} rootComponent
 * @return {?}
 */
function createEmptyState(urlTree, rootComponent) {
    var /** @type {?} */ snapshot = createEmptyStateSnapshot(urlTree, rootComponent);
    var /** @type {?} */ emptyUrl = new __WEBPACK_IMPORTED_MODULE_0_rxjs_BehaviorSubject__["BehaviorSubject"]([new __WEBPACK_IMPORTED_MODULE_2__url_tree__["c" /* UrlSegment */]('', {})]);
    var /** @type {?} */ emptyParams = new __WEBPACK_IMPORTED_MODULE_0_rxjs_BehaviorSubject__["BehaviorSubject"]({});
    var /** @type {?} */ emptyData = new __WEBPACK_IMPORTED_MODULE_0_rxjs_BehaviorSubject__["BehaviorSubject"]({});
    var /** @type {?} */ emptyQueryParams = new __WEBPACK_IMPORTED_MODULE_0_rxjs_BehaviorSubject__["BehaviorSubject"]({});
    var /** @type {?} */ fragment = new __WEBPACK_IMPORTED_MODULE_0_rxjs_BehaviorSubject__["BehaviorSubject"]('');
    var /** @type {?} */ activated = new ActivatedRoute(emptyUrl, emptyParams, emptyQueryParams, fragment, emptyData, __WEBPACK_IMPORTED_MODULE_1__shared__["a" /* PRIMARY_OUTLET */], rootComponent, snapshot.root);
    activated.snapshot = snapshot.root;
    return new RouterState(new __WEBPACK_IMPORTED_MODULE_4__utils_tree__["b" /* TreeNode */](activated, []), snapshot);
}
/**
 * @param {?} urlTree
 * @param {?} rootComponent
 * @return {?}
 */
function createEmptyStateSnapshot(urlTree, rootComponent) {
    var /** @type {?} */ emptyParams = {};
    var /** @type {?} */ emptyData = {};
    var /** @type {?} */ emptyQueryParams = {};
    var /** @type {?} */ fragment = '';
    var /** @type {?} */ activated = new ActivatedRouteSnapshot([], emptyParams, emptyQueryParams, fragment, emptyData, __WEBPACK_IMPORTED_MODULE_1__shared__["a" /* PRIMARY_OUTLET */], rootComponent, null, urlTree.root, -1, {});
    return new RouterStateSnapshot('', new __WEBPACK_IMPORTED_MODULE_4__utils_tree__["b" /* TreeNode */](activated, []));
}
/**
 * \@whatItDoes Contains the information about a route associated with a component loaded in an
 * outlet.
 * An `ActivatedRoute` can also be used to traverse the router state tree.
 *
 * \@howToUse
 *
 * ```
 * \@Component({...})
 * class MyComponent {
 *   constructor(route: ActivatedRoute) {
 *     const id: Observable<string> = route.params.map(p => p.id);
 *     const url: Observable<string> = route.url.map(segments => segments.join(''));
 *     // route.data includes both `data` and `resolve`
 *     const user = route.data.map(d => d.user);
 *   }
 * }
 * ```
 *
 * \@stable
 */
var ActivatedRoute = (function () {
    /**
     * \@internal
     * @param {?} url
     * @param {?} params
     * @param {?} queryParams
     * @param {?} fragment
     * @param {?} data
     * @param {?} outlet
     * @param {?} component
     * @param {?} futureSnapshot
     */
    function ActivatedRoute(url, params, queryParams, fragment, data, outlet, component, futureSnapshot) {
        this.url = url;
        this.params = params;
        this.queryParams = queryParams;
        this.fragment = fragment;
        this.data = data;
        this.outlet = outlet;
        this.component = component;
        this._futureSnapshot = futureSnapshot;
    }
    Object.defineProperty(ActivatedRoute.prototype, "routeConfig", {
        /**
         * The configuration used to match this route
         * @return {?}
         */
        get: function () { return this._futureSnapshot.routeConfig; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivatedRoute.prototype, "root", {
        /**
         * The root of the router state
         * @return {?}
         */
        get: function () { return this._routerState.root; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivatedRoute.prototype, "parent", {
        /**
         * The parent of this route in the router state tree
         * @return {?}
         */
        get: function () { return this._routerState.parent(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivatedRoute.prototype, "firstChild", {
        /**
         * The first child of this route in the router state tree
         * @return {?}
         */
        get: function () { return this._routerState.firstChild(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivatedRoute.prototype, "children", {
        /**
         * The children of this route in the router state tree
         * @return {?}
         */
        get: function () { return this._routerState.children(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivatedRoute.prototype, "pathFromRoot", {
        /**
         * The path from the root of the router state tree to this route
         * @return {?}
         */
        get: function () { return this._routerState.pathFromRoot(this); },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    ActivatedRoute.prototype.toString = function () {
        return this.snapshot ? this.snapshot.toString() : "Future(" + this._futureSnapshot + ")";
    };
    return ActivatedRoute;
}());
function ActivatedRoute_tsickle_Closure_declarations() {
    /**
     * The current snapshot of this route
     * @type {?}
     */
    ActivatedRoute.prototype.snapshot;
    /**
     * \@internal
     * @type {?}
     */
    ActivatedRoute.prototype._futureSnapshot;
    /**
     * \@internal
     * @type {?}
     */
    ActivatedRoute.prototype._routerState;
    /**
     * An observable of the URL segments matched by this route
     * @type {?}
     */
    ActivatedRoute.prototype.url;
    /**
     * An observable of the matrix parameters scoped to this route
     * @type {?}
     */
    ActivatedRoute.prototype.params;
    /**
     * An observable of the query parameters shared by all the routes
     * @type {?}
     */
    ActivatedRoute.prototype.queryParams;
    /**
     * An observable of the URL fragment shared by all the routes
     * @type {?}
     */
    ActivatedRoute.prototype.fragment;
    /**
     * An observable of the static and resolved data of this route.
     * @type {?}
     */
    ActivatedRoute.prototype.data;
    /**
     * The outlet name of the route. It's a constant
     * @type {?}
     */
    ActivatedRoute.prototype.outlet;
    /** @type {?} */
    ActivatedRoute.prototype.component;
}
/**
 * \@internal
 * @param {?} route
 * @return {?}
 */
function inheritedParamsDataResolve(route) {
    var /** @type {?} */ pathToRoot = route.pathFromRoot;
    var /** @type {?} */ inhertingStartingFrom = pathToRoot.length - 1;
    while (inhertingStartingFrom >= 1) {
        var /** @type {?} */ current = pathToRoot[inhertingStartingFrom];
        var /** @type {?} */ parent_1 = pathToRoot[inhertingStartingFrom - 1];
        // current route is an empty path => inherits its parent's params and data
        if (current.routeConfig && current.routeConfig.path === '') {
            inhertingStartingFrom--;
        }
        else if (!parent_1.component) {
            inhertingStartingFrom--;
        }
        else {
            break;
        }
    }
    return pathToRoot.slice(inhertingStartingFrom).reduce(function (res, curr) {
        var /** @type {?} */ params = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_collection__["g" /* merge */])(res.params, curr.params);
        var /** @type {?} */ data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_collection__["g" /* merge */])(res.data, curr.data);
        var /** @type {?} */ resolve = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_collection__["g" /* merge */])(res.resolve, curr._resolvedData);
        return { params: params, data: data, resolve: resolve };
    }, /** @type {?} */ ({ params: {}, data: {}, resolve: {} }));
}
/**
 * \@whatItDoes Contains the information about a route associated with a component loaded in an
 * outlet
 * at a particular moment in time. ActivatedRouteSnapshot can also be used to traverse the router
 * state tree.
 *
 * \@howToUse
 *
 * ```
 * \@Component({templateUrl:'./my-component.html'})
 * class MyComponent {
 *   constructor(route: ActivatedRoute) {
 *     const id: string = route.snapshot.params.id;
 *     const url: string = route.snapshot.url.join('');
 *     const user = route.snapshot.data.user;
 *   }
 * }
 * ```
 *
 * \@stable
 */
var ActivatedRouteSnapshot = (function () {
    /**
     * \@internal
     * @param {?} url
     * @param {?} params
     * @param {?} queryParams
     * @param {?} fragment
     * @param {?} data
     * @param {?} outlet
     * @param {?} component
     * @param {?} routeConfig
     * @param {?} urlSegment
     * @param {?} lastPathIndex
     * @param {?} resolve
     */
    function ActivatedRouteSnapshot(url, params, queryParams, fragment, data, outlet, component, routeConfig, urlSegment, lastPathIndex, resolve) {
        this.url = url;
        this.params = params;
        this.queryParams = queryParams;
        this.fragment = fragment;
        this.data = data;
        this.outlet = outlet;
        this.component = component;
        this._routeConfig = routeConfig;
        this._urlSegment = urlSegment;
        this._lastPathIndex = lastPathIndex;
        this._resolve = resolve;
    }
    Object.defineProperty(ActivatedRouteSnapshot.prototype, "routeConfig", {
        /**
         * The configuration used to match this route
         * @return {?}
         */
        get: function () { return this._routeConfig; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivatedRouteSnapshot.prototype, "root", {
        /**
         * The root of the router state
         * @return {?}
         */
        get: function () { return this._routerState.root; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivatedRouteSnapshot.prototype, "parent", {
        /**
         * The parent of this route in the router state tree
         * @return {?}
         */
        get: function () { return this._routerState.parent(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivatedRouteSnapshot.prototype, "firstChild", {
        /**
         * The first child of this route in the router state tree
         * @return {?}
         */
        get: function () { return this._routerState.firstChild(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivatedRouteSnapshot.prototype, "children", {
        /**
         * The children of this route in the router state tree
         * @return {?}
         */
        get: function () { return this._routerState.children(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivatedRouteSnapshot.prototype, "pathFromRoot", {
        /**
         * The path from the root of the router state tree to this route
         * @return {?}
         */
        get: function () { return this._routerState.pathFromRoot(this); },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    ActivatedRouteSnapshot.prototype.toString = function () {
        var /** @type {?} */ url = this.url.map(function (segment) { return segment.toString(); }).join('/');
        var /** @type {?} */ matched = this._routeConfig ? this._routeConfig.path : '';
        return "Route(url:'" + url + "', path:'" + matched + "')";
    };
    return ActivatedRouteSnapshot;
}());
function ActivatedRouteSnapshot_tsickle_Closure_declarations() {
    /**
     * \@internal *
     * @type {?}
     */
    ActivatedRouteSnapshot.prototype._routeConfig;
    /**
     * \@internal *
     * @type {?}
     */
    ActivatedRouteSnapshot.prototype._urlSegment;
    /**
     * \@internal
     * @type {?}
     */
    ActivatedRouteSnapshot.prototype._lastPathIndex;
    /**
     * \@internal
     * @type {?}
     */
    ActivatedRouteSnapshot.prototype._resolve;
    /**
     * \@internal
     * @type {?}
     */
    ActivatedRouteSnapshot.prototype._resolvedData;
    /**
     * \@internal
     * @type {?}
     */
    ActivatedRouteSnapshot.prototype._routerState;
    /**
     * The URL segments matched by this route
     * @type {?}
     */
    ActivatedRouteSnapshot.prototype.url;
    /**
     * The matrix parameters scoped to this route
     * @type {?}
     */
    ActivatedRouteSnapshot.prototype.params;
    /**
     * The query parameters shared by all the routes
     * @type {?}
     */
    ActivatedRouteSnapshot.prototype.queryParams;
    /**
     * The URL fragment shared by all the routes
     * @type {?}
     */
    ActivatedRouteSnapshot.prototype.fragment;
    /**
     * The static and resolved data of this route
     * @type {?}
     */
    ActivatedRouteSnapshot.prototype.data;
    /**
     * The outlet name of the route
     * @type {?}
     */
    ActivatedRouteSnapshot.prototype.outlet;
    /**
     * The component of the route
     * @type {?}
     */
    ActivatedRouteSnapshot.prototype.component;
}
/**
 * \@whatItDoes Represents the state of the router at a moment in time.
 *
 * \@howToUse
 *
 * ```
 * \@Component({templateUrl:'template.html'})
 * class MyComponent {
 *   constructor(router: Router) {
 *     const state: RouterState = router.routerState;
 *     const snapshot: RouterStateSnapshot = state.snapshot;
 *     const root: ActivatedRouteSnapshot = snapshot.root;
 *     const child = root.firstChild;
 *     const id: Observable<string> = child.params.map(p => p.id);
 *     //...
 *   }
 * }
 * ```
 *
 * \@description
 * RouterStateSnapshot is a tree of activated route snapshots. Every node in this tree knows about
 * the "consumed" URL segments, the extracted parameters, and the resolved data.
 *
 * \@stable
 */
var RouterStateSnapshot = (function (_super) {
    __extends(RouterStateSnapshot, _super);
    /**
     * \@internal
     * @param {?} url
     * @param {?} root
     */
    function RouterStateSnapshot(url, root) {
        _super.call(this, root);
        this.url = url;
        setRouterStateSnapshot(this, root);
    }
    /**
     * @return {?}
     */
    RouterStateSnapshot.prototype.toString = function () { return serializeNode(this._root); };
    return RouterStateSnapshot;
}(__WEBPACK_IMPORTED_MODULE_4__utils_tree__["a" /* Tree */]));
function RouterStateSnapshot_tsickle_Closure_declarations() {
    /**
     * The url from which this snapshot was created
     * @type {?}
     */
    RouterStateSnapshot.prototype.url;
}
/**
 * @param {?} state
 * @param {?} node
 * @return {?}
 */
function setRouterStateSnapshot(state, node) {
    node.value._routerState = state;
    node.children.forEach(function (c) { return setRouterStateSnapshot(state, c); });
}
/**
 * @param {?} node
 * @return {?}
 */
function serializeNode(node) {
    var /** @type {?} */ c = node.children.length > 0 ? " { " + node.children.map(serializeNode).join(", ") + " } " : '';
    return "" + node.value + c;
}
/**
 * The expectation is that the activate route is created with the right set of parameters.
 * So we push new values into the observables only when they are not the initial values.
 * And we detect that by checking if the snapshot field is set.
 * @param {?} route
 * @return {?}
 */
function advanceActivatedRoute(route) {
    if (route.snapshot) {
        var /** @type {?} */ currentSnapshot = route.snapshot;
        route.snapshot = route._futureSnapshot;
        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_collection__["c" /* shallowEqual */])(currentSnapshot.queryParams, route._futureSnapshot.queryParams)) {
            ((route.queryParams)).next(route._futureSnapshot.queryParams);
        }
        if (currentSnapshot.fragment !== route._futureSnapshot.fragment) {
            ((route.fragment)).next(route._futureSnapshot.fragment);
        }
        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_collection__["c" /* shallowEqual */])(currentSnapshot.params, route._futureSnapshot.params)) {
            ((route.params)).next(route._futureSnapshot.params);
        }
        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_collection__["h" /* shallowEqualArrays */])(currentSnapshot.url, route._futureSnapshot.url)) {
            ((route.url)).next(route._futureSnapshot.url);
        }
        if (!equalParamsAndUrlSegments(currentSnapshot, route._futureSnapshot)) {
            ((route.data)).next(route._futureSnapshot.data);
        }
    }
    else {
        route.snapshot = route._futureSnapshot;
        // this is for resolved data
        ((route.data)).next(route._futureSnapshot.data);
    }
}
/**
 * @param {?} a
 * @param {?} b
 * @return {?}
 */
function equalParamsAndUrlSegments(a, b) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_collection__["c" /* shallowEqual */])(a.params, b.params) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__url_tree__["d" /* equalSegments */])(a.url, b.url);
}
//# sourceMappingURL=router_state.js.map

/***/ },
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__control_container__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared__ = __webpack_require__(78);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return AbstractFormGroupDirective; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};


/**
 * This is a base class for code shared between {\@link NgModelGroup} and {\@link FormGroupName}.
 *
 * \@stable
 */
var AbstractFormGroupDirective = (function (_super) {
    __extends(AbstractFormGroupDirective, _super);
    function AbstractFormGroupDirective() {
        _super.apply(this, arguments);
    }
    /**
     * @return {?}
     */
    AbstractFormGroupDirective.prototype.ngOnInit = function () {
        this._checkParentType();
        this.formDirective.addFormGroup(this);
    };
    /**
     * @return {?}
     */
    AbstractFormGroupDirective.prototype.ngOnDestroy = function () {
        if (this.formDirective) {
            this.formDirective.removeFormGroup(this);
        }
    };
    Object.defineProperty(AbstractFormGroupDirective.prototype, "control", {
        /**
         * Get the {\@link FormGroup} backing this binding.
         * @return {?}
         */
        get: function () { return this.formDirective.getFormGroup(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractFormGroupDirective.prototype, "path", {
        /**
         * Get the path to this control group.
         * @return {?}
         */
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__shared__["a" /* controlPath */])(this.name, this._parent); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractFormGroupDirective.prototype, "formDirective", {
        /**
         * Get the {\@link Form} to which this group belongs.
         * @return {?}
         */
        get: function () { return this._parent ? this._parent.formDirective : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractFormGroupDirective.prototype, "validator", {
        /**
         * @return {?}
         */
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__shared__["b" /* composeValidators */])(this._validators); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractFormGroupDirective.prototype, "asyncValidator", {
        /**
         * @return {?}
         */
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__shared__["c" /* composeAsyncValidators */])(this._asyncValidators); },
        enumerable: true,
        configurable: true
    });
    /**
     * \@internal
     * @return {?}
     */
    AbstractFormGroupDirective.prototype._checkParentType = function () { };
    return AbstractFormGroupDirective;
}(__WEBPACK_IMPORTED_MODULE_0__control_container__["a" /* ControlContainer */]));
function AbstractFormGroupDirective_tsickle_Closure_declarations() {
    /**
     * \@internal
     * @type {?}
     */
    AbstractFormGroupDirective.prototype._parent;
    /**
     * \@internal
     * @type {?}
     */
    AbstractFormGroupDirective.prototype._validators;
    /**
     * \@internal
     * @type {?}
     */
    AbstractFormGroupDirective.prototype._asyncValidators;
}
//# sourceMappingURL=abstract_form_group_directive.js.map

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_async__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__validators__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__control_container__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared__ = __webpack_require__(78);
/* unused harmony export formDirectiveProvider */
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return NgForm; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};






var /** @type {?} */ formDirectiveProvider = {
    provide: __WEBPACK_IMPORTED_MODULE_4__control_container__["a" /* ControlContainer */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return NgForm; })
};
var /** @type {?} */ resolvedPromise = Promise.resolve(null);
/**
 * \@whatItDoes Creates a top-level {\@link FormGroup} instance and binds it to a form
 * to track aggregate form value and validation status.
 *
 * \@howToUse
 *
 * As soon as you import the `FormsModule`, this directive becomes active by default on
 * all `<form>` tags.  You don't need to add a special selector.
 *
 * You can export the directive into a local template variable using `ngForm` as the key
 * (ex: `#myForm="ngForm"`). This is optional, but useful.  Many properties from the underlying
 * {\@link FormGroup} instance are duplicated on the directive itself, so a reference to it
 * will give you access to the aggregate value and validity status of the form, as well as
 * user interaction properties like `dirty` and `touched`.
 *
 * To register child controls with the form, you'll want to use {\@link NgModel} with a
 * `name` attribute.  You can also use {\@link NgModelGroup} if you'd like to create
 * sub-groups within the form.
 *
 * You can listen to the directive's `ngSubmit` event to be notified when the user has
 * triggered a form submission. The `ngSubmit` event will be emitted with the original form
 * submission event.
 *
 * {\@example forms/ts/simpleForm/simple_form_example.ts region='Component'}
 *
 * * **npm package**: `\@angular/forms`
 *
 * * **NgModule**: `FormsModule`
 *
 *  \@stable
 */
var NgForm = (function (_super) {
    __extends(NgForm, _super);
    /**
     * @param {?} validators
     * @param {?} asyncValidators
     */
    function NgForm(validators, asyncValidators) {
        _super.call(this);
        this._submitted = false;
        this.ngSubmit = new __WEBPACK_IMPORTED_MODULE_1__facade_async__["a" /* EventEmitter */]();
        this.form =
            new __WEBPACK_IMPORTED_MODULE_2__model__["a" /* FormGroup */]({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared__["b" /* composeValidators */])(validators), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared__["c" /* composeAsyncValidators */])(asyncValidators));
    }
    Object.defineProperty(NgForm.prototype, "submitted", {
        /**
         * @return {?}
         */
        get: function () { return this._submitted; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgForm.prototype, "formDirective", {
        /**
         * @return {?}
         */
        get: function () { return this; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgForm.prototype, "control", {
        /**
         * @return {?}
         */
        get: function () { return this.form; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgForm.prototype, "path", {
        /**
         * @return {?}
         */
        get: function () { return []; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgForm.prototype, "controls", {
        /**
         * @return {?}
         */
        get: function () { return this.form.controls; },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} dir
     * @return {?}
     */
    NgForm.prototype.addControl = function (dir) {
        var _this = this;
        resolvedPromise.then(function () {
            var /** @type {?} */ container = _this._findContainer(dir.path);
            dir._control = (container.registerControl(dir.name, dir.control));
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared__["d" /* setUpControl */])(dir.control, dir);
            dir.control.updateValueAndValidity({ emitEvent: false });
        });
    };
    /**
     * @param {?} dir
     * @return {?}
     */
    NgForm.prototype.getControl = function (dir) { return (this.form.get(dir.path)); };
    /**
     * @param {?} dir
     * @return {?}
     */
    NgForm.prototype.removeControl = function (dir) {
        var _this = this;
        resolvedPromise.then(function () {
            var /** @type {?} */ container = _this._findContainer(dir.path);
            if (container) {
                container.removeControl(dir.name);
            }
        });
    };
    /**
     * @param {?} dir
     * @return {?}
     */
    NgForm.prototype.addFormGroup = function (dir) {
        var _this = this;
        resolvedPromise.then(function () {
            var /** @type {?} */ container = _this._findContainer(dir.path);
            var /** @type {?} */ group = new __WEBPACK_IMPORTED_MODULE_2__model__["a" /* FormGroup */]({});
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared__["e" /* setUpFormContainer */])(group, dir);
            container.registerControl(dir.name, group);
            group.updateValueAndValidity({ emitEvent: false });
        });
    };
    /**
     * @param {?} dir
     * @return {?}
     */
    NgForm.prototype.removeFormGroup = function (dir) {
        var _this = this;
        resolvedPromise.then(function () {
            var /** @type {?} */ container = _this._findContainer(dir.path);
            if (container) {
                container.removeControl(dir.name);
            }
        });
    };
    /**
     * @param {?} dir
     * @return {?}
     */
    NgForm.prototype.getFormGroup = function (dir) { return (this.form.get(dir.path)); };
    /**
     * @param {?} dir
     * @param {?} value
     * @return {?}
     */
    NgForm.prototype.updateModel = function (dir, value) {
        var _this = this;
        resolvedPromise.then(function () {
            var /** @type {?} */ ctrl = (_this.form.get(dir.path));
            ctrl.setValue(value);
        });
    };
    /**
     * @param {?} value
     * @return {?}
     */
    NgForm.prototype.setValue = function (value) { this.control.setValue(value); };
    /**
     * @param {?} $event
     * @return {?}
     */
    NgForm.prototype.onSubmit = function ($event) {
        this._submitted = true;
        this.ngSubmit.emit($event);
        return false;
    };
    /**
     * @return {?}
     */
    NgForm.prototype.onReset = function () { this.resetForm(); };
    /**
     * @param {?=} value
     * @return {?}
     */
    NgForm.prototype.resetForm = function (value) {
        if (value === void 0) { value = undefined; }
        this.form.reset(value);
        this._submitted = false;
    };
    /**
     * \@internal
     * @param {?} path
     * @return {?}
     */
    NgForm.prototype._findContainer = function (path) {
        path.pop();
        return path.length ? (this.form.get(path)) : this.form;
    };
    NgForm.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'form:not([ngNoForm]):not([formGroup]),ngForm,[ngForm]',
                    providers: [formDirectiveProvider],
                    host: { '(submit)': 'onSubmit($event)', '(reset)': 'onReset()' },
                    outputs: ['ngSubmit'],
                    exportAs: 'ngForm'
                },] },
    ];
    /** @nocollapse */
    NgForm.ctorParameters = function () { return [
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_3__validators__["b" /* NG_VALIDATORS */],] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_3__validators__["c" /* NG_ASYNC_VALIDATORS */],] },] },
    ]; };
    return NgForm;
}(__WEBPACK_IMPORTED_MODULE_4__control_container__["a" /* ControlContainer */]));
function NgForm_tsickle_Closure_declarations() {
    /** @type {?} */
    NgForm.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    NgForm.ctorParameters;
    /** @type {?} */
    NgForm.prototype._submitted;
    /** @type {?} */
    NgForm.prototype.form;
    /** @type {?} */
    NgForm.prototype.ngSubmit;
}
//# sourceMappingURL=ng_form.js.map

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__control_value_accessor__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ng_control__ = __webpack_require__(97);
/* unused harmony export RADIO_VALUE_ACCESSOR */
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return RadioControlRegistry; });
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return RadioControlValueAccessor; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */



var /** @type {?} */ RADIO_VALUE_ACCESSOR = {
    provide: __WEBPACK_IMPORTED_MODULE_1__control_value_accessor__["a" /* NG_VALUE_ACCESSOR */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return RadioControlValueAccessor; }),
    multi: true
};
/**
 * Internal class used by Angular to uncheck radio buttons with the matching name.
 */
var RadioControlRegistry = (function () {
    function RadioControlRegistry() {
        this._accessors = [];
    }
    /**
     * @param {?} control
     * @param {?} accessor
     * @return {?}
     */
    RadioControlRegistry.prototype.add = function (control, accessor) {
        this._accessors.push([control, accessor]);
    };
    /**
     * @param {?} accessor
     * @return {?}
     */
    RadioControlRegistry.prototype.remove = function (accessor) {
        for (var /** @type {?} */ i = this._accessors.length - 1; i >= 0; --i) {
            if (this._accessors[i][1] === accessor) {
                this._accessors.splice(i, 1);
                return;
            }
        }
    };
    /**
     * @param {?} accessor
     * @return {?}
     */
    RadioControlRegistry.prototype.select = function (accessor) {
        var _this = this;
        this._accessors.forEach(function (c) {
            if (_this._isSameGroup(c, accessor) && c[1] !== accessor) {
                c[1].fireUncheck(accessor.value);
            }
        });
    };
    /**
     * @param {?} controlPair
     * @param {?} accessor
     * @return {?}
     */
    RadioControlRegistry.prototype._isSameGroup = function (controlPair, accessor) {
        if (!controlPair[0].control)
            return false;
        return controlPair[0]._parent === accessor._control._parent &&
            controlPair[1].name === accessor.name;
    };
    RadioControlRegistry.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    RadioControlRegistry.ctorParameters = function () { return []; };
    return RadioControlRegistry;
}());
function RadioControlRegistry_tsickle_Closure_declarations() {
    /** @type {?} */
    RadioControlRegistry.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    RadioControlRegistry.ctorParameters;
    /** @type {?} */
    RadioControlRegistry.prototype._accessors;
}
/**
 * \@whatItDoes Writes radio control values and listens to radio control changes.
 *
 * Used by {\@link NgModel}, {\@link FormControlDirective}, and {\@link FormControlName}
 * to keep the view synced with the {\@link FormControl} model.
 *
 * \@howToUse
 *
 * If you have imported the {\@link FormsModule} or the {\@link ReactiveFormsModule}, this
 * value accessor will be active on any radio control that has a form directive. You do
 * **not** need to add a special selector to activate it.
 *
 * ### How to use radio buttons with form directives
 *
 * To use radio buttons in a template-driven form, you'll want to ensure that radio buttons
 * in the same group have the same `name` attribute.  Radio buttons with different `name`
 * attributes do not affect each other.
 *
 * {\@example forms/ts/radioButtons/radio_button_example.ts region='TemplateDriven'}
 *
 * When using radio buttons in a reactive form, radio buttons in the same group should have the
 * same `formControlName`. You can also add a `name` attribute, but it's optional.
 *
 * {\@example forms/ts/reactiveRadioButtons/reactive_radio_button_example.ts region='Reactive'}
 *
 *  * **npm package**: `\@angular/forms`
 *
 *  \@stable
 */
var RadioControlValueAccessor = (function () {
    /**
     * @param {?} _renderer
     * @param {?} _elementRef
     * @param {?} _registry
     * @param {?} _injector
     */
    function RadioControlValueAccessor(_renderer, _elementRef, _registry, _injector) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this._registry = _registry;
        this._injector = _injector;
        this.onChange = function () { };
        this.onTouched = function () { };
    }
    /**
     * @return {?}
     */
    RadioControlValueAccessor.prototype.ngOnInit = function () {
        this._control = this._injector.get(__WEBPACK_IMPORTED_MODULE_2__ng_control__["a" /* NgControl */]);
        this._checkName();
        this._registry.add(this._control, this);
    };
    /**
     * @return {?}
     */
    RadioControlValueAccessor.prototype.ngOnDestroy = function () { this._registry.remove(this); };
    /**
     * @param {?} value
     * @return {?}
     */
    RadioControlValueAccessor.prototype.writeValue = function (value) {
        this._state = value === this.value;
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'checked', this._state);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    RadioControlValueAccessor.prototype.registerOnChange = function (fn) {
        var _this = this;
        this._fn = fn;
        this.onChange = function () {
            fn(_this.value);
            _this._registry.select(_this);
        };
    };
    /**
     * @param {?} value
     * @return {?}
     */
    RadioControlValueAccessor.prototype.fireUncheck = function (value) { this.writeValue(value); };
    /**
     * @param {?} fn
     * @return {?}
     */
    RadioControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    RadioControlValueAccessor.prototype.setDisabledState = function (isDisabled) {
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    /**
     * @return {?}
     */
    RadioControlValueAccessor.prototype._checkName = function () {
        if (this.name && this.formControlName && this.name !== this.formControlName) {
            this._throwNameError();
        }
        if (!this.name && this.formControlName)
            this.name = this.formControlName;
    };
    /**
     * @return {?}
     */
    RadioControlValueAccessor.prototype._throwNameError = function () {
        throw new Error("\n      If you define both a name and a formControlName attribute on your radio button, their values\n      must match. Ex: <input type=\"radio\" formControlName=\"food\" name=\"food\">\n    ");
    };
    RadioControlValueAccessor.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'input[type=radio][formControlName],input[type=radio][formControl],input[type=radio][ngModel]',
                    host: { '(change)': 'onChange()', '(blur)': 'onTouched()' },
                    providers: [RADIO_VALUE_ACCESSOR]
                },] },
    ];
    /** @nocollapse */
    RadioControlValueAccessor.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: RadioControlRegistry, },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injector"], },
    ]; };
    RadioControlValueAccessor.propDecorators = {
        'name': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'formControlName': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'value': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return RadioControlValueAccessor;
}());
function RadioControlValueAccessor_tsickle_Closure_declarations() {
    /** @type {?} */
    RadioControlValueAccessor.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    RadioControlValueAccessor.ctorParameters;
    /** @type {?} */
    RadioControlValueAccessor.propDecorators;
    /**
     * \@internal
     * @type {?}
     */
    RadioControlValueAccessor.prototype._state;
    /**
     * \@internal
     * @type {?}
     */
    RadioControlValueAccessor.prototype._control;
    /**
     * \@internal
     * @type {?}
     */
    RadioControlValueAccessor.prototype._fn;
    /** @type {?} */
    RadioControlValueAccessor.prototype.onChange;
    /** @type {?} */
    RadioControlValueAccessor.prototype.onTouched;
    /** @type {?} */
    RadioControlValueAccessor.prototype.name;
    /** @type {?} */
    RadioControlValueAccessor.prototype.formControlName;
    /** @type {?} */
    RadioControlValueAccessor.prototype.value;
    /** @type {?} */
    RadioControlValueAccessor.prototype._renderer;
    /** @type {?} */
    RadioControlValueAccessor.prototype._elementRef;
    /** @type {?} */
    RadioControlValueAccessor.prototype._registry;
    /** @type {?} */
    RadioControlValueAccessor.prototype._injector;
}
//# sourceMappingURL=radio_control_value_accessor.js.map

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_async__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__facade_collection__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__validators__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__control_container__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reactive_errors__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared__ = __webpack_require__(78);
/* unused harmony export formDirectiveProvider */
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return FormGroupDirective; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};







var /** @type {?} */ formDirectiveProvider = {
    provide: __WEBPACK_IMPORTED_MODULE_4__control_container__["a" /* ControlContainer */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return FormGroupDirective; })
};
/**
 * \@whatItDoes Binds an existing {\@link FormGroup} to a DOM element.
 *
 * \@howToUse
 *
 * This directive accepts an existing {\@link FormGroup} instance. It will then use this
 * {\@link FormGroup} instance to match any child {\@link FormControl}, {\@link FormGroup},
 * and {\@link FormArray} instances to child {\@link FormControlName}, {\@link FormGroupName},
 * and {\@link FormArrayName} directives.
 *
 * **Set value**: You can set the form's initial value when instantiating the
 * {\@link FormGroup}, or you can set it programmatically later using the {\@link FormGroup}'s
 * {\@link AbstractControl.setValue} or {\@link AbstractControl.patchValue} methods.
 *
 * **Listen to value**: If you want to listen to changes in the value of the form, you can subscribe
 * to the {\@link FormGroup}'s {\@link AbstractControl.valueChanges} event.  You can also listen to
 * its {\@link AbstractControl.statusChanges} event to be notified when the validation status is
 * re-calculated.
 *
 * Furthermore, you can listen to the directive's `ngSubmit` event to be notified when the user has
 * triggered a form submission. The `ngSubmit` event will be emitted with the original form
 * submission event.
 *
 * ### Example
 *
 * In this example, we create form controls for first name and last name.
 *
 * {\@example forms/ts/simpleFormGroup/simple_form_group_example.ts region='Component'}
 *
 * **npm package**: `\@angular/forms`
 *
 * **NgModule**: {\@link ReactiveFormsModule}
 *
 *  \@stable
 */
var FormGroupDirective = (function (_super) {
    __extends(FormGroupDirective, _super);
    /**
     * @param {?} _validators
     * @param {?} _asyncValidators
     */
    function FormGroupDirective(_validators, _asyncValidators) {
        _super.call(this);
        this._validators = _validators;
        this._asyncValidators = _asyncValidators;
        this._submitted = false;
        this.directives = [];
        this.form = null;
        this.ngSubmit = new __WEBPACK_IMPORTED_MODULE_1__facade_async__["a" /* EventEmitter */]();
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    FormGroupDirective.prototype.ngOnChanges = function (changes) {
        this._checkFormPresent();
        if (changes.hasOwnProperty('form')) {
            this._updateValidators();
            this._updateDomValue();
            this._updateRegistrations();
        }
    };
    Object.defineProperty(FormGroupDirective.prototype, "submitted", {
        /**
         * @return {?}
         */
        get: function () { return this._submitted; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormGroupDirective.prototype, "formDirective", {
        /**
         * @return {?}
         */
        get: function () { return this; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormGroupDirective.prototype, "control", {
        /**
         * @return {?}
         */
        get: function () { return this.form; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormGroupDirective.prototype, "path", {
        /**
         * @return {?}
         */
        get: function () { return []; },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} dir
     * @return {?}
     */
    FormGroupDirective.prototype.addControl = function (dir) {
        var /** @type {?} */ ctrl = this.form.get(dir.path);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared__["d" /* setUpControl */])(ctrl, dir);
        ctrl.updateValueAndValidity({ emitEvent: false });
        this.directives.push(dir);
        return ctrl;
    };
    /**
     * @param {?} dir
     * @return {?}
     */
    FormGroupDirective.prototype.getControl = function (dir) { return (this.form.get(dir.path)); };
    /**
     * @param {?} dir
     * @return {?}
     */
    FormGroupDirective.prototype.removeControl = function (dir) { __WEBPACK_IMPORTED_MODULE_2__facade_collection__["b" /* ListWrapper */].remove(this.directives, dir); };
    /**
     * @param {?} dir
     * @return {?}
     */
    FormGroupDirective.prototype.addFormGroup = function (dir) {
        var /** @type {?} */ ctrl = this.form.get(dir.path);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared__["e" /* setUpFormContainer */])(ctrl, dir);
        ctrl.updateValueAndValidity({ emitEvent: false });
    };
    /**
     * @param {?} dir
     * @return {?}
     */
    FormGroupDirective.prototype.removeFormGroup = function (dir) { };
    /**
     * @param {?} dir
     * @return {?}
     */
    FormGroupDirective.prototype.getFormGroup = function (dir) { return (this.form.get(dir.path)); };
    /**
     * @param {?} dir
     * @return {?}
     */
    FormGroupDirective.prototype.addFormArray = function (dir) {
        var /** @type {?} */ ctrl = this.form.get(dir.path);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared__["e" /* setUpFormContainer */])(ctrl, dir);
        ctrl.updateValueAndValidity({ emitEvent: false });
    };
    /**
     * @param {?} dir
     * @return {?}
     */
    FormGroupDirective.prototype.removeFormArray = function (dir) { };
    /**
     * @param {?} dir
     * @return {?}
     */
    FormGroupDirective.prototype.getFormArray = function (dir) { return (this.form.get(dir.path)); };
    /**
     * @param {?} dir
     * @param {?} value
     * @return {?}
     */
    FormGroupDirective.prototype.updateModel = function (dir, value) {
        var /** @type {?} */ ctrl = (this.form.get(dir.path));
        ctrl.setValue(value);
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    FormGroupDirective.prototype.onSubmit = function ($event) {
        this._submitted = true;
        this.ngSubmit.emit($event);
        return false;
    };
    /**
     * @return {?}
     */
    FormGroupDirective.prototype.onReset = function () { this.resetForm(); };
    /**
     * @param {?=} value
     * @return {?}
     */
    FormGroupDirective.prototype.resetForm = function (value) {
        if (value === void 0) { value = undefined; }
        this.form.reset(value);
        this._submitted = false;
    };
    /**
     * \@internal
     * @return {?}
     */
    FormGroupDirective.prototype._updateDomValue = function () {
        var _this = this;
        this.directives.forEach(function (dir) {
            var /** @type {?} */ newCtrl = _this.form.get(dir.path);
            if (dir._control !== newCtrl) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared__["h" /* cleanUpControl */])(dir._control, dir);
                if (newCtrl)
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared__["d" /* setUpControl */])(newCtrl, dir);
                dir._control = newCtrl;
            }
        });
        this.form._updateTreeValidity({ emitEvent: false });
    };
    /**
     * @return {?}
     */
    FormGroupDirective.prototype._updateRegistrations = function () {
        var _this = this;
        this.form._registerOnCollectionChange(function () { return _this._updateDomValue(); });
        if (this._oldForm)
            this._oldForm._registerOnCollectionChange(function () { });
        this._oldForm = this.form;
    };
    /**
     * @return {?}
     */
    FormGroupDirective.prototype._updateValidators = function () {
        var /** @type {?} */ sync = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared__["b" /* composeValidators */])(this._validators);
        this.form.validator = __WEBPACK_IMPORTED_MODULE_3__validators__["a" /* Validators */].compose([this.form.validator, sync]);
        var /** @type {?} */ async = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared__["c" /* composeAsyncValidators */])(this._asyncValidators);
        this.form.asyncValidator = __WEBPACK_IMPORTED_MODULE_3__validators__["a" /* Validators */].composeAsync([this.form.asyncValidator, async]);
    };
    /**
     * @return {?}
     */
    FormGroupDirective.prototype._checkFormPresent = function () {
        if (!this.form) {
            __WEBPACK_IMPORTED_MODULE_5__reactive_errors__["a" /* ReactiveErrors */].missingFormException();
        }
    };
    FormGroupDirective.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: '[formGroup]',
                    providers: [formDirectiveProvider],
                    host: { '(submit)': 'onSubmit($event)', '(reset)': 'onReset()' },
                    exportAs: 'ngForm'
                },] },
    ];
    /** @nocollapse */
    FormGroupDirective.ctorParameters = function () { return [
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_3__validators__["b" /* NG_VALIDATORS */],] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_3__validators__["c" /* NG_ASYNC_VALIDATORS */],] },] },
    ]; };
    FormGroupDirective.propDecorators = {
        'form': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['formGroup',] },],
        'ngSubmit': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    };
    return FormGroupDirective;
}(__WEBPACK_IMPORTED_MODULE_4__control_container__["a" /* ControlContainer */]));
function FormGroupDirective_tsickle_Closure_declarations() {
    /** @type {?} */
    FormGroupDirective.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    FormGroupDirective.ctorParameters;
    /** @type {?} */
    FormGroupDirective.propDecorators;
    /** @type {?} */
    FormGroupDirective.prototype._submitted;
    /** @type {?} */
    FormGroupDirective.prototype._oldForm;
    /** @type {?} */
    FormGroupDirective.prototype.directives;
    /** @type {?} */
    FormGroupDirective.prototype.form;
    /** @type {?} */
    FormGroupDirective.prototype.ngSubmit;
    /** @type {?} */
    FormGroupDirective.prototype._validators;
    /** @type {?} */
    FormGroupDirective.prototype._asyncValidators;
}
//# sourceMappingURL=form_group_directive.js.map

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validators__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__abstract_form_group_directive__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__control_container__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reactive_errors__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_group_directive__ = __webpack_require__(141);
/* unused harmony export formGroupNameProvider */
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return FormGroupName; });
/* unused harmony export formArrayNameProvider */
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return FormArrayName; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};







var /** @type {?} */ formGroupNameProvider = {
    provide: __WEBPACK_IMPORTED_MODULE_3__control_container__["a" /* ControlContainer */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return FormGroupName; })
};
/**
 * \@whatItDoes Syncs a nested {\@link FormGroup} to a DOM element.
 *
 * \@howToUse
 *
 * This directive can only be used with a parent {\@link FormGroupDirective} (selector:
 * `[formGroup]`).
 *
 * It accepts the string name of the nested {\@link FormGroup} you want to link, and
 * will look for a {\@link FormGroup} registered with that name in the parent
 * {\@link FormGroup} instance you passed into {\@link FormGroupDirective}.
 *
 * Nested form groups can come in handy when you want to validate a sub-group of a
 * form separately from the rest or when you'd like to group the values of certain
 * controls into their own nested object.
 *
 * **Access the group**: You can access the associated {\@link FormGroup} using the
 * {\@link AbstractControl.get} method. Ex: `this.form.get('name')`.
 *
 * You can also access individual controls within the group using dot syntax.
 * Ex: `this.form.get('name.first')`
 *
 * **Get the value**: the `value` property is always synced and available on the
 * {\@link FormGroup}. See a full list of available properties in {\@link AbstractControl}.
 *
 * **Set the value**: You can set an initial value for each child control when instantiating
 * the {\@link FormGroup}, or you can set it programmatically later using
 * {\@link AbstractControl.setValue} or {\@link AbstractControl.patchValue}.
 *
 * **Listen to value**: If you want to listen to changes in the value of the group, you can
 * subscribe to the {\@link AbstractControl.valueChanges} event.  You can also listen to
 * {\@link AbstractControl.statusChanges} to be notified when the validation status is
 * re-calculated.
 *
 * ### Example
 *
 * {\@example forms/ts/nestedFormGroup/nested_form_group_example.ts region='Component'}
 *
 * * **npm package**: `\@angular/forms`
 *
 * * **NgModule**: `ReactiveFormsModule`
 *
 * \@stable
 */
var FormGroupName = (function (_super) {
    __extends(FormGroupName, _super);
    /**
     * @param {?} parent
     * @param {?} validators
     * @param {?} asyncValidators
     */
    function FormGroupName(parent, validators, asyncValidators) {
        _super.call(this);
        this._parent = parent;
        this._validators = validators;
        this._asyncValidators = asyncValidators;
    }
    /**
     * \@internal
     * @return {?}
     */
    FormGroupName.prototype._checkParentType = function () {
        if (_hasInvalidParent(this._parent)) {
            __WEBPACK_IMPORTED_MODULE_4__reactive_errors__["a" /* ReactiveErrors */].groupParentException();
        }
    };
    FormGroupName.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[formGroupName]', providers: [formGroupNameProvider] },] },
    ];
    /** @nocollapse */
    FormGroupName.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_3__control_container__["a" /* ControlContainer */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Host"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["SkipSelf"] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_1__validators__["b" /* NG_VALIDATORS */],] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_1__validators__["c" /* NG_ASYNC_VALIDATORS */],] },] },
    ]; };
    FormGroupName.propDecorators = {
        'name': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['formGroupName',] },],
    };
    return FormGroupName;
}(__WEBPACK_IMPORTED_MODULE_2__abstract_form_group_directive__["a" /* AbstractFormGroupDirective */]));
function FormGroupName_tsickle_Closure_declarations() {
    /** @type {?} */
    FormGroupName.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    FormGroupName.ctorParameters;
    /** @type {?} */
    FormGroupName.propDecorators;
    /** @type {?} */
    FormGroupName.prototype.name;
}
var /** @type {?} */ formArrayNameProvider = {
    provide: __WEBPACK_IMPORTED_MODULE_3__control_container__["a" /* ControlContainer */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return FormArrayName; })
};
/**
 * \@whatItDoes Syncs a nested {\@link FormArray} to a DOM element.
 *
 * \@howToUse
 *
 * This directive is designed to be used with a parent {\@link FormGroupDirective} (selector:
 * `[formGroup]`).
 *
 * It accepts the string name of the nested {\@link FormArray} you want to link, and
 * will look for a {\@link FormArray} registered with that name in the parent
 * {\@link FormGroup} instance you passed into {\@link FormGroupDirective}.
 *
 * Nested form arrays can come in handy when you have a group of form controls but
 * you're not sure how many there will be. Form arrays allow you to create new
 * form controls dynamically.
 *
 * **Access the array**: You can access the associated {\@link FormArray} using the
 * {\@link AbstractControl.get} method on the parent {\@link FormGroup}.
 * Ex: `this.form.get('cities')`.
 *
 * **Get the value**: the `value` property is always synced and available on the
 * {\@link FormArray}. See a full list of available properties in {\@link AbstractControl}.
 *
 * **Set the value**: You can set an initial value for each child control when instantiating
 * the {\@link FormArray}, or you can set the value programmatically later using the
 * {\@link FormArray}'s {\@link AbstractControl.setValue} or {\@link AbstractControl.patchValue}
 * methods.
 *
 * **Listen to value**: If you want to listen to changes in the value of the array, you can
 * subscribe to the {\@link FormArray}'s {\@link AbstractControl.valueChanges} event.  You can also
 * listen to its {\@link AbstractControl.statusChanges} event to be notified when the validation
 * status is re-calculated.
 *
 * **Add new controls**: You can add new controls to the {\@link FormArray} dynamically by
 * calling its {\@link FormArray.push} method.
 *  Ex: `this.form.get('cities').push(new FormControl());`
 *
 * ### Example
 *
 * {\@example forms/ts/nestedFormArray/nested_form_array_example.ts region='Component'}
 *
 * * **npm package**: `\@angular/forms`
 *
 * * **NgModule**: `ReactiveFormsModule`
 *
 * \@stable
 */
var FormArrayName = (function (_super) {
    __extends(FormArrayName, _super);
    /**
     * @param {?} parent
     * @param {?} validators
     * @param {?} asyncValidators
     */
    function FormArrayName(parent, validators, asyncValidators) {
        _super.call(this);
        this._parent = parent;
        this._validators = validators;
        this._asyncValidators = asyncValidators;
    }
    /**
     * @return {?}
     */
    FormArrayName.prototype.ngOnInit = function () {
        this._checkParentType();
        this.formDirective.addFormArray(this);
    };
    /**
     * @return {?}
     */
    FormArrayName.prototype.ngOnDestroy = function () {
        if (this.formDirective) {
            this.formDirective.removeFormArray(this);
        }
    };
    Object.defineProperty(FormArrayName.prototype, "control", {
        /**
         * @return {?}
         */
        get: function () { return this.formDirective.getFormArray(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormArrayName.prototype, "formDirective", {
        /**
         * @return {?}
         */
        get: function () {
            return this._parent ? (this._parent.formDirective) : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormArrayName.prototype, "path", {
        /**
         * @return {?}
         */
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared__["a" /* controlPath */])(this.name, this._parent); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormArrayName.prototype, "validator", {
        /**
         * @return {?}
         */
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared__["b" /* composeValidators */])(this._validators); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormArrayName.prototype, "asyncValidator", {
        /**
         * @return {?}
         */
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared__["c" /* composeAsyncValidators */])(this._asyncValidators); },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    FormArrayName.prototype._checkParentType = function () {
        if (_hasInvalidParent(this._parent)) {
            __WEBPACK_IMPORTED_MODULE_4__reactive_errors__["a" /* ReactiveErrors */].arrayParentException();
        }
    };
    FormArrayName.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[formArrayName]', providers: [formArrayNameProvider] },] },
    ];
    /** @nocollapse */
    FormArrayName.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_3__control_container__["a" /* ControlContainer */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Host"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["SkipSelf"] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_1__validators__["b" /* NG_VALIDATORS */],] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_1__validators__["c" /* NG_ASYNC_VALIDATORS */],] },] },
    ]; };
    FormArrayName.propDecorators = {
        'name': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['formArrayName',] },],
    };
    return FormArrayName;
}(__WEBPACK_IMPORTED_MODULE_3__control_container__["a" /* ControlContainer */]));
function FormArrayName_tsickle_Closure_declarations() {
    /** @type {?} */
    FormArrayName.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    FormArrayName.ctorParameters;
    /** @type {?} */
    FormArrayName.propDecorators;
    /**
     * \@internal
     * @type {?}
     */
    FormArrayName.prototype._parent;
    /**
     * \@internal
     * @type {?}
     */
    FormArrayName.prototype._validators;
    /**
     * \@internal
     * @type {?}
     */
    FormArrayName.prototype._asyncValidators;
    /** @type {?} */
    FormArrayName.prototype.name;
}
/**
 * @param {?} parent
 * @return {?}
 */
function _hasInvalidParent(parent) {
    return !(parent instanceof FormGroupName) && !(parent instanceof __WEBPACK_IMPORTED_MODULE_6__form_group_directive__["a" /* FormGroupDirective */]) &&
        !(parent instanceof FormArrayName);
}
//# sourceMappingURL=form_group_name.js.map

/***/ },
/* 143 */,
/* 144 */,
/* 145 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_BehaviorSubject__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_BehaviorSubject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_BehaviorSubject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_Subject__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_Subject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_Subject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_observable_from__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_observable_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_observable_of__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_observable_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_operator_concatMap__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_operator_concatMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_rxjs_operator_concatMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_every__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_every___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs_operator_every__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_operator_first__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_operator_first___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_rxjs_operator_first__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs_operator_map__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_rxjs_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rxjs_operator_mergeMap__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rxjs_operator_mergeMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_rxjs_operator_mergeMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rxjs_operator_reduce__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rxjs_operator_reduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_rxjs_operator_reduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__apply_redirects__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__config__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__create_router_state__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__create_url_tree__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__recognize__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__router_config_loader__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__router_outlet_map__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__router_state__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__shared__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__url_handling_strategy__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__url_tree__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_collection__ = __webpack_require__(61);
/* harmony export (binding) */ __webpack_require__.d(exports, "e", function() { return NavigationStart; });
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return NavigationEnd; });
/* harmony export (binding) */ __webpack_require__.d(exports, "c", function() { return NavigationCancel; });
/* harmony export (binding) */ __webpack_require__.d(exports, "d", function() { return NavigationError; });
/* harmony export (binding) */ __webpack_require__.d(exports, "f", function() { return RoutesRecognized; });
/* unused harmony export DefaultRouteReuseStrategy */
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return Router; });
/* unused harmony export PreActivation */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */























/**
 * \@whatItDoes Represents an event triggered when a navigation starts.
 *
 * \@stable
 */
var NavigationStart = (function () {
    /**
     * @param {?} id
     * @param {?} url
     */
    function NavigationStart(id, url) {
        this.id = id;
        this.url = url;
    }
    /**
     * \@docsNotRequired
     * @return {?}
     */
    NavigationStart.prototype.toString = function () { return "NavigationStart(id: " + this.id + ", url: '" + this.url + "')"; };
    return NavigationStart;
}());
function NavigationStart_tsickle_Closure_declarations() {
    /**
     * \@docsNotRequired
     * @type {?}
     */
    NavigationStart.prototype.id;
    /**
     * \@docsNotRequired
     * @type {?}
     */
    NavigationStart.prototype.url;
}
/**
 * \@whatItDoes Represents an event triggered when a navigation ends successfully.
 *
 * \@stable
 */
var NavigationEnd = (function () {
    /**
     * @param {?} id
     * @param {?} url
     * @param {?} urlAfterRedirects
     */
    function NavigationEnd(id, url, urlAfterRedirects) {
        this.id = id;
        this.url = url;
        this.urlAfterRedirects = urlAfterRedirects;
    }
    /**
     * \@docsNotRequired
     * @return {?}
     */
    NavigationEnd.prototype.toString = function () {
        return "NavigationEnd(id: " + this.id + ", url: '" + this.url + "', urlAfterRedirects: '" + this.urlAfterRedirects + "')";
    };
    return NavigationEnd;
}());
function NavigationEnd_tsickle_Closure_declarations() {
    /**
     * \@docsNotRequired
     * @type {?}
     */
    NavigationEnd.prototype.id;
    /**
     * \@docsNotRequired
     * @type {?}
     */
    NavigationEnd.prototype.url;
    /**
     * \@docsNotRequired
     * @type {?}
     */
    NavigationEnd.prototype.urlAfterRedirects;
}
/**
 * \@whatItDoes Represents an event triggered when a navigation is canceled.
 *
 * \@stable
 */
var NavigationCancel = (function () {
    /**
     * @param {?} id
     * @param {?} url
     * @param {?} reason
     */
    function NavigationCancel(id, url, reason) {
        this.id = id;
        this.url = url;
        this.reason = reason;
    }
    /**
     * \@docsNotRequired
     * @return {?}
     */
    NavigationCancel.prototype.toString = function () { return "NavigationCancel(id: " + this.id + ", url: '" + this.url + "')"; };
    return NavigationCancel;
}());
function NavigationCancel_tsickle_Closure_declarations() {
    /**
     * \@docsNotRequired
     * @type {?}
     */
    NavigationCancel.prototype.id;
    /**
     * \@docsNotRequired
     * @type {?}
     */
    NavigationCancel.prototype.url;
    /**
     * \@docsNotRequired
     * @type {?}
     */
    NavigationCancel.prototype.reason;
}
/**
 * \@whatItDoes Represents an event triggered when a navigation fails due to an unexpected error.
 *
 * \@stable
 */
var NavigationError = (function () {
    /**
     * @param {?} id
     * @param {?} url
     * @param {?} error
     */
    function NavigationError(id, url, error) {
        this.id = id;
        this.url = url;
        this.error = error;
    }
    /**
     * \@docsNotRequired
     * @return {?}
     */
    NavigationError.prototype.toString = function () {
        return "NavigationError(id: " + this.id + ", url: '" + this.url + "', error: " + this.error + ")";
    };
    return NavigationError;
}());
function NavigationError_tsickle_Closure_declarations() {
    /**
     * \@docsNotRequired
     * @type {?}
     */
    NavigationError.prototype.id;
    /**
     * \@docsNotRequired
     * @type {?}
     */
    NavigationError.prototype.url;
    /**
     * \@docsNotRequired
     * @type {?}
     */
    NavigationError.prototype.error;
}
/**
 * \@whatItDoes Represents an event triggered when routes are recognized.
 *
 * \@stable
 */
var RoutesRecognized = (function () {
    /**
     * @param {?} id
     * @param {?} url
     * @param {?} urlAfterRedirects
     * @param {?} state
     */
    function RoutesRecognized(id, url, urlAfterRedirects, state) {
        this.id = id;
        this.url = url;
        this.urlAfterRedirects = urlAfterRedirects;
        this.state = state;
    }
    /**
     * \@docsNotRequired
     * @return {?}
     */
    RoutesRecognized.prototype.toString = function () {
        return "RoutesRecognized(id: " + this.id + ", url: '" + this.url + "', urlAfterRedirects: '" + this.urlAfterRedirects + "', state: " + this.state + ")";
    };
    return RoutesRecognized;
}());
function RoutesRecognized_tsickle_Closure_declarations() {
    /**
     * \@docsNotRequired
     * @type {?}
     */
    RoutesRecognized.prototype.id;
    /**
     * \@docsNotRequired
     * @type {?}
     */
    RoutesRecognized.prototype.url;
    /**
     * \@docsNotRequired
     * @type {?}
     */
    RoutesRecognized.prototype.urlAfterRedirects;
    /**
     * \@docsNotRequired
     * @type {?}
     */
    RoutesRecognized.prototype.state;
}
/**
 * @param {?} error
 * @return {?}
 */
function defaultErrorHandler(error) {
    throw error;
}
/**
 * \@internal
 * @param {?} snapshot
 * @return {?}
 */
function defaultRouterHook(snapshot) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_of__["of"])(null);
}
/**
 * Does not detach any subtrees. Reuses routes as long as their route config is the same.
 */
var DefaultRouteReuseStrategy = (function () {
    function DefaultRouteReuseStrategy() {
    }
    /**
     * @param {?} route
     * @return {?}
     */
    DefaultRouteReuseStrategy.prototype.shouldDetach = function (route) { return false; };
    /**
     * @param {?} route
     * @param {?} detachedTree
     * @return {?}
     */
    DefaultRouteReuseStrategy.prototype.store = function (route, detachedTree) { };
    /**
     * @param {?} route
     * @return {?}
     */
    DefaultRouteReuseStrategy.prototype.shouldAttach = function (route) { return false; };
    /**
     * @param {?} route
     * @return {?}
     */
    DefaultRouteReuseStrategy.prototype.retrieve = function (route) { return null; };
    /**
     * @param {?} future
     * @param {?} curr
     * @return {?}
     */
    DefaultRouteReuseStrategy.prototype.shouldReuseRoute = function (future, curr) {
        return future.routeConfig === curr.routeConfig;
    };
    return DefaultRouteReuseStrategy;
}());
/**
 * \@whatItDoes Provides the navigation and url manipulation capabilities.
 *
 * See {\@link Routes} for more details and examples.
 *
 * \@ngModule RouterModule
 *
 * \@stable
 */
var Router = (function () {
    /**
     * @param {?} rootComponentType
     * @param {?} urlSerializer
     * @param {?} outletMap
     * @param {?} location
     * @param {?} injector
     * @param {?} loader
     * @param {?} compiler
     * @param {?} config
     */
    function Router(rootComponentType, urlSerializer, outletMap, location, injector, loader, compiler, config) {
        this.rootComponentType = rootComponentType;
        this.urlSerializer = urlSerializer;
        this.outletMap = outletMap;
        this.location = location;
        this.injector = injector;
        this.config = config;
        this.navigations = new __WEBPACK_IMPORTED_MODULE_1_rxjs_BehaviorSubject__["BehaviorSubject"](null);
        this.routerEvents = new __WEBPACK_IMPORTED_MODULE_2_rxjs_Subject__["Subject"]();
        this.navigationId = 0;
        /**
         * Error handler that is invoked when a navigation errors.
         *
         * See {@link ErrorHandler} for more information.
         */
        this.errorHandler = defaultErrorHandler;
        /**
         * Indicates if at least one navigation happened.
         */
        this.navigated = false;
        /**
         * Extracts and merges URLs. Used for Angular 1 to Angular 2 migrations.
         * Used by RouterModule. This allows us to
         * pause the navigation either before preactivation or after it.
         * @internal
         */
        this.hooks = {
            beforePreactivation: defaultRouterHook,
            afterPreactivation: defaultRouterHook
        };
        /**
         * Extracts and merges URLs. Used for AngularJS to Angular migrations.
         */
        this.urlHandlingStrategy = new __WEBPACK_IMPORTED_MODULE_20__url_handling_strategy__["a" /* DefaultUrlHandlingStrategy */]();
        this.routeReuseStrategy = new DefaultRouteReuseStrategy();
        this.resetConfig(config);
        this.currentUrlTree = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__url_tree__["f" /* createEmptyUrlTree */])();
        this.rawUrlTree = this.currentUrlTree;
        this.configLoader = new __WEBPACK_IMPORTED_MODULE_16__router_config_loader__["b" /* RouterConfigLoader */](loader, compiler);
        this.currentRouterState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__router_state__["f" /* createEmptyState */])(this.currentUrlTree, this.rootComponentType);
        this.processNavigations();
    }
    /**
     * \@internal
     * TODO: this should be removed once the constructor of the router made internal
     * @param {?} rootComponentType
     * @return {?}
     */
    Router.prototype.resetRootComponentType = function (rootComponentType) {
        this.rootComponentType = rootComponentType;
        // TODO: vsavkin router 4.0 should make the root component set to null
        // this will simplify the lifecycle of the router.
        this.currentRouterState.root.component = this.rootComponentType;
    };
    /**
     * Sets up the location change listener and performs the initial navigation.
     * @return {?}
     */
    Router.prototype.initialNavigation = function () {
        this.setUpLocationChangeListener();
        if (this.navigationId === 0) {
            this.navigateByUrl(this.location.path(true), { replaceUrl: true });
        }
    };
    /**
     * Sets up the location change listener.
     * @return {?}
     */
    Router.prototype.setUpLocationChangeListener = function () {
        var _this = this;
        // Zone.current.wrap is needed because of the issue with RxJS scheduler,
        // which does not work properly with zone.js in IE and Safari
        if (!this.locationSubscription) {
            this.locationSubscription = (this.location.subscribe(Zone.current.wrap(function (change) {
                var /** @type {?} */ rawUrlTree = _this.urlSerializer.parse(change['url']);
                var /** @type {?} */ source = change['type'] === 'popstate' ? 'popstate' : 'hashchange';
                setTimeout(function () { _this.scheduleNavigation(rawUrlTree, source, { replaceUrl: true }); }, 0);
            })));
        }
    };
    Object.defineProperty(Router.prototype, "routerState", {
        /**
         * The current route state
         * @return {?}
         */
        get: function () { return this.currentRouterState; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Router.prototype, "url", {
        /**
         * The current url
         * @return {?}
         */
        get: function () { return this.serializeUrl(this.currentUrlTree); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Router.prototype, "events", {
        /**
         * An observable of router events
         * @return {?}
         */
        get: function () { return this.routerEvents; },
        enumerable: true,
        configurable: true
    });
    /**
     * Resets the configuration used for navigation and generating links.
     *
     * ### Usage
     *
     * ```
     * router.resetConfig([
     *  { path: 'team/:id', component: TeamCmp, children: [
     *    { path: 'simple', component: SimpleCmp },
     *    { path: 'user/:name', component: UserCmp }
     *  ]}
     * ]);
     * ```
     * @param {?} config
     * @return {?}
     */
    Router.prototype.resetConfig = function (config) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__config__["a" /* validateConfig */])(config);
        this.config = config;
    };
    /**
     * \@docsNotRequired
     * @return {?}
     */
    Router.prototype.ngOnDestroy = function () { this.dispose(); };
    /**
     * Disposes of the router
     * @return {?}
     */
    Router.prototype.dispose = function () {
        if (this.locationSubscription) {
            this.locationSubscription.unsubscribe();
            this.locationSubscription = null;
        }
    };
    /**
     * Applies an array of commands to the current url tree and creates a new url tree.
     *
     * When given an activate route, applies the given commands starting from the route.
     * When not given a route, applies the given command starting from the root.
     *
     * ### Usage
     *
     * ```
     * // create /team/33/user/11
     * router.createUrlTree(['/team', 33, 'user', 11]);
     *
     * // create /team/33;expand=true/user/11
     * router.createUrlTree(['/team', 33, {expand: true}, 'user', 11]);
     *
     * // you can collapse static segments like this (this works only with the first passed-in value):
     * router.createUrlTree(['/team/33/user', userId]);
     *
     * // If the first segment can contain slashes, and you do not want the router to split it, you
     * // can do the following:
     *
     * router.createUrlTree([{segmentPath: '/one/two'}]);
     *
     * // create /team/33/(user/11//right:chat)
     * router.createUrlTree(['/team', 33, {outlets: {primary: 'user/11', right: 'chat'}}]);
     *
     * // remove the right secondary node
     * router.createUrlTree(['/team', 33, {outlets: {primary: 'user/11', right: null}}]);
     *
     * // assuming the current url is `/team/33/user/11` and the route points to `user/11`
     *
     * // navigate to /team/33/user/11/details
     * router.createUrlTree(['details'], {relativeTo: route});
     *
     * // navigate to /team/33/user/22
     * router.createUrlTree(['../22'], {relativeTo: route});
     *
     * // navigate to /team/44/user/22
     * router.createUrlTree(['../../team/44/user/22'], {relativeTo: route});
     * ```
     * @param {?} commands
     * @param {?=} __1
     * @return {?}
     */
    Router.prototype.createUrlTree = function (commands, _a) {
        var _b = _a === void 0 ? {} : _a, relativeTo = _b.relativeTo, queryParams = _b.queryParams, fragment = _b.fragment, preserveQueryParams = _b.preserveQueryParams, preserveFragment = _b.preserveFragment;
        var /** @type {?} */ a = relativeTo || this.routerState.root;
        var /** @type {?} */ q = preserveQueryParams ? this.currentUrlTree.queryParams : queryParams;
        var /** @type {?} */ f = preserveFragment ? this.currentUrlTree.fragment : fragment;
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__create_url_tree__["a" /* createUrlTree */])(a, this.currentUrlTree, commands, q, f);
    };
    /**
     * Navigate based on the provided url. This navigation is always absolute.
     *
     * Returns a promise that:
     * - resolves to 'true' when navigation succeeds,
     * - resolves to 'false' when navigation fails,
     * - is rejected when an error happens.
     *
     * ### Usage
     *
     * ```
     * router.navigateByUrl("/team/33/user/11");
     *
     * // Navigate without updating the URL
     * router.navigateByUrl("/team/33/user/11", { skipLocationChange: true });
     * ```
     *
     * In opposite to `navigate`, `navigateByUrl` takes a whole URL
     * and does not apply any delta to the current one.
     * @param {?} url
     * @param {?=} extras
     * @return {?}
     */
    Router.prototype.navigateByUrl = function (url, extras) {
        if (extras === void 0) { extras = { skipLocationChange: false }; }
        if (url instanceof __WEBPACK_IMPORTED_MODULE_21__url_tree__["b" /* UrlTree */]) {
            return this.scheduleNavigation(this.urlHandlingStrategy.merge(url, this.rawUrlTree), 'imperative', extras);
        }
        var /** @type {?} */ urlTree = this.urlSerializer.parse(url);
        return this.scheduleNavigation(this.urlHandlingStrategy.merge(urlTree, this.rawUrlTree), 'imperative', extras);
    };
    /**
     * Navigate based on the provided array of commands and a starting point.
     * If no starting route is provided, the navigation is absolute.
     *
     * Returns a promise that:
     * - resolves to 'true' when navigation succeeds,
     * - resolves to 'false' when navigation fails,
     * - is rejected when an error happens.
     *
     * ### Usage
     *
     * ```
     * router.navigate(['team', 33, 'user', 11], {relativeTo: route});
     *
     * // Navigate without updating the URL
     * router.navigate(['team', 33, 'user', 11], {relativeTo: route, skipLocationChange: true});
     * ```
     *
     * In opposite to `navigateByUrl`, `navigate` always takes a delta that is applied to the current
     * URL.
     * @param {?} commands
     * @param {?=} extras
     * @return {?}
     */
    Router.prototype.navigate = function (commands, extras) {
        if (extras === void 0) { extras = { skipLocationChange: false }; }
        validateCommands(commands);
        if (typeof extras.queryParams === 'object' && extras.queryParams !== null) {
            extras.queryParams = this.removeEmptyProps(extras.queryParams);
        }
        return this.navigateByUrl(this.createUrlTree(commands, extras), extras);
    };
    /**
     * Serializes a {\@link UrlTree} into a string
     * @param {?} url
     * @return {?}
     */
    Router.prototype.serializeUrl = function (url) { return this.urlSerializer.serialize(url); };
    /**
     * Parses a string into a {\@link UrlTree}
     * @param {?} url
     * @return {?}
     */
    Router.prototype.parseUrl = function (url) { return this.urlSerializer.parse(url); };
    /**
     * Returns whether the url is activated
     * @param {?} url
     * @param {?} exact
     * @return {?}
     */
    Router.prototype.isActive = function (url, exact) {
        if (url instanceof __WEBPACK_IMPORTED_MODULE_21__url_tree__["b" /* UrlTree */]) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__url_tree__["g" /* containsTree */])(this.currentUrlTree, url, exact);
        }
        else {
            var /** @type {?} */ urlTree = this.urlSerializer.parse(url);
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__url_tree__["g" /* containsTree */])(this.currentUrlTree, urlTree, exact);
        }
    };
    /**
     * @param {?} params
     * @return {?}
     */
    Router.prototype.removeEmptyProps = function (params) {
        return Object.keys(params).reduce(function (result, key) {
            var /** @type {?} */ value = params[key];
            if (value !== null && value !== undefined) {
                result[key] = value;
            }
            return result;
        }, {});
    };
    /**
     * @return {?}
     */
    Router.prototype.processNavigations = function () {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_5_rxjs_operator_concatMap__["concatMap"]
            .call(this.navigations, function (nav) {
            if (nav) {
                _this.executeScheduledNavigation(nav);
                // a failed navigation should not stop the router from processing
                // further navigations => the catch
                return nav.promise.catch(function () { });
            }
            else {
                return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_of__["of"])(null));
            }
        })
            .subscribe(function () { });
    };
    /**
     * @param {?} rawUrl
     * @param {?} source
     * @param {?} extras
     * @return {?}
     */
    Router.prototype.scheduleNavigation = function (rawUrl, source, extras) {
        var /** @type {?} */ lastNavigation = this.navigations.value;
        // If the user triggers a navigation imperatively (e.g., by using navigateByUrl),
        // and that navigation results in 'replaceState' that leads to the same URL,
        // we should skip those.
        if (lastNavigation && source !== 'imperative' && lastNavigation.source === 'imperative' &&
            lastNavigation.rawUrl.toString() === rawUrl.toString()) {
            return null; // return value is not used
        }
        // Because of a bug in IE and Edge, the location class fires two events (popstate and
        // hashchange)
        // every single time. The second one should be ignored. Otherwise, the URL will flicker.
        if (lastNavigation && source == 'hashchange' && lastNavigation.source === 'popstate' &&
            lastNavigation.rawUrl.toString() === rawUrl.toString()) {
            return null; // return value is not used
        }
        var /** @type {?} */ resolve = null;
        var /** @type {?} */ reject = null;
        var /** @type {?} */ promise = new Promise(function (res, rej) {
            resolve = res;
            reject = rej;
        });
        var /** @type {?} */ id = ++this.navigationId;
        this.navigations.next({ id: id, source: source, rawUrl: rawUrl, extras: extras, resolve: resolve, reject: reject, promise: promise });
        // Make sure that the error is propagated even though `processNavigations` catch
        // handler does not rethrow
        return promise.catch(function (e) { return Promise.reject(e); });
    };
    /**
     * @param {?} __0
     * @return {?}
     */
    Router.prototype.executeScheduledNavigation = function (_a) {
        var _this = this;
        var id = _a.id, rawUrl = _a.rawUrl, extras = _a.extras, resolve = _a.resolve, reject = _a.reject;
        var /** @type {?} */ url = this.urlHandlingStrategy.extract(rawUrl);
        var /** @type {?} */ urlTransition = !this.navigated || url.toString() !== this.currentUrlTree.toString();
        if (urlTransition && this.urlHandlingStrategy.shouldProcessUrl(rawUrl)) {
            this.routerEvents.next(new NavigationStart(id, this.serializeUrl(url)));
            Promise.resolve()
                .then(function (_) { return _this.runNavigate(url, rawUrl, extras.skipLocationChange, extras.replaceUrl, id, null); })
                .then(resolve, reject);
        }
        else if (urlTransition && this.rawUrlTree &&
            this.urlHandlingStrategy.shouldProcessUrl(this.rawUrlTree)) {
            this.routerEvents.next(new NavigationStart(id, this.serializeUrl(url)));
            Promise.resolve()
                .then(function (_) { return _this.runNavigate(url, rawUrl, false, false, id, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__router_state__["f" /* createEmptyState */])(url, _this.rootComponentType).snapshot); })
                .then(resolve, reject);
        }
        else {
            this.rawUrlTree = rawUrl;
            resolve(null);
        }
    };
    /**
     * @param {?} url
     * @param {?} rawUrl
     * @param {?} shouldPreventPushState
     * @param {?} shouldReplaceUrl
     * @param {?} id
     * @param {?} precreatedState
     * @return {?}
     */
    Router.prototype.runNavigate = function (url, rawUrl, shouldPreventPushState, shouldReplaceUrl, id, precreatedState) {
        var _this = this;
        if (id !== this.navigationId) {
            this.location.go(this.urlSerializer.serialize(this.currentUrlTree));
            this.routerEvents.next(new NavigationCancel(id, this.serializeUrl(url), "Navigation ID " + id + " is not equal to the current navigation id " + this.navigationId));
            return Promise.resolve(false);
        }
        return new Promise(function (resolvePromise, rejectPromise) {
            // create an observable of the url and route state snapshot
            // this operation do not result in any side effects
            var /** @type {?} */ urlAndSnapshot$;
            if (!precreatedState) {
                var /** @type {?} */ redirectsApplied$ = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__apply_redirects__["a" /* applyRedirects */])(_this.injector, _this.configLoader, _this.urlSerializer, url, _this.config);
                urlAndSnapshot$ = __WEBPACK_IMPORTED_MODULE_9_rxjs_operator_mergeMap__["mergeMap"].call(redirectsApplied$, function (appliedUrl) {
                    return __WEBPACK_IMPORTED_MODULE_8_rxjs_operator_map__["map"].call(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__recognize__["a" /* recognize */])(_this.rootComponentType, _this.config, appliedUrl, _this.serializeUrl(appliedUrl)), function (snapshot) {
                        _this.routerEvents.next(new RoutesRecognized(id, _this.serializeUrl(url), _this.serializeUrl(appliedUrl), snapshot));
                        return { appliedUrl: appliedUrl, snapshot: snapshot };
                    });
                });
            }
            else {
                urlAndSnapshot$ = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_of__["of"])({ appliedUrl: url, snapshot: precreatedState });
            }
            var /** @type {?} */ beforePreactivationDone$ = __WEBPACK_IMPORTED_MODULE_9_rxjs_operator_mergeMap__["mergeMap"].call(urlAndSnapshot$, function (p) {
                return __WEBPACK_IMPORTED_MODULE_8_rxjs_operator_map__["map"].call(_this.hooks.beforePreactivation(p.snapshot), function () { return p; });
            });
            // run preactivation: guards and data resolvers
            var /** @type {?} */ preActivation;
            var /** @type {?} */ preactivationTraverse$ = __WEBPACK_IMPORTED_MODULE_8_rxjs_operator_map__["map"].call(beforePreactivationDone$, function (_a) {
                var appliedUrl = _a.appliedUrl, snapshot = _a.snapshot;
                preActivation =
                    new PreActivation(snapshot, _this.currentRouterState.snapshot, _this.injector);
                preActivation.traverse(_this.outletMap);
                return { appliedUrl: appliedUrl, snapshot: snapshot };
            });
            var /** @type {?} */ preactivationCheckGuards$ = __WEBPACK_IMPORTED_MODULE_9_rxjs_operator_mergeMap__["mergeMap"].call(preactivationTraverse$, function (_a) {
                var appliedUrl = _a.appliedUrl, snapshot = _a.snapshot;
                if (_this.navigationId !== id)
                    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_of__["of"])(false);
                return __WEBPACK_IMPORTED_MODULE_8_rxjs_operator_map__["map"].call(preActivation.checkGuards(), function (shouldActivate) {
                    return { appliedUrl: appliedUrl, snapshot: snapshot, shouldActivate: shouldActivate };
                });
            });
            var /** @type {?} */ preactivationResolveData$ = __WEBPACK_IMPORTED_MODULE_9_rxjs_operator_mergeMap__["mergeMap"].call(preactivationCheckGuards$, function (p) {
                if (_this.navigationId !== id)
                    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_of__["of"])(false);
                if (p.shouldActivate) {
                    return __WEBPACK_IMPORTED_MODULE_8_rxjs_operator_map__["map"].call(preActivation.resolveData(), function () { return p; });
                }
                else {
                    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_of__["of"])(p);
                }
            });
            var /** @type {?} */ preactivationDone$ = __WEBPACK_IMPORTED_MODULE_9_rxjs_operator_mergeMap__["mergeMap"].call(preactivationResolveData$, function (p) {
                return __WEBPACK_IMPORTED_MODULE_8_rxjs_operator_map__["map"].call(_this.hooks.afterPreactivation(p.snapshot), function () { return p; });
            });
            // create router state
            // this operation has side effects => route state is being affected
            var /** @type {?} */ routerState$ = __WEBPACK_IMPORTED_MODULE_8_rxjs_operator_map__["map"].call(preactivationDone$, function (_a) {
                var appliedUrl = _a.appliedUrl, snapshot = _a.snapshot, shouldActivate = _a.shouldActivate;
                if (shouldActivate) {
                    var /** @type {?} */ state = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__create_router_state__["a" /* createRouterState */])(_this.routeReuseStrategy, snapshot, _this.currentRouterState);
                    return { appliedUrl: appliedUrl, state: state, shouldActivate: shouldActivate };
                }
                else {
                    return { appliedUrl: appliedUrl, state: null, shouldActivate: shouldActivate };
                }
            });
            // applied the new router state
            // this operation has side effects
            var /** @type {?} */ navigationIsSuccessful;
            var /** @type {?} */ storedState = _this.currentRouterState;
            var /** @type {?} */ storedUrl = _this.currentUrlTree;
            routerState$
                .forEach(function (_a) {
                var appliedUrl = _a.appliedUrl, state = _a.state, shouldActivate = _a.shouldActivate;
                if (!shouldActivate || id !== _this.navigationId) {
                    navigationIsSuccessful = false;
                    return;
                }
                _this.currentUrlTree = appliedUrl;
                _this.rawUrlTree = _this.urlHandlingStrategy.merge(_this.currentUrlTree, rawUrl);
                _this.currentRouterState = state;
                if (!shouldPreventPushState) {
                    var /** @type {?} */ path = _this.urlSerializer.serialize(_this.rawUrlTree);
                    if (_this.location.isCurrentPathEqualTo(path) || shouldReplaceUrl) {
                        _this.location.replaceState(path);
                    }
                    else {
                        _this.location.go(path);
                    }
                }
                new ActivateRoutes(_this.routeReuseStrategy, state, storedState)
                    .activate(_this.outletMap);
                navigationIsSuccessful = true;
            })
                .then(function () {
                if (navigationIsSuccessful) {
                    _this.navigated = true;
                    _this.routerEvents.next(new NavigationEnd(id, _this.serializeUrl(url), _this.serializeUrl(_this.currentUrlTree)));
                    resolvePromise(true);
                }
                else {
                    _this.resetUrlToCurrentUrlTree();
                    _this.routerEvents.next(new NavigationCancel(id, _this.serializeUrl(url), ''));
                    resolvePromise(false);
                }
            }, function (e) {
                if (e instanceof __WEBPACK_IMPORTED_MODULE_19__shared__["b" /* NavigationCancelingError */]) {
                    _this.resetUrlToCurrentUrlTree();
                    _this.navigated = true;
                    _this.routerEvents.next(new NavigationCancel(id, _this.serializeUrl(url), e.message));
                    resolvePromise(false);
                }
                else {
                    _this.routerEvents.next(new NavigationError(id, _this.serializeUrl(url), e));
                    try {
                        resolvePromise(_this.errorHandler(e));
                    }
                    catch (ee) {
                        rejectPromise(ee);
                    }
                }
                _this.currentRouterState = storedState;
                _this.currentUrlTree = storedUrl;
                _this.rawUrlTree = _this.urlHandlingStrategy.merge(_this.currentUrlTree, rawUrl);
                _this.location.replaceState(_this.serializeUrl(_this.rawUrlTree));
            });
        });
    };
    /**
     * @return {?}
     */
    Router.prototype.resetUrlToCurrentUrlTree = function () {
        var /** @type {?} */ path = this.urlSerializer.serialize(this.rawUrlTree);
        this.location.replaceState(path);
    };
    return Router;
}());
function Router_tsickle_Closure_declarations() {
    /** @type {?} */
    Router.prototype.currentUrlTree;
    /** @type {?} */
    Router.prototype.rawUrlTree;
    /** @type {?} */
    Router.prototype.navigations;
    /** @type {?} */
    Router.prototype.routerEvents;
    /** @type {?} */
    Router.prototype.currentRouterState;
    /** @type {?} */
    Router.prototype.locationSubscription;
    /** @type {?} */
    Router.prototype.navigationId;
    /** @type {?} */
    Router.prototype.configLoader;
    /**
     * Error handler that is invoked when a navigation errors.
     *
     * See {\@link ErrorHandler} for more information.
     * @type {?}
     */
    Router.prototype.errorHandler;
    /**
     * Indicates if at least one navigation happened.
     * @type {?}
     */
    Router.prototype.navigated;
    /**
     * Extracts and merges URLs. Used for Angular 1 to Angular 2 migrations.
     * Used by RouterModule. This allows us to
     * pause the navigation either before preactivation or after it.
     * \@internal
     * @type {?}
     */
    Router.prototype.hooks;
    /**
     * Extracts and merges URLs. Used for AngularJS to Angular migrations.
     * @type {?}
     */
    Router.prototype.urlHandlingStrategy;
    /** @type {?} */
    Router.prototype.routeReuseStrategy;
    /** @type {?} */
    Router.prototype.rootComponentType;
    /** @type {?} */
    Router.prototype.urlSerializer;
    /** @type {?} */
    Router.prototype.outletMap;
    /** @type {?} */
    Router.prototype.location;
    /** @type {?} */
    Router.prototype.injector;
    /** @type {?} */
    Router.prototype.config;
}
var CanActivate = (function () {
    /**
     * @param {?} path
     */
    function CanActivate(path) {
        this.path = path;
    }
    Object.defineProperty(CanActivate.prototype, "route", {
        /**
         * @return {?}
         */
        get: function () { return this.path[this.path.length - 1]; },
        enumerable: true,
        configurable: true
    });
    return CanActivate;
}());
function CanActivate_tsickle_Closure_declarations() {
    /** @type {?} */
    CanActivate.prototype.path;
}
var CanDeactivate = (function () {
    /**
     * @param {?} component
     * @param {?} route
     */
    function CanDeactivate(component, route) {
        this.component = component;
        this.route = route;
    }
    return CanDeactivate;
}());
function CanDeactivate_tsickle_Closure_declarations() {
    /** @type {?} */
    CanDeactivate.prototype.component;
    /** @type {?} */
    CanDeactivate.prototype.route;
}
var PreActivation = (function () {
    /**
     * @param {?} future
     * @param {?} curr
     * @param {?} injector
     */
    function PreActivation(future, curr, injector) {
        this.future = future;
        this.curr = curr;
        this.injector = injector;
        this.checks = [];
    }
    /**
     * @param {?} parentOutletMap
     * @return {?}
     */
    PreActivation.prototype.traverse = function (parentOutletMap) {
        var /** @type {?} */ futureRoot = this.future._root;
        var /** @type {?} */ currRoot = this.curr ? this.curr._root : null;
        this.traverseChildRoutes(futureRoot, currRoot, parentOutletMap, [futureRoot.value]);
    };
    /**
     * @return {?}
     */
    PreActivation.prototype.checkGuards = function () {
        var _this = this;
        if (this.checks.length === 0)
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_of__["of"])(true);
        var /** @type {?} */ checks$ = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_from__["from"])(this.checks);
        var /** @type {?} */ runningChecks$ = __WEBPACK_IMPORTED_MODULE_9_rxjs_operator_mergeMap__["mergeMap"].call(checks$, function (s) {
            if (s instanceof CanActivate) {
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_collection__["f" /* andObservables */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_from__["from"])([_this.runCanActivateChild(s.path), _this.runCanActivate(s.route)]));
            }
            else if (s instanceof CanDeactivate) {
                // workaround https://github.com/Microsoft/TypeScript/issues/7271
                var /** @type {?} */ s2 = (s);
                return _this.runCanDeactivate(s2.component, s2.route);
            }
            else {
                throw new Error('Cannot be reached');
            }
        });
        return __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_every__["every"].call(runningChecks$, function (result) { return result === true; });
    };
    /**
     * @return {?}
     */
    PreActivation.prototype.resolveData = function () {
        var _this = this;
        if (this.checks.length === 0)
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_of__["of"])(null);
        var /** @type {?} */ checks$ = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_from__["from"])(this.checks);
        var /** @type {?} */ runningChecks$ = __WEBPACK_IMPORTED_MODULE_5_rxjs_operator_concatMap__["concatMap"].call(checks$, function (s) {
            if (s instanceof CanActivate) {
                return _this.runResolve(s.route);
            }
            else {
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_of__["of"])(null);
            }
        });
        return __WEBPACK_IMPORTED_MODULE_10_rxjs_operator_reduce__["reduce"].call(runningChecks$, function (_, __) { return _; });
    };
    /**
     * @param {?} futureNode
     * @param {?} currNode
     * @param {?} outletMap
     * @param {?} futurePath
     * @return {?}
     */
    PreActivation.prototype.traverseChildRoutes = function (futureNode, currNode, outletMap, futurePath) {
        var _this = this;
        var /** @type {?} */ prevChildren = nodeChildrenAsMap(currNode);
        futureNode.children.forEach(function (c) {
            _this.traverseRoutes(c, prevChildren[c.value.outlet], outletMap, futurePath.concat([c.value]));
            delete prevChildren[c.value.outlet];
        });
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_collection__["d" /* forEach */])(prevChildren, function (v, k) { return _this.deactiveRouteAndItsChildren(v, outletMap._outlets[k]); });
    };
    /**
     * @param {?} futureNode
     * @param {?} currNode
     * @param {?} parentOutletMap
     * @param {?} futurePath
     * @return {?}
     */
    PreActivation.prototype.traverseRoutes = function (futureNode, currNode, parentOutletMap, futurePath) {
        var /** @type {?} */ future = futureNode.value;
        var /** @type {?} */ curr = currNode ? currNode.value : null;
        var /** @type {?} */ outlet = parentOutletMap ? parentOutletMap._outlets[futureNode.value.outlet] : null;
        // reusing the node
        if (curr && future._routeConfig === curr._routeConfig) {
            if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__router_state__["g" /* equalParamsAndUrlSegments */])(future, curr)) {
                this.checks.push(new CanDeactivate(outlet.component, curr), new CanActivate(futurePath));
            }
            else {
                // we need to set the data
                future.data = curr.data;
                future._resolvedData = curr._resolvedData;
            }
            // If we have a component, we need to go through an outlet.
            if (future.component) {
                this.traverseChildRoutes(futureNode, currNode, outlet ? outlet.outletMap : null, futurePath);
            }
            else {
                this.traverseChildRoutes(futureNode, currNode, parentOutletMap, futurePath);
            }
        }
        else {
            if (curr) {
                this.deactiveRouteAndItsChildren(currNode, outlet);
            }
            this.checks.push(new CanActivate(futurePath));
            // If we have a component, we need to go through an outlet.
            if (future.component) {
                this.traverseChildRoutes(futureNode, null, outlet ? outlet.outletMap : null, futurePath);
            }
            else {
                this.traverseChildRoutes(futureNode, null, parentOutletMap, futurePath);
            }
        }
    };
    /**
     * @param {?} route
     * @param {?} outlet
     * @return {?}
     */
    PreActivation.prototype.deactiveRouteAndItsChildren = function (route, outlet) {
        var _this = this;
        var /** @type {?} */ prevChildren = nodeChildrenAsMap(route);
        var /** @type {?} */ r = route.value;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_collection__["d" /* forEach */])(prevChildren, function (v, k) {
            if (!r.component) {
                _this.deactiveRouteAndItsChildren(v, outlet);
            }
            else if (!!outlet) {
                _this.deactiveRouteAndItsChildren(v, outlet.outletMap._outlets[k]);
            }
            else {
                _this.deactiveRouteAndItsChildren(v, null);
            }
        });
        if (!r.component) {
            this.checks.push(new CanDeactivate(null, r));
        }
        else if (outlet && outlet.isActivated) {
            this.checks.push(new CanDeactivate(outlet.component, r));
        }
        else {
            this.checks.push(new CanDeactivate(null, r));
        }
    };
    /**
     * @param {?} future
     * @return {?}
     */
    PreActivation.prototype.runCanActivate = function (future) {
        var _this = this;
        var /** @type {?} */ canActivate = future._routeConfig ? future._routeConfig.canActivate : null;
        if (!canActivate || canActivate.length === 0)
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_of__["of"])(true);
        var /** @type {?} */ obs = __WEBPACK_IMPORTED_MODULE_8_rxjs_operator_map__["map"].call(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_from__["from"])(canActivate), function (c) {
            var /** @type {?} */ guard = _this.getToken(c, future);
            var /** @type {?} */ observable;
            if (guard.canActivate) {
                observable = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_collection__["b" /* wrapIntoObservable */])(guard.canActivate(future, _this.future));
            }
            else {
                observable = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_collection__["b" /* wrapIntoObservable */])(guard(future, _this.future));
            }
            return __WEBPACK_IMPORTED_MODULE_7_rxjs_operator_first__["first"].call(observable);
        });
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_collection__["f" /* andObservables */])(obs);
    };
    /**
     * @param {?} path
     * @return {?}
     */
    PreActivation.prototype.runCanActivateChild = function (path) {
        var _this = this;
        var /** @type {?} */ future = path[path.length - 1];
        var /** @type {?} */ canActivateChildGuards = path.slice(0, path.length - 1)
            .reverse()
            .map(function (p) { return _this.extractCanActivateChild(p); })
            .filter(function (_) { return _ !== null; });
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_collection__["f" /* andObservables */])(__WEBPACK_IMPORTED_MODULE_8_rxjs_operator_map__["map"].call(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_from__["from"])(canActivateChildGuards), function (d) {
            var /** @type {?} */ obs = __WEBPACK_IMPORTED_MODULE_8_rxjs_operator_map__["map"].call(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_from__["from"])(d.guards), function (c) {
                var /** @type {?} */ guard = _this.getToken(c, d.node);
                var /** @type {?} */ observable;
                if (guard.canActivateChild) {
                    observable = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_collection__["b" /* wrapIntoObservable */])(guard.canActivateChild(future, _this.future));
                }
                else {
                    observable = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_collection__["b" /* wrapIntoObservable */])(guard(future, _this.future));
                }
                return __WEBPACK_IMPORTED_MODULE_7_rxjs_operator_first__["first"].call(observable);
            });
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_collection__["f" /* andObservables */])(obs);
        }));
    };
    /**
     * @param {?} p
     * @return {?}
     */
    PreActivation.prototype.extractCanActivateChild = function (p) {
        var /** @type {?} */ canActivateChild = p._routeConfig ? p._routeConfig.canActivateChild : null;
        if (!canActivateChild || canActivateChild.length === 0)
            return null;
        return { node: p, guards: canActivateChild };
    };
    /**
     * @param {?} component
     * @param {?} curr
     * @return {?}
     */
    PreActivation.prototype.runCanDeactivate = function (component, curr) {
        var _this = this;
        var /** @type {?} */ canDeactivate = curr && curr._routeConfig ? curr._routeConfig.canDeactivate : null;
        if (!canDeactivate || canDeactivate.length === 0)
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_of__["of"])(true);
        var /** @type {?} */ canDeactivate$ = __WEBPACK_IMPORTED_MODULE_9_rxjs_operator_mergeMap__["mergeMap"].call(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_from__["from"])(canDeactivate), function (c) {
            var /** @type {?} */ guard = _this.getToken(c, curr);
            var /** @type {?} */ observable;
            if (guard.canDeactivate) {
                observable = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_collection__["b" /* wrapIntoObservable */])(guard.canDeactivate(component, curr, _this.curr));
            }
            else {
                observable = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_collection__["b" /* wrapIntoObservable */])(guard(component, curr, _this.curr));
            }
            return __WEBPACK_IMPORTED_MODULE_7_rxjs_operator_first__["first"].call(observable);
        });
        return __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_every__["every"].call(canDeactivate$, function (result) { return result === true; });
    };
    /**
     * @param {?} future
     * @return {?}
     */
    PreActivation.prototype.runResolve = function (future) {
        var /** @type {?} */ resolve = future._resolve;
        return __WEBPACK_IMPORTED_MODULE_8_rxjs_operator_map__["map"].call(this.resolveNode(resolve, future), function (resolvedData) {
            future._resolvedData = resolvedData;
            future.data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_collection__["g" /* merge */])(future.data, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__router_state__["e" /* inheritedParamsDataResolve */])(future).resolve);
            return null;
        });
    };
    /**
     * @param {?} resolve
     * @param {?} future
     * @return {?}
     */
    PreActivation.prototype.resolveNode = function (resolve, future) {
        var _this = this;
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_collection__["e" /* waitForMap */])(resolve, function (k, v) {
            var /** @type {?} */ resolver = _this.getToken(v, future);
            return resolver.resolve ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_collection__["b" /* wrapIntoObservable */])(resolver.resolve(future, _this.future)) :
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_collection__["b" /* wrapIntoObservable */])(resolver(future, _this.future));
        });
    };
    /**
     * @param {?} token
     * @param {?} snapshot
     * @return {?}
     */
    PreActivation.prototype.getToken = function (token, snapshot) {
        var /** @type {?} */ config = closestLoadedConfig(snapshot);
        var /** @type {?} */ injector = config ? config.injector : this.injector;
        return injector.get(token);
    };
    return PreActivation;
}());
function PreActivation_tsickle_Closure_declarations() {
    /** @type {?} */
    PreActivation.prototype.checks;
    /** @type {?} */
    PreActivation.prototype.future;
    /** @type {?} */
    PreActivation.prototype.curr;
    /** @type {?} */
    PreActivation.prototype.injector;
}
var ActivateRoutes = (function () {
    /**
     * @param {?} routeReuseStrategy
     * @param {?} futureState
     * @param {?} currState
     */
    function ActivateRoutes(routeReuseStrategy, futureState, currState) {
        this.routeReuseStrategy = routeReuseStrategy;
        this.futureState = futureState;
        this.currState = currState;
    }
    /**
     * @param {?} parentOutletMap
     * @return {?}
     */
    ActivateRoutes.prototype.activate = function (parentOutletMap) {
        var /** @type {?} */ futureRoot = this.futureState._root;
        var /** @type {?} */ currRoot = this.currState ? this.currState._root : null;
        this.deactivateChildRoutes(futureRoot, currRoot, parentOutletMap);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__router_state__["h" /* advanceActivatedRoute */])(this.futureState.root);
        this.activateChildRoutes(futureRoot, currRoot, parentOutletMap);
    };
    /**
     * @param {?} futureNode
     * @param {?} currNode
     * @param {?} outletMap
     * @return {?}
     */
    ActivateRoutes.prototype.deactivateChildRoutes = function (futureNode, currNode, outletMap) {
        var _this = this;
        var /** @type {?} */ prevChildren = nodeChildrenAsMap(currNode);
        futureNode.children.forEach(function (c) {
            _this.deactivateRoutes(c, prevChildren[c.value.outlet], outletMap);
            delete prevChildren[c.value.outlet];
        });
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_collection__["d" /* forEach */])(prevChildren, function (v, k) { return _this.deactiveRouteAndItsChildren(v, outletMap); });
    };
    /**
     * @param {?} futureNode
     * @param {?} currNode
     * @param {?} outletMap
     * @return {?}
     */
    ActivateRoutes.prototype.activateChildRoutes = function (futureNode, currNode, outletMap) {
        var _this = this;
        var /** @type {?} */ prevChildren = nodeChildrenAsMap(currNode);
        futureNode.children.forEach(function (c) { _this.activateRoutes(c, prevChildren[c.value.outlet], outletMap); });
    };
    /**
     * @param {?} futureNode
     * @param {?} currNode
     * @param {?} parentOutletMap
     * @return {?}
     */
    ActivateRoutes.prototype.deactivateRoutes = function (futureNode, currNode, parentOutletMap) {
        var /** @type {?} */ future = futureNode.value;
        var /** @type {?} */ curr = currNode ? currNode.value : null;
        // reusing the node
        if (future === curr) {
            // If we have a normal route, we need to go through an outlet.
            if (future.component) {
                var /** @type {?} */ outlet = getOutlet(parentOutletMap, future);
                this.deactivateChildRoutes(futureNode, currNode, outlet.outletMap);
            }
            else {
                this.deactivateChildRoutes(futureNode, currNode, parentOutletMap);
            }
        }
        else {
            if (curr) {
                this.deactiveRouteAndItsChildren(currNode, parentOutletMap);
            }
        }
    };
    /**
     * @param {?} futureNode
     * @param {?} currNode
     * @param {?} parentOutletMap
     * @return {?}
     */
    ActivateRoutes.prototype.activateRoutes = function (futureNode, currNode, parentOutletMap) {
        var /** @type {?} */ future = futureNode.value;
        var /** @type {?} */ curr = currNode ? currNode.value : null;
        // reusing the node
        if (future === curr) {
            // advance the route to push the parameters
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__router_state__["h" /* advanceActivatedRoute */])(future);
            // If we have a normal route, we need to go through an outlet.
            if (future.component) {
                var /** @type {?} */ outlet = getOutlet(parentOutletMap, future);
                this.activateChildRoutes(futureNode, currNode, outlet.outletMap);
            }
            else {
                this.activateChildRoutes(futureNode, currNode, parentOutletMap);
            }
        }
        else {
            // if we have a normal route, we need to advance the route
            // and place the component into the outlet. After that recurse.
            if (future.component) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__router_state__["h" /* advanceActivatedRoute */])(future);
                var /** @type {?} */ outlet = getOutlet(parentOutletMap, futureNode.value);
                if (this.routeReuseStrategy.shouldAttach(future.snapshot)) {
                    var /** @type {?} */ stored = ((this.routeReuseStrategy.retrieve(future.snapshot)));
                    this.routeReuseStrategy.store(future.snapshot, null);
                    outlet.attach(stored.componentRef, stored.route.value);
                    advanceActivatedRouteNodeAndItsChildren(stored.route);
                }
                else {
                    var /** @type {?} */ outletMap = new __WEBPACK_IMPORTED_MODULE_17__router_outlet_map__["a" /* RouterOutletMap */]();
                    this.placeComponentIntoOutlet(outletMap, future, outlet);
                    this.activateChildRoutes(futureNode, null, outletMap);
                }
            }
            else {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__router_state__["h" /* advanceActivatedRoute */])(future);
                this.activateChildRoutes(futureNode, null, parentOutletMap);
            }
        }
    };
    /**
     * @param {?} outletMap
     * @param {?} future
     * @param {?} outlet
     * @return {?}
     */
    ActivateRoutes.prototype.placeComponentIntoOutlet = function (outletMap, future, outlet) {
        var /** @type {?} */ resolved = ([{ provide: __WEBPACK_IMPORTED_MODULE_18__router_state__["b" /* ActivatedRoute */], useValue: future }, {
                provide: __WEBPACK_IMPORTED_MODULE_17__router_outlet_map__["a" /* RouterOutletMap */],
                useValue: outletMap
            }]);
        var /** @type {?} */ config = parentLoadedConfig(future.snapshot);
        var /** @type {?} */ resolver = null;
        var /** @type {?} */ injector = null;
        if (config) {
            injector = config.injectorFactory(outlet.locationInjector);
            resolver = config.factoryResolver;
            resolved.push({ provide: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ComponentFactoryResolver"], useValue: resolver });
        }
        else {
            injector = outlet.locationInjector;
            resolver = outlet.locationFactoryResolver;
        }
        outlet.activate(future, resolver, injector, __WEBPACK_IMPORTED_MODULE_0__angular_core__["ReflectiveInjector"].resolve(resolved), outletMap);
    };
    /**
     * @param {?} route
     * @param {?} parentOutletMap
     * @return {?}
     */
    ActivateRoutes.prototype.deactiveRouteAndItsChildren = function (route, parentOutletMap) {
        if (this.routeReuseStrategy.shouldDetach(route.value.snapshot)) {
            this.detachAndStoreRouteSubtree(route, parentOutletMap);
        }
        else {
            this.deactiveRouteAndOutlet(route, parentOutletMap);
        }
    };
    /**
     * @param {?} route
     * @param {?} parentOutletMap
     * @return {?}
     */
    ActivateRoutes.prototype.detachAndStoreRouteSubtree = function (route, parentOutletMap) {
        var /** @type {?} */ outlet = getOutlet(parentOutletMap, route.value);
        var /** @type {?} */ componentRef = outlet.detach();
        this.routeReuseStrategy.store(route.value.snapshot, { componentRef: componentRef, route: route });
    };
    /**
     * @param {?} route
     * @param {?} parentOutletMap
     * @return {?}
     */
    ActivateRoutes.prototype.deactiveRouteAndOutlet = function (route, parentOutletMap) {
        var _this = this;
        var /** @type {?} */ prevChildren = nodeChildrenAsMap(route);
        var /** @type {?} */ outlet = null;
        // getOutlet throws when cannot find the right outlet,
        // which can happen if an outlet was in an NgIf and was removed
        try {
            outlet = getOutlet(parentOutletMap, route.value);
        }
        catch (e) {
            return;
        }
        var /** @type {?} */ childOutletMap = outlet.outletMap;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_collection__["d" /* forEach */])(prevChildren, function (v, k) {
            if (route.value.component) {
                _this.deactiveRouteAndItsChildren(v, childOutletMap);
            }
            else {
                _this.deactiveRouteAndItsChildren(v, parentOutletMap);
            }
        });
        if (outlet && outlet.isActivated) {
            outlet.deactivate();
        }
    };
    return ActivateRoutes;
}());
function ActivateRoutes_tsickle_Closure_declarations() {
    /** @type {?} */
    ActivateRoutes.prototype.routeReuseStrategy;
    /** @type {?} */
    ActivateRoutes.prototype.futureState;
    /** @type {?} */
    ActivateRoutes.prototype.currState;
}
/**
 * @param {?} node
 * @return {?}
 */
function advanceActivatedRouteNodeAndItsChildren(node) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__router_state__["h" /* advanceActivatedRoute */])(node.value);
    node.children.forEach(advanceActivatedRouteNodeAndItsChildren);
}
/**
 * @param {?} snapshot
 * @return {?}
 */
function parentLoadedConfig(snapshot) {
    var /** @type {?} */ s = snapshot.parent;
    while (s) {
        var /** @type {?} */ c = s._routeConfig;
        if (c && c._loadedConfig)
            return c._loadedConfig;
        if (c && c.component)
            return null;
        s = s.parent;
    }
    return null;
}
/**
 * @param {?} snapshot
 * @return {?}
 */
function closestLoadedConfig(snapshot) {
    if (!snapshot)
        return null;
    var /** @type {?} */ s = snapshot.parent;
    while (s) {
        var /** @type {?} */ c = s._routeConfig;
        if (c && c._loadedConfig)
            return c._loadedConfig;
        s = s.parent;
    }
    return null;
}
/**
 * @param {?} node
 * @return {?}
 */
function nodeChildrenAsMap(node) {
    return node ? node.children.reduce(function (m, c) {
        m[c.value.outlet] = c;
        return m;
    }, {}) : {};
}
/**
 * @param {?} outletMap
 * @param {?} route
 * @return {?}
 */
function getOutlet(outletMap, route) {
    var /** @type {?} */ outlet = outletMap._outlets[route.outlet];
    if (!outlet) {
        var /** @type {?} */ componentName = ((route.component)).name;
        if (route.outlet === __WEBPACK_IMPORTED_MODULE_19__shared__["a" /* PRIMARY_OUTLET */]) {
            throw new Error("Cannot find primary outlet to load '" + componentName + "'");
        }
        else {
            throw new Error("Cannot find the outlet " + route.outlet + " to load '" + componentName + "'");
        }
    }
    return outlet;
}
/**
 * @param {?} commands
 * @return {?}
 */
function validateCommands(commands) {
    for (var /** @type {?} */ i = 0; i < commands.length; i++) {
        var /** @type {?} */ cmd = commands[i];
        if (cmd == null) {
            throw new Error("The requested path contains " + cmd + " segment at index " + i);
        }
    }
}
//# sourceMappingURL=router.js.map

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_observable_fromPromise__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_observable_fromPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_observable_fromPromise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_observable_of__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_observable_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_map__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_mergeMap__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_mergeMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_operator_mergeMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_collection__ = __webpack_require__(61);
/* harmony export (binding) */ __webpack_require__.d(exports, "c", function() { return ROUTES; });
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return LoadedRouterConfig; });
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return RouterConfigLoader; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */






/**
 * @experimental
 */
var /** @type {?} */ ROUTES = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["OpaqueToken"]('ROUTES');
var LoadedRouterConfig = (function () {
    /**
     * @param {?} routes
     * @param {?} injector
     * @param {?} factoryResolver
     * @param {?} injectorFactory
     */
    function LoadedRouterConfig(routes, injector, factoryResolver, injectorFactory) {
        this.routes = routes;
        this.injector = injector;
        this.factoryResolver = factoryResolver;
        this.injectorFactory = injectorFactory;
    }
    return LoadedRouterConfig;
}());
function LoadedRouterConfig_tsickle_Closure_declarations() {
    /** @type {?} */
    LoadedRouterConfig.prototype.routes;
    /** @type {?} */
    LoadedRouterConfig.prototype.injector;
    /** @type {?} */
    LoadedRouterConfig.prototype.factoryResolver;
    /** @type {?} */
    LoadedRouterConfig.prototype.injectorFactory;
}
var RouterConfigLoader = (function () {
    /**
     * @param {?} loader
     * @param {?} compiler
     */
    function RouterConfigLoader(loader, compiler) {
        this.loader = loader;
        this.compiler = compiler;
    }
    /**
     * @param {?} parentInjector
     * @param {?} loadChildren
     * @return {?}
     */
    RouterConfigLoader.prototype.load = function (parentInjector, loadChildren) {
        return __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_map__["map"].call(this.loadModuleFactory(loadChildren), function (r) {
            var /** @type {?} */ ref = r.create(parentInjector);
            var /** @type {?} */ injectorFactory = function (parent) { return r.create(parent).injector; };
            return new LoadedRouterConfig(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_collection__["a" /* flatten */])(ref.injector.get(ROUTES)), ref.injector, ref.componentFactoryResolver, injectorFactory);
        });
    };
    /**
     * @param {?} loadChildren
     * @return {?}
     */
    RouterConfigLoader.prototype.loadModuleFactory = function (loadChildren) {
        var _this = this;
        if (typeof loadChildren === 'string') {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_rxjs_observable_fromPromise__["fromPromise"])(this.loader.load(loadChildren));
        }
        else {
            return __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_mergeMap__["mergeMap"].call(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_collection__["b" /* wrapIntoObservable */])(loadChildren()), function (t) {
                if (t instanceof __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModuleFactory"]) {
                    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_of__["of"])(t);
                }
                else {
                    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_rxjs_observable_fromPromise__["fromPromise"])(_this.compiler.compileModuleAsync(t));
                }
            });
        }
    };
    return RouterConfigLoader;
}());
function RouterConfigLoader_tsickle_Closure_declarations() {
    /** @type {?} */
    RouterConfigLoader.prototype.loader;
    /** @type {?} */
    RouterConfigLoader.prototype.compiler;
}
//# sourceMappingURL=router_config_loader.js.map

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var debug, debugOff = function () {
    var any = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        any[_i] = arguments[_i];
    }
};
"production" !== 'production' && (debug = __webpack_require__(4)('app:AnimateService'));
var AnimateService = (function () {
    function AnimateService() {
    }
    AnimateService.prototype.start = function (start, end, time, easing, callback, timeouts, name) {
        debugOff('Start animate');
        debugOff('Start:', start);
        debugOff('End:', end);
        debugOff('Easing:', easing);
        var count = 0, change = end - start, fps = 60, max = fps / (1000 / time), curr = start;
        typeof time === 'undefined' && (time = 1000);
        typeof easing === 'undefined' && (easing = 'easingInOutQuad');
        typeof callback === 'undefined' && (callback = function () { });
        typeof timeouts === 'undefined' && (timeouts = {});
        typeof timeouts === 'undefined' && (name = 'animate');
        if (time === 0) {
            callback(end, count, max);
            return;
        }
        cancelAnimationFrame(timeouts[name]);
        runAnimate(start, easing, callback, timeouts, name, count, change, max, curr);
        function runAnimate(start, easing, callback, timeouts, name, count, change, max, curr) {
            if ((curr - start) != change) {
                timeouts[name] = requestAnimationFrame(function () {
                    runAnimate(start, easing, callback, timeouts, name, count, change, max, curr);
                });
                if (easing == 'linearEase') {
                    curr = change * count / max + start;
                }
                else if (easing == 'easeInQuad') {
                    curr = change * (count / max) * (count / max) + start;
                }
                else if (easing == 'easeOutQuad') {
                    curr = (-change * (count / max) * (count / max - 2) + start);
                }
                else if (easing == 'easeInCubic') {
                    curr = change * Math.pow(count / max, 3) + start;
                }
                else if (easing == 'easeOutCubic') {
                    curr = change * (Math.pow(count / max - 1, 3) + 1) + start;
                }
                else if (easing == 'easeInOutQuad') {
                    if ((count / (max / 2)) < 1) {
                        curr = change / 2 * (count / (max / 2)) * (count / (max / 2)) + start;
                    }
                    else {
                        curr = -change / 2 * (((count / (max / 2)) - 1) * ((count / (max / 2)) - 3) - 1) + start;
                    }
                }
                else if (easing == 'easeInOutCubic') {
                    if ((count / (max / 2)) < 1) {
                        curr = change / 2 * Math.pow((count / (max / 2)), 3) + start;
                    }
                    else {
                        curr = change / 2 * (Math.pow((count / (max / 2)) - 2, 3) + 2) + start;
                    }
                }
                callback(curr, count, max);
                count++;
            }
        }
    };
    return AnimateService;
}());
AnimateService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [])
], AnimateService);
exports.AnimateService = AnimateService;


/***/ },
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var modal_instance_1 = __webpack_require__(470);
var ModalComponent = (function () {
    function ModalComponent(element) {
        var _this = this;
        this.element = element;
        this.overrideSize = null;
        this.visible = false;
        this.animation = true;
        this.backdrop = true;
        this.keyboard = true;
        this.cssClass = '';
        this.onClose = new core_1.EventEmitter(false);
        this.onDismiss = new core_1.EventEmitter(false);
        this.onOpen = new core_1.EventEmitter(false);
        this.instance = new modal_instance_1.ModalInstance(this.element);
        this.instance.hidden.subscribe(function (result) {
            _this.visible = _this.instance.visible;
            if (result === modal_instance_1.ModalResult.Dismiss) {
                _this.onDismiss.emit(undefined);
            }
        });
        this.instance.shown.subscribe(function () {
            _this.onOpen.emit(undefined);
        });
    }
    Object.defineProperty(ModalComponent.prototype, "fadeClass", {
        get: function () {
            return this.animation;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ModalComponent.prototype, "dataKeyboardAttr", {
        get: function () {
            return this.keyboard;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ModalComponent.prototype, "dataBackdropAttr", {
        get: function () {
            return this.backdrop;
        },
        enumerable: true,
        configurable: true
    });
    ModalComponent.prototype.ngOnDestroy = function () {
        return this.instance && this.instance.destroy();
    };
    ModalComponent.prototype.routerCanDeactivate = function () {
        return this.ngOnDestroy();
    };
    ModalComponent.prototype.open = function (size) {
        var _this = this;
        if (ModalSize.validSize(size))
            this.overrideSize = size;
        return this.instance.open().then(function () {
            _this.visible = _this.instance.visible;
        });
    };
    ModalComponent.prototype.close = function (value) {
        var _this = this;
        return this.instance.close().then(function () {
            _this.onClose.emit(value);
        });
    };
    ModalComponent.prototype.dismiss = function () {
        return this.instance.dismiss();
    };
    ModalComponent.prototype.getCssClasses = function () {
        var classes = [];
        if (this.isSmall()) {
            classes.push('modal-sm');
        }
        if (this.isLarge()) {
            classes.push('modal-lg');
        }
        if (this.cssClass !== '') {
            classes.push(this.cssClass);
        }
        return classes.join(' ');
    };
    ModalComponent.prototype.isSmall = function () {
        return this.overrideSize !== ModalSize.Large
            && this.size === ModalSize.Small
            || this.overrideSize === ModalSize.Small;
    };
    ModalComponent.prototype.isLarge = function () {
        return this.overrideSize !== ModalSize.Small
            && this.size === ModalSize.Large
            || this.overrideSize === ModalSize.Large;
    };
    ModalComponent.decorators = [
        { type: core_1.Component, args: [{
                    selector: 'modal',
                    host: {
                        'class': 'modal',
                        'role': 'dialog',
                        'tabindex': '-1'
                    },
                    template: "\n        <div class=\"modal-dialog\" [ngClass]=\"getCssClasses()\">\n            <div class=\"modal-content\">\n                <ng-content></ng-content>\n            </div>\n        </div>\n    "
                },] },
    ];
    /** @nocollapse */
    ModalComponent.ctorParameters = [
        { type: core_1.ElementRef, },
    ];
    ModalComponent.propDecorators = {
        'animation': [{ type: core_1.Input },],
        'backdrop': [{ type: core_1.Input },],
        'keyboard': [{ type: core_1.Input },],
        'size': [{ type: core_1.Input },],
        'cssClass': [{ type: core_1.Input },],
        'onClose': [{ type: core_1.Output },],
        'onDismiss': [{ type: core_1.Output },],
        'onOpen': [{ type: core_1.Output },],
        'fadeClass': [{ type: core_1.HostBinding, args: ['class.fade',] },],
        'dataKeyboardAttr': [{ type: core_1.HostBinding, args: ['attr.data-keyboard',] },],
        'dataBackdropAttr': [{ type: core_1.HostBinding, args: ['attr.data-backdrop',] },],
    };
    return ModalComponent;
}());
exports.ModalComponent = ModalComponent;
var ModalSize = (function () {
    function ModalSize() {
    }
    ModalSize.validSize = function (size) {
        return size && (size === ModalSize.Small || size === ModalSize.Large);
    };
    ModalSize.Small = 'sm';
    ModalSize.Large = 'lg';
    return ModalSize;
}());
exports.ModalSize = ModalSize;
//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__control_value_accessor__ = __webpack_require__(42);
/* unused harmony export CHECKBOX_VALUE_ACCESSOR */
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return CheckboxControlValueAccessor; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


var /** @type {?} */ CHECKBOX_VALUE_ACCESSOR = {
    provide: __WEBPACK_IMPORTED_MODULE_1__control_value_accessor__["a" /* NG_VALUE_ACCESSOR */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return CheckboxControlValueAccessor; }),
    multi: true,
};
/**
 * The accessor for writing a value and listening to changes on a checkbox input element.
 *
 *  ### Example
 *  ```
 *  <input type="checkbox" name="rememberLogin" ngModel>
 *  ```
 *
 *  \@stable
 */
var CheckboxControlValueAccessor = (function () {
    /**
     * @param {?} _renderer
     * @param {?} _elementRef
     */
    function CheckboxControlValueAccessor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this.onChange = function (_) { };
        this.onTouched = function () { };
    }
    /**
     * @param {?} value
     * @return {?}
     */
    CheckboxControlValueAccessor.prototype.writeValue = function (value) {
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'checked', value);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    CheckboxControlValueAccessor.prototype.registerOnChange = function (fn) { this.onChange = fn; };
    /**
     * @param {?} fn
     * @return {?}
     */
    CheckboxControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    CheckboxControlValueAccessor.prototype.setDisabledState = function (isDisabled) {
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    CheckboxControlValueAccessor.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]',
                    host: { '(change)': 'onChange($event.target.checked)', '(blur)': 'onTouched()' },
                    providers: [CHECKBOX_VALUE_ACCESSOR]
                },] },
    ];
    /** @nocollapse */
    CheckboxControlValueAccessor.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    ]; };
    return CheckboxControlValueAccessor;
}());
function CheckboxControlValueAccessor_tsickle_Closure_declarations() {
    /** @type {?} */
    CheckboxControlValueAccessor.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    CheckboxControlValueAccessor.ctorParameters;
    /** @type {?} */
    CheckboxControlValueAccessor.prototype.onChange;
    /** @type {?} */
    CheckboxControlValueAccessor.prototype.onTouched;
    /** @type {?} */
    CheckboxControlValueAccessor.prototype._renderer;
    /** @type {?} */
    CheckboxControlValueAccessor.prototype._elementRef;
}
//# sourceMappingURL=checkbox_value_accessor.js.map

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__control_value_accessor__ = __webpack_require__(42);
/* unused harmony export DEFAULT_VALUE_ACCESSOR */
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return DefaultValueAccessor; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


var /** @type {?} */ DEFAULT_VALUE_ACCESSOR = {
    provide: __WEBPACK_IMPORTED_MODULE_1__control_value_accessor__["a" /* NG_VALUE_ACCESSOR */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return DefaultValueAccessor; }),
    multi: true
};
/**
 * The default accessor for writing a value and listening to changes that is used by the
 * {\@link NgModel}, {\@link FormControlDirective}, and {\@link FormControlName} directives.
 *
 *  ### Example
 *  ```
 *  <input type="text" name="searchQuery" ngModel>
 *  ```
 *
 *  \@stable
 */
var DefaultValueAccessor = (function () {
    /**
     * @param {?} _renderer
     * @param {?} _elementRef
     */
    function DefaultValueAccessor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this.onChange = function (_) { };
        this.onTouched = function () { };
    }
    /**
     * @param {?} value
     * @return {?}
     */
    DefaultValueAccessor.prototype.writeValue = function (value) {
        var /** @type {?} */ normalizedValue = value == null ? '' : value;
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'value', normalizedValue);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    DefaultValueAccessor.prototype.registerOnChange = function (fn) { this.onChange = fn; };
    /**
     * @param {?} fn
     * @return {?}
     */
    DefaultValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    DefaultValueAccessor.prototype.setDisabledState = function (isDisabled) {
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    DefaultValueAccessor.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]',
                    // TODO: vsavkin replace the above selector with the one below it once
                    // https://github.com/angular/angular/issues/3011 is implemented
                    // selector: '[ngControl],[ngModel],[ngFormControl]',
                    host: { '(input)': 'onChange($event.target.value)', '(blur)': 'onTouched()' },
                    providers: [DEFAULT_VALUE_ACCESSOR]
                },] },
    ];
    /** @nocollapse */
    DefaultValueAccessor.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    ]; };
    return DefaultValueAccessor;
}());
function DefaultValueAccessor_tsickle_Closure_declarations() {
    /** @type {?} */
    DefaultValueAccessor.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    DefaultValueAccessor.ctorParameters;
    /** @type {?} */
    DefaultValueAccessor.prototype.onChange;
    /** @type {?} */
    DefaultValueAccessor.prototype.onTouched;
    /** @type {?} */
    DefaultValueAccessor.prototype._renderer;
    /** @type {?} */
    DefaultValueAccessor.prototype._elementRef;
}
//# sourceMappingURL=default_value_accessor.js.map

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validators__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__abstract_form_group_directive__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__control_container__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ng_form__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__template_driven_errors__ = __webpack_require__(389);
/* unused harmony export modelGroupProvider */
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return NgModelGroup; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};






var /** @type {?} */ modelGroupProvider = {
    provide: __WEBPACK_IMPORTED_MODULE_3__control_container__["a" /* ControlContainer */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return NgModelGroup; })
};
/**
 * \@whatItDoes Creates and binds a {\@link FormGroup} instance to a DOM element.
 *
 * \@howToUse
 *
 * This directive can only be used as a child of {\@link NgForm} (or in other words,
 * within `<form>` tags).
 *
 * Use this directive if you'd like to create a sub-group within a form. This can
 * come in handy if you want to validate a sub-group of your form separately from
 * the rest of your form, or if some values in your domain model make more sense to
 * consume together in a nested object.
 *
 * Pass in the name you'd like this sub-group to have and it will become the key
 * for the sub-group in the form's full value. You can also export the directive into
 * a local template variable using `ngModelGroup` (ex: `#myGroup="ngModelGroup"`).
 *
 * {\@example forms/ts/ngModelGroup/ng_model_group_example.ts region='Component'}
 *
 * * **npm package**: `\@angular/forms`
 *
 * * **NgModule**: `FormsModule`
 *
 * \@stable
 */
var NgModelGroup = (function (_super) {
    __extends(NgModelGroup, _super);
    /**
     * @param {?} parent
     * @param {?} validators
     * @param {?} asyncValidators
     */
    function NgModelGroup(parent, validators, asyncValidators) {
        _super.call(this);
        this._parent = parent;
        this._validators = validators;
        this._asyncValidators = asyncValidators;
    }
    /**
     * \@internal
     * @return {?}
     */
    NgModelGroup.prototype._checkParentType = function () {
        if (!(this._parent instanceof NgModelGroup) && !(this._parent instanceof __WEBPACK_IMPORTED_MODULE_4__ng_form__["a" /* NgForm */])) {
            __WEBPACK_IMPORTED_MODULE_5__template_driven_errors__["a" /* TemplateDrivenErrors */].modelGroupParentException();
        }
    };
    NgModelGroup.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[ngModelGroup]', providers: [modelGroupProvider], exportAs: 'ngModelGroup' },] },
    ];
    /** @nocollapse */
    NgModelGroup.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_3__control_container__["a" /* ControlContainer */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Host"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["SkipSelf"] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_1__validators__["b" /* NG_VALIDATORS */],] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_1__validators__["c" /* NG_ASYNC_VALIDATORS */],] },] },
    ]; };
    NgModelGroup.propDecorators = {
        'name': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngModelGroup',] },],
    };
    return NgModelGroup;
}(__WEBPACK_IMPORTED_MODULE_2__abstract_form_group_directive__["a" /* AbstractFormGroupDirective */]));
function NgModelGroup_tsickle_Closure_declarations() {
    /** @type {?} */
    NgModelGroup.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    NgModelGroup.ctorParameters;
    /** @type {?} */
    NgModelGroup.propDecorators;
    /** @type {?} */
    NgModelGroup.prototype.name;
}
//# sourceMappingURL=ng_model_group.js.map

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error_examples__ = __webpack_require__(388);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return ReactiveErrors; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

var ReactiveErrors = (function () {
    function ReactiveErrors() {
    }
    /**
     * @return {?}
     */
    ReactiveErrors.controlParentException = function () {
        throw new Error("formControlName must be used with a parent formGroup directive.  You'll want to add a formGroup\n       directive and pass it an existing FormGroup instance (you can create one in your class).\n\n      Example:\n\n      " + __WEBPACK_IMPORTED_MODULE_0__error_examples__["a" /* FormErrorExamples */].formControlName);
    };
    /**
     * @return {?}
     */
    ReactiveErrors.ngModelGroupException = function () {
        throw new Error("formControlName cannot be used with an ngModelGroup parent. It is only compatible with parents\n       that also have a \"form\" prefix: formGroupName, formArrayName, or formGroup.\n\n       Option 1:  Update the parent to be formGroupName (reactive form strategy)\n\n        " + __WEBPACK_IMPORTED_MODULE_0__error_examples__["a" /* FormErrorExamples */].formGroupName + "\n\n        Option 2: Use ngModel instead of formControlName (template-driven strategy)\n\n        " + __WEBPACK_IMPORTED_MODULE_0__error_examples__["a" /* FormErrorExamples */].ngModelGroup);
    };
    /**
     * @return {?}
     */
    ReactiveErrors.missingFormException = function () {
        throw new Error("formGroup expects a FormGroup instance. Please pass one in.\n\n       Example:\n\n       " + __WEBPACK_IMPORTED_MODULE_0__error_examples__["a" /* FormErrorExamples */].formControlName);
    };
    /**
     * @return {?}
     */
    ReactiveErrors.groupParentException = function () {
        throw new Error("formGroupName must be used with a parent formGroup directive.  You'll want to add a formGroup\n      directive and pass it an existing FormGroup instance (you can create one in your class).\n\n      Example:\n\n      " + __WEBPACK_IMPORTED_MODULE_0__error_examples__["a" /* FormErrorExamples */].formGroupName);
    };
    /**
     * @return {?}
     */
    ReactiveErrors.arrayParentException = function () {
        throw new Error("formArrayName must be used with a parent formGroup directive.  You'll want to add a formGroup\n       directive and pass it an existing FormGroup instance (you can create one in your class).\n\n        Example:\n\n        " + __WEBPACK_IMPORTED_MODULE_0__error_examples__["a" /* FormErrorExamples */].formArrayName);
    };
    /**
     * @return {?}
     */
    ReactiveErrors.disabledAttrWarning = function () {
        console.warn("\n      It looks like you're using the disabled attribute with a reactive form directive. If you set disabled to true\n      when you set up this control in your component class, the disabled attribute will actually be set in the DOM for\n      you. We recommend using this approach to avoid 'changed after checked' errors.\n       \n      Example: \n      form = new FormGroup({\n        first: new FormControl({value: 'Nancy', disabled: true}, Validators.required),\n        last: new FormControl('Drew', Validators.required)\n      });\n    ");
    };
    return ReactiveErrors;
}());
//# sourceMappingURL=reactive_errors.js.map

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_lang__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__control_value_accessor__ = __webpack_require__(42);
/* unused harmony export SELECT_VALUE_ACCESSOR */
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return SelectControlValueAccessor; });
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return NgSelectOption; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */



var /** @type {?} */ SELECT_VALUE_ACCESSOR = {
    provide: __WEBPACK_IMPORTED_MODULE_2__control_value_accessor__["a" /* NG_VALUE_ACCESSOR */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return SelectControlValueAccessor; }),
    multi: true
};
/**
 * @param {?} id
 * @param {?} value
 * @return {?}
 */
function _buildValueString(id, value) {
    if (id == null)
        return "" + value;
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["d" /* isPrimitive */])(value))
        value = 'Object';
    return (id + ": " + value).slice(0, 50);
}
/**
 * @param {?} valueString
 * @return {?}
 */
function _extractId(valueString) {
    return valueString.split(':')[0];
}
/**
 * \@whatItDoes Writes values and listens to changes on a select element.
 *
 * Used by {\@link NgModel}, {\@link FormControlDirective}, and {\@link FormControlName}
 * to keep the view synced with the {\@link FormControl} model.
 *
 * \@howToUse
 *
 * If you have imported the {\@link FormsModule} or the {\@link ReactiveFormsModule}, this
 * value accessor will be active on any select control that has a form directive. You do
 * **not** need to add a special selector to activate it.
 *
 * ### How to use select controls with form directives
 *
 * To use a select in a template-driven form, simply add an `ngModel` and a `name`
 * attribute to the main `<select>` tag.
 *
 * If your option values are simple strings, you can bind to the normal `value` property
 * on the option.  If your option values happen to be objects (and you'd like to save the
 * selection in your form as an object), use `ngValue` instead:
 *
 * {\@example forms/ts/selectControl/select_control_example.ts region='Component'}
 *
 * In reactive forms, you'll also want to add your form directive (`formControlName` or
 * `formControl`) on the main `<select>` tag. Like in the former example, you have the
 * choice of binding to the  `value` or `ngValue` property on the select's options.
 *
 * {\@example forms/ts/reactiveSelectControl/reactive_select_control_example.ts region='Component'}
 *
 * Note: We listen to the 'change' event because 'input' events aren't fired
 * for selects in Firefox and IE:
 * https://bugzilla.mozilla.org/show_bug.cgi?id=1024350
 * https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/4660045/
 *
 * * **npm package**: `\@angular/forms`
 *
 * \@stable
 */
var SelectControlValueAccessor = (function () {
    /**
     * @param {?} _renderer
     * @param {?} _elementRef
     */
    function SelectControlValueAccessor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        /** @internal */
        this._optionMap = new Map();
        /** @internal */
        this._idCounter = 0;
        this.onChange = function (_) { };
        this.onTouched = function () { };
    }
    /**
     * @param {?} value
     * @return {?}
     */
    SelectControlValueAccessor.prototype.writeValue = function (value) {
        this.value = value;
        var /** @type {?} */ id = this._getOptionId(value);
        if (id == null) {
            this._renderer.setElementProperty(this._elementRef.nativeElement, 'selectedIndex', -1);
        }
        var /** @type {?} */ valueString = _buildValueString(id, value);
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'value', valueString);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    SelectControlValueAccessor.prototype.registerOnChange = function (fn) {
        var _this = this;
        this.onChange = function (valueString) {
            _this.value = valueString;
            fn(_this._getOptionValue(valueString));
        };
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    SelectControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    SelectControlValueAccessor.prototype.setDisabledState = function (isDisabled) {
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    /**
     * \@internal
     * @return {?}
     */
    SelectControlValueAccessor.prototype._registerOption = function () { return (this._idCounter++).toString(); };
    /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    SelectControlValueAccessor.prototype._getOptionId = function (value) {
        for (var _i = 0, _a = Array.from(this._optionMap.keys()); _i < _a.length; _i++) {
            var id = _a[_i];
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["e" /* looseIdentical */])(this._optionMap.get(id), value))
                return id;
        }
        return null;
    };
    /**
     * \@internal
     * @param {?} valueString
     * @return {?}
     */
    SelectControlValueAccessor.prototype._getOptionValue = function (valueString) {
        var /** @type {?} */ id = _extractId(valueString);
        return this._optionMap.has(id) ? this._optionMap.get(id) : valueString;
    };
    SelectControlValueAccessor.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]',
                    host: { '(change)': 'onChange($event.target.value)', '(blur)': 'onTouched()' },
                    providers: [SELECT_VALUE_ACCESSOR]
                },] },
    ];
    /** @nocollapse */
    SelectControlValueAccessor.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    ]; };
    return SelectControlValueAccessor;
}());
function SelectControlValueAccessor_tsickle_Closure_declarations() {
    /** @type {?} */
    SelectControlValueAccessor.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    SelectControlValueAccessor.ctorParameters;
    /** @type {?} */
    SelectControlValueAccessor.prototype.value;
    /**
     * \@internal
     * @type {?}
     */
    SelectControlValueAccessor.prototype._optionMap;
    /**
     * \@internal
     * @type {?}
     */
    SelectControlValueAccessor.prototype._idCounter;
    /** @type {?} */
    SelectControlValueAccessor.prototype.onChange;
    /** @type {?} */
    SelectControlValueAccessor.prototype.onTouched;
    /** @type {?} */
    SelectControlValueAccessor.prototype._renderer;
    /** @type {?} */
    SelectControlValueAccessor.prototype._elementRef;
}
/**
 * \@whatItDoes Marks `<option>` as dynamic, so Angular can be notified when options change.
 *
 * \@howToUse
 *
 * See docs for {\@link SelectControlValueAccessor} for usage examples.
 *
 * \@stable
 */
var NgSelectOption = (function () {
    /**
     * @param {?} _element
     * @param {?} _renderer
     * @param {?} _select
     */
    function NgSelectOption(_element, _renderer, _select) {
        this._element = _element;
        this._renderer = _renderer;
        this._select = _select;
        if (this._select)
            this.id = this._select._registerOption();
    }
    Object.defineProperty(NgSelectOption.prototype, "ngValue", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (this._select == null)
                return;
            this._select._optionMap.set(this.id, value);
            this._setElementValue(_buildValueString(this.id, value));
            this._select.writeValue(this._select.value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgSelectOption.prototype, "value", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._setElementValue(value);
            if (this._select)
                this._select.writeValue(this._select.value);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    NgSelectOption.prototype._setElementValue = function (value) {
        this._renderer.setElementProperty(this._element.nativeElement, 'value', value);
    };
    /**
     * @return {?}
     */
    NgSelectOption.prototype.ngOnDestroy = function () {
        if (this._select) {
            this._select._optionMap.delete(this.id);
            this._select.writeValue(this._select.value);
        }
    };
    NgSelectOption.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: 'option' },] },
    ];
    /** @nocollapse */
    NgSelectOption.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: SelectControlValueAccessor, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Host"] },] },
    ]; };
    NgSelectOption.propDecorators = {
        'ngValue': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngValue',] },],
        'value': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['value',] },],
    };
    return NgSelectOption;
}());
function NgSelectOption_tsickle_Closure_declarations() {
    /** @type {?} */
    NgSelectOption.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    NgSelectOption.ctorParameters;
    /** @type {?} */
    NgSelectOption.propDecorators;
    /** @type {?} */
    NgSelectOption.prototype.id;
    /** @type {?} */
    NgSelectOption.prototype._element;
    /** @type {?} */
    NgSelectOption.prototype._renderer;
    /** @type {?} */
    NgSelectOption.prototype._select;
}
//# sourceMappingURL=select_control_value_accessor.js.map

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_lang__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__control_value_accessor__ = __webpack_require__(42);
/* unused harmony export SELECT_MULTIPLE_VALUE_ACCESSOR */
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return SelectMultipleControlValueAccessor; });
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return NgSelectMultipleOption; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */



var /** @type {?} */ SELECT_MULTIPLE_VALUE_ACCESSOR = {
    provide: __WEBPACK_IMPORTED_MODULE_2__control_value_accessor__["a" /* NG_VALUE_ACCESSOR */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return SelectMultipleControlValueAccessor; }),
    multi: true
};
/**
 * @param {?} id
 * @param {?} value
 * @return {?}
 */
function _buildValueString(id, value) {
    if (id == null)
        return "" + value;
    if (typeof value === 'string')
        value = "'" + value + "'";
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["d" /* isPrimitive */])(value))
        value = 'Object';
    return (id + ": " + value).slice(0, 50);
}
/**
 * @param {?} valueString
 * @return {?}
 */
function _extractId(valueString) {
    return valueString.split(':')[0];
}
/**
 * Mock interface for HTMLCollection
 * @abstract
 */
var HTMLCollection = (function () {
    function HTMLCollection() {
    }
    /**
     * @abstract
     * @param {?} _
     * @return {?}
     */
    HTMLCollection.prototype.item = function (_) { };
    return HTMLCollection;
}());
function HTMLCollection_tsickle_Closure_declarations() {
    /** @type {?} */
    HTMLCollection.prototype.length;
}
/**
 * The accessor for writing a value and listening to changes on a select element.
 *
 * \@stable
 */
var SelectMultipleControlValueAccessor = (function () {
    /**
     * @param {?} _renderer
     * @param {?} _elementRef
     */
    function SelectMultipleControlValueAccessor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        /** @internal */
        this._optionMap = new Map();
        /** @internal */
        this._idCounter = 0;
        this.onChange = function (_) { };
        this.onTouched = function () { };
    }
    /**
     * @param {?} value
     * @return {?}
     */
    SelectMultipleControlValueAccessor.prototype.writeValue = function (value) {
        var _this = this;
        this.value = value;
        var /** @type {?} */ optionSelectedStateSetter;
        if (Array.isArray(value)) {
            // convert values to ids
            var /** @type {?} */ ids_1 = value.map(function (v) { return _this._getOptionId(v); });
            optionSelectedStateSetter = function (opt, o) { opt._setSelected(ids_1.indexOf(o.toString()) > -1); };
        }
        else {
            optionSelectedStateSetter = function (opt, o) { opt._setSelected(false); };
        }
        this._optionMap.forEach(optionSelectedStateSetter);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    SelectMultipleControlValueAccessor.prototype.registerOnChange = function (fn) {
        var _this = this;
        this.onChange = function (_) {
            var /** @type {?} */ selected = [];
            if (_.hasOwnProperty('selectedOptions')) {
                var /** @type {?} */ options = _.selectedOptions;
                for (var /** @type {?} */ i = 0; i < options.length; i++) {
                    var /** @type {?} */ opt = options.item(i);
                    var /** @type {?} */ val = _this._getOptionValue(opt.value);
                    selected.push(val);
                }
            }
            else {
                var /** @type {?} */ options = (_.options);
                for (var /** @type {?} */ i = 0; i < options.length; i++) {
                    var /** @type {?} */ opt = options.item(i);
                    if (opt.selected) {
                        var /** @type {?} */ val = _this._getOptionValue(opt.value);
                        selected.push(val);
                    }
                }
            }
            _this.value = selected;
            fn(selected);
        };
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    SelectMultipleControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    SelectMultipleControlValueAccessor.prototype.setDisabledState = function (isDisabled) {
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    SelectMultipleControlValueAccessor.prototype._registerOption = function (value) {
        var /** @type {?} */ id = (this._idCounter++).toString();
        this._optionMap.set(id, value);
        return id;
    };
    /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    SelectMultipleControlValueAccessor.prototype._getOptionId = function (value) {
        for (var _i = 0, _a = Array.from(this._optionMap.keys()); _i < _a.length; _i++) {
            var id = _a[_i];
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["e" /* looseIdentical */])(this._optionMap.get(id)._value, value))
                return id;
        }
        return null;
    };
    /**
     * \@internal
     * @param {?} valueString
     * @return {?}
     */
    SelectMultipleControlValueAccessor.prototype._getOptionValue = function (valueString) {
        var /** @type {?} */ id = _extractId(valueString);
        return this._optionMap.has(id) ? this._optionMap.get(id)._value : valueString;
    };
    SelectMultipleControlValueAccessor.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'select[multiple][formControlName],select[multiple][formControl],select[multiple][ngModel]',
                    host: { '(change)': 'onChange($event.target)', '(blur)': 'onTouched()' },
                    providers: [SELECT_MULTIPLE_VALUE_ACCESSOR]
                },] },
    ];
    /** @nocollapse */
    SelectMultipleControlValueAccessor.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    ]; };
    return SelectMultipleControlValueAccessor;
}());
function SelectMultipleControlValueAccessor_tsickle_Closure_declarations() {
    /** @type {?} */
    SelectMultipleControlValueAccessor.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    SelectMultipleControlValueAccessor.ctorParameters;
    /** @type {?} */
    SelectMultipleControlValueAccessor.prototype.value;
    /**
     * \@internal
     * @type {?}
     */
    SelectMultipleControlValueAccessor.prototype._optionMap;
    /**
     * \@internal
     * @type {?}
     */
    SelectMultipleControlValueAccessor.prototype._idCounter;
    /** @type {?} */
    SelectMultipleControlValueAccessor.prototype.onChange;
    /** @type {?} */
    SelectMultipleControlValueAccessor.prototype.onTouched;
    /** @type {?} */
    SelectMultipleControlValueAccessor.prototype._renderer;
    /** @type {?} */
    SelectMultipleControlValueAccessor.prototype._elementRef;
}
/**
 * Marks `<option>` as dynamic, so Angular can be notified when options change.
 *
 * ### Example
 *
 * ```
 * <select multiple name="city" ngModel>
 *   <option *ngFor="let c of cities" [value]="c"></option>
 * </select>
 * ```
 */
var NgSelectMultipleOption = (function () {
    /**
     * @param {?} _element
     * @param {?} _renderer
     * @param {?} _select
     */
    function NgSelectMultipleOption(_element, _renderer, _select) {
        this._element = _element;
        this._renderer = _renderer;
        this._select = _select;
        if (this._select) {
            this.id = this._select._registerOption(this);
        }
    }
    Object.defineProperty(NgSelectMultipleOption.prototype, "ngValue", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (this._select == null)
                return;
            this._value = value;
            this._setElementValue(_buildValueString(this.id, value));
            this._select.writeValue(this._select.value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgSelectMultipleOption.prototype, "value", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (this._select) {
                this._value = value;
                this._setElementValue(_buildValueString(this.id, value));
                this._select.writeValue(this._select.value);
            }
            else {
                this._setElementValue(value);
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    NgSelectMultipleOption.prototype._setElementValue = function (value) {
        this._renderer.setElementProperty(this._element.nativeElement, 'value', value);
    };
    /**
     * \@internal
     * @param {?} selected
     * @return {?}
     */
    NgSelectMultipleOption.prototype._setSelected = function (selected) {
        this._renderer.setElementProperty(this._element.nativeElement, 'selected', selected);
    };
    /**
     * @return {?}
     */
    NgSelectMultipleOption.prototype.ngOnDestroy = function () {
        if (this._select) {
            this._select._optionMap.delete(this.id);
            this._select.writeValue(this._select.value);
        }
    };
    NgSelectMultipleOption.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: 'option' },] },
    ];
    /** @nocollapse */
    NgSelectMultipleOption.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: SelectMultipleControlValueAccessor, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Host"] },] },
    ]; };
    NgSelectMultipleOption.propDecorators = {
        'ngValue': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngValue',] },],
        'value': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['value',] },],
    };
    return NgSelectMultipleOption;
}());
function NgSelectMultipleOption_tsickle_Closure_declarations() {
    /** @type {?} */
    NgSelectMultipleOption.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    NgSelectMultipleOption.ctorParameters;
    /** @type {?} */
    NgSelectMultipleOption.propDecorators;
    /** @type {?} */
    NgSelectMultipleOption.prototype.id;
    /**
     * \@internal
     * @type {?}
     */
    NgSelectMultipleOption.prototype._value;
    /** @type {?} */
    NgSelectMultipleOption.prototype._element;
    /** @type {?} */
    NgSelectMultipleOption.prototype._renderer;
    /** @type {?} */
    NgSelectMultipleOption.prototype._select;
}
//# sourceMappingURL=select_multiple_control_value_accessor.js.map

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_observable_fromPromise__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_observable_fromPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_observable_fromPromise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_shared__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__facade_async__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__private_import_core__ = __webpack_require__(393);
/* unused harmony export VALID */
/* unused harmony export INVALID */
/* unused harmony export PENDING */
/* unused harmony export DISABLED */
/* harmony export (binding) */ __webpack_require__.d(exports, "d", function() { return AbstractControl; });
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return FormControl; });
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return FormGroup; });
/* harmony export (binding) */ __webpack_require__.d(exports, "c", function() { return FormArray; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};




/**
 * Indicates that a FormControl is valid, i.e. that no errors exist in the input value.
 */
var /** @type {?} */ VALID = 'VALID';
/**
 * Indicates that a FormControl is invalid, i.e. that an error exists in the input value.
 */
var /** @type {?} */ INVALID = 'INVALID';
/**
 * Indicates that a FormControl is pending, i.e. that async validation is occurring and
 * errors are not yet available for the input value.
 */
var /** @type {?} */ PENDING = 'PENDING';
/**
 * Indicates that a FormControl is disabled, i.e. that the control is exempt from ancestor
 * calculations of validity or value.
 */
var /** @type {?} */ DISABLED = 'DISABLED';
/**
 * @param {?} control
 * @param {?} path
 * @param {?} delimiter
 * @return {?}
 */
function _find(control, path, delimiter) {
    if (path == null)
        return null;
    if (!(path instanceof Array)) {
        path = ((path)).split(delimiter);
    }
    if (path instanceof Array && (path.length === 0))
        return null;
    return ((path)).reduce(function (v, name) {
        if (v instanceof FormGroup) {
            return v.controls[name] || null;
        }
        if (v instanceof FormArray) {
            return v.at(/** @type {?} */ (name)) || null;
        }
        return null;
    }, control);
}
/**
 * @param {?} r
 * @return {?}
 */
function toObservable(r) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__private_import_core__["a" /* isPromise */])(r) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_rxjs_observable_fromPromise__["fromPromise"])(r) : r;
}
/**
 * @param {?} validator
 * @return {?}
 */
function coerceToValidator(validator) {
    return Array.isArray(validator) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__directives_shared__["b" /* composeValidators */])(validator) : validator;
}
/**
 * @param {?} asyncValidator
 * @return {?}
 */
function coerceToAsyncValidator(asyncValidator) {
    return Array.isArray(asyncValidator) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__directives_shared__["c" /* composeAsyncValidators */])(asyncValidator) : asyncValidator;
}
/**
 * \@whatItDoes This is the base class for {\@link FormControl}, {\@link FormGroup}, and
 * {\@link FormArray}.
 *
 * It provides some of the shared behavior that all controls and groups of controls have, like
 * running validators, calculating status, and resetting state. It also defines the properties
 * that are shared between all sub-classes, like `value`, `valid`, and `dirty`. It shouldn't be
 * instantiated directly.
 *
 * \@stable
 * @abstract
 */
var AbstractControl = (function () {
    /**
     * @param {?} validator
     * @param {?} asyncValidator
     */
    function AbstractControl(validator, asyncValidator) {
        this.validator = validator;
        this.asyncValidator = asyncValidator;
        /** @internal */
        this._onCollectionChange = function () { };
        this._pristine = true;
        this._touched = false;
        /** @internal */
        this._onDisabledChange = [];
    }
    Object.defineProperty(AbstractControl.prototype, "value", {
        /**
         * The value of the control.
         * @return {?}
         */
        get: function () { return this._value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "parent", {
        /**
         * The parent control.
         * @return {?}
         */
        get: function () { return this._parent; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "status", {
        /**
         * The validation status of the control. There are four possible
         * validation statuses:
         *
         * * **VALID**:  control has passed all validation checks
         * * **INVALID**: control has failed at least one validation check
         * * **PENDING**: control is in the midst of conducting a validation check
         * * **DISABLED**: control is exempt from validation checks
         *
         * These statuses are mutually exclusive, so a control cannot be
         * both valid AND invalid or invalid AND disabled.
         * @return {?}
         */
        get: function () { return this._status; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "valid", {
        /**
         * A control is `valid` when its `status === VALID`.
         *
         * In order to have this status, the control must have passed all its
         * validation checks.
         * @return {?}
         */
        get: function () { return this._status === VALID; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "invalid", {
        /**
         * A control is `invalid` when its `status === INVALID`.
         *
         * In order to have this status, the control must have failed
         * at least one of its validation checks.
         * @return {?}
         */
        get: function () { return this._status === INVALID; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "pending", {
        /**
         * A control is `pending` when its `status === PENDING`.
         *
         * In order to have this status, the control must be in the
         * middle of conducting a validation check.
         * @return {?}
         */
        get: function () { return this._status == PENDING; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "disabled", {
        /**
         * A control is `disabled` when its `status === DISABLED`.
         *
         * Disabled controls are exempt from validation checks and
         * are not included in the aggregate value of their ancestor
         * controls.
         * @return {?}
         */
        get: function () { return this._status === DISABLED; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "enabled", {
        /**
         * A control is `enabled` as long as its `status !== DISABLED`.
         *
         * In other words, it has a status of `VALID`, `INVALID`, or
         * `PENDING`.
         * @return {?}
         */
        get: function () { return this._status !== DISABLED; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "errors", {
        /**
         * Returns any errors generated by failing validation. If there
         * are no errors, it will return null.
         * @return {?}
         */
        get: function () { return this._errors; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "pristine", {
        /**
         * A control is `pristine` if the user has not yet changed
         * the value in the UI.
         *
         * Note that programmatic changes to a control's value will
         * *not* mark it dirty.
         * @return {?}
         */
        get: function () { return this._pristine; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "dirty", {
        /**
         * A control is `dirty` if the user has changed the value
         * in the UI.
         *
         * Note that programmatic changes to a control's value will
         * *not* mark it dirty.
         * @return {?}
         */
        get: function () { return !this.pristine; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "touched", {
        /**
         * A control is marked `touched` once the user has triggered
         * a `blur` event on it.
         * @return {?}
         */
        get: function () { return this._touched; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "untouched", {
        /**
         * A control is `untouched` if the user has not yet triggered
         * a `blur` event on it.
         * @return {?}
         */
        get: function () { return !this._touched; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "valueChanges", {
        /**
         * Emits an event every time the value of the control changes, in
         * the UI or programmatically.
         * @return {?}
         */
        get: function () { return this._valueChanges; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "statusChanges", {
        /**
         * Emits an event every time the validation status of the control
         * is re-calculated.
         * @return {?}
         */
        get: function () { return this._statusChanges; },
        enumerable: true,
        configurable: true
    });
    /**
     * Sets the synchronous validators that are active on this control.  Calling
     * this will overwrite any existing sync validators.
     * @param {?} newValidator
     * @return {?}
     */
    AbstractControl.prototype.setValidators = function (newValidator) {
        this.validator = coerceToValidator(newValidator);
    };
    /**
     * Sets the async validators that are active on this control. Calling this
     * will overwrite any existing async validators.
     * @param {?} newValidator
     * @return {?}
     */
    AbstractControl.prototype.setAsyncValidators = function (newValidator) {
        this.asyncValidator = coerceToAsyncValidator(newValidator);
    };
    /**
     * Empties out the sync validator list.
     * @return {?}
     */
    AbstractControl.prototype.clearValidators = function () { this.validator = null; };
    /**
     * Empties out the async validator list.
     * @return {?}
     */
    AbstractControl.prototype.clearAsyncValidators = function () { this.asyncValidator = null; };
    /**
     * Marks the control as `touched`.
     *
     * This will also mark all direct ancestors as `touched` to maintain
     * the model.
     * @param {?=} __0
     * @return {?}
     */
    AbstractControl.prototype.markAsTouched = function (_a) {
        var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
        this._touched = true;
        if (this._parent && !onlySelf) {
            this._parent.markAsTouched({ onlySelf: onlySelf });
        }
    };
    /**
     * Marks the control as `untouched`.
     *
     * If the control has any children, it will also mark all children as `untouched`
     * to maintain the model, and re-calculate the `touched` status of all parent
     * controls.
     * @param {?=} __0
     * @return {?}
     */
    AbstractControl.prototype.markAsUntouched = function (_a) {
        var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
        this._touched = false;
        this._forEachChild(function (control) { control.markAsUntouched({ onlySelf: true }); });
        if (this._parent && !onlySelf) {
            this._parent._updateTouched({ onlySelf: onlySelf });
        }
    };
    /**
     * Marks the control as `dirty`.
     *
     * This will also mark all direct ancestors as `dirty` to maintain
     * the model.
     * @param {?=} __0
     * @return {?}
     */
    AbstractControl.prototype.markAsDirty = function (_a) {
        var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
        this._pristine = false;
        if (this._parent && !onlySelf) {
            this._parent.markAsDirty({ onlySelf: onlySelf });
        }
    };
    /**
     * Marks the control as `pristine`.
     *
     * If the control has any children, it will also mark all children as `pristine`
     * to maintain the model, and re-calculate the `pristine` status of all parent
     * controls.
     * @param {?=} __0
     * @return {?}
     */
    AbstractControl.prototype.markAsPristine = function (_a) {
        var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
        this._pristine = true;
        this._forEachChild(function (control) { control.markAsPristine({ onlySelf: true }); });
        if (this._parent && !onlySelf) {
            this._parent._updatePristine({ onlySelf: onlySelf });
        }
    };
    /**
     * Marks the control as `pending`.
     * @param {?=} __0
     * @return {?}
     */
    AbstractControl.prototype.markAsPending = function (_a) {
        var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
        this._status = PENDING;
        if (this._parent && !onlySelf) {
            this._parent.markAsPending({ onlySelf: onlySelf });
        }
    };
    /**
     * Disables the control. This means the control will be exempt from validation checks and
     * excluded from the aggregate value of any parent. Its status is `DISABLED`.
     *
     * If the control has children, all children will be disabled to maintain the model.
     * @param {?=} __0
     * @return {?}
     */
    AbstractControl.prototype.disable = function (_a) {
        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
        this._status = DISABLED;
        this._errors = null;
        this._forEachChild(function (control) { control.disable({ onlySelf: true }); });
        this._updateValue();
        if (emitEvent !== false) {
            this._valueChanges.emit(this._value);
            this._statusChanges.emit(this._status);
        }
        this._updateAncestors(onlySelf);
        this._onDisabledChange.forEach(function (changeFn) { return changeFn(true); });
    };
    /**
     * Enables the control. This means the control will be included in validation checks and
     * the aggregate value of its parent. Its status is re-calculated based on its value and
     * its validators.
     *
     * If the control has children, all children will be enabled.
     * @param {?=} __0
     * @return {?}
     */
    AbstractControl.prototype.enable = function (_a) {
        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
        this._status = VALID;
        this._forEachChild(function (control) { control.enable({ onlySelf: true }); });
        this.updateValueAndValidity({ onlySelf: true, emitEvent: emitEvent });
        this._updateAncestors(onlySelf);
        this._onDisabledChange.forEach(function (changeFn) { return changeFn(false); });
    };
    /**
     * @param {?} onlySelf
     * @return {?}
     */
    AbstractControl.prototype._updateAncestors = function (onlySelf) {
        if (this._parent && !onlySelf) {
            this._parent.updateValueAndValidity();
            this._parent._updatePristine();
            this._parent._updateTouched();
        }
    };
    /**
     * @param {?} parent
     * @return {?}
     */
    AbstractControl.prototype.setParent = function (parent) { this._parent = parent; };
    /**
     * Sets the value of the control. Abstract method (implemented in sub-classes).
     * @abstract
     * @param {?} value
     * @param {?=} options
     * @return {?}
     */
    AbstractControl.prototype.setValue = function (value, options) { };
    /**
     * Patches the value of the control. Abstract method (implemented in sub-classes).
     * @abstract
     * @param {?} value
     * @param {?=} options
     * @return {?}
     */
    AbstractControl.prototype.patchValue = function (value, options) { };
    /**
     * Resets the control. Abstract method (implemented in sub-classes).
     * @abstract
     * @param {?=} value
     * @param {?=} options
     * @return {?}
     */
    AbstractControl.prototype.reset = function (value, options) { };
    /**
     * Re-calculates the value and validation status of the control.
     *
     * By default, it will also update the value and validity of its ancestors.
     * @param {?=} __0
     * @return {?}
     */
    AbstractControl.prototype.updateValueAndValidity = function (_a) {
        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
        this._setInitialStatus();
        this._updateValue();
        if (this.enabled) {
            this._errors = this._runValidator();
            this._status = this._calculateStatus();
            if (this._status === VALID || this._status === PENDING) {
                this._runAsyncValidator(emitEvent);
            }
        }
        if (emitEvent !== false) {
            this._valueChanges.emit(this._value);
            this._statusChanges.emit(this._status);
        }
        if (this._parent && !onlySelf) {
            this._parent.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
        }
    };
    /**
     * \@internal
     * @param {?=} __0
     * @return {?}
     */
    AbstractControl.prototype._updateTreeValidity = function (_a) {
        var emitEvent = (_a === void 0 ? { emitEvent: true } : _a).emitEvent;
        this._forEachChild(function (ctrl) { return ctrl._updateTreeValidity({ emitEvent: emitEvent }); });
        this.updateValueAndValidity({ onlySelf: true, emitEvent: emitEvent });
    };
    /**
     * @return {?}
     */
    AbstractControl.prototype._setInitialStatus = function () { this._status = this._allControlsDisabled() ? DISABLED : VALID; };
    /**
     * @return {?}
     */
    AbstractControl.prototype._runValidator = function () {
        return this.validator ? this.validator(this) : null;
    };
    /**
     * @param {?} emitEvent
     * @return {?}
     */
    AbstractControl.prototype._runAsyncValidator = function (emitEvent) {
        var _this = this;
        if (this.asyncValidator) {
            this._status = PENDING;
            this._cancelExistingSubscription();
            var /** @type {?} */ obs = toObservable(this.asyncValidator(this));
            if (!(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__private_import_core__["b" /* isObservable */])(obs))) {
                throw new Error("expected the following validator to return Promise or Observable: " + this.asyncValidator + ". If you are using FormBuilder; did you forget to brace your validators in an array?");
            }
            this._asyncValidationSubscription =
                obs.subscribe({ next: function (res) { return _this.setErrors(res, { emitEvent: emitEvent }); } });
        }
    };
    /**
     * @return {?}
     */
    AbstractControl.prototype._cancelExistingSubscription = function () {
        if (this._asyncValidationSubscription) {
            this._asyncValidationSubscription.unsubscribe();
        }
    };
    /**
     * Sets errors on a form control.
     *
     * This is used when validations are run manually by the user, rather than automatically.
     *
     * Calling `setErrors` will also update the validity of the parent control.
     *
     * ### Example
     *
     * ```
     * const login = new FormControl("someLogin");
     * login.setErrors({
     *   "notUnique": true
     * });
     *
     * expect(login.valid).toEqual(false);
     * expect(login.errors).toEqual({"notUnique": true});
     *
     * login.setValue("someOtherLogin");
     *
     * expect(login.valid).toEqual(true);
     * ```
     * @param {?} errors
     * @param {?=} __1
     * @return {?}
     */
    AbstractControl.prototype.setErrors = function (errors, _a) {
        var emitEvent = (_a === void 0 ? {} : _a).emitEvent;
        this._errors = errors;
        this._updateControlsErrors(emitEvent !== false);
    };
    /**
     * Retrieves a child control given the control's name or path.
     *
     * Paths can be passed in as an array or a string delimited by a dot.
     *
     * To get a control nested within a `person` sub-group:
     *
     * * `this.form.get('person.name');`
     *
     * -OR-
     *
     * * `this.form.get(['person', 'name']);`
     * @param {?} path
     * @return {?}
     */
    AbstractControl.prototype.get = function (path) { return _find(this, path, '.'); };
    /**
     * Returns true if the control with the given path has the error specified. Otherwise
     * returns null or undefined.
     *
     * If no path is given, it checks for the error on the present control.
     * @param {?} errorCode
     * @param {?=} path
     * @return {?}
     */
    AbstractControl.prototype.getError = function (errorCode, path) {
        if (path === void 0) { path = null; }
        var /** @type {?} */ control = path ? this.get(path) : this;
        return control && control._errors ? control._errors[errorCode] : null;
    };
    /**
     * Returns true if the control with the given path has the error specified. Otherwise
     * returns false.
     *
     * If no path is given, it checks for the error on the present control.
     * @param {?} errorCode
     * @param {?=} path
     * @return {?}
     */
    AbstractControl.prototype.hasError = function (errorCode, path) {
        if (path === void 0) { path = null; }
        return !!this.getError(errorCode, path);
    };
    Object.defineProperty(AbstractControl.prototype, "root", {
        /**
         * Retrieves the top-level ancestor of this control.
         * @return {?}
         */
        get: function () {
            var /** @type {?} */ x = this;
            while (x._parent) {
                x = x._parent;
            }
            return x;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * \@internal
     * @param {?} emitEvent
     * @return {?}
     */
    AbstractControl.prototype._updateControlsErrors = function (emitEvent) {
        this._status = this._calculateStatus();
        if (emitEvent) {
            this._statusChanges.emit(this._status);
        }
        if (this._parent) {
            this._parent._updateControlsErrors(emitEvent);
        }
    };
    /**
     * \@internal
     * @return {?}
     */
    AbstractControl.prototype._initObservables = function () {
        this._valueChanges = new __WEBPACK_IMPORTED_MODULE_2__facade_async__["a" /* EventEmitter */]();
        this._statusChanges = new __WEBPACK_IMPORTED_MODULE_2__facade_async__["a" /* EventEmitter */]();
    };
    /**
     * @return {?}
     */
    AbstractControl.prototype._calculateStatus = function () {
        if (this._allControlsDisabled())
            return DISABLED;
        if (this._errors)
            return INVALID;
        if (this._anyControlsHaveStatus(PENDING))
            return PENDING;
        if (this._anyControlsHaveStatus(INVALID))
            return INVALID;
        return VALID;
    };
    /**
     * \@internal
     * @abstract
     * @return {?}
     */
    AbstractControl.prototype._updateValue = function () { };
    /**
     * \@internal
     * @abstract
     * @param {?} cb
     * @return {?}
     */
    AbstractControl.prototype._forEachChild = function (cb) { };
    /**
     * \@internal
     * @abstract
     * @param {?} condition
     * @return {?}
     */
    AbstractControl.prototype._anyControls = function (condition) { };
    /**
     * \@internal
     * @abstract
     * @return {?}
     */
    AbstractControl.prototype._allControlsDisabled = function () { };
    /**
     * \@internal
     * @param {?} status
     * @return {?}
     */
    AbstractControl.prototype._anyControlsHaveStatus = function (status) {
        return this._anyControls(function (control) { return control.status === status; });
    };
    /**
     * \@internal
     * @return {?}
     */
    AbstractControl.prototype._anyControlsDirty = function () {
        return this._anyControls(function (control) { return control.dirty; });
    };
    /**
     * \@internal
     * @return {?}
     */
    AbstractControl.prototype._anyControlsTouched = function () {
        return this._anyControls(function (control) { return control.touched; });
    };
    /**
     * \@internal
     * @param {?=} __0
     * @return {?}
     */
    AbstractControl.prototype._updatePristine = function (_a) {
        var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
        this._pristine = !this._anyControlsDirty();
        if (this._parent && !onlySelf) {
            this._parent._updatePristine({ onlySelf: onlySelf });
        }
    };
    /**
     * \@internal
     * @param {?=} __0
     * @return {?}
     */
    AbstractControl.prototype._updateTouched = function (_a) {
        var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
        this._touched = this._anyControlsTouched();
        if (this._parent && !onlySelf) {
            this._parent._updateTouched({ onlySelf: onlySelf });
        }
    };
    /**
     * \@internal
     * @param {?} formState
     * @return {?}
     */
    AbstractControl.prototype._isBoxedValue = function (formState) {
        return typeof formState === 'object' && formState !== null &&
            Object.keys(formState).length === 2 && 'value' in formState && 'disabled' in formState;
    };
    /**
     * \@internal
     * @param {?} fn
     * @return {?}
     */
    AbstractControl.prototype._registerOnCollectionChange = function (fn) { this._onCollectionChange = fn; };
    return AbstractControl;
}());
function AbstractControl_tsickle_Closure_declarations() {
    /**
     * \@internal
     * @type {?}
     */
    AbstractControl.prototype._value;
    /**
     * \@internal
     * @type {?}
     */
    AbstractControl.prototype._onCollectionChange;
    /** @type {?} */
    AbstractControl.prototype._valueChanges;
    /** @type {?} */
    AbstractControl.prototype._statusChanges;
    /** @type {?} */
    AbstractControl.prototype._status;
    /** @type {?} */
    AbstractControl.prototype._errors;
    /** @type {?} */
    AbstractControl.prototype._pristine;
    /** @type {?} */
    AbstractControl.prototype._touched;
    /** @type {?} */
    AbstractControl.prototype._parent;
    /** @type {?} */
    AbstractControl.prototype._asyncValidationSubscription;
    /**
     * \@internal
     * @type {?}
     */
    AbstractControl.prototype._onDisabledChange;
    /** @type {?} */
    AbstractControl.prototype.validator;
    /** @type {?} */
    AbstractControl.prototype.asyncValidator;
}
/**
 * \@whatItDoes Tracks the value and validation status of an individual form control.
 *
 * It is one of the three fundamental building blocks of Angular forms, along with
 * {\@link FormGroup} and {\@link FormArray}.
 *
 * \@howToUse
 *
 * When instantiating a {\@link FormControl}, you can pass in an initial value as the
 * first argument. Example:
 *
 * ```ts
 * const ctrl = new FormControl('some value');
 * console.log(ctrl.value);     // 'some value'
 * ```
 *
 * You can also initialize the control with a form state object on instantiation,
 * which includes both the value and whether or not the control is disabled.
 * You can't use the value key without the disabled key; both are required
 * to use this way of initialization.
 *
 * ```ts
 * const ctrl = new FormControl({value: 'n/a', disabled: true});
 * console.log(ctrl.value);     // 'n/a'
 * console.log(ctrl.status);   // 'DISABLED'
 * ```
 *
 * To include a sync validator (or an array of sync validators) with the control,
 * pass it in as the second argument. Async validators are also supported, but
 * have to be passed in separately as the third arg.
 *
 * ```ts
 * const ctrl = new FormControl('', Validators.required);
 * console.log(ctrl.value);     // ''
 * console.log(ctrl.status);   // 'INVALID'
 * ```
 *
 * See its superclass, {\@link AbstractControl}, for more properties and methods.
 *
 * * **npm package**: `\@angular/forms`
 *
 * \@stable
 */
var FormControl = (function (_super) {
    __extends(FormControl, _super);
    /**
     * @param {?=} formState
     * @param {?=} validator
     * @param {?=} asyncValidator
     */
    function FormControl(formState, validator, asyncValidator) {
        if (formState === void 0) { formState = null; }
        if (validator === void 0) { validator = null; }
        if (asyncValidator === void 0) { asyncValidator = null; }
        _super.call(this, coerceToValidator(validator), coerceToAsyncValidator(asyncValidator));
        /** @internal */
        this._onChange = [];
        this._applyFormState(formState);
        this.updateValueAndValidity({ onlySelf: true, emitEvent: false });
        this._initObservables();
    }
    /**
     * Set the value of the form control to `value`.
     *
     * If `onlySelf` is `true`, this change will only affect the validation of this `FormControl`
     * and not its parent component. This defaults to false.
     *
     * If `emitEvent` is `true`, this
     * change will cause a `valueChanges` event on the `FormControl` to be emitted. This defaults
     * to true (as it falls through to `updateValueAndValidity`).
     *
     * If `emitModelToViewChange` is `true`, the view will be notified about the new value
     * via an `onChange` event. This is the default behavior if `emitModelToViewChange` is not
     * specified.
     *
     * If `emitViewToModelChange` is `true`, an ngModelChange event will be fired to update the
     * model.  This is the default behavior if `emitViewToModelChange` is not specified.
     * @param {?} value
     * @param {?=} __1
     * @return {?}
     */
    FormControl.prototype.setValue = function (value, _a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent, emitModelToViewChange = _b.emitModelToViewChange, emitViewToModelChange = _b.emitViewToModelChange;
        this._value = value;
        if (this._onChange.length && emitModelToViewChange !== false) {
            this._onChange.forEach(function (changeFn) { return changeFn(_this._value, emitViewToModelChange !== false); });
        }
        this.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
    };
    /**
     * Patches the value of a control.
     *
     * This function is functionally the same as {\@link FormControl.setValue} at this level.
     * It exists for symmetry with {\@link FormGroup.patchValue} on `FormGroups` and `FormArrays`,
     * where it does behave differently.
     * @param {?} value
     * @param {?=} options
     * @return {?}
     */
    FormControl.prototype.patchValue = function (value, options) {
        if (options === void 0) { options = {}; }
        this.setValue(value, options);
    };
    /**
     * Resets the form control. This means by default:
     *
     * * it is marked as `pristine`
     * * it is marked as `untouched`
     * * value is set to null
     *
     * You can also reset to a specific form state by passing through a standalone
     * value or a form state object that contains both a value and a disabled state
     * (these are the only two properties that cannot be calculated).
     *
     * Ex:
     *
     * ```ts
     * this.control.reset('Nancy');
     *
     * console.log(this.control.value);  // 'Nancy'
     * ```
     *
     * OR
     *
     * ```
     * this.control.reset({value: 'Nancy', disabled: true});
     *
     * console.log(this.control.value);  // 'Nancy'
     * console.log(this.control.status);  // 'DISABLED'
     * ```
     * @param {?=} formState
     * @param {?=} __1
     * @return {?}
     */
    FormControl.prototype.reset = function (formState, _a) {
        if (formState === void 0) { formState = null; }
        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
        this._applyFormState(formState);
        this.markAsPristine({ onlySelf: onlySelf });
        this.markAsUntouched({ onlySelf: onlySelf });
        this.setValue(this._value, { onlySelf: onlySelf, emitEvent: emitEvent });
    };
    /**
     * \@internal
     * @return {?}
     */
    FormControl.prototype._updateValue = function () { };
    /**
     * \@internal
     * @param {?} condition
     * @return {?}
     */
    FormControl.prototype._anyControls = function (condition) { return false; };
    /**
     * \@internal
     * @return {?}
     */
    FormControl.prototype._allControlsDisabled = function () { return this.disabled; };
    /**
     * Register a listener for change events.
     * @param {?} fn
     * @return {?}
     */
    FormControl.prototype.registerOnChange = function (fn) { this._onChange.push(fn); };
    /**
     * \@internal
     * @return {?}
     */
    FormControl.prototype._clearChangeFns = function () {
        this._onChange = [];
        this._onDisabledChange = [];
        this._onCollectionChange = function () { };
    };
    /**
     * Register a listener for disabled events.
     * @param {?} fn
     * @return {?}
     */
    FormControl.prototype.registerOnDisabledChange = function (fn) {
        this._onDisabledChange.push(fn);
    };
    /**
     * \@internal
     * @param {?} cb
     * @return {?}
     */
    FormControl.prototype._forEachChild = function (cb) { };
    /**
     * @param {?} formState
     * @return {?}
     */
    FormControl.prototype._applyFormState = function (formState) {
        if (this._isBoxedValue(formState)) {
            this._value = formState.value;
            formState.disabled ? this.disable({ onlySelf: true, emitEvent: false }) :
                this.enable({ onlySelf: true, emitEvent: false });
        }
        else {
            this._value = formState;
        }
    };
    return FormControl;
}(AbstractControl));
function FormControl_tsickle_Closure_declarations() {
    /**
     * \@internal
     * @type {?}
     */
    FormControl.prototype._onChange;
}
/**
 * \@whatItDoes Tracks the value and validity state of a group of {\@link FormControl}
 * instances.
 *
 * A `FormGroup` aggregates the values of each child {\@link FormControl} into one object,
 * with each control name as the key.  It calculates its status by reducing the statuses
 * of its children. For example, if one of the controls in a group is invalid, the entire
 * group becomes invalid.
 *
 * `FormGroup` is one of the three fundamental building blocks used to define forms in Angular,
 * along with {\@link FormControl} and {\@link FormArray}.
 *
 * \@howToUse
 *
 * When instantiating a {\@link FormGroup}, pass in a collection of child controls as the first
 * argument. The key for each child will be the name under which it is registered.
 *
 * ### Example
 *
 * ```
 * const form = new FormGroup({
 *   first: new FormControl('Nancy', Validators.minLength(2)),
 *   last: new FormControl('Drew'),
 * });
 *
 * console.log(form.value);   // {first: 'Nancy', last; 'Drew'}
 * console.log(form.status);  // 'VALID'
 * ```
 *
 * You can also include group-level validators as the second arg, or group-level async
 * validators as the third arg. These come in handy when you want to perform validation
 * that considers the value of more than one child control.
 *
 * ### Example
 *
 * ```
 * const form = new FormGroup({
 *   password: new FormControl('', Validators.minLength(2)),
 *   passwordConfirm: new FormControl('', Validators.minLength(2)),
 * }, passwordMatchValidator);
 *
 *
 * function passwordMatchValidator(g: FormGroup) {
 *    return g.get('password').value === g.get('passwordConfirm').value
 *       ? null : {'mismatch': true};
 * }
 * ```
 *
 * * **npm package**: `\@angular/forms`
 *
 * \@stable
 */
var FormGroup = (function (_super) {
    __extends(FormGroup, _super);
    /**
     * @param {?} controls
     * @param {?=} validator
     * @param {?=} asyncValidator
     */
    function FormGroup(controls, validator, asyncValidator) {
        if (validator === void 0) { validator = null; }
        if (asyncValidator === void 0) { asyncValidator = null; }
        _super.call(this, validator, asyncValidator);
        this.controls = controls;
        this._initObservables();
        this._setUpControls();
        this.updateValueAndValidity({ onlySelf: true, emitEvent: false });
    }
    /**
     * Registers a control with the group's list of controls.
     *
     * This method does not update value or validity of the control, so for
     * most cases you'll want to use {\@link FormGroup.addControl} instead.
     * @param {?} name
     * @param {?} control
     * @return {?}
     */
    FormGroup.prototype.registerControl = function (name, control) {
        if (this.controls[name])
            return this.controls[name];
        this.controls[name] = control;
        control.setParent(this);
        control._registerOnCollectionChange(this._onCollectionChange);
        return control;
    };
    /**
     * Add a control to this group.
     * @param {?} name
     * @param {?} control
     * @return {?}
     */
    FormGroup.prototype.addControl = function (name, control) {
        this.registerControl(name, control);
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    /**
     * Remove a control from this group.
     * @param {?} name
     * @return {?}
     */
    FormGroup.prototype.removeControl = function (name) {
        if (this.controls[name])
            this.controls[name]._registerOnCollectionChange(function () { });
        delete (this.controls[name]);
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    /**
     * Replace an existing control.
     * @param {?} name
     * @param {?} control
     * @return {?}
     */
    FormGroup.prototype.setControl = function (name, control) {
        if (this.controls[name])
            this.controls[name]._registerOnCollectionChange(function () { });
        delete (this.controls[name]);
        if (control)
            this.registerControl(name, control);
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    /**
     * Check whether there is an enabled control with the given name in the group.
     *
     * It will return false for disabled controls. If you'd like to check for
     * existence in the group only, use {\@link AbstractControl.get} instead.
     * @param {?} controlName
     * @return {?}
     */
    FormGroup.prototype.contains = function (controlName) {
        return this.controls.hasOwnProperty(controlName) && this.controls[controlName].enabled;
    };
    /**
     *  Sets the value of the {\@link FormGroup}. It accepts an object that matches
     *  the structure of the group, with control names as keys.
     *
     * This method performs strict checks, so it will throw an error if you try
     * to set the value of a control that doesn't exist or if you exclude the
     * value of a control.
     *
     *  ### Example
     *
     *  ```
     *  const form = new FormGroup({
     *     first: new FormControl(),
     *     last: new FormControl()
     *  });
     *  console.log(form.value);   // {first: null, last: null}
     *
     *  form.setValue({first: 'Nancy', last: 'Drew'});
     *  console.log(form.value);   // {first: 'Nancy', last: 'Drew'}
     *
     *  ```
     * @param {?} value
     * @param {?=} __1
     * @return {?}
     */
    FormGroup.prototype.setValue = function (value, _a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
        this._checkAllValuesPresent(value);
        Object.keys(value).forEach(function (name) {
            _this._throwIfControlMissing(name);
            _this.controls[name].setValue(value[name], { onlySelf: true, emitEvent: emitEvent });
        });
        this.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
    };
    /**
     *  Patches the value of the {\@link FormGroup}. It accepts an object with control
     *  names as keys, and will do its best to match the values to the correct controls
     *  in the group.
     *
     *  It accepts both super-sets and sub-sets of the group without throwing an error.
     *
     *  ### Example
     *
     *  ```
     *  const form = new FormGroup({
     *     first: new FormControl(),
     *     last: new FormControl()
     *  });
     *  console.log(form.value);   // {first: null, last: null}
     *
     *  form.patchValue({first: 'Nancy'});
     *  console.log(form.value);   // {first: 'Nancy', last: null}
     *
     *  ```
     * @param {?} value
     * @param {?=} __1
     * @return {?}
     */
    FormGroup.prototype.patchValue = function (value, _a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
        Object.keys(value).forEach(function (name) {
            if (_this.controls[name]) {
                _this.controls[name].patchValue(value[name], { onlySelf: true, emitEvent: emitEvent });
            }
        });
        this.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
    };
    /**
     * Resets the {\@link FormGroup}. This means by default:
     *
     * * The group and all descendants are marked `pristine`
     * * The group and all descendants are marked `untouched`
     * * The value of all descendants will be null or null maps
     *
     * You can also reset to a specific form state by passing in a map of states
     * that matches the structure of your form, with control names as keys. The state
     * can be a standalone value or a form state object with both a value and a disabled
     * status.
     *
     * ### Example
     *
     * ```ts
     * this.form.reset({first: 'name', last: 'last name'});
     *
     * console.log(this.form.value);  // {first: 'name', last: 'last name'}
     * ```
     *
     * - OR -
     *
     * ```
     * this.form.reset({
     *   first: {value: 'name', disabled: true},
     *   last: 'last'
     * });
     *
     * console.log(this.form.value);  // {first: 'name', last: 'last name'}
     * console.log(this.form.get('first').status);  // 'DISABLED'
     * ```
     * @param {?=} value
     * @param {?=} __1
     * @return {?}
     */
    FormGroup.prototype.reset = function (value, _a) {
        if (value === void 0) { value = {}; }
        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
        this._forEachChild(function (control, name) {
            control.reset(value[name], { onlySelf: true, emitEvent: emitEvent });
        });
        this.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
        this._updatePristine({ onlySelf: onlySelf });
        this._updateTouched({ onlySelf: onlySelf });
    };
    /**
     * The aggregate value of the {\@link FormGroup}, including any disabled controls.
     *
     * If you'd like to include all values regardless of disabled status, use this method.
     * Otherwise, the `value` property is the best way to get the value of the group.
     * @return {?}
     */
    FormGroup.prototype.getRawValue = function () {
        return this._reduceChildren({}, function (acc, control, name) {
            acc[name] = control instanceof FormControl ? control.value : ((control)).getRawValue();
            return acc;
        });
    };
    /**
     * \@internal
     * @param {?} name
     * @return {?}
     */
    FormGroup.prototype._throwIfControlMissing = function (name) {
        if (!Object.keys(this.controls).length) {
            throw new Error("\n        There are no form controls registered with this group yet.  If you're using ngModel,\n        you may want to check next tick (e.g. use setTimeout).\n      ");
        }
        if (!this.controls[name]) {
            throw new Error("Cannot find form control with name: " + name + ".");
        }
    };
    /**
     * \@internal
     * @param {?} cb
     * @return {?}
     */
    FormGroup.prototype._forEachChild = function (cb) {
        var _this = this;
        Object.keys(this.controls).forEach(function (k) { return cb(_this.controls[k], k); });
    };
    /**
     * \@internal
     * @return {?}
     */
    FormGroup.prototype._setUpControls = function () {
        var _this = this;
        this._forEachChild(function (control) {
            control.setParent(_this);
            control._registerOnCollectionChange(_this._onCollectionChange);
        });
    };
    /**
     * \@internal
     * @return {?}
     */
    FormGroup.prototype._updateValue = function () { this._value = this._reduceValue(); };
    /**
     * \@internal
     * @param {?} condition
     * @return {?}
     */
    FormGroup.prototype._anyControls = function (condition) {
        var _this = this;
        var /** @type {?} */ res = false;
        this._forEachChild(function (control, name) {
            res = res || (_this.contains(name) && condition(control));
        });
        return res;
    };
    /**
     * \@internal
     * @return {?}
     */
    FormGroup.prototype._reduceValue = function () {
        var _this = this;
        return this._reduceChildren({}, function (acc, control, name) {
            if (control.enabled || _this.disabled) {
                acc[name] = control.value;
            }
            return acc;
        });
    };
    /**
     * \@internal
     * @param {?} initValue
     * @param {?} fn
     * @return {?}
     */
    FormGroup.prototype._reduceChildren = function (initValue, fn) {
        var /** @type {?} */ res = initValue;
        this._forEachChild(function (control, name) { res = fn(res, control, name); });
        return res;
    };
    /**
     * \@internal
     * @return {?}
     */
    FormGroup.prototype._allControlsDisabled = function () {
        for (var _i = 0, _a = Object.keys(this.controls); _i < _a.length; _i++) {
            var controlName = _a[_i];
            if (this.controls[controlName].enabled) {
                return false;
            }
        }
        return Object.keys(this.controls).length > 0 || this.disabled;
    };
    /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    FormGroup.prototype._checkAllValuesPresent = function (value) {
        this._forEachChild(function (control, name) {
            if (value[name] === undefined) {
                throw new Error("Must supply a value for form control with name: '" + name + "'.");
            }
        });
    };
    return FormGroup;
}(AbstractControl));
function FormGroup_tsickle_Closure_declarations() {
    /** @type {?} */
    FormGroup.prototype.controls;
}
/**
 * \@whatItDoes Tracks the value and validity state of an array of {\@link FormControl},
 * {\@link FormGroup} or {\@link FormArray} instances.
 *
 * A `FormArray` aggregates the values of each child {\@link FormControl} into an array.
 * It calculates its status by reducing the statuses of its children. For example, if one of
 * the controls in a `FormArray` is invalid, the entire array becomes invalid.
 *
 * `FormArray` is one of the three fundamental building blocks used to define forms in Angular,
 * along with {\@link FormControl} and {\@link FormGroup}.
 *
 * \@howToUse
 *
 * When instantiating a {\@link FormArray}, pass in an array of child controls as the first
 * argument.
 *
 * ### Example
 *
 * ```
 * const arr = new FormArray([
 *   new FormControl('Nancy', Validators.minLength(2)),
 *   new FormControl('Drew'),
 * ]);
 *
 * console.log(arr.value);   // ['Nancy', 'Drew']
 * console.log(arr.status);  // 'VALID'
 * ```
 *
 * You can also include array-level validators as the second arg, or array-level async
 * validators as the third arg. These come in handy when you want to perform validation
 * that considers the value of more than one child control.
 *
 * ### Adding or removing controls
 *
 * To change the controls in the array, use the `push`, `insert`, or `removeAt` methods
 * in `FormArray` itself. These methods ensure the controls are properly tracked in the
 * form's hierarchy. Do not modify the array of `AbstractControl`s used to instantiate
 * the `FormArray` directly, as that will result in strange and unexpected behavior such
 * as broken change detection.
 *
 * * **npm package**: `\@angular/forms`
 *
 * \@stable
 */
var FormArray = (function (_super) {
    __extends(FormArray, _super);
    /**
     * @param {?} controls
     * @param {?=} validator
     * @param {?=} asyncValidator
     */
    function FormArray(controls, validator, asyncValidator) {
        if (validator === void 0) { validator = null; }
        if (asyncValidator === void 0) { asyncValidator = null; }
        _super.call(this, validator, asyncValidator);
        this.controls = controls;
        this._initObservables();
        this._setUpControls();
        this.updateValueAndValidity({ onlySelf: true, emitEvent: false });
    }
    /**
     * Get the {\@link AbstractControl} at the given `index` in the array.
     * @param {?} index
     * @return {?}
     */
    FormArray.prototype.at = function (index) { return this.controls[index]; };
    /**
     * Insert a new {\@link AbstractControl} at the end of the array.
     * @param {?} control
     * @return {?}
     */
    FormArray.prototype.push = function (control) {
        this.controls.push(control);
        this._registerControl(control);
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    /**
     * Insert a new {\@link AbstractControl} at the given `index` in the array.
     * @param {?} index
     * @param {?} control
     * @return {?}
     */
    FormArray.prototype.insert = function (index, control) {
        this.controls.splice(index, 0, control);
        this._registerControl(control);
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    /**
     * Remove the control at the given `index` in the array.
     * @param {?} index
     * @return {?}
     */
    FormArray.prototype.removeAt = function (index) {
        if (this.controls[index])
            this.controls[index]._registerOnCollectionChange(function () { });
        this.controls.splice(index, 1);
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    /**
     * Replace an existing control.
     * @param {?} index
     * @param {?} control
     * @return {?}
     */
    FormArray.prototype.setControl = function (index, control) {
        if (this.controls[index])
            this.controls[index]._registerOnCollectionChange(function () { });
        this.controls.splice(index, 1);
        if (control) {
            this.controls.splice(index, 0, control);
            this._registerControl(control);
        }
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    Object.defineProperty(FormArray.prototype, "length", {
        /**
         * Length of the control array.
         * @return {?}
         */
        get: function () { return this.controls.length; },
        enumerable: true,
        configurable: true
    });
    /**
     *  Sets the value of the {\@link FormArray}. It accepts an array that matches
     *  the structure of the control.
     *
     * This method performs strict checks, so it will throw an error if you try
     * to set the value of a control that doesn't exist or if you exclude the
     * value of a control.
     *
     *  ### Example
     *
     *  ```
     *  const arr = new FormArray([
     *     new FormControl(),
     *     new FormControl()
     *  ]);
     *  console.log(arr.value);   // [null, null]
     *
     *  arr.setValue(['Nancy', 'Drew']);
     *  console.log(arr.value);   // ['Nancy', 'Drew']
     *  ```
     * @param {?} value
     * @param {?=} __1
     * @return {?}
     */
    FormArray.prototype.setValue = function (value, _a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
        this._checkAllValuesPresent(value);
        value.forEach(function (newValue, index) {
            _this._throwIfControlMissing(index);
            _this.at(index).setValue(newValue, { onlySelf: true, emitEvent: emitEvent });
        });
        this.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
    };
    /**
     *  Patches the value of the {\@link FormArray}. It accepts an array that matches the
     *  structure of the control, and will do its best to match the values to the correct
     *  controls in the group.
     *
     *  It accepts both super-sets and sub-sets of the array without throwing an error.
     *
     *  ### Example
     *
     *  ```
     *  const arr = new FormArray([
     *     new FormControl(),
     *     new FormControl()
     *  ]);
     *  console.log(arr.value);   // [null, null]
     *
     *  arr.patchValue(['Nancy']);
     *  console.log(arr.value);   // ['Nancy', null]
     *  ```
     * @param {?} value
     * @param {?=} __1
     * @return {?}
     */
    FormArray.prototype.patchValue = function (value, _a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
        value.forEach(function (newValue, index) {
            if (_this.at(index)) {
                _this.at(index).patchValue(newValue, { onlySelf: true, emitEvent: emitEvent });
            }
        });
        this.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
    };
    /**
     * Resets the {\@link FormArray}. This means by default:
     *
     * * The array and all descendants are marked `pristine`
     * * The array and all descendants are marked `untouched`
     * * The value of all descendants will be null or null maps
     *
     * You can also reset to a specific form state by passing in an array of states
     * that matches the structure of the control. The state can be a standalone value
     * or a form state object with both a value and a disabled status.
     *
     * ### Example
     *
     * ```ts
     * this.arr.reset(['name', 'last name']);
     *
     * console.log(this.arr.value);  // ['name', 'last name']
     * ```
     *
     * - OR -
     *
     * ```
     * this.arr.reset([
     *   {value: 'name', disabled: true},
     *   'last'
     * ]);
     *
     * console.log(this.arr.value);  // ['name', 'last name']
     * console.log(this.arr.get(0).status);  // 'DISABLED'
     * ```
     * @param {?=} value
     * @param {?=} __1
     * @return {?}
     */
    FormArray.prototype.reset = function (value, _a) {
        if (value === void 0) { value = []; }
        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
        this._forEachChild(function (control, index) {
            control.reset(value[index], { onlySelf: true, emitEvent: emitEvent });
        });
        this.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
        this._updatePristine({ onlySelf: onlySelf });
        this._updateTouched({ onlySelf: onlySelf });
    };
    /**
     * The aggregate value of the array, including any disabled controls.
     *
     * If you'd like to include all values regardless of disabled status, use this method.
     * Otherwise, the `value` property is the best way to get the value of the array.
     * @return {?}
     */
    FormArray.prototype.getRawValue = function () {
        return this.controls.map(function (control) {
            return control instanceof FormControl ? control.value : ((control)).getRawValue();
        });
    };
    /**
     * \@internal
     * @param {?} index
     * @return {?}
     */
    FormArray.prototype._throwIfControlMissing = function (index) {
        if (!this.controls.length) {
            throw new Error("\n        There are no form controls registered with this array yet.  If you're using ngModel,\n        you may want to check next tick (e.g. use setTimeout).\n      ");
        }
        if (!this.at(index)) {
            throw new Error("Cannot find form control at index " + index);
        }
    };
    /**
     * \@internal
     * @param {?} cb
     * @return {?}
     */
    FormArray.prototype._forEachChild = function (cb) {
        this.controls.forEach(function (control, index) { cb(control, index); });
    };
    /**
     * \@internal
     * @return {?}
     */
    FormArray.prototype._updateValue = function () {
        var _this = this;
        this._value = this.controls.filter(function (control) { return control.enabled || _this.disabled; })
            .map(function (control) { return control.value; });
    };
    /**
     * \@internal
     * @param {?} condition
     * @return {?}
     */
    FormArray.prototype._anyControls = function (condition) {
        return this.controls.some(function (control) { return control.enabled && condition(control); });
    };
    /**
     * \@internal
     * @return {?}
     */
    FormArray.prototype._setUpControls = function () {
        var _this = this;
        this._forEachChild(function (control) { return _this._registerControl(control); });
    };
    /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    FormArray.prototype._checkAllValuesPresent = function (value) {
        this._forEachChild(function (control, i) {
            if (value[i] === undefined) {
                throw new Error("Must supply a value for form control at index: " + i + ".");
            }
        });
    };
    /**
     * \@internal
     * @return {?}
     */
    FormArray.prototype._allControlsDisabled = function () {
        for (var _i = 0, _a = this.controls; _i < _a.length; _i++) {
            var control = _a[_i];
            if (control.enabled)
                return false;
        }
        return this.controls.length > 0 || this.disabled;
    };
    /**
     * @param {?} control
     * @return {?}
     */
    FormArray.prototype._registerControl = function (control) {
        control.setParent(this);
        control._registerOnCollectionChange(this._onCollectionChange);
    };
    return FormArray;
}(AbstractControl));
function FormArray_tsickle_Closure_declarations() {
    /** @type {?} */
    FormArray.prototype.controls;
}
//# sourceMappingURL=model.js.map

/***/ },
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return RouterOutletMap; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * \@whatItDoes Contains all the router outlets created in a component.
 *
 * \@stable
 */
var RouterOutletMap = (function () {
    function RouterOutletMap() {
        /** @internal */
        this._outlets = {};
    }
    /**
     * Adds an outlet to this map.
     * @param {?} name
     * @param {?} outlet
     * @return {?}
     */
    RouterOutletMap.prototype.registerOutlet = function (name, outlet) { this._outlets[name] = outlet; };
    /**
     * Removes an outlet from this map.
     * @param {?} name
     * @return {?}
     */
    RouterOutletMap.prototype.removeOutlet = function (name) { this._outlets[name] = undefined; };
    return RouterOutletMap;
}());
function RouterOutletMap_tsickle_Closure_declarations() {
    /**
     * \@internal
     * @type {?}
     */
    RouterOutletMap.prototype._outlets;
}
//# sourceMappingURL=router_outlet_map.js.map

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var debug, debugOff = function () {
    var any = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        any[_i] = arguments[_i];
    }
};
"production" !== 'production' && (debug = __webpack_require__(4)('app:SceneService'));
var SceneService = (function () {
    function SceneService() {
        this._sceneProducts = [];
        this.state = {
            totalPrice: 0,
            isEmpty: true,
        };
        this.events = {
            sceneUpdated: new core_1.EventEmitter(),
        };
    }
    SceneService.prototype.init = function (catalogService) {
        this._catalogService = catalogService;
        this._productsService = catalogService._productsService;
    };
    SceneService.prototype._addProduct = function (product) {
        this.state.isEmpty === false && (this.state.isEmpty = true);
        product.refreshState();
        this._sceneProducts.push(product);
        product.isAddedToScene = true;
        this.events.sceneUpdated.emit(null);
    };
    SceneService.prototype._removeProduct = function (product) {
        var index = this._sceneProducts.indexOf(product);
        index >= 0 && this._sceneProducts.splice(index, 1);
        if (this._sceneProducts.length === 0 &&
            this.state.isEmpty === true) {
            this.state.isEmpty = false;
        }
        product.isAddedToScene = false;
        this.events.sceneUpdated.emit(null);
    };
    SceneService.prototype._checkProductIsInScene = function (product) {
        return this._sceneProducts.indexOf(product) !== -1;
    };
    SceneService.prototype.emptyScene = function () {
        var tempSceneProdsList = [];
        this._sceneProducts.forEach(function (sceneProduct) { return tempSceneProdsList.push(sceneProduct); });
        tempSceneProdsList.forEach(function (sceneProduct) {
            sceneProduct.removeFromScene();
            sceneProduct.hideTooltip();
        });
    };
    SceneService.prototype.getSceneProducts = function () {
        debugOff('Get scene products');
        return this._sceneProducts;
    };
    SceneService.prototype.getSceneProductsByCategory = function (category) {
        console.warn('REFACTOR getSceneProductsByCategory()');
    };
    SceneService.prototype.removeProductsByCategory = function (category) {
        console.warn('REFACTOR getSceneProductsByCategory()');
    };
    SceneService.prototype.appendProductAPI = function (products) {
        var _this = this;
        products.forEach(function (product) {
            product.toggleInScene = function () {
                debugOff('Toggle add/remove "' + product.code + '" product in scene');
                var isInScene = product.isAddedToScene;
                if (isInScene === true) {
                    product.removeFromScene();
                }
                else {
                    product.addToScene();
                }
            };
            product.addToScene = function () {
                debugOff('Add "' + product.code + '" product in scene');
                _this._addProduct(product);
            };
            product.removeFromScene = function () {
                debugOff('Remove "' + product.code + '" product from scene');
                _this._removeProduct(product);
            };
        });
    };
    return SceneService;
}());
SceneService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [])
], SceneService);
exports.SceneService = SceneService;


/***/ },
/* 200 */
/***/ function(module, exports) {

"use strict";
"use strict";
exports.CONFIG = {
    domain: 'http://virtualspa.mrsteam.com/api'
};


/***/ },
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return PageScrollUtilService; });
/**
 * Created by sebastianfuss on 02.09.16.
 */
var PageScrollUtilService = (function () {
    function PageScrollUtilService() {
    }
    /**
     * Util method to check whether a given variable is either undefined or null
     * @param variable
     * @returns {boolean} true the variable is undefined or null
     */
    PageScrollUtilService.isUndefinedOrNull = function (variable) {
        return (typeof variable === 'undefined') || variable === undefined || variable === null;
    };
    PageScrollUtilService.extractElementPosition = function (document, scrollTargetElement) {
        var body = document.body;
        var docEl = document.documentElement;
        var windowPageYOffset = document.defaultView && document.defaultView.pageYOffset || undefined;
        var windowPageXOffset = document.defaultView && document.defaultView.pageXOffset || undefined;
        var scrollTop = windowPageYOffset || docEl.scrollTop || body.scrollTop;
        var scrollLeft = windowPageXOffset || docEl.scrollLeft || body.scrollLeft;
        var clientTop = docEl.clientTop || body.clientTop || 0;
        var clientLeft = docEl.clientLeft || body.clientLeft || 0;
        if (PageScrollUtilService.isUndefinedOrNull(scrollTargetElement)) {
            // No element found, so return the current position to not cause any change in scroll position
            return { top: scrollTop, left: scrollLeft };
        }
        var box = scrollTargetElement.getBoundingClientRect();
        var top = box.top + scrollTop - clientTop;
        var left = box.left + scrollLeft - clientLeft;
        return { top: Math.round(top), left: Math.round(left) };
    };
    return PageScrollUtilService;
}());



/***/ },
/* 211 */,
/* 212 */,
/* 213 */
/***/ function(module, exports) {

"use strict";
'use strict';

function oldAdd(element, className) {
  var classes = element.className.split(' ');
  if (classes.indexOf(className) < 0) {
    classes.push(className);
  }
  element.className = classes.join(' ');
}

function oldRemove(element, className) {
  var classes = element.className.split(' ');
  var idx = classes.indexOf(className);
  if (idx >= 0) {
    classes.splice(idx, 1);
  }
  element.className = classes.join(' ');
}

exports.add = function (element, className) {
  if (element.classList) {
    element.classList.add(className);
  } else {
    oldAdd(element, className);
  }
};

exports.remove = function (element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else {
    oldRemove(element, className);
  }
};

exports.list = function (element) {
  if (element.classList) {
    return Array.prototype.slice.apply(element.classList);
  } else {
    return element.className.split(' ');
  }
};


/***/ },
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony reexport (binding) */ __webpack_require__.d(exports, "FormGroupName", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_forms__ = __webpack_require__(599);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "AbstractControlDirective", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "AbstractFormGroupDirective", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "CheckboxControlValueAccessor", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "ControlContainer", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "NG_VALUE_ACCESSOR", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "DefaultValueAccessor", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "NgControl", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "NgControlStatus", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["i"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "NgControlStatusGroup", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["j"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "NgForm", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["k"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "NgModel", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["l"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "NgModelGroup", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["m"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "RadioControlValueAccessor", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["n"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "FormControlDirective", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["o"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "FormControlName", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["p"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "FormGroupDirective", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["q"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "FormArrayName", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["r"]; });
Object.defineProperty(exports, "__esModule", { value: true });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "NgSelectOption", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["s"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "SelectControlValueAccessor", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["t"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "SelectMultipleControlValueAccessor", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["u"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "CheckboxRequiredValidator", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["v"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "MaxLengthValidator", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["w"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "MinLengthValidator", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["x"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "PatternValidator", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["y"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "RequiredValidator", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["z"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "FormBuilder", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["A"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "AbstractControl", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["B"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "FormArray", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["C"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "FormControl", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["D"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "FormGroup", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["E"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "NG_ASYNC_VALIDATORS", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["F"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "NG_VALIDATORS", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["G"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "Validators", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["H"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "VERSION", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["I"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "FormsModule", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["J"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "ReactiveFormsModule", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["K"]; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @module
 * @description
 * Entry point for all public APIs of the forms package.
 */

//# sourceMappingURL=index.js.map

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return AbstractControlDirective; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Base class for control directives.
 *
 * Only used internally in the forms module.
 *
 * \@stable
 * @abstract
 */
var AbstractControlDirective = (function () {
    function AbstractControlDirective() {
    }
    Object.defineProperty(AbstractControlDirective.prototype, "control", {
        /**
         * @return {?}
         */
        get: function () { throw new Error('unimplemented'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "value", {
        /**
         * @return {?}
         */
        get: function () { return this.control ? this.control.value : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "valid", {
        /**
         * @return {?}
         */
        get: function () { return this.control ? this.control.valid : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "invalid", {
        /**
         * @return {?}
         */
        get: function () { return this.control ? this.control.invalid : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "pending", {
        /**
         * @return {?}
         */
        get: function () { return this.control ? this.control.pending : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "errors", {
        /**
         * @return {?}
         */
        get: function () { return this.control ? this.control.errors : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "pristine", {
        /**
         * @return {?}
         */
        get: function () { return this.control ? this.control.pristine : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "dirty", {
        /**
         * @return {?}
         */
        get: function () { return this.control ? this.control.dirty : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "touched", {
        /**
         * @return {?}
         */
        get: function () { return this.control ? this.control.touched : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "untouched", {
        /**
         * @return {?}
         */
        get: function () { return this.control ? this.control.untouched : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "disabled", {
        /**
         * @return {?}
         */
        get: function () { return this.control ? this.control.disabled : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "enabled", {
        /**
         * @return {?}
         */
        get: function () { return this.control ? this.control.enabled : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "statusChanges", {
        /**
         * @return {?}
         */
        get: function () { return this.control ? this.control.statusChanges : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "valueChanges", {
        /**
         * @return {?}
         */
        get: function () { return this.control ? this.control.valueChanges : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "path", {
        /**
         * @return {?}
         */
        get: function () { return null; },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?=} value
     * @return {?}
     */
    AbstractControlDirective.prototype.reset = function (value) {
        if (value === void 0) { value = undefined; }
        if (this.control)
            this.control.reset(value);
    };
    /**
     * @param {?} errorCode
     * @param {?=} path
     * @return {?}
     */
    AbstractControlDirective.prototype.hasError = function (errorCode, path) {
        if (path === void 0) { path = null; }
        return this.control ? this.control.hasError(errorCode, path) : false;
    };
    /**
     * @param {?} errorCode
     * @param {?=} path
     * @return {?}
     */
    AbstractControlDirective.prototype.getError = function (errorCode, path) {
        if (path === void 0) { path = null; }
        return this.control ? this.control.getError(errorCode, path) : null;
    };
    return AbstractControlDirective;
}());
//# sourceMappingURL=abstract_control_directive.js.map

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__control_container__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ng_control__ = __webpack_require__(97);
/* unused harmony export AbstractControlStatus */
/* unused harmony export ngControlStatusHost */
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return NgControlStatus; });
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return NgControlStatusGroup; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};



var AbstractControlStatus = (function () {
    /**
     * @param {?} cd
     */
    function AbstractControlStatus(cd) {
        this._cd = cd;
    }
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassUntouched", {
        /**
         * @return {?}
         */
        get: function () { return this._cd.control ? this._cd.control.untouched : false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassTouched", {
        /**
         * @return {?}
         */
        get: function () { return this._cd.control ? this._cd.control.touched : false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassPristine", {
        /**
         * @return {?}
         */
        get: function () { return this._cd.control ? this._cd.control.pristine : false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassDirty", {
        /**
         * @return {?}
         */
        get: function () { return this._cd.control ? this._cd.control.dirty : false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassValid", {
        /**
         * @return {?}
         */
        get: function () { return this._cd.control ? this._cd.control.valid : false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassInvalid", {
        /**
         * @return {?}
         */
        get: function () { return this._cd.control ? this._cd.control.invalid : false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassPending", {
        /**
         * @return {?}
         */
        get: function () { return this._cd.control ? this._cd.control.pending : false; },
        enumerable: true,
        configurable: true
    });
    return AbstractControlStatus;
}());
function AbstractControlStatus_tsickle_Closure_declarations() {
    /** @type {?} */
    AbstractControlStatus.prototype._cd;
}
var /** @type {?} */ ngControlStatusHost = {
    '[class.ng-untouched]': 'ngClassUntouched',
    '[class.ng-touched]': 'ngClassTouched',
    '[class.ng-pristine]': 'ngClassPristine',
    '[class.ng-dirty]': 'ngClassDirty',
    '[class.ng-valid]': 'ngClassValid',
    '[class.ng-invalid]': 'ngClassInvalid',
    '[class.ng-pending]': 'ngClassPending',
};
/**
 * Directive automatically applied to Angular form controls that sets CSS classes
 * based on control status (valid/invalid/dirty/etc).
 *
 * \@stable
 */
var NgControlStatus = (function (_super) {
    __extends(NgControlStatus, _super);
    /**
     * @param {?} cd
     */
    function NgControlStatus(cd) {
        _super.call(this, cd);
    }
    NgControlStatus.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[formControlName],[ngModel],[formControl]', host: ngControlStatusHost },] },
    ];
    /** @nocollapse */
    NgControlStatus.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_2__ng_control__["a" /* NgControl */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] },] },
    ]; };
    return NgControlStatus;
}(AbstractControlStatus));
function NgControlStatus_tsickle_Closure_declarations() {
    /** @type {?} */
    NgControlStatus.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    NgControlStatus.ctorParameters;
}
/**
 * Directive automatically applied to Angular form groups that sets CSS classes
 * based on control status (valid/invalid/dirty/etc).
 *
 * \@stable
 */
var NgControlStatusGroup = (function (_super) {
    __extends(NgControlStatusGroup, _super);
    /**
     * @param {?} cd
     */
    function NgControlStatusGroup(cd) {
        _super.call(this, cd);
    }
    NgControlStatusGroup.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: '[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]',
                    host: ngControlStatusHost
                },] },
    ];
    /** @nocollapse */
    NgControlStatusGroup.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__control_container__["a" /* ControlContainer */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] },] },
    ]; };
    return NgControlStatusGroup;
}(AbstractControlStatus));
function NgControlStatusGroup_tsickle_Closure_declarations() {
    /** @type {?} */
    NgControlStatusGroup.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    NgControlStatusGroup.ctorParameters;
}
//# sourceMappingURL=ng_control_status.js.map

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_async__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__validators__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__abstract_form_group_directive__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__control_container__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__control_value_accessor__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ng_control__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ng_form__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ng_model_group__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__template_driven_errors__ = __webpack_require__(389);
/* unused harmony export formControlBinding */
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return NgModel; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};












var /** @type {?} */ formControlBinding = {
    provide: __WEBPACK_IMPORTED_MODULE_7__ng_control__["a" /* NgControl */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return NgModel; })
};
/**
 * `ngModel` forces an additional change detection run when its inputs change:
 * E.g.:
 * ```
 * <div>{{myModel.valid}}</div>
 * <input [(ngModel)]="myValue" #myModel="ngModel">
 * ```
 * I.e. `ngModel` can export itself on the element and then be used in the template.
 * Normally, this would result in expressions before the `input` that use the exported directive
 * to have and old value as they have been
 * dirty checked before. As this is a very common case for `ngModel`, we added this second change
 * detection run.
 *
 * Notes:
 * - this is just one extra run no matter how many `ngModel` have been changed.
 * - this is a general problem when using `exportAs` for directives!
 */
var /** @type {?} */ resolvedPromise = Promise.resolve(null);
/**
 * \@whatItDoes Creates a {\@link FormControl} instance from a domain model and binds it
 * to a form control element.
 *
 * The {\@link FormControl} instance will track the value, user interaction, and
 * validation status of the control and keep the view synced with the model. If used
 * within a parent form, the directive will also register itself with the form as a child
 * control.
 *
 * \@howToUse
 *
 * This directive can be used by itself or as part of a larger form. All you need is the
 * `ngModel` selector to activate it.
 *
 * It accepts a domain model as an optional {\@link \@Input}. If you have a one-way binding
 * to `ngModel` with `[]` syntax, changing the value of the domain model in the component
 * class will set the value in the view. If you have a two-way binding with `[()]` syntax
 * (also known as 'banana-box syntax'), the value in the UI will always be synced back to
 * the domain model in your class as well.
 *
 * If you wish to inspect the properties of the associated {\@link FormControl} (like
 * validity state), you can also export the directive into a local template variable using
 * `ngModel` as the key (ex: `#myVar="ngModel"`). You can then access the control using the
 * directive's `control` property, but most properties you'll need (like `valid` and `dirty`)
 * will fall through to the control anyway, so you can access them directly. You can see a
 * full list of properties directly available in {\@link AbstractControlDirective}.
 *
 * The following is an example of a simple standalone control using `ngModel`:
 *
 * {\@example forms/ts/simpleNgModel/simple_ng_model_example.ts region='Component'}
 *
 * When using the `ngModel` within `<form>` tags, you'll also need to supply a `name` attribute
 * so that the control can be registered with the parent form under that name.
 *
 * It's worth noting that in the context of a parent form, you often can skip one-way or
 * two-way binding because the parent form will sync the value for you. You can access
 * its properties by exporting it into a local template variable using `ngForm` (ex:
 * `#f="ngForm"`). Then you can pass it where it needs to go on submit.
 *
 * If you do need to populate initial values into your form, using a one-way binding for
 * `ngModel` tends to be sufficient as long as you use the exported form's value rather
 * than the domain model's value on submit.
 *
 * Take a look at an example of using `ngModel` within a form:
 *
 * {\@example forms/ts/simpleForm/simple_form_example.ts region='Component'}
 *
 * To see `ngModel` examples with different form control types, see:
 *
 * * Radio buttons: {\@link RadioControlValueAccessor}
 * * Selects: {\@link SelectControlValueAccessor}
 *
 * **npm package**: `\@angular/forms`
 *
 * **NgModule**: `FormsModule`
 *
 *  \@stable
 */
var NgModel = (function (_super) {
    __extends(NgModel, _super);
    /**
     * @param {?} parent
     * @param {?} validators
     * @param {?} asyncValidators
     * @param {?} valueAccessors
     */
    function NgModel(parent, validators, asyncValidators, valueAccessors) {
        _super.call(this);
        /** @internal */
        this._control = new __WEBPACK_IMPORTED_MODULE_2__model__["b" /* FormControl */]();
        /** @internal */
        this._registered = false;
        this.update = new __WEBPACK_IMPORTED_MODULE_1__facade_async__["a" /* EventEmitter */]();
        this._parent = parent;
        this._rawValidators = validators || [];
        this._rawAsyncValidators = asyncValidators || [];
        this.valueAccessor = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__shared__["f" /* selectValueAccessor */])(this, valueAccessors);
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    NgModel.prototype.ngOnChanges = function (changes) {
        this._checkForErrors();
        if (!this._registered)
            this._setUpControl();
        if ('isDisabled' in changes) {
            this._updateDisabled(changes);
        }
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__shared__["g" /* isPropertyUpdated */])(changes, this.viewModel)) {
            this._updateValue(this.model);
            this.viewModel = this.model;
        }
    };
    /**
     * @return {?}
     */
    NgModel.prototype.ngOnDestroy = function () { this.formDirective && this.formDirective.removeControl(this); };
    Object.defineProperty(NgModel.prototype, "control", {
        /**
         * @return {?}
         */
        get: function () { return this._control; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgModel.prototype, "path", {
        /**
         * @return {?}
         */
        get: function () {
            return this._parent ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__shared__["a" /* controlPath */])(this.name, this._parent) : [this.name];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgModel.prototype, "formDirective", {
        /**
         * @return {?}
         */
        get: function () { return this._parent ? this._parent.formDirective : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgModel.prototype, "validator", {
        /**
         * @return {?}
         */
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__shared__["b" /* composeValidators */])(this._rawValidators); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgModel.prototype, "asyncValidator", {
        /**
         * @return {?}
         */
        get: function () {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__shared__["c" /* composeAsyncValidators */])(this._rawAsyncValidators);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} newValue
     * @return {?}
     */
    NgModel.prototype.viewToModelUpdate = function (newValue) {
        this.viewModel = newValue;
        this.update.emit(newValue);
    };
    /**
     * @return {?}
     */
    NgModel.prototype._setUpControl = function () {
        this._isStandalone() ? this._setUpStandalone() :
            this.formDirective.addControl(this);
        this._registered = true;
    };
    /**
     * @return {?}
     */
    NgModel.prototype._isStandalone = function () {
        return !this._parent || (this.options && this.options.standalone);
    };
    /**
     * @return {?}
     */
    NgModel.prototype._setUpStandalone = function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__shared__["d" /* setUpControl */])(this._control, this);
        this._control.updateValueAndValidity({ emitEvent: false });
    };
    /**
     * @return {?}
     */
    NgModel.prototype._checkForErrors = function () {
        if (!this._isStandalone()) {
            this._checkParentType();
        }
        this._checkName();
    };
    /**
     * @return {?}
     */
    NgModel.prototype._checkParentType = function () {
        if (!(this._parent instanceof __WEBPACK_IMPORTED_MODULE_9__ng_model_group__["a" /* NgModelGroup */]) &&
            this._parent instanceof __WEBPACK_IMPORTED_MODULE_4__abstract_form_group_directive__["a" /* AbstractFormGroupDirective */]) {
            __WEBPACK_IMPORTED_MODULE_11__template_driven_errors__["a" /* TemplateDrivenErrors */].formGroupNameException();
        }
        else if (!(this._parent instanceof __WEBPACK_IMPORTED_MODULE_9__ng_model_group__["a" /* NgModelGroup */]) && !(this._parent instanceof __WEBPACK_IMPORTED_MODULE_8__ng_form__["a" /* NgForm */])) {
            __WEBPACK_IMPORTED_MODULE_11__template_driven_errors__["a" /* TemplateDrivenErrors */].modelParentException();
        }
    };
    /**
     * @return {?}
     */
    NgModel.prototype._checkName = function () {
        if (this.options && this.options.name)
            this.name = this.options.name;
        if (!this._isStandalone() && !this.name) {
            __WEBPACK_IMPORTED_MODULE_11__template_driven_errors__["a" /* TemplateDrivenErrors */].missingNameException();
        }
    };
    /**
     * @param {?} value
     * @return {?}
     */
    NgModel.prototype._updateValue = function (value) {
        var _this = this;
        resolvedPromise.then(function () { _this.control.setValue(value, { emitViewToModelChange: false }); });
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    NgModel.prototype._updateDisabled = function (changes) {
        var _this = this;
        var /** @type {?} */ disabledValue = changes['isDisabled'].currentValue;
        var /** @type {?} */ isDisabled = disabledValue === '' || (disabledValue && disabledValue !== 'false');
        resolvedPromise.then(function () {
            if (isDisabled && !_this.control.disabled) {
                _this.control.disable();
            }
            else if (!isDisabled && _this.control.disabled) {
                _this.control.enable();
            }
        });
    };
    NgModel.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: '[ngModel]:not([formControlName]):not([formControl])',
                    providers: [formControlBinding],
                    exportAs: 'ngModel'
                },] },
    ];
    /** @nocollapse */
    NgModel.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_5__control_container__["a" /* ControlContainer */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Host"] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_3__validators__["b" /* NG_VALIDATORS */],] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_3__validators__["c" /* NG_ASYNC_VALIDATORS */],] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_6__control_value_accessor__["a" /* NG_VALUE_ACCESSOR */],] },] },
    ]; };
    NgModel.propDecorators = {
        'name': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'isDisabled': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['disabled',] },],
        'model': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngModel',] },],
        'options': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngModelOptions',] },],
        'update': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"], args: ['ngModelChange',] },],
    };
    return NgModel;
}(__WEBPACK_IMPORTED_MODULE_7__ng_control__["a" /* NgControl */]));
function NgModel_tsickle_Closure_declarations() {
    /** @type {?} */
    NgModel.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    NgModel.ctorParameters;
    /** @type {?} */
    NgModel.propDecorators;
    /**
     * \@internal
     * @type {?}
     */
    NgModel.prototype._control;
    /**
     * \@internal
     * @type {?}
     */
    NgModel.prototype._registered;
    /** @type {?} */
    NgModel.prototype.viewModel;
    /** @type {?} */
    NgModel.prototype.name;
    /** @type {?} */
    NgModel.prototype.isDisabled;
    /** @type {?} */
    NgModel.prototype.model;
    /** @type {?} */
    NgModel.prototype.options;
    /** @type {?} */
    NgModel.prototype.update;
}
//# sourceMappingURL=ng_model.js.map

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__control_value_accessor__ = __webpack_require__(42);
/* unused harmony export NUMBER_VALUE_ACCESSOR */
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return NumberValueAccessor; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


var /** @type {?} */ NUMBER_VALUE_ACCESSOR = {
    provide: __WEBPACK_IMPORTED_MODULE_1__control_value_accessor__["a" /* NG_VALUE_ACCESSOR */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return NumberValueAccessor; }),
    multi: true
};
/**
 * The accessor for writing a number value and listening to changes that is used by the
 * {\@link NgModel}, {\@link FormControlDirective}, and {\@link FormControlName} directives.
 *
 *  ### Example
 *  ```
 *  <input type="number" [(ngModel)]="age">
 *  ```
 */
var NumberValueAccessor = (function () {
    /**
     * @param {?} _renderer
     * @param {?} _elementRef
     */
    function NumberValueAccessor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this.onChange = function (_) { };
        this.onTouched = function () { };
    }
    /**
     * @param {?} value
     * @return {?}
     */
    NumberValueAccessor.prototype.writeValue = function (value) {
        // The value needs to be normalized for IE9, otherwise it is set to 'null' when null
        var /** @type {?} */ normalizedValue = value == null ? '' : value;
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'value', normalizedValue);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    NumberValueAccessor.prototype.registerOnChange = function (fn) {
        this.onChange = function (value) { fn(value == '' ? null : parseFloat(value)); };
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    NumberValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    NumberValueAccessor.prototype.setDisabledState = function (isDisabled) {
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    NumberValueAccessor.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'input[type=number][formControlName],input[type=number][formControl],input[type=number][ngModel]',
                    host: {
                        '(change)': 'onChange($event.target.value)',
                        '(input)': 'onChange($event.target.value)',
                        '(blur)': 'onTouched()'
                    },
                    providers: [NUMBER_VALUE_ACCESSOR]
                },] },
    ];
    /** @nocollapse */
    NumberValueAccessor.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    ]; };
    return NumberValueAccessor;
}());
function NumberValueAccessor_tsickle_Closure_declarations() {
    /** @type {?} */
    NumberValueAccessor.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    NumberValueAccessor.ctorParameters;
    /** @type {?} */
    NumberValueAccessor.prototype.onChange;
    /** @type {?} */
    NumberValueAccessor.prototype.onTouched;
    /** @type {?} */
    NumberValueAccessor.prototype._renderer;
    /** @type {?} */
    NumberValueAccessor.prototype._elementRef;
}
//# sourceMappingURL=number_value_accessor.js.map

/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__control_value_accessor__ = __webpack_require__(42);
/* unused harmony export RANGE_VALUE_ACCESSOR */
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return RangeValueAccessor; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


var /** @type {?} */ RANGE_VALUE_ACCESSOR = {
    provide: __WEBPACK_IMPORTED_MODULE_1__control_value_accessor__["a" /* NG_VALUE_ACCESSOR */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return RangeValueAccessor; }),
    multi: true
};
/**
 * The accessor for writing a range value and listening to changes that is used by the
 * {\@link NgModel}, {\@link FormControlDirective}, and {\@link FormControlName} directives.
 *
 *  ### Example
 *  ```
 *  <input type="range" [(ngModel)]="age" >
 *  ```
 */
var RangeValueAccessor = (function () {
    /**
     * @param {?} _renderer
     * @param {?} _elementRef
     */
    function RangeValueAccessor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this.onChange = function (_) { };
        this.onTouched = function () { };
    }
    /**
     * @param {?} value
     * @return {?}
     */
    RangeValueAccessor.prototype.writeValue = function (value) {
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'value', parseFloat(value));
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    RangeValueAccessor.prototype.registerOnChange = function (fn) {
        this.onChange = function (value) { fn(value == '' ? null : parseFloat(value)); };
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    RangeValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    RangeValueAccessor.prototype.setDisabledState = function (isDisabled) {
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    RangeValueAccessor.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'input[type=range][formControlName],input[type=range][formControl],input[type=range][ngModel]',
                    host: {
                        '(change)': 'onChange($event.target.value)',
                        '(input)': 'onChange($event.target.value)',
                        '(blur)': 'onTouched()'
                    },
                    providers: [RANGE_VALUE_ACCESSOR]
                },] },
    ];
    /** @nocollapse */
    RangeValueAccessor.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    ]; };
    return RangeValueAccessor;
}());
function RangeValueAccessor_tsickle_Closure_declarations() {
    /** @type {?} */
    RangeValueAccessor.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    RangeValueAccessor.ctorParameters;
    /** @type {?} */
    RangeValueAccessor.prototype.onChange;
    /** @type {?} */
    RangeValueAccessor.prototype.onTouched;
    /** @type {?} */
    RangeValueAccessor.prototype._renderer;
    /** @type {?} */
    RangeValueAccessor.prototype._elementRef;
}
//# sourceMappingURL=range_value_accessor.js.map

/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_async__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__validators__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__control_value_accessor__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ng_control__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reactive_errors__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared__ = __webpack_require__(78);
/* unused harmony export formControlBinding */
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return FormControlDirective; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};







var /** @type {?} */ formControlBinding = {
    provide: __WEBPACK_IMPORTED_MODULE_4__ng_control__["a" /* NgControl */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return FormControlDirective; })
};
/**
 * \@whatItDoes Syncs a standalone {\@link FormControl} instance to a form control element.
 *
 * In other words, this directive ensures that any values written to the {\@link FormControl}
 * instance programmatically will be written to the DOM element (model -> view). Conversely,
 * any values written to the DOM element through user input will be reflected in the
 * {\@link FormControl} instance (view -> model).
 *
 * \@howToUse
 *
 * Use this directive if you'd like to create and manage a {\@link FormControl} instance directly.
 * Simply create a {\@link FormControl}, save it to your component class, and pass it into the
 * {\@link FormControlDirective}.
 *
 * This directive is designed to be used as a standalone control.  Unlike {\@link FormControlName},
 * it does not require that your {\@link FormControl} instance be part of any parent
 * {\@link FormGroup}, and it won't be registered to any {\@link FormGroupDirective} that
 * exists above it.
 *
 * **Get the value**: the `value` property is always synced and available on the
 * {\@link FormControl} instance. See a full list of available properties in
 * {\@link AbstractControl}.
 *
 * **Set the value**: You can pass in an initial value when instantiating the {\@link FormControl},
 * or you can set it programmatically later using {\@link AbstractControl.setValue} or
 * {\@link AbstractControl.patchValue}.
 *
 * **Listen to value**: If you want to listen to changes in the value of the control, you can
 * subscribe to the {\@link AbstractControl.valueChanges} event.  You can also listen to
 * {\@link AbstractControl.statusChanges} to be notified when the validation status is
 * re-calculated.
 *
 * ### Example
 *
 * {\@example forms/ts/simpleFormControl/simple_form_control_example.ts region='Component'}
 *
 * * **npm package**: `\@angular/forms`
 *
 * * **NgModule**: `ReactiveFormsModule`
 *
 *  \@stable
 */
var FormControlDirective = (function (_super) {
    __extends(FormControlDirective, _super);
    /**
     * @param {?} validators
     * @param {?} asyncValidators
     * @param {?} valueAccessors
     */
    function FormControlDirective(validators, asyncValidators, valueAccessors) {
        _super.call(this);
        this.update = new __WEBPACK_IMPORTED_MODULE_1__facade_async__["a" /* EventEmitter */]();
        this._rawValidators = validators || [];
        this._rawAsyncValidators = asyncValidators || [];
        this.valueAccessor = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared__["f" /* selectValueAccessor */])(this, valueAccessors);
    }
    Object.defineProperty(FormControlDirective.prototype, "isDisabled", {
        /**
         * @param {?} isDisabled
         * @return {?}
         */
        set: function (isDisabled) { __WEBPACK_IMPORTED_MODULE_5__reactive_errors__["a" /* ReactiveErrors */].disabledAttrWarning(); },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} changes
     * @return {?}
     */
    FormControlDirective.prototype.ngOnChanges = function (changes) {
        if (this._isControlChanged(changes)) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared__["d" /* setUpControl */])(this.form, this);
            if (this.control.disabled && this.valueAccessor.setDisabledState) {
                this.valueAccessor.setDisabledState(true);
            }
            this.form.updateValueAndValidity({ emitEvent: false });
        }
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared__["g" /* isPropertyUpdated */])(changes, this.viewModel)) {
            this.form.setValue(this.model);
            this.viewModel = this.model;
        }
    };
    Object.defineProperty(FormControlDirective.prototype, "path", {
        /**
         * @return {?}
         */
        get: function () { return []; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlDirective.prototype, "validator", {
        /**
         * @return {?}
         */
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared__["b" /* composeValidators */])(this._rawValidators); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlDirective.prototype, "asyncValidator", {
        /**
         * @return {?}
         */
        get: function () {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared__["c" /* composeAsyncValidators */])(this._rawAsyncValidators);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlDirective.prototype, "control", {
        /**
         * @return {?}
         */
        get: function () { return this.form; },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} newValue
     * @return {?}
     */
    FormControlDirective.prototype.viewToModelUpdate = function (newValue) {
        this.viewModel = newValue;
        this.update.emit(newValue);
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    FormControlDirective.prototype._isControlChanged = function (changes) {
        return changes.hasOwnProperty('form');
    };
    FormControlDirective.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[formControl]', providers: [formControlBinding], exportAs: 'ngForm' },] },
    ];
    /** @nocollapse */
    FormControlDirective.ctorParameters = function () { return [
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_2__validators__["b" /* NG_VALIDATORS */],] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_2__validators__["c" /* NG_ASYNC_VALIDATORS */],] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_3__control_value_accessor__["a" /* NG_VALUE_ACCESSOR */],] },] },
    ]; };
    FormControlDirective.propDecorators = {
        'form': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['formControl',] },],
        'model': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngModel',] },],
        'update': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"], args: ['ngModelChange',] },],
        'isDisabled': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['disabled',] },],
    };
    return FormControlDirective;
}(__WEBPACK_IMPORTED_MODULE_4__ng_control__["a" /* NgControl */]));
function FormControlDirective_tsickle_Closure_declarations() {
    /** @type {?} */
    FormControlDirective.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    FormControlDirective.ctorParameters;
    /** @type {?} */
    FormControlDirective.propDecorators;
    /** @type {?} */
    FormControlDirective.prototype.viewModel;
    /** @type {?} */
    FormControlDirective.prototype.form;
    /** @type {?} */
    FormControlDirective.prototype.model;
    /** @type {?} */
    FormControlDirective.prototype.update;
}
//# sourceMappingURL=form_control_directive.js.map

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_async__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__validators__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__abstract_form_group_directive__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__control_container__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__control_value_accessor__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ng_control__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__reactive_errors__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__form_group_directive__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__form_group_name__ = __webpack_require__(142);
/* unused harmony export controlNameBinding */
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return FormControlName; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};











var /** @type {?} */ controlNameBinding = {
    provide: __WEBPACK_IMPORTED_MODULE_6__ng_control__["a" /* NgControl */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return FormControlName; })
};
/**
 * \@whatItDoes Syncs a {\@link FormControl} in an existing {\@link FormGroup} to a form control
 * element by name.
 *
 * In other words, this directive ensures that any values written to the {\@link FormControl}
 * instance programmatically will be written to the DOM element (model -> view). Conversely,
 * any values written to the DOM element through user input will be reflected in the
 * {\@link FormControl} instance (view -> model).
 *
 * \@howToUse
 *
 * This directive is designed to be used with a parent {\@link FormGroupDirective} (selector:
 * `[formGroup]`).
 *
 * It accepts the string name of the {\@link FormControl} instance you want to
 * link, and will look for a {\@link FormControl} registered with that name in the
 * closest {\@link FormGroup} or {\@link FormArray} above it.
 *
 * **Access the control**: You can access the {\@link FormControl} associated with
 * this directive by using the {\@link AbstractControl.get} method.
 * Ex: `this.form.get('first');`
 *
 * **Get value**: the `value` property is always synced and available on the {\@link FormControl}.
 * See a full list of available properties in {\@link AbstractControl}.
 *
 *  **Set value**: You can set an initial value for the control when instantiating the
 *  {\@link FormControl}, or you can set it programmatically later using
 *  {\@link AbstractControl.setValue} or {\@link AbstractControl.patchValue}.
 *
 * **Listen to value**: If you want to listen to changes in the value of the control, you can
 * subscribe to the {\@link AbstractControl.valueChanges} event.  You can also listen to
 * {\@link AbstractControl.statusChanges} to be notified when the validation status is
 * re-calculated.
 *
 * ### Example
 *
 * In this example, we create form controls for first name and last name.
 *
 * {\@example forms/ts/simpleFormGroup/simple_form_group_example.ts region='Component'}
 *
 * To see `formControlName` examples with different form control types, see:
 *
 * * Radio buttons: {\@link RadioControlValueAccessor}
 * * Selects: {\@link SelectControlValueAccessor}
 *
 * **npm package**: `\@angular/forms`
 *
 * **NgModule**: {\@link ReactiveFormsModule}
 *
 *  \@stable
 */
var FormControlName = (function (_super) {
    __extends(FormControlName, _super);
    /**
     * @param {?} parent
     * @param {?} validators
     * @param {?} asyncValidators
     * @param {?} valueAccessors
     */
    function FormControlName(parent, validators, asyncValidators, valueAccessors) {
        _super.call(this);
        this._added = false;
        this.update = new __WEBPACK_IMPORTED_MODULE_1__facade_async__["a" /* EventEmitter */]();
        this._parent = parent;
        this._rawValidators = validators || [];
        this._rawAsyncValidators = asyncValidators || [];
        this.valueAccessor = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared__["f" /* selectValueAccessor */])(this, valueAccessors);
    }
    Object.defineProperty(FormControlName.prototype, "isDisabled", {
        /**
         * @param {?} isDisabled
         * @return {?}
         */
        set: function (isDisabled) { __WEBPACK_IMPORTED_MODULE_7__reactive_errors__["a" /* ReactiveErrors */].disabledAttrWarning(); },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} changes
     * @return {?}
     */
    FormControlName.prototype.ngOnChanges = function (changes) {
        if (!this._added)
            this._setUpControl();
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared__["g" /* isPropertyUpdated */])(changes, this.viewModel)) {
            this.viewModel = this.model;
            this.formDirective.updateModel(this, this.model);
        }
    };
    /**
     * @return {?}
     */
    FormControlName.prototype.ngOnDestroy = function () {
        if (this.formDirective) {
            this.formDirective.removeControl(this);
        }
    };
    /**
     * @param {?} newValue
     * @return {?}
     */
    FormControlName.prototype.viewToModelUpdate = function (newValue) {
        this.viewModel = newValue;
        this.update.emit(newValue);
    };
    Object.defineProperty(FormControlName.prototype, "path", {
        /**
         * @return {?}
         */
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared__["a" /* controlPath */])(this.name, this._parent); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlName.prototype, "formDirective", {
        /**
         * @return {?}
         */
        get: function () { return this._parent ? this._parent.formDirective : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlName.prototype, "validator", {
        /**
         * @return {?}
         */
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared__["b" /* composeValidators */])(this._rawValidators); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlName.prototype, "asyncValidator", {
        /**
         * @return {?}
         */
        get: function () {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared__["c" /* composeAsyncValidators */])(this._rawAsyncValidators);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlName.prototype, "control", {
        /**
         * @return {?}
         */
        get: function () { return this._control; },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    FormControlName.prototype._checkParentType = function () {
        if (!(this._parent instanceof __WEBPACK_IMPORTED_MODULE_10__form_group_name__["a" /* FormGroupName */]) &&
            this._parent instanceof __WEBPACK_IMPORTED_MODULE_3__abstract_form_group_directive__["a" /* AbstractFormGroupDirective */]) {
            __WEBPACK_IMPORTED_MODULE_7__reactive_errors__["a" /* ReactiveErrors */].ngModelGroupException();
        }
        else if (!(this._parent instanceof __WEBPACK_IMPORTED_MODULE_10__form_group_name__["a" /* FormGroupName */]) && !(this._parent instanceof __WEBPACK_IMPORTED_MODULE_9__form_group_directive__["a" /* FormGroupDirective */]) &&
            !(this._parent instanceof __WEBPACK_IMPORTED_MODULE_10__form_group_name__["b" /* FormArrayName */])) {
            __WEBPACK_IMPORTED_MODULE_7__reactive_errors__["a" /* ReactiveErrors */].controlParentException();
        }
    };
    /**
     * @return {?}
     */
    FormControlName.prototype._setUpControl = function () {
        this._checkParentType();
        this._control = this.formDirective.addControl(this);
        if (this.control.disabled && this.valueAccessor.setDisabledState) {
            this.valueAccessor.setDisabledState(true);
        }
        this._added = true;
    };
    FormControlName.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[formControlName]', providers: [controlNameBinding] },] },
    ];
    /** @nocollapse */
    FormControlName.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_4__control_container__["a" /* ControlContainer */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Host"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["SkipSelf"] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_2__validators__["b" /* NG_VALIDATORS */],] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_2__validators__["c" /* NG_ASYNC_VALIDATORS */],] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_5__control_value_accessor__["a" /* NG_VALUE_ACCESSOR */],] },] },
    ]; };
    FormControlName.propDecorators = {
        'name': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['formControlName',] },],
        'model': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngModel',] },],
        'update': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"], args: ['ngModelChange',] },],
        'isDisabled': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['disabled',] },],
    };
    return FormControlName;
}(__WEBPACK_IMPORTED_MODULE_6__ng_control__["a" /* NgControl */]));
function FormControlName_tsickle_Closure_declarations() {
    /** @type {?} */
    FormControlName.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    FormControlName.ctorParameters;
    /** @type {?} */
    FormControlName.propDecorators;
    /** @type {?} */
    FormControlName.prototype._added;
    /**
     * \@internal
     * @type {?}
     */
    FormControlName.prototype.viewModel;
    /**
     * \@internal
     * @type {?}
     */
    FormControlName.prototype._control;
    /** @type {?} */
    FormControlName.prototype.name;
    /** @type {?} */
    FormControlName.prototype.model;
    /** @type {?} */
    FormControlName.prototype.update;
}
//# sourceMappingURL=form_control_name.js.map

/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

/**
 * @license Angular v2.4.10
 * (c) 2010-2017 Google, Inc. https://angular.io/
 * License: MIT
 */
(function (global, factory) {
     true ? factory(exports, __webpack_require__(0), __webpack_require__(43), __webpack_require__(153), __webpack_require__(15), __webpack_require__(498)) :
    typeof define === 'function' && define.amd ? define(['exports', '@angular/core', '@angular/http', 'rxjs/ReplaySubject', 'rxjs/Subject', 'rxjs/operator/take'], factory) :
    (factory((global.ng = global.ng || {}, global.ng.http = global.ng.http || {}, global.ng.http.testing = global.ng.http.testing || {}),global.ng.core,global.ng.http,global.Rx,global.Rx,global.Rx.Observable.prototype));
}(this, function (exports,_angular_core,_angular_http,rxjs_ReplaySubject,rxjs_Subject,rxjs_operator_take) { 'use strict';

    /**
     *
     * Mock Connection to represent a {@link Connection} for tests.
     *
     * @experimental
     */
    var MockConnection = (function () {
        function MockConnection(req) {
            this.response = rxjs_operator_take.take.call(new rxjs_ReplaySubject.ReplaySubject(1), 1);
            this.readyState = _angular_http.ReadyState.Open;
            this.request = req;
        }
        /**
         * Sends a mock response to the connection. This response is the value that is emitted to the
         * {@link EventEmitter} returned by {@link Http}.
         *
         * ### Example
         *
         * ```
         * var connection;
         * backend.connections.subscribe(c => connection = c);
         * http.request('data.json').subscribe(res => console.log(res.text()));
         * connection.mockRespond(new Response(new ResponseOptions({ body: 'fake response' }))); //logs
         * 'fake response'
         * ```
         *
         */
        MockConnection.prototype.mockRespond = function (res) {
            if (this.readyState === _angular_http.ReadyState.Done || this.readyState === _angular_http.ReadyState.Cancelled) {
                throw new Error('Connection has already been resolved');
            }
            this.readyState = _angular_http.ReadyState.Done;
            this.response.next(res);
            this.response.complete();
        };
        /**
         * Not yet implemented!
         *
         * Sends the provided {@link Response} to the `downloadObserver` of the `Request`
         * associated with this connection.
         */
        MockConnection.prototype.mockDownload = function (res) {
            // this.request.downloadObserver.onNext(res);
            // if (res.bytesLoaded === res.totalBytes) {
            //   this.request.downloadObserver.onCompleted();
            // }
        };
        // TODO(jeffbcross): consider using Response type
        /**
         * Emits the provided error object as an error to the {@link Response} {@link EventEmitter}
         * returned
         * from {@link Http}.
         *
         * ### Example
         *
         * ```
         * var connection;
         * backend.connections.subscribe(c => connection = c);
         * http.request('data.json').subscribe(res => res, err => console.log(err)));
         * connection.mockError(new Error('error'));
         * ```
         *
         */
        MockConnection.prototype.mockError = function (err) {
            // Matches ResourceLoader semantics
            this.readyState = _angular_http.ReadyState.Done;
            this.response.error(err);
        };
        return MockConnection;
    }());
    /**
     * A mock backend for testing the {@link Http} service.
     *
     * This class can be injected in tests, and should be used to override providers
     * to other backends, such as {@link XHRBackend}.
     *
     * ### Example
     *
     * ```
     * import {Injectable, ReflectiveInjector} from '@angular/core';
     * import {async, fakeAsync, tick} from '@angular/core/testing';
     * import {BaseRequestOptions, ConnectionBackend, Http, RequestOptions} from '@angular/http';
     * import {Response, ResponseOptions} from '@angular/http';
     * import {MockBackend, MockConnection} from '@angular/http/testing';
     *
     * const HERO_ONE = 'HeroNrOne';
     * const HERO_TWO = 'WillBeAlwaysTheSecond';
     *
     * @Injectable()
     * class HeroService {
     *   constructor(private http: Http) {}
     *
     *   getHeroes(): Promise<String[]> {
     *     return this.http.get('myservices.de/api/heroes')
     *         .toPromise()
     *         .then(response => response.json().data)
     *         .catch(e => this.handleError(e));
     *   }
     *
     *   private handleError(error: any): Promise<any> {
     *     console.error('An error occurred', error);
     *     return Promise.reject(error.message || error);
     *   }
     * }
     *
     * describe('MockBackend HeroService Example', () => {
     *   beforeEach(() => {
     *     this.injector = ReflectiveInjector.resolveAndCreate([
     *       {provide: ConnectionBackend, useClass: MockBackend},
     *       {provide: RequestOptions, useClass: BaseRequestOptions},
     *       Http,
     *       HeroService,
     *     ]);
     *     this.heroService = this.injector.get(HeroService);
     *     this.backend = this.injector.get(ConnectionBackend) as MockBackend;
     *     this.backend.connections.subscribe((connection: any) => this.lastConnection = connection);
     *   });
     *
     *   it('getHeroes() should query current service url', () => {
     *     this.heroService.getHeroes();
     *     expect(this.lastConnection).toBeDefined('no http service connection at all?');
     *     expect(this.lastConnection.request.url).toMatch(/api\/heroes$/, 'url invalid');
     *   });
     *
     *   it('getHeroes() should return some heroes', fakeAsync(() => {
     *        let result: String[];
     *        this.heroService.getHeroes().then((heroes: String[]) => result = heroes);
     *        this.lastConnection.mockRespond(new Response(new ResponseOptions({
     *          body: JSON.stringify({data: [HERO_ONE, HERO_TWO]}),
     *        })));
     *        tick();
     *        expect(result.length).toEqual(2, 'should contain given amount of heroes');
     *        expect(result[0]).toEqual(HERO_ONE, ' HERO_ONE should be the first hero');
     *        expect(result[1]).toEqual(HERO_TWO, ' HERO_TWO should be the second hero');
     *      }));
     *
     *   it('getHeroes() while server is down', fakeAsync(() => {
     *        let result: String[];
     *        let catchedError: any;
     *        this.heroService.getHeroes()
     *            .then((heroes: String[]) => result = heroes)
     *            .catch((error: any) => catchedError = error);
     *        this.lastConnection.mockRespond(new Response(new ResponseOptions({
     *          status: 404,
     *          statusText: 'URL not Found',
     *        })));
     *        tick();
     *        expect(result).toBeUndefined();
     *        expect(catchedError).toBeDefined();
     *      }));
     * });
     * ```
     *
     * This method only exists in the mock implementation, not in real Backends.
     *
     * @experimental
     */
    var MockBackend = (function () {
        function MockBackend() {
            var _this = this;
            this.connectionsArray = [];
            this.connections = new rxjs_Subject.Subject();
            this.connections.subscribe(function (connection) { return _this.connectionsArray.push(connection); });
            this.pendingConnections = new rxjs_Subject.Subject();
        }
        /**
         * Checks all connections, and raises an exception if any connection has not received a response.
         *
         * This method only exists in the mock implementation, not in real Backends.
         */
        MockBackend.prototype.verifyNoPendingRequests = function () {
            var pending = 0;
            this.pendingConnections.subscribe(function (c) { return pending++; });
            if (pending > 0)
                throw new Error(pending + " pending connections to be resolved");
        };
        /**
         * Can be used in conjunction with `verifyNoPendingRequests` to resolve any not-yet-resolve
         * connections, if it's expected that there are connections that have not yet received a response.
         *
         * This method only exists in the mock implementation, not in real Backends.
         */
        MockBackend.prototype.resolveAllConnections = function () { this.connections.subscribe(function (c) { return c.readyState = 4; }); };
        /**
         * Creates a new {@link MockConnection}. This is equivalent to calling `new
         * MockConnection()`, except that it also will emit the new `Connection` to the `connections`
         * emitter of this `MockBackend` instance. This method will usually only be used by tests
         * against the framework itself, not by end-users.
         */
        MockBackend.prototype.createConnection = function (req) {
            if (!req || !(req instanceof _angular_http.Request)) {
                throw new Error("createConnection requires an instance of Request, got " + req);
            }
            var connection = new MockConnection(req);
            this.connections.next(connection);
            return connection;
        };
        MockBackend.decorators = [
            { type: _angular_core.Injectable },
        ];
        /** @nocollapse */
        MockBackend.ctorParameters = function () { return []; };
        return MockBackend;
    }());

    exports.MockConnection = MockConnection;
    exports.MockBackend = MockBackend;

}));

/***/ },
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_common__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router_state__ = __webpack_require__(116);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return RouterLink; });
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return RouterLinkWithHref; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */




/**
 * \@whatItDoes Lets you link to specific parts of your app.
 *
 * \@howToUse
 *
 * Consider the following route configuration:
 * `[{ path: 'user/:name', component: UserCmp }]`
 *
 * When linking to this `user/:name` route, you can write:
 * `<a routerLink='/user/bob'>link to user component</a>`
 *
 * \@description
 *
 * The RouterLink directives let you link to specific parts of your app.
 *
 * When the link is static, you can use the directive as follows:
 * `<a routerLink="/user/bob">link to user component</a>`
 *
 * If you use dynamic values to generate the link, you can pass an array of path
 * segments, followed by the params for each segment.
 *
 * For instance `['/team', teamId, 'user', userName, {details: true}]`
 * means that we want to generate a link to `/team/11/user/bob;details=true`.
 *
 * Multiple static segments can be merged into one
 * (e.g., `['/team/11/user', userName, {details: true}]`).
 *
 * The first segment name can be prepended with `/`, `./`, or `../`:
 * * If the first segment begins with `/`, the router will look up the route from the root of the
 *   app.
 * * If the first segment begins with `./`, or doesn't begin with a slash, the router will
 *   instead look in the children of the current activated route.
 * * And if the first segment begins with `../`, the router will go up one level.
 *
 * You can set query params and fragment as follows:
 *
 * ```
 * <a [routerLink]="['/user/bob']" [queryParams]="{debug: true}" fragment="education">
 *   link to user component
 * </a>
 * ```
 * RouterLink will use these to generate this link: `/user/bob#education?debug=true`.
 *
 * You can also tell the directive to preserve the current query params and fragment:
 *
 * ```
 * <a [routerLink]="['/user/bob']" preserveQueryParams preserveFragment>
 *   link to user component
 * </a>
 * ```
 *
 * The router link directive always treats the provided input as a delta to the current url.
 *
 * For instance, if the current url is `/user/(box//aux:team)`.
 *
 * Then the following link `<a [routerLink]="['/user/jim']">Jim</a>` will generate the link
 * `/user/(jim//aux:team)`.
 *
 * \@ngModule RouterModule
 *
 * See {\@link Router.createUrlTree} for more information.
 *
 * \@stable
 */
var RouterLink = (function () {
    /**
     * @param {?} router
     * @param {?} route
     */
    function RouterLink(router, route) {
        this.router = router;
        this.route = route;
        this.commands = [];
    }
    Object.defineProperty(RouterLink.prototype, "routerLink", {
        /**
         * @param {?} commands
         * @return {?}
         */
        set: function (commands) {
            if (commands != null) {
                this.commands = Array.isArray(commands) ? commands : [commands];
            }
            else {
                this.commands = [];
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    RouterLink.prototype.onClick = function () {
        var /** @type {?} */ extras = {
            skipLocationChange: attrBoolValue(this.skipLocationChange),
            replaceUrl: attrBoolValue(this.replaceUrl),
        };
        this.router.navigateByUrl(this.urlTree, extras);
        return true;
    };
    Object.defineProperty(RouterLink.prototype, "urlTree", {
        /**
         * @return {?}
         */
        get: function () {
            return this.router.createUrlTree(this.commands, {
                relativeTo: this.route,
                queryParams: this.queryParams,
                fragment: this.fragment,
                preserveQueryParams: attrBoolValue(this.preserveQueryParams),
                preserveFragment: attrBoolValue(this.preserveFragment),
            });
        },
        enumerable: true,
        configurable: true
    });
    RouterLink.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{ selector: ':not(a)[routerLink]' },] },
    ];
    /** @nocollapse */
    RouterLink.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* Router */], },
        { type: __WEBPACK_IMPORTED_MODULE_3__router_state__["b" /* ActivatedRoute */], },
    ]; };
    RouterLink.propDecorators = {
        'queryParams': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
        'fragment': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
        'preserveQueryParams': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
        'preserveFragment': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
        'skipLocationChange': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
        'replaceUrl': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
        'routerLink': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
        'onClick': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["HostListener"], args: ['click',] },],
    };
    return RouterLink;
}());
function RouterLink_tsickle_Closure_declarations() {
    /** @type {?} */
    RouterLink.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    RouterLink.ctorParameters;
    /** @type {?} */
    RouterLink.propDecorators;
    /** @type {?} */
    RouterLink.prototype.queryParams;
    /** @type {?} */
    RouterLink.prototype.fragment;
    /** @type {?} */
    RouterLink.prototype.preserveQueryParams;
    /** @type {?} */
    RouterLink.prototype.preserveFragment;
    /** @type {?} */
    RouterLink.prototype.skipLocationChange;
    /** @type {?} */
    RouterLink.prototype.replaceUrl;
    /** @type {?} */
    RouterLink.prototype.commands;
    /** @type {?} */
    RouterLink.prototype.router;
    /** @type {?} */
    RouterLink.prototype.route;
}
/**
 * \@whatItDoes Lets you link to specific parts of your app.
 *
 * See {\@link RouterLink} for more information.
 *
 * \@ngModule RouterModule
 *
 * \@stable
 */
var RouterLinkWithHref = (function () {
    /**
     * @param {?} router
     * @param {?} route
     * @param {?} locationStrategy
     */
    function RouterLinkWithHref(router, route, locationStrategy) {
        var _this = this;
        this.router = router;
        this.route = route;
        this.locationStrategy = locationStrategy;
        this.commands = [];
        this.subscription = router.events.subscribe(function (s) {
            if (s instanceof __WEBPACK_IMPORTED_MODULE_2__router__["b" /* NavigationEnd */]) {
                _this.updateTargetUrlAndHref();
            }
        });
    }
    Object.defineProperty(RouterLinkWithHref.prototype, "routerLink", {
        /**
         * @param {?} commands
         * @return {?}
         */
        set: function (commands) {
            if (commands != null) {
                this.commands = Array.isArray(commands) ? commands : [commands];
            }
            else {
                this.commands = [];
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} changes
     * @return {?}
     */
    RouterLinkWithHref.prototype.ngOnChanges = function (changes) { this.updateTargetUrlAndHref(); };
    /**
     * @return {?}
     */
    RouterLinkWithHref.prototype.ngOnDestroy = function () { this.subscription.unsubscribe(); };
    /**
     * @param {?} button
     * @param {?} ctrlKey
     * @param {?} metaKey
     * @return {?}
     */
    RouterLinkWithHref.prototype.onClick = function (button, ctrlKey, metaKey) {
        if (button !== 0 || ctrlKey || metaKey) {
            return true;
        }
        if (typeof this.target === 'string' && this.target != '_self') {
            return true;
        }
        var /** @type {?} */ extras = {
            skipLocationChange: attrBoolValue(this.skipLocationChange),
            replaceUrl: attrBoolValue(this.replaceUrl),
        };
        this.router.navigateByUrl(this.urlTree, extras);
        return false;
    };
    /**
     * @return {?}
     */
    RouterLinkWithHref.prototype.updateTargetUrlAndHref = function () {
        this.href = this.locationStrategy.prepareExternalUrl(this.router.serializeUrl(this.urlTree));
    };
    Object.defineProperty(RouterLinkWithHref.prototype, "urlTree", {
        /**
         * @return {?}
         */
        get: function () {
            return this.router.createUrlTree(this.commands, {
                relativeTo: this.route,
                queryParams: this.queryParams,
                fragment: this.fragment,
                preserveQueryParams: attrBoolValue(this.preserveQueryParams),
                preserveFragment: attrBoolValue(this.preserveFragment),
            });
        },
        enumerable: true,
        configurable: true
    });
    RouterLinkWithHref.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{ selector: 'a[routerLink]' },] },
    ];
    /** @nocollapse */
    RouterLinkWithHref.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* Router */], },
        { type: __WEBPACK_IMPORTED_MODULE_3__router_state__["b" /* ActivatedRoute */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_common__["LocationStrategy"], },
    ]; };
    RouterLinkWithHref.propDecorators = {
        'target': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["HostBinding"], args: ['attr.target',] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
        'queryParams': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
        'fragment': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
        'preserveQueryParams': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
        'preserveFragment': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
        'skipLocationChange': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
        'replaceUrl': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
        'href': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["HostBinding"] },],
        'routerLink': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
        'onClick': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["HostListener"], args: ['click', ['$event.button', '$event.ctrlKey', '$event.metaKey'],] },],
    };
    return RouterLinkWithHref;
}());
function RouterLinkWithHref_tsickle_Closure_declarations() {
    /** @type {?} */
    RouterLinkWithHref.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    RouterLinkWithHref.ctorParameters;
    /** @type {?} */
    RouterLinkWithHref.propDecorators;
    /** @type {?} */
    RouterLinkWithHref.prototype.target;
    /** @type {?} */
    RouterLinkWithHref.prototype.queryParams;
    /** @type {?} */
    RouterLinkWithHref.prototype.fragment;
    /** @type {?} */
    RouterLinkWithHref.prototype.preserveQueryParams;
    /** @type {?} */
    RouterLinkWithHref.prototype.preserveFragment;
    /** @type {?} */
    RouterLinkWithHref.prototype.skipLocationChange;
    /** @type {?} */
    RouterLinkWithHref.prototype.replaceUrl;
    /** @type {?} */
    RouterLinkWithHref.prototype.commands;
    /** @type {?} */
    RouterLinkWithHref.prototype.subscription;
    /** @type {?} */
    RouterLinkWithHref.prototype.href;
    /** @type {?} */
    RouterLinkWithHref.prototype.router;
    /** @type {?} */
    RouterLinkWithHref.prototype.route;
    /** @type {?} */
    RouterLinkWithHref.prototype.locationStrategy;
}
/**
 * @param {?} s
 * @return {?}
 */
function attrBoolValue(s) {
    return s === '' || !!s;
}
//# sourceMappingURL=router_link.js.map

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return UrlHandlingStrategy; });
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return DefaultUrlHandlingStrategy; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * \@whatItDoes Provides a way to migrate Angular 1 applications to Angular 2.
 *
 * \@experimental
 * @abstract
 */
var UrlHandlingStrategy = (function () {
    function UrlHandlingStrategy() {
    }
    /**
     * Tells the router if this URL should be processed.
     *
     * When it returns true, the router will execute the regular navigation.
     * When it returns false, the router will set the router state to an empty state.
     * As a result, all the active components will be destroyed.
     *
     * @abstract
     * @param {?} url
     * @return {?}
     */
    UrlHandlingStrategy.prototype.shouldProcessUrl = function (url) { };
    /**
     * Extracts the part of the URL that should be handled by the router.
     * The rest of the URL will remain untouched.
     * @abstract
     * @param {?} url
     * @return {?}
     */
    UrlHandlingStrategy.prototype.extract = function (url) { };
    /**
     * Merges the URL fragment with the rest of the URL.
     * @abstract
     * @param {?} newUrlPart
     * @param {?} rawUrl
     * @return {?}
     */
    UrlHandlingStrategy.prototype.merge = function (newUrlPart, rawUrl) { };
    return UrlHandlingStrategy;
}());
/**
 * \@experimental
 */
var DefaultUrlHandlingStrategy = (function () {
    function DefaultUrlHandlingStrategy() {
    }
    /**
     * @param {?} url
     * @return {?}
     */
    DefaultUrlHandlingStrategy.prototype.shouldProcessUrl = function (url) { return true; };
    /**
     * @param {?} url
     * @return {?}
     */
    DefaultUrlHandlingStrategy.prototype.extract = function (url) { return url; };
    /**
     * @param {?} newUrlPart
     * @param {?} wholeUrl
     * @return {?}
     */
    DefaultUrlHandlingStrategy.prototype.merge = function (newUrlPart, wholeUrl) { return newUrlPart; };
    return DefaultUrlHandlingStrategy;
}());
//# sourceMappingURL=url_handling_strategy.js.map

/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return Tree; });
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return TreeNode; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var Tree = (function () {
    /**
     * @param {?} root
     */
    function Tree(root) {
        this._root = root;
    }
    Object.defineProperty(Tree.prototype, "root", {
        /**
         * @return {?}
         */
        get: function () { return this._root.value; },
        enumerable: true,
        configurable: true
    });
    /**
     * \@internal
     * @param {?} t
     * @return {?}
     */
    Tree.prototype.parent = function (t) {
        var /** @type {?} */ p = this.pathFromRoot(t);
        return p.length > 1 ? p[p.length - 2] : null;
    };
    /**
     * \@internal
     * @param {?} t
     * @return {?}
     */
    Tree.prototype.children = function (t) {
        var /** @type {?} */ n = findNode(t, this._root);
        return n ? n.children.map(function (t) { return t.value; }) : [];
    };
    /**
     * \@internal
     * @param {?} t
     * @return {?}
     */
    Tree.prototype.firstChild = function (t) {
        var /** @type {?} */ n = findNode(t, this._root);
        return n && n.children.length > 0 ? n.children[0].value : null;
    };
    /**
     * \@internal
     * @param {?} t
     * @return {?}
     */
    Tree.prototype.siblings = function (t) {
        var /** @type {?} */ p = findPath(t, this._root, []);
        if (p.length < 2)
            return [];
        var /** @type {?} */ c = p[p.length - 2].children.map(function (c) { return c.value; });
        return c.filter(function (cc) { return cc !== t; });
    };
    /**
     * \@internal
     * @param {?} t
     * @return {?}
     */
    Tree.prototype.pathFromRoot = function (t) { return findPath(t, this._root, []).map(function (s) { return s.value; }); };
    return Tree;
}());
function Tree_tsickle_Closure_declarations() {
    /**
     * \@internal
     * @type {?}
     */
    Tree.prototype._root;
}
/**
 * @param {?} expected
 * @param {?} c
 * @return {?}
 */
function findNode(expected, c) {
    if (expected === c.value)
        return c;
    for (var _i = 0, _a = c.children; _i < _a.length; _i++) {
        var cc = _a[_i];
        var /** @type {?} */ r = findNode(expected, cc);
        if (r)
            return r;
    }
    return null;
}
/**
 * @param {?} expected
 * @param {?} c
 * @param {?} collected
 * @return {?}
 */
function findPath(expected, c, collected) {
    collected.push(c);
    if (expected === c.value)
        return collected;
    for (var _i = 0, _a = c.children; _i < _a.length; _i++) {
        var cc = _a[_i];
        var /** @type {?} */ cloned = collected.slice(0);
        var /** @type {?} */ r = findPath(expected, cc, cloned);
        if (r.length > 0)
            return r;
    }
    return [];
}
var TreeNode = (function () {
    /**
     * @param {?} value
     * @param {?} children
     */
    function TreeNode(value, children) {
        this.value = value;
        this.children = children;
    }
    /**
     * @return {?}
     */
    TreeNode.prototype.toString = function () { return "TreeNode(" + this.value + ")"; };
    return TreeNode;
}());
function TreeNode_tsickle_Closure_declarations() {
    /** @type {?} */
    TreeNode.prototype.value;
    /** @type {?} */
    TreeNode.prototype.children;
}
//# sourceMappingURL=tree.js.map

/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return routerActions; });
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return routerActionTypes; });
/* harmony export (immutable) */ exports["c"] = go;
/* harmony export (immutable) */ exports["d"] = replace;
/* harmony export (immutable) */ exports["e"] = search;
/* harmony export (immutable) */ exports["f"] = show;
/* harmony export (immutable) */ exports["g"] = back;
/* harmony export (immutable) */ exports["h"] = forward;
var routerActions = {
    GO: '[Router] Go',
    REPLACE: '[Router] Replace',
    SEARCH: '[Router] Search',
    SHOW: '[Router] Show',
    BACK: '[Router] Back',
    FORWARD: '[Router] Forward',
    UPDATE_LOCATION: '[Router] Update Location'
};
var routerActionTypes = Object.keys(routerActions).map(function (key) { return routerActions[key]; });
function go(path, query, extras) {
    var payload = { path: path, query: query, extras: extras };
    return { type: routerActions.GO, payload: payload };
}
function replace(path, query, extras) {
    var payload = { path: path, query: query, extras: extras };
    return { type: routerActions.REPLACE, payload: payload };
}
function search(query, extras) {
    var payload = { query: query, extras: extras };
    return { type: routerActions.SEARCH, payload: payload };
}
function show(path, query, extras) {
    var payload = { path: path, query: query, extras: extras };
    return { type: routerActions.SHOW, payload: payload };
}
function back() {
    var payload = {};
    return { type: routerActions.BACK, payload: payload };
}
function forward() {
    var payload = {};
    return { type: routerActions.FORWARD, payload: payload };
}
//# sourceMappingURL=actions.js.map

/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return ActionTypes; });
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return StoreDevtoolActions; });
var ActionTypes = {
    PERFORM_ACTION: 'PERFORM_ACTION',
    RESET: 'RESET',
    ROLLBACK: 'ROLLBACK',
    COMMIT: 'COMMIT',
    SWEEP: 'SWEEP',
    TOGGLE_ACTION: 'TOGGLE_ACTION',
    SET_ACTIONS_ACTIVE: 'SET_ACTIONS_ACTIVE',
    JUMP_TO_STATE: 'JUMP_TO_STATE',
    IMPORT_STATE: 'IMPORT_STATE'
};
/**
* Action creators to change the History state.
*/
var StoreDevtoolActions = {
    performAction: function (action) {
        if (typeof action.type === 'undefined') {
            throw new Error('Actions may not have an undefined "type" property. ' +
                'Have you misspelled a constant?');
        }
        return { type: ActionTypes.PERFORM_ACTION, action: action, timestamp: Date.now() };
    },
    reset: function () {
        return { type: ActionTypes.RESET, timestamp: Date.now() };
    },
    rollback: function () {
        return { type: ActionTypes.ROLLBACK, timestamp: Date.now() };
    },
    commit: function () {
        return { type: ActionTypes.COMMIT, timestamp: Date.now() };
    },
    sweep: function () {
        return { type: ActionTypes.SWEEP };
    },
    toggleAction: function (id) {
        return { type: ActionTypes.TOGGLE_ACTION, id: id };
    },
    setActionsActive: function (start, end, active) {
        if (active === void 0) { active = true; }
        return { type: ActionTypes.SET_ACTIONS_ACTIVE, start: start, end: end, active: active };
    },
    jumpToState: function (index) {
        return { type: ActionTypes.JUMP_TO_STATE, index: index };
    },
    importState: function (nextLiftedState) {
        return { type: ActionTypes.IMPORT_STATE, nextLiftedState: nextLiftedState };
    }
};
//# sourceMappingURL=actions.js.map

/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(283);
/* harmony export (immutable) */ exports["c"] = difference;
/* harmony export (immutable) */ exports["d"] = unliftState;
/* unused harmony export unliftAction */
/* harmony export (immutable) */ exports["b"] = liftAction;
/* harmony export (immutable) */ exports["a"] = applyOperators;

function difference(first, second) {
    return first.filter(function (item) { return second.indexOf(item) < 0; });
}
/**
 * Provides an app's view into the state of the lifted store.
 */
function unliftState(liftedState) {
    var computedStates = liftedState.computedStates, currentStateIndex = liftedState.currentStateIndex;
    var state = computedStates[currentStateIndex].state;
    return state;
}
function unliftAction(liftedState) {
    return liftedState.actionsById[liftedState.nextActionId - 1];
}
/**
* Lifts an app's action into an action on the lifted store.
*/
function liftAction(action) {
    return __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* StoreDevtoolActions */].performAction(action);
}
function applyOperators(input$, operators) {
    return operators.reduce(function (source$, _a) {
        var operator = _a[0], args = _a.slice(1);
        return operator.apply(source$, args);
    }, input$);
}
//# sourceMappingURL=utils.js.map

/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var Debug = __webpack_require__(4);
var debug, debugOff = function () {
    var any = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        any[_i] = arguments[_i];
    }
};
"production" !== 'production' && (debug = __webpack_require__(4)('app:LogsService'));
var LogsService = (function () {
    function LogsService() {
        this._setupConsoleDebugApi();
    }
    LogsService.prototype._setupConsoleDebugApi = function () {
        window.debugStart = function (moduleName) {
            if (typeof moduleName === 'string') {
                console.log('Enable debug:', moduleName);
                Debug.enable(moduleName + ':*');
            }
            else {
                console.log('Enable debug all');
                Debug.enable('*');
            }
        };
        window.debugStop = function (moduleName) {
            if (typeof moduleName === 'string') {
                console.log('Disable debug:', moduleName);
                Debug.disable(moduleName + ':*');
            }
            else {
                console.log('Disable debug all');
                Debug.disable('*');
            }
        };
    };
    return LogsService;
}());
LogsService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [])
], LogsService);
exports.LogsService = LogsService;


/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var debug, debugOff = function () {
    var any = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        any[_i] = arguments[_i];
    }
};
"production" !== 'production' && (debug = __webpack_require__(4)('app:UtilsService'));
var UtilsService = (function () {
    function UtilsService() {
        this._verbose = null;
    }
    UtilsService.prototype.getElementToWindowOffset = function (element) {
        debugOff('Get element offset to window');
        var xPosition = 0;
        var yPosition = 0;
        while (element) {
            xPosition += (element.offsetLeft - element.scrollLeft + element.clientLeft);
            yPosition += (element.offsetTop - element.scrollTop + element.clientTop);
            element = element.offsetParent;
        }
        return { x: xPosition, y: yPosition };
    };
    return UtilsService;
}());
UtilsService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [])
], UtilsService);
exports.UtilsService = UtilsService;


/***/ },
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_ng2_page_scroll_directive__ = __webpack_require__(473);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "PageScroll", function() { return __WEBPACK_IMPORTED_MODULE_0__src_ng2_page_scroll_directive__["a"]; });
Object.defineProperty(exports, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_ng2_page_scroll_service__ = __webpack_require__(311);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "PageScrollService", function() { return __WEBPACK_IMPORTED_MODULE_1__src_ng2_page_scroll_service__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_ng2_page_scroll_config__ = __webpack_require__(310);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "EasingLogic", function() { return __WEBPACK_IMPORTED_MODULE_2__src_ng2_page_scroll_config__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "PageScrollConfig", function() { return __WEBPACK_IMPORTED_MODULE_2__src_ng2_page_scroll_config__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_ng2_page_scroll_instance__ = __webpack_require__(472);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "PageScrollInstance", function() { return __WEBPACK_IMPORTED_MODULE_3__src_ng2_page_scroll_instance__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_ng2_page_scroll_util_service__ = __webpack_require__(210);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "PageScrollUtilService", function() { return __WEBPACK_IMPORTED_MODULE_4__src_ng2_page_scroll_util_service__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_ng2_page_scroll_module__ = __webpack_require__(867);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "Ng2PageScrollModule", function() { return __WEBPACK_IMPORTED_MODULE_5__src_ng2_page_scroll_module__["a"]; });








/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return EasingLogic; });
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return PageScrollConfig; });
var EasingLogic = (function () {
    function EasingLogic() {
    }
    return EasingLogic;
}());

var PageScrollConfig = (function () {
    function PageScrollConfig() {
    }
    Object.defineProperty(PageScrollConfig, "defaultEasingLogic", {
        // Getter and setter to avoid auto completion to suggest calling the method
        get: function () {
            return PageScrollConfig._easingLogic;
        },
        set: function (easingLogic) {
            PageScrollConfig._easingLogic = easingLogic;
        },
        enumerable: true,
        configurable: true
    });
    return PageScrollConfig;
}());

/**
 * The number of milliseconds to wait till updating the scroll position again.
 * Small amounts may produce smoother animations but require more processing power.
 * @type {number}
 * @private
 */
PageScrollConfig._interval = 10;
/**
 * The amount of pixels that need to be between the current scrollTop/scrollLeft position
 * and the target position the cause a scroll animation. In case distance is below
 * this threshold, an immediate jump will be performed.
 * Due to dpi or rounding irregularities in browsers floating point numbers for scrollTop/scrollLeft values
 * are possible, making a === comparison of current scrollTop or scrollLeft and target scrollPosition error-prone.
 * @type {number}
 * @private
 */
PageScrollConfig._minScrollDistance = 2;
/**
 * Name of the default namespace.
 * @type {string}
 * @private
 */
PageScrollConfig._defaultNamespace = 'default';
/**
 * Whether by default the scrolling should happen in vertical direction (by manipulating the scrollTop property)
 * (= true; default) or in horizontal direction (by manipulating the scrollLeft property) (= false
 * @type {boolean}
 */
PageScrollConfig.defaultIsVerticalScrolling = true;
/**
 * How many console logs should be emitted.
 * 0: None
 * 2: If animation could not be started due to missing target, "already at destination" or similar reasons
 * 5: All scroll position values that get set
 * @type {boolean}
 * @private
 */
PageScrollConfig._logLevel = 2;
/**
 * The duration how long a scrollTo animation should last by default.
 * May be overridden using the page-scroll-duration attribute on a single ng2PageScroll instance.
 * @type {number}
 */
PageScrollConfig.defaultDuration = 1250;
/**
 * The distance in pixels above scroll target where the animation should stop. Setting a positive number results in
 * the scroll target being more in the middle of the screen, negative numbers will produce scrolling "too far"
 * @type {number}
 */
PageScrollConfig.defaultScrollOffset = 0;
/**
 * Whether by default for inline scroll animations the advanced offset calculation should take place (true) or
 * not (false). Default is false.
 * The advanced offset calculation will traverse the DOM tree upwards, starting at the scrollTarget, until it finds
 * the scrollingView container element. Along the way the offset positions of the relative positioned
 * (position: relative) elements will be taken into account for calculating the target elements position.
 * @type {boolean}
 */
PageScrollConfig.defaultAdvancedInlineOffsetCalculation = false;
/**
 * The events that are listened to on the body to decide whether a scroll animation has been interfered/interrupted by the user
 * @type {string[]}
 * @private
 */
PageScrollConfig._interruptEvents = ['mousedown', 'wheel', 'DOMMouseScroll', 'mousewheel', 'keyup', 'touchmove'];
/**
 * The keys that are considered to interrupt a scroll animation (mainly the arrow keys). All other key presses will not stop the
 * scroll animation.
 * @type {number[]}
 * @private
 */
PageScrollConfig._interruptKeys = [33, 34, 35, 36, 38, 40];
/**
 * Whether a scroll animation should be interruptible by user interaction (true) or not (false). If the user performs an
 * interrupting event while a scroll animation takes place, the scroll animation stops.
 * @type {boolean}
 */
PageScrollConfig.defaultInterruptible = true;
PageScrollConfig._easingLogic = {
    ease: function (t, b, c, d) {
        // Linear easing
        return c * t / d + b;
    }
};


/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ng2_page_scroll_config__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ng2_page_scroll_util_service__ = __webpack_require__(210);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return PageScrollService; });



var PageScrollService = (function () {
    function PageScrollService() {
        var _this = this;
        this.runningInstances = [];
        this.onInterrupted = {
            report: function (event, pageScrollInstance) {
                if (!pageScrollInstance.interruptible) {
                    // Non-interruptible anyway, so do not stop anything
                    return;
                }
                var shouldStop = true;
                if (event.type === 'keyup') {
                    // Only stop if specific keys have been pressed, for all others don't stop anything
                    if (__WEBPACK_IMPORTED_MODULE_1__ng2_page_scroll_config__["a" /* PageScrollConfig */]._interruptKeys.indexOf(event.keyCode) === -1) {
                        // The pressed key is not in the list of interrupting keys
                        shouldStop = false;
                    }
                }
                else if (event.type === 'mousedown') {
                    // For mousedown events we only stop the scroll animation of the mouse has
                    // been clicked inside the scrolling container
                    if (!pageScrollInstance.scrollingViews.some(function (scrollingView) { return scrollingView.contains(event.target); })) {
                        // Mouse clicked an element which is not inside any of the the scrolling containers
                        shouldStop = false;
                    }
                }
                if (shouldStop) {
                    _this.stopAll(pageScrollInstance.namespace);
                }
            }
        };
        if (PageScrollService.instanceCounter > 0 && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["isDevMode"])()) {
            console.warn('An instance of PageScrollService already exists, usually ' +
                'including one provider should be enough, so double check.');
        }
        PageScrollService.instanceCounter++;
    }
    PageScrollService.prototype.stopInternal = function (interrupted, pageScrollInstance) {
        var index = this.runningInstances.indexOf(pageScrollInstance);
        if (index >= 0) {
            this.runningInstances.splice(index, 1);
        }
        if (pageScrollInstance.interruptListenersAttached) {
            pageScrollInstance.detachInterruptListeners();
        }
        if (pageScrollInstance.timer) {
            // Clear/Stop the timer
            clearInterval(pageScrollInstance.timer);
            // Clear the reference to this timer
            pageScrollInstance.timer = undefined;
            pageScrollInstance.fireEvent(!interrupted);
            return true;
        }
        return false;
    };
    /**
     * Start a scroll animation. All properties of the animation are stored in the given {@link PageScrollInstance} object.
     *
     * This is the core functionality of the whole library.
     *
     * @param pageScrollInstance
     */
    PageScrollService.prototype.start = function (pageScrollInstance) {
        var _this = this;
        // Stop all possibly running scroll animations in the same namespace
        this.stopAll(pageScrollInstance.namespace);
        if (pageScrollInstance.scrollingViews === null || pageScrollInstance.scrollingViews.length === 0) {
            // No scrollingViews specified, thus we can't animate anything
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["isDevMode"])()) {
                console.warn('No scrollingViews specified, this ng2-page-scroll does not know which DOM elements to scroll');
            }
            return;
        }
        var startScrollPositionFound = false;
        // Reset start scroll position to 0. If any of the scrollingViews has a different one, it will be extracted next
        pageScrollInstance.startScrollPosition = 0;
        // Get the start scroll position from the scrollingViews (e.g. if the user already scrolled down the content)
        pageScrollInstance.scrollingViews.forEach(function (scrollingView) {
            if (__WEBPACK_IMPORTED_MODULE_2__ng2_page_scroll_util_service__["a" /* PageScrollUtilService */].isUndefinedOrNull(scrollingView)) {
                return;
            }
            // Get the scrollTop or scrollLeft value of the first scrollingView that returns a value for its "scrollTop"
            // or "scrollLeft" property that is not undefined and unequal to 0
            var scrollPosition = pageScrollInstance.getScrollPropertyValue(scrollingView);
            if (!startScrollPositionFound && scrollPosition) {
                // We found a scrollingView that does not have scrollTop or scrollLeft 0
                // Return the scroll position value, as this will be our startScrollPosition
                pageScrollInstance.startScrollPosition = scrollPosition;
                startScrollPositionFound = true;
            }
        });
        var pageScrollOffset = pageScrollInstance.getCurrentOffset();
        // Calculate the target position that the scroll animation should go to
        var scrollTargetPosition = pageScrollInstance.extractScrollTargetPosition();
        pageScrollInstance.targetScrollPosition = Math.round((pageScrollInstance.verticalScrolling ? scrollTargetPosition.top : scrollTargetPosition.left) - pageScrollOffset);
        // Calculate the distance we need to go in total
        pageScrollInstance.distanceToScroll = pageScrollInstance.targetScrollPosition - pageScrollInstance.startScrollPosition;
        if (isNaN(pageScrollInstance.distanceToScroll)) {
            // We weren't able to find the target position, maybe the element does not exist?
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["isDevMode"])()) {
                console.log('Scrolling not possible, as we can\'t find the specified target');
            }
            pageScrollInstance.fireEvent(false);
            return;
        }
        // We're at the final destination already
        // OR we need to scroll down but are already at the end
        // OR we need to scroll up but are at the top already
        var allReadyAtDestination = Math.abs(pageScrollInstance.distanceToScroll) < __WEBPACK_IMPORTED_MODULE_1__ng2_page_scroll_config__["a" /* PageScrollConfig */]._minScrollDistance;
        // Check how long we need to scroll if a speed option is given
        // Default executionDuration is the specified duration
        pageScrollInstance.executionDuration = pageScrollInstance.duration;
        // Maybe we need to pay attention to the speed option?
        if (!__WEBPACK_IMPORTED_MODULE_2__ng2_page_scroll_util_service__["a" /* PageScrollUtilService */].isUndefinedOrNull(pageScrollInstance.speed) && __WEBPACK_IMPORTED_MODULE_2__ng2_page_scroll_util_service__["a" /* PageScrollUtilService */].isUndefinedOrNull(pageScrollInstance.duration)) {
            // Speed option is set and no duration => calculate duration based on speed and scroll distance
            pageScrollInstance.executionDuration = pageScrollInstance.distanceToScroll / pageScrollInstance.speed * 1000;
        }
        // We should go there directly, as our "animation" would have one big step
        // only anyway and this way we save the interval stuff
        var tooShortInterval = pageScrollInstance.executionDuration <= __WEBPACK_IMPORTED_MODULE_1__ng2_page_scroll_config__["a" /* PageScrollConfig */]._interval;
        if (allReadyAtDestination || tooShortInterval) {
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["isDevMode"])()) {
                if (allReadyAtDestination) {
                    console.log('Scrolling not possible, as we can\'t get any closer to the destination');
                }
                else {
                    console.log('Scroll duration shorter that interval length, jumping to target');
                }
            }
            pageScrollInstance.setScrollPosition(pageScrollInstance.targetScrollPosition);
            pageScrollInstance.fireEvent(true);
            return;
        }
        // Register the interrupt listeners if we want an interruptible scroll animation
        if (pageScrollInstance.interruptible ||
            (__WEBPACK_IMPORTED_MODULE_2__ng2_page_scroll_util_service__["a" /* PageScrollUtilService */].isUndefinedOrNull(pageScrollInstance.interruptible) && __WEBPACK_IMPORTED_MODULE_1__ng2_page_scroll_config__["a" /* PageScrollConfig */].defaultInterruptible)) {
            pageScrollInstance.attachInterruptListeners(this.onInterrupted);
        }
        // Let's get started, get the start time...
        pageScrollInstance.startTime = new Date().getTime();
        // .. and calculate the end time (when we need to finish at last)
        pageScrollInstance.endTime = pageScrollInstance.startTime + pageScrollInstance.executionDuration;
        pageScrollInstance.timer = setInterval(function (_pageScrollInstance) {
            // Take the current time
            var currentTime = new Date().getTime();
            // Determine the new scroll position
            var newScrollPosition;
            var stopNow = false;
            if (_pageScrollInstance.endTime <= currentTime) {
                // We're over the time already, so go the targetScrollPosition (aka destination)
                newScrollPosition = _pageScrollInstance.targetScrollPosition;
                stopNow = true;
            }
            else {
                // Calculate the scroll position based on the current time using the easing function
                newScrollPosition = Math.round(_pageScrollInstance.easingLogic.ease(currentTime - _pageScrollInstance.startTime, _pageScrollInstance.startScrollPosition, _pageScrollInstance.distanceToScroll, _pageScrollInstance.executionDuration));
            }
            // Set the new scrollPosition to all scrollingViews elements
            if (!_pageScrollInstance.setScrollPosition(newScrollPosition)) {
                // Setting the new scrollTop/scrollLeft value failed for all ScrollingViews
                // early stop the scroll animation to save resources
                stopNow = true;
            }
            // At the end do the internal stop maintenance and fire the pageScrollFinish event
            // (otherwise the event might arrive at "too early")
            if (stopNow) {
                _this.stopInternal(false, _pageScrollInstance);
            }
        }, __WEBPACK_IMPORTED_MODULE_1__ng2_page_scroll_config__["a" /* PageScrollConfig */]._interval, pageScrollInstance);
        // Register the instance as running one
        this.runningInstances.push(pageScrollInstance);
    };
    /**
     * Stop all running scroll animations. Optionally limit to stop only the ones of specific namespace.
     *
     * @param namespace
     * @returns {boolean}
     */
    PageScrollService.prototype.stopAll = function (namespace) {
        if (this.runningInstances.length > 0) {
            var stoppedSome = false;
            for (var i = 0; i < this.runningInstances.length; ++i) {
                var pageScrollInstance = this.runningInstances[i];
                if (__WEBPACK_IMPORTED_MODULE_2__ng2_page_scroll_util_service__["a" /* PageScrollUtilService */].isUndefinedOrNull(namespace) || namespace.length === 0 ||
                    pageScrollInstance.namespace === namespace) {
                    stoppedSome = true;
                    this.stopInternal(true, pageScrollInstance);
                    // Decrease the counter, as we removed an item from the array we iterate over
                    i--;
                }
            }
            return stoppedSome;
        }
        return false;
    };
    PageScrollService.prototype.stop = function (pageScrollInstance) {
        return this.stopInternal(true, pageScrollInstance);
    };
    return PageScrollService;
}());

PageScrollService.instanceCounter = 0;
PageScrollService.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
];
/** @nocollapse */
PageScrollService.ctorParameters = function () { return []; };


/***/ },
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var store_1 = __webpack_require__(80);
var app_initial_state_1 = __webpack_require__(670);
var appState = app_initial_state_1.appInitialState;
function hotModuleReplacement(bootloader, module) {
    var MODULE_REF;
    var DATA = !!module.hot.data ?
        module.hot.data.state :
        undefined;
    console.log('[HotStore] App State:', DATA);
    console.time('[HotStore] bootstrap');
    if (document.readyState === 'complete') {
        bootloader()
            .then(function (modRef) { return MODULE_REF = modRef; })
            .then(function () { return console.timeEnd('[HotStore] bootstrap'); });
    }
    else {
        document.addEventListener('DOMContentLoaded', function () {
            bootloader()
                .then(function (modRef) { return MODULE_REF = modRef; })
                .then(function () { return console.timeEnd('[HotStore] bootstrap'); });
        });
    }
    function getState(store) {
        var state;
        store.take(1).subscribe(function (s) { return state = s; });
        return state;
    }
    module.hot.accept();
    module.hot.dispose(function (data) {
        console.clear();
        console.time('[HotStore] dispose');
        var store = MODULE_REF.injector.get(store_1.Store);
        appState = getState(store);
        Object.assign(data, { appState: appState });
        console.timeEnd('[HotStore] dispose');
    });
}
exports.hotModuleReplacement = hotModuleReplacement;
function provideHotStore(reducer) {
    return store_1.StoreModule.provideStore(reducer, appState);
}
exports.provideHotStore = provideHotStore;


/***/ },
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return FormErrorExamples; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var /** @type {?} */ FormErrorExamples = {
    formControlName: "\n    <div [formGroup]=\"myGroup\">\n      <input formControlName=\"firstName\">\n    </div>\n\n    In your class:\n\n    this.myGroup = new FormGroup({\n       firstName: new FormControl()\n    });",
    formGroupName: "\n    <div [formGroup]=\"myGroup\">\n       <div formGroupName=\"person\">\n          <input formControlName=\"firstName\">\n       </div>\n    </div>\n\n    In your class:\n\n    this.myGroup = new FormGroup({\n       person: new FormGroup({ firstName: new FormControl() })\n    });",
    formArrayName: "\n    <div [formGroup]=\"myGroup\">\n      <div formArrayName=\"cities\">\n        <div *ngFor=\"let city of cityArray.controls; let i=index\">\n          <input [formControlName]=\"i\">\n        </div>\n      </div>\n    </div>\n\n    In your class:\n\n    this.cityArray = new FormArray([new FormControl('SF')]);\n    this.myGroup = new FormGroup({\n      cities: this.cityArray\n    });",
    ngModelGroup: "\n    <form>\n       <div ngModelGroup=\"person\">\n          <input [(ngModel)]=\"person.name\" name=\"firstName\">\n       </div>\n    </form>",
    ngModelWithFormGroup: "\n    <div [formGroup]=\"myGroup\">\n       <input formControlName=\"firstName\">\n       <input [(ngModel)]=\"showMoreControls\" [ngModelOptions]=\"{standalone: true}\">\n    </div>\n  "
};
//# sourceMappingURL=error_examples.js.map

/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error_examples__ = __webpack_require__(388);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return TemplateDrivenErrors; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

var TemplateDrivenErrors = (function () {
    function TemplateDrivenErrors() {
    }
    /**
     * @return {?}
     */
    TemplateDrivenErrors.modelParentException = function () {
        throw new Error("\n      ngModel cannot be used to register form controls with a parent formGroup directive.  Try using\n      formGroup's partner directive \"formControlName\" instead.  Example:\n\n      " + __WEBPACK_IMPORTED_MODULE_0__error_examples__["a" /* FormErrorExamples */].formControlName + "\n\n      Or, if you'd like to avoid registering this form control, indicate that it's standalone in ngModelOptions:\n\n      Example:\n\n      " + __WEBPACK_IMPORTED_MODULE_0__error_examples__["a" /* FormErrorExamples */].ngModelWithFormGroup);
    };
    /**
     * @return {?}
     */
    TemplateDrivenErrors.formGroupNameException = function () {
        throw new Error("\n      ngModel cannot be used to register form controls with a parent formGroupName or formArrayName directive.\n\n      Option 1: Use formControlName instead of ngModel (reactive strategy):\n\n      " + __WEBPACK_IMPORTED_MODULE_0__error_examples__["a" /* FormErrorExamples */].formGroupName + "\n\n      Option 2:  Update ngModel's parent be ngModelGroup (template-driven strategy):\n\n      " + __WEBPACK_IMPORTED_MODULE_0__error_examples__["a" /* FormErrorExamples */].ngModelGroup);
    };
    /**
     * @return {?}
     */
    TemplateDrivenErrors.missingNameException = function () {
        throw new Error("If ngModel is used within a form tag, either the name attribute must be set or the form\n      control must be defined as 'standalone' in ngModelOptions.\n\n      Example 1: <input [(ngModel)]=\"person.firstName\" name=\"first\">\n      Example 2: <input [(ngModel)]=\"person.firstName\" [ngModelOptions]=\"{standalone: true}\">");
    };
    /**
     * @return {?}
     */
    TemplateDrivenErrors.modelGroupParentException = function () {
        throw new Error("\n      ngModelGroup cannot be used with a parent formGroup directive.\n\n      Option 1: Use formGroupName instead of ngModelGroup (reactive strategy):\n\n      " + __WEBPACK_IMPORTED_MODULE_0__error_examples__["a" /* FormErrorExamples */].formGroupName + "\n\n      Option 2:  Use a regular form tag instead of the formGroup directive (template-driven strategy):\n\n      " + __WEBPACK_IMPORTED_MODULE_0__error_examples__["a" /* FormErrorExamples */].ngModelGroup);
    };
    return TemplateDrivenErrors;
}());
//# sourceMappingURL=template_driven_errors.js.map

/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validators__ = __webpack_require__(54);
/* unused harmony export REQUIRED_VALIDATOR */
/* unused harmony export CHECKBOX_REQUIRED_VALIDATOR */
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return RequiredValidator; });
/* harmony export (binding) */ __webpack_require__.d(exports, "e", function() { return CheckboxRequiredValidator; });
/* unused harmony export MIN_LENGTH_VALIDATOR */
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return MinLengthValidator; });
/* unused harmony export MAX_LENGTH_VALIDATOR */
/* harmony export (binding) */ __webpack_require__.d(exports, "c", function() { return MaxLengthValidator; });
/* unused harmony export PATTERN_VALIDATOR */
/* harmony export (binding) */ __webpack_require__.d(exports, "d", function() { return PatternValidator; });
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};


var /** @type {?} */ REQUIRED_VALIDATOR = {
    provide: __WEBPACK_IMPORTED_MODULE_1__validators__["b" /* NG_VALIDATORS */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return RequiredValidator; }),
    multi: true
};
var /** @type {?} */ CHECKBOX_REQUIRED_VALIDATOR = {
    provide: __WEBPACK_IMPORTED_MODULE_1__validators__["b" /* NG_VALIDATORS */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return CheckboxRequiredValidator; }),
    multi: true
};
/**
 * A Directive that adds the `required` validator to any controls marked with the
 * `required` attribute, via the {\@link NG_VALIDATORS} binding.
 *
 * ### Example
 *
 * ```
 * <input name="fullName" ngModel required>
 * ```
 *
 * \@stable
 */
var RequiredValidator = (function () {
    function RequiredValidator() {
    }
    Object.defineProperty(RequiredValidator.prototype, "required", {
        /**
         * @return {?}
         */
        get: function () { return this._required; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._required = value != null && value !== false && "" + value !== 'false';
            if (this._onChange)
                this._onChange();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} c
     * @return {?}
     */
    RequiredValidator.prototype.validate = function (c) {
        return this.required ? __WEBPACK_IMPORTED_MODULE_1__validators__["a" /* Validators */].required(c) : null;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    RequiredValidator.prototype.registerOnValidatorChange = function (fn) { this._onChange = fn; };
    RequiredValidator.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: ':not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]',
                    providers: [REQUIRED_VALIDATOR],
                    host: { '[attr.required]': 'required ? "" : null' }
                },] },
    ];
    /** @nocollapse */
    RequiredValidator.ctorParameters = function () { return []; };
    RequiredValidator.propDecorators = {
        'required': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return RequiredValidator;
}());
function RequiredValidator_tsickle_Closure_declarations() {
    /** @type {?} */
    RequiredValidator.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    RequiredValidator.ctorParameters;
    /** @type {?} */
    RequiredValidator.propDecorators;
    /** @type {?} */
    RequiredValidator.prototype._required;
    /** @type {?} */
    RequiredValidator.prototype._onChange;
}
/**
 * A Directive that adds the `required` validator to checkbox controls marked with the
 * `required` attribute, via the {\@link NG_VALIDATORS} binding.
 *
 * ### Example
 *
 * ```
 * <input type="checkbox" name="active" ngModel required>
 * ```
 *
 * \@experimental
 */
var CheckboxRequiredValidator = (function (_super) {
    __extends(CheckboxRequiredValidator, _super);
    function CheckboxRequiredValidator() {
        _super.apply(this, arguments);
    }
    /**
     * @param {?} c
     * @return {?}
     */
    CheckboxRequiredValidator.prototype.validate = function (c) {
        return this.required ? __WEBPACK_IMPORTED_MODULE_1__validators__["a" /* Validators */].requiredTrue(c) : null;
    };
    CheckboxRequiredValidator.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'input[type=checkbox][required][formControlName],input[type=checkbox][required][formControl],input[type=checkbox][required][ngModel]',
                    providers: [CHECKBOX_REQUIRED_VALIDATOR],
                    host: { '[attr.required]': 'required ? "" : null' }
                },] },
    ];
    /** @nocollapse */
    CheckboxRequiredValidator.ctorParameters = function () { return []; };
    return CheckboxRequiredValidator;
}(RequiredValidator));
function CheckboxRequiredValidator_tsickle_Closure_declarations() {
    /** @type {?} */
    CheckboxRequiredValidator.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    CheckboxRequiredValidator.ctorParameters;
}
/**
 * Provider which adds {@link MinLengthValidator} to {@link NG_VALIDATORS}.
 *
 * ## Example:
 *
 * {@example common/forms/ts/validators/validators.ts region='min'}
 */
var /** @type {?} */ MIN_LENGTH_VALIDATOR = {
    provide: __WEBPACK_IMPORTED_MODULE_1__validators__["b" /* NG_VALIDATORS */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return MinLengthValidator; }),
    multi: true
};
/**
 * A directive which installs the {\@link MinLengthValidator} for any `formControlName`,
 * `formControl`, or control with `ngModel` that also has a `minlength` attribute.
 *
 * \@stable
 */
var MinLengthValidator = (function () {
    function MinLengthValidator() {
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    MinLengthValidator.prototype.ngOnChanges = function (changes) {
        if ('minlength' in changes) {
            this._createValidator();
            if (this._onChange)
                this._onChange();
        }
    };
    /**
     * @param {?} c
     * @return {?}
     */
    MinLengthValidator.prototype.validate = function (c) {
        return this.minlength == null ? null : this._validator(c);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    MinLengthValidator.prototype.registerOnValidatorChange = function (fn) { this._onChange = fn; };
    /**
     * @return {?}
     */
    MinLengthValidator.prototype._createValidator = function () {
        this._validator = __WEBPACK_IMPORTED_MODULE_1__validators__["a" /* Validators */].minLength(parseInt(this.minlength, 10));
    };
    MinLengthValidator.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: '[minlength][formControlName],[minlength][formControl],[minlength][ngModel]',
                    providers: [MIN_LENGTH_VALIDATOR],
                    host: { '[attr.minlength]': 'minlength ? minlength : null' }
                },] },
    ];
    /** @nocollapse */
    MinLengthValidator.ctorParameters = function () { return []; };
    MinLengthValidator.propDecorators = {
        'minlength': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return MinLengthValidator;
}());
function MinLengthValidator_tsickle_Closure_declarations() {
    /** @type {?} */
    MinLengthValidator.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    MinLengthValidator.ctorParameters;
    /** @type {?} */
    MinLengthValidator.propDecorators;
    /** @type {?} */
    MinLengthValidator.prototype._validator;
    /** @type {?} */
    MinLengthValidator.prototype._onChange;
    /** @type {?} */
    MinLengthValidator.prototype.minlength;
}
/**
 * Provider which adds {@link MaxLengthValidator} to {@link NG_VALIDATORS}.
 *
 * ## Example:
 *
 * {@example common/forms/ts/validators/validators.ts region='max'}
 */
var /** @type {?} */ MAX_LENGTH_VALIDATOR = {
    provide: __WEBPACK_IMPORTED_MODULE_1__validators__["b" /* NG_VALIDATORS */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return MaxLengthValidator; }),
    multi: true
};
/**
 * A directive which installs the {\@link MaxLengthValidator} for any `formControlName,
 * `formControl`,
 * or control with `ngModel` that also has a `maxlength` attribute.
 *
 * \@stable
 */
var MaxLengthValidator = (function () {
    function MaxLengthValidator() {
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    MaxLengthValidator.prototype.ngOnChanges = function (changes) {
        if ('maxlength' in changes) {
            this._createValidator();
            if (this._onChange)
                this._onChange();
        }
    };
    /**
     * @param {?} c
     * @return {?}
     */
    MaxLengthValidator.prototype.validate = function (c) {
        return this.maxlength != null ? this._validator(c) : null;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    MaxLengthValidator.prototype.registerOnValidatorChange = function (fn) { this._onChange = fn; };
    /**
     * @return {?}
     */
    MaxLengthValidator.prototype._createValidator = function () {
        this._validator = __WEBPACK_IMPORTED_MODULE_1__validators__["a" /* Validators */].maxLength(parseInt(this.maxlength, 10));
    };
    MaxLengthValidator.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: '[maxlength][formControlName],[maxlength][formControl],[maxlength][ngModel]',
                    providers: [MAX_LENGTH_VALIDATOR],
                    host: { '[attr.maxlength]': 'maxlength ? maxlength : null' }
                },] },
    ];
    /** @nocollapse */
    MaxLengthValidator.ctorParameters = function () { return []; };
    MaxLengthValidator.propDecorators = {
        'maxlength': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return MaxLengthValidator;
}());
function MaxLengthValidator_tsickle_Closure_declarations() {
    /** @type {?} */
    MaxLengthValidator.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    MaxLengthValidator.ctorParameters;
    /** @type {?} */
    MaxLengthValidator.propDecorators;
    /** @type {?} */
    MaxLengthValidator.prototype._validator;
    /** @type {?} */
    MaxLengthValidator.prototype._onChange;
    /** @type {?} */
    MaxLengthValidator.prototype.maxlength;
}
var /** @type {?} */ PATTERN_VALIDATOR = {
    provide: __WEBPACK_IMPORTED_MODULE_1__validators__["b" /* NG_VALIDATORS */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return PatternValidator; }),
    multi: true
};
/**
 * A Directive that adds the `pattern` validator to any controls marked with the
 * `pattern` attribute, via the {\@link NG_VALIDATORS} binding. Uses attribute value
 * as the regex to validate Control value against.  Follows pattern attribute
 * semantics; i.e. regex must match entire Control value.
 *
 * ### Example
 *
 * ```
 * <input [name]="fullName" pattern="[a-zA-Z ]*" ngModel>
 * ```
 * \@stable
 */
var PatternValidator = (function () {
    function PatternValidator() {
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    PatternValidator.prototype.ngOnChanges = function (changes) {
        if ('pattern' in changes) {
            this._createValidator();
            if (this._onChange)
                this._onChange();
        }
    };
    /**
     * @param {?} c
     * @return {?}
     */
    PatternValidator.prototype.validate = function (c) { return this._validator(c); };
    /**
     * @param {?} fn
     * @return {?}
     */
    PatternValidator.prototype.registerOnValidatorChange = function (fn) { this._onChange = fn; };
    /**
     * @return {?}
     */
    PatternValidator.prototype._createValidator = function () { this._validator = __WEBPACK_IMPORTED_MODULE_1__validators__["a" /* Validators */].pattern(this.pattern); };
    PatternValidator.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: '[pattern][formControlName],[pattern][formControl],[pattern][ngModel]',
                    providers: [PATTERN_VALIDATOR],
                    host: { '[attr.pattern]': 'pattern ? pattern : null' }
                },] },
    ];
    /** @nocollapse */
    PatternValidator.ctorParameters = function () { return []; };
    PatternValidator.propDecorators = {
        'pattern': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return PatternValidator;
}());
function PatternValidator_tsickle_Closure_declarations() {
    /** @type {?} */
    PatternValidator.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    PatternValidator.ctorParameters;
    /** @type {?} */
    PatternValidator.propDecorators;
    /** @type {?} */
    PatternValidator.prototype._validator;
    /** @type {?} */
    PatternValidator.prototype._onChange;
    /** @type {?} */
    PatternValidator.prototype.pattern;
}
//# sourceMappingURL=validators.js.map

/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lang__ = __webpack_require__(113);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return StringMapWrapper; });
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return ListWrapper; });
/* unused harmony export isListLikeIterable */
/* unused harmony export areIterablesEqual */
/* unused harmony export iterateListLike */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * Wraps Javascript Objects
 */
var StringMapWrapper = (function () {
    function StringMapWrapper() {
    }
    /**
     * @param {?} m1
     * @param {?} m2
     * @return {?}
     */
    StringMapWrapper.merge = function (m1, m2) {
        var /** @type {?} */ m = {};
        for (var _i = 0, _a = Object.keys(m1); _i < _a.length; _i++) {
            var k = _a[_i];
            m[k] = m1[k];
        }
        for (var _b = 0, _c = Object.keys(m2); _b < _c.length; _b++) {
            var k = _c[_b];
            m[k] = m2[k];
        }
        return m;
    };
    /**
     * @param {?} m1
     * @param {?} m2
     * @return {?}
     */
    StringMapWrapper.equals = function (m1, m2) {
        var /** @type {?} */ k1 = Object.keys(m1);
        var /** @type {?} */ k2 = Object.keys(m2);
        if (k1.length != k2.length) {
            return false;
        }
        for (var /** @type {?} */ i = 0; i < k1.length; i++) {
            var /** @type {?} */ key = k1[i];
            if (m1[key] !== m2[key]) {
                return false;
            }
        }
        return true;
    };
    return StringMapWrapper;
}());
var ListWrapper = (function () {
    function ListWrapper() {
    }
    /**
     * @param {?} arr
     * @param {?} condition
     * @return {?}
     */
    ListWrapper.findLast = function (arr, condition) {
        for (var /** @type {?} */ i = arr.length - 1; i >= 0; i--) {
            if (condition(arr[i])) {
                return arr[i];
            }
        }
        return null;
    };
    /**
     * @param {?} list
     * @param {?} items
     * @return {?}
     */
    ListWrapper.removeAll = function (list, items) {
        for (var /** @type {?} */ i = 0; i < items.length; ++i) {
            var /** @type {?} */ index = list.indexOf(items[i]);
            if (index > -1) {
                list.splice(index, 1);
            }
        }
    };
    /**
     * @param {?} list
     * @param {?} el
     * @return {?}
     */
    ListWrapper.remove = function (list, el) {
        var /** @type {?} */ index = list.indexOf(el);
        if (index > -1) {
            list.splice(index, 1);
            return true;
        }
        return false;
    };
    /**
     * @param {?} a
     * @param {?} b
     * @return {?}
     */
    ListWrapper.equals = function (a, b) {
        if (a.length != b.length)
            return false;
        for (var /** @type {?} */ i = 0; i < a.length; ++i) {
            if (a[i] !== b[i])
                return false;
        }
        return true;
    };
    /**
     * @param {?} list
     * @return {?}
     */
    ListWrapper.flatten = function (list) {
        return list.reduce(function (flat, item) {
            var /** @type {?} */ flatItem = Array.isArray(item) ? ListWrapper.flatten(item) : item;
            return ((flat)).concat(flatItem);
        }, []);
    };
    return ListWrapper;
}());
/**
 * @param {?} obj
 * @return {?}
 */
function isListLikeIterable(obj) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lang__["a" /* isJsObject */])(obj))
        return false;
    return Array.isArray(obj) ||
        (!(obj instanceof Map) &&
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lang__["b" /* getSymbolIterator */])() in obj); // JS Iterable have a Symbol.iterator prop
}
/**
 * @param {?} a
 * @param {?} b
 * @param {?} comparator
 * @return {?}
 */
function areIterablesEqual(a, b, comparator) {
    var /** @type {?} */ iterator1 = a[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lang__["b" /* getSymbolIterator */])()]();
    var /** @type {?} */ iterator2 = b[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lang__["b" /* getSymbolIterator */])()]();
    while (true) {
        var /** @type {?} */ item1 = iterator1.next();
        var /** @type {?} */ item2 = iterator2.next();
        if (item1.done && item2.done)
            return true;
        if (item1.done || item2.done)
            return false;
        if (!comparator(item1.value, item2.value))
            return false;
    }
}
/**
 * @param {?} obj
 * @param {?} fn
 * @return {?}
 */
function iterateListLike(obj, fn) {
    if (Array.isArray(obj)) {
        for (var /** @type {?} */ i = 0; i < obj.length; i++) {
            fn(obj[i]);
        }
    }
    else {
        var /** @type {?} */ iterator = obj[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lang__["b" /* getSymbolIterator */])()]();
        var /** @type {?} */ item = void 0;
        while (!((item = iterator.next()).done)) {
            fn(item.value);
        }
    }
}
//# sourceMappingURL=collection.js.map

/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_lang__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model__ = __webpack_require__(193);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return FormBuilder; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */



/**
 * \@whatItDoes Creates an {\@link AbstractControl} from a user-specified configuration.
 *
 * It is essentially syntactic sugar that shortens the `new FormGroup()`,
 * `new FormControl()`, and `new FormArray()` boilerplate that can build up in larger
 * forms.
 *
 * \@howToUse
 *
 * To use, inject `FormBuilder` into your component class. You can then call its methods
 * directly.
 *
 * {\@example forms/ts/formBuilder/form_builder_example.ts region='Component'}
 *
 *  * **npm package**: `\@angular/forms`
 *
 *  * **NgModule**: {\@link ReactiveFormsModule}
 *
 * \@stable
 */
var FormBuilder = (function () {
    function FormBuilder() {
    }
    /**
     * Construct a new {\@link FormGroup} with the given map of configuration.
     * Valid keys for the `extra` parameter map are `validator` and `asyncValidator`.
     *
     * See the {\@link FormGroup} constructor for more details.
     * @param {?} controlsConfig
     * @param {?=} extra
     * @return {?}
     */
    FormBuilder.prototype.group = function (controlsConfig, extra) {
        if (extra === void 0) { extra = null; }
        var /** @type {?} */ controls = this._reduceControls(controlsConfig);
        var /** @type {?} */ validator = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["c" /* isPresent */])(extra) ? extra['validator'] : null;
        var /** @type {?} */ asyncValidator = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["c" /* isPresent */])(extra) ? extra['asyncValidator'] : null;
        return new __WEBPACK_IMPORTED_MODULE_2__model__["a" /* FormGroup */](controls, validator, asyncValidator);
    };
    /**
     * Construct a new {\@link FormControl} with the given `formState`,`validator`, and
     * `asyncValidator`.
     *
     * `formState` can either be a standalone value for the form control or an object
     * that contains both a value and a disabled status.
     *
     * @param {?} formState
     * @param {?=} validator
     * @param {?=} asyncValidator
     * @return {?}
     */
    FormBuilder.prototype.control = function (formState, validator, asyncValidator) {
        if (validator === void 0) { validator = null; }
        if (asyncValidator === void 0) { asyncValidator = null; }
        return new __WEBPACK_IMPORTED_MODULE_2__model__["b" /* FormControl */](formState, validator, asyncValidator);
    };
    /**
     * Construct a {\@link FormArray} from the given `controlsConfig` array of
     * configuration, with the given optional `validator` and `asyncValidator`.
     * @param {?} controlsConfig
     * @param {?=} validator
     * @param {?=} asyncValidator
     * @return {?}
     */
    FormBuilder.prototype.array = function (controlsConfig, validator, asyncValidator) {
        var _this = this;
        if (validator === void 0) { validator = null; }
        if (asyncValidator === void 0) { asyncValidator = null; }
        var /** @type {?} */ controls = controlsConfig.map(function (c) { return _this._createControl(c); });
        return new __WEBPACK_IMPORTED_MODULE_2__model__["c" /* FormArray */](controls, validator, asyncValidator);
    };
    /**
     * \@internal
     * @param {?} controlsConfig
     * @return {?}
     */
    FormBuilder.prototype._reduceControls = function (controlsConfig) {
        var _this = this;
        var /** @type {?} */ controls = {};
        Object.keys(controlsConfig).forEach(function (controlName) {
            controls[controlName] = _this._createControl(controlsConfig[controlName]);
        });
        return controls;
    };
    /**
     * \@internal
     * @param {?} controlConfig
     * @return {?}
     */
    FormBuilder.prototype._createControl = function (controlConfig) {
        if (controlConfig instanceof __WEBPACK_IMPORTED_MODULE_2__model__["b" /* FormControl */] || controlConfig instanceof __WEBPACK_IMPORTED_MODULE_2__model__["a" /* FormGroup */] ||
            controlConfig instanceof __WEBPACK_IMPORTED_MODULE_2__model__["c" /* FormArray */]) {
            return controlConfig;
        }
        else if (Array.isArray(controlConfig)) {
            var /** @type {?} */ value = controlConfig[0];
            var /** @type {?} */ validator = controlConfig.length > 1 ? controlConfig[1] : null;
            var /** @type {?} */ asyncValidator = controlConfig.length > 2 ? controlConfig[2] : null;
            return this.control(value, validator, asyncValidator);
        }
        else {
            return this.control(controlConfig);
        }
    };
    FormBuilder.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    FormBuilder.ctorParameters = function () { return []; };
    return FormBuilder;
}());
function FormBuilder_tsickle_Closure_declarations() {
    /** @type {?} */
    FormBuilder.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    FormBuilder.ctorParameters;
}
//# sourceMappingURL=form_builder.js.map

/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return isPromise; });
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return isObservable; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

var /** @type {?} */ isPromise = __WEBPACK_IMPORTED_MODULE_0__angular_core__["__core_private__"].isPromise;
var /** @type {?} */ isObservable = __WEBPACK_IMPORTED_MODULE_0__angular_core__["__core_private__"].isObservable;
//# sourceMappingURL=private_import_core.js.map

/***/ },
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_link__ = __webpack_require__(279);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return RouterLinkActive; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */



/**
 * \@whatItDoes Lets you add a CSS class to an element when the link's route becomes active.
 *
 * \@howToUse
 *
 * ```
 * <a routerLink="/user/bob" routerLinkActive="active-link">Bob</a>
 * ```
 *
 * \@description
 *
 * The RouterLinkActive directive lets you add a CSS class to an element when the link's route
 * becomes active.
 *
 * Consider the following example:
 *
 * ```
 * <a routerLink="/user/bob" routerLinkActive="active-link">Bob</a>
 * ```
 *
 * When the url is either '/user' or '/user/bob', the active-link class will
 * be added to the `a` tag. If the url changes, the class will be removed.
 *
 * You can set more than one class, as follows:
 *
 * ```
 * <a routerLink="/user/bob" routerLinkActive="class1 class2">Bob</a>
 * <a routerLink="/user/bob" [routerLinkActive]="['class1', 'class2']">Bob</a>
 * ```
 *
 * You can configure RouterLinkActive by passing `exact: true`. This will add the classes
 * only when the url matches the link exactly.
 *
 * ```
 * <a routerLink="/user/bob" routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:
 * true}">Bob</a>
 * ```
 *
 * You can assign the RouterLinkActive instance to a template variable and directly check
 * the `isActive` status.
 * ```
 * <a routerLink="/user/bob" routerLinkActive #rla="routerLinkActive">
 *   Bob {{ rla.isActive ? '(already open)' : ''}}
 * </a>
 * ```
 *
 * Finally, you can apply the RouterLinkActive directive to an ancestor of a RouterLink.
 *
 * ```
 * <div routerLinkActive="active-link" [routerLinkActiveOptions]="{exact: true}">
 *   <a routerLink="/user/jim">Jim</a>
 *   <a routerLink="/user/bob">Bob</a>
 * </div>
 * ```
 *
 * This will set the active-link class on the div tag if the url is either '/user/jim' or
 * '/user/bob'.
 *
 * \@ngModule RouterModule
 *
 * \@stable
 */
var RouterLinkActive = (function () {
    /**
     * @param {?} router
     * @param {?} element
     * @param {?} renderer
     * @param {?} cdr
     */
    function RouterLinkActive(router, element, renderer, cdr) {
        var _this = this;
        this.router = router;
        this.element = element;
        this.renderer = renderer;
        this.cdr = cdr;
        this.classes = [];
        this.active = false;
        this.routerLinkActiveOptions = { exact: false };
        this.subscription = router.events.subscribe(function (s) {
            if (s instanceof __WEBPACK_IMPORTED_MODULE_1__router__["b" /* NavigationEnd */]) {
                _this.update();
            }
        });
    }
    Object.defineProperty(RouterLinkActive.prototype, "isActive", {
        /**
         * @return {?}
         */
        get: function () { return this.active; },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    RouterLinkActive.prototype.ngAfterContentInit = function () {
        var _this = this;
        this.links.changes.subscribe(function (_) { return _this.update(); });
        this.linksWithHrefs.changes.subscribe(function (_) { return _this.update(); });
        this.update();
    };
    Object.defineProperty(RouterLinkActive.prototype, "routerLinkActive", {
        /**
         * @param {?} data
         * @return {?}
         */
        set: function (data) {
            var /** @type {?} */ classes = Array.isArray(data) ? data : data.split(' ');
            this.classes = classes.filter(function (c) { return !!c; });
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} changes
     * @return {?}
     */
    RouterLinkActive.prototype.ngOnChanges = function (changes) { this.update(); };
    /**
     * @return {?}
     */
    RouterLinkActive.prototype.ngOnDestroy = function () { this.subscription.unsubscribe(); };
    /**
     * @return {?}
     */
    RouterLinkActive.prototype.update = function () {
        var _this = this;
        if (!this.links || !this.linksWithHrefs || !this.router.navigated)
            return;
        var /** @type {?} */ hasActiveLinks = this.hasActiveLinks();
        // react only when status has changed to prevent unnecessary dom updates
        if (this.active !== hasActiveLinks) {
            this.active = hasActiveLinks;
            this.classes.forEach(function (c) { return _this.renderer.setElementClass(_this.element.nativeElement, c, hasActiveLinks); });
            this.cdr.detectChanges();
        }
    };
    /**
     * @param {?} router
     * @return {?}
     */
    RouterLinkActive.prototype.isLinkActive = function (router) {
        var _this = this;
        return function (link) {
            return router.isActive(link.urlTree, _this.routerLinkActiveOptions.exact);
        };
    };
    /**
     * @return {?}
     */
    RouterLinkActive.prototype.hasActiveLinks = function () {
        return this.links.some(this.isLinkActive(this.router)) ||
            this.linksWithHrefs.some(this.isLinkActive(this.router));
    };
    RouterLinkActive.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: '[routerLinkActive]',
                    exportAs: 'routerLinkActive',
                },] },
    ];
    /** @nocollapse */
    RouterLinkActive.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__router__["a" /* Router */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"], },
    ]; };
    RouterLinkActive.propDecorators = {
        'links': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChildren"], args: [__WEBPACK_IMPORTED_MODULE_2__router_link__["a" /* RouterLink */], { descendants: true },] },],
        'linksWithHrefs': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChildren"], args: [__WEBPACK_IMPORTED_MODULE_2__router_link__["b" /* RouterLinkWithHref */], { descendants: true },] },],
        'routerLinkActiveOptions': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'routerLinkActive': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return RouterLinkActive;
}());
function RouterLinkActive_tsickle_Closure_declarations() {
    /** @type {?} */
    RouterLinkActive.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    RouterLinkActive.ctorParameters;
    /** @type {?} */
    RouterLinkActive.propDecorators;
    /** @type {?} */
    RouterLinkActive.prototype.links;
    /** @type {?} */
    RouterLinkActive.prototype.linksWithHrefs;
    /** @type {?} */
    RouterLinkActive.prototype.classes;
    /** @type {?} */
    RouterLinkActive.prototype.subscription;
    /** @type {?} */
    RouterLinkActive.prototype.active;
    /** @type {?} */
    RouterLinkActive.prototype.routerLinkActiveOptions;
    /** @type {?} */
    RouterLinkActive.prototype.router;
    /** @type {?} */
    RouterLinkActive.prototype.element;
    /** @type {?} */
    RouterLinkActive.prototype.renderer;
    /** @type {?} */
    RouterLinkActive.prototype.cdr;
}
//# sourceMappingURL=router_link_active.js.map

/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_outlet_map__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared__ = __webpack_require__(56);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return RouterOutlet; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */



/**
 * \@whatItDoes Acts as a placeholder that Angular dynamically fills based on the current router
 * state.
 *
 * \@howToUse
 *
 * ```
 * <router-outlet></router-outlet>
 * <router-outlet name='left'></router-outlet>
 * <router-outlet name='right'></router-outlet>
 * ```
 *
 * A router outlet will emit an activate event any time a new component is being instantiated,
 * and a deactivate event when it is being destroyed.
 *
 * ```
 * <router-outlet
 *   (activate)='onActivate($event)'
 *   (deactivate)='onDeactivate($event)'></router-outlet>
 * ```
 * \@ngModule RouterModule
 *
 * \@stable
 */
var RouterOutlet = (function () {
    /**
     * @param {?} parentOutletMap
     * @param {?} location
     * @param {?} resolver
     * @param {?} name
     */
    function RouterOutlet(parentOutletMap, location, resolver, name) {
        this.parentOutletMap = parentOutletMap;
        this.location = location;
        this.resolver = resolver;
        this.name = name;
        this.activateEvents = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.deactivateEvents = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        parentOutletMap.registerOutlet(name ? name : __WEBPACK_IMPORTED_MODULE_2__shared__["a" /* PRIMARY_OUTLET */], this);
    }
    /**
     * @return {?}
     */
    RouterOutlet.prototype.ngOnDestroy = function () { this.parentOutletMap.removeOutlet(this.name ? this.name : __WEBPACK_IMPORTED_MODULE_2__shared__["a" /* PRIMARY_OUTLET */]); };
    Object.defineProperty(RouterOutlet.prototype, "locationInjector", {
        /**
         * @return {?}
         */
        get: function () { return this.location.injector; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RouterOutlet.prototype, "locationFactoryResolver", {
        /**
         * @return {?}
         */
        get: function () { return this.resolver; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RouterOutlet.prototype, "isActivated", {
        /**
         * @return {?}
         */
        get: function () { return !!this.activated; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RouterOutlet.prototype, "component", {
        /**
         * @return {?}
         */
        get: function () {
            if (!this.activated)
                throw new Error('Outlet is not activated');
            return this.activated.instance;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RouterOutlet.prototype, "activatedRoute", {
        /**
         * @return {?}
         */
        get: function () {
            if (!this.activated)
                throw new Error('Outlet is not activated');
            return this._activatedRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    RouterOutlet.prototype.detach = function () {
        if (!this.activated)
            throw new Error('Outlet is not activated');
        this.location.detach();
        var /** @type {?} */ r = this.activated;
        this.activated = null;
        this._activatedRoute = null;
        return r;
    };
    /**
     * @param {?} ref
     * @param {?} activatedRoute
     * @return {?}
     */
    RouterOutlet.prototype.attach = function (ref, activatedRoute) {
        this.activated = ref;
        this._activatedRoute = activatedRoute;
        this.location.insert(ref.hostView);
    };
    /**
     * @return {?}
     */
    RouterOutlet.prototype.deactivate = function () {
        if (this.activated) {
            var /** @type {?} */ c = this.component;
            this.activated.destroy();
            this.activated = null;
            this._activatedRoute = null;
            this.deactivateEvents.emit(c);
        }
    };
    /**
     * @param {?} activatedRoute
     * @param {?} resolver
     * @param {?} injector
     * @param {?} providers
     * @param {?} outletMap
     * @return {?}
     */
    RouterOutlet.prototype.activate = function (activatedRoute, resolver, injector, providers, outletMap) {
        if (this.isActivated) {
            throw new Error('Cannot activate an already activated outlet');
        }
        this.outletMap = outletMap;
        this._activatedRoute = activatedRoute;
        var /** @type {?} */ snapshot = activatedRoute._futureSnapshot;
        var /** @type {?} */ component = (snapshot._routeConfig.component);
        var /** @type {?} */ factory = resolver.resolveComponentFactory(component);
        var /** @type {?} */ inj = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ReflectiveInjector"].fromResolvedProviders(providers, injector);
        this.activated = this.location.createComponent(factory, this.location.length, inj, []);
        this.activated.changeDetectorRef.detectChanges();
        this.activateEvents.emit(this.activated.instance);
    };
    RouterOutlet.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: 'router-outlet' },] },
    ];
    /** @nocollapse */
    RouterOutlet.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__router_outlet_map__["a" /* RouterOutletMap */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ComponentFactoryResolver"], },
        { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Attribute"], args: ['name',] },] },
    ]; };
    RouterOutlet.propDecorators = {
        'activateEvents': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"], args: ['activate',] },],
        'deactivateEvents': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"], args: ['deactivate',] },],
    };
    return RouterOutlet;
}());
function RouterOutlet_tsickle_Closure_declarations() {
    /** @type {?} */
    RouterOutlet.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    RouterOutlet.ctorParameters;
    /** @type {?} */
    RouterOutlet.propDecorators;
    /** @type {?} */
    RouterOutlet.prototype.activated;
    /** @type {?} */
    RouterOutlet.prototype._activatedRoute;
    /** @type {?} */
    RouterOutlet.prototype.outletMap;
    /** @type {?} */
    RouterOutlet.prototype.activateEvents;
    /** @type {?} */
    RouterOutlet.prototype.deactivateEvents;
    /** @type {?} */
    RouterOutlet.prototype.parentOutletMap;
    /** @type {?} */
    RouterOutlet.prototype.location;
    /** @type {?} */
    RouterOutlet.prototype.resolver;
    /** @type {?} */
    RouterOutlet.prototype.name;
}
//# sourceMappingURL=router_outlet.js.map

/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return RouteReuseStrategy; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * \@whatItDoes Provides a way to customize when activated routes get reused.
 *
 * \@experimental
 * @abstract
 */
var RouteReuseStrategy = (function () {
    function RouteReuseStrategy() {
    }
    /**
     * Determines if this route (and its subtree) should be detached to be reused later
     * @abstract
     * @param {?} route
     * @return {?}
     */
    RouteReuseStrategy.prototype.shouldDetach = function (route) { };
    /**
     * Stores the detached route
     * @abstract
     * @param {?} route
     * @param {?} handle
     * @return {?}
     */
    RouteReuseStrategy.prototype.store = function (route, handle) { };
    /**
     * Determines if this route (and its subtree) should be reattached
     * @abstract
     * @param {?} route
     * @return {?}
     */
    RouteReuseStrategy.prototype.shouldAttach = function (route) { };
    /**
     * Retrieves the previously stored route
     * @abstract
     * @param {?} route
     * @return {?}
     */
    RouteReuseStrategy.prototype.retrieve = function (route) { };
    /**
     * Determines if a route should be reused
     * @abstract
     * @param {?} future
     * @param {?} curr
     * @return {?}
     */
    RouteReuseStrategy.prototype.shouldReuseRoute = function (future, curr) { };
    return RouteReuseStrategy;
}());
//# sourceMappingURL=route_reuse_strategy.js.map

/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_common__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_Subject__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_Subject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_Subject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__directives_router_link__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__directives_router_link_active__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__directives_router_outlet__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__private_import_platform_browser__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__route_reuse_strategy__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__router__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__router_config_loader__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__router_outlet_map__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__router_preloader__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__router_state__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__url_handling_strategy__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__url_tree__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_collection__ = __webpack_require__(61);
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return ROUTER_CONFIGURATION; });
/* unused harmony export ROUTER_FORROOT_GUARD */
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return ROUTER_PROVIDERS; });
/* unused harmony export routerNgProbeToken */
/* harmony export (binding) */ __webpack_require__.d(exports, "d", function() { return RouterModule; });
/* unused harmony export provideLocationStrategy */
/* unused harmony export provideForRootGuard */
/* harmony export (immutable) */ exports["e"] = provideRoutes;
/* unused harmony export setupRouter */
/* unused harmony export rootRoute */
/* unused harmony export RouterInitializer */
/* unused harmony export getAppInitializer */
/* unused harmony export getBootstrapListener */
/* harmony export (binding) */ __webpack_require__.d(exports, "c", function() { return ROUTER_INITIALIZER; });
/* unused harmony export provideRouterInitializer */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

















/**
 * @whatItDoes Contains a list of directives
 * @stable
 */
var /** @type {?} */ ROUTER_DIRECTIVES = [__WEBPACK_IMPORTED_MODULE_6__directives_router_outlet__["a" /* RouterOutlet */], __WEBPACK_IMPORTED_MODULE_4__directives_router_link__["a" /* RouterLink */], __WEBPACK_IMPORTED_MODULE_4__directives_router_link__["b" /* RouterLinkWithHref */], __WEBPACK_IMPORTED_MODULE_5__directives_router_link_active__["a" /* RouterLinkActive */]];
/**
 * @whatItDoes Is used in DI to configure the router.
 * @stable
 */
var /** @type {?} */ ROUTER_CONFIGURATION = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["OpaqueToken"]('ROUTER_CONFIGURATION');
/**
 * @docsNotRequired
 */
var /** @type {?} */ ROUTER_FORROOT_GUARD = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["OpaqueToken"]('ROUTER_FORROOT_GUARD');
var /** @type {?} */ ROUTER_PROVIDERS = [
    __WEBPACK_IMPORTED_MODULE_0__angular_common__["Location"],
    { provide: __WEBPACK_IMPORTED_MODULE_15__url_tree__["h" /* UrlSerializer */], useClass: __WEBPACK_IMPORTED_MODULE_15__url_tree__["i" /* DefaultUrlSerializer */] },
    {
        provide: __WEBPACK_IMPORTED_MODULE_9__router__["a" /* Router */],
        useFactory: setupRouter,
        deps: [
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["ApplicationRef"], __WEBPACK_IMPORTED_MODULE_15__url_tree__["h" /* UrlSerializer */], __WEBPACK_IMPORTED_MODULE_11__router_outlet_map__["a" /* RouterOutletMap */], __WEBPACK_IMPORTED_MODULE_0__angular_common__["Location"], __WEBPACK_IMPORTED_MODULE_1__angular_core__["Injector"], __WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModuleFactoryLoader"],
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["Compiler"], __WEBPACK_IMPORTED_MODULE_10__router_config_loader__["c" /* ROUTES */], ROUTER_CONFIGURATION, [__WEBPACK_IMPORTED_MODULE_14__url_handling_strategy__["b" /* UrlHandlingStrategy */], new __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"]()],
            [__WEBPACK_IMPORTED_MODULE_8__route_reuse_strategy__["a" /* RouteReuseStrategy */], new __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"]()]
        ]
    },
    __WEBPACK_IMPORTED_MODULE_11__router_outlet_map__["a" /* RouterOutletMap */],
    { provide: __WEBPACK_IMPORTED_MODULE_13__router_state__["b" /* ActivatedRoute */], useFactory: rootRoute, deps: [__WEBPACK_IMPORTED_MODULE_9__router__["a" /* Router */]] },
    { provide: __WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModuleFactoryLoader"], useClass: __WEBPACK_IMPORTED_MODULE_1__angular_core__["SystemJsNgModuleLoader"] },
    __WEBPACK_IMPORTED_MODULE_12__router_preloader__["a" /* RouterPreloader */],
    __WEBPACK_IMPORTED_MODULE_12__router_preloader__["b" /* NoPreloading */],
    __WEBPACK_IMPORTED_MODULE_12__router_preloader__["c" /* PreloadAllModules */],
    { provide: ROUTER_CONFIGURATION, useValue: { enableTracing: false } },
];
/**
 * @return {?}
 */
function routerNgProbeToken() {
    return new __WEBPACK_IMPORTED_MODULE_1__angular_core__["NgProbeToken"]('Router', __WEBPACK_IMPORTED_MODULE_9__router__["a" /* Router */]);
}
/**
 * \@whatItDoes Adds router directives and providers.
 *
 * \@howToUse
 *
 * RouterModule can be imported multiple times: once per lazily-loaded bundle.
 * Since the router deals with a global shared resource--location, we cannot have
 * more than one router service active.
 *
 * That is why there are two ways to create the module: `RouterModule.forRoot` and
 * `RouterModule.forChild`.
 *
 * * `forRoot` creates a module that contains all the directives, the given routes, and the router
 *   service itself.
 * * `forChild` creates a module that contains all the directives and the given routes, but does not
 *   include the router service.
 *
 * When registered at the root, the module should be used as follows
 *
 * ```
 * \@NgModule({
 *   imports: [RouterModule.forRoot(ROUTES)]
 * })
 * class MyNgModule {}
 * ```
 *
 * For submodules and lazy loaded submodules the module should be used as follows:
 *
 * ```
 * \@NgModule({
 *   imports: [RouterModule.forChild(ROUTES)]
 * })
 * class MyNgModule {}
 * ```
 *
 * \@description
 *
 * Managing state transitions is one of the hardest parts of building applications. This is
 * especially true on the web, where you also need to ensure that the state is reflected in the URL.
 * In addition, we often want to split applications into multiple bundles and load them on demand.
 * Doing this transparently is not trivial.
 *
 * The Angular 2 router solves these problems. Using the router, you can declaratively specify
 * application states, manage state transitions while taking care of the URL, and load bundles on
 * demand.
 *
 * [Read this developer guide](https://angular.io/docs/ts/latest/guide/router.html) to get an
 * overview of how the router should be used.
 *
 * \@stable
 */
var RouterModule = (function () {
    /**
     * @param {?} guard
     */
    function RouterModule(guard) {
    }
    /**
     * Creates a module with all the router providers and directives. It also optionally sets up an
     * application listener to perform an initial navigation.
     *
     * Options:
     * * `enableTracing` makes the router log all its internal events to the console.
     * * `useHash` enables the location strategy that uses the URL fragment instead of the history
     * API.
     * * `initialNavigation` disables the initial navigation.
     * * `errorHandler` provides a custom error handler.
     * @param {?} routes
     * @param {?=} config
     * @return {?}
     */
    RouterModule.forRoot = function (routes, config) {
        return {
            ngModule: RouterModule,
            providers: [
                ROUTER_PROVIDERS,
                provideRoutes(routes),
                {
                    provide: ROUTER_FORROOT_GUARD,
                    useFactory: provideForRootGuard,
                    deps: [[__WEBPACK_IMPORTED_MODULE_9__router__["a" /* Router */], new __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"](), new __WEBPACK_IMPORTED_MODULE_1__angular_core__["SkipSelf"]()]]
                },
                { provide: ROUTER_CONFIGURATION, useValue: config ? config : {} },
                {
                    provide: __WEBPACK_IMPORTED_MODULE_0__angular_common__["LocationStrategy"],
                    useFactory: provideLocationStrategy,
                    deps: [
                        __WEBPACK_IMPORTED_MODULE_0__angular_common__["PlatformLocation"], [new __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"](__WEBPACK_IMPORTED_MODULE_0__angular_common__["APP_BASE_HREF"]), new __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"]()], ROUTER_CONFIGURATION
                    ]
                },
                {
                    provide: __WEBPACK_IMPORTED_MODULE_12__router_preloader__["d" /* PreloadingStrategy */],
                    useExisting: config && config.preloadingStrategy ? config.preloadingStrategy :
                        __WEBPACK_IMPORTED_MODULE_12__router_preloader__["b" /* NoPreloading */]
                },
                { provide: __WEBPACK_IMPORTED_MODULE_1__angular_core__["NgProbeToken"], multi: true, useFactory: routerNgProbeToken },
                provideRouterInitializer(),
            ],
        };
    };
    /**
     * Creates a module with all the router directives and a provider registering routes.
     * @param {?} routes
     * @return {?}
     */
    RouterModule.forChild = function (routes) {
        return { ngModule: RouterModule, providers: [provideRoutes(routes)] };
    };
    RouterModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModule"], args: [{ declarations: ROUTER_DIRECTIVES, exports: ROUTER_DIRECTIVES },] },
    ];
    /** @nocollapse */
    RouterModule.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [ROUTER_FORROOT_GUARD,] },] },
    ]; };
    return RouterModule;
}());
function RouterModule_tsickle_Closure_declarations() {
    /** @type {?} */
    RouterModule.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    RouterModule.ctorParameters;
}
/**
 * @param {?} platformLocationStrategy
 * @param {?} baseHref
 * @param {?=} options
 * @return {?}
 */
function provideLocationStrategy(platformLocationStrategy, baseHref, options) {
    if (options === void 0) { options = {}; }
    return options.useHash ? new __WEBPACK_IMPORTED_MODULE_0__angular_common__["HashLocationStrategy"](platformLocationStrategy, baseHref) :
        new __WEBPACK_IMPORTED_MODULE_0__angular_common__["PathLocationStrategy"](platformLocationStrategy, baseHref);
}
/**
 * @param {?} router
 * @return {?}
 */
function provideForRootGuard(router) {
    if (router) {
        throw new Error("RouterModule.forRoot() called twice. Lazy loaded modules should use RouterModule.forChild() instead.");
    }
    return 'guarded';
}
/**
 * \@whatItDoes Registers routes.
 *
 * \@howToUse
 *
 * ```
 * \@NgModule({
 *   imports: [RouterModule.forChild(ROUTES)],
 *   providers: [provideRoutes(EXTRA_ROUTES)]
 * })
 * class MyNgModule {}
 * ```
 *
 * \@stable
 * @param {?} routes
 * @return {?}
 */
function provideRoutes(routes) {
    return [
        { provide: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ANALYZE_FOR_ENTRY_COMPONENTS"], multi: true, useValue: routes },
        { provide: __WEBPACK_IMPORTED_MODULE_10__router_config_loader__["c" /* ROUTES */], multi: true, useValue: routes },
    ];
}
/**
 * @param {?} ref
 * @param {?} urlSerializer
 * @param {?} outletMap
 * @param {?} location
 * @param {?} injector
 * @param {?} loader
 * @param {?} compiler
 * @param {?} config
 * @param {?=} opts
 * @param {?=} urlHandlingStrategy
 * @param {?=} routeReuseStrategy
 * @return {?}
 */
function setupRouter(ref, urlSerializer, outletMap, location, injector, loader, compiler, config, opts, urlHandlingStrategy, routeReuseStrategy) {
    if (opts === void 0) { opts = {}; }
    var /** @type {?} */ router = new __WEBPACK_IMPORTED_MODULE_9__router__["a" /* Router */](null, urlSerializer, outletMap, location, injector, loader, compiler, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_collection__["a" /* flatten */])(config));
    if (urlHandlingStrategy) {
        router.urlHandlingStrategy = urlHandlingStrategy;
    }
    if (routeReuseStrategy) {
        router.routeReuseStrategy = routeReuseStrategy;
    }
    if (opts.errorHandler) {
        router.errorHandler = opts.errorHandler;
    }
    if (opts.enableTracing) {
        var /** @type {?} */ dom_1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__private_import_platform_browser__["a" /* getDOM */])();
        router.events.subscribe(function (e) {
            dom_1.logGroup("Router Event: " + ((e.constructor)).name);
            dom_1.log(e.toString());
            dom_1.log(e);
            dom_1.logGroupEnd();
        });
    }
    return router;
}
/**
 * @param {?} router
 * @return {?}
 */
function rootRoute(router) {
    return router.routerState.root;
}
/**
 * To initialize the router properly we need to do in two steps:
 *
 * We need to start the navigation in a APP_INITIALIZER to block the bootstrap if
 * a resolver or a guards executes asynchronously. Second, we need to actually run
 * activation in a BOOTSTRAP_LISTENER. We utilize the afterPreactivation
 * hook provided by the router to do that.
 *
 * The router navigation starts, reaches the point when preactivation is done, and then
 * pauses. It waits for the hook to be resolved. We then resolve it only in a bootstrap listener.
 */
var RouterInitializer = (function () {
    /**
     * @param {?} injector
     */
    function RouterInitializer(injector) {
        this.injector = injector;
        this.initNavigation = false;
        this.resultOfPreactivationDone = new __WEBPACK_IMPORTED_MODULE_2_rxjs_Subject__["Subject"]();
    }
    /**
     * @return {?}
     */
    RouterInitializer.prototype.appInitializer = function () {
        var _this = this;
        var /** @type {?} */ p = this.injector.get(__WEBPACK_IMPORTED_MODULE_0__angular_common__["LOCATION_INITIALIZED"], Promise.resolve(null));
        return p.then(function () {
            var /** @type {?} */ resolve = null;
            var /** @type {?} */ res = new Promise(function (r) { return resolve = r; });
            var /** @type {?} */ router = _this.injector.get(__WEBPACK_IMPORTED_MODULE_9__router__["a" /* Router */]);
            var /** @type {?} */ opts = _this.injector.get(ROUTER_CONFIGURATION);
            if (_this.isLegacyDisabled(opts) || _this.isLegacyEnabled(opts)) {
                resolve(true);
            }
            else if (opts.initialNavigation === 'disabled') {
                router.setUpLocationChangeListener();
                resolve(true);
            }
            else if (opts.initialNavigation === 'enabled') {
                router.hooks.afterPreactivation = function () {
                    // only the initial navigation should be delayed
                    if (!_this.initNavigation) {
                        _this.initNavigation = true;
                        resolve(true);
                        return _this.resultOfPreactivationDone;
                    }
                    else {
                        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(null);
                    }
                };
                router.initialNavigation();
            }
            else {
                throw new Error("Invalid initialNavigation options: '" + opts.initialNavigation + "'");
            }
            return res;
        });
    };
    /**
     * @param {?} bootstrappedComponentRef
     * @return {?}
     */
    RouterInitializer.prototype.bootstrapListener = function (bootstrappedComponentRef) {
        var /** @type {?} */ opts = this.injector.get(ROUTER_CONFIGURATION);
        var /** @type {?} */ preloader = this.injector.get(__WEBPACK_IMPORTED_MODULE_12__router_preloader__["a" /* RouterPreloader */]);
        var /** @type {?} */ router = this.injector.get(__WEBPACK_IMPORTED_MODULE_9__router__["a" /* Router */]);
        var /** @type {?} */ ref = this.injector.get(__WEBPACK_IMPORTED_MODULE_1__angular_core__["ApplicationRef"]);
        if (bootstrappedComponentRef !== ref.components[0]) {
            return;
        }
        if (this.isLegacyEnabled(opts)) {
            router.initialNavigation();
        }
        else if (this.isLegacyDisabled(opts)) {
            router.setUpLocationChangeListener();
        }
        preloader.setUpPreloading();
        router.resetRootComponentType(ref.componentTypes[0]);
        this.resultOfPreactivationDone.next(null);
        this.resultOfPreactivationDone.complete();
    };
    /**
     * @param {?} opts
     * @return {?}
     */
    RouterInitializer.prototype.isLegacyEnabled = function (opts) {
        return opts.initialNavigation === 'legacy_enabled' || opts.initialNavigation === true ||
            opts.initialNavigation === undefined;
    };
    /**
     * @param {?} opts
     * @return {?}
     */
    RouterInitializer.prototype.isLegacyDisabled = function (opts) {
        return opts.initialNavigation === 'legacy_disabled' || opts.initialNavigation === false;
    };
    RouterInitializer.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    RouterInitializer.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Injector"], },
    ]; };
    return RouterInitializer;
}());
function RouterInitializer_tsickle_Closure_declarations() {
    /** @type {?} */
    RouterInitializer.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    RouterInitializer.ctorParameters;
    /** @type {?} */
    RouterInitializer.prototype.initNavigation;
    /** @type {?} */
    RouterInitializer.prototype.resultOfPreactivationDone;
    /** @type {?} */
    RouterInitializer.prototype.injector;
}
/**
 * @param {?} r
 * @return {?}
 */
function getAppInitializer(r) {
    return r.appInitializer.bind(r);
}
/**
 * @param {?} r
 * @return {?}
 */
function getBootstrapListener(r) {
    return r.bootstrapListener.bind(r);
}
/**
 * A token for the router initializer that will be called after the app is bootstrapped.
 *
 * @experimental
 */
var /** @type {?} */ ROUTER_INITIALIZER = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["OpaqueToken"]('Router Initializer');
/**
 * @return {?}
 */
function provideRouterInitializer() {
    return [
        RouterInitializer,
        {
            provide: __WEBPACK_IMPORTED_MODULE_1__angular_core__["APP_INITIALIZER"],
            multi: true,
            useFactory: getAppInitializer,
            deps: [RouterInitializer]
        },
        { provide: ROUTER_INITIALIZER, useFactory: getBootstrapListener, deps: [RouterInitializer] },
        { provide: __WEBPACK_IMPORTED_MODULE_1__angular_core__["APP_BOOTSTRAP_LISTENER"], multi: true, useExisting: ROUTER_INITIALIZER },
    ];
}
//# sourceMappingURL=router_module.js.map

/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_observable_from__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_observable_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_observable_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_observable_of__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_observable_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_catch__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_catch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_operator_catch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_concatMap__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_concatMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_operator_concatMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_operator_filter__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_operator_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_rxjs_operator_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_mergeAll__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_mergeAll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs_operator_mergeAll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_operator_mergeMap__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_operator_mergeMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_rxjs_operator_mergeMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__router_config_loader__ = __webpack_require__(146);
/* harmony export (binding) */ __webpack_require__.d(exports, "d", function() { return PreloadingStrategy; });
/* harmony export (binding) */ __webpack_require__.d(exports, "c", function() { return PreloadAllModules; });
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return NoPreloading; });
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return RouterPreloader; });
/**
*@license
*Copyright Google Inc. All Rights Reserved.
*
*Use of this source code is governed by an MIT-style license that can be
*found in the LICENSE file at https://angular.io/license
*/










/**
 * \@whatItDoes Provides a preloading strategy.
 *
 * \@experimental
 * @abstract
 */
var PreloadingStrategy = (function () {
    function PreloadingStrategy() {
    }
    /**
     * @abstract
     * @param {?} route
     * @param {?} fn
     * @return {?}
     */
    PreloadingStrategy.prototype.preload = function (route, fn) { };
    return PreloadingStrategy;
}());
/**
 * \@whatItDoes Provides a preloading strategy that preloads all modules as quicky as possible.
 *
 * \@howToUse
 *
 * ```
 * RouteModule.forRoot(ROUTES, {preloadingStrategy: PreloadAllModules})
 * ```
 *
 * \@experimental
 */
var PreloadAllModules = (function () {
    function PreloadAllModules() {
    }
    /**
     * @param {?} route
     * @param {?} fn
     * @return {?}
     */
    PreloadAllModules.prototype.preload = function (route, fn) {
        return __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_catch__["_catch"].call(fn(), function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_of__["of"])(null); });
    };
    return PreloadAllModules;
}());
/**
 * \@whatItDoes Provides a preloading strategy that does not preload any modules.
 *
 * \@description
 *
 * This strategy is enabled by default.
 *
 * \@experimental
 */
var NoPreloading = (function () {
    function NoPreloading() {
    }
    /**
     * @param {?} route
     * @param {?} fn
     * @return {?}
     */
    NoPreloading.prototype.preload = function (route, fn) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_of__["of"])(null); };
    return NoPreloading;
}());
/**
 * The preloader optimistically loads all router configurations to
 * make navigations into lazily-loaded sections of the application faster.
 *
 * The preloader runs in the background. When the router bootstraps, the preloader
 * starts listening to all navigation events. After every such event, the preloader
 * will check if any configurations can be loaded lazily.
 *
 * If a route is protected by `canLoad` guards, the preloaded will not load it.
 *
 * \@stable
 */
var RouterPreloader = (function () {
    /**
     * @param {?} router
     * @param {?} moduleLoader
     * @param {?} compiler
     * @param {?} injector
     * @param {?} preloadingStrategy
     */
    function RouterPreloader(router, moduleLoader, compiler, injector, preloadingStrategy) {
        this.router = router;
        this.injector = injector;
        this.preloadingStrategy = preloadingStrategy;
        this.loader = new __WEBPACK_IMPORTED_MODULE_9__router_config_loader__["b" /* RouterConfigLoader */](moduleLoader, compiler);
    }
    ;
    /**
     * @return {?}
     */
    RouterPreloader.prototype.setUpPreloading = function () {
        var _this = this;
        var /** @type {?} */ navigations = __WEBPACK_IMPORTED_MODULE_5_rxjs_operator_filter__["filter"].call(this.router.events, function (e) { return e instanceof __WEBPACK_IMPORTED_MODULE_8__router__["b" /* NavigationEnd */]; });
        this.subscription = __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_concatMap__["concatMap"].call(navigations, function () { return _this.preload(); }).subscribe(function (v) { });
    };
    /**
     * @return {?}
     */
    RouterPreloader.prototype.preload = function () { return this.processRoutes(this.injector, this.router.config); };
    /**
     * @return {?}
     */
    RouterPreloader.prototype.ngOnDestroy = function () { this.subscription.unsubscribe(); };
    /**
     * @param {?} injector
     * @param {?} routes
     * @return {?}
     */
    RouterPreloader.prototype.processRoutes = function (injector, routes) {
        var /** @type {?} */ res = [];
        for (var _i = 0, routes_1 = routes; _i < routes_1.length; _i++) {
            var c = routes_1[_i];
            // we already have the config loaded, just recurse
            if (c.loadChildren && !c.canLoad && ((c))._loadedConfig) {
                var /** @type {?} */ childConfig = ((c))._loadedConfig;
                res.push(this.processRoutes(childConfig.injector, childConfig.routes));
            }
            else if (c.loadChildren && !c.canLoad) {
                res.push(this.preloadConfig(injector, c));
            }
            else if (c.children) {
                res.push(this.processRoutes(injector, c.children));
            }
        }
        return __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_mergeAll__["mergeAll"].call(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_rxjs_observable_from__["from"])(res));
    };
    /**
     * @param {?} injector
     * @param {?} route
     * @return {?}
     */
    RouterPreloader.prototype.preloadConfig = function (injector, route) {
        var _this = this;
        return this.preloadingStrategy.preload(route, function () {
            var /** @type {?} */ loaded = _this.loader.load(injector, route.loadChildren);
            return __WEBPACK_IMPORTED_MODULE_7_rxjs_operator_mergeMap__["mergeMap"].call(loaded, function (config) {
                var /** @type {?} */ c = route;
                c._loadedConfig = config;
                return _this.processRoutes(config.injector, config.routes);
            });
        });
    };
    RouterPreloader.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    RouterPreloader.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_8__router__["a" /* Router */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModuleFactoryLoader"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Compiler"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injector"], },
        { type: PreloadingStrategy, },
    ]; };
    return RouterPreloader;
}());
function RouterPreloader_tsickle_Closure_declarations() {
    /** @type {?} */
    RouterPreloader.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    RouterPreloader.ctorParameters;
    /** @type {?} */
    RouterPreloader.prototype.loader;
    /** @type {?} */
    RouterPreloader.prototype.subscription;
    /** @type {?} */
    RouterPreloader.prototype.router;
    /** @type {?} */
    RouterPreloader.prototype.injector;
    /** @type {?} */
    RouterPreloader.prototype.preloadingStrategy;
}
//# sourceMappingURL=router_preloader.js.map

/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_operator_enterZone__ = __webpack_require__(634);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_operator_leaveZone__ = __webpack_require__(635);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_operator_select__ = __webpack_require__(636);
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__src_operator_select__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_compose__ = __webpack_require__(633);
/* unused harmony namespace reexport */




//# sourceMappingURL=index.js.map

/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return STORE_DEVTOOLS_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return INITIAL_OPTIONS; });

var STORE_DEVTOOLS_CONFIG = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["OpaqueToken"]('@ngrx/devtools Options');
var INITIAL_OPTIONS = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["OpaqueToken"]('@ngrx/devtools Initial Config');
//# sourceMappingURL=config.js.map

/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ngrx_store__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_ReplaySubject__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_ReplaySubject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_ReplaySubject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_map__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_merge__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_operator_merge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_operator_observeOn__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_operator_observeOn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_rxjs_operator_observeOn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_scan__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_scan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs_operator_scan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_operator_skip__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_operator_skip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_rxjs_operator_skip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs_operator_withLatestFrom__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs_operator_withLatestFrom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_rxjs_operator_withLatestFrom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rxjs_scheduler_queue__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rxjs_scheduler_queue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_rxjs_scheduler_queue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__extension__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__reducer__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__actions__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__config__ = __webpack_require__(417);
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return DevtoolsDispatcher; });
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return StoreDevtools; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();















var DevtoolsDispatcher = (function (_super) {
    __extends(DevtoolsDispatcher, _super);
    function DevtoolsDispatcher() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return DevtoolsDispatcher;
}(__WEBPACK_IMPORTED_MODULE_1__ngrx_store__["Dispatcher"]));

DevtoolsDispatcher.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
];
/** @nocollapse */
DevtoolsDispatcher.ctorParameters = function () { return []; };
var StoreDevtools = (function () {
    function StoreDevtools(dispatcher, actions$, reducers$, extension, initialState, config) {
        var liftedInitialState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__reducer__["a" /* liftInitialState */])(initialState, config.monitor);
        var liftReducer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__reducer__["b" /* liftReducerWith */])(initialState, liftedInitialState, config.monitor, {
            maxAge: config.maxAge
        });
        var liftedAction$ = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils__["a" /* applyOperators */])(actions$, [
            [__WEBPACK_IMPORTED_MODULE_7_rxjs_operator_skip__["skip"], 1],
            [__WEBPACK_IMPORTED_MODULE_4_rxjs_operator_merge__["merge"], extension.actions$],
            [__WEBPACK_IMPORTED_MODULE_3_rxjs_operator_map__["map"], __WEBPACK_IMPORTED_MODULE_11__utils__["b" /* liftAction */]],
            [__WEBPACK_IMPORTED_MODULE_4_rxjs_operator_merge__["merge"], dispatcher, extension.liftedActions$],
            [__WEBPACK_IMPORTED_MODULE_5_rxjs_operator_observeOn__["observeOn"], __WEBPACK_IMPORTED_MODULE_9_rxjs_scheduler_queue__["queue"]]
        ]);
        var liftedReducer$ = __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_map__["map"].call(reducers$, liftReducer);
        var liftedStateSubject = new __WEBPACK_IMPORTED_MODULE_2_rxjs_ReplaySubject__["ReplaySubject"](1);
        var liftedStateSubscription = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils__["a" /* applyOperators */])(liftedAction$, [
            [__WEBPACK_IMPORTED_MODULE_8_rxjs_operator_withLatestFrom__["withLatestFrom"], liftedReducer$],
            [__WEBPACK_IMPORTED_MODULE_6_rxjs_operator_scan__["scan"], function (liftedState, _a) {
                    var action = _a[0], reducer = _a[1];
                    var nextState = reducer(liftedState, action);
                    extension.notify(action, nextState);
                    return nextState;
                }, liftedInitialState]
        ]).subscribe(liftedStateSubject);
        var liftedState$ = liftedStateSubject.asObservable();
        var state$ = __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_map__["map"].call(liftedState$, __WEBPACK_IMPORTED_MODULE_11__utils__["d" /* unliftState */]);
        this.stateSubscription = liftedStateSubscription;
        this.dispatcher = dispatcher;
        this.liftedState = liftedState$;
        this.state = state$;
    }
    StoreDevtools.prototype.dispatch = function (action) {
        this.dispatcher.dispatch(action);
    };
    StoreDevtools.prototype.next = function (action) {
        this.dispatcher.dispatch(action);
    };
    StoreDevtools.prototype.error = function (error) { };
    StoreDevtools.prototype.complete = function () { };
    StoreDevtools.prototype.performAction = function (action) {
        this.dispatch(__WEBPACK_IMPORTED_MODULE_13__actions__["a" /* StoreDevtoolActions */].performAction(action));
    };
    StoreDevtools.prototype.reset = function () {
        this.dispatch(__WEBPACK_IMPORTED_MODULE_13__actions__["a" /* StoreDevtoolActions */].reset());
    };
    StoreDevtools.prototype.rollback = function () {
        this.dispatch(__WEBPACK_IMPORTED_MODULE_13__actions__["a" /* StoreDevtoolActions */].rollback());
    };
    StoreDevtools.prototype.commit = function () {
        this.dispatch(__WEBPACK_IMPORTED_MODULE_13__actions__["a" /* StoreDevtoolActions */].commit());
    };
    StoreDevtools.prototype.sweep = function () {
        this.dispatch(__WEBPACK_IMPORTED_MODULE_13__actions__["a" /* StoreDevtoolActions */].sweep());
    };
    StoreDevtools.prototype.toggleAction = function (id) {
        this.dispatch(__WEBPACK_IMPORTED_MODULE_13__actions__["a" /* StoreDevtoolActions */].toggleAction(id));
    };
    StoreDevtools.prototype.jumpToState = function (index) {
        this.dispatch(__WEBPACK_IMPORTED_MODULE_13__actions__["a" /* StoreDevtoolActions */].jumpToState(index));
    };
    StoreDevtools.prototype.importState = function (nextLiftedState) {
        this.dispatch(__WEBPACK_IMPORTED_MODULE_13__actions__["a" /* StoreDevtoolActions */].importState(nextLiftedState));
    };
    return StoreDevtools;
}());

StoreDevtools.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
];
/** @nocollapse */
StoreDevtools.ctorParameters = function () { return [
    { type: DevtoolsDispatcher, },
    { type: __WEBPACK_IMPORTED_MODULE_1__ngrx_store__["Dispatcher"], },
    { type: __WEBPACK_IMPORTED_MODULE_1__ngrx_store__["Reducer"], },
    { type: __WEBPACK_IMPORTED_MODULE_10__extension__["a" /* DevtoolsExtension */], },
    { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_1__ngrx_store__["INITIAL_STATE"],] },] },
    { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_14__config__["a" /* STORE_DEVTOOLS_CONFIG */],] },] },
]; };
//# sourceMappingURL=devtools.js.map

/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_observable_empty__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_observable_empty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_empty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_filter__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_operator_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_map__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_operator_share__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_operator_share___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_rxjs_operator_share__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_switchMap__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_switchMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs_operator_switchMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_operator_takeUntil__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_operator_takeUntil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_rxjs_operator_takeUntil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(284);
/* unused harmony export ExtensionActionTypes */
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return REDUX_DEVTOOLS_EXTENSION; });
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return DevtoolsExtension; });









var ExtensionActionTypes = {
    START: 'START',
    DISPATCH: 'DISPATCH',
    STOP: 'STOP',
    ACTION: 'ACTION'
};
var REDUX_DEVTOOLS_EXTENSION = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["OpaqueToken"]('Redux Devtools Extension');
var DevtoolsExtension = (function () {
    function DevtoolsExtension(devtoolsExtension) {
        this.instanceId = "ngrx-store-" + Date.now();
        this.devtoolsExtension = devtoolsExtension;
        this.createActionStreams();
    }
    DevtoolsExtension.prototype.notify = function (action, state) {
        if (!this.devtoolsExtension) {
            return;
        }
        this.devtoolsExtension.send(null, state, false, this.instanceId);
    };
    DevtoolsExtension.prototype.createChangesObservable = function () {
        var _this = this;
        if (!this.devtoolsExtension) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_empty__["empty"])();
        }
        return new __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"](function (subscriber) {
            var connection = _this.devtoolsExtension.connect({ instanceId: _this.instanceId });
            connection.subscribe(function (change) { return subscriber.next(change); });
            return connection.unsubscribe;
        });
    };
    DevtoolsExtension.prototype.createActionStreams = function () {
        var _this = this;
        // Listens to all changes based on our instanceId
        var changes$ = __WEBPACK_IMPORTED_MODULE_5_rxjs_operator_share__["share"].call(this.createChangesObservable());
        // Listen for the start action
        var start$ = __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_filter__["filter"].call(changes$, function (change) { return change.type === ExtensionActionTypes.START; });
        // Listen for the stop action
        var stop$ = __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_filter__["filter"].call(changes$, function (change) { return change.type === ExtensionActionTypes.STOP; });
        // Listen for lifted actions
        var liftedActions$ = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils__["a" /* applyOperators */])(changes$, [
            [__WEBPACK_IMPORTED_MODULE_3_rxjs_operator_filter__["filter"], function (change) { return change.type === ExtensionActionTypes.DISPATCH; }],
            [__WEBPACK_IMPORTED_MODULE_4_rxjs_operator_map__["map"], function (change) { return _this.unwrapAction(change.payload); }]
        ]);
        // Listen for unlifted actions
        var actions$ = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils__["a" /* applyOperators */])(changes$, [
            [__WEBPACK_IMPORTED_MODULE_3_rxjs_operator_filter__["filter"], function (change) { return change.type === ExtensionActionTypes.ACTION; }],
            [__WEBPACK_IMPORTED_MODULE_4_rxjs_operator_map__["map"], function (change) { return _this.unwrapAction(change.payload); }]
        ]);
        var actionsUntilStop$ = __WEBPACK_IMPORTED_MODULE_7_rxjs_operator_takeUntil__["takeUntil"].call(actions$, stop$);
        var liftedUntilStop$ = __WEBPACK_IMPORTED_MODULE_7_rxjs_operator_takeUntil__["takeUntil"].call(liftedActions$, stop$);
        // Only take the action sources between the start/stop events
        this.actions$ = __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_switchMap__["switchMap"].call(start$, function () { return actionsUntilStop$; });
        this.liftedActions$ = __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_switchMap__["switchMap"].call(start$, function () { return liftedUntilStop$; });
    };
    DevtoolsExtension.prototype.unwrapAction = function (action) {
        return typeof action === 'string' ? eval("(" + action + ")") : action;
    };
    return DevtoolsExtension;
}());

DevtoolsExtension.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
];
/** @nocollapse */
DevtoolsExtension.ctorParameters = function () { return [
    { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [REDUX_DEVTOOLS_EXTENSION,] },] },
]; };
//# sourceMappingURL=extension.js.map

/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_BehaviorSubject__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_BehaviorSubject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_BehaviorSubject__);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return Dispatcher; });
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var Dispatcher = (function (_super) {
    __extends(Dispatcher, _super);
    function Dispatcher() {
        _super.call(this, { type: Dispatcher.INIT });
    }
    Dispatcher.prototype.dispatch = function (action) {
        this.next(action);
    };
    Dispatcher.prototype.complete = function () {
        // noop
    };
    Dispatcher.INIT = '@ngrx/store/init';
    return Dispatcher;
}(__WEBPACK_IMPORTED_MODULE_0_rxjs_BehaviorSubject__["BehaviorSubject"]));
//# sourceMappingURL=dispatcher.js.map

/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_BehaviorSubject__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_BehaviorSubject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_BehaviorSubject__);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return Reducer; });
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var Reducer = (function (_super) {
    __extends(Reducer, _super);
    function Reducer(_dispatcher, initialReducer) {
        _super.call(this, initialReducer);
        this._dispatcher = _dispatcher;
    }
    Reducer.prototype.replaceReducer = function (reducer) {
        this.next(reducer);
    };
    Reducer.prototype.next = function (reducer) {
        _super.prototype.next.call(this, reducer);
        this._dispatcher.dispatch({ type: Reducer.REPLACE });
    };
    Reducer.REPLACE = '@ngrx/store/replace-reducer';
    return Reducer;
}(__WEBPACK_IMPORTED_MODULE_0_rxjs_BehaviorSubject__["BehaviorSubject"]));
//# sourceMappingURL=reducer.js.map

/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_operator_withLatestFrom__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_operator_withLatestFrom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_operator_withLatestFrom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_operator_scan__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_operator_scan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_operator_scan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_operator_observeOn__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_operator_observeOn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_operator_observeOn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_scheduler_queue__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_scheduler_queue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_scheduler_queue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_BehaviorSubject__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_BehaviorSubject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_BehaviorSubject__);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return State; });
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};





var State = (function (_super) {
    __extends(State, _super);
    function State(_initialState, action$, reducer$) {
        var _this = this;
        _super.call(this, _initialState);
        var actionInQueue$ = __WEBPACK_IMPORTED_MODULE_2_rxjs_operator_observeOn__["observeOn"].call(action$, __WEBPACK_IMPORTED_MODULE_3_rxjs_scheduler_queue__["queue"]);
        var actionAndReducer$ = __WEBPACK_IMPORTED_MODULE_0_rxjs_operator_withLatestFrom__["withLatestFrom"].call(actionInQueue$, reducer$);
        var state$ = __WEBPACK_IMPORTED_MODULE_1_rxjs_operator_scan__["scan"].call(actionAndReducer$, function (state, _a) {
            var action = _a[0], reducer = _a[1];
            return reducer(state, action);
        }, _initialState);
        state$.subscribe(function (value) { return _this.next(value); });
    }
    return State;
}(__WEBPACK_IMPORTED_MODULE_4_rxjs_BehaviorSubject__["BehaviorSubject"]));
//# sourceMappingURL=state.js.map

/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ngrx_core__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return Store; });
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};


var Store = (function (_super) {
    __extends(Store, _super);
    function Store(_dispatcher, _reducer, state$) {
        _super.call(this);
        this._dispatcher = _dispatcher;
        this._reducer = _reducer;
        this.select = __WEBPACK_IMPORTED_MODULE_0__ngrx_core__["a" /* select */].bind(this);
        this.source = state$;
    }
    Store.prototype.lift = function (operator) {
        var store = new Store(this._dispatcher, this._reducer, this);
        store.operator = operator;
        return store;
    };
    Store.prototype.replaceReducer = function (reducer) {
        this._reducer.next(reducer);
    };
    Store.prototype.dispatch = function (action) {
        this._dispatcher.next(action);
    };
    Store.prototype.next = function (action) {
        this._dispatcher.next(action);
    };
    Store.prototype.error = function (err) {
        this._dispatcher.error(err);
    };
    Store.prototype.complete = function () {
        // noop
    };
    return Store;
}(__WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"]));
//# sourceMappingURL=store.js.map

/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ exports["a"] = combineReducers;
function combineReducers(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for (var i = 0; i < reducerKeys.length; i++) {
        var key = reducerKeys[i];
        if (typeof reducers[key] === 'function') {
            finalReducers[key] = reducers[key];
        }
    }
    var finalReducerKeys = Object.keys(finalReducers);
    return function combination(state, action) {
        if (state === void 0) { state = {}; }
        var hasChanged = false;
        var nextState = {};
        for (var i = 0; i < finalReducerKeys.length; i++) {
            var key = finalReducerKeys[i];
            var reducer = finalReducers[key];
            var previousStateForKey = state[key];
            var nextStateForKey = reducer(previousStateForKey, action);
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        return hasChanged ? nextState : state;
    };
}
//# sourceMappingURL=utils.js.map

/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var app_service_1 = __webpack_require__(23);
var navigation_service_1 = __webpack_require__(81);
var app_catalog_service_1 = __webpack_require__(62);
var catalog_service_1 = __webpack_require__(28);
var cart_service_1 = __webpack_require__(35);
var scene_service_1 = __webpack_require__(199);
var debug, debugOff = function () {
    var any = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        any[_i] = arguments[_i];
    }
};
"production" !== 'production' && (debug = __webpack_require__(4)('app:CatalogPageCmp'));
var Ps = __webpack_require__(106);
var CatalogPageCmp = (function () {
    function CatalogPageCmp(_appService, _catalogService, _appCatalogService, _navigationService, _elementRef, _cartService, _sceneService) {
        this._appService = _appService;
        this._catalogService = _catalogService;
        this._appCatalogService = _appCatalogService;
        this._navigationService = _navigationService;
        this._elementRef = _elementRef;
        this._cartService = _cartService;
        this._sceneService = _sceneService;
        this._catalogIsVisible = false;
        this._catalogIsRendered = false;
        this._subscriptions = {};
        this.catalogElem = null;
        this._state = {};
        this._cacheDomElements();
        this._setupCustomScroll();
        this._imgPaths = this._catalogService.imgPaths;
    }
    CatalogPageCmp.prototype.onResize = function (event) {
        this._updateCustomScroll();
    };
    CatalogPageCmp.prototype.ngOnInit = function () {
        var self = this;
        this._openCatalog();
        this._subscriptions.previewVisibilityChanged = this._appService.events.previewVisibilityChanged.subscribe(function (event) {
            event === false ? self._openCatalog() : self._closeCatalog();
        });
    };
    CatalogPageCmp.prototype.ngOnDestroy = function () {
    };
    CatalogPageCmp.prototype._cacheDomElements = function () {
        this.catalogElem = this._elementRef.nativeElement;
        debugOff('Product categories list element:', this.catalogElem);
    };
    CatalogPageCmp.prototype._openCatalog = function () {
        if (this._catalogIsRendered === true) {
            return;
        }
        this._fadeInCatalog();
        this._sceneService.emptyScene();
    };
    CatalogPageCmp.prototype._closeCatalog = function () {
        if (this._catalogIsRendered === false) {
            return;
        }
        this._fadeOutCatalog();
        var cartProducts = this._cartService.getCartProducts();
        cartProducts.forEach(function (product) {
            product.hideTooltip();
        });
    };
    CatalogPageCmp.prototype._fadeInCatalog = function () {
        debugOff('Fade in catalog');
        var self = this;
        this._catalogIsRendered = true;
        setTimeout(function () { return self._catalogIsVisible = true; }, 0);
    };
    CatalogPageCmp.prototype._fadeOutCatalog = function () {
        debugOff('Fade out catalog');
        var self = this;
        this._catalogIsVisible = false;
        setTimeout(function () { return self._catalogIsRendered = false; }, 300);
    };
    CatalogPageCmp.prototype._setupCustomScroll = function () {
        debugOff('Setup catalog custom scroll');
        Ps.initialize(this.catalogElem, {
            minScrollbarLength: 30
        });
    };
    CatalogPageCmp.prototype._updateCustomScroll = function () {
        debugOff('Update catalog custom scroll');
        Ps.update(this.catalogElem);
    };
    return CatalogPageCmp;
}());
__decorate([
    core_1.HostBinding('class.visible'),
    __metadata("design:type", Boolean)
], CatalogPageCmp.prototype, "_catalogIsVisible", void 0);
__decorate([
    core_1.HostBinding('class.rendered'),
    __metadata("design:type", Boolean)
], CatalogPageCmp.prototype, "_catalogIsRendered", void 0);
__decorate([
    core_1.HostListener('window:resize', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CatalogPageCmp.prototype, "onResize", null);
CatalogPageCmp = __decorate([
    core_1.Component({
        selector: 'catalog-page-cmp',
        template: __webpack_require__(843),
        styles: [String(__webpack_require__(1132))],
        host: { id: 'catalog-host', class: 'catalog-page' },
    }),
    __metadata("design:paramtypes", [app_service_1.AppService,
        catalog_service_1.CatalogService,
        app_catalog_service_1.AppCatalogService,
        navigation_service_1.NavigationService,
        core_1.ElementRef,
        cart_service_1.CartService,
        scene_service_1.SceneService])
], CatalogPageCmp);
exports.CatalogPageCmp = CatalogPageCmp;


/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var app_service_1 = __webpack_require__(23);
var navigation_service_1 = __webpack_require__(81);
var generators_service_1 = __webpack_require__(99);
var catalog_service_1 = __webpack_require__(28);
var app_catalog_service_1 = __webpack_require__(62);
var cart_service_1 = __webpack_require__(35);
var debug, debugOff = function () {
    var any = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        any[_i] = arguments[_i];
    }
};
"production" !== 'production' && (debug = __webpack_require__(4)('app:SummaryPageCmp'));
var Ps = __webpack_require__(106);
var SummaryPageCmp = (function () {
    function SummaryPageCmp(_appService, _elementRef, _navigationService, _generatorsService, _catalogService, _appCatalogService, _cartService) {
        this._appService = _appService;
        this._elementRef = _elementRef;
        this._navigationService = _navigationService;
        this._generatorsService = _generatorsService;
        this._catalogService = _catalogService;
        this._appCatalogService = _appCatalogService;
        this._cartService = _cartService;
        this._summaryIsVisible = false;
        this._summaryIsRendered = false;
        this._globals = null;
        this._summaryElement = null;
        this._subscriptions = {};
        this._dic = {
            stone: 'Natural Stone',
            ceramic: 'Ceramic, Porcelain, Glass Tile',
            acrylic: 'Acrylic, Fiberglass, Composite'
        };
        this._globals = this._catalogService.getGlobals();
        this._summaryElement = _elementRef.nativeElement;
        this._imgPaths = this._catalogService.imgPaths;
    }
    SummaryPageCmp.prototype.onResize = function (event) {
        this._updateCustomScroll();
    };
    SummaryPageCmp.prototype.ngOnInit = function () {
        var self = this;
        this._openAppSummary();
        this._subscriptions.previewVisibilityChanged = this._appService.events.previewVisibilityChanged.subscribe(function (event) {
            event === false ? self._openAppSummary() : self._closeAppSummary();
        });
        this._setupCustomScroll();
    };
    SummaryPageCmp.prototype.ngOnDestroy = function () {
        for (var subscriptionId in this._subscriptions) {
            this._subscriptions[subscriptionId].unsubscribe();
        }
    };
    SummaryPageCmp.prototype._setupCustomScroll = function () {
        debugOff('Setup app summary custom scroll');
        Ps.initialize(this._summaryElement, {
            minScrollbarLength: 30
        });
    };
    SummaryPageCmp.prototype._updateCustomScroll = function () {
        debugOff('Update app summary custom scroll');
        Ps.update(this._summaryElement);
    };
    SummaryPageCmp.prototype._openAppSummary = function () {
        if (this._summaryIsRendered === true) {
            return;
        }
        this._fadeInAppSummary();
    };
    SummaryPageCmp.prototype._closeAppSummary = function () {
        if (this._summaryIsRendered === false) {
            return;
        }
        this._fadeOutAppSummary();
    };
    SummaryPageCmp.prototype._fadeInAppSummary = function () {
        var self = this;
        debugOff('Fade in app summary');
        this._summaryIsRendered = true;
        setTimeout(function () { return self._summaryIsVisible = true; }, 0);
    };
    SummaryPageCmp.prototype._fadeOutAppSummary = function () {
        var self = this;
        debugOff('Fade out app summary');
        this._summaryIsVisible = false;
        setTimeout(function () { return self._summaryIsRendered = false; }, 300);
    };
    SummaryPageCmp.prototype._roundRoomVolume = function (volume) {
        debugOff('Round room volume');
        return Math.ceil(volume);
    };
    SummaryPageCmp.prototype.setProduct = function () {
        console.log(23);
        this._cartService.productEvent.emit("");
    };
    return SummaryPageCmp;
}());
__decorate([
    core_1.HostBinding('class.visible'),
    __metadata("design:type", Boolean)
], SummaryPageCmp.prototype, "_summaryIsVisible", void 0);
__decorate([
    core_1.HostBinding('class.rendered'),
    __metadata("design:type", Boolean)
], SummaryPageCmp.prototype, "_summaryIsRendered", void 0);
__decorate([
    core_1.HostListener('window:resize', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SummaryPageCmp.prototype, "onResize", null);
SummaryPageCmp = __decorate([
    core_1.Component({
        selector: 'summary-page-cmp',
        template: __webpack_require__(844),
        styles: [String(__webpack_require__(1133))],
        host: { id: 'summary', class: 'summary-page' }
    }),
    __metadata("design:paramtypes", [app_service_1.AppService,
        core_1.ElementRef,
        navigation_service_1.NavigationService,
        generators_service_1.GeneratorsService,
        catalog_service_1.CatalogService,
        app_catalog_service_1.AppCatalogService,
        cart_service_1.CartService])
], SummaryPageCmp);
exports.SummaryPageCmp = SummaryPageCmp;


/***/ },
/* 427 */
/***/ function(module, exports) {

"use strict";
"use strict";
var ProductCategory = (function () {
    function ProductCategory(config) {
        this._uuid = config._uuid;
        this._id = config.id;
        this.id = config.id;
        this.parentCategoryId = config.parentCategoryId;
        this.menuName = config.menuName;
        this.title = config.title;
        this.subtitle = config.subtitle;
        this.shortDescription = config.shortDescription;
        this.longDescription = config.longDescription;
        this.techSpecsLink = config.techSpecsLink;
        this.image = config.image;
        this.renderMode = config.renderMode;
        this.customRenderer = config.customRenderer;
        this.isVisible = config.isVisible;
        this.allowInCartMultipleProds = config.allowInCartMultipleProds;
        this.sortOrder = config.sortOrder;
        this.zIndex = config.zIndex;
    }
    return ProductCategory;
}());
exports.ProductCategory = ProductCategory;


/***/ },
/* 428 */
/***/ function(module, exports) {

"use strict";
"use strict";
var Descriptions = (function () {
    function Descriptions() {
    }
    return Descriptions;
}());
exports.Descriptions = Descriptions;
var Images = (function () {
    function Images() {
        this.thumbnail = null;
        this.folder = null;
        this.scene = null;
    }
    return Images;
}());
exports.Images = Images;
var Links = (function () {
    function Links() {
        this.tech = null;
    }
    return Links;
}());
exports.Links = Links;
var Taxonomy = (function () {
    function Taxonomy() {
        this.categories = null;
        this.currentCategoryId = null;
        this.sortOrder = null;
        this.zIndex = null;
        this.series = null;
    }
    return Taxonomy;
}());
exports.Taxonomy = Taxonomy;
var Options = (function () {
    function Options() {
        this.enabledListsIds = null;
        this.list = null;
        this.selected = null;
        this.dropdownIsActive = false;
    }
    return Options;
}());
exports.Options = Options;
var Package = (function () {
    function Package() {
        this.config = null;
        this.products = null;
    }
    return Package;
}());
exports.Package = Package;
var Tooltip = (function () {
    function Tooltip() {
        this.top = 10;
        this.left = 10;
        this.width = 10;
        this.height = 10;
        this.orientation = null;
    }
    return Tooltip;
}());
exports.Tooltip = Tooltip;
var VSpa = (function () {
    function VSpa() {
        this.spaFrameIsVisible = false;
        this.standardGeneratorIsVisible = false;
        this.isSuperCompatible = false;
        this.isSuperGenerator = null;
    }
    return VSpa;
}());
exports.VSpa = VSpa;
var ProductConfig = (function () {
    function ProductConfig() {
        this._uuid = null;
        this.code = null;
        this.partnumber = null;
        this.previewname = null;
        this.name = null;
        this.price = null;
        this.descriptions = null;
        this.images = null;
        this.links = null;
        this.taxonomy = null;
        this.package = null;
        this.dynamicProperties = null;
        this.tooltips = null;
        this.vSpa = null;
    }
    return ProductConfig;
}());
exports.ProductConfig = ProductConfig;
var Product = (function () {
    function Product(config) {
        this._uuid = null;
        this._code = null;
        this._globals = null;
        this.code = null;
        this.partnumber = null;
        this.previewname = null;
        this.name = null;
        this.price = null;
        this.isVisible = true;
        this.descriptions = null;
        this.images = null;
        this.links = null;
        this.taxonomy = null;
        this.options = null;
        this.dynamicProperties = null;
        this.package = null;
        this.isAddedToCart = false;
        this.tooltips = null;
        this.tooltipIsVisible = false;
        this.tooltipIsHovered = false;
        this.isAddedToScene = false;
        this._uuid = config._uuid;
        this._code = config.code;
        this.code = config.code;
        this.partnumber = config.partnumber;
        this.previewname = config.previewname;
        this.name = config.name;
        this.price = config.price;
        this.descriptions = config.descriptions;
        this.images = config.images;
        this.links = config.links;
        this.taxonomy = config.taxonomy;
        this.options = config.options;
        this.dynamicProperties = config.dynamicProperties;
        this.package = config.package;
        this.tooltips = config.tooltips;
        this.vSpa = config.vSpa;
    }
    return Product;
}());
exports.Product = Product;


/***/ },
/* 429 */
/***/ function(module, exports) {

"use strict";
"use strict";
exports.productOptions = {
    aroma: {
        EUCALYPTUS: {
            name: "Eucalyptus",
            image: "Eucalyptus.png"
        },
        EVERGREEN: {
            name: "Evergreen",
            image: "Evergreen.png"
        },
        MINT: {
            name: "Mint",
            image: "Mint.png"
        },
        BREATHE: {
            name: "Breathe",
            image: "Breathe.png"
        },
        LAVENDER: {
            name: "Lavender",
            image: "Lavender.png"
        },
        PACK_5: {
            name: "Essential 5 Pack",
            image: "Pack.png"
        },
        PACK_7: {
            name: "Chakra 7 Pack",
            image: "Pack.png"
        },
        VITALITY: {
            name: "Vitality",
            image: "Vitality.png"
        },
        INVIGORATE: {
            name: "Invigorate",
            image: "Invigorate.png"
        },
        AWAKENING: {
            name: "Awakening",
            image: "Awakening.png"
        },
        HARMONY: {
            name: "Harmony",
            image: "Harmony.png"
        },
        CELESTIAL: {
            name: "Celestial",
            image: "Celestial.png"
        },
        MYSTIC: {
            name: "Mystic",
            image: "Mystic.png"
        },
        NIRVANA: {
            name: "Nirvana",
            image: "Nirvana.png"
        }
    },
    color: {
        BLACK: {
            name: "Black",
            image: "Matte-Black.png",
            spaFrame: "MatteBlack.png"
        },
        WHITE: {
            name: "White",
            image: "White.png",
            spaFrame: "White.png"
        }
    },
    shape: {
        ROUND: {
            name: "Round",
            image: "Round.png"
        },
        SQUARE: {
            name: "Square",
            image: "Square.png"
        }
    },
    steamHead: {
        LINEAR_STEAMHEAD: {
            name: "Linear SteamHead",
            image: "Linear.png"
        },
        ISTEAM_STEAMHEAD: {
            name: "iSteam SteamHead",
            image: "iSteam.png"
        },
        AIRTEMPO_STEAMHEAD: {
            name: "AirTempo SteamHead",
            image: "AirTempo.png"
        },
        ITEMPO_STEAMHEAD: {
            name: "iTempo SteamHead",
            image: "iTempo.png"
        }
    },
    finish: {
        ANTIQUE_BRASS: {
            name: "Antique Brass",
            image: "Antique-Brass.png",
            spaFrame: "AntiqueBrass.png"
        },
        BRUSHED_BRONZE: {
            name: "Brushed Bronze",
            image: "Brushed-Bronze.png",
            spaFrame: "BrushedBronze.png"
        },
        BRUSHED_NICKEL: {
            name: "Brushed Nickel",
            image: "Brushed-Nickel.png",
            spaFrame: "BrushedNickel.png"
        },
        OIL_RUBBED_BRONZE: {
            name: "Oil Rubbed Bronze",
            image: "Oil-Rubbed-Bronze.png",
            spaFrame: "OilRubbedBronze.png"
        },
        POLISHED_BRASS: {
            name: "Polished Brass",
            image: "Polished-Brass.png",
            spaFrame: "PolishedBrass.png"
        },
        POLISHED_CHROME: {
            name: "Polished Chrome",
            image: "Polished-Chrome.png",
            spaFrame: "PolishedChrome.png"
        },
        POLISHED_GOLD: {
            name: "Polished Gold",
            image: "Polished-Gold.png",
            spaFrame: "PolishedGold.png"
        },
        POLISHED_NICKEL: {
            name: "Polished Nickel",
            image: "Polished-Nickel.png",
            spaFrame: "PolishedNickel.png"
        },
        SATIN_NICKEL: {
            name: "Satin Nickel",
            image: "Satin-Nickel.png",
            spaFrame: "SatinNickel.png"
        },
        SATIN_BRASS: {
            name: "Satin Brass",
            image: "Polished-Brass.png",
            spaFrame: "SatinBrass.png"
        },
        STAINLESS_STEEL_BRUSHED: {
            name: "Stainless Steel Brushed",
            image: "Stainless-Steel-Brushed.png",
            spaFrame: "StainlessSteelBrushed.png"
        },
        STAINLESS_STEEL_POLISHED: {
            name: "Stainless Steel Polished",
            image: "Stainless-Steel-Polished.png",
            spaFrame: "StainlessSteelPolished.png"
        },
        MATTE_BLACK: {
            name: "Matte Black",
            image: "Matte-Black.png",
            spaFrame: "MatteBlack.png"
        },
        WHITE: {
            name: "White",
            image: "White.png",
            spaFrame: "White.png"
        },
        BLACK: {
            name: "Black",
            image: "Matte-Black.png",
            spaFrame: "MatteBlack.png"
        },
        POLISHED_ALUMINUM: {
            name: "Polished Aluminum",
            image: "Stainless-Steel-Polished.png",
            spaFrame: "Stainless-Steel-Polished.png"
        },
        SATIN_ALUMINUM: {
            name: "Satin Aluminum",
            image: "Satin-Nickel.png",
            spaFrame: "Satin-Nickel.png"
        },
        RAW: {
            name: "Raw",
            image: "Raw.png",
            spaFrame: "SatinBrass.png"
        }
    },
};


/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var debug, debugOff = function () {
    var any = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        any[_i] = arguments[_i];
    }
};
"production" !== 'production' && (debug = __webpack_require__(4)('app:DynamicPropertiesService'));
var DynamicPropertiesService = (function () {
    function DynamicPropertiesService() {
        this._productsService = null;
    }
    DynamicPropertiesService.prototype.init = function (productsService) {
        this._productsService = productsService;
    };
    DynamicPropertiesService.prototype.updateDynamicProperties = function (product) {
        for (var propertyId in product.dynamicProperties) {
            this._updateDynamicProperty(product, propertyId, product.dynamicProperties[propertyId]);
        }
        debugOff('Updated dynamic properties product:', [product]);
    };
    DynamicPropertiesService.prototype._updateDynamicProperty = function (product, propertyId, dynamicProperty) {
        debugOff('Update "' + propertyId + '" dynamic property');
        debugOff('Dynamic property:', dynamicProperty);
        var key = this._getDynamicPropertyKey(product, propertyId, dynamicProperty.keyTemplate);
        debugOff('Dynamic property key:', key);
        var keyValue = this._getKeyValue(key, dynamicProperty.tallies);
        debugOff('Key value:', keyValue);
        var propertyChain = propertyId.split('.');
        this._setPropertyChainValue(product, propertyChain, keyValue);
    };
    DynamicPropertiesService.prototype._getDynamicPropertyKey = function (product, propertyId, keyTemplate) {
        var _this = this;
        debugOff('Get "' + propertyId + '" dynamic property key');
        debugOff('Key template', keyTemplate);
        var self = this;
        var key = [];
        keyTemplate.forEach(function (prodPropertyTemplate, index) {
            debugOff('Product property template:', prodPropertyTemplate);
            debugOff('Index:', index);
            key[index] = _this._getProductPropertyValue(product, prodPropertyTemplate);
        });
        return key;
    };
    DynamicPropertiesService.prototype._getProductPropertyValue = function (product, prodPropertyTemplate) {
        debugOff('Get "' + prodPropertyTemplate + '" product property');
        var propertyChain = prodPropertyTemplate.split('.');
        debugOff('Product property chain:', propertyChain);
        var value = this._getPropertyChainValue(product, propertyChain);
        debugOff('Property chain value:', propertyChain);
        return value;
    };
    DynamicPropertiesService.prototype._getPropertyChainValue = function (product, propertyChain) {
        var value = product;
        propertyChain.forEach(function (propertyId) {
            if (value !== undefined && value !== null) {
                value = value[propertyId];
            }
            if (value === undefined) {
                console.warn('Product "' + product.code + '" property chain, returned undefined value:', propertyChain);
            }
            if (propertyId === 'isSuperGenerator') {
                console.log('value', value);
                console.log('product', product);
                console.log('product._globals', product._globals);
            }
            debugOff('Object "' + propertyId + '" property:', value);
        });
        value === undefined && (value = null);
        debugOff('Object dynamic key value:', value);
        return value;
    };
    DynamicPropertiesService.prototype._setPropertyChainValue = function (product, propertyChain, value) {
        var object = product, maxIndex = propertyChain.length - 1;
        propertyChain.forEach(function (propertyId, index) {
            debugOff(propertyId, index, maxIndex);
            if (index !== maxIndex) {
                object[propertyId] === undefined && (object[propertyId] = {});
                object = object[propertyId];
            }
            else {
                object[propertyId] = value;
            }
        });
    };
    DynamicPropertiesService.prototype._getKeyValue = function (key, tallies) {
        var _this = this;
        debugOff('Get key value');
        debugOff('Key:', key);
        debugOff('Tallies table:', tallies);
        var value;
        tallies.forEach(function (row, index) {
            row.tally.forEach(function (tallyMember) {
                var keyMatchesTally = _this._checkKeyMatchesTally(key, tallyMember);
                debugOff('Table row "' + index + '" matches', keyMatchesTally);
                if (keyMatchesTally === true) {
                    value = row.value;
                }
            });
        });
        debugOff('Matched value:', value);
        return value;
    };
    DynamicPropertiesService.prototype._checkKeyMatchesTally = function (key, tally) {
        debugOff('Check key matches tally');
        debugOff('Key:', key);
        debugOff('Tally:', tally);
        if (key.length !== tally.length) {
            console.warn('Key:', key);
            console.warn('Tally:', tally);
            console.error('Key and tally don\'t have same length');
            return;
        }
        var numOfMatches = 0;
        tally.forEach(function (value, index) {
            if (tally[index] === key[index]) {
                debugOff('Match found');
                numOfMatches += 1;
            }
        });
        var perfectMatch = numOfMatches === key.length;
        debugOff('Perfect match found:', perfectMatch);
        return perfectMatch;
    };
    return DynamicPropertiesService;
}());
DynamicPropertiesService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [])
], DynamicPropertiesService);
exports.DynamicPropertiesService = DynamicPropertiesService;


/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var testing_1 = __webpack_require__(268);
var http_1 = __webpack_require__(43);
var product_category_1 = __webpack_require__(427);
var config_1 = __webpack_require__(200);
var product_categories_1 = __webpack_require__(660);
var debug, debugOff = function () {
    var any = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        any[_i] = arguments[_i];
    }
};
"production" !== 'production' && (debug = __webpack_require__(4)('app:ProductCategoriesMockApi'));
var ProductCategoriesMockApi = (function () {
    function ProductCategoriesMockApi(_mockBackend) {
        this._mockBackend = _mockBackend;
        this._categories = [];
        this._setupMockProductCategoriesDb();
        this._setupMockConnections();
    }
    ProductCategoriesMockApi.prototype._setupMockProductCategoriesDb = function () {
        var _this = this;
        var uuid = 0;
        product_categories_1.productCategories.forEach(function (productCategoryCfg) {
            var productCategory = new product_category_1.ProductCategory({
                _uuid: uuid++,
                id: productCategoryCfg.id,
                parentCategoryId: productCategoryCfg.parentCategoryId,
                menuName: productCategoryCfg.menuName,
                title: productCategoryCfg.title,
                subtitle: productCategoryCfg.subtitle,
                shortDescription: productCategoryCfg.shortDescription,
                longDescription: productCategoryCfg.longDescription,
                techSpecsLink: productCategoryCfg.techSpecsLink,
                image: productCategoryCfg.image,
                renderMode: productCategoryCfg.renderMode,
                customRenderer: productCategoryCfg.customRenderer,
                isVisible: productCategoryCfg.isVisible,
                allowInCartMultipleProds: productCategoryCfg.allowInCartMultipleProds,
                sortOrder: productCategoryCfg.sortOrder,
                zIndex: productCategoryCfg.zIndex
            });
            _this._categories.push(productCategory);
        });
        debugOff('Product categories:', this._categories);
    };
    ProductCategoriesMockApi.prototype._setupMockConnections = function () {
        var _this = this;
        this._mockBackend.connections.subscribe(function (connection) {
            var singleCategoryMatcher = /\/api\/category\/([0-9]+)/i;
            var domain = config_1.CONFIG.domain;
            debugOff('Request url:', connection.request.url);
            debugOff('Request method:', connection.request.method);
            if (connection.request.url === domain + 'api/category' &&
                connection.request.method === 0) {
                _this._getAllCategories(connection);
            }
            else if (connection.request.url.match(singleCategoryMatcher) &&
                connection.request.method === 0) {
                _this._getCategoryById(connection);
            }
            else if (connection.request.url === domain + 'api/category'
                && connection.request.method === 1) {
                _this._postCategory(connection);
            }
            else if (connection.request.url.match(singleCategoryMatcher) &&
                connection.request.method === 3) {
                _this._deleteCategory(connection);
            }
        });
    };
    ProductCategoriesMockApi.prototype._getAllCategories = function (connection) {
        debugOff('Get all categories');
        var response = new http_1.Response(new http_1.ResponseOptions({
            body: JSON.stringify(this._categories)
        }));
        debugOff('Mock response:', response);
        connection.mockRespond(response);
    };
    ProductCategoriesMockApi.prototype._getCategoryById = function (connection) {
        debugOff('Get category by id');
        var singleCategoryMatcher = /\/api\/category\/([0-9]+)/i, matches = this._categories.filter(function (category) {
            return category._uuid == connection.request.url.match(singleCategoryMatcher)[1];
        }), response = new http_1.Response(new http_1.ResponseOptions({
            body: JSON.stringify(matches[0])
        }));
        connection.mockRespond(response);
    };
    ProductCategoriesMockApi.prototype._postCategory = function (connection) {
        var newCategory = JSON.parse(connection.request._body);
        debugOff('Post category');
        var existingCategory = this._categories.filter(function (category) { return category._uuid == newCategory._uuid; });
        if (existingCategory && existingCategory.length === 1) {
            Object.assign(existingCategory[0], newCategory);
            var response = new http_1.Response(new http_1.ResponseOptions({
                body: JSON.stringify(existingCategory[0])
            }));
            connection.mockRespond(response);
        }
        else {
            newCategory._uuid = parseInt(_.max(this._categories, function (category) { return category._uuid; })._uuid || 0, 10) + 1;
            this._categories.push(newCategory);
            var response = new http_1.Response(new http_1.ResponseOptions({
                body: JSON.stringify(newCategory)
            }));
            connection.mockRespond(response);
        }
    };
    ProductCategoriesMockApi.prototype._deleteCategory = function (connection) {
        debugOff('Delete category');
        var singleCategoryMatcher = /\/api\/category\/([0-9]+)/i, categoryId = connection.request.url.match(singleCategoryMatcher)[1], position = _.indexOf(_.pluck(this._categories, '_uuid'), categoryId);
        this._categories.splice(position, 1);
        var response = new http_1.Response(new http_1.ResponseOptions({
            body: JSON.stringify({})
        }));
        connection.mockRespond(response);
    };
    return ProductCategoriesMockApi;
}());
ProductCategoriesMockApi = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [testing_1.MockBackend])
], ProductCategoriesMockApi);
exports.ProductCategoriesMockApi = ProductCategoriesMockApi;


/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var testing_1 = __webpack_require__(268);
var http_1 = __webpack_require__(43);
var product_1 = __webpack_require__(428);
var config_1 = __webpack_require__(200);
var products = __webpack_require__(520);
var debug, debugOff = function () {
    var any = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        any[_i] = arguments[_i];
    }
};
"production" !== 'production' && (debug = __webpack_require__(4)('app:ProductsMockApi'));
var ProductsMockApi = (function () {
    function ProductsMockApi(_mockBackend) {
        this._mockBackend = _mockBackend;
        this._products = [];
        this._setupMockProductsDb();
        this._setupMockConnections();
    }
    ProductsMockApi.prototype._setupMockProductsDb = function () {
        var _this = this;
        var uuid = 0;
        products.forEach(function (productCfg) {
            var product = new product_1.Product({
                _uuid: uuid++,
                code: productCfg.code,
                partnumber: productCfg.partnumber,
                previewname: productCfg.previewname,
                name: productCfg.name,
                price: productCfg.price,
                descriptions: productCfg.descriptions,
                images: productCfg.images,
                links: productCfg.links,
                taxonomy: productCfg.taxonomy,
                options: productCfg.options,
                package: productCfg.package,
                dynamicProperties: productCfg.dynamicProperties,
                tooltips: productCfg.tooltips,
                vSpa: productCfg.vSpa
            });
            _this._products.push(product);
        });
        debugOff('Products:', this._products);
    };
    ProductsMockApi.prototype._setupMockConnections = function () {
        var _this = this;
        this._mockBackend.connections.subscribe(function (connection) {
            var singleProductMatcher = /\/api\/product\/([0-9]+)/i;
            var domain = config_1.CONFIG.domain;
            debugOff('Request url:', connection.request.url);
            debugOff('Request method:', connection.request.method);
            if (connection.request.url === domain + 'api/product' &&
                connection.request.method === 0) {
                _this._getAllProducts(connection);
            }
            else if (connection.request.url.match(singleProductMatcher) &&
                connection.request.method === 0) {
                _this._getProductById(connection);
            }
            else if (connection.request.url === domain + 'api/product'
                && connection.request.method === 1) {
                _this._postProduct(connection);
            }
            else if (connection.request.url.match(singleProductMatcher) &&
                connection.request.method === 3) {
                _this._deleteProduct(connection);
            }
        });
    };
    ProductsMockApi.prototype._getAllProducts = function (connection) {
        debugOff('Get all products');
        var response = new http_1.Response(new http_1.ResponseOptions({
            body: JSON.stringify(this._products)
        }));
        debugOff('Mock response:', response);
        connection.mockRespond(response);
    };
    ProductsMockApi.prototype._getProductById = function (connection) {
        debugOff('Get product by id');
        var singleProductMatcher = /\/api\/product\/([0-9]+)/i, matches = this._products.filter(function (product) {
            return product._uuid == connection.request.url.match(singleProductMatcher)[1];
        }), response = new http_1.Response(new http_1.ResponseOptions({
            body: JSON.stringify(matches[0])
        }));
        connection.mockRespond(response);
    };
    ProductsMockApi.prototype._postProduct = function (connection) {
        var newProduct = JSON.parse(connection.request._body);
        debugOff('Post product');
        var existingProduct = this._products.filter(function (product) { return product._uuid == newProduct._uuid; });
        if (existingProduct && existingProduct.length === 1) {
            Object.assign(existingProduct[0], newProduct);
            var response = new http_1.Response(new http_1.ResponseOptions({
                body: JSON.stringify(existingProduct[0])
            }));
            connection.mockRespond(response);
        }
        else {
            newProduct._uuid = parseInt(_.max(this._products, function (product) { return product._uuid; })._uuid || 0, 10) + 1;
            this._products.push(newProduct);
            var response = new http_1.Response(new http_1.ResponseOptions({
                body: JSON.stringify(newProduct)
            }));
            connection.mockRespond(response);
        }
    };
    ProductsMockApi.prototype._deleteProduct = function (connection) {
        debugOff('Delete product');
        var singleProductMatcher = /\/api\/product\/([0-9]+)/i, productId = connection.request.url.match(singleProductMatcher)[1], position = _.indexOf(_.pluck(this._products, '_uuid'), productId);
        this._products.splice(position, 1);
        var response = new http_1.Response(new http_1.ResponseOptions({
            body: JSON.stringify({})
        }));
        connection.mockRespond(response);
    };
    return ProductsMockApi;
}());
ProductsMockApi = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [testing_1.MockBackend])
], ProductsMockApi);
exports.ProductsMockApi = ProductsMockApi;


/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(43);
var Observable_1 = __webpack_require__(1);
__webpack_require__(224);
var config_1 = __webpack_require__(200);
var debug, debugOff = function () {
    var any = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        any[_i] = arguments[_i];
    }
};
"production" !== 'production' && (debug = __webpack_require__(4)('app:ProductCategoriesService'));
var ProductCategoriesService = (function () {
    function ProductCategoriesService(_http) {
        this._http = _http;
        this._categories = [];
        this._rootCategory = null;
    }
    ProductCategoriesService.prototype.init = function (catalogService) {
        this._catalogService = catalogService;
        this._imgPaths = this._catalogService.imgPaths;
    };
    ProductCategoriesService.prototype.getAllCategoriesAsync = function () {
        var self = this, domain = config_1.CONFIG.domain, observable = this._http.get(domain + 'api/category')
            .map(function (res) { return res.json(); })
            .catch(this._handleError);
        observable.subscribe(function (response) {
            self._categories = response;
            debugOff('Categories:', self._categories);
        }, function (error) { return console.error(error); });
        return observable;
    };
    ProductCategoriesService.prototype.getCategoryByIdAsync = function (id) {
        var domain = config_1.CONFIG.domain;
        return this._http.get(domain + 'api/category/' + id)
            .map(function (res) { return res.json(); })
            .catch(this._handleError);
    };
    ProductCategoriesService.prototype.saveCategoryAsync = function (category) {
        var domain = config_1.CONFIG.domain;
        if (category.id === 0) {
            return this._http.post(domain + 'api/category', category)
                .map(function (res) { return res.json(); })
                .catch(this._handleError);
        }
        else {
            return this._http.put(domain + 'api/category/' + category.id, category)
                .map(function (res) { return res.json(); })
                .catch(this._handleError);
        }
    };
    ProductCategoriesService.prototype.deleteCategoryAsync = function (category) {
        var domain = config_1.CONFIG.domain;
        return this._http.delete('api/category/' + category.id)
            .map(function (res) { return category; })
            .catch(this._handleError);
    };
    ProductCategoriesService.prototype.getProductCategoriesList = function () {
        debugOff('Product categories list:', this._categories);
        return this._categories;
    };
    ProductCategoriesService.prototype.getRootCategory = function () {
        debugOff('Root category:', this._rootCategory);
        return this._rootCategory;
    };
    ProductCategoriesService.prototype.getCategoryThumbnailPath = function (category) {
        if (category === undefined) {
            console.error('Cannot return category thumbnail path, category is undefined');
            return;
        }
        debugOff('Get "' + category.id + '" category thumbnail');
        var path;
        if (category.image !== null) {
            path = this._imgPaths.categories + category.image;
        }
        else {
            var productThumb = this.getFeaturedProductThumb(category);
            if (productThumb !== null) {
                path = this._imgPaths.products + this.getFeaturedProductThumb(category);
            }
            else {
                path = this._imgPaths.categories + 'Category-Placeholder.jpg';
            }
        }
        debugOff('Category thumbnail path:', path);
        return path;
    };
    ProductCategoriesService.prototype.getFeaturedProductThumb = function (category) {
        debugOff('Get featured product thumbnail for "' + category.id + '" category');
        function retrieveThumb(category) {
            if (category.products[0] !== undefined) {
                return category.products[0].images.folder + category.products[0].images.thumbnail;
            }
            else if (category.subcategories !== undefined &&
                category.subcategories.length !== 0) {
                for (var subCatId = 0; subCatId < category.subcategories.length; subCatId++) {
                    var subCategory = category.subcategories[subCatId];
                    return retrieveThumb(subCategory);
                }
            }
            else {
                return null;
            }
        }
        return retrieveThumb(category);
    };
    ProductCategoriesService.prototype.getProductCategoryById = function (id) {
        debugOff('Get product category by "' + id + '" ID');
        var category = this._categories.find(function (category) { return category.id === id; });
        category === undefined && console.warn("Category " + id + " is undefined");
        debugOff('Category:', category);
        return category;
    };
    ProductCategoriesService.prototype.generateCategoriesThree = function () {
        var rootCategory = {
            _uuid: null,
            _id: 'rootCategory',
            id: 'rootCategory',
            parentCategoryId: null,
            menuName: null,
            title: null,
            subtitle: null,
            shortDescription: null,
            techSpecsLink: null,
            image: null,
            renderMode: 'expanded',
            customRenderer: null,
            isVisible: true,
            allowInCartMultipleProds: true,
            sortOrder: 0,
            zIndex: 0,
            products: [],
            subcategories: []
        };
        var childCategs = {};
        this._categories.forEach(function (category) {
            var parentCatId = category.parentCategoryId;
            if (parentCatId === undefined) {
                console.error('"category.parentCategoryId" is undefined');
                return;
            }
            if (parentCatId === null) {
                rootCategory.subcategories.push(category);
                return;
            }
            childCategs[parentCatId] === undefined && (childCategs[parentCatId] = []);
            childCategs[parentCatId].push(category);
        });
        debugOff('Children categories arrays:', childCategs);
        for (var parentCatId in childCategs) {
            var category = this.getProductCategoryById(parentCatId);
            !category && console.warn('Cannot add subcategories. "' + parentCatId + '" parent category is undefined.');
            category.subcategories = childCategs[parentCatId];
        }
        this._categories.push(rootCategory);
        this._rootCategory = rootCategory;
        debugOff('Root category:', rootCategory);
        return rootCategory;
    };
    ProductCategoriesService.prototype.updateCategoriesSortOrder = function () {
        var self = this;
        this._categories.forEach(function (category) {
            if (category.subcategories === undefined ||
                category.subcategories.length === 0) {
                return;
            }
            category.subcategories.forEach(function (subcategory) {
                subcategory.sortOrder === undefined && (category.sortOrder = 0);
            });
            category.subcategories.sort(function (a, b) { return a.sortOrder - b.sortOrder; });
            debugOff('Sorted subcategories of "' + category.id + '":', category.subcategories);
        });
    };
    ProductCategoriesService.prototype.shallowCloneCategory = function (category) {
        debugOff('Clone subcategories');
        debugOff('"' + category.id + '" category:', category);
        var cloneCategory = {};
        for (var prop in category) {
            cloneCategory[prop] = category[prop];
        }
        return cloneCategory;
    };
    ProductCategoriesService.prototype.shallowCloneSubcategories = function (category) {
        debugOff('Clone subcategories');
        debugOff('"' + category.id + '" category:', category);
        debugOff('Subcategories:', category.subcategories);
        var subcategories = [];
        category.subcategories && category.subcategories.forEach(function (subcategory) {
            subcategories.push(subcategory);
        });
        return subcategories;
    };
    ProductCategoriesService.prototype.getAllProducts = function (category) {
        debugOff('Get all products in category and all subcategories');
        debugOff('"' + category.id + '" category:', category);
        var products = [];
        getProducts(category);
        function getProducts(_category) {
            _category.products !== undefined && (products = products.concat(_category.products));
            _category.subcategories && _category.subcategories.forEach(function (subcategory) {
                getProducts(subcategory);
            });
        }
        debugOff('Products:', products);
        return products;
    };
    ProductCategoriesService.prototype.appendProductAPI = function (products) {
        var self = this;
        products.forEach(function (product) {
            product.getCurrentCategory = function () {
                debugOff('Get "' + product.code + '" product current parent category');
                return self.getProductCategoryById(product.taxonomy.currentCategoryId);
            };
        });
    };
    ProductCategoriesService.prototype._handleError = function (error) {
        console.error(error);
        return Observable_1.Observable.throw(error.json().error || 'Server error');
    };
    return ProductCategoriesService;
}());
ProductCategoriesService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], ProductCategoriesService);
exports.ProductCategoriesService = ProductCategoriesService;


/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var debug, debugOff = function () {
    var any = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        any[_i] = arguments[_i];
    }
};
"production" !== 'production' && (debug = __webpack_require__(4)('app:ProductsPackagesService'));
var ProductsPackagesService = (function () {
    function ProductsPackagesService() {
        this._productsService = null;
    }
    ProductsPackagesService.prototype.init = function (productsService) {
        this._productsService = productsService;
    };
    ProductsPackagesService.prototype.generatePackageProducts = function (product) {
        var self = this;
        if (product.package.config === undefined ||
            product.package.config === null) {
            console.warn(' "' + product.code + '" product has no package products defined');
            return;
        }
        debugOff('"' + product.code + '" - Clone package base products');
        if (product.package.config.staticProducts !== undefined &&
            product.package.config.staticProducts.length !== 0) {
            var staticProducts = product.package.config.staticProducts;
            if (staticProducts === undefined) {
                console.warn('"' + product.code + '.staticProducts" is undefined');
                return;
            }
            var packProdsIdsList = staticProducts.map(function (obj) { return obj['productId']; });
            for (var propertyId in product.package.config.dynamicProducts) {
                var dynamicProducts = product.package.config.dynamicProducts[propertyId];
                if (dynamicProducts === undefined) {
                    console.warn('"' + product.code + '.package.config.dynamicProducts.' + propertyId + '" is undefined');
                    return;
                }
                var dynamicPackProdsIdsList = dynamicProducts.map(function (obj) { return obj['productId']; });
                packProdsIdsList = packProdsIdsList.concat(dynamicPackProdsIdsList);
            }
            debugOff('"' + product.code + '" - Package products ids:', packProdsIdsList);
            var packageProducts_1 = [];
            packProdsIdsList.forEach(function (packProdId) {
                var requiredProduct = self._productsService.getProductById(packProdId);
                var clone = requiredProduct.getClone();
                packageProducts_1.push(clone);
            });
            packageProducts_1.forEach(function (packProduct) {
                if (packProduct.options) {
                    packProduct.options.selected = product.options.selected;
                }
                self._productsService._dynamicPropertiesService.updateDynamicProperties(packProduct);
            });
            product.package.products = [];
            product.package.products = product.package.products.concat(packageProducts_1);
        }
    };
    return ProductsPackagesService;
}());
ProductsPackagesService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [])
], ProductsPackagesService);
exports.ProductsPackagesService = ProductsPackagesService;


/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(43);
var Observable_1 = __webpack_require__(1);
__webpack_require__(224);
var products_packages_service_1 = __webpack_require__(434);
var dynamic_properties_service_1 = __webpack_require__(430);
var config_1 = __webpack_require__(200);
var product_options_1 = __webpack_require__(429);
var debug, debugOff = function () {
    var any = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        any[_i] = arguments[_i];
    }
};
"production" !== 'production' && (debug = __webpack_require__(4)('app:ProductsService'));
var ProductsService = (function () {
    function ProductsService(_http, _productsPackagesService, _dynamicPropertiesService) {
        this._http = _http;
        this._productsPackagesService = _productsPackagesService;
        this._dynamicPropertiesService = _dynamicPropertiesService;
        this.events = {
            productStateRefreshed: new core_1.EventEmitter()
        };
        this._products = [];
        this._productsPackagesService.init(this);
        this._dynamicPropertiesService.init(this);
    }
    ProductsService.prototype.init = function (catalogService, AppService) {
        this._catalogService = catalogService;
        this._appService = AppService;
        this._imgPaths = this._catalogService.imgPaths;
    };
    ProductsService.prototype.getAllProductsAsync = function () {
        var self = this, domain = config_1.CONFIG.domain, observable = this._http.get(domain + 'api/product')
            .map(function (res) { return res.json(); })
            .catch(this._handleError);
        observable.subscribe(function (response) {
            self._products = response;
            debugOff('Products:', self._products);
        }, function (error) { return console.error(error); });
        return observable;
    };
    ProductsService.prototype.getProductByIdAsync = function (id) {
        var domain = config_1.CONFIG.domain;
        return this._http.get(domain + 'api/product/' + id)
            .map(function (res) { return res.json(); })
            .catch(this._handleError);
    };
    ProductsService.prototype.saveProductAsync = function (product) {
        var domain = config_1.CONFIG.domain;
        if (product.code === 0) {
            return this._http.post(domain + 'api/product', product)
                .map(function (res) { return res.json(); })
                .catch(this._handleError);
        }
        else {
            return this._http.put(domain + 'api/product/' + product.code, product)
                .map(function (res) { return res.json(); })
                .catch(this._handleError);
        }
    };
    ProductsService.prototype.deleteProductAsync = function (product) {
        var domain = config_1.CONFIG.domain;
        return this._http.delete('api/product/' + product.code)
            .map(function (res) { return product; })
            .catch(this._handleError);
    };
    ProductsService.prototype.getProductsList = function () {
        debugOff('Get products list');
        debugOff('Product categories list:', this._products);
        return this._products;
    };
    ProductsService.prototype.getProductsByCategoryId = function (categId) {
        debugOff('Get products by "' + categId + '" category id');
        var products = this._products.filter(function (product) {
            return product.taxonomy !== undefined &&
                product.taxonomy.categories !== undefined &&
                product.taxonomy.categories.indexOf(categId) !== -1;
        });
        debugOff('Products:', products);
        return products;
    };
    ;
    ProductsService.prototype.getProductById = function (prodId) {
        debugOff('Get product by id  "' + prodId + '"');
        var product = this._products.filter(function (product) {
            return product.code === prodId;
        });
        if (product.length > 1) {
            console.warn('Multiple products have "' + prodId + '" id');
        }
        debugOff('Product:', product[0]);
        return product[0];
    };
    ;
    ProductsService.prototype.getProductOptionImage = function (optionsId, optionId) {
        debugOff('Get option image');
        var imagePath = '';
        if (product_options_1.productOptions[optionsId][optionId] !== undefined) {
            imagePath = this._imgPaths.options + optionsId + '/' + product_options_1.productOptions[optionsId][optionId].image;
        }
        debugOff('Image path:', imagePath);
        return imagePath;
    };
    ProductsService.prototype.getProductOptionName = function (optionsId, optionId) {
        debugOff('Get option name');
        var optionName = '';
        if (product_options_1.productOptions[optionsId][optionId] !== undefined) {
            optionName = product_options_1.productOptions[optionsId][optionId].name;
        }
        debugOff('Option name:', optionName);
        return optionName;
    };
    ProductsService.prototype.initProducts = function (products, globals) {
        products.forEach(function (product) {
            product._globals = globals;
        });
    };
    ProductsService.prototype.refreshAllProducts = function () {
        this._products.forEach(function (product) {
            product.refreshState();
        });
    };
    ProductsService.prototype.appendProductAPI = function (products) {
        var _this = this;
        var self = this;
        products.forEach(function (product) {
            product.displayTooltip = function () {
                product.tooltipIsVisible = true;
                product.package && product.package.products.forEach(function (product) {
                    debugOff('Product:', product);
                    product.tooltipIsVisible = true;
                });
            };
            product.hideTooltip = function () {
                product.tooltipIsVisible = false;
                product.package && product.package.products.forEach(function (product) {
                    product.tooltipIsVisible = false;
                });
            };
            product.updateDynamicProperties = function () {
                _this._dynamicPropertiesService.updateDynamicProperties(product);
            };
            product.generatePackageProducts = function () {
                _this._productsPackagesService.generatePackageProducts(product);
            };
            product.refreshState = function () {
                _this._dynamicPropertiesService.updateDynamicProperties(product);
                if (product.package !== undefined &&
                    product.package.config !== undefined) {
                    _this._productsPackagesService.generatePackageProducts(product);
                }
                _this.events.productStateRefreshed.emit({ product: product });
            };
            product.displayProductDetails = function () {
                debugOff('Display "' + product.code + '" product details');
                _this._appService.displayProductDetailsModal(product);
            };
            product.getClone = function () {
                debugOff('Clone "' + product.code + '" product');
                var clone = Object.assign({}, product);
                debugOff('Clone:', clone);
                return clone;
            };
            product.getNameTags = function () {
                debugOff('Get "' + product.code + '" product name tags');
                var basicGens = ['MS90EC1', 'MS150EC1', 'MS225EC1', 'MS400EC1', 'MSSUPER1EC1', 'MSSUPER2EC1', 'MSSUPER3EC1'];
                var superGens = ['MX4EC1', 'MX5EC1', 'MX6EC1'];
                var currGenerator = _this._catalogService._globals.selectedGenerator;
                var tags = '';
                if (product.code === 'IDREAM_PACKAGE') {
                    if (['MX4EC1', 'MX5EC1', 'MX6EC1'].indexOf(currGenerator) !== -1 &&
                        product.vSpa.isSuperCompatible === true) {
                        tags += ' MAX';
                    }
                }
                if (product.code === 'IBUTLER_PACKAGE') {
                    if (['MX4EC1', 'MX5EC1', 'MX6EC1'].indexOf(currGenerator) !== -1 &&
                        product.vSpa.isSuperCompatible === true) {
                        tags += ' MAX';
                    }
                }
                if (product.code === 'AIRBUTLER_PACKAGE') {
                    if (['MX4EC1', 'MX5EC1', 'MX6EC1'].indexOf(currGenerator) !== -1 &&
                        product.vSpa.isSuperCompatible === true) {
                        tags += ' MAX';
                    }
                }
                if (product.code === 'BUTLER_PACKAGE') {
                    if (['MX4EC1', 'MX5EC1', 'MX6EC1'].indexOf(currGenerator) !== -1 &&
                        product.vSpa.isSuperCompatible === true) {
                        tags += ' MAX';
                    }
                }
                if (product.code === 'ITEMPO_PLUS_PACKAGE') {
                    if (['MX4EC1', 'MX5EC1', 'MX6EC1'].indexOf(currGenerator) !== -1 &&
                        product.vSpa.isSuperCompatible === true) {
                    }
                }
                if (product.code === 'ITEMPO_PACKAGE') {
                    if (['MX4EC1', 'MX5EC1', 'MX6EC1'].indexOf(currGenerator) !== -1 &&
                        product.vSpa.isSuperCompatible === true) {
                    }
                }
                if (product.code === 'AIRTEMPO_PACKAGE') {
                    if (['MX4EC1', 'MX5EC1', 'MX6EC1'].indexOf(currGenerator) !== -1 &&
                        product.vSpa.isSuperCompatible === true) {
                    }
                }
                if (product.code === 'ISTEAM_PACKAGE') {
                    if (['MX4EC1', 'MX5EC1', 'MX6EC1'].indexOf(currGenerator) !== -1 &&
                        product.vSpa.isSuperCompatible === true) {
                    }
                }
                else {
                    if (superGens.indexOf(currGenerator) !== -1 &&
                        product.vSpa.isSuperCompatible === true) {
                    }
                }
                return tags;
            };
            product.getNameTagsSummary = function () {
                debugOff('Get "' + product.code + '" product name tags');
                var basicGens = ['MS90EC1', 'MS150EC1', 'MS225EC1', 'MS400EC1', 'MSSUPER1EC1', 'MSSUPER2EC1', 'MSSUPER3EC1'];
                var superGens = ['MX4EC1', 'MX5EC1', 'MX6EC1'];
                var currGenerator = _this._catalogService._globals.selectedGenerator;
                var tags = '';
                if (product.code === 'IDREAM_PACKAGE') {
                    if (['MX4EC1', 'MX5EC1', 'MX6EC1'].indexOf(currGenerator) !== -1 &&
                        product.vSpa.isSuperCompatible === true) {
                    }
                }
                else {
                    if (superGens.indexOf(currGenerator) !== -1 &&
                        product.vSpa.isSuperCompatible === true) {
                    }
                }
                return tags;
            };
            product.getSceneImage = function () {
                debugOff('Get "' + product.code + '" product scene image');
                var imagePath = null;
                if (product.images.scene !== null) {
                    imagePath = self._imgPaths.products + product.images.folder + 'scene/' + product.images.scene;
                }
                debugOff('Image path:', imagePath);
                return imagePath;
            };
            product.syncWithProduct = function (sourceProduct, properties) {
                debugOff('Sync "' + product.code + '" product with "' + sourceProduct.code + '" target product');
                properties.forEach(function (property) {
                    product[property] = sourceProduct[property];
                });
            };
        });
    };
    ProductsService.prototype._handleError = function (error) {
        console.error(error);
        return Observable_1.Observable.throw(error.json().error || 'Server error');
    };
    return ProductsService;
}());
ProductsService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http,
        products_packages_service_1.ProductsPackagesService,
        dynamic_properties_service_1.DynamicPropertiesService])
], ProductsService);
exports.ProductsService = ProductsService;


/***/ },
/* 436 */
/***/ function(module, exports) {

"use strict";
"use strict";
exports.SELECT_PRODUCT_CATEGORY = 'SELECT_PRODUCT_CATEGORY';
exports.SELECT_PRODUCT = 'SELECT_PRODUCT';
exports.SELECT_RENDER_MODE = 'SELECT_RENDER_MODE';


/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var debug, debugOff = function () {
    var any = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        any[_i] = arguments[_i];
    }
};
"production" !== 'production' && (debug = __webpack_require__(4)('app:NotFound404PageCmp'));
var NotFound404PageCmp = (function () {
    function NotFound404PageCmp() {
    }
    return NotFound404PageCmp;
}());
NotFound404PageCmp = __decorate([
    core_1.Component({
        selector: 'not-found-404-page-cmp',
        template: __webpack_require__(864),
        styles: [String(__webpack_require__(1153))],
        host: { 'class': 'not-found-404 page' }
    }),
    __metadata("design:paramtypes", [])
], NotFound404PageCmp);
exports.NotFound404PageCmp = NotFound404PageCmp;


/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var platform_browser_1 = __webpack_require__(49);
var ng2_translate_1 = __webpack_require__(161);
var forms_1 = __webpack_require__(260);
var http_1 = __webpack_require__(43);
var router_1 = __webpack_require__(115);
var app_service_1 = __webpack_require__(23);
var translate_service_1 = __webpack_require__(669);
var navigation_service_1 = __webpack_require__(81);
var animate_service_1 = __webpack_require__(147);
var logs_service_1 = __webpack_require__(285);
var utils_service_1 = __webpack_require__(286);
var not_found_404_page_cmp_1 = __webpack_require__(437);
var navigation_menu_cmp_1 = __webpack_require__(663);
var quick_menu_cmp_1 = __webpack_require__(665);
var start_arrow_cmp_1 = __webpack_require__(666);
var modal_cmp_1 = __webpack_require__(667);
var alert_cmp_1 = __webpack_require__(662);
var options_menu_cmp_1 = __webpack_require__(664);
var product_categories_list_cmp_1 = __webpack_require__(650);
var products_tiny_list_cmp_1 = __webpack_require__(656);
var debug, debugOff = function () {
    var any = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        any[_i] = arguments[_i];
    }
};
"production" !== 'production' && (debug = __webpack_require__(4)('app:SharedModule'));
var SharedModule = (function () {
    function SharedModule() {
    }
    return SharedModule;
}());
SharedModule = __decorate([
    core_1.NgModule({
        imports: [
            platform_browser_1.BrowserModule,
            ng2_translate_1.TranslateModule,
            forms_1.FormsModule,
            forms_1.ReactiveFormsModule,
            http_1.HttpModule,
            router_1.RouterModule
        ],
        providers: [
            app_service_1.AppService,
            translate_service_1.TranslateService,
            navigation_service_1.NavigationService,
            animate_service_1.AnimateService,
            logs_service_1.LogsService,
            utils_service_1.UtilsService
        ],
        declarations: [
            not_found_404_page_cmp_1.NotFound404PageCmp,
            navigation_menu_cmp_1.NavigationMenuCmp,
            quick_menu_cmp_1.QuickMenuCmp,
            start_arrow_cmp_1.StartArrowCmp,
            modal_cmp_1.ModalCmp,
            alert_cmp_1.AlertCmp,
            options_menu_cmp_1.OptionsMenuCmp,
            product_categories_list_cmp_1.ProductCategoriesListCmp,
            products_tiny_list_cmp_1.ProductsTinyListCmp
        ],
        exports: [
            ng2_translate_1.TranslateModule,
            platform_browser_1.BrowserModule,
            forms_1.FormsModule,
            forms_1.ReactiveFormsModule,
            http_1.HttpModule,
            router_1.RouterModule,
            navigation_menu_cmp_1.NavigationMenuCmp,
            quick_menu_cmp_1.QuickMenuCmp,
            modal_cmp_1.ModalCmp,
            alert_cmp_1.AlertCmp,
            options_menu_cmp_1.OptionsMenuCmp,
        ]
    }),
    __metadata("design:paramtypes", [])
], SharedModule);
exports.SharedModule = SharedModule;


/***/ },
/* 439 */
/***/ function(module, exports) {

"use strict";
"use strict";
exports.DISPLAY_NAVIGATION_MENU = 'DISPLAY_NAVIGATION_MENU';
exports.HIDE_NAVIGATION_MENU = 'HIDE_NAVIGATION_MENU';
exports.DISPLAY_START_ARROW = 'DISPLAY_START_ARROW';
exports.HIDE_START_ARROW = 'HIDE_START_ARROW';
exports.DISPLAY_PRODUCT_DETAILS_MODAL = 'DISPLAY_PRODUCT_DETAILS_MODAL';
exports.HIDE_PRODUCT_DETAILS_MODAL = 'HIDE_PRODUCT_DETAILS_MODAL';
exports.DISPLAY_PRINT_SUMMARY_MODAL = 'DISPLAY_PRINT_SUMMARY_MODAL';
exports.HIDE_PRINT_SUMMARY_MODAL = 'HIDE_PRINT_SUMMARY_MODAL';
exports.DISPLAY_EMAIL_SUMMARY_MODAL = 'DISPLAY_EMAIL_SUMMARY_MODAL';
exports.HIDE_EMAIL_SUMMARY_MODAL = 'HIDE_EMAIL_SUMMARY_MODAL';
exports.DISPLAY_ALERT_MODAL = 'DISPLAY_ALER_MODAL';
exports.HIDE_ALERT_MODAL = 'HIDE_ALERT_MODAL';
exports.DISPLAY_ONLY_DROPDOWN = 'DISPLAY_ONLY_DROPDOWN';
exports.DISPLAY_ALL_CONTENT = 'DISPLAY_ALL_CONTENT';
exports.DISPLAY_OPTIONS_MENU = 'DISPLAY_OPTIONS_MENU';
exports.HIDE_OPTIONS_MENU = 'HIDE_OPTIONS_MENU';
exports.DISPLAY_PREVIEW = 'DISPLAY_PREVIEW';
exports.HIDE_PREVIEW = 'HIDE_PREVIEW';


/***/ },
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var ModalBodyComponent = (function () {
    function ModalBodyComponent() {
    }
    ModalBodyComponent.decorators = [
        { type: core_1.Component, args: [{
                    selector: 'modal-body',
                    template: "\n        <div class=\"modal-body\">\n            <ng-content></ng-content>\n        </div>\n    "
                },] },
    ];
    /** @nocollapse */
    ModalBodyComponent.ctorParameters = [];
    return ModalBodyComponent;
}());
exports.ModalBodyComponent = ModalBodyComponent;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibW9kYWwtYm9keS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9uZzItYnMzLW1vZGFsL2NvbXBvbmVudHMvbW9kYWwtYm9keS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEscUJBQTZELGVBQWUsQ0FBQyxDQUFBO0FBSTdFO0lBQUE7SUFjQSxDQUFDO0lBYk0sNkJBQVUsR0FBMEI7UUFDM0MsRUFBRSxJQUFJLEVBQUUsZ0JBQVMsRUFBRSxJQUFJLEVBQUUsQ0FBQztvQkFDdEIsUUFBUSxFQUFFLFlBQVk7b0JBQ3RCLFFBQVEsRUFBRSxtR0FJVDtpQkFDSixFQUFHLEVBQUU7S0FDTCxDQUFDO0lBQ0Ysa0JBQWtCO0lBQ1gsaUNBQWMsR0FBNkQsRUFDakYsQ0FBQztJQUNGLHlCQUFDO0FBQUQsQ0FBQyxBQWRELElBY0M7QUFkWSwwQkFBa0IscUJBYzlCLENBQUEifQ==

/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var modal_1 = __webpack_require__(151);
var ModalFooterComponent = (function () {
    function ModalFooterComponent(modal) {
        this.modal = modal;
        this.showDefaultButtons = false;
        this.dismissButtonLabel = 'Dismiss';
        this.closeButtonLabel = 'Close';
    }
    ModalFooterComponent.decorators = [
        { type: core_1.Component, args: [{
                    selector: 'modal-footer',
                    template: "\n        <div class=\"modal-footer\">\n            <ng-content></ng-content>\n            <button *ngIf=\"showDefaultButtons\" type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" (click)=\"modal.dismiss()\">{{dismissButtonLabel}}</button>\n            <button *ngIf=\"showDefaultButtons\" type=\"button\" class=\"btn btn-primary\" (click)=\"modal.close()\">{{closeButtonLabel}}</button>\n        </div>\n    "
                },] },
    ];
    /** @nocollapse */
    ModalFooterComponent.ctorParameters = [
        { type: modal_1.ModalComponent, },
    ];
    ModalFooterComponent.propDecorators = {
        'showDefaultButtons': [{ type: core_1.Input, args: ['show-default-buttons',] },],
        'dismissButtonLabel': [{ type: core_1.Input, args: ['dismiss-button-label',] },],
        'closeButtonLabel': [{ type: core_1.Input, args: ['close-button-label',] },],
    };
    return ModalFooterComponent;
}());
exports.ModalFooterComponent = ModalFooterComponent;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibW9kYWwtZm9vdGVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL25nMi1iczMtbW9kYWwvY29tcG9uZW50cy9tb2RhbC1mb290ZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLHFCQUF5QyxlQUFlLENBQUMsQ0FBQTtBQUN6RCxzQkFBK0IsU0FBUyxDQUFDLENBQUE7QUFHekM7SUFJSSw4QkFBb0IsS0FBcUI7UUFBckIsVUFBSyxHQUFMLEtBQUssQ0FBZ0I7UUFIeEMsdUJBQWtCLEdBQVksS0FBSyxDQUFDO1FBQ3BDLHVCQUFrQixHQUFXLFNBQVMsQ0FBQztRQUN2QyxxQkFBZ0IsR0FBVyxPQUFPLENBQUM7SUFDUyxDQUFDO0lBQzNDLCtCQUFVLEdBQTBCO1FBQzNDLEVBQUUsSUFBSSxFQUFFLGdCQUFTLEVBQUUsSUFBSSxFQUFFLENBQUM7b0JBQ3RCLFFBQVEsRUFBRSxjQUFjO29CQUN4QixRQUFRLEVBQUUsd2FBTVQ7aUJBQ0osRUFBRyxFQUFFO0tBQ0wsQ0FBQztJQUNGLGtCQUFrQjtJQUNYLG1DQUFjLEdBQTZEO1FBQ2xGLEVBQUMsSUFBSSxFQUFFLHNCQUFjLEdBQUc7S0FDdkIsQ0FBQztJQUNLLG1DQUFjLEdBQTJDO1FBQ2hFLG9CQUFvQixFQUFFLENBQUMsRUFBRSxJQUFJLEVBQUUsWUFBSyxFQUFFLElBQUksRUFBRSxDQUFDLHNCQUFzQixFQUFHLEVBQUUsRUFBRTtRQUMxRSxvQkFBb0IsRUFBRSxDQUFDLEVBQUUsSUFBSSxFQUFFLFlBQUssRUFBRSxJQUFJLEVBQUUsQ0FBQyxzQkFBc0IsRUFBRyxFQUFFLEVBQUU7UUFDMUUsa0JBQWtCLEVBQUUsQ0FBQyxFQUFFLElBQUksRUFBRSxZQUFLLEVBQUUsSUFBSSxFQUFFLENBQUMsb0JBQW9CLEVBQUcsRUFBRSxFQUFFO0tBQ3JFLENBQUM7SUFDRiwyQkFBQztBQUFELENBQUMsQUExQkQsSUEwQkM7QUExQlksNEJBQW9CLHVCQTBCaEMsQ0FBQSJ9

/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var modal_1 = __webpack_require__(151);
var ModalHeaderComponent = (function () {
    function ModalHeaderComponent(modal) {
        this.modal = modal;
        this.showClose = false;
    }
    ModalHeaderComponent.decorators = [
        { type: core_1.Component, args: [{
                    selector: 'modal-header',
                    template: "\n        <div class=\"modal-header\">\n            <button *ngIf=\"showClose\" type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" (click)=\"modal.dismiss()\">\n                <span aria-hidden=\"true\">&times;</span>\n            </button>\n            <ng-content></ng-content>\n        </div>\n    "
                },] },
    ];
    /** @nocollapse */
    ModalHeaderComponent.ctorParameters = [
        { type: modal_1.ModalComponent, },
    ];
    ModalHeaderComponent.propDecorators = {
        'showClose': [{ type: core_1.Input, args: ['show-close',] },],
    };
    return ModalHeaderComponent;
}());
exports.ModalHeaderComponent = ModalHeaderComponent;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibW9kYWwtaGVhZGVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL25nMi1iczMtbW9kYWwvY29tcG9uZW50cy9tb2RhbC1oZWFkZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLHFCQUF5QyxlQUFlLENBQUMsQ0FBQTtBQUN6RCxzQkFBK0IsU0FBUyxDQUFDLENBQUE7QUFHekM7SUFFSSw4QkFBb0IsS0FBcUI7UUFBckIsVUFBSyxHQUFMLEtBQUssQ0FBZ0I7UUFEeEMsY0FBUyxHQUFZLEtBQUssQ0FBQztJQUNpQixDQUFDO0lBQzNDLCtCQUFVLEdBQTBCO1FBQzNDLEVBQUUsSUFBSSxFQUFFLGdCQUFTLEVBQUUsSUFBSSxFQUFFLENBQUM7b0JBQ3RCLFFBQVEsRUFBRSxjQUFjO29CQUN4QixRQUFRLEVBQUUseVVBT1Q7aUJBQ0osRUFBRyxFQUFFO0tBQ0wsQ0FBQztJQUNGLGtCQUFrQjtJQUNYLG1DQUFjLEdBQTZEO1FBQ2xGLEVBQUMsSUFBSSxFQUFFLHNCQUFjLEdBQUc7S0FDdkIsQ0FBQztJQUNLLG1DQUFjLEdBQTJDO1FBQ2hFLFdBQVcsRUFBRSxDQUFDLEVBQUUsSUFBSSxFQUFFLFlBQUssRUFBRSxJQUFJLEVBQUUsQ0FBQyxZQUFZLEVBQUcsRUFBRSxFQUFFO0tBQ3RELENBQUM7SUFDRiwyQkFBQztBQUFELENBQUMsQUF2QkQsSUF1QkM7QUF2QlksNEJBQW9CLHVCQXVCaEMsQ0FBQSJ9

/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var Observable_1 = __webpack_require__(1);
__webpack_require__(314);
__webpack_require__(478);
var ModalInstance = (function () {
    function ModalInstance(element) {
        this.element = element;
        this.suffix = '.ng2-bs3-modal';
        this.shownEventName = 'shown.bs.modal' + this.suffix;
        this.hiddenEventName = 'hidden.bs.modal' + this.suffix;
        this.visible = false;
        this.init();
    }
    ModalInstance.prototype.open = function () {
        return this.show();
    };
    ModalInstance.prototype.close = function () {
        this.result = ModalResult.Close;
        return this.hide();
    };
    ModalInstance.prototype.dismiss = function () {
        this.result = ModalResult.Dismiss;
        return this.hide();
    };
    ModalInstance.prototype.destroy = function () {
        var _this = this;
        return this.hide().then(function () {
            if (_this.$modal) {
                _this.$modal.data('bs.modal', null);
                _this.$modal.remove();
            }
        });
    };
    ModalInstance.prototype.show = function () {
        var promise = toPromise(this.shown);
        this.resetData();
        this.$modal.modal();
        return promise;
    };
    ModalInstance.prototype.hide = function () {
        if (this.$modal && this.visible) {
            var promise = toPromise(this.hidden);
            this.$modal.modal('hide');
            return promise;
        }
        return Promise.resolve(this.result);
    };
    ModalInstance.prototype.init = function () {
        var _this = this;
        this.$modal = jQuery(this.element.nativeElement);
        this.$modal.appendTo('body');
        this.shown = Observable_1.Observable.fromEvent(this.$modal, this.shownEventName)
            .map(function () {
            _this.visible = true;
        });
        this.hidden = Observable_1.Observable.fromEvent(this.$modal, this.hiddenEventName)
            .map(function () {
            var result = (!_this.result || _this.result === ModalResult.None)
                ? ModalResult.Dismiss : _this.result;
            _this.result = ModalResult.None;
            _this.visible = false;
            return result;
        });
    };
    ModalInstance.prototype.resetData = function () {
        this.$modal.removeData();
        this.$modal.data('backdrop', booleanOrValue(this.$modal.attr('data-backdrop')));
        this.$modal.data('keyboard', booleanOrValue(this.$modal.attr('data-keyboard')));
    };
    return ModalInstance;
}());
exports.ModalInstance = ModalInstance;
function booleanOrValue(value) {
    if (value === 'true')
        return true;
    else if (value === 'false')
        return false;
    return value;
}
function toPromise(observable) {
    return new Promise(function (resolve, reject) {
        observable.subscribe(function (next) {
            resolve(next);
        });
    });
}
(function (ModalResult) {
    ModalResult[ModalResult["None"] = 0] = "None";
    ModalResult[ModalResult["Close"] = 1] = "Close";
    ModalResult[ModalResult["Dismiss"] = 2] = "Dismiss";
})(exports.ModalResult || (exports.ModalResult = {}));
var ModalResult = exports.ModalResult;
//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
var core_1 = __webpack_require__(0);
var common_1 = __webpack_require__(71);
var modal_1 = __webpack_require__(151);
var modal_header_1 = __webpack_require__(469);
var modal_body_1 = __webpack_require__(467);
var modal_footer_1 = __webpack_require__(468);
var autofocus_1 = __webpack_require__(866);
__export(__webpack_require__(151));
__export(__webpack_require__(469));
__export(__webpack_require__(467));
__export(__webpack_require__(468));
__export(__webpack_require__(470));
var Ng2Bs3ModalModule = (function () {
    function Ng2Bs3ModalModule() {
    }
    Ng2Bs3ModalModule.decorators = [
        { type: core_1.NgModule, args: [{
                    imports: [
                        common_1.CommonModule
                    ],
                    declarations: [
                        modal_1.ModalComponent,
                        modal_header_1.ModalHeaderComponent,
                        modal_body_1.ModalBodyComponent,
                        modal_footer_1.ModalFooterComponent,
                        autofocus_1.AutofocusDirective
                    ],
                    exports: [
                        modal_1.ModalComponent,
                        modal_header_1.ModalHeaderComponent,
                        modal_body_1.ModalBodyComponent,
                        modal_footer_1.ModalFooterComponent,
                        autofocus_1.AutofocusDirective
                    ]
                },] },
    ];
    /** @nocollapse */
    Ng2Bs3ModalModule.ctorParameters = [];
    return Ng2Bs3ModalModule;
}());
exports.Ng2Bs3ModalModule = Ng2Bs3ModalModule;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibmcyLWJzMy1tb2RhbC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInNyYy9uZzItYnMzLW1vZGFsL25nMi1iczMtbW9kYWwudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7OztBQUFBLHFCQUF5QixlQUFlLENBQUMsQ0FBQTtBQUN6Qyx1QkFBNkIsaUJBQWlCLENBQUMsQ0FBQTtBQUUvQyxzQkFBK0Isb0JBQW9CLENBQUMsQ0FBQTtBQUNwRCw2QkFBcUMsMkJBQTJCLENBQUMsQ0FBQTtBQUNqRSwyQkFBbUMseUJBQXlCLENBQUMsQ0FBQTtBQUM3RCw2QkFBcUMsMkJBQTJCLENBQUMsQ0FBQTtBQUNqRSwwQkFBbUMsd0JBQXdCLENBQUMsQ0FBQTtBQUU1RCxpQkFBYyxvQkFBb0IsQ0FBQyxFQUFBO0FBQ25DLGlCQUFjLDJCQUEyQixDQUFDLEVBQUE7QUFDMUMsaUJBQWMseUJBQXlCLENBQUMsRUFBQTtBQUN4QyxpQkFBYywyQkFBMkIsQ0FBQyxFQUFBO0FBQzFDLGlCQUFjLDZCQUE2QixDQUFDLEVBQUE7QUFHNUM7SUFBQTtJQXlCQSxDQUFDO0lBeEJNLDRCQUFVLEdBQTBCO1FBQzNDLEVBQUUsSUFBSSxFQUFFLGVBQVEsRUFBRSxJQUFJLEVBQUUsQ0FBQztvQkFDckIsT0FBTyxFQUFFO3dCQUNMLHFCQUFZO3FCQUNmO29CQUNELFlBQVksRUFBRTt3QkFDVixzQkFBYzt3QkFDZCxtQ0FBb0I7d0JBQ3BCLCtCQUFrQjt3QkFDbEIsbUNBQW9CO3dCQUNwQiw4QkFBa0I7cUJBQ3JCO29CQUNELE9BQU8sRUFBRTt3QkFDTCxzQkFBYzt3QkFDZCxtQ0FBb0I7d0JBQ3BCLCtCQUFrQjt3QkFDbEIsbUNBQW9CO3dCQUNwQiw4QkFBa0I7cUJBQ3JCO2lCQUNKLEVBQUcsRUFBRTtLQUNMLENBQUM7SUFDRixrQkFBa0I7SUFDWCxnQ0FBYyxHQUE2RCxFQUNqRixDQUFDO0lBQ0Ysd0JBQUM7QUFBRCxDQUFDLEFBekJELElBeUJDO0FBekJZLHlCQUFpQixvQkF5QjdCLENBQUEifQ==

/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ng2_page_scroll_config__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ng2_page_scroll_util_service__ = __webpack_require__(210);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return PageScrollInstance; });
/**
 * Created by sebastianfuss on 29.08.16.
 */



/**
 * Represents a scrolling action
 */
var PageScrollInstance = (function () {
    /**
     * Private constructor, requires the properties assumed to be the bare minimum.
     * Use the factory methods to create instances:
     *      {@link PageScrollInstance#simpleInstance}
     *      {@link PageScrollInstance#newInstance}
     * @param namespace
     * @param document
     */
    function PageScrollInstance(namespace, document) {
        /**
         * These properties will be set during instance construction and default to their defaults from PageScrollConfig
         */
        /* A namespace to "group" scroll animations together and stopping some does not stop others */
        this._namespace = __WEBPACK_IMPORTED_MODULE_1__ng2_page_scroll_config__["a" /* PageScrollConfig */]._defaultNamespace;
        /* Whether we scroll vertically (true) or horizontally (false) */
        this._verticalScrolling = __WEBPACK_IMPORTED_MODULE_1__ng2_page_scroll_config__["a" /* PageScrollConfig */].defaultIsVerticalScrolling;
        /* Offset in px that the animation should stop above that target element */
        this._offset = __WEBPACK_IMPORTED_MODULE_1__ng2_page_scroll_config__["a" /* PageScrollConfig */].defaultScrollOffset;
        /* Duration in milliseconds the scroll animation should last */
        this._duration = __WEBPACK_IMPORTED_MODULE_1__ng2_page_scroll_config__["a" /* PageScrollConfig */].defaultDuration;
        /* Easing function to manipulate the scrollTop/scrollLeft value over time */
        this._easingLogic = __WEBPACK_IMPORTED_MODULE_1__ng2_page_scroll_config__["a" /* PageScrollConfig */].defaultEasingLogic;
        /* Boolean whether the scroll animation should stop on user interruption or not */
        this._interruptible = __WEBPACK_IMPORTED_MODULE_1__ng2_page_scroll_config__["a" /* PageScrollConfig */].defaultInterruptible;
        /* Whether the advanded offset calculation for inline scrolling should be used */
        this._advancedInlineOffsetCalculation = __WEBPACK_IMPORTED_MODULE_1__ng2_page_scroll_config__["a" /* PageScrollConfig */].defaultAdvancedInlineOffsetCalculation;
        /* Event emitter to notify the world about the scrolling */
        this._pageScrollFinish = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
         * These properties will be set/manipulated if the scroll animation starts
         */
        /* The initial value of the scrollTop or scrollLeft position when the animation starts */
        this._startScrollPosition = 0;
        /* Whether an interrupt listener is attached to the body or not */
        this._interruptListenersAttached = false;
        /* References to the timer instance that is used to perform the scroll animation to be
         able to clear it on animation end*/
        this._timer = null;
        this._namespace = namespace;
        this.document = document;
    }
    /*
     * Factory methods for instance creation
     */
    PageScrollInstance.simpleInstance = function (document, scrollTarget, namespace) {
        return PageScrollInstance.newInstance({
            document: document,
            scrollTarget: scrollTarget,
            namespace: namespace
        });
    };
    PageScrollInstance.newInstance = function (options) {
        if (__WEBPACK_IMPORTED_MODULE_2__ng2_page_scroll_util_service__["a" /* PageScrollUtilService */].isUndefinedOrNull(options.namespace) || options.namespace.length <= 0) {
            options.namespace = __WEBPACK_IMPORTED_MODULE_1__ng2_page_scroll_config__["a" /* PageScrollConfig */]._defaultNamespace;
        }
        var pageScrollInstance = new PageScrollInstance(options.namespace, document);
        if (__WEBPACK_IMPORTED_MODULE_2__ng2_page_scroll_util_service__["a" /* PageScrollUtilService */].isUndefinedOrNull(options.scrollingViews) || options.scrollingViews.length === 0) {
            pageScrollInstance._isInlineScrolling = false;
            pageScrollInstance._scrollingViews = [document.documentElement, document.body, document.body.parentNode];
        }
        else {
            pageScrollInstance._isInlineScrolling = true;
            pageScrollInstance._scrollingViews = options.scrollingViews;
        }
        pageScrollInstance._scrollTarget = options.scrollTarget;
        if (!__WEBPACK_IMPORTED_MODULE_2__ng2_page_scroll_util_service__["a" /* PageScrollUtilService */].isUndefinedOrNull(options.verticalScrolling)) {
            pageScrollInstance._verticalScrolling = options.verticalScrolling;
        }
        if (!__WEBPACK_IMPORTED_MODULE_2__ng2_page_scroll_util_service__["a" /* PageScrollUtilService */].isUndefinedOrNull(options.pageScrollOffset)) {
            pageScrollInstance._offset = options.pageScrollOffset;
        }
        if (!__WEBPACK_IMPORTED_MODULE_2__ng2_page_scroll_util_service__["a" /* PageScrollUtilService */].isUndefinedOrNull(options.pageScrollEasingLogic)) {
            pageScrollInstance._easingLogic = options.pageScrollEasingLogic;
        }
        if (__WEBPACK_IMPORTED_MODULE_2__ng2_page_scroll_util_service__["a" /* PageScrollUtilService */].isUndefinedOrNull(options.pageScrollDuration) && !__WEBPACK_IMPORTED_MODULE_2__ng2_page_scroll_util_service__["a" /* PageScrollUtilService */].isUndefinedOrNull(options.pageScrollSpeed)) {
            // No duration specified in the options, only in this case we use the speed option when present
            pageScrollInstance._speed = options.pageScrollSpeed;
            pageScrollInstance._duration = undefined;
        }
        else if (!__WEBPACK_IMPORTED_MODULE_2__ng2_page_scroll_util_service__["a" /* PageScrollUtilService */].isUndefinedOrNull(options.pageScrollDuration)) {
            pageScrollInstance._duration = options.pageScrollDuration;
        }
        if (!__WEBPACK_IMPORTED_MODULE_2__ng2_page_scroll_util_service__["a" /* PageScrollUtilService */].isUndefinedOrNull(options.pageScrollFinishListener)) {
            pageScrollInstance._pageScrollFinish = options.pageScrollFinishListener;
        }
        pageScrollInstance._interruptible = options.pageScrollInterruptible ||
            (__WEBPACK_IMPORTED_MODULE_2__ng2_page_scroll_util_service__["a" /* PageScrollUtilService */].isUndefinedOrNull(options.pageScrollInterruptible) && __WEBPACK_IMPORTED_MODULE_1__ng2_page_scroll_config__["a" /* PageScrollConfig */].defaultInterruptible);
        pageScrollInstance._advancedInlineOffsetCalculation = options.advancedInlineOffsetCalculation ||
            (__WEBPACK_IMPORTED_MODULE_2__ng2_page_scroll_util_service__["a" /* PageScrollUtilService */].isUndefinedOrNull(options.advancedInlineOffsetCalculation) &&
                __WEBPACK_IMPORTED_MODULE_1__ng2_page_scroll_config__["a" /* PageScrollConfig */].defaultAdvancedInlineOffsetCalculation);
        return pageScrollInstance;
    };
    /**
     * Create a PageScrollInstance representing a scroll animation on the documents body.
     *
     * @param document The document that contains the body to be scrolled and the scrollTarget elements
     * @param scrollTarget Where to scroll to. Can be a HTMLElement reference or a string like '#elementId'
     * @param verticalScrolling
     * @param namespace Optional namespace to group scroll animations logically
     * @returns {PageScrollInstance}
     *
     * @deprecated Use {@link newInstance(options: PageScrollOptions)}
     **/
    PageScrollInstance.simpleDirectionInstance = function (document, scrollTarget, verticalScrolling, namespace) {
        return PageScrollInstance.newInstance({
            document: document,
            scrollTarget: scrollTarget,
            namespace: namespace,
            verticalScrolling: verticalScrolling,
        });
    };
    /**
     * Create a PageScrollInstance representing a scroll animation to the target element where the scrollingView
     * elements get scrolled (like a div container with fixed height, resulting in scrollbars in it).
     *
     * Make sure that the scrollTarget is located inside the scrollingView in the DOM hierarchy, otherwise the
     * scrollingView will be scrolled to an apparently arbitrary position.
     *
     * @param document The document that contains the body to be scrolled and the scrollTarget elements
     * @param scrollTarget Where to scroll to. Can be a HTMLElement reference or a string like '#elementId'
     * @param scrollingView The element that should be scrolled
     * @param namespace Optional namespace to group scroll animations logically
     * @returns {PageScrollInstance}
     *
     * @deprecated Use {@link newInstance(options: PageScrollOptions)}
     */
    PageScrollInstance.simpleInlineInstance = function (document, scrollTarget, scrollingView, namespace) {
        return PageScrollInstance.newInstance({
            document: document,
            scrollTarget: scrollTarget,
            scrollingViews: [scrollingView],
            verticalScrolling: true,
            namespace: namespace
        });
    };
    /**
     *
     * @param document The document that contains the body to be scrolled and the scrollTarget elements
     * @param scrollTarget Where to scroll to. Can be a HTMLElement reference or a string like '#elementId'
     * @param scrollingView The element that should be scrolled
     * @param verticalScrolling whether the scrolling should be performed in vertical direction (true, default) or horizontal (false)
     * @param namespace Optional namespace to group scroll animations logically
     * @returns {PageScrollInstance}
     *
     * @deprecated Use {@link newInstance(options: PageScrollOptions)}
     */
    PageScrollInstance.simpleInlineDirectionInstance = function (document, scrollTarget, scrollingView, verticalScrolling, namespace) {
        return PageScrollInstance.newInstance({
            document: document,
            scrollTarget: scrollTarget,
            scrollingViews: [scrollingView],
            namespace: namespace,
            verticalScrolling: verticalScrolling,
        });
    };
    /**
     *
     * @param document The document that contains the body to be scrolled and the scrollTarget elements
     * @param scrollTarget Where to scroll to. Can be a HTMLElement reference or a string like '#elementId'
     * @param scrollingViews The elements that should be scrolled. Null to use the default elements of document and body.
     * @param namespace Optional namespace to group scroll animations logically
     * @param verticalScrolling whether the scrolling should be performed in vertical direction (true, default) or horizontal (false)
     * @param pageScrollOffset The offset to be attached to the top of the target element or
     *                          null/undefined to use application default
     * @param pageScrollInterruptible Whether this scroll animation should be interruptible.
     *                                 Null/undefined for application default
     * @param pageScrollEasingLogic Easing function to be used for manipulating the scroll position
     *                          over time. Null/undefined for application default
     * @param pageScrollDuration The duration in milliseconds the animation should last.
     *                            Null/undefined for application default
     * @param pageScrollFinishListener Listener to be called to notify other parts of the application
     *                                  that the scroll animation has finished
     * @returns {PageScrollInstance}
     *
     * @deprecated Use {@link newInstance(options: PageScrollOptions)}
     */
    PageScrollInstance.advancedInstance = function (document, scrollTarget, scrollingViews, namespace, verticalScrolling, pageScrollOffset, pageScrollInterruptible, pageScrollEasingLogic, pageScrollDuration, pageScrollFinishListener) {
        return PageScrollInstance.newInstance({
            document: document,
            scrollTarget: scrollTarget,
            scrollingViews: scrollingViews,
            namespace: namespace,
            verticalScrolling: verticalScrolling,
            pageScrollOffset: pageScrollOffset,
            pageScrollInterruptible: pageScrollInterruptible,
            pageScrollEasingLogic: pageScrollEasingLogic,
            pageScrollDuration: pageScrollDuration,
            pageScrollFinishListener: pageScrollFinishListener
        });
    };
    PageScrollInstance.prototype.getScrollPropertyValue = function (scrollingView) {
        if (!this.verticalScrolling) {
            return scrollingView.scrollLeft;
        }
        return scrollingView.scrollTop;
    };
    /**
     * Extract the exact location of the scrollTarget element.
     *
     * Extract the scrollTarget HTMLElement from the given PageScrollTarget object. The latter one may be
     * a string like "#heading2", then this method returns the corresponding DOM element for that id.
     *
     * @returns {HTMLElement}
     */
    PageScrollInstance.prototype.extractScrollTargetPosition = function () {
        var scrollTargetElement;
        if (typeof this._scrollTarget === 'string') {
            scrollTargetElement = this.document.getElementById(this._scrollTarget.substr(1));
        }
        else {
            scrollTargetElement = this._scrollTarget;
        }
        if (scrollTargetElement === null || scrollTargetElement === undefined) {
            // Scroll target not found
            return { top: NaN, left: NaN };
        }
        if (this._isInlineScrolling) {
            var position = { top: scrollTargetElement.offsetTop, left: scrollTargetElement.offsetLeft };
            if (this._advancedInlineOffsetCalculation && this.scrollingViews.length === 1) {
                var accumulatedParentsPos = { top: 0, left: 0 };
                // not named window to make sure we're not getting the global window variable by accident
                var theWindow = scrollTargetElement.ownerDocument.defaultView;
                var parentFound = false;
                // Start parent is the immediate parent
                var parent_1 = scrollTargetElement.parentElement;
                // Iterate upwards all parents
                while (!parentFound && !__WEBPACK_IMPORTED_MODULE_2__ng2_page_scroll_util_service__["a" /* PageScrollUtilService */].isUndefinedOrNull(parent_1)) {
                    if (theWindow.getComputedStyle(parent_1).getPropertyValue('position') === 'relative') {
                        accumulatedParentsPos.top += parent_1.offsetTop;
                        accumulatedParentsPos.left += parent_1.offsetLeft;
                    }
                    // Next iteration
                    parent_1 = parent_1.parentElement;
                    parentFound = parent_1 === this.scrollingViews[0];
                }
                if (parentFound) {
                    // Only use the results if we found the parent, otherwise we accumulated too much anyway
                    position.top += accumulatedParentsPos.top;
                    position.left += accumulatedParentsPos.left;
                }
                else {
                    if (__WEBPACK_IMPORTED_MODULE_1__ng2_page_scroll_config__["a" /* PageScrollConfig */]._logLevel >= 2) {
                        console.warn('Unable to find nested scrolling targets parent!');
                    }
                }
            }
            return position;
        }
        return __WEBPACK_IMPORTED_MODULE_2__ng2_page_scroll_util_service__["a" /* PageScrollUtilService */].extractElementPosition(this.document, scrollTargetElement);
    };
    /**
     * Get the top offset of the scroll animation.
     * This automatically takes the offset location of the scrolling container/scrolling view
     * into account (for nested/inline scrolling).
     *
     * @returns {number}
     */
    PageScrollInstance.prototype.getCurrentOffset = function () {
        return this._offset;
    };
    /**
     * Sets the "scrollTop" or "scrollLeft" property for all scrollingViews to the provided value
     * @param position
     * @return true if at least for one ScrollTopSource the scrollTop/scrollLeft value could be set and it kept the new value.
     *          false if it failed for all ScrollingViews, meaning that we should stop the animation
     *          (probably because we're at the end of the scrolling region)
     */
    PageScrollInstance.prototype.setScrollPosition = function (position) {
        var _this = this;
        if (__WEBPACK_IMPORTED_MODULE_1__ng2_page_scroll_config__["a" /* PageScrollConfig */]._logLevel >= 5) {
            console.warn('Scroll Position: ' + position);
        }
        // Set the new scrollTop/scrollLeft to all scrollingViews elements
        return this.scrollingViews.reduce(function (oneAlreadyWorked, scrollingView) {
            var startScrollPropertyValue = _this.getScrollPropertyValue(scrollingView);
            if (scrollingView && !__WEBPACK_IMPORTED_MODULE_2__ng2_page_scroll_util_service__["a" /* PageScrollUtilService */].isUndefinedOrNull(startScrollPropertyValue)) {
                var scrollDistance = Math.abs(startScrollPropertyValue - position);
                // The movement we need to perform is less than 2px
                // This we consider a small movement which some browser may not perform when
                // changing the scrollTop/scrollLeft property
                // Thus in this cases we do not stop the scroll animation, although setting the
                // scrollTop/scrollLeft value "fails"
                var isSmallMovement = scrollDistance < __WEBPACK_IMPORTED_MODULE_1__ng2_page_scroll_config__["a" /* PageScrollConfig */]._minScrollDistance;
                if (!_this.verticalScrolling) {
                    scrollingView.scrollLeft = position;
                }
                else {
                    scrollingView.scrollTop = position;
                }
                // Return true of setting the new scrollTop/scrollLeft value worked
                // We consider that it worked if the new scrollTop/scrollLeft value is closer to the
                // desired scrollTop/scrollLeft than before (it might not be exactly the value we
                // set due to dpi or rounding irregularities)
                if (isSmallMovement || scrollDistance > Math.abs(_this.getScrollPropertyValue(scrollingView) - position)) {
                    return true;
                }
            }
            return oneAlreadyWorked;
        }, false);
    };
    /**
     * Trigger firing a animation finish event
     * @param value Whether the animation finished at the target (true) or got interrupted (false)
     */
    PageScrollInstance.prototype.fireEvent = function (value) {
        if (this._pageScrollFinish) {
            this._pageScrollFinish.emit(value);
        }
    };
    /**
     * Attach the interrupt listeners to the PageScrollInstance body. The given interruptReporter
     * will be called if any of the attached events is fired.
     *
     * Possibly attached interruptListeners are automatically removed from the body before the new one will be attached.
     *
     * @param interruptReporter
     */
    PageScrollInstance.prototype.attachInterruptListeners = function (interruptReporter) {
        var _this = this;
        if (this._interruptListenersAttached) {
            // Detach possibly existing listeners first
            this.detachInterruptListeners();
        }
        this._interruptListener = function (event) {
            interruptReporter.report(event, _this);
        };
        __WEBPACK_IMPORTED_MODULE_1__ng2_page_scroll_config__["a" /* PageScrollConfig */]._interruptEvents.forEach(function (event) { return _this.document.body.addEventListener(event, _this._interruptListener); });
        this._interruptListenersAttached = true;
    };
    /**
     * Remove event listeners from the body and stop listening for events that might be treated as "animation
     * interrupt" events.
     */
    PageScrollInstance.prototype.detachInterruptListeners = function () {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_1__ng2_page_scroll_config__["a" /* PageScrollConfig */]._interruptEvents.forEach(function (event) { return _this.document.body.removeEventListener(event, _this._interruptListener); });
        this._interruptListenersAttached = false;
    };
    Object.defineProperty(PageScrollInstance.prototype, "namespace", {
        get: function () {
            return this._namespace;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PageScrollInstance.prototype, "scrollTarget", {
        get: function () {
            return this._scrollTarget;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PageScrollInstance.prototype, "verticalScrolling", {
        get: function () {
            return this._verticalScrolling;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PageScrollInstance.prototype, "scrollingViews", {
        get: function () {
            return this._scrollingViews;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PageScrollInstance.prototype, "startScrollPosition", {
        get: function () {
            return this._startScrollPosition;
        },
        set: function (value) {
            this._startScrollPosition = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PageScrollInstance.prototype, "targetScrollPosition", {
        get: function () {
            return this._targetScrollPosition;
        },
        set: function (value) {
            this._targetScrollPosition = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PageScrollInstance.prototype, "distanceToScroll", {
        get: function () {
            return this._distanceToScroll;
        },
        set: function (value) {
            this._distanceToScroll = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PageScrollInstance.prototype, "executionDuration", {
        get: function () {
            return this._executionDuration;
        },
        set: function (value) {
            this._executionDuration = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PageScrollInstance.prototype, "duration", {
        get: function () {
            return this._duration;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PageScrollInstance.prototype, "speed", {
        get: function () {
            return this._speed;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PageScrollInstance.prototype, "easingLogic", {
        get: function () {
            return this._easingLogic;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PageScrollInstance.prototype, "interruptible", {
        get: function () {
            return this._interruptible;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PageScrollInstance.prototype, "startTime", {
        get: function () {
            return this._startTime;
        },
        set: function (value) {
            this._startTime = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PageScrollInstance.prototype, "endTime", {
        get: function () {
            return this._endTime;
        },
        set: function (value) {
            this._endTime = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PageScrollInstance.prototype, "timer", {
        get: function () {
            return this._timer;
        },
        set: function (value) {
            this._timer = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PageScrollInstance.prototype, "interruptListenersAttached", {
        get: function () {
            return this._interruptListenersAttached;
        },
        enumerable: true,
        configurable: true
    });
    return PageScrollInstance;
}());



/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_router__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_platform_browser__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ng2_page_scroll_service__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ng2_page_scroll_instance__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ng2_page_scroll_util_service__ = __webpack_require__(210);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return PageScroll; });






var PageScroll = (function () {
    function PageScroll(pageScrollService, router, document) {
        this.pageScrollService = pageScrollService;
        this.router = router;
        this.pageScrollHorizontal = null;
        this.pageScrollOffset = null;
        this.pageScrollDuration = null;
        this.pageScrollSpeed = null;
        this.pageScrollEasing = null;
        this.pageScrollAdjustHash = false;
        this.pageScroll = null;
        this.pageScrollFinish = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.document = document;
    }
    PageScroll.prototype.ngOnChanges = function (changes) {
        // Some inputs changed, reset the pageScrollInstance
        this.pageScrollInstance = undefined;
    };
    PageScroll.prototype.ngOnDestroy = function () {
        if (this.pageScrollInstance) {
            this.pageScrollService.stop(this.pageScrollInstance);
        }
        return undefined;
    };
    PageScroll.prototype.generatePageScrollInstance = function () {
        if (__WEBPACK_IMPORTED_MODULE_5__ng2_page_scroll_util_service__["a" /* PageScrollUtilService */].isUndefinedOrNull(this.pageScrollInstance)) {
            this.pageScrollInstance = __WEBPACK_IMPORTED_MODULE_4__ng2_page_scroll_instance__["a" /* PageScrollInstance */].newInstance({
                document: this.document,
                scrollTarget: this.href,
                scrollingViews: null,
                namespace: this.pageScroll,
                verticalScrolling: !this.pageScrollHorizontal,
                pageScrollOffset: this.pageScrollOffset,
                pageScrollInterruptible: this.pageScrollInterruptible,
                pageScrollEasingLogic: this.pageScrollEasing,
                pageScrollDuration: this.pageScrollDuration,
                pageScrollSpeed: this.pageScrollSpeed,
                pageScrollFinishListener: this.pageScrollFinish
            });
        }
        return this.pageScrollInstance;
    };
    PageScroll.prototype.pushRouterState = function () {
        if (this.pageScrollAdjustHash && typeof this.pageScrollInstance.scrollTarget === 'string'
            && this.pageScrollInstance.scrollTarget.substr(0, 1) === '#') {
            // "Navigate" to the current route again and this time set the fragment/hash
            this.router.navigate([], {
                fragment: this.pageScrollInstance.scrollTarget.substr(1),
                preserveQueryParams: true
            });
        }
    };
    PageScroll.prototype.scroll = function () {
        var pageScrollInstance = this.generatePageScrollInstance();
        this.pushRouterState();
        this.pageScrollService.start(pageScrollInstance);
    };
    PageScroll.prototype.handleClick = function (clickEvent) {
        var _this = this;
        if (this.routerLink && this.router !== null && this.router !== undefined) {
            var urlTree = void 0;
            if (typeof this.routerLink === 'string') {
                urlTree = this.router.parseUrl(this.routerLink);
            }
            else {
                urlTree = this.router.createUrlTree(this.routerLink);
            }
            if (!this.router.isActive(urlTree, true)) {
                // We need to navigate their first.
                // Navigation is handled by the routerLink directive
                // so we only need to listen for route change
                var subscription_1 = this.router.events.subscribe(function (routerEvent) {
                    if (routerEvent instanceof __WEBPACK_IMPORTED_MODULE_1__angular_router__["NavigationEnd"]) {
                        subscription_1.unsubscribe();
                        _this.scroll();
                    }
                    else if (routerEvent instanceof __WEBPACK_IMPORTED_MODULE_1__angular_router__["NavigationError"] || routerEvent instanceof __WEBPACK_IMPORTED_MODULE_1__angular_router__["NavigationCancel"]) {
                        subscription_1.unsubscribe();
                    }
                });
                return false; // to preventDefault()
            }
        }
        this.scroll();
        return false; // to preventDefault()
    };
    return PageScroll;
}());

PageScroll.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: '[pageScroll]',
                host: {
                    '(click)': 'handleClick($event)',
                }
            },] },
];
/** @nocollapse */
PageScroll.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_3__ng2_page_scroll_service__["a" /* PageScrollService */], },
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_router__["Router"], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] },] },
    { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_2__angular_platform_browser__["DOCUMENT"],] },] },
]; };
PageScroll.propDecorators = {
    'routerLink': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'href': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'pageScrollHorizontal': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'pageScrollOffset': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'pageScrollDuration': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'pageScrollSpeed': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'pageScrollEasing': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'pageScrollInterruptible': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'pageScrollAdjustHash': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'pageScroll': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'pageScrollFinish': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
};


/***/ },
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(115);
var app_routes_1 = __webpack_require__(668);
var store_devtools_1 = __webpack_require__(641);
var hot_store_1 = __webpack_require__(329);
var app_reducers_1 = __webpack_require__(672);
var platform_browser_1 = __webpack_require__(49);
var forms_1 = __webpack_require__(260);
var http_1 = __webpack_require__(43);
var ng2_translate_1 = __webpack_require__(161);
var shared_module_1 = __webpack_require__(438);
var catalog_module_1 = __webpack_require__(646);
var logs_service_1 = __webpack_require__(285);
var app_cmp_1 = __webpack_require__(645);
var ng2_bs3_modal_1 = __webpack_require__(471);
var ng2_page_scroll_1 = __webpack_require__(309);
var debug, debugOff = function () {
    var any = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        any[_i] = arguments[_i];
    }
};
"production" !== 'production' && (debug = __webpack_require__(4)('app:AppModule'));
var AppModule = (function () {
    function AppModule() {
    }
    return AppModule;
}());
AppModule = __decorate([
    core_1.NgModule({
        declarations: [
            app_cmp_1.AppCmp
        ],
        imports: [
            platform_browser_1.BrowserModule,
            forms_1.FormsModule,
            forms_1.ReactiveFormsModule,
            http_1.HttpModule,
            ng2_bs3_modal_1.Ng2Bs3ModalModule,
            router_1.RouterModule.forRoot(app_routes_1.ROUTES, { useHash: false }),
            ng2_translate_1.TranslateModule.forRoot(),
            hot_store_1.provideHotStore(app_reducers_1.AppReducers),
            store_devtools_1.StoreDevtoolsModule.instrumentStore({ maxAge: 500 }),
            shared_module_1.SharedModule,
            catalog_module_1.CatalogModule,
            ng2_page_scroll_1.Ng2PageScrollModule.forRoot()
        ],
        providers: [
            logs_service_1.LogsService
        ],
        bootstrap: [app_cmp_1.AppCmp]
    }),
    __metadata("design:paramtypes", [])
], AppModule);
exports.AppModule = AppModule;


/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var platform_browser_1 = __webpack_require__(49);
var core_1 = __webpack_require__(0);
var PROVIDERS = [];
var DECORATEMODULEREF = function identity(value) {
    return value;
};
if (true) {
    platform_browser_1.disableDebugTools();
    core_1.enableProdMode();
    PROVIDERS = PROVIDERS.slice();
}
else {
    DECORATEMODULEREF = function (modRef) {
        var appRef = modRef.injector.get(core_1.ApplicationRef);
        var cmpRef = appRef.components[0];
        var NG = window.ng;
        platform_browser_1.enableDebugTools(cmpRef);
        window.ng.probe = NG.probe;
        window.ng.coreTokens = NG.coreTokens;
        return modRef;
    };
    PROVIDERS = PROVIDERS.slice();
}
exports.decorateModuleRef = DECORATEMODULEREF;
exports.ENV_PROVIDERS = PROVIDERS.slice();


/***/ },
/* 516 */,
/* 517 */,
/* 518 */
/***/ function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(833);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(16)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./main.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./main.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ },
/* 519 */,
/* 520 */
/***/ function(module, exports) {

module.exports = [
	{
		"code": "MS90EC1",
		"partnumber": "MS90E",
		"previewname": "MS90E",
		"name": "MS90E",
		"price": 2400,
		"descriptions": {
			"short": "Residential Generator",
			"long": "<BR>eSeries Generators are crafted from recyclable stainless steel and assembled with meticulous attention to detail. Designed, engineered and assembled in Long Island City, NY to the most exacting standards, our generators are clean, green, virtually silent, and ultra-efficient.<ul><LI>Free from defects in materials and craftsmanship for its lifetime. MrSteam will repair or replace (at its option) a Generator which fails to conform to this warranty</LI><LI>Installs in areas such as a cabinet, closet, under a sealed bench or in an insulated attic</LI><LI>Exclusive micro processor operating system is the brains of our intelligent steam generator</LI><LI>Easily install spa therapy accessories or components such as AromaTherapy, ChromaTherapy, Steamlinx, and more</LI><LI>LED indicators to help you troubleshoot any connection and maintenance challenges</LI><LI>Naturally corrosion resistant, 100 percent recyclable stainless steel inside and out</LI><LI>Designed to save water and energy. Uses less than two gallons of water vs 40 gallons for an ordinary bath</LI><li>60 minute automatic cutoff, low voltage board, designed for easy access safe service</li><li>US and Canadian UL listed, and CE and NOM certified for unsurpassed quality and safety</li><li>Reliable, industrial grade, and the industries largest copper heating element heats fast and is easy to remove and service</li></ul>",
			"tech": "Total Room Volume: UP TO 71 Cu Ft<BR>KW: 5<BR>Wire Size*: 10<BR>Dimensions** : 14 ½” L x 14 ¾” H x 6 ¾” D<BR>Water Usage Gallons***: 0.67<BR>Shipping Wt. (lbs)**** : 27<BR><BR><BR>*Wire size (AWG) based on minimum 90°C rated THHN copper conductors.<BR>Refer to the National Electrical Code for other types of conductors.<BR><BR>**Dimensions are for generator only, without AutoFlush or plumbing features.<BR><BR>***Water usage based on 20 minutes of operation.<BR><BR>****Shipping weight & pricing are for generator only, without control or steamhead.<BR>"
		},
		"images": {
			"thumbnail": "MS90E-400E.jpg",
			"folder": "generators/",
			"scene": "MS-90-400.png"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/0e9b7d91-2a0a-478d-9425-797faf20a8e4.pdf"
		},
		"taxonomy": {
			"categories": [
				"generators"
			],
			"sortOrder": {
				"generators": 1
			},
			"zIndex": {
				"generators": 1
			},
			"series": "90-400"
		},
		"tooltips": {
			"list": [
				{
					"top": 73,
					"left": 10,
					"width": 13,
					"height": 16
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false,
			"isSuperGenerator": false
		}
	},
	{
		"code": "MS150EC1",
		"partnumber": "MS150E",
		"previewname": "MS150E",
		"name": "MS150E",
		"price": 3000,
		"descriptions": {
			"short": "Residential Generator",
			"long": "<BR>eSeries Generators are crafted from recyclable stainless steel and assembled with meticulous attention to detail. Designed, engineered and assembled in Long Island City, NY to the most exacting standards, our generators are clean, green, virtually silent, and ultra-efficient.<ul><LI>Free from defects in materials and craftsmanship for its lifetime. MrSteam will repair or replace (at its option) a Generator which fails to conform to this warranty</LI><LI>Installs in areas such as a cabinet, closet, under a sealed bench or in an insulated attic</LI><LI>Exclusive micro processor operating system is the brains of our intelligent steam generator</LI><LI>Easily install spa therapy accessories or components such as AromaTherapy, ChromaTherapy, Steamlinx, and more</LI><LI>LED indicators to help you troubleshoot any connection and maintenance challenges</LI><LI>Naturally corrosion resistant, 100 percent recyclable stainless steel inside and out</LI><LI>Designed to save water and energy. Uses less than two gallons of water vs 40 gallons for an ordinary bath</LI><li>60 minute automatic cutoff, low voltage board, designed for easy access safe service</li><li>US and Canadian UL listed, and CE and NOM certified for unsurpassed quality and safety</li><li>Reliable, industrial grade, and the industries largest copper heating element heats fast and is easy to remove and service</li></ul>",
			"tech": "Total Room Volume: 72 - 107<BR>KW: 6<BR>Wire Size*: 8<BR>Dimensions** : 14 ½” L x 14 ¾” H x 6 ¾” D<BR>Water Usage Gallons***: 0.80<BR>Shipping Wt. (lbs)**** : 27<BR><BR><BR>*Wire size (AWG) based on minimum 90°C rated THHN copper conductors.<BR>Refer to the National Electrical Code for other types of conductors.<BR><BR>**Dimensions are for generator only, without AutoFlush or plumbing features.<BR><BR>***Water usage based on 20 minutes of operation.<BR><BR>****Shipping weight & pricing are for generator only, without control or steamhead.<BR>"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/0e9b7d91-2a0a-478d-9425-797faf20a8e4.pdf"
		},
		"images": {
			"thumbnail": "MS90E-400E.jpg",
			"folder": "generators/",
			"scene": "MS-90-400.png"
		},
		"taxonomy": {
			"categories": [
				"generators"
			],
			"sortOrder": {
				"generators": 2
			},
			"zIndex": {
				"generators": 2
			},
			"series": "90-400"
		},
		"tooltips": {
			"list": [
				{
					"top": 73,
					"left": 10,
					"width": 13,
					"height": 16
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false,
			"isSuperGenerator": false
		}
	},
	{
		"code": "MS225EC1",
		"partnumber": "MS225E",
		"previewname": "MS225E",
		"name": "MS225E",
		"price": 3450,
		"descriptions": {
			"short": "Residential Generator",
			"long": "<BR>eSeries Generators are crafted from recyclable stainless steel and assembled with meticulous attention to detail. Designed, engineered and assembled in Long Island City, NY to the most exacting standards, our generators are clean, green, virtually silent, and ultra-efficient.<ul><LI>Free from defects in materials and craftsmanship for its lifetime. MrSteam will repair or replace (at its option) a Generator which fails to conform to this warranty</LI><LI>Installs in areas such as a cabinet, closet, under a sealed bench or in an insulated attic</LI><LI>Exclusive micro processor operating system is the brains of our intelligent steam generator</LI><LI>Easily install spa therapy accessories or components such as AromaTherapy, ChromaTherapy, Steamlinx, and more</LI><LI>LED indicators to help you troubleshoot any connection and maintenance challenges</LI><LI>Naturally corrosion resistant, 100 percent recyclable stainless steel inside and out</LI><LI>Designed to save water and energy. Uses less than two gallons of water vs 40 gallons for an ordinary bath</LI><li>60 minute automatic cutoff, low voltage board, designed for easy access safe service</li><li>US and Canadian UL listed, and CE and NOM certified for unsurpassed quality and safety</li><li>Reliable, industrial grade, and the industries largest copper heating element heats fast and is easy to remove and service</li></ul>",
			"tech": "Total Room Volume: 108 - 161<BR>KW: 7.5<BR>Wire Size*: 8<BR>Dimensions** : 14 ½” L x 14 ¾” H x 6 ¾” D<BR>Water Usage Gallons***: 1.0<BR>Shipping Wt. (lbs)**** : 27<BR><BR><BR>*Wire size (AWG) based on minimum 90°C rated THHN copper conductors.<BR>Refer to the National Electrical Code for other types of conductors.<BR><BR>**Dimensions are for generator only, without AutoFlush or plumbing features.<BR><BR>***Water usage based on 20 minutes of operation.<BR><BR>****Shipping weight & pricing are for generator only, without control or steamhead.<BR>"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/0e9b7d91-2a0a-478d-9425-797faf20a8e4.pdf"
		},
		"images": {
			"thumbnail": "MS90E-400E.jpg",
			"folder": "generators/",
			"scene": "MS-90-400.png"
		},
		"taxonomy": {
			"categories": [
				"generators"
			],
			"sortOrder": {
				"generators": 3
			},
			"zIndex": {
				"generators": 3
			},
			"series": "90-400"
		},
		"tooltips": {
			"list": [
				{
					"top": 73,
					"left": 10,
					"width": 13,
					"height": 16
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false,
			"isSuperGenerator": false
		}
	},
	{
		"code": "MS400EC1",
		"partnumber": "MS400E",
		"previewname": "MS400E",
		"name": "MS400E",
		"price": 3675,
		"descriptions": {
			"short": "Residential Generator",
			"long": "<BR>eSeries Generators are crafted from recyclable stainless steel and assembled with meticulous attention to detail. Designed, engineered and assembled in Long Island City, NY to the most exacting standards, our generators are clean, green, virtually silent, and ultra-efficient.<ul><LI>Free from defects in materials and craftsmanship for its lifetime. MrSteam will repair or replace (at its option) a Generator which fails to conform to this warranty</LI><LI>Installs in areas such as a cabinet, closet, under a sealed bench or in an insulated attic</LI><LI>Exclusive micro processor operating system is the brains of our intelligent steam generator</LI><LI>Easily install spa therapy accessories or components such as AromaTherapy, ChromaTherapy, Steamlinx, and more</LI><LI>LED indicators to help you troubleshoot any connection and maintenance challenges</LI><LI>Naturally corrosion resistant, 100 percent recyclable stainless steel inside and out</LI><LI>Designed to save water and energy. Uses less than two gallons of water vs 40 gallons for an ordinary bath</LI><li>60 minute automatic cutoff, low voltage board, designed for easy access safe service</li><li>US and Canadian UL listed, and CE and NOM certified for unsurpassed quality and safety</li><li>Reliable, industrial grade, and the industries largest copper heating element heats fast and is easy to remove and service</li></ul>",
			"tech": "Total Room Volume: 162 - 257<BR>KW: 9<BR>Wire Size*: 8<BR>Dimensions** : 14 ½” L x 14 ¾” H x 6 ¾” D<BR>Water Usage Gallons***: 1.2<BR>Shipping Wt. (lbs)**** : 27<BR><BR><BR>*Wire size (AWG) based on minimum 90°C rated THHN copper conductors.<BR>Refer to the National Electrical Code for other types of conductors.<BR><BR>**Dimensions are for generator only, without AutoFlush or plumbing features.<BR><BR>***Water usage based on 20 minutes of operation.<BR><BR>****Shipping weight & pricing are for generator only, without control or steamhead.<BR>"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/0e9b7d91-2a0a-478d-9425-797faf20a8e4.pdf"
		},
		"images": {
			"thumbnail": "MS90E-400E.jpg",
			"folder": "generators/",
			"scene": "MS-90-400.png"
		},
		"taxonomy": {
			"categories": [
				"generators"
			],
			"sortOrder": {
				"generators": 4
			},
			"zIndex": {
				"generators": 4
			},
			"series": "90-400"
		},
		"tooltips": {
			"list": [
				{
					"top": 73,
					"left": 10,
					"width": 13,
					"height": 16
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false,
			"isSuperGenerator": false
		}
	},
	{
		"code": "MSSUPER1EC1",
		"partnumber": "MSSUPER1E",
		"previewname": "MSSUPER1E",
		"name": "MSSUPER1E",
		"price": 4200,
		"descriptions": {
			"short": "Residential Generator",
			"long": "<BR>eSeries Generators are crafted from stainless steel and assembled with meticulous attention to detail. Every component is designed, designed and engineered in-house to the most exacting standards.<ul><LI>Free from defects in materials and craftsmanship for its lifetime. MrSteam will repair or replace (at its option) a Generator which fails to conform to this warranty</LI><LI>Installs in areas such as a cabinet, closet, under a sealed bench or in an insulated attic</LI><LI>Exclusive micro processor operating system is the brains of our intelligent steam generator</LI><LI>Easily install spa therapy accessories or components such as AromaTherapy, ChromaTherapy, Steamlinx, and more</LI>\\r\\n<LI>LED indicators to help you troubleshoot any connection and maintenance challenges</LI><LI>Naturally corrosion resistant, 100 percent recyclable stainless steel inside and out</LI><LI>Designed to save water and energy. Uses less than two gallons of water vs 40 gallons for an ordinary bath</LI><li>60 minute automatic cutoff, low voltage board, designed for easy access safe service</li><li>US and Canadian UL listed, and CE and NOM certified for unsurpassed quality and safety</li><li>Reliable, industrial grade, and the industries largest copper heating element heats fast and is easy to remove and service</li></ul>",
			"tech": "Total Room Volume: 258 - 339<BR>KW: 10<BR>Wire Size*: 8<BR>Dimensions** : 17” L x 18 ½” H x 7 ⅞ ” D<BR>Water Usage Gallons***: 1.4<BR>Shipping Wt. (lbs)**** : 39<BR><BR><BR>*Wire size (AWG) based on minimum 90°C rated THHN copper conductors.<BR>Refer to the National Electrical Code for other types of conductors.<BR><BR>**Dimensions are for generator only, without AutoFlush or plumbing features.<BR><BR>***Water usage based on 20 minutes of operation.<BR><BR>****Shipping weight & pricing are for generator only, without control or steamhead.<BR>"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/cd5e7178-85a0-4af8-a1d5-52566d10b500.pdf"
		},
		"images": {
			"thumbnail": "MSSuper1E-3E.jpg",
			"folder": "generators/",
			"scene": "MS-Super-1-3.png"
		},
		"taxonomy": {
			"categories": [
				"generators"
			],
			"sortOrder": {
				"generators": 5
			},
			"zIndex": {
				"generators": 5
			},
			"series": "1-3"
		},
		"tooltips": {
			"list": [
				{
					"top": 73,
					"left": 10,
					"width": 13,
					"height": 16
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false,
			"isSuperGenerator": true
		}
	},
	{
		"code": "MSSUPER2EC1",
		"partnumber": "MSSUPER2E",
		"previewname": "MSSUPER2E",
		"name": "MSSUPER2E",
		"price": 4600,
		"descriptions": {
			"short": "Residential Generator",
			"long": "<BR>eSeries Generators are crafted from stainless steel and assembled with meticulous attention to detail. Every component is designed, designed and engineered in-house to the most exacting standards.<ul><LI>Free from defects in materials and craftsmanship for its lifetime. MrSteam will repair or replace (at its option) a Generator which fails to conform to this warranty</LI><LI>Installs in areas such as a cabinet, closet, under a sealed bench or in an insulated attic</LI><LI>Exclusive micro processor operating system is the brains of our intelligent steam generator</LI><LI>Easily install spa therapy accessories or components such as AromaTherapy, ChromaTherapy, Steamlinx, and more</LI><LI>LED indicators to help you troubleshoot any connection and maintenance challenges</LI><LI>Naturally corrosion resistant, 100 percent recyclable stainless steel inside and out</LI><LI>Designed to save water and energy. Uses less than two gallons of water vs 40 gallons for an ordinary bath</LI><li>60 minute automatic cutoff, low voltage board, designed for easy access safe service</li><li>US and Canadian UL listed, and CE and NOM certified for unsurpassed quality and safety</li><li>Reliable, industrial grade, and the industries largest copper heating element heats fast and is easy to remove and service</li></ul>",
			"tech": "Total Room Volume: 340 - 411 <BR>KW: 12<BR>Wire Size*: 6<BR>Dimensions** :17” L x 18 ½” H x 7 ⅞ ” D<BR>Water Usage Gallons***: 1.6<BR>Shipping Wt. (lbs)**** : 39<BR><BR><BR>*Wire size (AWG) based on minimum 90°C rated THHN copper conductors.<BR>Refer to the National Electrical Code for other types of conductors.<BR><BR>**Dimensions are for generator only, without AutoFlush or plumbing features.<BR><BR>***Water usage based on 20 minutes of operation.<BR><BR>****Shipping weight & pricing are for generator only, without control or steamhead.<BR>"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/cd5e7178-85a0-4af8-a1d5-52566d10b500.pdf"
		},
		"images": {
			"thumbnail": "MSSuper1E-3E.jpg",
			"folder": "generators/",
			"scene": "MS-Super-1-3.png"
		},
		"taxonomy": {
			"categories": [
				"generators"
			],
			"sortOrder": {
				"generators": 6
			},
			"zIndex": {
				"generators": 6
			},
			"series": "1-3"
		},
		"tooltips": {
			"list": [
				{
					"top": 73,
					"left": 10,
					"width": 13,
					"height": 16
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false,
			"isSuperGenerator": true
		}
	},
	{
		"code": "MSSUPER3EC1",
		"partnumber": "MSSUPER3E",
		"previewname": "MSSUPER3E",
		"name": "MSSUPER3E",
		"price": 5150,
		"descriptions": {
			"short": "Residential Generator",
			"long": "<BR>eSeries Generators are crafted from stainless steel and assembled with meticulous attention to detail. Every component is designed, designed and engineered in-house to the most exacting standards.<ul><LI>Free from defects in materials and craftsmanship for its lifetime. MrSteam will repair or replace (at its option) a Generator which fails to conform to this warranty</LI><LI>Installs in areas such as a cabinet, closet, under a sealed bench or in an insulated attic</LI><LI>Exclusive micro processor operating system is the brains of our intelligent steam generator</LI><LI>Easily install spa therapy accessories or components such as AromaTherapy, ChromaTherapy, Steamlinx, and more</LI>\\r\\n<LI>LED indicators to help you troubleshoot any connection and maintenance challenges</LI><LI>Naturally corrosion resistant, 100 percent recyclable stainless steel inside and out</LI><LI>Designed to save water and energy. Uses less than two gallons of water vs 40 gallons for an ordinary bath</LI><li>60 minute automatic cutoff, low voltage board, designed for easy access safe service</li><li>US and Canadian UL listed, and CE and NOM certified for unsurpassed quality and safety</li><li>Reliable, industrial grade, and the industries largest copper heating element heats fast and is easy to remove and service</li></ul>",
			"tech": "Total Room Volume: 412 - 482<BR>KW: 15<BR>Wire Size*: 4<BR>Dimensions** : 17” L x 18 ½” H x 7 ⅞ ” D<BR>Water Usage Gallons***: 2.0<BR>Shipping Wt. (lbs)**** : 39<BR><BR><BR>*Wire size (AWG) based on minimum 90°C rated THHN copper conductors.<BR>Refer to the National Electrical Code for other types of conductors.<BR><BR>**Dimensions are for generator only, without AutoFlush or plumbing features.<BR><BR>***Water usage based on 20 minutes of operation.<BR><BR>****Shipping weight & pricing are for generator only, without control or steamhead.<BR>"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/cd5e7178-85a0-4af8-a1d5-52566d10b500.pdf"
		},
		"images": {
			"thumbnail": "MSSuper1E-3E.jpg",
			"folder": "generators/",
			"scene": "MS-Super-1-3.png"
		},
		"taxonomy": {
			"categories": [
				"generators"
			],
			"sortOrder": {
				"generators": 7
			},
			"zIndex": {
				"generators": 7
			},
			"series": "1-3"
		},
		"tooltips": {
			"list": [
				{
					"top": 73,
					"left": 10,
					"width": 13,
					"height": 16
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false,
			"isSuperGenerator": true
		}
	},
	{
		"code": "MX4EC1",
		"partnumber": "MX4E",
		"previewname": "MX4E",
		"name": "MX4E",
		"price": 6700,
		"descriptions": {
			"short": "Residential Generator",
			"long": "<BR>MAX Generators are built for large residential enclosures. These units are crafted from stainless steel and assembled with meticulous attention to detail. Every component is designed and engineered in-house to the most exacting standards.<ul><LI>Exclusive microprocessor operating system is the brains of our intelligent steam generator </LI><LI>All MrSteam residential steambath MAX Generators installed in the United States or Canada qualify for a limited lifetime warranty, for full warranty details visit: https://blog.mrsteam.com/wr</LI><LI>Industrial grade, large diameter copper heating element heats fast and is easy to remove and service</LI><LI>Modular Plug and Play connections for easy installation of spa therapy accessories or components such as AromaTherapy, ChromaTherapy, MusicTherapy, Steamlinx, and more </LI><LI>Naturally corrosion resistant, 100 percent recyclable stainless-steel tank</LI><LI>LED indicators to help you troubleshoot any connection and maintenance challenges</LI><LI>US and Canadian UL listed, and CE and NOM certified for unsurpassed quality and safety</LI><LI>60-minute electronic countdown shutdown with 75-minute limiting safety back-up</LI><LI>Electronic water-level control system and full-port drain valve</LI><LI>Built-in, low-voltage 24-volt control and ASME safety valve</LI></ul>",
			"tech": " Total Room Volume: 483 - 678<BR>KW: 20<BR>Wire Size*: 2<BR>Dimensions** : 27 ⅝” L x 20 ¾” H x 7 ⅞ ” D<BR>Water Usage Gallons***: 2.7<BR>Shipping Wt. (lbs)**** : 67<BR><BR><BR>*Wire size (AWG) based on minimum 90°C rated THHN copper conductors.<BR>Refer to the National Electrical Code for other types of conductors.<BR><BR>**Dimensions are for generator only, without AutoFlush or plumbing features.<BR><BR>***Water usage based on 20 minutes of operation.<BR><BR>****Shipping weight & pricing are for generator only, without control or steamhead.<BR><BR>"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/68f8ac0d-243e-4be3-ac85-561a12bb2993.pdf"
		},
		"images": {
			"thumbnail": "MX4E-6E.jpg",
			"folder": "generators/",
			"scene": "MS-Super-4-6.png"
		},
		"taxonomy": {
			"categories": [
				"generators"
			],
			"sortOrder": {
				"generators": 8
			},
			"zIndex": {
				"generators": 8
			},
			"series": "4-6"
		},
		"tooltips": {
			"list": [
				{
					"top": 73,
					"left": 10,
					"width": 13,
					"height": 16
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false,
			"isSuperGenerator": true
		}
	},
	{
		"code": "MX5EC1",
		"partnumber": "MX5E",
		"previewname": "MX5E",
		"name": "MX5E",
		"price": 7000,
		"descriptions": {
			"short": "Residential Generator",
			"long": "<BR>MAX Generators are built for large residential enclosures. These units are crafted from stainless steel and assembled with meticulous attention to detail. Every component is designed and engineered in-house to the most exacting standards.<ul><LI>Exclusive microprocessor operating system is the brains of our intelligent steam generator </LI><LI>All MrSteam residential steambath MAX Generators installed in the United States or Canada qualify for a limited lifetime warranty, for full warranty details visit: https://blog.mrsteam.com/wr</LI><LI>Industrial grade, large diameter copper heating element heats fast and is easy to remove and service</LI><LI>Modular Plug and Play connections for easy installation of spa therapy accessories or components such as AromaTherapy, ChromaTherapy, MusicTherapy, Steamlinx, and more </LI><LI>Naturally corrosion resistant, 100 percent recyclable stainless-steel tank</LI><LI>LED indicators to help you troubleshoot any connection and maintenance challenges</LI><LI>US and Canadian UL listed, and CE and NOM certified for unsurpassed quality and safety</LI><LI>60-minute electronic countdown shutdown with 75-minute limiting safety back-up</LI><LI>Electronic water-level control system and full-port drain valve</LI><LI>Built-in, low-voltage 24-volt control and ASME safety valve</LI></ul>",
			"tech": "Total Room Volume: 679 - 822<BR>KW: 24<BR>Wire Size*: 1<BR>Dimensions** : 27 ⅝” L x 20 ¾” H x 7 ⅞ ” D<BR>Water Usage Gallons***: 3.2<BR>Shipping Wt. (lbs)**** : 67<BR><BR><BR>*Wire size (AWG) based on minimum 90°C rated THHN copper conductors.<BR>Refer to the National Electrical Code for other types of conductors.<BR><BR>**Dimensions are for generator only, without AutoFlush or plumbing features.<BR><BR>***Water usage based on 20 minutes of operation.<BR><BR>****Shipping weight & pricing are for generator only, without control or steamhead.<BR><BR>"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/68f8ac0d-243e-4be3-ac85-561a12bb2993.pdf"
		},
		"images": {
			"thumbnail": "MX4E-6E.jpg",
			"folder": "generators/",
			"scene": "MS-Super-4-6.png"
		},
		"taxonomy": {
			"categories": [
				"generators"
			],
			"sortOrder": {
				"generators": 9
			},
			"zIndex": {
				"generators": 9
			},
			"series": "4-6"
		},
		"tooltips": {
			"list": [
				{
					"top": 73,
					"left": 10,
					"width": 13,
					"height": 16
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false,
			"isSuperGenerator": true
		}
	},
	{
		"code": "MX6EC1",
		"partnumber": "MX6E",
		"previewname": "MX6E",
		"name": "MX6E",
		"price": 7400,
		"descriptions": {
			"short": "Residential Generator",
			"long": "<BR>MAX Generators are built for large residential enclosures. These units are crafted from stainless steel and assembled with meticulous attention to detail. Every component is designed and engineered in-house to the most exacting standards.<ul><LI>Exclusive microprocessor operating system is the brains of our intelligent steam generator </LI><LI>All MrSteam residential steambath MAX Generators installed in the United States or Canada qualify for a limited lifetime warranty, for full warranty details visit: https://blog.mrsteam.com/wr</LI><LI>Industrial grade, large diameter copper heating element heats fast and is easy to remove and service</LI><LI>Modular Plug and Play connections for easy installation of spa therapy accessories or components such as AromaTherapy, ChromaTherapy, MusicTherapy, Steamlinx, and more </LI><LI>Naturally corrosion resistant, 100 percent recyclable stainless-steel tank</LI><LI>LED indicators to help you troubleshoot any connection and maintenance challenges</LI><LI>US and Canadian UL listed, and CE and NOM certified for unsurpassed quality and safety</LI><LI>60-minute electronic countdown shutdown with 75-minute limiting safety back-up</LI><LI>Electronic water-level control system and full-port drain valve</LI><LI>Built-in, low-voltage 24-volt control and ASME safety valve</LI></ul>",
			"tech": "Total Room Volume: 823 - 964<BR>KW: 30<BR>Wire Size*: 2/0<BR>Dimensions** : 27 ⅝” L x 20 ¾” H x 7 ⅞ ” D<BR>Water Usage Gallons***: 4<BR>Shipping Wt. (lbs)**** : 67<BR><BR><BR>*Wire size (AWG) based on minimum 90°C rated THHN copper conductors.<BR>Refer to the National Electrical Code for other types of conductors.<BR><BR>**Dimensions are for generator only, without AutoFlush or plumbing features.<BR><BR>***Water usage based on 20 minutes of operation.<BR><BR>****Shipping weight & pricing are for generator only, without control or steamhead.<BR><BR>"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/68f8ac0d-243e-4be3-ac85-561a12bb2993.pdf"
		},
		"images": {
			"thumbnail": "MX4E-6E.jpg",
			"folder": "generators/",
			"scene": "MS-Super-4-6.png"
		},
		"taxonomy": {
			"categories": [
				"generators"
			],
			"sortOrder": {
				"generators": 10
			},
			"zIndex": {
				"generators": 10
			},
			"series": "4-6"
		},
		"tooltips": {
			"list": [
				{
					"top": 73,
					"left": 10,
					"width": 13,
					"height": 16
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false,
			"isSuperGenerator": true
		}
	},
	{
		"code": "ISTEAMX_CONTROL",
		"partnumber": "ISTEAMX_Control",
		"previewname": "ISTEAMX",
		"name": "iSteamX Touch Screen Control",
		"descriptions": {
			"short": "The iSteamX",
			"long": "With the iSteamX you have total control of every detail of your steaming experience. Housed in a sleek, slimline package, it mounts nearly flush on the wall of your shower. This awardwinning control is the most technologically advanced steam shower control available.",
			"tech": "<li>Change temperature & time settings with the touch of a finger</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Control of your listening experience with AUX, Bluetooth, USB or Radio</li><li>Create profiles for custom settings for temperature, time and more</li><li>Available in six different languages: English, French, Spanish, Italian, German, and Russian<li>Have peace of mind with temperature timed shut-offs and passcode protection</li><li>Automatically pre-heat your SteamShower so it's ready when you are</li><li>Water proof touch screen so technologically advanced it can tell the difference between a drop of water and your finger</li>"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/39ee6bd6-3ba2-45d1-a0bd-b4a97c25c527.pdf"
		},
		"images": {
			"thumbnail": "ISTEAMXBKPC.jpg",
			"folder": "individual-controls/iSteamX/",
			"scene": "mst2023-01_vspa_update_isteamx_PC_black.png"
		},
		"options": {
			"enabledListsIds": [
				"color"
			],
			"selected": {
				"color": "BLACK"
			},
			"list": {
				"color": [
					"BLACK",
					"WHITE"
				]
			}
		},
		"dynamicProperties": {
			"images.scene": {
				"keyTemplate": [
					"options.selected.color"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK"
							]
						],
						"value": "mst2023-01_vspa_update_isteamx_PC_black.png"
					},
					{
						"tally": [
							[
								"WHITE"
							]
						],
						"value": "mst2023-01_vspa_update_isteamx_PC_white.png"
					}
				]
			}
		},
		"tooltips": {
			"list": [
				{
					"top": 50,
					"left": 69.5,
					"width": 4.5,
					"height": 6
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false
		}
	},
	{
		"code": "XBUTLER_PACKAGE",
		"partnumber": "XBUTLER",
		"previewname": "xButler Package®",
		"name": "xButler Package®",
		"price": 3350,
		"descriptions": {
			"short": "The xButler package provides enhanced convenience and savings",
			"long": "With the iSteamX you have total control of every detail of your steaming experience. Housed in a sleek, slimline package, it mounts nearly flush on the wall of your shower. This award-winning control is the most technologically advanced steam shower control available.",
			"tech": "<li>Change temperature & time settings with the touch of a finger</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Control of your listening experience with AUX, Bluetooth, USB or Radio</li><li>Create profiles for custom settings for temperature, time and more</li><li>Available in six different languages: English, French, Spanish, Italian, German, and Russian</li><li>Have peace of mind with temperature timed shut-offs and passcode protection</li><li>Automatically pre-heat your SteamShower so it's ready when you are</li><li>Water proof touch screen so technologically advanced it can tell the difference between a drop of water and your finger</li>",
			"parts": "test"
		},
		"links": {
			"tech": "https://pim.mrsteam.com/Resources/Entities/MRSTEAM/Documents/a3a9e7f5-a3ef-4f91-9eb6-e55f35aa8232.pdf"
		},
		"taxonomy": {
			"categories": [
				"isteamx-touch-screen-controls"
			]
		},
		"images": {
			"folder": "control-packages/xButler/",
			"thumbnail": "XBTLRBKPC.jpg",
			"scene": "ibutler_package_black.png"
		},
		"options": {
			"enabledListsIds": [
				"color",
				"finish",
				"steamHead"
			],
			"selected": {
				"shape": "SQUARE",
				"color": "BLACK",
				"finish": "POLISHED_CHROME",
				"steamHead": "ISTEAM_STEAMHEAD"
			},
			"list": {
				"color": [
					"BLACK",
					"WHITE"
				],
				"finish": [
					"POLISHED_CHROME",
					"BRUSHED_BRONZE",
					"BRUSHED_NICKEL",
					"OIL_RUBBED_BRONZE",
					"POLISHED_BRASS",
					"POLISHED_NICKEL",
					"SATIN_BRASS",
					"MATTE_BLACK"
				],
				"steamHead": [
					"ISTEAM_STEAMHEAD",
					"LINEAR_STEAMHEAD"
				]
			}
		},
		"dynamicProperties": {
			"price": {
				"keyTemplate": [
					"options.selected.steamHead",
					"_globals.selectedGenerator",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							]
						],
						"value": 3780
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							]
						],
						"value": 3980
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							]
						],
						"value": 3380
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								null,
								"MATTE_BLACK"
							]
						],
						"value": 3480
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": 3780
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": 4580
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": 3380
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": 3530
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": 3980
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": 4780
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": 3480
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": 3780
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": 3980
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": 4780
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": 3480
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": 3780
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": 3980
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": 4780
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": 3480
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": 3780
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": 3980
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": 4780
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": 3480
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": 3780
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": 3980
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": 4780
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": 3480
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": 3780
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": 3980
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": 4780
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": 3450
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": 3780
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": 3980
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": 4780
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": 3480
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": 3780
					}
				]
			},
			"images.thumbnail": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.steamHead",
					"_globals.selectedGenerator",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XBTLRBKPC.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XBTLRBKBB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XBTLRBKBN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XBTLRBKOB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XBTLRBKPB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XBTLRBKPN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XBTLRBKSB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XBTLRBKMB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XBTLRWHPC.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XBTLRWHBB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XBTLRWHBN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XBTLRWHOB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XBTLRWHPB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XBTLRWHPN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XBTLRWHSB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XBTLRWHMB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XBTLRBKLPC.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XBTLRBKLBB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XBTLRBKLBN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XBTLRBKLOB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XBTLRBKLPB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XBTLRBKLPN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XBTLRBKLSB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XBTLRBKLMB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XBTLRWHLPC.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XBTLRWHLBB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XBTLRWHLBN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XBTLRWHLOB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XBTLRWHLPB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XBTLRWHLPN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XBTLRWHLSB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XBTLRWHLMB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XBTLRBKXPC.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XBTLRBKXBB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XBTLRBKXBN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XBTLRBKXOB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XBTLRBKXPB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XBTLRBKXPN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XBTLRBKXSB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XBTLRBKXMB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XBTLRWHXPC.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XBTLRWHXBB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XBTLRWHXBN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XBTLRWHXOB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XBTLRWHXPB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XBTLRWHXPN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XBTLRWHXSB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XBTLRWHXMB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XBTLRBKXLPC.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XBTLRBKXLBB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XBTLRBKXLBN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XBTLRBKXLOB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XBTLRBKXLPB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XBTLRBKXLPN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XBTLRBKXLSB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XBTLRBKXLMB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XBTLRWHXLPC.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XBTLRWHXLBB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XBTLRWHXLBN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XBTLRWHXLOB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XBTLRWHXLPB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XBTLRWHXLPN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XBTLRWHXLSB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XBTLRWHXLMB.jpg"
					}
				]
			},
			"descriptions.long": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.steamHead",
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<p align=”justify”>With the iSteamX you have total control of every detail of your steaming experience. Housed in a sleek, slimline package, it mounts nearly flush on the wall of your shower. This awardwinning control is the most technologically advanced steam shower control available.</p>"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<p align=”justify”>With the iSteamX you have total control of every detail of your steaming experience. Housed in a sleek, slimline package, it mounts nearly flush on the wall of your shower. This awardwinning control is the most technologically advanced steam shower control available.</p>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<p align=”justify”>With the iSteamX you have total control of every detail of your steaming experience. Housed in a sleek, slimline package, it mounts nearly flush on the wall of your shower. This awardwinning control is the most technologically advanced steam shower control available.</p>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<p align=”justify”>With the iSteamX you have total control of every detail of your steaming experience. Housed in a sleek, slimline package, it mounts nearly flush on the wall of your shower. This awardwinning control is the most technologically advanced steam shower control available.</p>"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "The iButler MAX Linear Package, features the award-winning iSteamX Control and the award-winning Linear SteamHead. It includes the SteamLinx Module and Mobile App that enables Amazon Alexa Skills, 2 Linear SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "The iButler MAX Linear Package, features the award-winning iSteamX Control and the award-winning Linear SteamHead. It includes the SteamLinx Module and Mobile App that enables Amazon Alexa Skills, 2 Linear SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "The iButler MAX Linear Package, features the award-winning iSteamX Control and the award-winning Linear SteamHead. It includes the SteamLinx Module and Mobile App that enables Amazon Alexa Skills, 2 Linear SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "The iButler MAX Linear Package, features the award-winning iSteamX Control and the award-winning Linear SteamHead. It includes the SteamLinx Module and Mobile App that enables Amazon Alexa Skills, 2 Linear SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					}
				]
			},
			"descriptions.tech": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.steamHead",
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<p align=”justify”><li>Change temperature & time settings with the touch of a finger</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Control of your listening experience with AUX, Bluetooth, USB or Radio</li><li>Create profiles for custom settings for temperature, time and more</li><li>Available in six different languages: English, French, Spanish, Italian, German, and Russian</li><li>Have peace of mind with temperature timed shut-offs and passcode protection</li><li>Automatically pre-heat your SteamShower so it's ready when you are</li><li>Water proof touch screen so technologically advanced it can tell the difference between a drop of water and your finger</li></p>"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<p align=”justify”><li>Change temperature & time settings with the touch of a finger</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Control of your listening experience with AUX, Bluetooth, USB or Radio</li><li>Create profiles for custom settings for temperature, time and more</li><li>Available in six different languages: English, French, Spanish, Italian, German, and Russian</li><li>Have peace of mind with temperature timed shut-offs and passcode protection</li><li>Automatically pre-heat your SteamShower so it's ready when you are</li><li>Water proof touch screen so technologically advanced it can tell the difference between a drop of water and your finger</li></p>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<p align=”justify”><li>Change temperature & time settings with the touch of a finger</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Control of your listening experience with AUX, Bluetooth, USB or Radio</li><li>Create profiles for custom settings for temperature, time and more</li><li>Available in six different languages: English, French, Spanish, Italian, German, and Russian</li><li>Have peace of mind with temperature timed shut-offs and passcode protection</li><li>Automatically pre-heat your SteamShower so it's ready when you are</li><li>Water proof touch screen so technologically advanced it can tell the difference between a drop of water and your finger</li></p>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<p align=”justify”><li>Change temperature & time settings with the touch of a finger</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Control of your listening experience with AUX, Bluetooth, USB or Radio</li><li>Create profiles for custom settings for temperature, time and more</li><li>Available in six different languages: English, French, Spanish, Italian, German, and Russian</li><li>Have peace of mind with temperature timed shut-offs and passcode protection</li><li>Automatically pre-heat your SteamShower so it's ready when you are</li><li>Water proof touch screen so technologically advanced it can tell the difference between a drop of water and your finger</li></p>"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<p align=”justify”><li> For MX4E - MX6E Generators </li><li> Includes the award-winning iSteamX Control with capcitive touch screen, programmable custom settings for up to with 8 users, 7 available languages, white or black interface color, real time clock, Autostart Programing to get your steam shower ready each day of the week</li><li>2 Aroma Glass SteamHeads that match MrSteam glass facia controls and features an oil reservoir discretely hidden at the top of the steam head</li><li> Control of your listening experience with AUX, Bluetooth, USB or Radio through your iSteamX Control</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through your iSteamX Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E</li></p>"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<p align=”justify”><li> For MX4E - MX6E Generators </li><li> Includes the award-winning iSteamX Control with capcitive touch screen, programmable custom settings for up to with 8 users, 7 available languages, white or black interface color, real time clock, Autostart Programing to get your steam shower ready each day of the week</li><li>2 Aroma Glass SteamHeads that match MrSteam glass facia controls and features an oil reservoir discretely hidden at the top of the steam head</li><li> Control of your listening experience with AUX, Bluetooth, USB or Radio through your iSteamX Control</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through your iSteamX Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E</li></p>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<p align=”justify”><li> For MX4E - MX6E Generators </li><li> Includes the award-winning iSteamX Control with capcitive touch screen, programmable custom settings for up to with 8 users, 7 available languages, white or black interface color, real time clock, Autostart Programing to get your steam shower ready each day of the week</li><li>2 Aroma Glass SteamHeads that match MrSteam glass facia controls and features an oil reservoir discretely hidden at the top of the steam head</li><li> Control of your listening experience with AUX, Bluetooth, USB or Radio through your iSteamX Control</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through your iSteamX Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E</li></p>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<p align=”justify”><li> For MX4E - MX6E Generators </li><li> Includes the award-winning iSteamX Control with capcitive touch screen, programmable custom settings for up to with 8 users, 7 available languages, white or black interface color, real time clock, Autostart Programing to get your steam shower ready each day of the week</li><li>2 Aroma Glass SteamHeads that match MrSteam glass facia controls and features an oil reservoir discretely hidden at the top of the steam head</li><li> Control of your listening experience with AUX, Bluetooth, USB or Radio through your iSteamX Control</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through your iSteamX Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E</li></p>"
					}
				]
			},
			"descriptions.parts": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.steamHead",
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<li>  (1)iSteamX Touch Screen Control </li><li>(1) AromaSteam SteamHead </li><li>(1) AutoFlush </li><li> (1) Condensation Pan </li><li>(1) SteamLinx</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<li>  (1)iSteamX Touch Screen Control </li><li>(1) AromaSteam SteamHead </li><li>(1) AutoFlush </li><li> (1) Condensation Pan </li><li>(1) SteamLinx</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<li>  (1)iSteamX Touch Screen Control </li><li>(1) Linear SteamHead </li><li>(1) AutoFlush </li><li> (1) Condensation Pan </li><li>(1) SteamLinx</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<li>  (1)iSteamX Touch Screen Control </li><li>(1) Linear SteamHead </li><li>(1) AutoFlush </li><li> (1) Condensation Pan </li><li>(1) SteamLinx</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<li>  (1)iSteamX Touch Screen Control in black </li><li>(2) AromaSteam Glass SteamHeads in black </li><li>(1) Max AutoFlush </li><li> (1) Max Condensation Pan </li><li>(1) SteamLinx</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<li>  (1)iSteamX Touch Screen Control in white </li><li>(2) AromaSteam Glass SteamHeads in white </li><li>(1) Max AutoFlush </li><li> (1) Max Condensation Pan </li><li>(1) SteamLinx</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<li>  (1)iSteamX Touch Screen Control in black </li><li> (2) 16 inch Linear SteamHeads </li><li>(1) Max AutoFlush </li><li> (1) Max Condensation Pan </li><li>(1) SteamLinx</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<li>  (1)iSteamX Touch Screen Control in white </li><li> (2) 16 inch Linear SteamHeads </li><li>(1) Max AutoFlush </li><li> (1) Max Condensation Pan </li><li>(1) SteamLinx</li>"
					}
				]
			},
			"partnumber": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.steamHead",
					"_globals.selectedGenerator",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XBTLRBKPC"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XBTLRBKBB"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XBTLRBKBN"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XBTLRBKOB"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XBTLRBKPB"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XBTLRBKPN"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XBTLRBKSB"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XBTLRBKMB"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XBTLRWHPC"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XBTLRWHBB"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XBTLRWHBN"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XBTLRWHOB"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XBTLRWHPB"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XBTLRWHPN"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XBTLRWHSB"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XBTLRWHMB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XBTLRBKLPC"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XBTLRBKLBB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XBTLRBKLBN"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XBTLRBKLOB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XBTLRBKLPB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XBTLRBKLPN"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XBTLRBKLSB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XBTLRBKLMB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XBTLRWHLPC"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XBTLRWHLBB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XBTLRWHLBN"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XBTLRWHLOB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XBTLRWHLPB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XBTLRWHLPN"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XBTLRWHLSB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XBTLRWHLMB"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XBTLRBKXPC"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XBTLRBKXBB"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XBTLRBKXBN"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XBTLRBKXOB"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XBTLRBKXPB"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XBTLRBKXPN"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XBTLRBKXSB"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XBTLRBKXMB"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XBTLRWHXPC"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XBTLRWHXBB"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XBTLRWHXBN"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XBTLRWHXOB"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XBTLRWHXPB"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XBTLRWHXPN"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XBTLRWHXSB"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XBTLRWHXMB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XBTLRBKXLPC"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XBTLRBKXLBB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XBTLRBKXLBN"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XBTLRBKXLOB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XBTLRBKXLPB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XBTLRBKXLPN"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XBTLRBKXLSB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XBTLRBKXLMB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XBTLRWHXLPC"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XBTLRWHXLBB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XBTLRWHXLBN"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XBTLRWHXLOB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XBTLRWHXLPB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XBTLRWHXLPN"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XBTLRWHXLSB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XBTLRWHXLMB"
					}
				]
			},
			"images.scene": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.steamHead",
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "ibutler_package_black.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "ibutler_package_2_black.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "ibutler_package_white.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "ibutler_package_2_white.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "ibutler_linear_package_black.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "ibutler_linear_package_2_black.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "ibutler_linear_package_white.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "ibutler_linear_package_2_white.png"
					}
				]
			},
			"package.config.dynamicProducts.selectedGenerator": {
				"keyTemplate": [
					"options.selected.steamHead",
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS90EC1"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS150EC1"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS225EC1"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS400EC1"
							]
						],
						"value": [
							{
								"productId": "ISTEAM_STEAMHEAD",
								"quantity": 1
							},
							{
								"productId": "AUTOFLUSH",
								"quantity": 1
							},
							{
								"productId": "Condensation Pan",
								"quantity": 1
							}
						]
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX4EC1"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX5EC1"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": [
							{
								"productId": "ISTEAM_STEAMHEAD",
								"quantity": 2
							},
							{
								"productId": "AUTOFLUSH",
								"quantity": 2
							},
							{
								"productId": "Condensation Pan",
								"quantity": 2
							}
						]
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								null
							],
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1"
							]
						],
						"value": [
							{
								"productId": "LINEAR_STEAMHEAD",
								"quantity": 1
							},
							{
								"productId": "AUTOFLUSH",
								"quantity": 1
							},
							{
								"productId": "Condensation Pan",
								"quantity": 1
							}
						]
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": [
							{
								"productId": "LINEAR_STEAMHEAD",
								"quantity": 2
							},
							{
								"productId": "AUTOFLUSH",
								"quantity": 2
							},
							{
								"productId": "Condensation Pan",
								"quantity": 2
							}
						]
					}
				]
			}
		},
		"package": {
			"config": {
				"staticProducts": [
					{
						"productId": "ISTEAMX_CONTROL",
						"quantity": 1
					},
					{
						"productId": "SteamLinx",
						"quantity": 1
					}
				]
			}
		},
		"vSpa": {
			"spaFrameSourceOption": "finish",
			"spaFrameIsVisible": true,
			"standardGeneratorIsVisible": true,
			"isSuperCompatible": true
		}
	},
	{
		"code": "ISTEAMX_PACKAGE",
		"partnumber": "ISTEAMX",
		"previewname": "ISTEAMX",
		"name": "iSteamX Shower Control",
		"price": 2300,
		"descriptions": {
			"short": "The iSteamX",
			"long": "With the iSteamX you have total control of every detail of your steaming experience. Housed in a sleek, slimline package, it mounts nearly flush on the wall of your shower. This awardwinning control is the most technologically advanced steam shower control available.",
			"tech": "<li>Change temperature & time settings with the touch of a finger</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Control of your listening experience with AUX, Bluetooth, USB or Radio</li><li>Create profiles for custom settings for temperature, time and more</li><li>Available in six different languages: English, French, Spanish, Italian, German, and Russian<li>Have peace of mind with temperature timed shut-offs and passcode protection</li><li>Automatically pre-heat your SteamShower so it's ready when you are</li><li>Water proof touch screen so technologically advanced it can tell the difference between a drop of water and your finger</li>"
		},
		"links": {
			"tech": "https://pim.mrsteam.com/Resources/Entities/MRSTEAM/Documents/ec2bf67d-e707-4e3b-a9cc-1a3f94082b68.pdf"
		},
		"images": {
			"thumbnail": "ISTEAMXBKPC.jpg",
			"folder": "individual-controls/iSteamX/",
			"scene": "mst2023-01_vspa_update_isteamx_PC_black.png"
		},
		"taxonomy": {
			"categories": [
				"isteamx-touch-screen-controls"
			],
			"sortOrder": {
				"isteamx-touch-screen-controls": 1
			},
			"zIndex": {
				"isteamx-touch-screen-controls": 1
			}
		},
		"options": {
			"enabledListsIds": [
				"color",
				"finish"
			],
			"selected": {
				"color": "BLACK",
				"finish": "POLISHED_CHROME"
			},
			"list": {
				"color": [
					"BLACK",
					"WHITE"
				],
				"finish": [
					"POLISHED_CHROME",
					"BRUSHED_BRONZE",
					"BRUSHED_NICKEL",
					"OIL_RUBBED_BRONZE",
					"POLISHED_BRASS",
					"POLISHED_NICKEL",
					"SATIN_BRASS",
					"MATTE_BLACK"
				]
			}
		},
		"dynamicProperties": {
			"images.thumbnail": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"POLISHED_CHROME"
							]
						],
						"value": "ISTEAMXBKPC.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"BRUSHED_BRONZE"
							]
						],
						"value": "ISTEAMXBKBB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"BRUSHED_NICKEL"
							]
						],
						"value": "ISTEAMXBKBN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "ISTEAMXBKOB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"POLISHED_BRASS"
							]
						],
						"value": "ISTEAMXBKPB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"POLISHED_NICKEL"
							]
						],
						"value": "ISTEAMXBKPN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"SATIN_BRASS"
							]
						],
						"value": "ISTEAMXBKSB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"MATTE_BLACK"
							]
						],
						"value": "ISTEAMXBKMB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"POLISHED_CHROME"
							]
						],
						"value": "ISTEAMXWHPC.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"BRUSHED_BRONZE"
							]
						],
						"value": "ISTEAMXWHBB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"BRUSHED_NICKEL"
							]
						],
						"value": "ISTEAMXWHBN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "ISTEAMXWHOB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"POLISHED_BRASS"
							]
						],
						"value": "ISTEAMXWHPB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"POLISHED_NICKEL"
							]
						],
						"value": "ISTEAMXWHPN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"SATIN_BRASS"
							]
						],
						"value": "ISTEAMXWHSB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"MATTE_BLACK"
							]
						],
						"value": "ISTEAMXWHMB.jpg"
					}
				]
			},
			"links.tech": {
				"keyTemplate": [
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								null
							],
							[
								"MS90EC1"
							],
							[
								"MS150EC1"
							],
							[
								"MS225EC1"
							],
							[
								"MS400EC1"
							]
						],
						"value": "https://pim.mrsteam.com/Resources/Entities/MRSTEAM/Documents/ec2bf67d-e707-4e3b-a9cc-1a3f94082b68.pdf"
					},
					{
						"tally": [
							[
								"MSSUPER1EC1"
							],
							[
								"MSSUPER2EC1"
							],
							[
								"MSSUPER3EC1"
							],
							[
								"MX4EC1"
							],
							[
								"MX5EC1"
							],
							[
								"MX6EC1"
							]
						],
						"value": "https://pim.mrsteam.com/Resources/Entities/MRSTEAM/Documents/ec2bf67d-e707-4e3b-a9cc-1a3f94082b68.pdf"
					}
				]
			},
			"price": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"POLISHED_CHROME"
							]
						],
						"value": 2400
					},
					{
						"tally": [
							[
								"BRUSHED_BRONZE"
							],
							[
								"BRUSHED_NICKEL"
							],
							[
								"OIL_RUBBED_BRONZE"
							],
							[
								"POLISHED_BRASS"
							],
							[
								"POLISHED_NICKEL"
							],
							[
								"SATIN_BRASS"
							],
							[
								"MATTE_BLACK"
							]
						],
						"value": 2500
					}
				]
			},
			"descriptions.parts": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>iSteamX Touch Screen Control</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>iSteamX Touch Screen Control</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>iSteamX Touch Screen Control</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>iSteamX Touch Screen Control</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>iSteamX Touch Screen Control</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>iSteamX Touch Screen Control</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"SATIN_BRASS"
							]
						],
						"value": "<li>iSteamX Touch Screen Control</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"MATTE_BLACK"
							]
						],
						"value": "<li>iSteamX Touch Screen Control</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>iSteamX Touch Screen Control</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>iSteamX Touch Screen Control</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>iSteamX Touch Screen Control</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>iSteamX Touch Screen Control</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>iSteamX Touch Screen Control</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>iSteamX Touch Screen Control</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"SATIN_BRASS"
							]
						],
						"value": "<li>iSteamX Touch Screen Control</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"MATTE_BLACK"
							]
						],
						"value": "<li>iSteamX Touch Screen Control</li>"
					}
				]
			},
			"partnumber": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"POLISHED_CHROME"
							]
						],
						"value": "ISTEAMXBKPC"
					},
					{
						"tally": [
							[
								"BLACK",
								"BRUSHED_BRONZE"
							]
						],
						"value": "ISTEAMXBKBB"
					},
					{
						"tally": [
							[
								"BLACK",
								"BRUSHED_NICKEL"
							]
						],
						"value": "ISTEAMXBKBN"
					},
					{
						"tally": [
							[
								"BLACK",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "ISTEAMXBKOB"
					},
					{
						"tally": [
							[
								"BLACK",
								"POLISHED_BRASS"
							]
						],
						"value": "ISTEAMXBKPB"
					},
					{
						"tally": [
							[
								"BLACK",
								"POLISHED_NICKEL"
							]
						],
						"value": "ISTEAMXBKPN"
					},
					{
						"tally": [
							[
								"BLACK",
								"SATIN_BRASS"
							]
						],
						"value": "ISTEAMXBKSB"
					},
					{
						"tally": [
							[
								"BLACK",
								"MATTE_BLACK"
							]
						],
						"value": "ISTEAMXBKMB"
					},
					{
						"tally": [
							[
								"WHITE",
								"POLISHED_CHROME"
							]
						],
						"value": "ISTEAMXWHPC"
					},
					{
						"tally": [
							[
								"WHITE",
								"BRUSHED_BRONZE"
							]
						],
						"value": "ISTEAMXWHBB"
					},
					{
						"tally": [
							[
								"WHITE",
								"BRUSHED_NICKEL"
							]
						],
						"value": "ISTEAMXWHBN"
					},
					{
						"tally": [
							[
								"WHITE",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "ISTEAMXWHOB"
					},
					{
						"tally": [
							[
								"WHITE",
								"POLISHED_BRASS"
							]
						],
						"value": "ISTEAMXWHPB"
					},
					{
						"tally": [
							[
								"WHITE",
								"POLISHED_NICKEL"
							]
						],
						"value": "ISTEAMXWHPN"
					},
					{
						"tally": [
							[
								"WHITE",
								"SATIN_BRASS"
							]
						],
						"value": "ISTEAMXWHSB"
					},
					{
						"tally": [
							[
								"WHITE",
								"MATTE_BLACK"
							]
						],
						"value": "ISTEAMXWHMB"
					}
				]
			},
			"images.scene": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"POLISHED_CHROME"
							]
						],
						"value": "mst2023-01_vspa_update_isteamx_PC_black.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"BRUSHED_BRONZE"
							]
						],
						"value": "mst2023-01_vspa_update_isteamx_BB_black.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"BRUSHED_NICKEL"
							]
						],
						"value": "mst2023-01_vspa_update_isteamx_BN_black.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "mst2023-01_vspa_update_isteamx_ORB_black.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"POLISHED_BRASS"
							]
						],
						"value": "mst2023-01_vspa_update_isteamx_PB_black.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"POLISHED_NICKEL"
							]
						],
						"value": "mst2023-01_vspa_update_isteamx_PN_black.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"SATIN_BRASS"
							]
						],
						"value": "mst2023-01_vspa_update_isteamx_SB_black.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"MATTE_BLACK"
							]
						],
						"value": "mst2023-01_vspa_update_isteamx_MB_black.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"POLISHED_CHROME"
							]
						],
						"value": "mst2023-01_vspa_update_isteamx_PC_white.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"BRUSHED_BRONZE"
							]
						],
						"value": "mst2023-01_vspa_update_isteamx_BB_white.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"BRUSHED_NICKEL"
							]
						],
						"value": "mst2023-01_vspa_update_isteamx_BN_white.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "mst2023-01_vspa_update_isteamx_ORB_white.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"POLISHED_BRASS"
							]
						],
						"value": "mst2023-01_vspa_update_isteamx_PB_white.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"POLISHED_NICKEL"
							]
						],
						"value": "mst2023-01_vspa_update_isteamx_PN_white.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"SATIN_BRASS"
							]
						],
						"value": "mst2023-01_vspa_update_isteamx_SB_white.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"MATTE_BLACK"
							]
						],
						"value": "mst2023-01_vspa_update_isteamx_MB_white.png"
					}
				]
			},
			"package.config.dynamicProducts.selectedGenerator": {
				"keyTemplate": [
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								null
							],
							[
								"MS90EC1"
							],
							[
								"MS150EC1"
							],
							[
								"MS225EC1"
							],
							[
								"MS400EC1"
							]
						],
						"value": [
							{
								"productId": "ISTEAMX_CONTROL",
								"quantity": 1
							}
						]
					},
					{
						"tally": [
							[
								"MSSUPER1EC1"
							],
							[
								"MSSUPER2EC1"
							],
							[
								"MSSUPER3EC1"
							],
							[
								"MX4EC1"
							],
							[
								"MX5EC1"
							],
							[
								"MX6EC1"
							]
						],
						"value": [
							{
								"productId": "ISTEAMX_CONTROL",
								"quantity": 2
							}
						]
					}
				]
			}
		},
		"package": {
			"config": {
				"staticProducts": [
					{
						"productId": "ISTEAMX_CONTROL",
						"quantity": 1
					}
				]
			}
		},
		"vSpa": {
			"spaFrameSourceOption": "color",
			"spaFrameIsVisible": true,
			"standardGeneratorIsVisible": true,
			"isSuperCompatible": true
		}
	},
	{
		"code": "ISTEAM_STEAMHEAD",
		"partnumber": "ISTEAM3.0 ISTEAMHEAD",
		"previewname": "iSteam SteamHead",
		"name": "iSteam SteamHead",
		"descriptions": {
			"long": "We're passionate about steam, so we invest in every detail of our steam shower products. All of our steamheads leave a lasting visual imprint in any shower space. They provide a steam dispersion that has no moving parts, require no field assembly, and simple installation that matches any interior. Each of our steamhead designs will transform your shower giving you the atmosphere you desire-making steam second nature to your wellbeing.</LI>",
			"tech": "<li>Features oil reservoir for aroma therapy</li><li>Sleek black or white glass face complements the look of our glass face controls. It comes standard with glass face controls</li><li>No assembly of moving parts required</li><li>Standard with glass finish controls</li>"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/c48bdca4-da11-43ca-9a63-73a5bb12bf28.pdf"
		},
		"images": {
			"thumbnail": "isteam_steamhead.jpg",
			"folder": "individual-controls/iSteam/",
			"scene": "iSteam-SteamHead-Black.png"
		},
		"options": {
			"enabledListsIds": [
				"color"
			],
			"selected": {
				"color": "BLACK"
			},
			"list": {
				"color": [
					"BLACK",
					"WHITE"
				]
			}
		},
		"dynamicProperties": {
			"images.scene": {
				"keyTemplate": [
					"options.selected.color",
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								null
							],
							[
								"BLACK",
								"MS90EC1"
							],
							[
								"BLACK",
								"MS150EC1"
							],
							[
								"BLACK",
								"MS225EC1"
							],
							[
								"BLACK",
								"MS400EC1"
							],
							[
								"BLACK",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"MSSUPER3EC1"
							]
						],
						"value": "iSteam-SteamHead-Black.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"MX4EC1"
							],
							[
								"BLACK",
								"MX5EC1"
							],
							[
								"BLACK",
								"MX6EC1"
							]
						],
						"value": "iSteam-SteamHead-Black-Double.png"
					},
					{
						"tally": [
							[
								"WHITE",
								null
							],
							[
								"WHITE",
								"MS90EC1"
							],
							[
								"WHITE",
								"MS150EC1"
							],
							[
								"WHITE",
								"MS225EC1"
							],
							[
								"WHITE",
								"MS400EC1"
							],
							[
								"WHITE",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"MSSUPER3EC1"
							]
						],
						"value": "iSteam-SteamHead-White.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"MX4EC1"
							],
							[
								"WHITE",
								"MX5EC1"
							],
							[
								"WHITE",
								"MX6EC1"
							]
						],
						"value": "iSteam-SteamHead-White-Double.png"
					}
				]
			},
			"tooltips.list": {
				"keyTemplate": [
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								null
							],
							[
								"MS90EC1"
							],
							[
								"MS150EC1"
							],
							[
								"MS225EC1"
							],
							[
								"MS400EC1"
							]
						],
						"value": [
							{
								"top": 72.5,
								"left": 40,
								"width": 3,
								"height": 4
							}
						]
					},
					{
						"tally": [
							[
								"MSSUPER1EC1"
							],
							[
								"MSSUPER2EC1"
							],
							[
								"MSSUPER3EC1"
							],
							[
								"MX4EC1"
							],
							[
								"MX5EC1"
							],
							[
								"MX6EC1"
							]
						],
						"value": [
							{
								"top": 71.5,
								"left": 43.7,
								"width": 3,
								"height": 4,
								"orientation": "right"
							},
							{
								"top": 73.2,
								"left": 36.5,
								"width": 3,
								"height": 4,
								"orientation": "left"
							}
						]
					}
				]
			}
		},
		"tooltips": {
			"list": [
				{
					"top": 72.5,
					"left": 40,
					"width": 3,
					"height": 4
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": true
		}
	},
	{
		"code": "AIRTEMPO_PACKAGE",
		"partnumber": "AIRT",
		"previewname": "AirTempo Wireless Steam Shower Control",
		"name": "AirTempo Wireless Steam Shower Control",
		"price": 1550,
		"descriptions": {
			"short": "AirTempo Surface Mount Programmable Control – Wireless",
			"long": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat.",
			"tech": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li><li>LCD display</li>"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/6805c486-7ad2-47aa-b292-83cc7a6980a9.pdf"
		},
		"images": {
			"thumbnail": "AIRTBK-PC.jpg",
			"folder": "individual-controls/AirTempo/"
		},
		"taxonomy": {
			"categories": [
				"airtempo-wireless-controls"
			],
			"sortOrder": {
				"airtempo-wireless-controls": 2
			},
			"zIndex": {
				"airtempo-wireless-controls": 2
			}
		},
		"options": {
			"enabledListsIds": [
				"color",
				"finish"
			],
			"selected": {
				"color": "BLACK",
				"finish": "POLISHED_CHROME"
			},
			"list": {
				"color": [
					"BLACK",
					"WHITE"
				],
				"finish": [
					"POLISHED_CHROME",
					"BRUSHED_BRONZE",
					"BRUSHED_NICKEL",
					"OIL_RUBBED_BRONZE",
					"POLISHED_BRASS",
					"POLISHED_NICKEL",
					"SATIN_BRASS",
					"MATTE_BLACK"
				]
			}
		},
		"dynamicProperties": {
			"images.thumbnail": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"POLISHED_CHROME"
							]
						],
						"value": "AIRTBK-PC.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"BRUSHED_BRONZE"
							]
						],
						"value": "AIRTBK-BB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"BRUSHED_NICKEL"
							]
						],
						"value": "AIRTBK-BN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "AIRTBK-ORB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"POLISHED_BRASS"
							]
						],
						"value": "AIRTBK-PB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"POLISHED_NICKEL"
							]
						],
						"value": "AIRTBK-PN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"SATIN_BRASS"
							]
						],
						"value": "AIRTBK-SB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"MATTE_BLACK"
							]
						],
						"value": "AIRTBK-MB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"POLISHED_CHROME"
							]
						],
						"value": "AIRTWH-PC.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"BRUSHED_BRONZE"
							]
						],
						"value": "AIRTWH-BB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"BRUSHED_NICKEL"
							]
						],
						"value": "AIRTWH-BN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "AIRTWH-ORB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"POLISHED_BRASS"
							]
						],
						"value": "AIRTWH-PB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"POLISHED_NICKEL"
							]
						],
						"value": "AIRTWH-PN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"SATIN_BRASS"
							]
						],
						"value": "AIRTWH-SB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"MATTE_BLACK"
							]
						],
						"value": "AIRTWH-MB.jpg"
					}
				]
			},
			"links.tech": {
				"keyTemplate": [
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								null
							],
							[
								"MS90EC1"
							],
							[
								"MS150EC1"
							],
							[
								"MS225EC1"
							],
							[
								"MS400EC1"
							]
						],
						"value": "http://prodrep.mrsteam.com/DocumentResources/5ec25c10-e17d-434b-a820-3c5753948cca.pdf"
					},
					{
						"tally": [
							[
								"MSSUPER1EC1"
							],
							[
								"MSSUPER2EC1"
							],
							[
								"MSSUPER3EC1"
							],
							[
								"MX4EC1"
							],
							[
								"MX5EC1"
							],
							[
								"MX6EC1"
							]
						],
						"value": "http://prodrep.mrsteam.com/DocumentResources/5ec25c10-e17d-434b-a820-3c5753948cca.pdf"
					}
				]
			},
			"price": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"POLISHED_CHROME"
							]
						],
						"value": 1700
					},
					{
						"tally": [
							[
								"BRUSHED_BRONZE"
							],
							[
								"BRUSHED_NICKEL"
							],
							[
								"OIL_RUBBED_BRONZE"
							],
							[
								"POLISHED_BRASS"
							],
							[
								"POLISHED_NICKEL"
							],
							[
								"SATIN_BRASS"
							],
							[
								"MATTE_BLACK"
							]
						],
						"value": 1900
					}
				]
			},
			"descriptions.parts": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>AirTempo Wireless Steam Shower Control</li><li>AirTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>AirTempo Wireless Steam Shower Control</li><li>AirTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>AirTempo Wireless Steam Shower Control</li><li>AirTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>AirTempo Wireless Steam Shower Control</li><li>AirTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>AirTempo Wireless Steam Shower Control</li><li>AirTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>AirTempo Wireless Steam Shower Control</li><li>AirTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"SATIN_BRASS"
							]
						],
						"value": "<li>AirTempo Wireless Steam Shower Control</li><li>AirTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"MATTE_BLACK"
							]
						],
						"value": "<li>AirTempo Wireless Steam Shower Control</li><li>AirTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>AirTempo Wireless Steam Shower Control</li><li>AirTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>AirTempo Wireless Steam Shower Control</li><li>AirTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>AirTempo Wireless Steam Shower Control</li><li>AirTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>AirTempo Wireless Steam Shower Control</li><li>AirTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>AirTempo Wireless Steam Shower Control</li><li>AirTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>AirTempo Wireless Steam Shower Control</li><li>AirTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"SATIN_BRASS"
							]
						],
						"value": "<li>AirTempo Wireless Steam Shower Control</li><li>AirTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"MATTE_BLACK"
							]
						],
						"value": "<li>AirTempo Wireless Steam Shower Control</li><li>AirTempo SteamHead</li>"
					}
				]
			},
			"partnumber": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"POLISHED_CHROME"
							]
						],
						"value": "AIRTBK-PC"
					},
					{
						"tally": [
							[
								"BLACK",
								"BRUSHED_BRONZE"
							]
						],
						"value": "AIRTBK-BB"
					},
					{
						"tally": [
							[
								"BLACK",
								"BRUSHED_NICKEL"
							]
						],
						"value": "AIRTBK-BN"
					},
					{
						"tally": [
							[
								"BLACK",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "AIRTBK-ORB"
					},
					{
						"tally": [
							[
								"BLACK",
								"POLISHED_BRASS"
							]
						],
						"value": "AIRTBK-PB"
					},
					{
						"tally": [
							[
								"BLACK",
								"POLISHED_NICKEL"
							]
						],
						"value": "AIRTBK-PN"
					},
					{
						"tally": [
							[
								"BLACK",
								"SATIN_BRASS"
							]
						],
						"value": "AIRTBK-SB"
					},
					{
						"tally": [
							[
								"BLACK",
								"MATTE_BLACK"
							]
						],
						"value": "AIRTBK-MB"
					},
					{
						"tally": [
							[
								"WHITE",
								"POLISHED_CHROME"
							]
						],
						"value": "AIRTWH-PC"
					},
					{
						"tally": [
							[
								"WHITE",
								"BRUSHED_BRONZE"
							]
						],
						"value": "AIRTWH-BB"
					},
					{
						"tally": [
							[
								"WHITE",
								"BRUSHED_NICKEL"
							]
						],
						"value": "AIRTWH-BN"
					},
					{
						"tally": [
							[
								"WHITE",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "AIRTWH-ORB"
					},
					{
						"tally": [
							[
								"WHITE",
								"POLISHED_BRASS"
							]
						],
						"value": "AIRTWH-PB"
					},
					{
						"tally": [
							[
								"WHITE",
								"POLISHED_NICKEL"
							]
						],
						"value": "AIRTWH-PN"
					},
					{
						"tally": [
							[
								"WHITE",
								"SATIN_BRASS"
							]
						],
						"value": "AIRTWH-SB"
					},
					{
						"tally": [
							[
								"WHITE",
								"MATTE_BLACK"
							]
						],
						"value": "AIRTWH-MB"
					}
				]
			},
			"package.config.dynamicProducts.selectedGenerator": {
				"keyTemplate": [
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								null
							],
							[
								"MS90EC1"
							],
							[
								"MS150EC1"
							],
							[
								"MS225EC1"
							],
							[
								"MS400EC1"
							]
						],
						"value": [
							{
								"productId": "AIRTEMPO_STEAMHEAD",
								"quantity": 1
							}
						]
					},
					{
						"tally": [
							[
								"MSSUPER1EC1"
							],
							[
								"MSSUPER2EC1"
							],
							[
								"MSSUPER3EC1"
							],
							[
								"MX4EC1"
							],
							[
								"MX5EC1"
							],
							[
								"MX6EC1"
							]
						],
						"value": [
							{
								"productId": "AIRTEMPO_STEAMHEAD",
								"quantity": 2
							}
						]
					}
				]
			}
		},
		"package": {
			"config": {
				"staticProducts": [
					{
						"productId": "AIRTEMPO_CONTROL",
						"quantity": 1
					}
				]
			}
		},
		"vSpa": {
			"spaFrameSourceOption": "color",
			"spaFrameIsVisible": true,
			"standardGeneratorIsVisible": true,
			"isSuperCompatible": true
		}
	},
	{
		"code": "AIRTEMPO_CONTROL",
		"partnumber": "AIRT CONTROL",
		"previewname": "AirTempo Wireless Steam Shower Control",
		"name": "AirTempo Wireless Steam Shower Control",
		"descriptions": {
			"short": "AirTempo Surface Mount Programmable Control – Wireless",
			"long": "Wireless. No longer tethered by cables, the AirTempo control offers a nomadic way to control your steam. Its exquisite waterproof design, allows the AirTempo control to be easily installed on almost any steam room wall, even glass. \\r\\n",
			"tech": "<li>Need to replace or upgrade your control? Do so easily with the new wireless AirTempo</li>\\r\\n<li>Includes two CR2450 lithium batteries</li>\\r\\n<li>A six month battery life if used daily for 20 minutes </li>\\r\\n<li>Programmable Temperature and time, AromaSteam, ChromaSteam, Dual Settings</li>\\r\\n<li>Comes standard as surface mount with available flush mount options </li>\\r\\n<li>60 foot wireless range from steam generator </li><li>LCD display</li>"
		},
		"images": {
			"thumbnail": "AirTempo-Package-Black-PolishedChrome.jpg",
			"folder": "individual-controls/AirTempo/",
			"scene": "AirTempo-SteamHead-Black.png"
		},
		"options": {
			"enabledListsIds": [
				"color",
				"finish"
			],
			"selected": {
				"color": "BLACK",
				"finish": "POLISHED_CHROME"
			},
			"list": {
				"color": [
					"BLACK",
					"WHITE"
				],
				"finish": [
					"POLISHED_CHROME",
					"BRUSHED_BRONZE",
					"BRUSHED_NICKEL",
					"OIL_RUBBED_BRONZE",
					"POLISHED_BRASS",
					"POLISHED_NICKEL",
					"SATIN_BRASS",
					"MATTE_BLACK"
				]
			}
		},
		"dynamicProperties": {
			"images.scene": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"POLISHED_CHROME"
							]
						],
						"value": "AirTempo-Control-Black-PolishedChrome.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"BRUSHED_BRONZE"
							]
						],
						"value": "AirTempo-Control-Black-BrushedBronze.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"BRUSHED_NICKEL"
							]
						],
						"value": "AirTempo-Control-Black-BrushedNickel.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "AirTempo-Control-Black-OilRubbedBronze.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"POLISHED_BRASS"
							]
						],
						"value": "AirTempo-Control-Black-PolishedBrass.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"POLISHED_NICKEL"
							]
						],
						"value": "AirTempo-Control-Black-PolishedNickel.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"SATIN_BRASS"
							]
						],
						"value": "AirTempo-Control-Black-SatinBrass.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"MATTE_BLACK"
							]
						],
						"value": "AirTempo-Control-Black-BrushedBronze.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"POLISHED_CHROME"
							]
						],
						"value": "AirTempo-Control-White-PolishedChrome.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"BRUSHED_BRONZE"
							]
						],
						"value": "AirTempo-Control-White-BrushedBronze.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"BRUSHED_NICKEL"
							]
						],
						"value": "AirTempo-Control-White-BrushedNickel.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "AirTempo-Control-White-OilRubbedBronze.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"POLISHED_BRASS"
							]
						],
						"value": "AirTempo-Control-White-PolishedBrass.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"POLISHED_NICKEL"
							]
						],
						"value": "AirTempo-Control-White-PolishedNickel.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"SATIN_BRASS"
							]
						],
						"value": "AirTempo-Control-White-SatinBrass.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"MATTE_BLACK"
							]
						],
						"value": "AirTempo-Control-White-OilRubbedBronze.png"
					}
				]
			}
		},
		"tooltips": {
			"list": [
				{
					"top": 50,
					"left": 69.5,
					"width": 4.5,
					"height": 6
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false
		}
	},
	{
		"code": "AIRTEMPO_STEAMHEAD",
		"partnumber": "AIRT STEAMHEAD",
		"previewname": "AirTempo SteamHead",
		"name": "AirTempo SteamHead",
		"descriptions": {
			"long": "We're passionate about steam, so we invest in every detail of our steam shower products. All of our steamheads leave a lasting visual imprint in any shower space. They provide a steam dispersion that has no moving parts, require no field assembly, and simple installation that matches any interior. Each of our steamhead designs will transform your shower giving you the atmosphere you desire-making steam second nature to your wellbeing.</LI>",
			"tech": "<li>Features oil reservoir for aroma therapy</li><li>Sleek black or white glass face complements the look of our glass face controls. It comes standard with glass face controls</li><li>No assembly of moving parts required</li><li>Standard with glass finish controls</li><li>Available in 7 metal trim finishes to match your control selection</li>"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/c48bdca4-da11-43ca-9a63-73a5bb12bf28.pdf"
		},
		"images": {
			"thumbnail": "airtempo_steamhead.jpg",
			"folder": "individual-controls/AirTempo/",
			"scene": "AirTempo-SteamHead-Black.png"
		},
		"options": {
			"enabledListsIds": [
				"color",
				"finish"
			],
			"selected": {
				"color": "BLACK",
				"finish": "POLISHED_CHROME"
			},
			"list": {
				"color": [
					"BLACK",
					"WHITE"
				],
				"finish": [
					"POLISHED_CHROME",
					"BRUSHED_BRONZE",
					"BRUSHED_NICKEL",
					"OIL_RUBBED_BRONZE",
					"POLISHED_BRASS",
					"POLISHED_NICKEL",
					"SATIN_BRASS"
				]
			}
		},
		"dynamicProperties": {
			"images.scene": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.finish",
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"POLISHED_CHROME",
								null
							],
							[
								"BLACK",
								"POLISHED_CHROME",
								"MS90EC1"
							],
							[
								"BLACK",
								"POLISHED_CHROME",
								"MS150EC1"
							],
							[
								"BLACK",
								"POLISHED_CHROME",
								"MS225EC1"
							],
							[
								"BLACK",
								"POLISHED_CHROME",
								"MS400EC1"
							],
							[
								"BLACK",
								"POLISHED_CHROME",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"POLISHED_CHROME",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"POLISHED_CHROME",
								"MSSUPER3EC1"
							]
						],
						"value": "AirTempo-SteamHead-Black-PolishedChrome.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"BRUSHED_BRONZE",
								null
							],
							[
								"BLACK",
								"BRUSHED_BRONZE",
								"MS90EC1"
							],
							[
								"BLACK",
								"BRUSHED_BRONZE",
								"MS150EC1"
							],
							[
								"BLACK",
								"BRUSHED_BRONZE",
								"MS225EC1"
							],
							[
								"BLACK",
								"BRUSHED_BRONZE",
								"MS400EC1"
							],
							[
								"BLACK",
								"BRUSHED_BRONZE",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"BRUSHED_BRONZE",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"BRUSHED_BRONZE",
								"MSSUPER3EC1"
							]
						],
						"value": "AirTempo-SteamHead-Black-BrushedBronze.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"BRUSHED_NICKEL",
								null
							],
							[
								"BLACK",
								"BRUSHED_NICKEL",
								"MS90EC1"
							],
							[
								"BLACK",
								"BRUSHED_NICKEL",
								"MS150EC1"
							],
							[
								"BLACK",
								"BRUSHED_NICKEL",
								"MS225EC1"
							],
							[
								"BLACK",
								"BRUSHED_NICKEL",
								"MS400EC1"
							],
							[
								"BLACK",
								"BRUSHED_NICKEL",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"BRUSHED_NICKEL",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"BRUSHED_NICKEL",
								"MSSUPER3EC1"
							]
						],
						"value": "AirTempo-SteamHead-Black-BrushedNickel.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"OIL_RUBBED_BRONZE",
								null
							],
							[
								"BLACK",
								"OIL_RUBBED_BRONZE",
								"MS90EC1"
							],
							[
								"BLACK",
								"OIL_RUBBED_BRONZE",
								"MS150EC1"
							],
							[
								"BLACK",
								"OIL_RUBBED_BRONZE",
								"MS225EC1"
							],
							[
								"BLACK",
								"OIL_RUBBED_BRONZE",
								"MS400EC1"
							],
							[
								"BLACK",
								"OIL_RUBBED_BRONZE",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"OIL_RUBBED_BRONZE",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"OIL_RUBBED_BRONZE",
								"MSSUPER3EC1"
							]
						],
						"value": "AirTempo-SteamHead-Black-OilRubbedBronze.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"POLISHED_BRASS",
								null
							],
							[
								"BLACK",
								"POLISHED_BRASS",
								"MS90EC1"
							],
							[
								"BLACK",
								"POLISHED_BRASS",
								"MS150EC1"
							],
							[
								"BLACK",
								"POLISHED_BRASS",
								"MS225EC1"
							],
							[
								"BLACK",
								"POLISHED_BRASS",
								"MS400EC1"
							],
							[
								"BLACK",
								"POLISHED_BRASS",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"POLISHED_BRASS",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"POLISHED_BRASS",
								"MSSUPER3EC1"
							]
						],
						"value": "AirTempo-SteamHead-Black-PolishedBrass.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"POLISHED_NICKEL",
								null
							],
							[
								"BLACK",
								"POLISHED_NICKEL",
								"MS90EC1"
							],
							[
								"BLACK",
								"POLISHED_NICKEL",
								"MS150EC1"
							],
							[
								"BLACK",
								"POLISHED_NICKEL",
								"MS225EC1"
							],
							[
								"BLACK",
								"POLISHED_NICKEL",
								"MS400EC1"
							],
							[
								"BLACK",
								"POLISHED_NICKEL",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"POLISHED_NICKEL",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"POLISHED_NICKEL",
								"MSSUPER3EC1"
							]
						],
						"value": "AirTempo-SteamHead-Black-PolishedNickel.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"SATIN_BRASS",
								null
							],
							[
								"BLACK",
								"SATIN_BRASS",
								"MS90EC1"
							],
							[
								"BLACK",
								"SATIN_BRASS",
								"MS150EC1"
							],
							[
								"BLACK",
								"SATIN_BRASS",
								"MS225EC1"
							],
							[
								"BLACK",
								"SATIN_BRASS",
								"MS400EC1"
							],
							[
								"BLACK",
								"SATIN_BRASS",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"SATIN_BRASS",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"SATIN_BRASS",
								"MSSUPER3EC1"
							]
						],
						"value": "AirTempo-SteamHead-Black-SatinBrass.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"POLISHED_CHROME",
								null
							],
							[
								"WHITE",
								"POLISHED_CHROME",
								"MS90EC1"
							],
							[
								"WHITE",
								"POLISHED_CHROME",
								"MS150EC1"
							],
							[
								"WHITE",
								"POLISHED_CHROME",
								"MS225EC1"
							],
							[
								"WHITE",
								"POLISHED_CHROME",
								"MS400EC1"
							],
							[
								"WHITE",
								"POLISHED_CHROME",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"POLISHED_CHROME",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"POLISHED_CHROME",
								"MSSUPER3EC1"
							]
						],
						"value": "AirTempo-SteamHead-White-PolishedChrome.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"BRUSHED_BRONZE",
								null
							],
							[
								"WHITE",
								"BRUSHED_BRONZE",
								"MS90EC1"
							],
							[
								"WHITE",
								"BRUSHED_BRONZE",
								"MS150EC1"
							],
							[
								"WHITE",
								"BRUSHED_BRONZE",
								"MS225EC1"
							],
							[
								"WHITE",
								"BRUSHED_BRONZE",
								"MS400EC1"
							],
							[
								"WHITE",
								"BRUSHED_BRONZE",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"BRUSHED_BRONZE",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"BRUSHED_BRONZE",
								"MSSUPER3EC1"
							]
						],
						"value": "AirTempo-SteamHead-White-BrushedBronze.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"BRUSHED_NICKEL",
								null
							],
							[
								"WHITE",
								"BRUSHED_NICKEL",
								"MS90EC1"
							],
							[
								"WHITE",
								"BRUSHED_NICKEL",
								"MS150EC1"
							],
							[
								"WHITE",
								"BRUSHED_NICKEL",
								"MS225EC1"
							],
							[
								"WHITE",
								"BRUSHED_NICKEL",
								"MS400EC1"
							],
							[
								"WHITE",
								"BRUSHED_NICKEL",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"BRUSHED_NICKEL",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"BRUSHED_NICKEL",
								"MSSUPER3EC1"
							]
						],
						"value": "AirTempo-SteamHead-White-BrushedNickel.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"OIL_RUBBED_BRONZE",
								null
							],
							[
								"WHITE",
								"OIL_RUBBED_BRONZE",
								"MS90EC1"
							],
							[
								"WHITE",
								"OIL_RUBBED_BRONZE",
								"MS150EC1"
							],
							[
								"WHITE",
								"OIL_RUBBED_BRONZE",
								"MS225EC1"
							],
							[
								"WHITE",
								"OIL_RUBBED_BRONZE",
								"MS400EC1"
							],
							[
								"WHITE",
								"OIL_RUBBED_BRONZE",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"OIL_RUBBED_BRONZE",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"OIL_RUBBED_BRONZE",
								"MSSUPER3EC1"
							]
						],
						"value": "AirTempo-SteamHead-White-OilRubbedBronze.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"POLISHED_BRASS",
								null
							],
							[
								"WHITE",
								"POLISHED_BRASS",
								"MS90EC1"
							],
							[
								"WHITE",
								"POLISHED_BRASS",
								"MS150EC1"
							],
							[
								"WHITE",
								"POLISHED_BRASS",
								"MS225EC1"
							],
							[
								"WHITE",
								"POLISHED_BRASS",
								"MS400EC1"
							],
							[
								"WHITE",
								"POLISHED_BRASS",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"POLISHED_BRASS",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"POLISHED_BRASS",
								"MSSUPER3EC1"
							]
						],
						"value": "AirTempo-SteamHead-White-PolishedBrass.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"POLISHED_NICKEL",
								null
							],
							[
								"WHITE",
								"POLISHED_NICKEL",
								"MS90EC1"
							],
							[
								"WHITE",
								"POLISHED_NICKEL",
								"MS150EC1"
							],
							[
								"WHITE",
								"POLISHED_NICKEL",
								"MS225EC1"
							],
							[
								"WHITE",
								"POLISHED_NICKEL",
								"MS400EC1"
							],
							[
								"WHITE",
								"POLISHED_NICKEL",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"POLISHED_NICKEL",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"POLISHED_NICKEL",
								"MSSUPER3EC1"
							]
						],
						"value": "AirTempo-SteamHead-White-PolishedNickel.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"SATIN_BRASS",
								null
							],
							[
								"WHITE",
								"SATIN_BRASS",
								"MS90EC1"
							],
							[
								"WHITE",
								"SATIN_BRASS",
								"MS150EC1"
							],
							[
								"WHITE",
								"SATIN_BRASS",
								"MS225EC1"
							],
							[
								"WHITE",
								"SATIN_BRASS",
								"MS400EC1"
							],
							[
								"WHITE",
								"SATIN_BRASS",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"SATIN_BRASS",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"SATIN_BRASS",
								"MSSUPER3EC1"
							]
						],
						"value": "AirTempo-SteamHead-White-SatinBrass.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"POLISHED_CHROME",
								"MX4EC1"
							],
							[
								"BLACK",
								"POLISHED_CHROME",
								"MX5EC1"
							],
							[
								"BLACK",
								"POLISHED_CHROME",
								"MX6EC1"
							]
						],
						"value": "AirTempo-SteamHead-Black-PolishedChrome-Double.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"BRUSHED_BRONZE",
								"MX4EC1"
							],
							[
								"BLACK",
								"BRUSHED_BRONZE",
								"MX5EC1"
							],
							[
								"BLACK",
								"BRUSHED_BRONZE",
								"MX6EC1"
							]
						],
						"value": "AirTempo-SteamHead-Black-BrushedBronze-Double.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"BRUSHED_NICKEL",
								"MX4EC1"
							],
							[
								"BLACK",
								"BRUSHED_NICKEL",
								"MX5EC1"
							],
							[
								"BLACK",
								"BRUSHED_NICKEL",
								"MX6EC1"
							]
						],
						"value": "AirTempo-SteamHead-Black-BrushedNickel-Double.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"OIL_RUBBED_BRONZE",
								"MX4EC1"
							],
							[
								"BLACK",
								"OIL_RUBBED_BRONZE",
								"MX5EC1"
							],
							[
								"BLACK",
								"OIL_RUBBED_BRONZE",
								"MX6EC1"
							]
						],
						"value": "AirTempo-SteamHead-Black-OilRubbedBronze-Double.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"POLISHED_BRASS",
								"MX4EC1"
							],
							[
								"BLACK",
								"POLISHED_BRASS",
								"MX5EC1"
							],
							[
								"BLACK",
								"POLISHED_BRASS",
								"MX6EC1"
							]
						],
						"value": "AirTempo-SteamHead-Black-PolishedBrass-Double.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"POLISHED_NICKEL",
								"MX4EC1"
							],
							[
								"BLACK",
								"POLISHED_NICKEL",
								"MX5EC1"
							],
							[
								"BLACK",
								"POLISHED_NICKEL",
								"MX6EC1"
							]
						],
						"value": "AirTempo-SteamHead-Black-PolishedNickel-Double.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"SATIN_BRASS",
								"MX4EC1"
							],
							[
								"BLACK",
								"SATIN_BRASS",
								"MX5EC1"
							],
							[
								"BLACK",
								"SATIN_BRASS",
								"MX6EC1"
							]
						],
						"value": "AirTempo-SteamHead-Black-SatinBrass-Double.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"POLISHED_CHROME",
								"MX4EC1"
							],
							[
								"WHITE",
								"POLISHED_CHROME",
								"MX5EC1"
							],
							[
								"WHITE",
								"POLISHED_CHROME",
								"MX6EC1"
							]
						],
						"value": "AirTempo-SteamHead-White-PolishedChrome-Double.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"BRUSHED_BRONZE",
								"MX4EC1"
							],
							[
								"WHITE",
								"BRUSHED_BRONZE",
								"MX5EC1"
							],
							[
								"WHITE",
								"BRUSHED_BRONZE",
								"MX6EC1"
							]
						],
						"value": "AirTempo-SteamHead-White-BrushedBronze-Double.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"BRUSHED_NICKEL",
								"MX4EC1"
							],
							[
								"WHITE",
								"BRUSHED_NICKEL",
								"MX5EC1"
							],
							[
								"WHITE",
								"BRUSHED_NICKEL",
								"MX6EC1"
							]
						],
						"value": "AirTempo-SteamHead-White-BrushedNickel-Double.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"OIL_RUBBED_BRONZE",
								"MX4EC1"
							],
							[
								"WHITE",
								"OIL_RUBBED_BRONZE",
								"MX5EC1"
							],
							[
								"WHITE",
								"OIL_RUBBED_BRONZE",
								"MX6EC1"
							]
						],
						"value": "AirTempo-SteamHead-White-OilRubbedBronze-Double.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"POLISHED_BRASS",
								"MX4EC1"
							],
							[
								"WHITE",
								"POLISHED_BRASS",
								"MX5EC1"
							],
							[
								"WHITE",
								"POLISHED_BRASS",
								"MX6EC1"
							]
						],
						"value": "AirTempo-SteamHead-White-PolishedBrass-Double.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"POLISHED_NICKEL",
								"MX4EC1"
							],
							[
								"WHITE",
								"POLISHED_NICKEL",
								"MX5EC1"
							],
							[
								"WHITE",
								"POLISHED_NICKEL",
								"MX6EC1"
							]
						],
						"value": "AirTempo-SteamHead-White-PolishedNickel-Double.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"SATIN_BRASS",
								"MX4EC1"
							],
							[
								"WHITE",
								"SATIN_BRASS",
								"MX5EC1"
							],
							[
								"WHITE",
								"SATIN_BRASS",
								"MX6EC1"
							]
						],
						"value": "AirTempo-SteamHead-White-SatinBrass-Double.png"
					}
				]
			},
			"tooltips.list": {
				"keyTemplate": [
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								null
							],
							[
								"MS90EC1"
							],
							[
								"MS150EC1"
							],
							[
								"MS225EC1"
							],
							[
								"MS400EC1"
							]
						],
						"value": [
							{
								"top": 72.5,
								"left": 40,
								"width": 3,
								"height": 4
							}
						]
					},
					{
						"tally": [
							[
								"MSSUPER1EC1"
							],
							[
								"MSSUPER2EC1"
							],
							[
								"MSSUPER3EC1"
							],
							[
								"MX4EC1"
							],
							[
								"MX5EC1"
							],
							[
								"MX6EC1"
							]
						],
						"value": [
							{
								"top": 71.5,
								"left": 43.7,
								"width": 3,
								"height": 4,
								"orientation": "right"
							},
							{
								"top": 73.2,
								"left": 36.5,
								"width": 3,
								"height": 4,
								"orientation": "left"
							}
						]
					}
				]
			}
		},
		"tooltips": {
			"list": [
				{
					"top": 72.5,
					"left": 40,
					"width": 3,
					"height": 4
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": true
		}
	},
	{
		"code": "ITEMPO_PLUS_PACKAGE",
		"partnumber": "MSITPLUS",
		"previewname": "iTempo Plus Control",
		"name": "iTempo Plus Control",
		"price": 1350,
		"descriptions": {
			"long": "Its never been easier to optimize your steam shower experience. With an elegant design and easy to use interface, you can control more than steam. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center.",
			"tech": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaSteam lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li><li>Operates with optional SteamLinx™</li><li>Control includes digital clock</li>",
			"parts": "test"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/b759ed5f-4528-45f1-b6f1-e22967c9f281.pdf"
		},
		"images": {
			"thumbnail": "MSITPLUSSQ-PC.jpg",
			"folder": "individual-controls/iTempoPlus/"
		},
		"taxonomy": {
			"categories": [
				"itempo-plus-controls"
			],
			"sortOrder": {
				"itempo-plus-controls": 2
			},
			"zIndex": {
				"itempo-plus-controls": 2
			}
		},
		"options": {
			"enabledListsIds": [
				"shape",
				"finish"
			],
			"selected": {
				"shape": "SQUARE",
				"color": "BLACK",
				"finish": "POLISHED_CHROME"
			},
			"list": {
				"shape": [
					"SQUARE",
					"ROUND"
				],
				"finish": [
					"POLISHED_CHROME",
					"BRUSHED_BRONZE",
					"BRUSHED_NICKEL",
					"OIL_RUBBED_BRONZE",
					"POLISHED_BRASS",
					"POLISHED_NICKEL",
					"SATIN_BRASS",
					"BLACK",
					"MATTE_BLACK",
					"WHITE",
					"RAW"
				]
			}
		},
		"dynamicProperties": {
			"images.thumbnail": {
				"keyTemplate": [
					"options.selected.shape",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"ROUND",
								"BLACK"
							]
						],
						"value": "MSITPLUSRD-BK.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"MATTE_BLACK"
							]
						],
						"value": "MSITPLUSRD-MB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"WHITE"
							]
						],
						"value": "MSITPLUSRD-WH.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"POLISHED_CHROME"
							]
						],
						"value": "MSITPLUSRD-PC.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"BRUSHED_BRONZE"
							]
						],
						"value": "MSITPLUSRD-BB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"BRUSHED_NICKEL"
							]
						],
						"value": "MSITPLUSRD-BN.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "MSITPLUSRD-ORB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"POLISHED_BRASS"
							]
						],
						"value": "MSITPLUSRD-PB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"POLISHED_NICKEL"
							]
						],
						"value": "MSITPLUSRD-PN.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"SATIN_BRASS"
							]
						],
						"value": "MSITPLUSRD-SB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"Raw"
							]
						],
						"value": "MSITPLUSRD-RAW.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"BLACK"
							]
						],
						"value": "MSITPLUSSQ-BK.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"MATTE_BLACK"
							]
						],
						"value": "MSITPLUSSQ-MB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"WHITE"
							]
						],
						"value": "MSITPLUSSQ-WH.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"POLISHED_CHROME"
							]
						],
						"value": "MSITPLUSSQ-PC.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"BRUSHED_BRONZE"
							]
						],
						"value": "MSITPLUSSQ-BB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"BRUSHED_NICKEL"
							]
						],
						"value": "MSITPLUSSQ-BN.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "MSITPLUSSQ-ORB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"POLISHED_BRASS"
							]
						],
						"value": "MSITPLUSSQ-PB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"POLISHED_NICKEL"
							]
						],
						"value": "MSITPLUSSQ-PN.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"SATIN_BRASS"
							]
						],
						"value": "MSITPLUSSQ-SB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"RAW"
							]
						],
						"value": "MSITPLUSSQ-RAW.jpg"
					}
				]
			},
			"descriptions.parts": {
				"keyTemplate": [
					"options.selected.shape",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"ROUND",
								"BLACK"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"MATTE_BLACK"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"WHITE"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"SATIN_BRASS"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"RAW"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"BLACK"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"MATTE_BLACK"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"WHITE"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"SATIN_BRASS"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"RAW"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>iTempo SteamHead</li>"
					}
				]
			},
			"partnumber": {
				"keyTemplate": [
					"options.selected.shape",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"ROUND",
								"BLACK"
							]
						],
						"value": "MSITPLUSRD-BK"
					},
					{
						"tally": [
							[
								"ROUND",
								"MATTE_BLACK"
							]
						],
						"value": "MSITPLUSRD-MB"
					},
					{
						"tally": [
							[
								"ROUND",
								"WHITE"
							]
						],
						"value": "MSITPLUSRD-WH"
					},
					{
						"tally": [
							[
								"ROUND",
								"POLISHED_CHROME"
							]
						],
						"value": "MSITPLUSRD-PC"
					},
					{
						"tally": [
							[
								"ROUND",
								"BRUSHED_BRONZE"
							]
						],
						"value": "MSITPLUSRD-BB"
					},
					{
						"tally": [
							[
								"ROUND",
								"BRUSHED_NICKEL"
							]
						],
						"value": "MSITPLUSRD-BN"
					},
					{
						"tally": [
							[
								"ROUND",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "MSITPLUSRD-ORB"
					},
					{
						"tally": [
							[
								"ROUND",
								"POLISHED_BRASS"
							]
						],
						"value": "MSITPLUSRD-PB"
					},
					{
						"tally": [
							[
								"ROUND",
								"POLISHED_NICKEL"
							]
						],
						"value": "MSITPLUSRD-PN"
					},
					{
						"tally": [
							[
								"ROUND",
								"SATIN_BRASS"
							]
						],
						"value": "MSITPLUSRD-SB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"BLACK"
							]
						],
						"value": "MSITPLUSSQ-BK"
					},
					{
						"tally": [
							[
								"SQUARE",
								"MATTE_BLACK"
							]
						],
						"value": "MSITPLUSSQ-MB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"WHITE"
							]
						],
						"value": "MSITPLUSSQ-WH"
					},
					{
						"tally": [
							[
								"SQUARE",
								"POLISHED_CHROME"
							]
						],
						"value": "MSITPLUSSQ-PC"
					},
					{
						"tally": [
							[
								"SQUARE",
								"BRUSHED_BRONZE"
							]
						],
						"value": "MSITPLUSSQ-BB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"BRUSHED_NICKEL"
							]
						],
						"value": "MSITPLUSSQ-BN"
					},
					{
						"tally": [
							[
								"SQUARE",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "MSITPLUSSQ-ORB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"POLISHED_BRASS"
							]
						],
						"value": "MSITPLUSSQ-PB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"POLISHED_NICKEL"
							]
						],
						"value": "MSITPLUSSQ-PN"
					},
					{
						"tally": [
							[
								"SQUARE",
								"SATIN_BRASS"
							]
						],
						"value": "MSITPLUSSQ-SB"
					}
				]
			},
			"links.tech": {
				"keyTemplate": [
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								null
							],
							[
								"MS90EC1"
							],
							[
								"MS150EC1"
							],
							[
								"MS225EC1"
							],
							[
								"MS400EC1"
							]
						],
						"value": "http://prodrep.mrsteam.com/DocumentResources/b759ed5f-4528-45f1-b6f1-e22967c9f281.pdf"
					},
					{
						"tally": [
							[
								"MSSUPER1EC1"
							],
							[
								"MSSUPER2EC1"
							],
							[
								"MSSUPER3EC1"
							],
							[
								"MX4EC1"
							],
							[
								"MX5EC1"
							],
							[
								"MX6EC1"
							]
						],
						"value": "http://prodrep.mrsteam.com/DocumentResources/b759ed5f-4528-45f1-b6f1-e22967c9f281.pdf"
					}
				]
			},
			"price": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"POLISHED_CHROME"
							]
						],
						"value": 1450
					},
					{
						"tally": [
							[
								"BRUSHED_BRONZE"
							],
							[
								"BRUSHED_NICKEL"
							],
							[
								"OIL_RUBBED_BRONZE"
							],
							[
								"POLISHED_BRASS"
							],
							[
								"POLISHED_NICKEL"
							],
							[
								"SATIN_BRASS"
							],
							[
								"WHITE"
							],
							[
								"MATTE_BLACK"
							],
							[
								"BLACK"
							],
							[
								"RAW"
							]
						],
						"value": 1600
					}
				]
			},
			"package.config.dynamicProducts.selectedGenerator": {
				"keyTemplate": [
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								null
							],
							[
								"MS90EC1"
							],
							[
								"MS150EC1"
							],
							[
								"MS225EC1"
							],
							[
								"MS400EC1"
							]
						],
						"value": [
							{
								"productId": "ITEMPO_STEAMHEAD",
								"quantity": 1
							}
						]
					},
					{
						"tally": [
							[
								"MSSUPER1EC1"
							],
							[
								"MSSUPER2EC1"
							],
							[
								"MSSUPER3EC1"
							],
							[
								"MX4EC1"
							],
							[
								"MX5EC1"
							],
							[
								"MX6EC1"
							]
						],
						"value": [
							{
								"productId": "ITEMPO_STEAMHEAD",
								"quantity": 2
							}
						]
					}
				]
			}
		},
		"package": {
			"config": {
				"staticProducts": [
					{
						"productId": "ITEMPO_CONTROL",
						"quantity": 1
					}
				]
			}
		},
		"vSpa": {
			"spaFrameSourceOption": "finish",
			"spaFrameIsVisible": true,
			"standardGeneratorIsVisible": true,
			"isSuperCompatible": true
		}
	},
	{
		"code": "ITEMPO_CONTROL",
		"partnumber": "MSITEMPO",
		"name": "iTempo Plus Control",
		"previewname": "iTempo Plus Control",
		"descriptions": {
			"long": "With the flush-moutned iTempoPlus Control, your steam system can be seamless. Command more than just steam on this user-friendly interface. Easily add AromaSteam and ChromaSteam capabilities from this sleek control. It has never been easier to optimize your steam shower experience.",
			"tech": "<li>Comes with matching Aroma Designer Finish Steamhead</li><li>Display lets you program temperature and get comfortable</li><li>Easily mount and install your control snug to the wall</li><li>Operates with optional wireless SteamLinx Module</li><li>Use your smartphone or mobile device to control your steam shower</li><li>Works with Steamlinx module and mobile app</li>"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/b2810ea7-b57e-409a-ad8a-f542851f66be.pdf"
		},
		"images": {
			"thumbnail": "MSITEMPOSQ-PC.jpg",
			"folder": "individual-controls/iTempo/",
			"scene": "iTempo-Control-Square.png"
		},
		"options": {
			"enabledListsIds": [
				"shape",
				"finish"
			],
			"selected": {
				"shape": "SQUARE",
				"finish": "POLISHED_CHROME"
			},
			"list": {
				"shape": [
					"SQUARE",
					"ROUND"
				],
				"finish": [
					"POLISHED_CHROME",
					"BRUSHED_BRONZE",
					"BRUSHED_NICKEL",
					"OIL_RUBBED_BRONZE",
					"POLISHED_BRASS",
					"POLISHED_NICKEL",
					"SATIN_BRASS",
					"MATTE_BLACK",
					"BLACK",
					"WHITE",
					"RAW"
				]
			}
		},
		"dynamicProperties": {
			"images.scene": {
				"keyTemplate": [
					"options.selected.shape",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"ROUND",
								"BLACK"
							]
						],
						"value": "iTempo-Control-Round-Black.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"MATTE_BLACK"
							]
						],
						"value": "iTempo-Control-Round-Black.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"WHITE"
							]
						],
						"value": "iTempo-Control-Round-White.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"POLISHED_CHROME"
							]
						],
						"value": "iTempo-Control-Round-PolishedChrome.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"BRUSHED_BRONZE"
							]
						],
						"value": "iTempo-Control-Round-BrushedBronze.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"BRUSHED_NICKEL"
							]
						],
						"value": "iTempo-Control-Round-BrushedNickel.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "iTempo-Control-Round-OilRubbedBronze.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"POLISHED_BRASS"
							]
						],
						"value": "iTempo-Control-Round-PolishedBrass.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"POLISHED_NICKEL"
							]
						],
						"value": "iTempo-Control-Round-PolishedNickel.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"SATIN_BRASS"
							]
						],
						"value": "iTempo-Control-Round-SatinBrass.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"RAW"
							]
						],
						"value": "iTempo-Control-Round-SatinBrass.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"BLACK"
							]
						],
						"value": "iTempo-Control-Square-Black.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"MATTE_BLACK"
							]
						],
						"value": "iTempo-Control-Square-Black.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"WHITE"
							]
						],
						"value": "iTempo-Control-Square-White.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"POLISHED_CHROME"
							]
						],
						"value": "iTempo-Control-Square-PolishedChrome.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"BRUSHED_BRONZE"
							]
						],
						"value": "iTempo-Control-Square-BrushedBronze.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"BRUSHED_NICKEL"
							]
						],
						"value": "iTempo-Control-Square-BrushedNickel.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "iTempo-Control-Square-OilRubbedBronze.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"POLISHED_BRASS"
							]
						],
						"value": "iTempo-Control-Square-PolishedBrass.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"POLISHED_NICKEL"
							]
						],
						"value": "iTempo-Control-Square-PolishedNickel.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"SATIN_BRASS"
							]
						],
						"value": "iTempo-Control-Square-SatinBrass.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"RAW"
							]
						],
						"value": "iTempo-Control-Square-SatinBrass.png"
					}
				]
			}
		},
		"tooltips": {
			"list": [
				{
					"top": 50,
					"left": 69.5,
					"width": 4.5,
					"height": 6
				}
			]
		}
	},
	{
		"code": "ITEMPO_STEAMHEAD",
		"partnumber": "MSITEMPO STEAMHEAD",
		"previewname": "iTempo SteamHead",
		"name": "iTempo SteamHead",
		"descriptions": {
			"long": "We're passionate about steam, so we invest in every detail of our steam shower products. All of our steamheads leave a lasting visual imprint in any shower space. They provide a steam dispersion that has no moving parts, require no field assembly, and simple installation that matches any interior. Each of our steamhead designs will transform your shower giving you the atmosphere you desire-making steam second nature to your wellbeing.</LI>",
			"tech": "<li>Features oil reservoir for aroma therapy</li><li>Sleek black or white glass face complements the look of our glass face controls. It comes standard with glass face controls</li><li>No assembly of moving parts required</li><li>Standard with glass finish controls</li><li>Available in 7 metal trim finishes to match your control selection</li>"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/c48bdca4-da11-43ca-9a63-73a5bb12bf28.pdf"
		},
		"images": {
			"thumbnail": "itempo_steamhead.jpg",
			"folder": "individual-controls/iTempo/",
			"scene": "iTempo-SteamHead-Black.png"
		},
		"options": {
			"enabledListsIds": [
				"shape",
				"finish"
			],
			"selected": {
				"shape": "SQUARE",
				"finish": "POLISHED_CHROME"
			},
			"list": {
				"shape": [
					"SQUARE",
					"ROUND"
				],
				"finish": [
					"POLISHED_CHROME",
					"BRUSHED_BRONZE",
					"BRUSHED_NICKEL",
					"OIL_RUBBED_BRONZE",
					"POLISHED_BRASS",
					"POLISHED_NICKEL",
					"SATIN_BRASS",
					"BLACK",
					"MATTE_BLACK",
					"WHITE",
					"RAW"
				]
			}
		},
		"dynamicProperties": {
			"images.scene": {
				"keyTemplate": [
					"options.selected.shape",
					"options.selected.finish",
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								"SQUARE",
								"BLACK",
								null
							],
							[
								"SQUARE",
								"BLACK",
								"MS90EC1"
							],
							[
								"SQUARE",
								"BLACK",
								"MS150EC1"
							],
							[
								"SQUARE",
								"BLACK",
								"MS225EC1"
							],
							[
								"SQUARE",
								"BLACK",
								"MS400EC1"
							],
							[
								"SQUARE",
								"BLACK",
								"MSSUPER1EC1"
							],
							[
								"SQUARE",
								"BLACK",
								"MSSUPER2EC1"
							],
							[
								"SQUARE",
								"BLACK",
								"MSSUPER3EC1"
							]
						],
						"value": "iTempo-SteamHead-Square-Black.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"MATTE_BLACK",
								null
							],
							[
								"SQUARE",
								"MATTE_BLACK",
								"MS90EC1"
							],
							[
								"SQUARE",
								"MATTE_BLACK",
								"MS150EC1"
							],
							[
								"SQUARE",
								"MATTE_BLACK",
								"MS225EC1"
							],
							[
								"SQUARE",
								"MATTE_BLACK",
								"MS400EC1"
							],
							[
								"SQUARE",
								"MATTE_BLACK",
								"MSSUPER1EC1"
							],
							[
								"SQUARE",
								"MATTE_BLACK",
								"MSSUPER2EC1"
							],
							[
								"SQUARE",
								"MATTE_BLACK",
								"MSSUPER3EC1"
							]
						],
						"value": "iTempo-SteamHead-Square-Black.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"WHITE",
								null
							],
							[
								"SQUARE",
								"WHITE",
								"MS90EC1"
							],
							[
								"SQUARE",
								"WHITE",
								"MS150EC1"
							],
							[
								"SQUARE",
								"WHITE",
								"MS225EC1"
							],
							[
								"SQUARE",
								"WHITE",
								"MS400EC1"
							],
							[
								"SQUARE",
								"WHITE",
								"MSSUPER1EC1"
							],
							[
								"SQUARE",
								"WHITE",
								"MSSUPER2EC1"
							],
							[
								"SQUARE",
								"WHITE",
								"MSSUPER3EC1"
							]
						],
						"value": "iTempo-SteamHead-Square-White.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"POLISHED_CHROME",
								null
							],
							[
								"SQUARE",
								"POLISHED_CHROME",
								"MS90EC1"
							],
							[
								"SQUARE",
								"POLISHED_CHROME",
								"MS150EC1"
							],
							[
								"SQUARE",
								"POLISHED_CHROME",
								"MS225EC1"
							],
							[
								"SQUARE",
								"POLISHED_CHROME",
								"MS400EC1"
							],
							[
								"SQUARE",
								"POLISHED_CHROME",
								"MSSUPER1EC1"
							],
							[
								"SQUARE",
								"POLISHED_CHROME",
								"MSSUPER2EC1"
							],
							[
								"SQUARE",
								"POLISHED_CHROME",
								"MSSUPER3EC1"
							]
						],
						"value": "iTempo-SteamHead-Square-PolishedChrome.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"BRUSHED_BRONZE",
								null
							],
							[
								"SQUARE",
								"BRUSHED_BRONZE",
								"MS90EC1"
							],
							[
								"SQUARE",
								"BRUSHED_BRONZE",
								"MS150EC1"
							],
							[
								"SQUARE",
								"BRUSHED_BRONZE",
								"MS225EC1"
							],
							[
								"SQUARE",
								"BRUSHED_BRONZE",
								"MS400EC1"
							],
							[
								"SQUARE",
								"BRUSHED_BRONZE",
								"MSSUPER1EC1"
							],
							[
								"SQUARE",
								"BRUSHED_BRONZE",
								"MSSUPER2EC1"
							],
							[
								"SQUARE",
								"BRUSHED_BRONZE",
								"MSSUPER3EC1"
							]
						],
						"value": "iTempo-SteamHead-Square-BrushedBronze.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"BRUSHED_NICKEL",
								null
							],
							[
								"SQUARE",
								"BRUSHED_NICKEL",
								"MS90EC1"
							],
							[
								"SQUARE",
								"BRUSHED_NICKEL",
								"MS150EC1"
							],
							[
								"SQUARE",
								"BRUSHED_NICKEL",
								"MS225EC1"
							],
							[
								"SQUARE",
								"BRUSHED_NICKEL",
								"MS400EC1"
							],
							[
								"SQUARE",
								"BRUSHED_NICKEL",
								"MSSUPER1EC1"
							],
							[
								"SQUARE",
								"BRUSHED_NICKEL",
								"MSSUPER2EC1"
							],
							[
								"SQUARE",
								"BRUSHED_NICKEL",
								"MSSUPER3EC1"
							]
						],
						"value": "iTempo-SteamHead-Square-BrushedNickel.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"OIL_RUBBED_BRONZE",
								null
							],
							[
								"SQUARE",
								"OIL_RUBBED_BRONZE",
								"MS90EC1"
							],
							[
								"SQUARE",
								"OIL_RUBBED_BRONZE",
								"MS150EC1"
							],
							[
								"SQUARE",
								"OIL_RUBBED_BRONZE",
								"MS225EC1"
							],
							[
								"SQUARE",
								"OIL_RUBBED_BRONZE",
								"MS400EC1"
							],
							[
								"SQUARE",
								"OIL_RUBBED_BRONZE",
								"MSSUPER1EC1"
							],
							[
								"SQUARE",
								"OIL_RUBBED_BRONZE",
								"MSSUPER2EC1"
							],
							[
								"SQUARE",
								"OIL_RUBBED_BRONZE",
								"MSSUPER3EC1"
							]
						],
						"value": "iTempo-SteamHead-Square-OilRubbedBronze.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"POLISHED_BRASS",
								null
							],
							[
								"SQUARE",
								"POLISHED_BRASS",
								"MS90EC1"
							],
							[
								"SQUARE",
								"POLISHED_BRASS",
								"MS150EC1"
							],
							[
								"SQUARE",
								"POLISHED_BRASS",
								"MS225EC1"
							],
							[
								"SQUARE",
								"POLISHED_BRASS",
								"MS400EC1"
							],
							[
								"SQUARE",
								"POLISHED_BRASS",
								"MSSUPER1EC1"
							],
							[
								"SQUARE",
								"POLISHED_BRASS",
								"MSSUPER2EC1"
							],
							[
								"SQUARE",
								"POLISHED_BRASS",
								"MSSUPER3EC1"
							]
						],
						"value": "iTempo-SteamHead-Square-PolishedBrass.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"POLISHED_NICKEL",
								null
							],
							[
								"SQUARE",
								"POLISHED_NICKEL",
								"MS90EC1"
							],
							[
								"SQUARE",
								"POLISHED_NICKEL",
								"MS150EC1"
							],
							[
								"SQUARE",
								"POLISHED_NICKEL",
								"MS225EC1"
							],
							[
								"SQUARE",
								"POLISHED_NICKEL",
								"MS400EC1"
							],
							[
								"SQUARE",
								"POLISHED_NICKEL",
								"MSSUPER1EC1"
							],
							[
								"SQUARE",
								"POLISHED_NICKEL",
								"MSSUPER2EC1"
							],
							[
								"SQUARE",
								"POLISHED_NICKEL",
								"MSSUPER3EC1"
							]
						],
						"value": "iTempo-SteamHead-Square-PolishedNickel.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"SATIN_BRASS",
								null
							],
							[
								"SQUARE",
								"SATIN_BRASS",
								"MS90EC1"
							],
							[
								"SQUARE",
								"SATIN_BRASS",
								"MS150EC1"
							],
							[
								"SQUARE",
								"SATIN_BRASS",
								"MS225EC1"
							],
							[
								"SQUARE",
								"SATIN_BRASS",
								"MS400EC1"
							],
							[
								"SQUARE",
								"SATIN_BRASS",
								"MSSUPER1EC1"
							],
							[
								"SQUARE",
								"SATIN_BRASS",
								"MSSUPER2EC1"
							],
							[
								"SQUARE",
								"SATIN_BRASS",
								"MSSUPER3EC1"
							]
						],
						"value": "iTempo-SteamHead-Square-SatinBrass.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"RAW",
								null
							],
							[
								"SQUARE",
								"RAW",
								"MS90EC1"
							],
							[
								"SQUARE",
								"RAW",
								"MS150EC1"
							],
							[
								"SQUARE",
								"RAW",
								"MS225EC1"
							],
							[
								"SQUARE",
								"RAW",
								"MS400EC1"
							],
							[
								"SQUARE",
								"RAW",
								"MSSUPER1EC1"
							],
							[
								"SQUARE",
								"RAW",
								"MSSUPER2EC1"
							],
							[
								"SQUARE",
								"RAW",
								"MSSUPER3EC1"
							]
						],
						"value": "iTempo-SteamHead-Square-SatinBrass.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"BLACK",
								null
							],
							[
								"ROUND",
								"BLACK",
								"MS90EC1"
							],
							[
								"ROUND",
								"BLACK",
								"MS150EC1"
							],
							[
								"ROUND",
								"BLACK",
								"MS225EC1"
							],
							[
								"ROUND",
								"BLACK",
								"MS400EC1"
							],
							[
								"ROUND",
								"BLACK",
								"MSSUPER1EC1"
							],
							[
								"ROUND",
								"BLACK",
								"MSSUPER2EC1"
							],
							[
								"ROUND",
								"BLACK",
								"MSSUPER3EC1"
							]
						],
						"value": "iTempo-SteamHead-Round-PolishedChrome.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"MATTE_BLACK",
								null
							],
							[
								"ROUND",
								"MATTE_BLACK",
								"MS90EC1"
							],
							[
								"ROUND",
								"MATTE_BLACK",
								"MS150EC1"
							],
							[
								"ROUND",
								"MATTE_BLACK",
								"MS225EC1"
							],
							[
								"ROUND",
								"MATTE_BLACK",
								"MS400EC1"
							],
							[
								"ROUND",
								"MATTE_BLACK",
								"MSSUPER1EC1"
							],
							[
								"ROUND",
								"MATTE_BLACK",
								"MSSUPER2EC1"
							],
							[
								"ROUND",
								"MATTE_BLACK",
								"MSSUPER3EC1"
							]
						],
						"value": "iTempo-SteamHead-Round-PolishedChrome.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"WHITE",
								null
							],
							[
								"ROUND",
								"WHITE",
								"MS90EC1"
							],
							[
								"ROUND",
								"WHITE",
								"MS150EC1"
							],
							[
								"ROUND",
								"WHITE",
								"MS225EC1"
							],
							[
								"ROUND",
								"WHITE",
								"MS400EC1"
							],
							[
								"ROUND",
								"WHITE",
								"MSSUPER1EC1"
							],
							[
								"ROUND",
								"WHITE",
								"MSSUPER2EC1"
							],
							[
								"ROUND",
								"WHITE",
								"MSSUPER3EC1"
							]
						],
						"value": "iTempo-SteamHead-Round-PolishedChrome.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"POLISHED_CHROME",
								null
							],
							[
								"ROUND",
								"POLISHED_CHROME",
								"MS90EC1"
							],
							[
								"ROUND",
								"POLISHED_CHROME",
								"MS150EC1"
							],
							[
								"ROUND",
								"POLISHED_CHROME",
								"MS225EC1"
							],
							[
								"ROUND",
								"POLISHED_CHROME",
								"MS400EC1"
							],
							[
								"ROUND",
								"POLISHED_CHROME",
								"MSSUPER1EC1"
							],
							[
								"ROUND",
								"POLISHED_CHROME",
								"MSSUPER2EC1"
							],
							[
								"ROUND",
								"POLISHED_CHROME",
								"MSSUPER3EC1"
							]
						],
						"value": "iTempo-SteamHead-Round-PolishedChrome.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"BRUSHED_BRONZE",
								null
							],
							[
								"ROUND",
								"BRUSHED_BRONZE",
								"MS90EC1"
							],
							[
								"ROUND",
								"BRUSHED_BRONZE",
								"MS150EC1"
							],
							[
								"ROUND",
								"BRUSHED_BRONZE",
								"MS225EC1"
							],
							[
								"ROUND",
								"BRUSHED_BRONZE",
								"MS400EC1"
							],
							[
								"ROUND",
								"BRUSHED_BRONZE",
								"MSSUPER1EC1"
							],
							[
								"ROUND",
								"BRUSHED_BRONZE",
								"MSSUPER2EC1"
							],
							[
								"ROUND",
								"BRUSHED_BRONZE",
								"MSSUPER3EC1"
							]
						],
						"value": "iTempo-SteamHead-Round-BrushedBronze.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"BRUSHED_NICKEL",
								null
							],
							[
								"ROUND",
								"BRUSHED_NICKEL",
								"MS90EC1"
							],
							[
								"ROUND",
								"BRUSHED_NICKEL",
								"MS150EC1"
							],
							[
								"ROUND",
								"BRUSHED_NICKEL",
								"MS225EC1"
							],
							[
								"ROUND",
								"BRUSHED_NICKEL",
								"MS400EC1"
							],
							[
								"ROUND",
								"BRUSHED_NICKEL",
								"MSSUPER1EC1"
							],
							[
								"ROUND",
								"BRUSHED_NICKEL",
								"MSSUPER2EC1"
							],
							[
								"ROUND",
								"BRUSHED_NICKEL",
								"MSSUPER3EC1"
							]
						],
						"value": "iTempo-SteamHead-Round-BrushedNickel.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"OIL_RUBBED_BRONZE",
								null
							],
							[
								"ROUND",
								"OIL_RUBBED_BRONZE",
								"MS90EC1"
							],
							[
								"ROUND",
								"OIL_RUBBED_BRONZE",
								"MS150EC1"
							],
							[
								"ROUND",
								"OIL_RUBBED_BRONZE",
								"MS225EC1"
							],
							[
								"ROUND",
								"OIL_RUBBED_BRONZE",
								"MS400EC1"
							],
							[
								"ROUND",
								"OIL_RUBBED_BRONZE",
								"MSSUPER1EC1"
							],
							[
								"ROUND",
								"OIL_RUBBED_BRONZE",
								"MSSUPER2EC1"
							],
							[
								"ROUND",
								"OIL_RUBBED_BRONZE",
								"MSSUPER3EC1"
							]
						],
						"value": "iTempo-SteamHead-Round-OilRubbedBronze.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"POLISHED_BRASS",
								null
							],
							[
								"ROUND",
								"POLISHED_BRASS",
								"MS90EC1"
							],
							[
								"ROUND",
								"POLISHED_BRASS",
								"MS150EC1"
							],
							[
								"ROUND",
								"POLISHED_BRASS",
								"MS225EC1"
							],
							[
								"ROUND",
								"POLISHED_BRASS",
								"MS400EC1"
							],
							[
								"ROUND",
								"POLISHED_BRASS",
								"MSSUPER1EC1"
							],
							[
								"ROUND",
								"POLISHED_BRASS",
								"MSSUPER2EC1"
							],
							[
								"ROUND",
								"POLISHED_BRASS",
								"MSSUPER3EC1"
							]
						],
						"value": "iTempo-SteamHead-Round-PolishedBrass.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"POLISHED_NICKEL",
								null
							],
							[
								"ROUND",
								"POLISHED_NICKEL",
								"MS90EC1"
							],
							[
								"ROUND",
								"POLISHED_NICKEL",
								"MS150EC1"
							],
							[
								"ROUND",
								"POLISHED_NICKEL",
								"MS225EC1"
							],
							[
								"ROUND",
								"POLISHED_NICKEL",
								"MS400EC1"
							],
							[
								"ROUND",
								"POLISHED_NICKEL",
								"MSSUPER1EC1"
							],
							[
								"ROUND",
								"POLISHED_NICKEL",
								"MSSUPER2EC1"
							],
							[
								"ROUND",
								"POLISHED_NICKEL",
								"MSSUPER3EC1"
							]
						],
						"value": "iTempo-SteamHead-Round-PolishedNickel.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"SATIN_BRASS",
								null
							],
							[
								"ROUND",
								"SATIN_BRASS",
								"MS90EC1"
							],
							[
								"ROUND",
								"SATIN_BRASS",
								"MS150EC1"
							],
							[
								"ROUND",
								"SATIN_BRASS",
								"MS225EC1"
							],
							[
								"ROUND",
								"SATIN_BRASS",
								"MS400EC1"
							],
							[
								"ROUND",
								"SATIN_BRASS",
								"MSSUPER1EC1"
							],
							[
								"ROUND",
								"SATIN_BRASS",
								"MSSUPER2EC1"
							],
							[
								"ROUND",
								"SATIN_BRASS",
								"MSSUPER3EC1"
							]
						],
						"value": "iTempo-SteamHead-Round-SatinBrass.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"RAW",
								null
							],
							[
								"ROUND",
								"RAW",
								"MS90EC1"
							],
							[
								"ROUND",
								"RAW",
								"MS150EC1"
							],
							[
								"ROUND",
								"RAW",
								"MS225EC1"
							],
							[
								"ROUND",
								"RAW",
								"MS400EC1"
							],
							[
								"ROUND",
								"RAW",
								"MSSUPER1EC1"
							],
							[
								"ROUND",
								"RAW",
								"MSSUPER2EC1"
							],
							[
								"ROUND",
								"RAW",
								"MSSUPER3EC1"
							]
						],
						"value": "iTempo-SteamHead-Round-SatinBrass.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"BLACK",
								"MX4EC1"
							],
							[
								"SQUARE",
								"BLACK",
								"MX5EC1"
							],
							[
								"SQUARE",
								"BLACK",
								"MX6EC1"
							]
						],
						"value": "iTempo-SteamHead-Square-Black-Double.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"MATTE_BLACK",
								"MX4EC1"
							],
							[
								"SQUARE",
								"MATTE_BLACK",
								"MX5EC1"
							],
							[
								"SQUARE",
								"MATTE_BLACK",
								"MX6EC1"
							]
						],
						"value": "iTempo-SteamHead-Square-Black-Double.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"WHITE",
								"MX4EC1"
							],
							[
								"SQUARE",
								"WHITE",
								"MX5EC1"
							],
							[
								"SQUARE",
								"WHITE",
								"MX6EC1"
							]
						],
						"value": "iTempo-SteamHead-Square-White-Double.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"POLISHED_CHROME",
								"MX4EC1"
							],
							[
								"SQUARE",
								"POLISHED_CHROME",
								"MX5EC1"
							],
							[
								"SQUARE",
								"POLISHED_CHROME",
								"MX6EC1"
							]
						],
						"value": "iTempo-SteamHead-Square-PolishedChrome-Double.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"BRUSHED_BRONZE",
								"MX4EC1"
							],
							[
								"SQUARE",
								"BRUSHED_BRONZE",
								"MX5EC1"
							],
							[
								"SQUARE",
								"BRUSHED_BRONZE",
								"MX6EC1"
							]
						],
						"value": "iTempo-SteamHead-Square-BrushedBronze-Double.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"BRUSHED_NICKEL",
								"MX4EC1"
							],
							[
								"SQUARE",
								"BRUSHED_NICKEL",
								"MX5EC1"
							],
							[
								"SQUARE",
								"BRUSHED_NICKEL",
								"MX6EC1"
							]
						],
						"value": "iTempo-SteamHead-Square-BrushedNickel-Double.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"OIL_RUBBED_BRONZE",
								"MX4EC1"
							],
							[
								"SQUARE",
								"OIL_RUBBED_BRONZE",
								"MX5EC1"
							],
							[
								"SQUARE",
								"OIL_RUBBED_BRONZE",
								"MX6EC1"
							]
						],
						"value": "iTempo-SteamHead-Square-OilRubbedBronze-Double.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"POLISHED_BRASS",
								"MX4EC1"
							],
							[
								"SQUARE",
								"POLISHED_BRASS",
								"MX5EC1"
							],
							[
								"SQUARE",
								"POLISHED_BRASS",
								"MX6EC1"
							]
						],
						"value": "iTempo-SteamHead-Square-PolishedBrass-Double.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"POLISHED_NICKEL",
								"MX4EC1"
							],
							[
								"SQUARE",
								"POLISHED_NICKEL",
								"MX5EC1"
							],
							[
								"SQUARE",
								"POLISHED_NICKEL",
								"MX6EC1"
							]
						],
						"value": "iTempo-SteamHead-Square-PolishedNickel-Double.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"SATIN_BRASS",
								"MX4EC1"
							],
							[
								"SQUARE",
								"SATIN_BRASS",
								"MX5EC1"
							],
							[
								"SQUARE",
								"SATIN_BRASS",
								"MX6EC1"
							]
						],
						"value": "iTempo-SteamHead-Square-SatinBrass-Double.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"RAW",
								"MX4EC1"
							],
							[
								"SQUARE",
								"RAW",
								"MX5EC1"
							],
							[
								"SQUARE",
								"RAW",
								"MX6EC1"
							]
						],
						"value": "iTempo-SteamHead-Square-SatinBrass-Double.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"WHITE",
								"MX4EC1"
							],
							[
								"ROUND",
								"WHITE",
								"MX5EC1"
							],
							[
								"ROUND",
								"WHITE",
								"MX6EC1"
							]
						],
						"value": "iTempo-SteamHead-Round-PolishedChrome-Double.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"BLACK",
								"MX4EC1"
							],
							[
								"ROUND",
								"BLACK",
								"MX5EC1"
							],
							[
								"ROUND",
								"BLACK",
								"MX6EC1"
							]
						],
						"value": "iTempo-SteamHead-Round-PolishedChrome-Double.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"MATTE_BLACK",
								"MX4EC1"
							],
							[
								"ROUND",
								"MATTE_BLACK",
								"MX5EC1"
							],
							[
								"ROUND",
								"MATTE_BLACK",
								"MX6EC1"
							]
						],
						"value": "iTempo-SteamHead-Round-PolishedChrome-Double.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"POLISHED_CHROME",
								"MX4EC1"
							],
							[
								"ROUND",
								"POLISHED_CHROME",
								"MX5EC1"
							],
							[
								"ROUND",
								"POLISHED_CHROME",
								"MX6EC1"
							]
						],
						"value": "iTempo-SteamHead-Round-PolishedChrome-Double.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"BRUSHED_BRONZE",
								"MX4EC1"
							],
							[
								"ROUND",
								"BRUSHED_BRONZE",
								"MX5EC1"
							],
							[
								"ROUND",
								"BRUSHED_BRONZE",
								"MX6EC1"
							]
						],
						"value": "iTempo-SteamHead-Round-BrushedBronze-Double.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"BRUSHED_NICKEL",
								"MX4EC1"
							],
							[
								"ROUND",
								"BRUSHED_NICKEL",
								"MX5EC1"
							],
							[
								"ROUND",
								"BRUSHED_NICKEL",
								"MX6EC1"
							]
						],
						"value": "iTempo-SteamHead-Round-BrushedNickel-Double.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"OIL_RUBBED_BRONZE",
								"MX4EC1"
							],
							[
								"ROUND",
								"OIL_RUBBED_BRONZE",
								"MX5EC1"
							],
							[
								"ROUND",
								"OIL_RUBBED_BRONZE",
								"MX6EC1"
							]
						],
						"value": "iTempo-SteamHead-Round-OilRubbedBronze-Double.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"POLISHED_BRASS",
								"MX4EC1"
							],
							[
								"ROUND",
								"POLISHED_BRASS",
								"MX5EC1"
							],
							[
								"ROUND",
								"POLISHED_BRASS",
								"MX6EC1"
							]
						],
						"value": "iTempo-SteamHead-Round-PolishedBrass-Double.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"POLISHED_NICKEL",
								"MX4EC1"
							],
							[
								"ROUND",
								"POLISHED_NICKEL",
								"MX5EC1"
							],
							[
								"ROUND",
								"POLISHED_NICKEL",
								"MX6EC1"
							]
						],
						"value": "iTempo-SteamHead-Round-PolishedNickel-Double.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"SATIN_BRASS",
								"MX4EC1"
							],
							[
								"ROUND",
								"SATIN_BRASS",
								"MX5EC1"
							],
							[
								"ROUND",
								"SATIN_BRASS",
								"MX6EC1"
							]
						],
						"value": "iTempo-SteamHead-Round-SatinBrass-Double.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"RAW",
								"MX4EC1"
							],
							[
								"ROUND",
								"RAW",
								"MX5EC1"
							],
							[
								"ROUND",
								"RAW",
								"MX6EC1"
							]
						],
						"value": "iTempo-SteamHead-Round-SatinBrass-Double.png"
					}
				]
			},
			"tooltips.list": {
				"keyTemplate": [
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								null
							],
							[
								"MS90EC1"
							],
							[
								"MS150EC1"
							],
							[
								"MS225EC1"
							],
							[
								"MS400EC1"
							]
						],
						"value": [
							{
								"top": 72.5,
								"left": 40,
								"width": 3,
								"height": 4
							}
						]
					},
					{
						"tally": [
							[
								"MSSUPER1EC1"
							],
							[
								"MSSUPER2EC1"
							],
							[
								"MSSUPER3EC1"
							],
							[
								"MX4EC1"
							],
							[
								"MX5EC1"
							],
							[
								"MX6EC1"
							]
						],
						"value": [
							{
								"top": 72.5,
								"left": 43.7,
								"width": 3,
								"height": 4,
								"orientation": "right"
							},
							{
								"top": 74.5,
								"left": 36.5,
								"width": 3,
								"height": 4,
								"orientation": "left"
							}
						]
					}
				]
			}
		},
		"tooltips": {
			"list": [
				{
					"top": 72.5,
					"left": 40,
					"width": 3,
					"height": 4
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false
		}
	},
	{
		"code": "ITEMPO_PACKAGE",
		"partnumber": "MSITEMPO",
		"previewname": "iTempo Control",
		"name": "iTempo Control",
		"price": 895,
		"descriptions": {
			"long": "The iTempo Control is simple, elegant, and easy to use. Forged from solid brass and available in your choice of 10 designer finishes, iTempo meshes seamlessly with any bathroom décor.",
			"tech": "<li>Easily mount and install your control snug to the wall</li><li>Use your smartphone or mobile device to control your steam shower</li><li>Whatever your preference, program your temperature and get comfortable</li><li>Operates with optional wireless SteamLinx™ Control</li>",
			"parts": "test"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/b2810ea7-b57e-409a-ad8a-f542851f66be.pdf"
		},
		"images": {
			"thumbnail": "MSITEMPOSQ-PC.jpg",
			"folder": "individual-controls/iTempo/"
		},
		"taxonomy": {
			"categories": [
				"itempo-controls"
			],
			"sortOrder": {
				"itempo-controls": 2
			},
			"zIndex": {
				"itempo-controls": 2
			}
		},
		"options": {
			"enabledListsIds": [
				"shape",
				"finish"
			],
			"selected": {
				"color": "BLACK",
				"shape": "SQUARE",
				"finish": "POLISHED_CHROME"
			},
			"list": {
				"shape": [
					"SQUARE",
					"ROUND"
				],
				"finish": [
					"POLISHED_CHROME",
					"BRUSHED_BRONZE",
					"BRUSHED_NICKEL",
					"OIL_RUBBED_BRONZE",
					"POLISHED_BRASS",
					"POLISHED_NICKEL",
					"SATIN_BRASS",
					"BLACK",
					"MATTE_BLACK",
					"WHITE",
					"RAW"
				]
			}
		},
		"dynamicProperties": {
			"images.thumbnail": {
				"keyTemplate": [
					"options.selected.shape",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"ROUND",
								"BLACK"
							]
						],
						"value": "MSITEMPORD-BK.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"MATTE_BLACK"
							]
						],
						"value": "MSITEMPORD-MB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"WHITE"
							]
						],
						"value": "MSITEMPORD-WH.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"POLISHED_CHROME"
							]
						],
						"value": "MSITEMPORD-PC.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"BRUSHED_BRONZE"
							]
						],
						"value": "MSITEMPORD-BB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"BRUSHED_NICKEL"
							]
						],
						"value": "MSITEMPORD-BN.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "MSITEMPORD-ORB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"POLISHED_BRASS"
							]
						],
						"value": "MSITEMPORD-PB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"POLISHED_NICKEL"
							]
						],
						"value": "MSITEMPORD-PN.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"SATIN_BRASS"
							]
						],
						"value": "MSITEMPORD-SB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"RAW"
							]
						],
						"value": "MSITEMPORD-RAW.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"BLACK"
							]
						],
						"value": "MSITEMPOSQ-BK.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"MATTE_BLACK"
							]
						],
						"value": "MSITEMPOSQ-MB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"WHITE"
							]
						],
						"value": "MSITEMPOSQ-WH.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"POLISHED_CHROME"
							]
						],
						"value": "MSITEMPOSQ-PC.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"BRUSHED_BRONZE"
							]
						],
						"value": "MSITEMPOSQ-BB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"BRUSHED_NICKEL"
							]
						],
						"value": "MSITEMPOSQ-BN.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "MSITEMPOSQ-ORB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"POLISHED_BRASS"
							]
						],
						"value": "MSITEMPOSQ-PB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"POLISHED_NICKEL"
							]
						],
						"value": "MSITEMPOSQ-PC.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"SATIN_BRASS"
							]
						],
						"value": "MSITEMPOSQ-SB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"RAW"
							]
						],
						"value": "MSITEMPOSQ-RAW.jpg"
					}
				]
			},
			"descriptions.parts": {
				"keyTemplate": [
					"options.selected.shape",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"ROUND",
								"BLACK"
							]
						],
						"value": "<li>iTempo Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"MATTE_BLACK"
							]
						],
						"value": "<li>iTempo Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"WHITE"
							]
						],
						"value": "<li>iTempo Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>iTempo Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>iTempo Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>iTempo Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>iTempo Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>iTempo Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>iTempo Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"SATIN_BRASS"
							]
						],
						"value": "<li>iTempo Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"RAW"
							]
						],
						"value": "<li>iTempo Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"BLACK"
							]
						],
						"value": "<li>iTempo Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"MATTE_BLACK"
							]
						],
						"value": "<li>iTempo Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"WHITE"
							]
						],
						"value": "<li>iTempo Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>iTempo Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>iTempo Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>iTempo Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>iTempo Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>iTempo Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>iTempo Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"SATIN_BRASS"
							]
						],
						"value": "<li>iTempo Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"RAW"
							]
						],
						"value": "<li>iTempo Control</li><li>iTempo SteamHead</li>"
					}
				]
			},
			"partnumber": {
				"keyTemplate": [
					"options.selected.shape",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"ROUND",
								"BLACK"
							]
						],
						"value": "MSITEMPORD-BK"
					},
					{
						"tally": [
							[
								"ROUND",
								"MATTE_BLACK"
							]
						],
						"value": "MSITEMPORD-MB"
					},
					{
						"tally": [
							[
								"ROUND",
								"WHITE"
							]
						],
						"value": "MSITEMPORD-WH"
					},
					{
						"tally": [
							[
								"ROUND",
								"POLISHED_CHROME"
							]
						],
						"value": "MSITEMPORD-PC"
					},
					{
						"tally": [
							[
								"ROUND",
								"BRUSHED_BRONZE"
							]
						],
						"value": "MSITEMPORD-BB"
					},
					{
						"tally": [
							[
								"ROUND",
								"BRUSHED_NICKEL"
							]
						],
						"value": "MSITEMPORD-BN"
					},
					{
						"tally": [
							[
								"ROUND",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "MSITEMPORD-ORB"
					},
					{
						"tally": [
							[
								"ROUND",
								"POLISHED_BRASS"
							]
						],
						"value": "MSITEMPORD-PB"
					},
					{
						"tally": [
							[
								"ROUND",
								"POLISHED_NICKEL"
							]
						],
						"value": "MSITEMPORD-PN"
					},
					{
						"tally": [
							[
								"ROUND",
								"SATIN_BRASS"
							]
						],
						"value": "MSITEMPORD-SB"
					},
					{
						"tally": [
							[
								"ROUND",
								"RAW"
							]
						],
						"value": "MSITEMPORD-RAW"
					},
					{
						"tally": [
							[
								"SQUARE",
								"BLACK"
							]
						],
						"value": "MSITEMPOSQ-BK"
					},
					{
						"tally": [
							[
								"SQUARE",
								"MATTE_BLACK"
							]
						],
						"value": "MSITEMPOSQ-MB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"WHITE"
							]
						],
						"value": "MSITEMPOSQ-WH"
					},
					{
						"tally": [
							[
								"SQUARE",
								"POLISHED_CHROME"
							]
						],
						"value": "MSITEMPOSQ-PC"
					},
					{
						"tally": [
							[
								"SQUARE",
								"BRUSHED_BRONZE"
							]
						],
						"value": "MSITEMPOSQ-BB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"BRUSHED_NICKEL"
							]
						],
						"value": "MSITEMPOSQ-BN"
					},
					{
						"tally": [
							[
								"SQUARE",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "MSITEMPOSQ-ORB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"POLISHED_BRASS"
							]
						],
						"value": "MSITEMPOSQ-PB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"POLISHED_NICKEL"
							]
						],
						"value": "MSITEMPOSQ-PN"
					},
					{
						"tally": [
							[
								"SQUARE",
								"SATIN_BRASS"
							]
						],
						"value": "MSITEMPOSQ-SB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"RAW"
							]
						],
						"value": "MSITEMPOSQ-RAW"
					}
				]
			},
			"price": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"POLISHED_CHROME"
							]
						],
						"value": 950
					},
					{
						"tally": [
							[
								"BRUSHED_BRONZE"
							]
						],
						"value": 1150
					},
					{
						"tally": [
							[
								"BRUSHED_NICKEL"
							]
						],
						"value": 1150
					},
					{
						"tally": [
							[
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": 1150
					},
					{
						"tally": [
							[
								"POLISHED_BRASS"
							]
						],
						"value": 1150
					},
					{
						"tally": [
							[
								"POLISHED_NICKEL"
							]
						],
						"value": 1150
					},
					{
						"tally": [
							[
								"SATIN_BRASS"
							]
						],
						"value": 1150
					},
					{
						"tally": [
							[
								"BLACK"
							]
						],
						"value": 1150
					},
					{
						"tally": [
							[
								"MATTE_BLACK"
							]
						],
						"value": 1150
					},
					{
						"tally": [
							[
								"WHITE"
							]
						],
						"value": 1150
					},
					{
						"tally": [
							[
								"RAW"
							]
						],
						"value": 1150
					}
				]
			}
		},
		"package": {
			"config": {
				"staticProducts": [
					{
						"productId": "ITEMPO_CONTROL",
						"quantity": 1
					},
					{
						"productId": "ITEMPO_STEAMHEAD",
						"quantity": 1
					}
				]
			}
		},
		"vSpa": {
			"spaFrameSourceOption": "finish",
			"spaFrameIsVisible": true,
			"standardGeneratorIsVisible": true,
			"isSuperCompatible": true
		}
	},
	{
		"code": "AUTOFLUSH",
		"partnumber": "MS81500E",
		"previewname": "AutoFlush",
		"name": "AutoFlush",
		"price": 515,
		"descriptions": {
			"short": "Autoflush for residential MS generators",
			"long": "Your steam generator is the most important component of your steam shower. Protect your investment with AutoFlush. AutoFlush® is a MrSteam exclusive product. It's an automatic self-cleaning system that promotes a long, healthy life for steam generators by automatically flushing the generator of sediment two hours after every steambath. We automate everything in the background, so no work is needed after every steam shower session. AutoFlush® assures that you get clean steam every time.",
			"tech": "<li>The system quietly flushes impurities through a ½\" electronically-activated valve - no small opening to clog</li><li>Automatically flushes old water and impurities from your steam generator after every session, no buttons to push to initiate draining</li><li>Impurities and old water are flushed through a ½\", electronically activated valve. You'll never experience a clog, and there's nothing to remember</li><li>Simple plug and play installation</li><li>Length-4.25\"</li><li>Width-5\"</li><li>Height-2.75\"</li><li>Weight-2 lbs</li>"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/7abd8ed4-8769-4dc7-baff-af9afcfeceea.pdf"
		},
		"images": {
			"thumbnail": "AutoFlush.jpg",
			"folder": "controls-accessories/",
			"scene": "AutoFlush.png"
		},
		"taxonomy": {
			"categories": [
				"controls-accessories"
			],
			"sortOrder": {
				"controls-accessories": 3
			},
			"zIndex": {
				"controls-accessories": 3
			}
		},
		"dynamicProperties": {
			"images.thumbnail": {
				"keyTemplate": [
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								null
							],
							[
								"MS90EC1"
							],
							[
								"MS150EC1"
							],
							[
								"MS225EC1"
							],
							[
								"MS400EC1"
							],
							[
								"MSSUPER1EC1"
							],
							[
								"MSSUPER2EC1"
							],
							[
								"MSSUPER3EC1"
							]
						],
						"value": "AutoFlush.jpg"
					},
					{
						"tally": [
							[
								"MX4EC1"
							],
							[
								"MX5EC1"
							],
							[
								"MX6EC1"
							]
						],
						"value": "autoflushmax.jpg"
					}
				]
			},
			"descriptions.short": {
				"keyTemplate": [
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								null
							],
							[
								"MS90EC1"
							],
							[
								"MS150EC1"
							],
							[
								"MS225EC1"
							],
							[
								"MS400EC1"
							],
							[
								"MSSUPER1EC1"
							],
							[
								"MSSUPER2EC1"
							],
							[
								"MSSUPER3EC1"
							]
						],
						"value": "Autoflush for residential MS generators"
					},
					{
						"tally": [
							[
								"MX4EC1"
							],
							[
								"MX5EC1"
							],
							[
								"MX6EC1"
							]
						],
						"value": "Max AutoFlush for Residential eSeries Max Generators"
					}
				]
			},
			"descriptions.long": {
				"keyTemplate": [
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								null
							],
							[
								"MS90EC1"
							],
							[
								"MS150EC1"
							],
							[
								"MS225EC1"
							],
							[
								"MS400EC1"
							],
							[
								"MSSUPER1EC1"
							],
							[
								"MSSUPER2EC1"
							],
							[
								"MSSUPER3EC1"
							]
						],
						"value": "Your steam generator is the most important component of your steam shower. Protect your investment with AutoFlush. AutoFlush® is a MrSteam exclusive product. It's an automatic self-cleaning system that promotes a long, healthy life for steam generators by automatically flushing the generator of sediment two hours after every steambath. We automate everything in the background, so no work is needed after every steam shower session. AutoFlush® assures that you get clean steam every time."
					},
					{
						"tally": [
							[
								"MX4EC1"
							],
							[
								"MX5EC1"
							],
							[
								"MX6EC1"
							]
						],
						"value": "Your steam generator is the most important component of your steam shower. Protect your investment with AutoFlush. AutoFlush® is a MrSteam exclusive product. It's an automatic self-cleaning system that promotes a long, healthy life for steam generators by automatically flushing the generator of sediment two hours after every steambath. We automate everything in the background, so no work is needed after every steam shower session. AutoFlush® assures that you get clean steam every time."
					}
				]
			},
			"descriptions.tech": {
				"keyTemplate": [
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								null
							],
							[
								"MS90EC1"
							],
							[
								"MS150EC1"
							],
							[
								"MS225EC1"
							],
							[
								"MS400EC1"
							],
							[
								"MSSUPER1EC1"
							],
							[
								"MSSUPER2EC1"
							],
							[
								"MSSUPER3EC1"
							]
						],
						"value": "<li>The system quietly flushes impurities through a ½\" electronically-activated valve - no small opening to clog</li><li>Automatically flushes old water and impurities from your steam generator after every session, no buttons to push to initiate draining</li><li>Impurities and old water are flushed through a ½\", electronically activated valve. You'll never experience a clog, and there's nothing to remember</li><li>Simple plug and play installation</li><li>Length-4.25\"</li><li>Width-5\"</li><li>Height-2.75\"</li><li>Weight-2 lbs</li>"
					},
					{
						"tally": [
							[
								"MX4EC1"
							],
							[
								"MX5EC1"
							],
							[
								"MX6EC1"
							]
						],
						"value": "<li>The system quietly flushes impurities through a ½\" electronically-activated valve - no small opening to clog</li><li>Automatically flushes old water and impurities from your steam generator after every session, no buttons to push to initiate draining</li><li>Impurities and old water are flushed through a ½\", electronically activated valve. You'll never experience a clog, and there's nothing to remember</li><li>Simple plug and play installation</li>"
					}
				]
			},
			"partnumber": {
				"keyTemplate": [
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								null
							],
							[
								"MS90EC1"
							],
							[
								"MS150EC1"
							],
							[
								"MS225EC1"
							],
							[
								"MS400EC1"
							],
							[
								"MSSUPER1EC1"
							],
							[
								"MSSUPER2EC1"
							],
							[
								"MSSUPER3EC1"
							]
						],
						"value": "MS81500E"
					},
					{
						"tally": [
							[
								"MX4EC1"
							],
							[
								"MX5EC1"
							],
							[
								"MX6EC1"
							]
						],
						"value": "CT81500"
					}
				]
			},
			"name": {
				"keyTemplate": [
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								null
							],
							[
								"MS90EC1"
							],
							[
								"MS150EC1"
							],
							[
								"MS225EC1"
							],
							[
								"MS400EC1"
							],
							[
								"MSSUPER1EC1"
							],
							[
								"MSSUPER2EC1"
							],
							[
								"MSSUPER3EC1"
							]
						],
						"value": "AutoFlush"
					},
					{
						"tally": [
							[
								"MX4EC1"
							],
							[
								"MX5EC1"
							],
							[
								"MX6EC1"
							]
						],
						"value": "AutoFlush Max"
					}
				]
			},
			"price": {
				"keyTemplate": [
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								null
							],
							[
								"MS90EC1"
							],
							[
								"MS150EC1"
							],
							[
								"MS225EC1"
							],
							[
								"MS400EC1"
							],
							[
								"MSSUPER1EC1"
							],
							[
								"MSSUPER2EC1"
							],
							[
								"MSSUPER3EC1"
							]
						],
						"value": 550
					},
					{
						"tally": [
							[
								"MX4EC1"
							],
							[
								"MX5EC1"
							],
							[
								"MX6EC1"
							]
						],
						"value": 580
					}
				]
			},
			"images.scene": {
				"keyTemplate": [
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								null
							],
							[
								"MS90EC1"
							],
							[
								"MS150EC1"
							],
							[
								"MS225EC1"
							],
							[
								"MS400EC1"
							]
						],
						"value": "AutoFlush-MS-90-400.png"
					},
					{
						"tally": [
							[
								"MSSUPER1EC1"
							],
							[
								"MSSUPER2EC1"
							],
							[
								"MSSUPER3EC1"
							]
						],
						"value": "AutoFlush-MS-Super-1-3.png"
					},
					{
						"tally": [
							[
								"MX4EC1"
							],
							[
								"MX5EC1"
							],
							[
								"MX6EC1"
							]
						],
						"value": "AutoFlush-MS-Super-4-6.png"
					}
				]
			},
			"tooltips.list": {
				"keyTemplate": [
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								null
							],
							[
								"MS90EC1"
							],
							[
								"MS150EC1"
							],
							[
								"MS225EC1"
							],
							[
								"MS400EC1"
							]
						],
						"value": [
							{
								"top": 79.5,
								"left": 20,
								"width": 3,
								"height": 6,
								"orientation": "right"
							}
						]
					},
					{
						"tally": [
							[
								"MSSUPER1EC1"
							],
							[
								"MSSUPER2EC1"
							],
							[
								"MSSUPER3EC1"
							]
						],
						"value": [
							{
								"top": 80,
								"left": 22,
								"width": 3,
								"height": 6,
								"orientation": "right"
							}
						]
					},
					{
						"tally": [
							[
								"MX4EC1"
							],
							[
								"MX5EC1"
							],
							[
								"MX6EC1"
							]
						],
						"value": [
							{
								"top": 78.5,
								"left": 22,
								"width": 4,
								"height": 7,
								"orientation": "right"
							}
						]
					}
				]
			}
		},
		"tooltips": {
			"list": [
				{
					"top": 79.5,
					"left": 20,
					"width": 3,
					"height": 6,
					"orientation": "right"
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": true,
			"isSuperCompatible": true
		}
	},
	{
		"code": "Condensation Pan",
		"partnumber": "103867",
		"previewname": "Condensation Pan",
		"name": "Condensation Pan",
		"price": 185,
		"descriptions": {
			"long": "Sitting under our e-Series Generators, the Condensation Pan protects bathrooms from potential water escape. Just locate the condensation pan on a solid level surface and place the steam generator inside the condensation pan. Insure the steam generator is level. Condensation pan drains by gravity.",
			"tech": "<li>Installs beneath the steam generator and connects to an approved drain line to collect and direct a potential water accumulation or leak</li>\\r\\n<li>Built in brackets raise the Steam Generator above the bottom of the pan</li>\\r\\n<li>Measures 25”L x 9”W x 1  ½”H\" NPT fitting</li><li>Compatible with all Mr. Steam generators</li>"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/c566466a-4819-4364-b47b-9ec1e71d3f77.pdf"
		},
		"images": {
			"thumbnail": "condensationpan.jpg",
			"folder": "controls-accessories/",
			"scene": "DripPan.png"
		},
		"taxonomy": {
			"categories": [
				"controls-accessories"
			],
			"sortOrder": {
				"controls-accessories": 4
			},
			"zIndex": {
				"controls-accessories": 4
			}
		},
		"dynamicProperties": {
			"images.thumbnail": {
				"keyTemplate": [
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								null
							],
							[
								"MS90EC1"
							],
							[
								"MS150EC1"
							],
							[
								"MS225EC1"
							],
							[
								"MS400EC1"
							],
							[
								"MSSUPER1EC1"
							],
							[
								"MSSUPER2EC1"
							],
							[
								"MSSUPER3EC1"
							]
						],
						"value": "condensationpan.jpg"
					},
					{
						"tally": [
							[
								"MX4EC1"
							],
							[
								"MX5EC1"
							],
							[
								"MX6EC1"
							]
						],
						"value": "maxcondpan.jpg"
					}
				]
			},
			"price": {
				"keyTemplate": [
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								null
							],
							[
								"MS90EC1"
							],
							[
								"MS150EC1"
							],
							[
								"MS225EC1"
							],
							[
								"MS400EC1"
							],
							[
								"MSSUPER1EC1"
							],
							[
								"MSSUPER2EC1"
							],
							[
								"MSSUPER3EC1"
							]
						],
						"value": 195
					},
					{
						"tally": [
							[
								"MX4EC1"
							],
							[
								"MX5EC1"
							],
							[
								"MX6EC1"
							]
						],
						"value": 275
					}
				]
			},
			"partnumber": {
				"keyTemplate": [
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								null
							],
							[
								"MS90EC1"
							],
							[
								"MS150EC1"
							],
							[
								"MS225EC1"
							],
							[
								"MS400EC1"
							],
							[
								"MSSUPER1EC1"
							],
							[
								"MSSUPER2EC1"
							],
							[
								"MSSUPER3EC1"
							]
						],
						"value": 103867
					},
					{
						"tally": [
							[
								"MX4EC1"
							],
							[
								"MX5EC1"
							],
							[
								"MX6EC1"
							]
						],
						"value": 104402
					}
				]
			},
			"name": {
				"keyTemplate": [
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								null
							],
							[
								"MS90EC1"
							],
							[
								"MS150EC1"
							],
							[
								"MS225EC1"
							],
							[
								"MS400EC1"
							],
							[
								"MSSUPER1EC1"
							],
							[
								"MSSUPER2EC1"
							],
							[
								"MSSUPER3EC1"
							]
						],
						"value": "Condensation Pan"
					},
					{
						"tally": [
							[
								"MX4EC1"
							],
							[
								"MX5EC1"
							],
							[
								"MX6EC1"
							]
						],
						"value": "Max Condensation Pan"
					}
				]
			},
			"descriptions.long": {
				"keyTemplate": [
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								null
							],
							[
								"MS90EC1"
							],
							[
								"MS150EC1"
							],
							[
								"MS225EC1"
							],
							[
								"MS400EC1"
							],
							[
								"MSSUPER1EC1"
							],
							[
								"MSSUPER2EC1"
							],
							[
								"MSSUPER3EC1"
							]
						],
						"value": "Sitting under our e-Series Generators, the Condensation Pan protects bathrooms from potential water escape. Just locate the condensation pan on a solid level surface and place the steam generator inside the condensation pan. Insure the steam generator is level. Condensation pan drains by gravity."
					},
					{
						"tally": [
							[
								"MX4EC1"
							],
							[
								"MX5EC1"
							],
							[
								"MX6EC1"
							]
						],
						"value": "Sitting under our MAX Series Generators, the MAX Condensation Pan protects bathrooms from potential water escape. Just locate the condensation pan on a solid level surface and place the steam generator inside the condensation pan. Insure the steam generator is level. MAX Condensation pan drains by gravity."
					}
				]
			},
			"descriptions.tech": {
				"keyTemplate": [
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								null
							],
							[
								"MS90EC1"
							],
							[
								"MS150EC1"
							],
							[
								"MS225EC1"
							],
							[
								"MS400EC1"
							],
							[
								"MSSUPER1EC1"
							],
							[
								"MSSUPER2EC1"
							],
							[
								"MSSUPER3EC1"
							]
						],
						"value": "<li>Installs beneath the steam generator and connects to an approved drain line to collect and direct a potential water accumulation or leak</li>\\r\\n<li>Built in brackets raise the Steam Generator above the bottom of the pan</li>\\r\\n<li>Measures 25”L x 9”W x 1  ½”H\" NPT fitting</li><li>Compatible with all Mr. Steam generators</li>"
					},
					{
						"tally": [
							[
								"MX4EC1"
							],
							[
								"MX5EC1"
							],
							[
								"MX6EC1"
							]
						],
						"value": "<li>For MX4E - MX6E Generators</li><li>Installs beneath the MAX Steam Generator and connects to an approved drain line to collect and direct a potential water accumulation or leak</li><li>Built in brackets raise the MAX Steam Generator above the bottom of the pan</li><li>Measures 33” x 9” x 1 1/2”</li>"
					}
				]
			},
			"images.scene": {
				"keyTemplate": [
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								null
							],
							[
								"MS90EC1"
							],
							[
								"MS150EC1"
							],
							[
								"MS225EC1"
							],
							[
								"MS400EC1"
							]
						],
						"value": "DripPan-MS-90-400.png"
					},
					{
						"tally": [
							[
								"MSSUPER1EC1"
							],
							[
								"MSSUPER2EC1"
							],
							[
								"MSSUPER3EC1"
							]
						],
						"value": "DripPan-MS-Super-1-3.png"
					},
					{
						"tally": [
							[
								"MX4EC1"
							],
							[
								"MX5EC1"
							],
							[
								"MX6EC1"
							]
						],
						"value": "drippanmax.png"
					}
				]
			},
			"tooltips.list": {
				"keyTemplate": [
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								null
							],
							[
								"MS90EC1"
							],
							[
								"MS150EC1"
							],
							[
								"MS225EC1"
							],
							[
								"MS400EC1"
							]
						],
						"value": [
							{
								"top": 84,
								"left": 8,
								"width": 15,
								"height": 7,
								"orientation": "left"
							}
						]
					},
					{
						"tally": [
							[
								"MSSUPER1EC1"
							],
							[
								"MSSUPER2EC1"
							],
							[
								"MSSUPER3EC1"
							]
						],
						"value": [
							{
								"top": 85,
								"left": 10,
								"width": 15,
								"height": 7,
								"orientation": "left"
							}
						]
					},
					{
						"tally": [
							[
								"MX4EC1"
							],
							[
								"MX5EC1"
							],
							[
								"MX6EC1"
							]
						],
						"value": [
							{
								"top": 85,
								"left": 8,
								"width": 17,
								"height": 6,
								"orientation": "left"
							}
						]
					}
				]
			}
		},
		"tooltips": {
			"list": [
				{
					"top": 84,
					"left": 8,
					"width": 15,
					"height": 7,
					"orientation": "left"
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": true,
			"isSuperCompatible": true
		}
	},
	{
		"code": "SteamLinx",
		"partnumber": "SteamLinx",
		"previewname": "SteamLinx",
		"name": "SteamLinx",
		"price": 535,
		"descriptions": {
			"short": "SteamLinx® Wireless Interface",
			"long": "SteamLinx brings the convenience of using your smartphone or mobile device to start your steam shower from anywhere within your home. Get off to a quick start with just a few taps. All the benefits with less effort.",
			"tech": "<li>Use your smartphone or mobile device to control your steam shower</li><li>Whatever your preference, program your temperature and get comfortable</li><li>Use our standard 60-minute timer and take total control of how long you want your steam experience to last</li><li>Bring your steam system into your network</li>"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/0afda6f4-0e68-4d00-826f-640d03f82144.pdf"
		},
		"images": {
			"thumbnail": "steamlinx.jpg",
			"folder": "controls-accessories/",
			"scene": "steamlink_m+l.png"
		},
		"taxonomy": {
			"categories": [
				"controls-accessories"
			],
			"sortOrder": {
				"controls-accessories": 2
			},
			"zIndex": {
				"controls-accessories": 2
			}
		},
		"tooltips": {
			"list": [
				{
					"top": 73,
					"left": 27,
					"width": 4,
					"height": 4,
					"orientation": "left"
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false
		}
	},
	{
		"code": "CHROMASTEAM",
		"partnumber": "MSCHROMA-72",
		"previewname": "ChromaSteam",
		"name": "ChromaSteam",
		"price": 1150,
		"descriptions": {
			"short": "Music Therapy Speakers",
			"long": "Step into your shower. Let the steam envelope you. Now extend a hand and effortlessly dial in just the mood you're seeking. Your elegant, vapor-sealed LED mood lighting responds with a flood of pure energy.",
			"tech": "<li>Suffuses the steam shower with a spectrum of color from airy blue to sensual red</li><li>Vapor-sealed</li><li>Low-voltage LED modules yield long-lasting high performance and cool operation</li><li>The Chroma logic color selection can be set for a single color or to cycle from one to another</li><li>ChromaSteam is UL listed for safety</li>"
		},
		"images": {
			"thumbnail": "ChromaSteam.jpg",
			"folder": "spa-therapies/ChromaSteam/",
			"scene": "ChromaSteam.png"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/61737f7f-1e0f-4134-bbbb-f37338a4d2d0.pdf"
		},
		"taxonomy": {
			"categories": [
				"spa-therapies"
			],
			"sortOrder": {
				"spa-therapies": 6
			},
			"zIndex": {
				"spa-therapies": 6
			}
		},
		"tooltips": {
			"list": [
				{
					"top": 15,
					"left": 54.7,
					"width": 6,
					"height": 5
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false
		}
	},
	{
		"code": "CHROMASTEAMX",
		"partnumber": "CHROMASTEAMX",
		"previewname": "ChromaX System",
		"name": "ChromaX System",
		"price": 1100,
		"descriptions": {
			"short": "Music Therapy Speakers",
			"long": "ChromaSteam System suffuses the steam shower with a spectrum of color from airy blue to sensual red. Select color and modes directly from the iSteamX Control.Includes a built-in low voltage transformer and color microprocessor.",
			"tech": "<li>Ceiling mounted, vapor-sealed</li><li>Energy efficient LED module</li><li>Color selection microprocessor</li><li>Can be controlled from a dedicated wall switch</li><li>Can be controlled from in-shower control</li><BR><BR>IMPORTANT: ChromaSteam™ System is for mood lighting only and is not a substitute for general illumination."
		},
		"images": {
			"thumbnail": "chroma_blk.jpg",
			"folder": "spa-therapies/ChromaSteam/",
			"scene": "chromasteam_light_bk.png"
		},
		"links": {
			"tech": "https://pim.mrsteam.com/Resources/Entities/MRSTEAM/Documents/0e8404cb-f535-4476-9a40-b750675dea56.pdf"
		},
		"taxonomy": {
			"categories": [
				"spa-therapies"
			],
			"sortOrder": {
				"spa-therapies": 4
			},
			"zIndex": {
				"spa-therapies": 4
			}
		},
		"options": {
			"enabledListsIds": [
				"color"
			],
			"selected": {
				"color": "BLACK",
				"type": "CHROMAXBK"
			},
			"list": {
				"color": [
					"BLACK",
					"WHITE"
				]
			}
		},
		"dynamicProperties": {
			"images.thumbnail": {
				"keyTemplate": [
					"options.selected.color"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK"
							]
						],
						"value": "chroma_blk.jpg"
					},
					{
						"tally": [
							[
								"WHITE"
							]
						],
						"value": "chroma_wh.jpg"
					}
				]
			},
			"partnumber": {
				"keyTemplate": [
					"options.selected.color"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK"
							]
						],
						"value": "CHROMAXBK"
					},
					{
						"tally": [
							[
								"WHITE"
							]
						],
						"value": "CHROMAXWH"
					}
				]
			},
			"images.scene": {
				"keyTemplate": [
					"options.selected.color"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK"
							]
						],
						"value": "chromasteam_light_bk.png"
					},
					{
						"tally": [
							[
								"WHITE"
							]
						],
						"value": "chromasteam_light_wh.png"
					}
				]
			}
		},
		"tooltips": {
			"list": [
				{
					"top": 15,
					"left": 54.7,
					"width": 6,
					"height": 5
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false
		}
	},
	{
		"code": "AROMASTEAM",
		"partnumber": "MSAROMA",
		"previewname": "AromaSteam System",
		"name": "AromaSteam System",
		"price": 1500,
		"descriptions": {
			"short": "AromaSteam System",
			"long": "Effortlessly infuse your steam shower with the AromaSteam System. This state-of-the-art injector pump electronically atomizes our organic botanical fragrances into your steam at the source, for the most complete and consistent infusion of delightful essences into your steam shower. We’ve raised aroma to an art form.",
			"tech": "<Li>The AromaSteam is easily controlled directly from an iSteam, iTempo Plus and AirTempo in-shower control</Li><Li>Complete with hoses, fittings and oil atomizer</Li><Li>All installation hardware included</Li><li>Install in a dry low humidity location for optimal performance </li>"
		},
		"images": {
			"thumbnail": "MSAROMA.jpg",
			"folder": "spa-therapies/AromaSteam/",
			"scene": "mst2024-02_vspa_aroma-flo-pump_final_01.png"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/0a8f8aef-9d7b-4865-aa56-24f1c58dee7f.pdf"
		},
		"taxonomy": {
			"categories": [
				"spa-therapies"
			],
			"sortOrder": {
				"spa-therapies": 7
			},
			"zIndex": {
				"spa-therapies": 7
			}
		},
		"tooltips": {
			"list": [
				{
					"top": 77,
					"left": 23.5,
					"width": 7,
					"height": 11
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": true,
			"isSuperCompatible": false
		}
	},
	{
		"code": "AROMA_STEAM_OIL_1L",
		"partnumber": "MS AROMA",
		"previewname": "AromaSteam Oil",
		"name": "AromaSteam Oil",
		"price": 160,
		"descriptions": {
			"long": "Aromatherapy has been recognized for centuries as having potentially profound healing effects. Aromatherapy was mankind’s first medicine, a holistic practice of caring for the body using botanical oils. Essential oils can help awaken and stimulate, or relax and promote better sleep. The MrSteam Aromas are a unique collection of natural fragrances, available in 1-liter bottles, that enrich the steam experience. Each aromatic oil offers a distinct fragrance with characteristic benefits.",
			"tech": "<li>Infuse your steam with AromaSteam bottles </li><li>Specially formulated & packaged for use with the AromaSteam system</li><li>1 liter bottle </li><li>Approximate 120 20-minute steam sessions </li>"
		},
		"images": {
			"folder": "spa-therapies/AromaSteam-Oils-1l/",
			"thumbnail": "MS-OIL1.jpg",
			"scene": "AromaSteam.png"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/805b5799-a245-41fb-98e3-44230f966852.pdf"
		},
		"taxonomy": {
			"categories": [
				"spa-therapies"
			],
			"sortOrder": {
				"spa-therapies": 8
			},
			"zIndex": {
				"spa-therapies": 8
			}
		},
		"options": {
			"enabledListsIds": [
				"aroma"
			],
			"selected": {
				"aroma": "EUCALYPTUS"
			},
			"list": {
				"aroma": [
					"EUCALYPTUS",
					"EVERGREEN",
					"BREATHE",
					"LAVENDER",
					"MINT"
				]
			}
		},
		"dynamicProperties": {
			"images.thumbnail": {
				"keyTemplate": [
					"options.selected.aroma"
				],
				"tallies": [
					{
						"tally": [
							[
								"EUCALYPTUS"
							]
						],
						"value": "MS-OIL1.jpg"
					},
					{
						"tally": [
							[
								"EVERGREEN"
							]
						],
						"value": "MS-OIL3.jpg"
					},
					{
						"tally": [
							[
								"BREATHE"
							]
						],
						"value": "MS-OIL5.jpg"
					},
					{
						"tally": [
							[
								"LAVENDER"
							]
						],
						"value": "MS-OIL2.jpg"
					},
					{
						"tally": [
							[
								"MINT"
							]
						],
						"value": "MS-OIL4.jpg"
					}
				]
			},
			"partnumber": {
				"keyTemplate": [
					"options.selected.aroma"
				],
				"tallies": [
					{
						"tally": [
							[
								"EUCALYPTUS"
							]
						],
						"value": "MS-OIL1"
					},
					{
						"tally": [
							[
								"EVERGREEN"
							]
						],
						"value": "MS-OIL3"
					},
					{
						"tally": [
							[
								"BREATHE"
							]
						],
						"value": "MS-OIL5"
					},
					{
						"tally": [
							[
								"LAVENDER"
							]
						],
						"value": "MS-OIL2"
					},
					{
						"tally": [
							[
								"MINT"
							]
						],
						"value": "MS-OIL4"
					}
				]
			}
		},
		"tooltips": {
			"list": [
				{
					"top": 77,
					"left": 24.5,
					"width": 7,
					"height": 11
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false
		}
	},
	{
		"code": "RECESSED_LIGHT",
		"partnumber": "MSLIGHTRCS",
		"previewname": "Recessed LED Light",
		"name": "Recessed LED Light",
		"price": 950,
		"descriptions": {
			"long": "Built for steam environments, this Recessed Light is designed for ceiling mount and architectural integration. Available in both aluminum polished and aluminum satin finishes, it can fit nearly any steam room design. Complete with 120 VAC LED Driver and rough-in bracket, the impressive 600 lumens light is ready to install in your steam shower.",
			"tech": "<li>Low voltage</li><li>600 lumens</li><li>120 volt</li><li>Includes 120 VAC LED Driver</li><li>Includes rough-in bracket</li><li>3 ½ “ high x 4 ¼” diameter</li><li>UL Listed</li>"
		},
		"images": {
			"thumbnail": "LEDLITE-AP.jpg",
			"folder": "accessories/RecessedLight/",
			"scene": "RecessedLight.png"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/ea007e32-e745-4a09-8acc-7d0489918ac8.pdf"
		},
		"taxonomy": {
			"categories": [
				"accessories"
			],
			"sortOrder": {
				"accessories": 1
			},
			"zIndex": {
				"accessories": 1
			}
		},
		"options": {
			"enabledListsIds": [
				"finish"
			],
			"selected": {
				"finish": "POLISHED_ALUMINUM"
			},
			"list": {
				"finish": [
					"POLISHED_ALUMINUM",
					"SATIN_ALUMINUM"
				]
			}
		},
		"dynamicProperties": {
			"images.thumbnail": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"POLISHED_ALUMINUM"
							]
						],
						"value": "LEDLITE-AP.jpg"
					},
					{
						"tally": [
							[
								"SATIN_ALUMINUM"
							]
						],
						"value": "LEDLITE-AS.jpg"
					}
				]
			},
			"partnumber": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"POLISHED_ALUMINUM"
							]
						],
						"value": "LEDLITE-AP"
					},
					{
						"tally": [
							[
								"SATIN_ALUMINUM"
							]
						],
						"value": "LEDLITE-AS"
					}
				]
			},
			"price": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"POLISHED_ALUMINUM"
							]
						],
						"value": 950
					},
					{
						"tally": [
							[
								"SATIN_ALUMINUM"
							]
						],
						"value": 950
					}
				]
			}
		},
		"tooltips": {
			"list": [
				{
					"top": 12,
					"left": 49.2,
					"height": 5,
					"width": 5
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false
		}
	},
	{
		"code": "WALL_SEAT",
		"partnumber": "MS WALLSEAT",
		"previewname": "Wall Seat",
		"name": "Wall Seat",
		"price": 675,
		"descriptions": {
			"long": "The Teak in shower wall seat for the home spa offered by Mr. Steam is perfect for sitting and relaxing in steam. The contemporary styled seat easily folds up against the wall for added space when needed in the steam shower. The seat is built to hold up to 250 pounds as well as meeting ADA specifications. ",
			"tech": "<li>Made with beautifully finished and sealed teak wood</li><li>Wall brackets are finished in polished chrome, polished nickel, satin nickel, or brushed nickel</li><li>All nessecary installation hardware is included with seat</li><li>Rated max 250 lbs</li>"
		},
		"images": {
			"thumbnail": "WallSeat.jpg",
			"folder": "accessories/WallSeat/",
			"scene": "Wallseat_PC.png"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/e39f363d-8e04-4151-ab2e-e3d573d62099.pdf"
		},
		"taxonomy": {
			"categories": [
				"accessories"
			],
			"sortOrder": {
				"accessories": 1
			},
			"zIndex": {
				"accessories": 1
			}
		},
		"options": {
			"enabledListsIds": [
				"finish"
			],
			"selected": {
				"finish": "POLISHED_CHROME"
			},
			"list": {
				"finish": [
					"POLISHED_CHROME",
					"POLISHED_NICKEL",
					"BRUSHED_NICKEL",
					"SATIN_BRASS"
				]
			}
		},
		"dynamicProperties": {
			"images.scene": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"POLISHED_CHROME"
							]
						],
						"value": "wallseat_pc.png"
					},
					{
						"tally": [
							[
								"POLISHED_NICKEL"
							]
						],
						"value": "wallseat_pn.png"
					},
					{
						"tally": [
							[
								"BRUSHED_NICKEL"
							]
						],
						"value": "wallseat_bn.png"
					},
					{
						"tally": [
							[
								"SATIN_BRASS"
							]
						],
						"value": "wallseat_sb.png"
					}
				]
			},
			"images.thumbnail": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"POLISHED_CHROME"
							]
						],
						"value": "MSWSEAT-PC.jpg"
					},
					{
						"tally": [
							[
								"POLISHED_NICKEL"
							]
						],
						"value": "MSWSEAT-PN.jpg"
					},
					{
						"tally": [
							[
								"BRUSHED_NICKEL"
							]
						],
						"value": "MSWSEAT-BN.jpg"
					},
					{
						"tally": [
							[
								"SATIN_BRASS"
							]
						],
						"value": "MSWSEAT-SB.jpg"
					}
				]
			},
			"partnumber": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"POLISHED_CHROME"
							]
						],
						"value": "MSWSEAT-PC"
					},
					{
						"tally": [
							[
								"POLISHED_NICKEL"
							]
						],
						"value": "MSWSEAT-PN"
					},
					{
						"tally": [
							[
								"BRUSHED_NICKEL"
							]
						],
						"value": "MSWSEAT-BN"
					},
					{
						"tally": [
							[
								"SATIN_BRASS"
							]
						],
						"value": "MSWSEAT-SB"
					}
				]
			},
			"price": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"POLISHED_CHROME"
							]
						],
						"value": 735
					},
					{
						"tally": [
							[
								"POLISHED_NICKEL"
							],
							[
								"BRUSHED_NICKEL"
							],
							[
								"SATIN_BRASS"
							]
						],
						"value": 810
					}
				]
			}
		},
		"tooltips": {
			"list": [
				{
					"top": 66,
					"left": 56.5,
					"height": 7,
					"width": 13
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false
		}
	},
	{
		"code": "LINEAR_STEAMHEAD",
		"partnumber": "104216",
		"previewname": "Linear SteamHead",
		"name": "Linear SteamHead",
		"price": 510,
		"descriptions": {
			"long": "Award winning, whisper quite Linear SteamHead matches any design style. Mounts flush to the wall, and creates a wide ribbon of smooth that brings a new level of performance and aesthetic pleasure to your steam shower. Now includes designer finish trim, aroma oil well, and diverter.",
			"tech": "<li>A series of patented interior baffles delivers whisper quiet billowing steam</li><li>Slender, horizontal opening disperses steam evenly and smoothly</li><li>Decorative trim in designer finish pushes in place and is held with silicone/friction</li><li>Aroma oil tray in neutral finish attaches to the steam head with or diverter is included</li><li>Stainless steel diveter can be used to reduce the steam emission if desired is included</li><li>Fits between 16\" on center 2' x 4\" studs</li><li>Anodized hard coat aluminum construction and finish</li><li>Installs flush to the wall and nearly disappears in the grout line</li><li>No assembly of moving parts required</li>"
		},
		"images": {
			"thumbnail": "104480PC.jpg",
			"folder": "accessories/LinearSteamHead/",
			"scene": "LinearSteamHead.png"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/25133f67-bf80-4b52-a44c-ce57ec32ddbd.pdf"
		},
		"taxonomy": {
			"categories": [
				"controls-accessories"
			],
			"sortOrder": {
				"controls-accessories": 1
			},
			"zIndex": {
				"controls-accessories": 1
			}
		},
		"options": {
			"enabledListsIds": [
				"finish"
			],
			"selected": {
				"finish": "POLISHED_CHROME"
			},
			"list": {
				"finish": [
					"POLISHED_CHROME",
					"POLISHED_NICKEL",
					"BRUSHED_NICKEL",
					"BRUSHED_BRONZE",
					"MATTE_BLACK",
					"OIL_RUBBED_BRONZE",
					"POLISHED_BRASS",
					"SATIN_BRASS"
				]
			}
		},
		"dynamicProperties": {
			"partnumber": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"POLISHED_CHROME"
							]
						],
						"value": "104480PC"
					},
					{
						"tally": [
							[
								"POLISHED_NICKEL"
							]
						],
						"value": "104480PN"
					},
					{
						"tally": [
							[
								"BRUSHED_NICKEL"
							]
						],
						"value": "104480BN"
					},
					{
						"tally": [
							[
								"BRUSHED_BRONZE"
							]
						],
						"value": "104480BB"
					},
					{
						"tally": [
							[
								"MATTE_BLACK"
							]
						],
						"value": "104480MB"
					},
					{
						"tally": [
							[
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "104480ORB"
					},
					{
						"tally": [
							[
								"POLISHED_BRASS"
							]
						],
						"value": "104480PB"
					},
					{
						"tally": [
							[
								"SATIN_BRASS"
							]
						],
						"value": "104480SB"
					}
				]
			},
			"images.scene": {
				"keyTemplate": [
					"_globals.selectedGenerator",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								null,
								"SATIN_BRASS"
							],
							[
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "linear_steamhead_SB.png"
					},
					{
						"tally": [
							[
								null,
								"POLISHED_CHROME"
							],
							[
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "linear_steamhead_PC.png"
					},
					{
						"tally": [
							[
								null,
								"POLISHED_NICKEL"
							],
							[
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "linear_steamhead_PN.png"
					},
					{
						"tally": [
							[
								null,
								"BRUSHED_NICKEL"
							],
							[
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "linear_steamhead_BN.png"
					},
					{
						"tally": [
							[
								null,
								"BRUSHED_BRONZE"
							],
							[
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "linear_steamhead_BB.png"
					},
					{
						"tally": [
							[
								null,
								"MATTE_BLACK"
							],
							[
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "linear_steamhead_MB.png"
					},
					{
						"tally": [
							[
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "linear_steamhead_ORB.png"
					},
					{
						"tally": [
							[
								null,
								"POLISHED_BRASS"
							],
							[
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "linear_steamhead_PB.png"
					},
					{
						"tally": [
							[
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "linear_steamhead_double_SB.png"
					},
					{
						"tally": [
							[
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "linear_steamhead_double_PC.png"
					},
					{
						"tally": [
							[
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "linear_steamhead_double_PN.png"
					},
					{
						"tally": [
							[
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "linear_steamhead_double_BN.png"
					},
					{
						"tally": [
							[
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "linear_steamhead_double_BB.png"
					},
					{
						"tally": [
							[
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "linear_steamhead_double_MB.png"
					},
					{
						"tally": [
							[
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "linear_steamhead_double_ORB.png"
					},
					{
						"tally": [
							[
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "linear_steamhead_double_PB.png"
					}
				]
			},
			"price": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"POLISHED_NICKEL"
							]
						],
						"value": 900
					},
					{
						"tally": [
							[
								"BRUSHED_NICKEL"
							]
						],
						"value": 900
					},
					{
						"tally": [
							[
								"BRUSHED_BRONZE"
							]
						],
						"value": 900
					},
					{
						"tally": [
							[
								"MATTE_BLACK"
							]
						],
						"value": 900
					},
					{
						"tally": [
							[
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": 900
					},
					{
						"tally": [
							[
								"SATIN_BRASS"
							]
						],
						"value": 900
					},
					{
						"tally": [
							[
								"POLISHED_BRASS"
							]
						],
						"value": 900
					},
					{
						"tally": [
							[
								"POLISHED_CHROME"
							]
						],
						"value": 750
					}
				]
			},
			"images.thumbnail": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"POLISHED_CHROME"
							]
						],
						"value": "104480PC.jpg"
					},
					{
						"tally": [
							[
								"POLISHED_NICKEL"
							]
						],
						"value": "104480PN.jpg"
					},
					{
						"tally": [
							[
								"BRUSHED_NICKEL"
							]
						],
						"value": "104480BN.jpg"
					},
					{
						"tally": [
							[
								"BRUSHED_BRONZE"
							]
						],
						"value": "104480BB.jpg"
					},
					{
						"tally": [
							[
								"MATTE_BLACK"
							]
						],
						"value": "104480MB.jpg"
					},
					{
						"tally": [
							[
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "104480ORB.jpg"
					},
					{
						"tally": [
							[
								"POLISHED_BRASS"
							]
						],
						"value": "104480PB.jpg"
					},
					{
						"tally": [
							[
								"SATIN_BRASS"
							]
						],
						"value": "104480SB.jpg"
					}
				]
			},
			"tooltips.list": {
				"keyTemplate": [
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								null
							],
							[
								"MS90EC1"
							],
							[
								"MS150EC1"
							],
							[
								"MS225EC1"
							],
							[
								"MS400EC1"
							]
						],
						"value": [
							{
								"top": 73.5,
								"left": 38.5,
								"height": 4,
								"width": 6
							}
						]
					},
					{
						"tally": [
							[
								"MSSUPER1EC1"
							],
							[
								"MSSUPER2EC1"
							],
							[
								"MSSUPER3EC1"
							],
							[
								"MX4EC1"
							],
							[
								"MX5EC1"
							],
							[
								"MX6EC1"
							]
						],
						"value": [
							{
								"top": 73,
								"left": 36.5,
								"height": 5,
								"width": 10
							}
						]
					}
				]
			}
		},
		"tooltips": {
			"list": [
				{
					"top": 73.5,
					"left": 38.5,
					"height": 4,
					"width": 6
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": true
		}
	},
	{
		"code": "AROMA_STEAM_OIL",
		"partnumber": "MS AROMA",
		"previewname": "AromaSteam Oil",
		"name": "AromaSteam Oil",
		"price": 450,
		"descriptions": {
			"long": "A deeply refreshing aroma with cleansing effects, eucalyptus may help open air passageways",
			"tech": "10 ml. bottle with integral dropper made from organic plant and flower extracts\\r\\n100% essential oils"
		},
		"images": {
			"folder": "accessories/AromaSteam-Oils/",
			"thumbnail": "AromaSteam-5-pack.jpg",
			"scene": "AromaSteam.png"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/ca152b1a-3ef0-4dfc-8c79-e4727b24f730.pdf"
		},
		"taxonomy": {
			"categories": [
				"accessories"
			],
			"sortOrder": {
				"accessories": 2
			},
			"zIndex": {
				"accessories": 2
			}
		},
		"options": {
			"enabledListsIds": [
				"aroma"
			],
			"selected": {
				"aroma": "PACK_5"
			},
			"list": {
				"aroma": [
					"PACK_5",
					"EUCALYPTUS",
					"EVERGREEN",
					"BREATHE",
					"LAVENDER",
					"MINT"
				]
			}
		},
		"dynamicProperties": {
			"images.thumbnail": {
				"keyTemplate": [
					"options.selected.aroma"
				],
				"tallies": [
					{
						"tally": [
							[
								"EUCALYPTUS"
							]
						],
						"value": "Eucalyptus.jpg"
					},
					{
						"tally": [
							[
								"EVERGREEN"
							]
						],
						"value": "Evergreen.jpg"
					},
					{
						"tally": [
							[
								"BREATHE"
							]
						],
						"value": "Breathe.jpg"
					},
					{
						"tally": [
							[
								"LAVENDER"
							]
						],
						"value": "Lavender.jpg"
					},
					{
						"tally": [
							[
								"MINT"
							]
						],
						"value": "Mint.jpg"
					},
					{
						"tally": [
							[
								"PACK_5"
							]
						],
						"value": "AromaSteam-5-pack.jpg"
					}
				]
			},
			"partnumber": {
				"keyTemplate": [
					"options.selected.aroma"
				],
				"tallies": [
					{
						"tally": [
							[
								"EUCALYPTUS"
							]
						],
						"value": "103810"
					},
					{
						"tally": [
							[
								"EVERGREEN"
							]
						],
						"value": "103812"
					},
					{
						"tally": [
							[
								"BREATHE"
							]
						],
						"value": "103814"
					},
					{
						"tally": [
							[
								"LAVENDER"
							]
						],
						"value": "103811"
					},
					{
						"tally": [
							[
								"MINT"
							]
						],
						"value": "103813"
					},
					{
						"tally": [
							[
								"PACK_5"
							]
						],
						"value": "MS ESSENTIAL 5"
					}
				]
			},
			"descriptions.long": {
				"keyTemplate": [
					"options.selected.aroma"
				],
				"tallies": [
					{
						"tally": [
							[
								"EUCALYPTUS"
							]
						],
						"value": "A deeply refreshing aroma with cleansing effects, eucalyptus may help open air passageways"
					},
					{
						"tally": [
							[
								"EVERGREEN"
							]
						],
						"value": "A refreshing blend of spruce, fir and pine reminiscent of a forest on a crisp morning"
					},
					{
						"tally": [
							[
								"BREATHE"
							]
						],
						"value": "A tropical combination that may help clear chest, nose and sinuses"
					},
					{
						"tally": [
							[
								"LAVENDER"
							]
						],
						"value": "A sweet, lightly floral scent, lavender may help soothe anxiety with its calming and restorative properties"
					},
					{
						"tally": [
							[
								"MINT"
							]
						],
						"value": "A blend of mint, citrus and herbs that may stimulate and energize"
					},
					{
						"tally": [
							[
								"PACK_5"
							]
						],
						"value": "5 Pack Essential Oils: Eucalyptus, Evergreen, Breathe, Lavender, Mint"
					}
				]
			},
			"price": {
				"keyTemplate": [
					"options.selected.aroma"
				],
				"tallies": [
					{
						"tally": [
							[
								"EUCALYPTUS"
							],
							[
								"EVERGREEN"
							],
							[
								"BREATHE"
							],
							[
								"LAVENDER"
							],
							[
								"MINT"
							]
						],
						"value": 50
					},
					{
						"tally": [
							[
								"PACK_5"
							]
						],
						"value": 200
					}
				]
			}
		},
		"tooltips": {
			"list": [
				{
					"top": 46.5,
					"left": 45,
					"width": 6,
					"height": 5
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false
		}
	},
	{
		"code": "CHAKRA_OIL",
		"partnumber": "MS CHAKRA7",
		"previewname": "Chakra Oil",
		"name": "Chakra Oil",
		"price": 450,
		"descriptions": {
			"long": "MrSteam® introduces specially formulated essential oils extracted from organic flowers and plant material. The MrSteam Chakra blends may support the body's specific needs. Each MrSteam Chakra oil offers a unique fragrance with characteristic benefits.",
			"tech": "<li>Formulated to work in harmony with the ChromaSteam system's color settings</li><li>Made from organic plant and flower extracts</li><li>10 ml bottles with integral dropper</li><li>For use with towel warmer and steam head wells</li>"
		},
		"images": {
			"folder": "accessories/Chackra-Oils/",
			"thumbnail": "Chackra-Oils-7-pack.jpg",
			"scene": "Chackra-Oils.png"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/2c58532f-9174-4619-b251-eb39942a5c0c.pdf"
		},
		"taxonomy": {
			"categories": [
				"accessories"
			],
			"sortOrder": {
				"accessories": 2
			},
			"zIndex": {
				"accessories": 2
			}
		},
		"options": {
			"enabledListsIds": [
				"aroma"
			],
			"selected": {
				"aroma": "PACK_7"
			},
			"list": {
				"aroma": [
					"PACK_7",
					"VITALITY",
					"INVIGORATE",
					"AWAKENING",
					"HARMONY",
					"CELESTIAL",
					"MYSTIC",
					"NIRVANA"
				]
			}
		},
		"dynamicProperties": {
			"images.thumbnail": {
				"keyTemplate": [
					"options.selected.aroma"
				],
				"tallies": [
					{
						"tally": [
							[
								"VITALITY"
							]
						],
						"value": "Vitality.jpg"
					},
					{
						"tally": [
							[
								"INVIGORATE"
							]
						],
						"value": "Invigorate.jpg"
					},
					{
						"tally": [
							[
								"AWAKENING"
							]
						],
						"value": "Awakening.jpg"
					},
					{
						"tally": [
							[
								"HARMONY"
							]
						],
						"value": "Harmony.jpg"
					},
					{
						"tally": [
							[
								"CELESTIAL"
							]
						],
						"value": "Celestial.jpg"
					},
					{
						"tally": [
							[
								"MYSTIC"
							]
						],
						"value": "Mystic.jpg"
					},
					{
						"tally": [
							[
								"NIRVANA"
							]
						],
						"value": "Nirvana.jpg"
					},
					{
						"tally": [
							[
								"PACK_7"
							]
						],
						"value": "Chackra-Oils-7-pack.jpg"
					}
				]
			},
			"partnumber": {
				"keyTemplate": [
					"options.selected.aroma"
				],
				"tallies": [
					{
						"tally": [
							[
								"VITALITY"
							]
						],
						"value": "104006"
					},
					{
						"tally": [
							[
								"INVIGORATE"
							]
						],
						"value": "104007"
					},
					{
						"tally": [
							[
								"AWAKENING"
							]
						],
						"value": "104008"
					},
					{
						"tally": [
							[
								"HARMONY"
							]
						],
						"value": "104009"
					},
					{
						"tally": [
							[
								"CELESTIAL"
							]
						],
						"value": "104010"
					},
					{
						"tally": [
							[
								"MYSTIC"
							]
						],
						"value": "104011"
					},
					{
						"tally": [
							[
								"NIRVANA"
							]
						],
						"value": "104012"
					},
					{
						"tally": [
							[
								"PACK_7"
							]
						],
						"value": "MS CHAKRA7"
					}
				]
			},
			"price": {
				"keyTemplate": [
					"options.selected.aroma"
				],
				"tallies": [
					{
						"tally": [
							[
								"CELESTIAL"
							],
							[
								"VITALITY"
							],
							[
								"INVIGORATE"
							],
							[
								"AWAKENING"
							],
							[
								"HARMONY"
							],
							[
								"MYSTIC"
							],
							[
								"NIRVANA"
							]
						],
						"value": 55
					},
					{
						"tally": [
							[
								"PACK_7"
							]
						],
						"value": 260
					}
				]
			}
		},
		"tooltips": {
			"list": [
				{
					"top": 46.5,
					"left": 45,
					"width": 6,
					"height": 5
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false
		}
	},
	{
		"code": "AIRBUTLER_PACKAGE",
		"partnumber": "ABUTLER",
		"previewname": "AirButler Package",
		"name": "AirButler Package",
		"price": 1950,
		"descriptions": {
			"short": "AirButlerWhite",
			"long": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat.",
			"tech": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>",
			"parts": "test"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/87dca122-a38e-4002-9255-81ceb75eb37b.pdf"
		},
		"taxonomy": {
			"categories": [
				"airtempo-wireless-controls"
			]
		},
		"images": {
			"folder": "control-packages/AirButler/",
			"thumbnail": "ABUTLER1B-PC.jpg"
		},
		"options": {
			"enabledListsIds": [
				"color",
				"finish",
				"steamHead"
			],
			"selected": {
				"shape": "SQUARE",
				"color": "BLACK",
				"finish": "POLISHED_CHROME",
				"steamHead": "AIRTEMPO_STEAMHEAD"
			},
			"list": {
				"color": [
					"BLACK",
					"WHITE"
				],
				"finish": [
					"POLISHED_CHROME",
					"BRUSHED_BRONZE",
					"BRUSHED_NICKEL",
					"OIL_RUBBED_BRONZE",
					"POLISHED_BRASS",
					"POLISHED_NICKEL",
					"SATIN_BRASS",
					"MATTE_BLACK"
				],
				"steamHead": [
					"AIRTEMPO_STEAMHEAD",
					"LINEAR_STEAMHEAD"
				]
			}
		},
		"dynamicProperties": {
			"price": {
				"keyTemplate": [
					"options.selected.steamHead",
					"_globals.selectedGenerator",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							]
						],
						"value": 3255
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							]
						],
						"value": 3505
					},
					{
						"tally": [
							[
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							]
						],
						"value": 2755
					},
					{
						"tally": [
							[
								"AIRTEMPO_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								null,
								"MATTE_BLACK"
							]
						],
						"value": 3005
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": 3255
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": 4030
					},
					{
						"tally": [
							[
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": 2755
					},
					{
						"tally": [
							[
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": 3180
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": 3505
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": 4430
					},
					{
						"tally": [
							[
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": 3005
					},
					{
						"tally": [
							[
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": 3380
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": 3505
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": 4430
					},
					{
						"tally": [
							[
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": 3005
					},
					{
						"tally": [
							[
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": 3380
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": 3505
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": 4430
					},
					{
						"tally": [
							[
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": 3005
					},
					{
						"tally": [
							[
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": 3380
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": 3505
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": 4430
					},
					{
						"tally": [
							[
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": 3005
					},
					{
						"tally": [
							[
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": 3380
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": 3505
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": 4430
					},
					{
						"tally": [
							[
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": 3005
					},
					{
						"tally": [
							[
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": 3380
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": 3505
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": 4430
					},
					{
						"tally": [
							[
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": 3005
					},
					{
						"tally": [
							[
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": 3380
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": 3505
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": 4430
					},
					{
						"tally": [
							[
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": 3005
					},
					{
						"tally": [
							[
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": 3380
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": 3505
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": 4430
					},
					{
						"tally": [
							[
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": 3005
					},
					{
						"tally": [
							[
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": 3380
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": 3505
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": 4430
					},
					{
						"tally": [
							[
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": 3005
					},
					{
						"tally": [
							[
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": 3380
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": 3505
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": 4430
					},
					{
						"tally": [
							[
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": 3005
					},
					{
						"tally": [
							[
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": 3380
					}
				]
			},
			"descriptions.long": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.steamHead",
					"_globals.selectedGenerator",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					}
				]
			},
			"descriptions.tech": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.steamHead",
					"_globals.selectedGenerator",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					}
				]
			},
			"descriptions.parts": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.steamHead",
					"_globals.selectedGenerator",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li> AirTempo Wireless Steam Shower Control</li><li>SteamLinx</li><li> AirTempo SteamHead</li><li> AutoFlush®</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li> AirTempo Wireless Steam Shower Control</li><li>SteamLinx</li><li> AirTempo SteamHead</li><li> AutoFlush®</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li> AirTempo Wireless Steam Shower Control</li><li>SteamLinx</li><li> AirTempo SteamHead</li><li> AutoFlush®</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li> AirTempo Wireless Steam Shower Control</li><li>SteamLinx</li><li> AirTempo SteamHead</li><li> AutoFlush®</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li> AirTempo Wireless Steam Shower Control</li><li>SteamLinx</li><li> AirTempo SteamHead</li><li> AutoFlush®</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li> AirTempo Wireless Steam Shower Control</li><li>SteamLinx</li><li> AirTempo SteamHead</li><li> AutoFlush®</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li> AirTempo Wireless Steam Shower Control</li><li>SteamLinx</li><li> AirTempo SteamHead</li><li> AutoFlush®</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li> AirTempo Wireless Steam Shower Control</li><li>SteamLinx</li><li> AirTempo SteamHead</li><li> AutoFlush®</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li> AirTempo Wireless Steam Shower Control</li><li>SteamLinx</li><li> AirTempo SteamHead</li><li> AutoFlush®</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li> AirTempo Wireless Steam Shower Control</li><li>SteamLinx</li><li> AirTempo SteamHead</li><li> AutoFlush®</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li> AirTempo Wireless Steam Shower Control</li><li>SteamLinx</li><li> AirTempo SteamHead</li><li> AutoFlush®</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li> AirTempo Wireless Steam Shower Control</li><li>SteamLinx</li><li> AirTempo SteamHead</li><li> AutoFlush®</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li> AirTempo Wireless Steam Shower Control</li><li>SteamLinx</li><li> AirTempo SteamHead</li><li> AutoFlush®</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li> AirTempo Wireless Steam Shower Control</li><li>SteamLinx</li><li> AirTempo SteamHead</li><li> AutoFlush®</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li> AirTempo Wireless Steam Shower Control</li><li>SteamLinx</li><li> AirTempo SteamHead</li><li> AutoFlush®</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li> AirTempo Wireless Steam Shower Control</li><li>SteamLinx</li><li>Linear SteamHead</li><li> AutoFlush®</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li> AirTempo Wireless Steam Shower Control</li><li>SteamLinx</li><li>Linear SteamHead</li><li> AutoFlush®</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li> AirTempo Wireless Steam Shower Control</li><li>SteamLinx</li><li>Linear SteamHead</li><li> AutoFlush®</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li> AirTempo Wireless Steam Shower Control</li><li>SteamLinx</li><li>Linear SteamHead</li><li> AutoFlush®</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li> AirTempo Wireless Steam Shower Control</li><li>SteamLinx</li><li>Linear SteamHead</li><li> AutoFlush®</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li> AirTempo Wireless Steam Shower Control</li><li>SteamLinx</li><li>Linear SteamHead</li><li> AutoFlush®</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li> AirTempo Wireless Steam Shower Control</li><li>SteamLinx</li><li>Linear SteamHead</li><li> AutoFlush®</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li> AirTempo Wireless Steam Shower Control</li><li>SteamLinx</li><li>Linear SteamHead</li><li> AutoFlush®</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li> AirTempo Wireless Steam Shower Control</li><li>SteamLinx</li><li>Linear SteamHead</li><li> AutoFlush®</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li> AirTempo Wireless Steam Shower Control</li><li>SteamLinx</li><li>Linear SteamHead</li><li> AutoFlush®</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li> AirTempo Wireless Steam Shower Control</li><li>SteamLinx</li><li>Linear SteamHead</li><li> AutoFlush®</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li> AirTempo Wireless Steam Shower Control</li><li>SteamLinx</li><li>Linear SteamHead</li><li> AutoFlush®</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li> AirTempo Wireless Steam Shower Control</li><li>SteamLinx</li><li>Linear SteamHead</li><li> AutoFlush®</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li> AirTempo Wireless Steam Shower Control</li><li>SteamLinx</li><li>Linear SteamHead</li><li> AutoFlush®</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li> AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2)</li><li> SteamLinx</li><li> Max AutoFlush®</li><li>Max Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li> AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2)</li><li> SteamLinx</li><li> Max AutoFlush®</li><li>Max Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li> AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2)</li><li> SteamLinx</li><li> Max AutoFlush®</li><li>Max Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li> AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2)</li><li> SteamLinx</li><li> Max AutoFlush®</li><li>Max Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li> AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2)</li><li> SteamLinx</li><li> Max AutoFlush®</li><li>Max Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li> AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2)</li><li> SteamLinx</li><li> Max AutoFlush®</li><li>Max Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li> AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2)</li><li> SteamLinx</li><li> Max AutoFlush®</li><li>Max Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li> AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2)</li><li> SteamLinx</li><li> Max AutoFlush®</li><li>Max Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li> AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2)</li><li> SteamLinx</li><li> Max AutoFlush®</li><li>Max Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li> AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2)</li><li> SteamLinx</li><li> Max AutoFlush®</li><li>Max Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li> AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2)</li><li> SteamLinx</li><li> Max AutoFlush®</li><li>Max Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li> AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2)</li><li> SteamLinx</li><li> Max AutoFlush®</li><li>Max Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li> AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2)</li><li> SteamLinx</li><li> Max AutoFlush®</li><li>Max Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li> AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2)</li><li> SteamLinx</li><li> Max AutoFlush®</li><li>Max Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li> AirTempo™ Surface mount Control</li><li>Linear SteamHead (2)</li><li> SteamLinx</li><li> Max AutoFlush®</li><li>Max Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li> AirTempo™ Surface mount Control</li><li>Linear SteamHead (2)</li><li> SteamLinx</li><li> Max AutoFlush®</li><li>Max Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li> AirTempo™ Surface mount Control</li><li>Linear SteamHead (2)</li><li> SteamLinx</li><li> Max AutoFlush®</li><li>Max Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li> AirTempo™ Surface mount Control</li><li>Linear SteamHead (2)</li><li> SteamLinx</li><li> Max AutoFlush®</li><li>Max Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li> AirTempo™ Surface mount Control</li><li>Linear SteamHead (2)</li><li> SteamLinx</li><li> Max AutoFlush®</li><li>Max Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li> AirTempo™ Surface mount Control</li><li>Linear SteamHead (2)</li><li> SteamLinx</li><li> Max AutoFlush®</li><li>Max Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li> AirTempo™ Surface mount Control</li><li>Linear SteamHead (2)</li><li> SteamLinx</li><li> Max AutoFlush®</li><li>Max Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li> AirTempo™ Surface mount Control</li><li>Linear SteamHead (2)</li><li> SteamLinx</li><li> Max AutoFlush®</li><li>Max Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li> AirTempo™ Surface mount Control</li><li>Linear SteamHead (2)</li><li> SteamLinx</li><li> Max AutoFlush®</li><li>Max Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li> AirTempo™ Surface mount Control</li><li>Linear SteamHead (2)</li><li> SteamLinx</li><li> Max AutoFlush®</li><li>Max Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li> AirTempo™ Surface mount Control</li><li>Linear SteamHead (2)</li><li> SteamLinx</li><li> Max AutoFlush®</li><li>Max Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li> AirTempo™ Surface mount Control</li><li>Linear SteamHead (2)</li><li> SteamLinx</li><li> Max AutoFlush®</li><li>Max Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li> AirTempo™ Surface mount Control</li><li>Linear SteamHead (2)</li><li> SteamLinx</li><li> Max AutoFlush®</li><li>Max Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li> AirTempo™ Surface mount Control</li><li>Linear SteamHead (2)</li><li> SteamLinx</li><li> Max AutoFlush®</li><li>Max Condensation Pan</li>"
					}
				]
			},
			"images.thumbnail": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.steamHead",
					"_globals.selectedGenerator",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "ABUTLER1B-PC.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "ABUTLER1B-BB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "ABUTLER1B-BN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "ABUTLER1B-ORB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "ABUTLER1B-PB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "ABUTLER1B-PN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "ABUTLER1B-SB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "ABUTLER1B-MB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "ABUTLER1W-PC.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "ABUTLER1W-BB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "ABUTLER1W-BN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "ABUTLER1W-ORB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "ABUTLER1W-PB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "ABUTLER1W-PN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "ABUTLER1W-SB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "ABUTLER1W-MB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "ABUTLERLBKPC.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "ABUTLERLBKBB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "ABUTLERLBKBN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "ABUTLERLBKORB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "ABUTLERLBKPB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "ABUTLERLBKPN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "ABUTLERLBKSB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "ABTLRLBKMB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "ABUTLERLWHPC.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "ABUTLERLWHBB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "ABUTLERLWHBN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "ABUTLERLWHORB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "ABUTLERLWHPB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "ABUTLERLWHPN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "ABUTLERLWHSB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "ABTLRLWHMB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "ABUTLERXB-PC.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "ABUTLERXB-BB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "ABUTLERXB-BN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "ABUTLERXB-ORB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "ABUTLERXB-PB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "ABUTLERXB-PN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "ABUTLERXB-SB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "ABUTLERXB-MB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "ABUTLERXW-PC.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "ABUTLERXW-BB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "ABUTLERXW-BN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "ABUTLERXW-ORB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "ABUTLERXW-PB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "ABUTLERXW-PN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "ABUTLERXW-SB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "ABUTLERXW-MB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "ABUTLERLXBPC.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "ABUTLERLXBBB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "ABUTLERLXBBN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "ABUTLERLXBORB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "ABUTLERLXBPB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "ABUTLERLXBPN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "ABUTLERLXBSB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "ABTLRLXBKMB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "ABUTLERLXWPC.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "ABUTLERLXWBB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "ABUTLERLXWBN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "ABUTLERLXWORB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "ABUTLERLXWPB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "ABUTLERLXWPN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "ABUTLERLXWSB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "ABTLRLXWHMB.jpg"
					}
				]
			},
			"partnumber": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.steamHead",
					"_globals.selectedGenerator",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "ABUTLER1B-PC"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "ABUTLER1B-BB"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "ABUTLER1B-BN"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "ABUTLER1B-OR"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "ABUTLER1B-PB"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "ABUTLER1B-PN"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "ABUTLER1B-SB"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "ABUTLER1B-MB"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "ABUTLER1W-PC"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "ABUTLER1W-BB"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "ABUTLER1W-BN"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "ABUTLER1W-OR"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "ABUTLER1W-PB"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "ABUTLER1W-PN"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "ABUTLER1W-SB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "ABTLRLBKPC"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "ABTLRLBKBB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "ABTLRLBKBN"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "ABTLRLBKORB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "ABTLRLBKPB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "ABTLRLBKPN"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "ABTLRLBKSB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "ABTLRLWHPC"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "ABTLRLWHBB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "ABTLRLWHBN"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "ABTLRLWHORB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "ABTLRLWHPB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "ABTLRLWHPN"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "ABTLRLWHSB"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "ABUTLERXB-PC"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "ABUTLERXB-BB"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "ABUTLERXB-BN"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "ABUTLERXB-OR"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "ABUTLERXB-PB"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "ABUTLERXB-PN"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "ABUTLERXB-SB"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "ABUTLERXW-PC"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "ABUTLERXW-BB"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "ABUTLERXW-BN"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "ABUTLERXW-OR"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "ABUTLERXW-PB"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "ABUTLERXW-PN"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "ABUTLERXW-SB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "ABTLRLXBKPC"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "ABTLRLXBKBB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "ABTLRLXBKBN"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "ABTLRLXBKORB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "ABTLRLXBKPB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "ABTLRLXBKPN"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "ABTLRLXBKSB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "ABTLRLXWHPC"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "ABTLRLXWHBB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "ABTLRLXWHBN"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "ABTLRLXWHORB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "ABTLRLXWHPB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "ABTLRLXWHPN"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "ABTLRLXWHSB"
					}
				]
			},
			"package.config.dynamicProducts.selectedGenerator": {
				"keyTemplate": [
					"options.selected.steamHead",
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								"AIRTEMPO_STEAMHEAD",
								null
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": [
							{
								"productId": "AIRTEMPO_STEAMHEAD",
								"quantity": 1
							},
							{
								"productId": "AUTOFLUSH",
								"quantity": 1
							},
							{
								"productId": "Condensation Pan",
								"quantity": 1
							}
						]
					},
					{
						"tally": [
							[
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": [
							{
								"productId": "AIRTEMPO_STEAMHEAD",
								"quantity": 2
							},
							{
								"productId": "AUTOFLUSH",
								"quantity": 2
							},
							{
								"productId": "Condensation Pan",
								"quantity": 2
							}
						]
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								null
							],
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": [
							{
								"productId": "LINEAR_STEAMHEAD",
								"quantity": 1
							},
							{
								"productId": "AUTOFLUSH",
								"quantity": 1
							},
							{
								"productId": "Condensation Pan",
								"quantity": 1
							}
						]
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": [
							{
								"productId": "LINEAR_STEAMHEAD",
								"quantity": 2
							},
							{
								"productId": "AUTOFLUSH",
								"quantity": 2
							},
							{
								"productId": "Condensation Pan",
								"quantity": 2
							}
						]
					}
				]
			}
		},
		"package": {
			"config": {
				"staticProducts": [
					{
						"productId": "AIRTEMPO_CONTROL",
						"quantity": 1
					},
					{
						"productId": "SteamLinx",
						"quantity": 1
					}
				]
			}
		},
		"vSpa": {
			"spaFrameSourceOption": "finish",
			"spaFrameIsVisible": true,
			"standardGeneratorIsVisible": true,
			"isSuperCompatible": true
		}
	},
	{
		"code": "BUTLER_PACKAGE",
		"partnumber": "MSBUTLER",
		"previewname": "Butler Package",
		"name": "Butler Package",
		"price": 2580,
		"descriptions": {
			"short": "Take the stress out of stress relief. Everything you need to get started is in one convenient -- and discounted -- package.",
			"long": "Its never been easier to optimize your steam shower experience. With an elegant design and easy to use interface, you can control more than steam. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center.",
			"tech": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/dcf45949-fdc5-42ac-b825-59f139ef9bff.pdf"
		},
		"taxonomy": {
			"categories": [
				"itempo-plus-controls"
			],
			"sortOrder": {
				"itempo-plus-controls": 1
			},
			"zIndex": {
				"itempo-plus-controls": 1
			}
		},
		"images": {
			"folder": "control-packages/Butler/",
			"thumbnail": "MSBUTLER1SQ-PC.jpg"
		},
		"options": {
			"enabledListsIds": [
				"shape",
				"finish",
				"steamHead"
			],
			"selected": {
				"shape": "SQUARE",
				"color": "BLACK",
				"finish": "POLISHED_CHROME",
				"steamHead": "ITEMPO_STEAMHEAD"
			},
			"list": {
				"shape": [
					"SQUARE",
					"ROUND"
				],
				"finish": [
					"POLISHED_CHROME",
					"BRUSHED_BRONZE",
					"BRUSHED_NICKEL",
					"OIL_RUBBED_BRONZE",
					"POLISHED_BRASS",
					"POLISHED_NICKEL",
					"SATIN_BRASS",
					"WHITE",
					"BLACK",
					"MATTE_BLACK"
				],
				"steamHead": [
					"ITEMPO_STEAMHEAD",
					"LINEAR_STEAMHEAD"
				]
			}
		},
		"dynamicProperties": {
			"price": {
				"keyTemplate": [
					"options.selected.steamHead",
					"_globals.selectedGenerator",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								null,
								"WHITE"
							]
						],
						"value": 2905
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null,
								"WHITE"
							]
						],
						"value": 2580
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								null,
								"BLACK"
							]
						],
						"value": 2905
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null,
								"BLACK"
							]
						],
						"value": 2580
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							]
						],
						"value": 3030
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null,
								"MATTE_BLACK"
							]
						],
						"value": 2730
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							]
						],
						"value": 2905
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"RAW"
							]
						],
						"value": 3030
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							]
						],
						"value": 2580
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								null,
								"RAW"
							]
						],
						"value": 2730
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": 2905
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": 3680
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": 2580
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": 2930
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": 3030
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": 4080
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC2",
								"BRUSHED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": 2730
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": 3230
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": 3030
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": 4080
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": 2730
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": 3230
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": 3030
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": 4080
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": 2730
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": 3230
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": 3030
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": 4080
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": 2730
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": 3230
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": 3030
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": 4080
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": 2730
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": 3230
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": 3030
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": 4080
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": 2730
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": 3230
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": 3030
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": 4080
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": 2730
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": 3230
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": 3030
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": 4080
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": 2730
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": 3230
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": 3030
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": 4080
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": 2730
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": 3230
					}
				]
			},
			"images.thumbnail": {
				"keyTemplate": [
					"options.selected.shape",
					"options.selected.steamHead",
					"_globals.selectedGenerator",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "MSBUTLER1SQ-PC.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "MSBUTLER1SQ-BB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "MSBUTLER1SQ-BN.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "MSBUTLER1SQ-ORB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "MSBUTLER1SQ-PB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "MSBUTLER1SQ-PN.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "MSBUTLER1SQ-SB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "MSBUTLER1SQ-WH.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "MSBUTLER1SQ-BK.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "MSBUTLER1SQ-MB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "MSBUTLER1RD-PC.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "MSBUTLER1RD-BB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "MSBUTLER1RD-BN.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "MSBUTLER1RD-ORB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "MSBUTLER1RD-PB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "MSBUTLER1RD-PN.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "MSBUTLER1RD-SB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "MSBUTLER1RD-WH.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "MSBUTLER1SQ-BK.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "MSBUTLER1RD-MB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BUTLERL1SQPC.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BUTLERL1SQBB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BUTLERL1SQBN.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BUTLERL1SQORB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BUTLERL1SQPB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BUTLERL1SQPN.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BUTLERL1SQSB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "BUTLERL1SQWH.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "BUTLERL1SQBK.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BUTLERL1SQMB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BUTLERL1RDPC.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BUTLERL1RDBB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BUTLERL1RDPN.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BUTLERL1RDORB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BUTLERL1RDPB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BUTLERL1RDPN.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BUTLERL1RDSB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "BUTLERL1RDWH.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "BUTLERL1RDBK.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BUTLERL1RDMB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "MSBUTLERXSQ-PC.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "MSBUTLERXSQ-BB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "MSBUTLERXSQ-BN.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "MSBUTLERXSQ-ORB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "MSBUTLERXSQ-PB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "MSBUTLERXSQ-PN.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "MSBUTLERXSQ-SB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": "MSBUTLERXSQ-BK.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "MSBUTLERXSQ-BK.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": "MSBUTLERXSQ-WH.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "MSBUTLERXRD-PC.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "MSBUTLERXRD-BB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "MSBUTLERXRD-BN.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "MSBUTLERXRD-ORB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "MSBUTLERXRD-PB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "MSBUTLERXRD-PN.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "MSBUTLERXRD-SB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": "MSBUTLERXRD-BK.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "MSBUTLERXRD-BK.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": "MSBUTLERXRD-WH.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BUTLERLXSPC.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BUTLERLXSBB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BUTLERLXSBN.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BUTLERLXSORB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BUTLERLXSPB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BUTLERLXSPN.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BUTLERLXSSB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": "BUTLERLXSWH.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": "BUTLERLXSBK.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BUTLERLXSBK.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BUTLERLXRPC.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BUTLERLXRBB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BUTLERLXRBN.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BUTLERLXRORB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BUTLERLXRPB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BUTLERLXRPN.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BUTLERLXRSB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": "BUTLERLXRWH.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": "BUTLERLXRBK.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BUTLERLXRBK.jpg"
					}
				]
			},
			"descriptions.long": {
				"keyTemplate": [
					"options.selected.shape",
					"options.selected.steamHead",
					"_globals.selectedGenerator",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, an Aroma Designer SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, an Aroma Designer SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, an Aroma Designer SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, an Aroma Designer SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, an Aroma Designer SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, an Aroma Designer SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, an Aroma Designer SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, an Aroma Designer SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, an Aroma Designer SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, an Aroma Designer SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, an Aroma Designer SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, an Aroma Designer SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, an Aroma Designer SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, an Aroma Designer SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, an Aroma Designer SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, an Aroma Designer SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, an Aroma Designer SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, an Aroma Designer SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, an Aroma Designer SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, an Aroma Designer SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "The Butler Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. A matching Linear SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "The Butler Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. A matching Linear SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "The Butler Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. A matching Linear SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "The Butler Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. A matching Linear SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "The Butler Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. A matching Linear SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "The Butler Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. A matching Linear SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "The Butler Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. A matching Linear SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "The Butler Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. A matching Linear SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "The Butler Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. A matching Linear SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "The Butler Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. A matching Linear SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "The Butler Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. A matching Linear SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "The Butler Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. A matching Linear SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "The Butler Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. A matching Linear SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "The Butler Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. A matching Linear SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "The Butler Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. A matching Linear SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "The Butler Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. A matching Linear SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "The Butler Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. A matching Linear SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "The Butler Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. A matching Linear SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "The Butler Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. A matching Linear SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "The Butler Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. A matching Linear SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler MAX Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, two Aroma Glass SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler MAX Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, two Aroma Glass SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler MAX Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, two Aroma Glass SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler MAX Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, two Aroma Glass SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler MAX Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, two Aroma Glass SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler MAX Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, two Aroma Glass SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler MAX Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, two Aroma Glass SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler MAX Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, two Aroma Glass SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler MAX Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, two Aroma Glass SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler MAX Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, two Aroma Glass SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler MAX Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, two Aroma Glass SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler MAX Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, two Aroma Glass SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler MAX Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, two Aroma Glass SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler MAX Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, two Aroma Glass SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler MAX Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, two Aroma Glass SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler MAX Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, two Aroma Glass SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler MAX Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, two Aroma Glass SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler MAX Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, two Aroma Glass SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler MAX Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, two Aroma Glass SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler MAX Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, two Aroma Glass SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "The Butler MAX Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. Two matching Linear SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "The Butler MAX Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. Two matching Linear SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "The Butler MAX Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. Two matching Linear SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "The Butler MAX Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. Two matching Linear SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "The Butler MAX Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. Two matching Linear SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "The Butler MAX Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. Two matching Linear SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "The Butler MAX Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. Two matching Linear SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": "The Butler MAX Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. Two matching Linear SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": "The Butler MAX Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. Two matching Linear SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "The Butler MAX Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. Two matching Linear SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "The Butler MAX Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. Two matching Linear SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "The Butler MAX Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. Two matching Linear SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "The Butler MAX Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. Two matching Linear SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "The Butler MAX Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. Two matching Linear SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "The Butler MAX Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. Two matching Linear SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "The Butler MAX Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. Two matching Linear SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "The Butler MAX Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. Two matching Linear SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": "The Butler MAX Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. Two matching Linear SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": "The Butler MAX Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. Two matching Linear SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "The Butler MAX Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. Two matching Linear SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					}
				]
			},
			"descriptions.tech": {
				"keyTemplate": [
					"options.selected.shape",
					"options.selected.steamHead",
					"_globals.selectedGenerator",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Aroma Designer SteamHeads that match the iTempoPlus Control and feature an oil reservoir discretely hidden at the top of the steam head</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Aroma Designer SteamHeads that match the iTempoPlus Control and feature an oil reservoir discretely hidden at the top of the steam head</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Aroma Designer SteamHeads that match the iTempoPlus Control and feature an oil reservoir discretely hidden at the top of the steam head</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Aroma Designer SteamHeads that match the iTempoPlus Control and feature an oil reservoir discretely hidden at the top of the steam head</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Aroma Designer SteamHeads that match the iTempoPlus Control and feature an oil reservoir discretely hidden at the top of the steam head</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Aroma Designer SteamHeads that match the iTempoPlus Control and feature an oil reservoir discretely hidden at the top of the steam head</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Aroma Designer SteamHeads that match the iTempoPlus Control and feature an oil reservoir discretely hidden at the top of the steam head</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Aroma Designer SteamHeads that match the iTempoPlus Control and feature an oil reservoir discretely hidden at the top of the steam head</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Aroma Designer SteamHeads that match the iTempoPlus Control and feature an oil reservoir discretely hidden at the top of the steam head</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Aroma Designer SteamHeads that match the iTempoPlus Control and feature an oil reservoir discretely hidden at the top of the steam head</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Aroma Designer SteamHeads that match the iTempoPlus Control and feature an oil reservoir discretely hidden at the top of the steam head</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Aroma Designer SteamHeads that match the iTempoPlus Control and feature an oil reservoir discretely hidden at the top of the steam head</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Aroma Designer SteamHeads that match the iTempoPlus Control and feature an oil reservoir discretely hidden at the top of the steam head</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Aroma Designer SteamHeads that match the iTempoPlus Control and feature an oil reservoir discretely hidden at the top of the steam head</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Aroma Designer SteamHeads that match the iTempoPlus Control and feature an oil reservoir discretely hidden at the top of the steam head</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Aroma Designer SteamHeads that match the iTempoPlus Control and feature an oil reservoir discretely hidden at the top of the steam head</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Aroma Designer SteamHeads that match the iTempoPlus Control and feature an oil reservoir discretely hidden at the top of the steam head</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Aroma Designer SteamHeads that match the iTempoPlus Control and feature an oil reservoir discretely hidden at the top of the steam head</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Aroma Designer SteamHeads that match the iTempoPlus Control and feature an oil reservoir discretely hidden at the top of the steam head</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Aroma Designer SteamHeads that match the iTempoPlus Control and feature an oil reservoir discretely hidden at the top of the steam head</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Award-Winning Linear SteamHeads, that are whisper quiet, install flush with the wall and can be tiled so only a slim opening remains visible.</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Award-Winning Linear SteamHeads, that are whisper quiet, install flush with the wall and can be tiled so only a slim opening remains visible.</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Award-Winning Linear SteamHeads, that are whisper quiet, install flush with the wall and can be tiled so only a slim opening remains visible.</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Award-Winning Linear SteamHeads, that are whisper quiet, install flush with the wall and can be tiled so only a slim opening remains visible.</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Award-Winning Linear SteamHeads, that are whisper quiet, install flush with the wall and can be tiled so only a slim opening remains visible.</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Award-Winning Linear SteamHeads, that are whisper quiet, install flush with the wall and can be tiled so only a slim opening remains visible.</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Award-Winning Linear SteamHeads, that are whisper quiet, install flush with the wall and can be tiled so only a slim opening remains visible.</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Award-Winning Linear SteamHeads, that are whisper quiet, install flush with the wall and can be tiled so only a slim opening remains visible.</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Award-Winning Linear SteamHeads, that are whisper quiet, install flush with the wall and can be tiled so only a slim opening remains visible.</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Award-Winning Linear SteamHeads, that are whisper quiet, install flush with the wall and can be tiled so only a slim opening remains visible.</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Award-Winning Linear SteamHeads, that are whisper quiet, install flush with the wall and can be tiled so only a slim opening remains visible.</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Award-Winning Linear SteamHeads, that are whisper quiet, install flush with the wall and can be tiled so only a slim opening remains visible.</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Award-Winning Linear SteamHeads, that are whisper quiet, install flush with the wall and can be tiled so only a slim opening remains visible.</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Award-Winning Linear SteamHeads, that are whisper quiet, install flush with the wall and can be tiled so only a slim opening remains visible.</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Award-Winning Linear SteamHeads, that are whisper quiet, install flush with the wall and can be tiled so only a slim opening remains visible.</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Award-Winning Linear SteamHeads, that are whisper quiet, install flush with the wall and can be tiled so only a slim opening remains visible.</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Award-Winning Linear SteamHeads, that are whisper quiet, install flush with the wall and can be tiled so only a slim opening remains visible.</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Award-Winning Linear SteamHeads, that are whisper quiet, install flush with the wall and can be tiled so only a slim opening remains visible.</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Award-Winning Linear SteamHeads, that are whisper quiet, install flush with the wall and can be tiled so only a slim opening remains visible.</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Award-Winning Linear SteamHeads, that are whisper quiet, install flush with the wall and can be tiled so only a slim opening remains visible.</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					}
				]
			},
			"descriptions.parts": {
				"keyTemplate": [
					"options.selected.shape",
					"options.selected.steamHead",
					"_globals.selectedGenerator",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>iTempo Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>iTempo Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>iTempo Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>iTempo Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>iTempo Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>iTempo Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>iTempo Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>iTempo Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>iTempo Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>iTempo Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>iTempo Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>iTempo Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>iTempo Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>iTempo Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>iTempo Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>iTempo Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>iTempo Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>iTempo Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>iTempo Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>iTempo Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>Linear Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>Linear Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>Linear Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>Linear Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>Linear Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>Linear Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>Linear Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>Linear Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>Linear Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>Linear Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>Linear Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>Linear Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>Linear Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>Linear Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>Linear Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>Linear Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>Linear Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>Linear Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>Linear Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>Linear Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					}
				]
			},
			"partnumber": {
				"keyTemplate": [
					"options.selected.shape",
					"options.selected.steamHead",
					"_globals.selectedGenerator",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "MSBUTLER1SQ-PC"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "MSBUTLER1SQ-BB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "MSBUTLER1SQ-BN"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "MSBUTLER1SQ-ORB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "MSBUTLER1SQ-PB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "MSBUTLER1SQ-PN"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "MSBUTLER1SQ-SB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "MSBUTLER1SQ-WH"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "MSBUTLER1SQ-BK"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "MSBUTLER1SQ-MB"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "MSBUTLER1RD-PC"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "MSBUTLER1RD-BB"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "MSBUTLER1RD-BN"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "MSBUTLER1RD-ORB"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "MSBUTLER1RD-PB"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "MSBUTLER1RD-PN"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "MSBUTLER1RD-SB"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "MSBUTLER1RD-WH"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "MSBUTLER1RD-BK"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "MSBUTLER1RD-MB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BTLRL1SPC"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BTLRL1SBB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BTLRL1SBN"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BTLRL1SORB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BTLRL1SPB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BTLRL1SPN"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BTLRL1SSB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "BTLRL1SWH"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "BTLRL1SBK"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BTLRL1SMB"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BTLRL1RPC"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BTLRL1RBB"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BTLRL1RBN"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BTLRL1RORB"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BTLRL1RPB"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BTLRL1RPN"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BTLRL1RSB"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "BTLRL1RWH"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "BTLRL1RBK"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BTLRL1RMB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "MSBUTLERXSQ-PC"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "MSBUTLERXSQ-BB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "MSBUTLERXSQ-BN"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "MSBUTLERXSQ-ORB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "MSBUTLERXSQ-PB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "MSBUTLERXSQ-PN"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "MSBUTLERXSQ-SB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": "MSBUTLERXSQ-BK"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "MSBUTLERXSQ-MB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": "MSBUTLERXSQ-WH"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "MSBUTLERXRD-PC"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "MSBUTLERXRD-BB"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "MSBUTLERXRD-BN"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "MSBUTLERXRD-ORB"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "MSBUTLERXRD-PB"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "MSBUTLERXRD-PN"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "MSBUTLERXRD-SB"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": "MSBUTLERXRD-BK"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "MSBUTLERXRD-MB"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": "MSBUTLERXRD-WH"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BTLRLXSPC"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BTLRLXSBB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BTLRLXSBN"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BTLRLXSORB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BTLRLXSPB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BTLRLXSPN"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BTLRLXSSB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							]
						],
						"value": "BTLRLXSWH"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": "BTLRLXSBK"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BTLRLXSMB"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BTLRLXRPC"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BTLRLXRBB"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BTLRLXRBN"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BTLRLXRORB"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BTLRLXRPB"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BTLRLXRPN"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BTLRLXRSB"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": "BTLRLXRWH"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": "BTLRLXRBK"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BTLRLXRMB"
					}
				]
			},
			"package.config.dynamicProducts.selectedGenerator": {
				"keyTemplate": [
					"options.selected.steamHead",
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS90EC1"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS150EC1"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS225EC1"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS400EC1"
							]
						],
						"value": [
							{
								"productId": "ITEMPO_STEAMHEAD",
								"quantity": 1
							},
							{
								"productId": "AUTOFLUSH",
								"quantity": 1
							},
							{
								"productId": "Condensation Pan",
								"quantity": 1
							}
						]
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX4EC1"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX5EC1"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": [
							{
								"productId": "ITEMPO_STEAMHEAD",
								"quantity": 2
							},
							{
								"productId": "AUTOFLUSH",
								"quantity": 2
							},
							{
								"productId": "Condensation Pan",
								"quantity": 2
							}
						]
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								null
							],
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1"
							]
						],
						"value": [
							{
								"productId": "LINEAR_STEAMHEAD",
								"quantity": 1
							},
							{
								"productId": "AUTOFLUSH",
								"quantity": 1
							},
							{
								"productId": "Condensation Pan",
								"quantity": 1
							}
						]
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": [
							{
								"productId": "LINEAR_STEAMHEAD",
								"quantity": 2
							},
							{
								"productId": "AUTOFLUSH",
								"quantity": 2
							},
							{
								"productId": "Condensation Pan",
								"quantity": 2
							}
						]
					}
				]
			}
		},
		"package": {
			"config": {
				"staticProducts": [
					{
						"productId": "ITEMPO_CONTROL",
						"quantity": 1
					},
					{
						"productId": "SteamLinx",
						"quantity": 1
					}
				]
			}
		},
		"vSpa": {
			"spaFrameSourceOption": "finish",
			"spaFrameIsVisible": true,
			"standardGeneratorIsVisible": true,
			"isSuperCompatible": true
		}
	},
	{
		"code": "BASIC_BUTLER_PACKAGE",
		"partnumber": "MSBUTLER",
		"previewname": " Basic Butler Package",
		"name": "Basic Butler Package",
		"price": 1695,
		"descriptions": {
			"short": "Take the stress out of stress relief. Everything you need to get started is in one convenient -- and discounted -- package.",
			"long": "All the elements you need to add steam to your home.  This package featuring the classic iTempo Control. Forged from solid brass and available in your choice of 10 designer finishes, iTempo and the matching Linear steam head meshes seamlessly with any bathroom décor.",
			"tech": "<li>Compliment any bathroom design with one of 11 designer or glass finishes</li><li>Includes matching Aroma SteamHead</li><li>iTempo Control Mounts flush to the wall</li><li>Digital display lets you program temperature</li><li>Set the duration of your steam sessions</li><li>Compatible with SteamLinx Module</li><li>iTempo is manufactured in strong, durable and long-lasting solid brass</li>"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/df2b1337-01b2-4585-9212-3d9211ff9697.pdf"
		},
		"taxonomy": {
			"categories": [
				"itempo-controls"
			],
			"sortOrder": {
				"itempo-controls": 1
			},
			"zIndex": {
				"itempo-controls": 1
			}
		},
		"images": {
			"folder": "control-packages/BasicButler/",
			"thumbnail": "BBUTLERSPC.jpg"
		},
		"options": {
			"enabledListsIds": [
				"shape",
				"finish",
				"steamHead"
			],
			"selected": {
				"shape": "SQUARE",
				"color": "BLACK",
				"finish": "POLISHED_CHROME",
				"steamHead": "ITEMPO_STEAMHEAD"
			},
			"list": {
				"shape": [
					"SQUARE",
					"ROUND"
				],
				"finish": [
					"POLISHED_CHROME",
					"BRUSHED_BRONZE",
					"BRUSHED_NICKEL",
					"OIL_RUBBED_BRONZE",
					"POLISHED_BRASS",
					"POLISHED_NICKEL",
					"SATIN_BRASS",
					"WHITE",
					"BLACK",
					"MATTE_BLACK",
					"RAW"
				],
				"steamHead": [
					"ITEMPO_STEAMHEAD",
					"LINEAR_STEAMHEAD"
				]
			}
		},
		"dynamicProperties": {
			"price": {
				"keyTemplate": [
					"options.selected.steamHead",
					"_globals.selectedGenerator",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								null,
								"WHITE"
							]
						],
						"value": 1850
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null,
								"WHITE"
							]
						],
						"value": 1550
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								null,
								"BLACK"
							]
						],
						"value": 1850
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null,
								"BLACK"
							]
						],
						"value": 1550
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							]
						],
						"value": 1850
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null,
								"MATTE_BLACK"
							]
						],
						"value": 1550
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							]
						],
						"value": 2195
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							]
						],
						"value": 2545
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							]
						],
						"value": 1695
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								null,
								"SATIN_BRASS"
							]
						],
						"value": 1895
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": 2195
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": 2195
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": 1695
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": 1695
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": 2545
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": 2545
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC2",
								"BRUSHED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": 1895
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": 1895
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": 2545
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": 2545
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": 1895
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": 1895
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": 2545
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": 2545
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": 1895
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": 1895
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": 2545
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": 2545
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": 1895
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": 1895
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": 2545
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": 2545
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": 1895
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": 1895
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": 2545
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": 2545
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": 1895
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": 1895
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": 2545
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": 2545
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": 1895
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": 1895
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": 2545
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": 2545
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": 1895
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": 1895
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": 2545
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": 2545
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": 1895
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": 1895
					}
				]
			},
			"images.thumbnail": {
				"keyTemplate": [
					"options.selected.shape",
					"options.selected.steamHead",
					"_globals.selectedGenerator",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BBUTLERSPC.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BBUTLERSBB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BBUTLERSBN.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BBUTLERSORB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BBUTLERSPB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BBUTLERSPN.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BBUTLERSSB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "BBUTLERSWH.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "BBUTLERSBK.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BBUTLERSMB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"RAW"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"RAW"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"RAW"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"RAW"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"RAW"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"RAW"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"RAW"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"RAW"
							]
						],
						"value": "BBUTLERSRAW.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BBUTLERRPC.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BBUTLERRBB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BBUTLERRBN.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BBUTLERRORB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BBUTLERRPB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BBUTLERRPN.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BBUTLERRSB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "BBUTLERRWH.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "BBUTLERRBK.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BBUTLERRMB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"RAW"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"RAW"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"RAW"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"RAW"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"RAW"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"RAW"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"RAW"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"RAW"
							]
						],
						"value": "BBUTLERRRAW.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BBUTLERLSPC.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BBUTLERLSBB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BBUTLERLSBN.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BBUTLERLSORB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BBUTLERLSPB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BBUTLERLSPN.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BBUTLERLSSB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "BBUTLERLSWH.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "BBUTLERLSBK.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BBUTLERLSMB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"RAW"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"RAW"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"RAW"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"RAW"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"RAW"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"RAW"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"RAW"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"RAW"
							]
						],
						"value": "BBUTLERLSRAW.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BBUTLERLRPC.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BBUTLERLRBB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BBUTLERLRBN.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BBUTLERLRORB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BBUTLERLRPB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BBUTLERLRPN.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BBUTLERLRSB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "BBUTLERLRWH.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "BBUTLERLRBK.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BBUTLERLRMB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"RAW"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"RAW"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"RAW"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"RAW"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"RAW"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"RAW"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"RAW"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"RAW"
							]
						],
						"value": "BBUTLERLRRAW.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "MSBUTLERXSQ-PC.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "MSBUTLERXSQ-BB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "MSBUTLERXSQ-BN.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "MSBUTLERXSQ-ORB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "MSBUTLERXSQ-PB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "MSBUTLERXSQ-PN.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "MSBUTLERXSQ-SB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "MSBUTLERXSQ-BK.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": "MSBUTLERXSQ-WH.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "MSBUTLERXSQ-MB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"RAW"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"RAW"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"RAW"
							]
						],
						"value": "MSBUTLERXSQ-RAW.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "MSBUTLERXRD-PC.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "MSBUTLERXRD-BB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "MSBUTLERXRD-BN.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "MSBUTLERXRD-ORB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "MSBUTLERXRD-PB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "MSBUTLERXRD-PN.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "MSBUTLERXRD-SB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "MSBUTLERXRD-MB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": "MSBUTLERXRD-WH.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"RAW"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"RAW"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"RAW"
							]
						],
						"value": "MSBUTLERXRD-RAW.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"RAW"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"RAW"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"RAW"
							]
						],
						"value": "MSBUTLERXRD-RAW.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BUTLERLXSPC.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BUTLERLXSBB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BUTLERLXSBN.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BUTLERLXSORB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BUTLERLXSPB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BUTLERLXSPN.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BUTLERLXSSB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							]
						],
						"value": "BUTLERLXSWH.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": "BUTLERLXSBK.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BUTLERLXSMB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"RAW"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"RAW"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"RAW"
							]
						],
						"value": "BUTLERLXSRAW.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BUTLERLXRPC.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BUTLERLXRBB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BUTLERLXRBN.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BUTLERLXRORB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BUTLERLXRPB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BUTLERLXRPN.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BUTLERLXRSB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": "BUTLERLXRWH.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": "BUTLERLXRBK.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BUTLERLXRMB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"RAW"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"RAW"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"RAW"
							]
						],
						"value": "BUTLERLXRRAW.jpg"
					}
				]
			},
			"descriptions.parts": {
				"keyTemplate": [
					"options.selected.shape",
					"options.selected.steamHead",
					"_globals.selectedGenerator",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					}
				]
			},
			"partnumber": {
				"keyTemplate": [
					"options.selected.shape",
					"options.selected.steamHead",
					"_globals.selectedGenerator",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BBUTLERSPC"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BBUTLERSBB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BBUTLERSBN"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BBUTLERSORB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BBUTLERSPB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BBUTLERSPN"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BBUTLERSSB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "BBUTLERSWH"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "BBUTLERSBK"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BBUTLERSMB"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BBUTLERRPC"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BBUTLERRBB"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BBUTLERRBN"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BBUTLERRORB"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BBUTLERRPB"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BBUTLERRPN"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BBUTLERRSB"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "BBUTLERRWH"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "BBUTLERRBK"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BBUTLERRMB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BBUTLERLSPC"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BBUTLERLSBB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BBUTLERLSBN"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BBUTLERLSORB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BBUTLERLSPB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BBUTLERLSPN"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BBUTLERLSSB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "BBUTLERLSWH"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "BBUTLERLSBK"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BBUTLERLSMB"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BBUTLERLRPC"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BBUTLERLRBB"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BBUTLERLRBN"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BBUTLERLRORB"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BBUTLERLRPB"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BBUTLERLRPN"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BBUTLERLRSB"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "BBUTLERLRWH"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "BBUTLERLRBK"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BBUTLERLRMB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "MSBUTLERXSQ-PC"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "MSBUTLERXSQ-BB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "MSBUTLERXSQ-BN"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "MSBUTLERXSQ-ORB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "MSBUTLERXSQ-PB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "MSBUTLERXSQ-PN"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "MSBUTLERXSQ-SB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": "MSBUTLERXSQ-BK"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "MSBUTLERXSQ-MB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": "MSBUTLERXSQ-WH"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "MSBUTLERXRD-PC"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "MSBUTLERXRD-BB"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "MSBUTLERXRD-BN"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "MSBUTLERXRD-ORB"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "MSBUTLERXRD-PB"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "MSBUTLERXRD-PN"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "MSBUTLERXRD-SB"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": "MSBUTLERXRD-BK"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "MSBUTLERXRD-MB"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": "MSBUTLERXRD-WH"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BUTLERLXSPC"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BUTLERLXSBB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BUTLERLXSBN"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BUTLERLXSORB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BUTLERLXSPB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BUTLERLXSPN"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BUTLERLXSSB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							]
						],
						"value": "BUTLERLXSWH"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": "BUTLERLXSBK"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BUTLERLXSMB"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BUTLERLXRPC"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BUTLERLXRBB"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BUTLERLXRBN"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BUTLERLXRORB"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BUTLERLXRPB"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BUTLERLXRPN"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BUTLERLXRSB"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": "BUTLERLXRWH"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": "BUTLERLXRBK"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BUTLERLXRMB"
					}
				]
			},
			"package.config.dynamicProducts.selectedGenerator": {
				"keyTemplate": [
					"options.selected.steamHead",
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS90EC1"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS150EC1"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS225EC1"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS400EC1"
							]
						],
						"value": [
							{
								"productId": "ITEMPO_STEAMHEAD",
								"quantity": 1
							},
							{
								"productId": "AUTOFLUSH",
								"quantity": 1
							},
							{
								"productId": "Condensation Pan",
								"quantity": 1
							}
						]
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX4EC1"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX5EC1"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": [
							{
								"productId": "ITEMPO_STEAMHEAD",
								"quantity": 2
							},
							{
								"productId": "AUTOFLUSH",
								"quantity": 2
							},
							{
								"productId": "Condensation Pan",
								"quantity": 2
							}
						]
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								null
							],
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1"
							]
						],
						"value": [
							{
								"productId": "LINEAR_STEAMHEAD",
								"quantity": 1
							},
							{
								"productId": "AUTOFLUSH",
								"quantity": 1
							},
							{
								"productId": "Condensation Pan",
								"quantity": 1
							}
						]
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": [
							{
								"productId": "LINEAR_STEAMHEAD",
								"quantity": 2
							},
							{
								"productId": "AUTOFLUSH",
								"quantity": 2
							},
							{
								"productId": "Condensation Pan",
								"quantity": 2
							}
						]
					}
				]
			}
		},
		"package": {
			"config": {
				"staticProducts": [
					{
						"productId": "ITEMPO_CONTROL",
						"quantity": 1
					},
					{
						"productId": "SteamLinx",
						"quantity": 1
					}
				]
			}
		},
		"vSpa": {
			"spaFrameSourceOption": "finish",
			"spaFrameIsVisible": true,
			"standardGeneratorIsVisible": true,
			"isSuperCompatible": true
		}
	},
	{
		"code": "DIGITAL_TIMER",
		"partnumber": "103588DIG",
		"previewname": "Digital Timer",
		"name": "Digital Timer",
		"price": 120,
		"descriptions": {
			"short": "Digital Timer",
			"long": "Ready When You Are In-wall, 24-hour electronic timer for pre-start and automatic shut-off of the towel warmer at programmed times. White plate standard. Designer finishes plates available."
		},
		"links": {
			"tech": "http://www.mrsteam.com/Media/Default/Products/DigitalTimer/Digital%20Timer%20Technical%20Sheet.pdf"
		},
		"taxonomy": {
			"categories": [
				"towel-warmers-accessories"
			]
		},
		"images": {
			"folder": "towel-warmers-accessories/Digital-Timer/",
			"thumbnail": "DigitalTimer.jpg",
			"scene": "DigitalTimer.png"
		},
		"options": {
			"enabledListsIds": [
				"finish"
			],
			"selected": {
				"finish": "POLISHED_CHROME"
			},
			"list": {
				"finish": [
					"POLISHED_CHROME",
					"BRUSHED_NICKEL",
					"OIL_RUBBED_BRONZE",
					"POLISHED_NICKEL",
					"STAINLESS_STEEL_BRUSHED",
					"STAINLESS_STEEL_POLISHED",
					"WHITE"
				]
			}
		},
		"dynamicProperties": {
			"images.scene": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"POLISHED_CHROME"
							]
						],
						"value": "DigitalTimer-PolishedChrome.png"
					},
					{
						"tally": [
							[
								"BRUSHED_NICKEL"
							]
						],
						"value": "DigitalTimer-BrushedNickel.png"
					},
					{
						"tally": [
							[
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "DigitalTimer-OilRubbedBronze.png"
					},
					{
						"tally": [
							[
								"POLISHED_NICKEL"
							]
						],
						"value": "DigitalTimer-PolishedNickel.png"
					},
					{
						"tally": [
							[
								"STAINLESS_STEEL_BRUSHED"
							]
						],
						"value": "DigitalTimer-StainlessSteelBrushed.png"
					},
					{
						"tally": [
							[
								"STAINLESS_STEEL_POLISHED"
							]
						],
						"value": "DigitalTimer-StainlessSteelPolished.png"
					},
					{
						"tally": [
							[
								"WHITE"
							]
						],
						"value": "DigitalTimer-White.png"
					}
				]
			},
			"price": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"POLISHED_CHROME"
							]
						],
						"value": 120
					},
					{
						"tally": [
							[
								"BRUSHED_NICKEL"
							],
							[
								"OIL_RUBBED_BRONZE"
							],
							[
								"POLISHED_NICKEL"
							],
							[
								"STAINLESS_STEEL_BRUSHED"
							],
							[
								"STAINLESS_STEEL_POLISHED"
							],
							[
								"WHITE"
							]
						],
						"value": 130
					}
				]
			}
		},
		"tooltips": {
			"list": [
				{
					"top": 50,
					"left": 88.8,
					"height": 6,
					"width": 3
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false
		}
	},
	{
		"code": "xDream_PACKAGE",
		"partnumber": "xDream",
		"previewname": "xDream Package",
		"name": "xDream Package",
		"price": 6900,
		"descriptions": {
			"short": "Innovation, luxury, and ease are at the core of the flagship xDream spa package.",
			"long": "<p align=”justify”>Your dream steam shower has arrived. The xDream Package allows you to take total control over every detail of your steam shower experience. With the sophisticated and intuitive iSteamX, Chroma, Aroma, and Music Therapy systems, AromaGlass Steam Head, AutoFlush system, and more.</p>",
			"tech": "<p align=”justify”><li>The xDream Package includes the iSteamX control, intuitively designed for a tailored user experience</li><li>The xDream Package includes the Aroma Glass SteamHead, available in many designer finishes to match any décor</li><li>Package includes the Bluetooth audio sound AudioX System designed for wet, high-heat environments</li><li>Package includes the ChromaX System offering 78,N/AN/AN/A color selection possibilities</li><li>Package includes the AromaSteam System which directly infuses aroma fragrance into the steam line</li><li>Package includes a 1-liter bottle of Eucalyptus Fragrance for use with the Aroma Steam System</li><li>Package includes the AutoFlush System, offering clean steam every time</li><li>Package includes a Condensation Pan</li></p>",
			"parts": "test"
		},
		"links": {
			"tech": "https://pim.mrsteam.com/Resources/Entities/MRSTEAM/Documents/64fcb529-4d88-43ae-9c27-a25d27512a34.pdf"
		},
		"taxonomy": {
			"categories": [
				"isteamx-touch-screen-controls"
			]
		},
		"images": {
			"folder": "control-packages/xDream/",
			"thumbnail": "XDRM1BKPC.jpg",
			"scene": "idream_package_black.png"
		},
		"options": {
			"enabledListsIds": [
				"color",
				"finish",
				"steamHead"
			],
			"selected": {
				"shape": "SQUARE",
				"color": "BLACK",
				"finish": "POLISHED_CHROME",
				"steamHead": "ISTEAM_STEAMHEAD"
			},
			"list": {
				"color": [
					"BLACK",
					"WHITE"
				],
				"steamHead": [
					"ISTEAM_STEAMHEAD",
					"LINEAR_STEAMHEAD"
				],
				"finish": [
					"POLISHED_CHROME",
					"BRUSHED_BRONZE",
					"BRUSHED_NICKEL",
					"OIL_RUBBED_BRONZE",
					"POLISHED_BRASS",
					"POLISHED_NICKEL",
					"SATIN_BRASS",
					"MATTE_BLACK"
				]
			}
		},
		"dynamicProperties": {
			"price": {
				"keyTemplate": [
					"options.selected.steamHead",
					"_globals.selectedGenerator",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							]
						],
						"value": 7200
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							]
						],
						"value": 7500
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							]
						],
						"value": 6900
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								null,
								"MATTE_BLACK"
							]
						],
						"value": 7100
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": 7200
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": 7200
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": 8000
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": 6900
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": 7200
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": 7500
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": 8300
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": 7100
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": 7400
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": 7500
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": 8300
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": 7100
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": 7400
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": 7500
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": 8300
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": 7100
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": 7400
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": 7500
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": 8300
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": 7100
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": 7400
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": 7500
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": 8300
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": 7100
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": 7400
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": 7500
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": 8300
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": 7100
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": 7400
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": 7500
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": 8300
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": 7100
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": 7400
					}
				]
			},
			"descriptions.long": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.steamHead",
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<p align=”justify”>Your dream steam shower has arrived. The xDream Package allows you to take total control over every detail of your steam shower experience. With the sophisticated and intuitive iSteamX, Chroma, Aroma, and Music Therapy systems, AromaGlass Steam Head, AutoFlush system, and more.</p>"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<p align=”justify”>Your dream steam shower has arrived. The xDream Package allows you to take total control over every detail of your steam shower experience. With the sophisticated and intuitive iSteamX, Chroma, Aroma, and Music Therapy systems, AromaGlass Steam Head, AutoFlush system, and more.</p>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<p align=”justify”>Your dream steam shower has arrived. The xDream Package allows you to take total control over every detail of your steam shower experience. With the sophisticated and intuitive iSteamX, Chroma, Aroma, and Music Therapy systems, AromaGlass Steam Head, AutoFlush system, and more.</p>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<p align=”justify”>Your dream steam shower has arrived. The xDream Package allows you to take total control over every detail of your steam shower experience. With the sophisticated and intuitive iSteamX, Chroma, Aroma, and Music Therapy systems, AromaGlass Steam Head, AutoFlush system, and more.</p>"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<p align=”justify”>Your dream steam shower has arrived. The xDream Package allows you to take total control over every detail of your steam shower experience. With the sophisticated and intuitive iSteamX, Chroma, Aroma, and Music Therapy systems, AromaGlass Steam Head, AutoFlush system, and more.</p>"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<p align=”justify”>Your dream steam shower has arrived. The xDream Package allows you to take total control over every detail of your steam shower experience. With the sophisticated and intuitive iSteamX, Chroma, Aroma, and Music Therapy systems, AromaGlass Steam Head, AutoFlush system, and more.</p>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<p align=”justify”>Your dream steam shower has arrived. The xDream Package allows you to take total control over every detail of your steam shower experience. With the sophisticated and intuitive iSteamX, Chroma, Aroma, and Music Therapy systems, AromaGlass Steam Head, AutoFlush system, and more.</p>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<p align=”justify”>Your dream steam shower has arrived. The xDream Package allows you to take total control over every detail of your steam shower experience. With the sophisticated and intuitive iSteamX, Chroma, Aroma, and Music Therapy systems, AromaGlass Steam Head, AutoFlush system, and more.</p>"
					}
				]
			},
			"descriptions.tech": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.steamHead",
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<p align=”justify”><li>The xDream Package includes the iSteamX control, intuitively designed for a tailored user experience</li><li>The xDream Package includes the Aroma Glass SteamHead, available in many designer finishes to match any décor</li><li>Package includes the Bluetooth audio sound AudioX System designed for wet, high-heat environments</li><li>Package includes the ChromaX System offering 78,N/AN/AN/A color selection possibilities</li><li>Package includes the AromaSteam System which directly infuses aroma fragrance into the steam line</li><li>Package includes a 1-liter bottle of Eucalyptus Fragrance for use with the Aroma Steam System</li><li>Package includes the AutoFlush System, offering clean steam every time</li><li>Package includes a Condensation Pan</li></p>"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<p align=”justify”><li>The xDream Package includes the iSteamX control, intuitively designed for a tailored user experience</li><li>The xDream Package includes the Aroma Glass SteamHead, available in many designer finishes to match any décor</li><li>Package includes the Bluetooth audio sound AudioX System designed for wet, high-heat environments</li><li>Package includes the ChromaX System offering 78,N/AN/AN/A color selection possibilities</li><li>Package includes the AromaSteam System which directly infuses aroma fragrance into the steam line</li><li>Package includes a 1-liter bottle of Eucalyptus Fragrance for use with the Aroma Steam System</li><li>Package includes the AutoFlush System, offering clean steam every time</li><li>Package includes a Condensation Pan</li></p>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<p align=”justify”><li>The xDream Package includes the iSteamX control, intuitively designed for a tailored user experience</li><li>The xDream Package includes the Aroma Glass SteamHead, available in many designer finishes to match any décor</li><li>Package includes the Bluetooth audio sound AudioX System designed for wet, high-heat environments</li><li>Package includes the ChromaX System offering 78,N/AN/AN/A color selection possibilities</li><li>Package includes the AromaSteam System which directly infuses aroma fragrance into the steam line</li><li>Package includes a 1-liter bottle of Eucalyptus Fragrance for use with the Aroma Steam System</li><li>Package includes the AutoFlush System, offering clean steam every time</li><li>Package includes a Condensation Pan</li></p>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<p align=”justify”><li>The xDream Package includes the iSteamX control, intuitively designed for a tailored user experience</li><li>The xDream Package includes the Aroma Glass SteamHead, available in many designer finishes to match any décor</li><li>Package includes the Bluetooth audio sound AudioX System designed for wet, high-heat environments</li><li>Package includes the ChromaX System offering 78,N/AN/AN/A color selection possibilities</li><li>Package includes the AromaSteam System which directly infuses aroma fragrance into the steam line</li><li>Package includes a 1-liter bottle of Eucalyptus Fragrance for use with the Aroma Steam System</li><li>Package includes the AutoFlush System, offering clean steam every time</li><li>Package includes a Condensation Pan</li></p>"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<p align=”justify”><li>The xDream Package includes the iSteamX control, intuitively designed for a tailored user experience</li><li>The xDream Package includes the Aroma Glass SteamHead, available in many designer finishes to match any décor</li><li>Package includes the Bluetooth audio sound AudioX System designed for wet, high-heat environments</li><li>Package includes the ChromaX System offering 78,N/AN/AN/A color selection possibilities</li><li>Package includes the AromaSteam System which directly infuses aroma fragrance into the steam line</li><li>Package includes a 1-liter bottle of Eucalyptus Fragrance for use with the Aroma Steam System</li><li>Package includes the AutoFlush System, offering clean steam every time</li><li>Package includes a Condensation Pan</li></p>"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<p align=”justify”><li>The xDream Package includes the iSteamX control, intuitively designed for a tailored user experience</li><li>The xDream Package includes the Aroma Glass SteamHead, available in many designer finishes to match any décor</li><li>Package includes the Bluetooth audio sound AudioX System designed for wet, high-heat environments</li><li>Package includes the ChromaX System offering 78,N/AN/AN/A color selection possibilities</li><li>Package includes the AromaSteam System which directly infuses aroma fragrance into the steam line</li><li>Package includes a 1-liter bottle of Eucalyptus Fragrance for use with the Aroma Steam System</li><li>Package includes the AutoFlush System, offering clean steam every time</li><li>Package includes a Condensation Pan</li></p>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<p align=”justify”><li>The xDream Package includes the iSteamX control, intuitively designed for a tailored user experience</li><li>The xDream Package includes the Aroma Glass SteamHead, available in many designer finishes to match any décor</li><li>Package includes the Bluetooth audio sound AudioX System designed for wet, high-heat environments</li><li>Package includes the ChromaX System offering 78,N/AN/AN/A color selection possibilities</li><li>Package includes the AromaSteam System which directly infuses aroma fragrance into the steam line</li><li>Package includes a 1-liter bottle of Eucalyptus Fragrance for use with the Aroma Steam System</li><li>Package includes the AutoFlush System, offering clean steam every time</li><li>Package includes a Condensation Pan</li></p>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<p align=”justify”><li>The xDream Package includes the iSteamX control, intuitively designed for a tailored user experience</li><li>The xDream Package includes the Aroma Glass SteamHead, available in many designer finishes to match any décor</li><li>Package includes the Bluetooth audio sound AudioX System designed for wet, high-heat environments</li><li>Package includes the ChromaX System offering 78,N/AN/AN/A color selection possibilities</li><li>Package includes the AromaSteam System which directly infuses aroma fragrance into the steam line</li><li>Package includes a 1-liter bottle of Eucalyptus Fragrance for use with the Aroma Steam System</li><li>Package includes the AutoFlush System, offering clean steam every time</li><li>Package includes a Condensation Pan</li></p>"
					}
				]
			},
			"descriptions.parts": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.steamHead",
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<li>  (1) iSteamX Touch Screen Control in black  </li><li>(1) Aroma Glass SteamHead </li><li>(1) SteamLinx</li><li>(1) AutoFlush </li><li>(1) Condensation Pan</li><li> (1) AromaSteam Oil Delivery System </li><li>(1) ChromaX Mood Lighting System</li><li>(1) Pair of Square In-shower Music Therapy Speakers in black</li><li>(1) Liter Eucalyptus Oil with Caddy</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<li>  (1) iSteamX Touch Screen Control in white  </li><li>(1) Aroma Glass SteamHead </li><li>(1) SteamLinx</li><li>(1) AutoFlush </li><li>(1) Condensation Pan</li><li> (1) AromaSteam Oil Delivery System </li><li>(1) ChromaX Mood Lighting System</li><li>(1) Pair of Square In-shower Music Therapy Speakers in white</li><li>(1) Liter Eucalyptus Oil with Caddy</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<li>  (1) iSteamX Touch Screen Control in black  </li><li>(1) 16 inch Linear SteamHead  </li><li>(1) SteamLinx</li><li>(1) AutoFlush </li><li>(1) Condensation Pan</li><li> (1) AromaSteam Oil Delivery System </li><li>(1) ChromaX Mood Lighting System</li><li>(1) Pair of Square In-shower Music Therapy Speakers in black</li><li>(1) Liter Eucalyptus Oil with Caddy</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<li>  (1) iSteamX Touch Screen Control in white  </li><li>(1) 16 inch Linear SteamHead  </li><li>(1) SteamLinx</li><li>(1) AutoFlush </li><li>(1) Condensation Pan</li><li> (1) AromaSteam Oil Delivery System </li><li>(1) ChromaX Mood Lighting System</li><li>(1) Pair of Square In-shower Music Therapy Speakers in white</li><li>(1) Liter Eucalyptus Oil with Caddy</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<li>  (1) iSteamX Touch Screen Control in black  </li><li> (2) AromaSteam Glass SteamHeads in black   </li><li>(1) SteamLinx</li><li>(1) Max AutoFlush </li><li>(1) Max Condensation Pan</li><li> (1) AromaSteam Oil Delivery System with Caddy</li><li>(1) ChromaX Mood Lighting System</li><li>(1) Pair of Square In-shower Music Therapy Speakers in black</li><li>(1) Liter Eucalyptus Oil with Caddy</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<li>  (1) iSteamX Touch Screen Control in white  </li><li> (2) AromaSteam Glass SteamHeads in white   </li><li>(1) SteamLinx</li><li>(1) Max AutoFlush </li><li>(1) Max Condensation Pan</li><li> (1) AromaSteam Oil Delivery System with Caddy</li><li>(1) ChromaX Mood Lighting System</li><li>(1) Pair of Square In-shower Music Therapy Speakers in white</li><li>(1) Liter Eucalyptus Oil with Caddy</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<li>  (1) iSteamX Touch Screen Control in black  </li><li> (2)  Linear SteamHeads in black   </li><li>(1) SteamLinx</li><li>(1) Max AutoFlush </li><li>(1) Max Condensation Pan</li><li> (1) AromaSteam Oil Delivery System with Caddy</li><li>(1) ChromaX Mood Lighting System</li><li>(1) Pair of Square In-shower Music Therapy Speakers in black</li><li>(1) Liter Eucalyptus Oil with Caddy</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<li>  (1) iSteamX Touch Screen Control in white  </li><li> (2)  Linear SteamHeads in white   </li><li>(1) SteamLinx</li><li>(1) Max AutoFlush </li><li>(1) Max Condensation Pan</li><li> (1) AromaSteam Oil Delivery System with Caddy</li><li>(1) ChromaX Mood Lighting System</li><li>(1) Pair of Square In-shower Music Therapy Speakers in white</li><li>(1) Liter Eucalyptus Oil with Caddy</li>"
					}
				]
			},
			"images.scene": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.steamHead",
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "idream_package_black.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "idream_package_2_black.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "idream_package_white.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "idream_package_2_white.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "idream_linear_package_black.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "idream_2_linear_package_black.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "idream_linear_package_white.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "idream_2_linear_package_white.png"
					}
				]
			},
			"partnumber": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.steamHead",
					"_globals.selectedGenerator",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XDRM1BKPC"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XDRM1BKBB"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XDRM1BKBN"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XDRM1BKOR"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XDRM1BKPB"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XDRM1BKPN"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XDRM1BKSB"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XDRM1BKMB"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XDRM1WHPC"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XDRM1WHBB"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XDRM1WHBN"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XDRM1WHOB"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XDRM1WHPB"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XDRM1WHPN"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XDRM1WHSB"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XDRM1WHMB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XDRM1BKLPC"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XDRM1BKLBB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XDRM1BKLBN"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XDRM1BKLORB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XDRM1BKLPB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XDRM1BKLPN"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XDRM1BKLSB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XDRM1BKLMB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XDRM1WHLPC"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XDRM1WHLBB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XDRM1WHLBN"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XDRM1WHLOR"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XDRM1WHLPB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XDRM1WHLPN"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XDRM1WHLSB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XDRM1WHLMB"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XDRM1BKXPC"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XDRM1BKXBB"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XDRM1BKXBN"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XDRM1BKXOR"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XDRM1BKXPB"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XDRM1BKXPN"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XDRM1BKXSB"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XDRM1BKXMB"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XDRM1WHXPC"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XDRM1WHXBB"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XDRM1WHXBN"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XDRM1WHXOR"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XDRM1WHXPB"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XDRM1WHXPN"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XDRM1WHXSB"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XDRM1WHXMB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XDRM1BKXLPC"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XDRM1BKXLBB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XDRM1BKXLBN"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XDRM1BKXLORB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XDRM1BKXLPB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XDRM1BKXLPN"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XDRM1BKXLSB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XDRM1BKXLMB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XDRM1WHXLPC"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XDRM1WHXLBB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XDRM1WHXLBN"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XDRM1WHXLORB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XDRM1WHXLPB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XDRM1WHXLPN"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XDRM1WHXLSB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XDRM1WHXLMB"
					}
				]
			},
			"package.config.dynamicProducts.selectedGenerator": {
				"keyTemplate": [
					"options.selected.steamHead",
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS90EC1"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS150EC1"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS225EC1"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS400EC1"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": [
							{
								"productId": "ISTEAM_STEAMHEAD",
								"quantity": 1
							},
							{
								"productId": "AUTOFLUSH",
								"quantity": 1
							},
							{
								"productId": "Condensation Pan",
								"quantity": 1
							}
						]
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								"MX4EC1"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX5EC1"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": [
							{
								"productId": "ISTEAM_STEAMHEAD",
								"quantity": 2
							},
							{
								"productId": "AUTOFLUSH",
								"quantity": 2
							},
							{
								"productId": "Condensation Pan",
								"quantity": 2
							}
						]
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								null
							],
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": [
							{
								"productId": "LINEAR_STEAMHEAD",
								"quantity": 1
							},
							{
								"productId": "AUTOFLUSH",
								"quantity": 1
							},
							{
								"productId": "Condensation Pan",
								"quantity": 1
							}
						]
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": [
							{
								"productId": "LINEAR_STEAMHEAD",
								"quantity": 2
							},
							{
								"productId": "AUTOFLUSH",
								"quantity": 2
							},
							{
								"productId": "Condensation Pan",
								"quantity": 2
							}
						]
					}
				]
			},
			"images.thumbnail": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.steamHead",
					"_globals.selectedGenerator",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XDRM1BKPC.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XDRM1BKBB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XDRM1BKBN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XDRM1BKOR.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XDRM1BKPB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XDRM1BKPN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XDRM1BKSB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XDRM1BKMB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XDRM1WHPC.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XDRM1WHBB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XDRM1WHBN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XDRM1WHOB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XDRM1WHPB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XDRM1WHPN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XDRM1WHSB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XDRM1WHMB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XDRM1BKLPC.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XDRM1BKLBB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XDRM1BKLBN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XDRM1BKLOB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XDRM1BKLPB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XDRM1BKLPN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XDRM1BKLSB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XDRM1BKLMB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XDRM1WHLPC.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XDRM1WHLBB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XDRM1WHLBN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XDRM1WHLOR.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XDRM1WHLPB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XDRM1WHLPN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XDRM1WHLSB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XDRM1WHLMB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XDRM1BKXPC.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XDRM1BKXBB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XDRM1BKXBN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XDRM1BKXOR.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XDRM1BKXPB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XDRM1BKXPN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XDRM1BKXSB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XDRM1BKXMB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XDRM1WHXPC.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XDRM1WHXBB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XDRM1WHXBN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XDRM1WHXOR.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XDRM1WHXPB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XDRM1WHXPN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XDRM1WHXSB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XDRM1WHXMB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XDRM1BKXLPC.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XDRM1BKXLBB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XDRM1BKXLBN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XDRM1BKXLOB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XDRM1BKXLPB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XDRM1BKXLPN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XDRM1BKXLSB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XDRM1BKXLMB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XDRM1WHXLPC.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XDRM1WHXLBB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XDRM1WHXLBN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XDRM1WHXLOB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XDRM1WHXLPB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XDRM1WHXLPN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XDRM1WHXLSB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XDRM1WHXLMB.jpg"
					}
				]
			}
		},
		"package": {
			"config": {
				"staticProducts": [
					{
						"productId": "ISTEAMX_CONTROL",
						"quantity": 1
					},
					{
						"productId": "AROMASTEAM",
						"quantity": 1
					},
					{
						"productId": "CHROMASTEAMX",
						"quantity": 1
					},
					{
						"productId": "SteamLinx",
						"quantity": 1
					}
				]
			}
		},
		"vSpa": {
			"spaFrameSourceOption": "finish",
			"spaFrameIsVisible": true,
			"standardGeneratorIsVisible": true,
			"isSuperCompatible": true
		}
	},
	{
		"code": "Bliss_PACKAGE",
		"partnumber": "Bliss",
		"previewname": "Bliss Package",
		"name": "Bliss Package",
		"price": 6900,
		"descriptions": {
			"short": "Innovation, luxury, and ease are at the core of the flagship Bliss spa package.",
			"long": "<p align=”justify”>Welcome the ultimate shower experience, the Bliss Package. The bliss package is a curated collection of the finest steam systems and shower experiences available. Anchored by the sophisticated and intuitive iSteamX, along with Chroma, Aroma, and Music Therapy systems, AromaGlass Steam Head, AutoFlush system, Condensation Pan, and now completely blissful with the addition of the innovative SpaH2O electronic shower valve.</p>",
			"tech": "<p align=”justify”><li>The new MrSteam Bliss Package introduces the SpaH2O digital shower valve system</li><li> This electronic valve syncs with the iSteamX control for seamless control of your shower and steam systems</li><li>Bliss Package includes the AudioX System, the best in Bluetooth audio sound designed for wet high-heat environments</li><li>Package includes the ChromaX System offering 78,N/AN/AN/A color selection possibilities</li><li>Package includes the AromaSteam System which directly infuses specially formulated aroma fragrances into the steam line</li><li>Package includes a 1-liter bottle of Eucalyptus Fragrance for use with the Aroma Steam System</li><li>Package includes the AutoFlush System, offering clean steam every time</li><li>Package includes a Condensation Pan that helps insure a dry and clean environment for you steam generator</li></p>",
			"parts": "test"
		},
		"links": {
			"tech": "https://pim.mrsteam.com/Resources/Entities/MRSTEAM/Documents/cc301597-83e9-453c-ae5f-5f39542829b6.pdf"
		},
		"taxonomy": {
			"categories": [
				"isteamx-touch-screen-controls"
			]
		},
		"images": {
			"folder": "control-packages/Bliss/",
			"thumbnail": "BLS-BKPC.jpg",
			"scene": "idream_package_black.png"
		},
		"options": {
			"enabledListsIds": [
				"color",
				"finish",
				"steamHead"
			],
			"selected": {
				"shape": "SQUARE",
				"color": "BLACK",
				"finish": "POLISHED_CHROME",
				"steamHead": "ISTEAM_STEAMHEAD"
			},
			"list": {
				"color": [
					"BLACK",
					"WHITE"
				],
				"steamHead": [
					"ISTEAM_STEAMHEAD",
					"LINEAR_STEAMHEAD"
				],
				"finish": [
					"POLISHED_CHROME",
					"BRUSHED_BRONZE",
					"BRUSHED_NICKEL",
					"OIL_RUBBED_BRONZE",
					"POLISHED_BRASS",
					"POLISHED_NICKEL",
					"SATIN_BRASS",
					"MATTE_BLACK"
				]
			}
		},
		"dynamicProperties": {
			"price": {
				"keyTemplate": [
					"options.selected.steamHead",
					"_globals.selectedGenerator",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							]
						],
						"value": 9200
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							]
						],
						"value": 9500
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							]
						],
						"value": 8900
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								null,
								"MATTE_BLACK"
							]
						],
						"value": 9100
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": 9200
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": 9200
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": 10000
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": 8900
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": 9200
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": 9500
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": 10300
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": 9100
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": 9400
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": 9500
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": 10300
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": 9100
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": 9400
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": 9500
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": 10300
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": 9100
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": 9400
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": 9500
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": 10300
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": 9100
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": 9400
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": 9500
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": 10300
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": 9100
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": 9400
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": 9500
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": 10300
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": 9100
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": 9400
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": 9500
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": 10300
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": 9100
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": 9400
					}
				]
			},
			"descriptions.long": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.steamHead",
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<p align=”justify”>Welcome the ultimate shower experience, the Bliss Package. The bliss package is a curated collection of the finest steam systems and shower experiences available. Anchored by the sophisticated and intuitive iSteamX, along with Chroma, Aroma, and Music Therapy systems, AromaGlass Steam Head, AutoFlush system, Condensation Pan, and now completely blissful with the addition of the innovative SpaH2O electronic shower valve.</p>"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<p align=”justify”>Welcome the ultimate shower experience, the Bliss Package. The bliss package is a curated collection of the finest steam systems and shower experiences available. Anchored by the sophisticated and intuitive iSteamX, along with Chroma, Aroma, and Music Therapy systems, AromaGlass Steam Head, AutoFlush system, Condensation Pan, and now completely blissful with the addition of the innovative SpaH2O electronic shower valve.</p>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<p align=”justify”>Welcome the ultimate shower experience, the Bliss Package. The bliss package is a curated collection of the finest steam systems and shower experiences available. Anchored by the sophisticated and intuitive iSteamX, along with Chroma, Aroma, and Music Therapy systems, AromaGlass Steam Head, AutoFlush system, Condensation Pan, and now completely blissful with the addition of the innovative SpaH2O electronic shower valve.</p>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<p align=”justify”>Welcome the ultimate shower experience, the Bliss Package. The bliss package is a curated collection of the finest steam systems and shower experiences available. Anchored by the sophisticated and intuitive iSteamX, along with Chroma, Aroma, and Music Therapy systems, AromaGlass Steam Head, AutoFlush system, Condensation Pan, and now completely blissful with the addition of the innovative SpaH2O electronic shower valve.</p>"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<p align=”justify”>Welcome the ultimate shower experience, the Bliss Package. The bliss package is a curated collection of the finest steam systems and shower experiences available. Anchored by the sophisticated and intuitive iSteamX, along with Chroma, Aroma, and Music Therapy systems, AromaGlass Steam Head, AutoFlush system, Condensation Pan, and now completely blissful with the addition of the innovative SpaH2O electronic shower valve.</p>"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<p align=”justify”>Welcome the ultimate shower experience, the Bliss Package. The bliss package is a curated collection of the finest steam systems and shower experiences available. Anchored by the sophisticated and intuitive iSteamX, along with Chroma, Aroma, and Music Therapy systems, AromaGlass Steam Head, AutoFlush system, Condensation Pan, and now completely blissful with the addition of the innovative SpaH2O electronic shower valve.</p>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<p align=”justify”>Welcome the ultimate shower experience, the Bliss Package. The bliss package is a curated collection of the finest steam systems and shower experiences available. Anchored by the sophisticated and intuitive iSteamX, along with Chroma, Aroma, and Music Therapy systems, AromaGlass Steam Head, AutoFlush system, Condensation Pan, and now completely blissful with the addition of the innovative SpaH2O electronic shower valve.</p>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<p align=”justify”>Welcome the ultimate shower experience, the Bliss Package. The bliss package is a curated collection of the finest steam systems and shower experiences available. Anchored by the sophisticated and intuitive iSteamX, along with Chroma, Aroma, and Music Therapy systems, AromaGlass Steam Head, AutoFlush system, Condensation Pan, and now completely blissful with the addition of the innovative SpaH2O electronic shower valve.</p>"
					}
				]
			},
			"descriptions.tech": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.steamHead",
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<p align=”justify”><li>The new MrSteam Bliss Package introduces the SpaH2O digital shower valve system</li><li> This electronic valve syncs with the iSteamX control for seamless control of your shower and steam systems</li><li>Bliss Package includes the AudioX System, the best in Bluetooth audio sound designed for wet high-heat environments</li><li>Package includes the ChromaX System offering 78,N/AN/AN/A color selection possibilities</li><li>Package includes the AromaSteam System which directly infuses specially formulated aroma fragrances into the steam line</li><li>Package includes a 1-liter bottle of Eucalyptus Fragrance for use with the Aroma Steam System</li><li>Package includes the AutoFlush System, offering clean steam every time</li><li>Package includes a Condensation Pan that helps insure a dry and clean environment for you steam generator</li></p>"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<p align=”justify”><li>The new MrSteam Bliss Package introduces the SpaH2O digital shower valve system</li><li> This electronic valve syncs with the iSteamX control for seamless control of your shower and steam systems</li><li>Bliss Package includes the AudioX System, the best in Bluetooth audio sound designed for wet high-heat environments</li><li>Package includes the ChromaX System offering 78,N/AN/AN/A color selection possibilities</li><li>Package includes the AromaSteam System which directly infuses specially formulated aroma fragrances into the steam line</li><li>Package includes a 1-liter bottle of Eucalyptus Fragrance for use with the Aroma Steam System</li><li>Package includes the AutoFlush System, offering clean steam every time</li><li>Package includes a Condensation Pan that helps insure a dry and clean environment for you steam generator</li></p>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<p align=”justify”><li>The new MrSteam Bliss Package introduces the SpaH2O digital shower valve system</li><li> This electronic valve syncs with the iSteamX control for seamless control of your shower and steam systems</li><li>Bliss Package includes the AudioX System, the best in Bluetooth audio sound designed for wet high-heat environments</li><li>Package includes the ChromaX System offering 78,N/AN/AN/A color selection possibilities</li><li>Package includes the AromaSteam System which directly infuses specially formulated aroma fragrances into the steam line</li><li>Package includes a 1-liter bottle of Eucalyptus Fragrance for use with the Aroma Steam System</li><li>Package includes the AutoFlush System, offering clean steam every time</li><li>Package includes a Condensation Pan that helps insure a dry and clean environment for you steam generator</li></p>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<p align=”justify”><li>The new MrSteam Bliss Package introduces the SpaH2O digital shower valve system</li><li> This electronic valve syncs with the iSteamX control for seamless control of your shower and steam systems</li><li>Bliss Package includes the AudioX System, the best in Bluetooth audio sound designed for wet high-heat environments</li><li>Package includes the ChromaX System offering 78,N/AN/AN/A color selection possibilities</li><li>Package includes the AromaSteam System which directly infuses specially formulated aroma fragrances into the steam line</li><li>Package includes a 1-liter bottle of Eucalyptus Fragrance for use with the Aroma Steam System</li><li>Package includes the AutoFlush System, offering clean steam every time</li><li>Package includes a Condensation Pan that helps insure a dry and clean environment for you steam generator</li></p>"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<p align=”justify”><li>The new MrSteam Bliss Package introduces the SpaH2O digital shower valve system</li><li> This electronic valve syncs with the iSteamX control for seamless control of your shower and steam systems</li><li>Bliss Package includes the AudioX System, the best in Bluetooth audio sound designed for wet high-heat environments</li><li>Package includes the ChromaX System offering 78,N/AN/AN/A color selection possibilities</li><li>Package includes the AromaSteam System which directly infuses specially formulated aroma fragrances into the steam line</li><li>Package includes a 1-liter bottle of Eucalyptus Fragrance for use with the Aroma Steam System</li><li>Package includes the AutoFlush System, offering clean steam every time</li><li>Package includes a Condensation Pan that helps insure a dry and clean environment for you steam generator</li></p>"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<p align=”justify”><li>The new MrSteam Bliss Package introduces the SpaH2O digital shower valve system</li><li> This electronic valve syncs with the iSteamX control for seamless control of your shower and steam systems</li><li>Bliss Package includes the AudioX System, the best in Bluetooth audio sound designed for wet high-heat environments</li><li>Package includes the ChromaX System offering 78,N/AN/AN/A color selection possibilities</li><li>Package includes the AromaSteam System which directly infuses specially formulated aroma fragrances into the steam line</li><li>Package includes a 1-liter bottle of Eucalyptus Fragrance for use with the Aroma Steam System</li><li>Package includes the AutoFlush System, offering clean steam every time</li><li>Package includes a Condensation Pan that helps insure a dry and clean environment for you steam generator</li></p>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<p align=”justify”><li>The new MrSteam Bliss Package introduces the SpaH2O digital shower valve system</li><li> This electronic valve syncs with the iSteamX control for seamless control of your shower and steam systems</li><li>Bliss Package includes the AudioX System, the best in Bluetooth audio sound designed for wet high-heat environments</li><li>Package includes the ChromaX System offering 78,N/AN/AN/A color selection possibilities</li><li>Package includes the AromaSteam System which directly infuses specially formulated aroma fragrances into the steam line</li><li>Package includes a 1-liter bottle of Eucalyptus Fragrance for use with the Aroma Steam System</li><li>Package includes the AutoFlush System, offering clean steam every time</li><li>Package includes a Condensation Pan that helps insure a dry and clean environment for you steam generator</li></p>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<p align=”justify”><li>The new MrSteam Bliss Package introduces the SpaH2O digital shower valve system</li><li> This electronic valve syncs with the iSteamX control for seamless control of your shower and steam systems</li><li>Bliss Package includes the AudioX System, the best in Bluetooth audio sound designed for wet high-heat environments</li><li>Package includes the ChromaX System offering 78,N/AN/AN/A color selection possibilities</li><li>Package includes the AromaSteam System which directly infuses specially formulated aroma fragrances into the steam line</li><li>Package includes a 1-liter bottle of Eucalyptus Fragrance for use with the Aroma Steam System</li><li>Package includes the AutoFlush System, offering clean steam every time</li><li>Package includes a Condensation Pan that helps insure a dry and clean environment for you steam generator</li></p>"
					}
				]
			},
			"descriptions.parts": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.steamHead",
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<li>  (1) iSteamX Touch Screen Control in black  </li><li>(1) Aroma Glass SteamHead </li><li>(1) SteamLinx</li><li>(1) AutoFlush </li><li>(1) Condensation Pan</li><li> (1) AromaSteam Oil Delivery System </li><li>(1) ChromaX Mood Lighting System</li><li>(1) Pair of Square In-shower Music Therapy Speakers in black</li><li>(1) Liter Eucalyptus Oil with Caddy</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<li>  (1) iSteamX Touch Screen Control in white  </li><li>(1) Aroma Glass SteamHead </li><li>(1) SteamLinx</li><li>(1) AutoFlush </li><li>(1) Condensation Pan</li><li> (1) AromaSteam Oil Delivery System </li><li>(1) ChromaX Mood Lighting System</li><li>(1) Pair of Square In-shower Music Therapy Speakers in white</li><li>(1) Liter Eucalyptus Oil with Caddy</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<li>  (1) iSteamX Touch Screen Control in black  </li><li>(1) 16 inch Linear SteamHead  </li><li>(1) SteamLinx</li><li>(1) AutoFlush </li><li>(1) Condensation Pan</li><li> (1) AromaSteam Oil Delivery System </li><li>(1) ChromaX Mood Lighting System</li><li>(1) Pair of Square In-shower Music Therapy Speakers in black</li><li>(1) Liter Eucalyptus Oil with Caddy</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<li>  (1) iSteamX Touch Screen Control in white  </li><li>(1) 16 inch Linear SteamHead  </li><li>(1) SteamLinx</li><li>(1) AutoFlush </li><li>(1) Condensation Pan</li><li> (1) AromaSteam Oil Delivery System </li><li>(1) ChromaX Mood Lighting System</li><li>(1) Pair of Square In-shower Music Therapy Speakers in white</li><li>(1) Liter Eucalyptus Oil with Caddy</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<li>  (1) iSteamX Touch Screen Control in black  </li><li> (2) AromaSteam Glass SteamHeads in black   </li><li>(1) SteamLinx</li><li>(1) Max AutoFlush </li><li>(1) Max Condensation Pan</li><li> (1) AromaSteam Oil Delivery System with Caddy</li><li>(1) ChromaX Mood Lighting System</li><li>(1) Pair of Square In-shower Music Therapy Speakers in black</li><li>(1) Liter Eucalyptus Oil with Caddy</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<li>  (1) iSteamX Touch Screen Control in white  </li><li> (2) AromaSteam Glass SteamHeads in white   </li><li>(1) SteamLinx</li><li>(1) Max AutoFlush </li><li>(1) Max Condensation Pan</li><li> (1) AromaSteam Oil Delivery System with Caddy</li><li>(1) ChromaX Mood Lighting System</li><li>(1) Pair of Square In-shower Music Therapy Speakers in white</li><li>(1) Liter Eucalyptus Oil with Caddy</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<li>  (1) iSteamX Touch Screen Control in black  </li><li> (2)  Linear SteamHeads in black   </li><li>(1) SteamLinx</li><li>(1) Max AutoFlush </li><li>(1) Max Condensation Pan</li><li> (1) AromaSteam Oil Delivery System with Caddy</li><li>(1) ChromaX Mood Lighting System</li><li>(1) Pair of Square In-shower Music Therapy Speakers in black</li><li>(1) Liter Eucalyptus Oil with Caddy</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<li>  (1) iSteamX Touch Screen Control in white  </li><li> (2)  Linear SteamHeads in white   </li><li>(1) SteamLinx</li><li>(1) Max AutoFlush </li><li>(1) Max Condensation Pan</li><li> (1) AromaSteam Oil Delivery System with Caddy</li><li>(1) ChromaX Mood Lighting System</li><li>(1) Pair of Square In-shower Music Therapy Speakers in white</li><li>(1) Liter Eucalyptus Oil with Caddy</li>"
					}
				]
			},
			"images.scene": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.steamHead",
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "idream_package_black.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "idream_package_2_black.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "idream_package_white.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "idream_package_2_white.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "idream_linear_package_black.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "idream_2_linear_package_black.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "idream_linear_package_white.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "idream_2_linear_package_white.png"
					}
				]
			},
			"partnumber": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.steamHead",
					"_globals.selectedGenerator",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BLS-BKPC"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BLS-BKBB"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BLS-BKBN"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BLS-BKOB"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BLS-BKPB"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BLS-BKPN"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BLS-BKSB"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BLS-BKMB"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BLS-WHPC"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BLS-WHBB"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BLS-WHBN"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BLS-WHOB"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BLS-WHPB"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BLS-WHPN"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BLS-WHSB"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BLS-WHMB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BLS-BKLPC"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BLS-BKLBB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BLS-BKLBN"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BLS-BKLORB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BLS-BKLPB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BLS-BKLPN"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BLS-BKLSB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BLS-BKLMB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BLS-WHLPC"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BLS-WHLBB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BLS-WHLBN"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BLS-WHLORB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BLS-WHLPB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BLS-WHLPN"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BLS-WHLSB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BLS-WHLMB"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BLS-BKXPC"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BLS-BKXBB"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BLS-BKXBN"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BLS-BKXOB"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BLS-BKXPB"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BLS-BKXPN"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BLS-BKXSB"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BLS-BKXMB"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BLS-WHXPC"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BLS-WHXBB"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BLS-WHXBN"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BLS-WHXOB"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BLS-WHXPB"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BLS-WHXPN"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BLS-WHXSB"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BLS-WHXMB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BLS-BKXLPC"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BLS-BKXLBB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BLS-BKXLBN"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BLS-BKXLORB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BLS-BKXLPB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BLS-BKXLPN"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BLS-BKXLSB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BLS-BKXLMB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BLS-WHXLPC"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BLS-WHXLBB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BLS-WHXLBN"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BLS-WHXLORB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BLS-WHXLPB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BLS-WHXLPN"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BLS-WHXLSB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BLS-WHXLMB"
					}
				]
			},
			"package.config.dynamicProducts.selectedGenerator": {
				"keyTemplate": [
					"options.selected.steamHead",
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS90EC1"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS150EC1"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS225EC1"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS400EC1"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": [
							{
								"productId": "ISTEAM_STEAMHEAD",
								"quantity": 1
							},
							{
								"productId": "AUTOFLUSH",
								"quantity": 1
							},
							{
								"productId": "Condensation Pan",
								"quantity": 1
							}
						]
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								"MX4EC1"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX5EC1"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": [
							{
								"productId": "ISTEAM_STEAMHEAD",
								"quantity": 2
							},
							{
								"productId": "AUTOFLUSH",
								"quantity": 2
							},
							{
								"productId": "Condensation Pan",
								"quantity": 2
							}
						]
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								null
							],
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": [
							{
								"productId": "LINEAR_STEAMHEAD",
								"quantity": 1
							},
							{
								"productId": "AUTOFLUSH",
								"quantity": 1
							},
							{
								"productId": "Condensation Pan",
								"quantity": 1
							}
						]
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": [
							{
								"productId": "LINEAR_STEAMHEAD",
								"quantity": 2
							},
							{
								"productId": "AUTOFLUSH",
								"quantity": 2
							},
							{
								"productId": "Condensation Pan",
								"quantity": 2
							}
						]
					}
				]
			},
			"images.thumbnail": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.steamHead",
					"_globals.selectedGenerator",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BLS-BKPC.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BLS-BKBB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BLS-BKBN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BLS-BKOB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BLS-BKPB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BLS-BKPN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BLS-BKSB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BLS-BKMB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BLS-WHPC.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BLS-WHBB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BLS-WHBN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BLS-WHOB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BLS-WHPB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BLS-WHPN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BLS-WHSB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BLS-WHMB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BLS-BKLPC.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BLS-BKLBB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BLS-BKLBN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BLS-BKLOB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BLS-BKLPB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BLS-BKLPN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BLS-BKLSB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BLS-BKLMB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BLS-WHLPC.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BLS-WHLBB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BLS-WHLBN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BLS-WHLOB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BLS-WHLPB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BLS-WHLPN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BLS-WHLSB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BLS-WHLMB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BLS-BKXPC.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BLS-BKXBB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BLS-BKXBN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BLS-BKXOB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BLS-BKXPB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BLS-BKXPN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BLS-BKXSB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BLS-BKXMB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BLS-WHXPC.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BLS-WHXBB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BLS-WHXBN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BLS-WHXOB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BLS-WHXPB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BLS-WHXPN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BLS-WHXSB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BLS-WHXMB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BLS-BKXLPC.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BLS-BKXLBB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BLS-BKXLBN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BLS-BKXLOB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BLS-BKXLPB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BLS-BKXLPN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BLS-BKXLSB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BLS-BKXLMB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BLS-WHXLPC.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BLS-WHXLBB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BLS-WHXLBN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BLS-WHXLOB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BLS-WHXLPB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BLS-WHXLPN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BLS-WHXLSB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BLS-WHXLMB.jpg"
					}
				]
			}
		},
		"package": {
			"config": {
				"staticProducts": [
					{
						"productId": "ISTEAMX_CONTROL",
						"quantity": 1
					},
					{
						"productId": "AROMASTEAM",
						"quantity": 1
					},
					{
						"productId": "CHROMASTEAMX",
						"quantity": 1
					},
					{
						"productId": "SteamLinx",
						"quantity": 1
					}
				]
			}
		},
		"vSpa": {
			"spaFrameSourceOption": "finish",
			"spaFrameIsVisible": true,
			"standardGeneratorIsVisible": true,
			"isSuperCompatible": true
		}
	},
	{
		"code": "CHROMASTEAMDUOX",
		"partnumber": "CHROMASTEAMDUOX",
		"previewname": "ChromaX Duo System",
		"name": "ChromaX Duo System",
		"price": 1950,
		"descriptions": {
			"short": "Music Therapy Speakers",
			"long": "Step into your shower. Let the steam envelope you. Now extend a hand and effortlessly dial in just the mood you're seeking. Your elegant, vapor-sealed LED mood lighting will respond with a flood of pure energy.\\r\\n\\r\\n",
			"tech": "<li>Select color and modes directly from the iSteamX control</li><li>Can also be controlled from a dedicated wall switch</li><li>Included low voltage power supply</li><li>Works with all Mr.Steam eSeries Generators</li><li>Includes two Chroma light and control module</li>"
		},
		"images": {
			"thumbnail": "ChromaXDUOBK.jpg",
			"folder": "spa-therapies/ChromaSteamX/",
			"scene": "chromasteam_light_bk.png"
		},
		"links": {
			"tech": "https://pim.mrsteam.com/Resources/Entities/MRSTEAM/Documents/0e8404cb-f535-4476-9a40-b750675dea56.pdf"
		},
		"taxonomy": {
			"categories": [
				"spa-therapies"
			],
			"sortOrder": {
				"spa-therapies": 4
			},
			"zIndex": {
				"spa-therapies": 4
			}
		},
		"options": {
			"enabledListsIds": [
				"color"
			],
			"selected": {
				"color": "BLACK",
				"type": "CHROMAXBK"
			},
			"list": {
				"color": [
					"BLACK",
					"WHITE"
				]
			}
		},
		"dynamicProperties": {
			"images.thumbnail": {
				"keyTemplate": [
					"options.selected.color"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK"
							]
						],
						"value": "ChromaXDUOBK.jpg"
					},
					{
						"tally": [
							[
								"WHITE"
							]
						],
						"value": "ChromaXDUOWH.jpg"
					}
				]
			},
			"partnumber": {
				"keyTemplate": [
					"options.selected.color"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK"
							]
						],
						"value": "CHROMAXDUOBK"
					},
					{
						"tally": [
							[
								"WHITE"
							]
						],
						"value": "CHROMAXDUOWH"
					}
				]
			},
			"images.scene": {
				"keyTemplate": [
					"options.selected.color"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK"
							]
						],
						"value": "chromasteam_light_bk.png"
					},
					{
						"tally": [
							[
								"WHITE"
							]
						],
						"value": "chromasteam_light_wh.png"
					}
				]
			}
		},
		"tooltips": {
			"list": [
				{
					"top": 15,
					"left": 54.7,
					"width": 6,
					"height": 5
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false
		}
	},
	{
		"code": "AUDIOX",
		"partnumber": "AUDIOX",
		"previewname": "AudioX",
		"name": "AudioX",
		"price": 895,
		"descriptions": {
			"short": "Music Therapy Speakers",
			"long": "The AudioX system is an innovation in wet and warm environment audio. The AudioX offers exquisite sound and performance, enhancing and elevating the steam room and the entire bathroom experience to new heights.",
			"tech": "<li>AudioX System is fully Bluetooth enabled, offering amazing flexibility, connectivity, and control with smart devices</li><li>AudioX speakers are 75” square with a 5”mounting depth, designed to be flush mounted on the wall or ceiling</li><li>Comes with two, 6N/A-watt peak power speakers</li><li>With the SpaH2O mobile app, users can monitor and control the functionality of this completely digital control on any smart device</li><li>Available in both white and black finishes</li><li>Designed for use inside or outside the shower enclosure</li><li>Powerful bass, crystal-clear performance, with  full-range sound</li>"
		},
		"images": {
			"thumbnail": "AUDIOXBK.jpg",
			"folder": "spa-therapies/MsSpeakers/",
			"scene": "MsSpeakers-Square-Black.png"
		},
		"links": {
			"tech": "https://pim.mrsteam.com/Resources/Entities/MRSTEAM/Documents/37d1a512-92f0-4089-bb89-b2dce30877ef.pdf"
		},
		"taxonomy": {
			"categories": [
				"spa-therapies"
			],
			"sortOrder": {
				"spa-therapies": 3
			},
			"zIndex": {
				"spa-therapies": 3
			}
		},
		"options": {
			"enabledListsIds": [
				"color"
			],
			"selected": {
				"color": "BLACK"
			},
			"list": {
				"color": [
					"BLACK",
					"WHITE"
				]
			}
		},
		"dynamicProperties": {
			"images.thumbnail": {
				"keyTemplate": [
					"options.selected.color"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK"
							]
						],
						"value": "AUDIOXBK.jpg"
					},
					{
						"tally": [
							[
								"WHITE"
							]
						],
						"value": "AUDIOXWH.jpg"
					}
				]
			},
			"partnumber": {
				"keyTemplate": [
					"options.selected.color"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK"
							]
						],
						"value": "AUDIOXBK"
					},
					{
						"tally": [
							[
								"WHITE"
							]
						],
						"value": "AUDIOXWH"
					}
				]
			},
			"images.scene": {
				"keyTemplate": [
					"options.selected.color"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK"
							]
						],
						"value": "MsSpeakers-Square-Black.png"
					},
					{
						"tally": [
							[
								"WHITE"
							]
						],
						"value": "MsSpeakers-Square-White.png"
					}
				]
			}
		},
		"tooltips": {
			"list": [
				{
					"top": 17,
					"left": 46.3,
					"width": 6,
					"height": 5,
					"orientation": "left"
				},
				{
					"top": 12,
					"left": 64.8,
					"width": 6,
					"height": 5,
					"orientation": "right"
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false
		}
	},
	{
		"code": "104665",
		"partnumber": "104665",
		"previewname": "Shower Bench",
		"name": "Shower Bench",
		"price": 550,
		"descriptions": {
			"short": "Solid Surface Shower Bench",
			"long": "Sit down, relax, wash your troubles and the grime of the day away. It’s time to bathe in comfort and style. The MS Shower Bench is a sleek, contemporary addition to any shower or bathroom.",
			"tech": "<li>The MS Shower Bench is a complete white solid surface contruction</li><li>The MS Shower Bench is strong and sturdy with a 3N/AN/A lb weight capactiy</li><li>The MS Shower Bench can be used in wet or dry locations</li><li>The MS Shower bench has an elegant sophisticated design  and comfortably luxurious style</li><li>Shower bench dimensions 15 ¾” wide x 11 7/8” deep x 16¾” tall</li>"
		},
		"images": {
			"thumbnail": "104665.jpg",
			"folder": "accessories/WallSeat/",
			"scene": "mst2024-02_vspa_solid-surface-shower-bench_final_01.png"
		},
		"links": {
			"tech": "https://pim.mrsteam.com/Resources/Entities/MRSTEAM/Documents/708fce30-8eb7-4ee4-9991-c1375a7f6adf.pdf"
		},
		"taxonomy": {
			"categories": [
				"accessories"
			],
			"sortOrder": {
				"accessories": 1
			},
			"zIndex": {
				"accessories": 1
			}
		},
		"tooltips": {
			"list": [
				{
					"top": 66,
					"left": 56.5,
					"height": 7,
					"width": 13
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false
		}
	},
	{
		"code": "SHOWERVALVE",
		"partnumber": "SHOWERVALVE",
		"previewname": "Shower Valve",
		"name": "Shower Valve",
		"price": 2000,
		"descriptions": {
			"short": "SpaH2O Electronic Shower Valve 120 VAC",
			"long": "The SpaH2O electronic shower valve syncs seamlessly with the iSteamX control for meticulous management of the water flow to your shower. The SPAH2O is a thermostatic pressure-balancing valve with an electronic mixer CPU that is directly controlled by the iSteamX.",
			"tech": "<li>The SpaH2O electronic shower valve offers 3 outputs</li><li>The SpaH2O user can program up to three custom user sequences</li><li>Streamlined maintenance, including built-in thermal disinfection and self-cleaning</li><li>The SpaH2O shower valve offers warm up and eco modes</li><li>Operating pressure range 3N/A - 1N/AN/A psi and 12N/A-degree Fahrenheit maximum hot water temperature control</li>"
		},
		"images": {
			"thumbnail": "SPAH2O.jpg",
			"folder": "controls-accessories/",
			"scene": "mst2024-02_vspa_SPAH2O-shower-valve_final_01.png"
		},
		"links": {
			"tech": "https://pim.mrsteam.com/Resources/Entities/MRSTEAM/Documents/7b0f24da-3704-4761-9aa6-39b6a3027b71.pdf"
		},
		"taxonomy": {
			"categories": [
				"controls-accessories"
			],
			"sortOrder": {
				"controls-accessories": 1
			},
			"zIndex": {
				"controls-accessories": 1
			}
		},
		"tooltips": {
			"list": [
				{
					"top": 66,
					"left": 56.5,
					"height": 7,
					"width": 13
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false
		}
	},
	{
		"code": "TOWEL_WARMER_W228",
		"partnumber": "W228",
		"previewname": "Towel Warmer W228",
		"name": "Towel Warmer W228",
		"price": 1450,
		"descriptions": {
			"short": "Towel Warmer",
			"long": "Explore the Broadway Towel Warmer Collection. This collection will catch the eye with its classic design and is sure to leave you in a warm embrace and a comforting elevation of the senses.",
			"tech": "<li>Comes standard with a digital timer</li><li>Comes standard with a matching timer cover plate</li><li>Designed with a built-in AromaTherapy oil well</li><li>The Broadway collection is available in distinct designer finishes; Polished Chrome, Brushed Nickel, Brushed Bronze, and Mat Black</li>"
		},
		"links": {
			"tech": "https://pim.mrsteam.com/Resources/Entities/MRSTEAM/Documents/e0a227c8-d556-4c39-9fdb-0110ec6bf4a4.pdf"
		},
		"taxonomy": {
			"categories": [
				"towel-warmers-200"
			],
			"series": "S200"
		},
		"images": {
			"folder": "towel-warmers/S200-Broadway/",
			"thumbnail": "W228TPC.jpg",
			"scene": "TowelWarmer-W228-PolishedChrome.png"
		},
		"options": {
			"enabledListsIds": [
				"finish"
			],
			"selected": {
				"finish": "POLISHED_CHROME"
			},
			"list": {
				"finish": [
					"POLISHED_CHROME",
					"BRUSHED_NICKEL",
					"BRUSHED_BRONZE",
					"MATTE_BLACK"
				]
			}
		},
		"dynamicProperties": {
			"images.thumbnail": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"POLISHED_CHROME"
							]
						],
						"value": "W228TPC.jpg"
					},
					{
						"tally": [
							[
								"BRUSHED_NICKEL"
							]
						],
						"value": "W228TBN.jpg"
					},
					{
						"tally": [
							[
								"BRUSHED_BRONZE"
							]
						],
						"value": "W228TBB.jpg"
					},
					{
						"tally": [
							[
								"MATTE_BLACK"
							]
						],
						"value": "W228TMB.jpg"
					}
				]
			},
			"partnumber": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"POLISHED_CHROME"
							]
						],
						"value": "W228TPC"
					},
					{
						"tally": [
							[
								"BRUSHED_NICKEL"
							]
						],
						"value": "W228TBN"
					},
					{
						"tally": [
							[
								"BRUSHED_BRONZE"
							]
						],
						"value": "W228TBB"
					},
					{
						"tally": [
							[
								"MATTE_BLACK"
							]
						],
						"value": "W228TMB"
					}
				]
			},
			"images.scene": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"POLISHED_CHROME"
							]
						],
						"value": "TowelWarmer-W228-PolishedChrome.png"
					},
					{
						"tally": [
							[
								"BRUSHED_NICKEL"
							]
						],
						"value": "mst2024-02_vspa_towel-warmer_broadway_BN_final_01.png"
					},
					{
						"tally": [
							[
								"BRUSHED_BRONZE"
							]
						],
						"value": "mst2024-02_vspa_towel-warmer_broadway_BB_final_01.png"
					},
					{
						"tally": [
							[
								"MATTE_BLACK"
							]
						],
						"value": "mst2024-02_vspa_towel-warmer_broadway_BM_final_01.png"
					}
				]
			},
			"price": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"POLISHED_CHROME"
							]
						],
						"value": 1450
					},
					{
						"tally": [
							[
								"BRUSHED_NICKEL"
							]
						],
						"value": 1600
					},
					{
						"tally": [
							[
								"BRUSHED_BRONZE"
							]
						],
						"value": 1600
					},
					{
						"tally": [
							[
								"MATTE_BLACK"
							]
						],
						"value": 1600
					}
				]
			}
		},
		"tooltips": {
			"list": [
				{
					"top": 37,
					"left": 77.5,
					"height": 27,
					"width": 11
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false
		}
	},
	{
		"code": "TOWEL_WARMER_W236",
		"partnumber": "W236",
		"previewname": "Towel Warmer W236",
		"name": "Towel Warmer W236",
		"price": 1700,
		"descriptions": {
			"short": "Towel Warmer",
			"long": "Explore the Broadway Towel Warmer Collection. This collection will catch the eye with its classic design and is sure to leave you in a warm embrace and a comforting elevation of the senses.",
			"tech": "<li>Comes standard with a digital timer</li><li>Comes standard with a matching timer cover plate</li><li>Designed with a built-in AromaTherapy oil well</li><li>The Broadway collection is available in distinct designer finishes; Polished Chrome, Brushed Nickel, Brushed Bronze, and Mat Black</li>"
		},
		"links": {
			"tech": "https://pim.mrsteam.com/Resources/Entities/MRSTEAM/Documents/e0a227c8-d556-4c39-9fdb-0110ec6bf4a4.pdf"
		},
		"taxonomy": {
			"categories": [
				"towel-warmers-200"
			],
			"series": "S200"
		},
		"images": {
			"folder": "towel-warmers/S200-Broadway/",
			"thumbnail": "W236TPC.jpg",
			"scene": "TowelWarmer-W228-PolishedChrome.png"
		},
		"options": {
			"enabledListsIds": [
				"finish"
			],
			"selected": {
				"finish": "POLISHED_CHROME"
			},
			"list": {
				"finish": [
					"POLISHED_CHROME",
					"BRUSHED_NICKEL",
					"BRUSHED_BRONZE",
					"MATTE_BLACK"
				]
			}
		},
		"dynamicProperties": {
			"images.thumbnail": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"POLISHED_CHROME"
							]
						],
						"value": "W236TPC.jpg"
					},
					{
						"tally": [
							[
								"BRUSHED_NICKEL"
							]
						],
						"value": "W236TBN.jpg"
					},
					{
						"tally": [
							[
								"BRUSHED_BRONZE"
							]
						],
						"value": "W236TBB.jpg"
					},
					{
						"tally": [
							[
								"MATTE_BLACK"
							]
						],
						"value": "W236TMB.jpg"
					}
				]
			},
			"partnumber": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"POLISHED_CHROME"
							]
						],
						"value": "W236TPC"
					},
					{
						"tally": [
							[
								"BRUSHED_NICKEL"
							]
						],
						"value": "W236TBN"
					},
					{
						"tally": [
							[
								"BRUSHED_BRONZE"
							]
						],
						"value": "W236TBB"
					},
					{
						"tally": [
							[
								"MATTE_BLACK"
							]
						],
						"value": "W236TMB"
					}
				]
			},
			"images.scene": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"POLISHED_CHROME"
							]
						],
						"value": "TowelWarmer-W228-PolishedChrome.png"
					},
					{
						"tally": [
							[
								"BRUSHED_NICKEL"
							]
						],
						"value": "mst2024-02_vspa_towel-warmer_broadway_BN_final_01.png"
					},
					{
						"tally": [
							[
								"BRUSHED_BRONZE"
							]
						],
						"value": "mst2024-02_vspa_towel-warmer_broadway_BB_final_01.png"
					},
					{
						"tally": [
							[
								"MATTE_BLACK"
							]
						],
						"value": "mst2024-02_vspa_towel-warmer_broadway_BM_final_01.png"
					}
				]
			},
			"price": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"POLISHED_CHROME"
							]
						],
						"value": 1550
					},
					{
						"tally": [
							[
								"BRUSHED_NICKEL"
							]
						],
						"value": 1700
					},
					{
						"tally": [
							[
								"BRUSHED_BRONZE"
							]
						],
						"value": 1700
					},
					{
						"tally": [
							[
								"MATTE_BLACK"
							]
						],
						"value": 1700
					}
				]
			}
		},
		"tooltips": {
			"list": [
				{
					"top": 36,
					"left": 77.5,
					"height": 33,
					"width": 11
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false
		}
	},
	{
		"code": "TOWEL_WARMER_W248",
		"partnumber": "W248",
		"previewname": "Towel Warmer W248",
		"name": "Towel Warmer W248",
		"price": 1850,
		"descriptions": {
			"short": "Towel Warmer",
			"long": "Explore the Broadway Towel Warmer Collection. This collection will catch the eye with its classic design and is sure to leave you in a warm embrace and a comforting elevation of the senses.",
			"tech": "<li>Comes standard with a digital timer</li><li>Comes standard with a matching timer cover plate</li><li>Designed with a built-in AromaTherapy oil well</li><li>The Broadway collection is available in distinct designer finishes; Polished Chrome, Brushed Nickel, Brushed Bronze, and Mat Black</li>"
		},
		"links": {
			"tech": "https://pim.mrsteam.com/Resources/Entities/MRSTEAM/Documents/e0a227c8-d556-4c39-9fdb-0110ec6bf4a4.pdf"
		},
		"taxonomy": {
			"categories": [
				"towel-warmers-200"
			],
			"series": "S200"
		},
		"images": {
			"folder": "towel-warmers/S200-Broadway/",
			"thumbnail": "W248TPC.jpg",
			"scene": "TowelWarmer-W228-PolishedChrome.png"
		},
		"options": {
			"enabledListsIds": [
				"finish"
			],
			"selected": {
				"finish": "POLISHED_CHROME"
			},
			"list": {
				"finish": [
					"POLISHED_CHROME",
					"BRUSHED_NICKEL",
					"BRUSHED_BRONZE",
					"MATTE_BLACK"
				]
			}
		},
		"dynamicProperties": {
			"images.thumbnail": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"POLISHED_CHROME"
							]
						],
						"value": "W248TPC.jpg"
					},
					{
						"tally": [
							[
								"BRUSHED_NICKEL"
							]
						],
						"value": "W248TBN.jpg"
					},
					{
						"tally": [
							[
								"BRUSHED_BRONZE"
							]
						],
						"value": "W248TBB.jpg"
					},
					{
						"tally": [
							[
								"MATTE_BLACK"
							]
						],
						"value": "W248TMB.jpg"
					}
				]
			},
			"partnumber": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"POLISHED_CHROME"
							]
						],
						"value": "W248TPC"
					},
					{
						"tally": [
							[
								"BRUSHED_NICKEL"
							]
						],
						"value": "W248TBN"
					},
					{
						"tally": [
							[
								"BRUSHED_BRONZE"
							]
						],
						"value": "W248TBB"
					},
					{
						"tally": [
							[
								"MATTE_BLACK"
							]
						],
						"value": "W248TMB"
					}
				]
			},
			"images.scene": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"POLISHED_CHROME"
							]
						],
						"value": "TowelWarmer-W228-PolishedChrome.png"
					},
					{
						"tally": [
							[
								"BRUSHED_NICKEL"
							]
						],
						"value": "mst2024-02_vspa_towel-warmer_broadway_BN_final_01.png"
					},
					{
						"tally": [
							[
								"BRUSHED_BRONZE"
							]
						],
						"value": "mst2024-02_vspa_towel-warmer_broadway_BB_final_01.png"
					},
					{
						"tally": [
							[
								"MATTE_BLACK"
							]
						],
						"value": "mst2024-02_vspa_towel-warmer_broadway_BM_final_01.png"
					}
				]
			},
			"price": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"POLISHED_CHROME"
							]
						],
						"value": 1700
					},
					{
						"tally": [
							[
								"BRUSHED_NICKEL"
							]
						],
						"value": 1850
					},
					{
						"tally": [
							[
								"BRUSHED_BRONZE"
							]
						],
						"value": 1850
					},
					{
						"tally": [
							[
								"MATTE_BLACK"
							]
						],
						"value": 1850
					}
				]
			}
		},
		"tooltips": {
			"list": [
				{
					"top": 31,
					"left": 77.5,
					"height": 43,
					"width": 11
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false
		}
	},
	{
		"code": "TOWEL_WARMER_W328",
		"partnumber": "W328",
		"previewname": "Towel Warmer W328",
		"name": "Towel Warmer W328",
		"price": 1550,
		"descriptions": {
			"short": "Towel Warmer",
			"long": "Inspired by contemporary design and made with heating wire to lighten the weight, the Metro Collection brings home refined lines to complement the most stylish sanctuaries. It's a worthy match for your everyday routine-giving you a renewed sense of wellbeing everyday. Discover a new way to immerse your senses and surround yourself in aromatherapy. In addition to providing you a warm, dry towel after you bathe, this collection includes an essential oil well.",
			"tech": "<li>Comes standard with 24-hour digital timer and matching timer cover plate</li><li>Available in brushed stainless steel and polished stainless steel</li><li>The quality, design and performance you expect from a MrSteam product</li><li>Installation tools and kit included</li><li>Dimensions: 31.375”H × 20”W × 4.75”D </li><li>All models need to be hardwired to 120V</li>"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/e12bad9c-8371-4732-a366-618fa0c54130.pdf"
		},
		"taxonomy": {
			"categories": [
				"towel-warmers-300"
			],
			"series": "S300"
		},
		"images": {
			"folder": "towel-warmers/S300-Metro/",
			"thumbnail": "W328TSSP.jpg",
			"scene": "TowelWarmer-W328-StainlessSteelPolished.png"
		},
		"options": {
			"enabledListsIds": [
				"finish"
			],
			"selected": {
				"finish": "STAINLESS_STEEL_POLISHED"
			},
			"list": {
				"finish": [
					"STAINLESS_STEEL_POLISHED",
					"STAINLESS_STEEL_BRUSHED"
				]
			}
		},
		"dynamicProperties": {
			"images.thumbnail": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"STAINLESS_STEEL_POLISHED"
							]
						],
						"value": "W328TSSP.jpg"
					},
					{
						"tally": [
							[
								"STAINLESS_STEEL_BRUSHED"
							]
						],
						"value": "W328TSSB.jpg"
					}
				]
			},
			"partnumber": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"STAINLESS_STEEL_POLISHED"
							]
						],
						"value": "W328TSSP"
					},
					{
						"tally": [
							[
								"STAINLESS_STEEL_BRUSHED"
							]
						],
						"value": "W328TSSB"
					}
				]
			},
			"images.scene": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"STAINLESS_STEEL_POLISHED"
							]
						],
						"value": "TowelWarmer-W328-StainlessSteelPolished.png"
					},
					{
						"tally": [
							[
								"STAINLESS_STEEL_BRUSHED"
							]
						],
						"value": "TowelWarmer-W328-StainlessSteelBrushed.png"
					}
				]
			},
			"price": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"STAINLESS_STEEL_POLISHED"
							]
						],
						"value": 1550
					},
					{
						"tally": [
							[
								"STAINLESS_STEEL_BRUSHED"
							]
						],
						"value": 1550
					}
				]
			}
		},
		"tooltips": {
			"list": [
				{
					"top": 36,
					"left": 77.5,
					"height": 26,
					"width": 11
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false
		}
	},
	{
		"code": "TOWEL_WARMER_W336",
		"partnumber": "W336",
		"previewname": "Towel Warmer W336",
		"name": "Towel Warmer W336",
		"price": 1675,
		"descriptions": {
			"short": "Towel Warmer",
			"long": "Inspired by contemporary design and made with heating wire to lighten the weight, the Metro Collection brings home refined lines to complement the most stylish sanctuaries. It's a worthy match for your everyday routine-giving you a renewed sense of wellbeing everyday. Discover a new way to immerse your senses and surround yourself in aromatherapy. In addition to providing you a warm, dry towel after you bathe, this collection includes an essential oil well.",
			"tech": "<li>Comes standard with 24-hour digital timer and matching timer cover plate</li><li>Available in brushed stainless steel and polished stainless steel</li><li>The quality, design and performance you expect from a MrSteam product</li><li>Installation tools and kit included</li><li>Dimensions: 38.875”H × 20”W × 4.75”D</li><li>All models need to be hardwired to 120V</li>"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/e12bad9c-8371-4732-a366-618fa0c54130.pdf"
		},
		"taxonomy": {
			"categories": [
				"towel-warmers-300"
			],
			"series": "S300"
		},
		"images": {
			"folder": "towel-warmers/S300-Metro/",
			"thumbnail": "W336TSSP.jpg",
			"scene": "TowelWarmer-W336-StainlessSteelPolished.png"
		},
		"options": {
			"enabledListsIds": [
				"finish"
			],
			"selected": {
				"finish": "STAINLESS_STEEL_POLISHED"
			},
			"list": {
				"finish": [
					"STAINLESS_STEEL_POLISHED",
					"STAINLESS_STEEL_BRUSHED"
				]
			}
		},
		"dynamicProperties": {
			"images.thumbnail": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"STAINLESS_STEEL_POLISHED"
							]
						],
						"value": "W336TSSP.jpg"
					},
					{
						"tally": [
							[
								"STAINLESS_STEEL_BRUSHED"
							]
						],
						"value": "W336TSSB.jpg"
					}
				]
			},
			"partnumber": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"STAINLESS_STEEL_POLISHED"
							]
						],
						"value": "W336TSSP"
					},
					{
						"tally": [
							[
								"STAINLESS_STEEL_BRUSHED"
							]
						],
						"value": "W336TSSB"
					}
				]
			},
			"images.scene": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"STAINLESS_STEEL_POLISHED"
							]
						],
						"value": "TowelWarmer-W336-StainlessSteelPolished.png"
					},
					{
						"tally": [
							[
								"STAINLESS_STEEL_BRUSHED"
							]
						],
						"value": "TowelWarmer-W336-StainlessSteelBrushed.png"
					}
				]
			},
			"price": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"STAINLESS_STEEL_POLISHED"
							]
						],
						"value": 1675
					},
					{
						"tally": [
							[
								"STAINLESS_STEEL_BRUSHED"
							]
						],
						"value": 1675
					}
				]
			}
		},
		"tooltips": {
			"list": [
				{
					"top": 35,
					"left": 77.5,
					"height": 34,
					"width": 11
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false
		}
	},
	{
		"code": "TOWEL_WARMER_W832",
		"partnumber": "W832",
		"previewname": "Towel Warmer W832",
		"name": "Towel Warmer W832",
		"price": 1400,
		"descriptions": {
			"short": "Towel Warmer",
			"long": "This towel warmer collection is properly named after the very hip and trendy art inspired streets of Tribeca NYC. This inspired collection will catch the eye, warm the heart, soothe the body, and leave you in a warm embrace.",
			"tech": "<li>The unique powder coated mat back color is heat cured to create a beautiful unique finish</li><li>Made with solid steel construction and is quality tested</li><li>Sturdy and solid contemporary design</li><li>Comes standard with a digital timer and cover plate</li>"
		},
		"links": {
			"tech": "https://pim.mrsteam.com/Resources/Entities/MRSTEAM/Documents/58eb8561-b0e5-4675-828d-bb01d74e943a.pdf"
		},
		"taxonomy": {
			"categories": [
				"towel-warmers-800"
			],
			"series": "S800"
		},
		"images": {
			"folder": "towel-warmers/S800-Tribeca/",
			"thumbnail": "W832TBN.jpg",
			"scene": "mst2024-02_vspa_towel-warmer_tribeca_BN_final_01.png"
		},
		"options": {
			"enabledListsIds": [
				"finish"
			],
			"selected": {
				"finish": "BRUSHED_NICKEL"
			},
			"list": {
				"finish": [
					"BRUSHED_NICKEL",
					"BRUSHED_BRONZE",
					"MATTE_BLACK"
				]
			}
		},
		"dynamicProperties": {
			"images.thumbnail": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"BRUSHED_NICKEL"
							]
						],
						"value": "W832TBN.jpg"
					},
					{
						"tally": [
							[
								"BRUSHED_BRONZE"
							]
						],
						"value": "W832TBB.jpg"
					},
					{
						"tally": [
							[
								"MATTE_BLACK"
							]
						],
						"value": "W832TMB.jpg"
					}
				]
			},
			"partnumber": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"BRUSHED_NICKEL"
							]
						],
						"value": "W832TBN"
					},
					{
						"tally": [
							[
								"BRUSHED_BRONZE"
							]
						],
						"value": "W832TBB"
					},
					{
						"tally": [
							[
								"MATTE_BLACK"
							]
						],
						"value": "W832TMB"
					}
				]
			},
			"images.scene": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"BRUSHED_NICKEL"
							]
						],
						"value": "mst2024-02_vspa_towel-warmer_tribeca_BN_final_01.png"
					},
					{
						"tally": [
							[
								"BRUSHED_BRONZE"
							]
						],
						"value": "mst2024-02_vspa_towel-warmer_tribeca_BB_final_01.png"
					},
					{
						"tally": [
							[
								"MATTE_BLACK"
							]
						],
						"value": "mst2024-02_vspa_towel-warmer_tribeca_BM_final_01.png"
					}
				]
			},
			"price": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"BRUSHED_NICKEL"
							]
						],
						"value": 1400
					},
					{
						"tally": [
							[
								"BRUSHED_BRONZE"
							]
						],
						"value": 1400
					},
					{
						"tally": [
							[
								"MATTE_BLACK"
							]
						],
						"value": 1400
					}
				]
			}
		},
		"tooltips": {
			"list": [
				{
					"top": 31,
					"left": 77.5,
					"height": 43,
					"width": 11
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false
		}
	}
];

/***/ },
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_checkbox_value_accessor__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives_default_value_accessor__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__directives_ng_control_status__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__directives_ng_form__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__directives_ng_model__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__directives_ng_model_group__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives_number_value_accessor__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__directives_radio_control_value_accessor__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__directives_range_value_accessor__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__directives_reactive_directives_form_control_directive__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__directives_reactive_directives_form_control_name__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__directives_reactive_directives_form_group_directive__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__directives_reactive_directives_form_group_name__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__directives_select_control_value_accessor__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__directives_select_multiple_control_value_accessor__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__directives_validators__ = __webpack_require__(390);
/* unused harmony reexport CheckboxControlValueAccessor */
/* unused harmony reexport DefaultValueAccessor */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__directives_ng_control__ = __webpack_require__(97);
/* unused harmony reexport NgControl */
/* unused harmony reexport NgControlStatusGroup */
/* unused harmony reexport NgControlStatus */
/* unused harmony reexport NgForm */
/* unused harmony reexport NgModel */
/* unused harmony reexport NgModelGroup */
/* unused harmony reexport NumberValueAccessor */
/* unused harmony reexport RadioControlValueAccessor */
/* unused harmony reexport RangeValueAccessor */
/* unused harmony reexport FormControlDirective */
/* unused harmony reexport FormControlName */
/* unused harmony reexport FormGroupDirective */
/* unused harmony reexport FormArrayName */
/* unused harmony reexport FormGroupName */
/* unused harmony reexport NgSelectOption */
/* unused harmony reexport SelectControlValueAccessor */
/* unused harmony reexport NgSelectMultipleOption */
/* unused harmony reexport SelectMultipleControlValueAccessor */
/* unused harmony export SHARED_FORM_DIRECTIVES */
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return TEMPLATE_DRIVEN_DIRECTIVES; });
/* harmony export (binding) */ __webpack_require__.d(exports, "c", function() { return REACTIVE_DRIVEN_DIRECTIVES; });
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return InternalFormsSharedModule; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

































var /** @type {?} */ SHARED_FORM_DIRECTIVES = [
    __WEBPACK_IMPORTED_MODULE_14__directives_select_control_value_accessor__["b" /* NgSelectOption */],
    __WEBPACK_IMPORTED_MODULE_15__directives_select_multiple_control_value_accessor__["b" /* NgSelectMultipleOption */],
    __WEBPACK_IMPORTED_MODULE_2__directives_default_value_accessor__["a" /* DefaultValueAccessor */],
    __WEBPACK_IMPORTED_MODULE_7__directives_number_value_accessor__["a" /* NumberValueAccessor */],
    __WEBPACK_IMPORTED_MODULE_9__directives_range_value_accessor__["a" /* RangeValueAccessor */],
    __WEBPACK_IMPORTED_MODULE_1__directives_checkbox_value_accessor__["a" /* CheckboxControlValueAccessor */],
    __WEBPACK_IMPORTED_MODULE_14__directives_select_control_value_accessor__["a" /* SelectControlValueAccessor */],
    __WEBPACK_IMPORTED_MODULE_15__directives_select_multiple_control_value_accessor__["a" /* SelectMultipleControlValueAccessor */],
    __WEBPACK_IMPORTED_MODULE_8__directives_radio_control_value_accessor__["a" /* RadioControlValueAccessor */],
    __WEBPACK_IMPORTED_MODULE_3__directives_ng_control_status__["a" /* NgControlStatus */],
    __WEBPACK_IMPORTED_MODULE_3__directives_ng_control_status__["b" /* NgControlStatusGroup */],
    __WEBPACK_IMPORTED_MODULE_16__directives_validators__["a" /* RequiredValidator */],
    __WEBPACK_IMPORTED_MODULE_16__directives_validators__["b" /* MinLengthValidator */],
    __WEBPACK_IMPORTED_MODULE_16__directives_validators__["c" /* MaxLengthValidator */],
    __WEBPACK_IMPORTED_MODULE_16__directives_validators__["d" /* PatternValidator */],
    __WEBPACK_IMPORTED_MODULE_16__directives_validators__["e" /* CheckboxRequiredValidator */],
];
var /** @type {?} */ TEMPLATE_DRIVEN_DIRECTIVES = [__WEBPACK_IMPORTED_MODULE_5__directives_ng_model__["a" /* NgModel */], __WEBPACK_IMPORTED_MODULE_6__directives_ng_model_group__["a" /* NgModelGroup */], __WEBPACK_IMPORTED_MODULE_4__directives_ng_form__["a" /* NgForm */]];
var /** @type {?} */ REACTIVE_DRIVEN_DIRECTIVES = [__WEBPACK_IMPORTED_MODULE_10__directives_reactive_directives_form_control_directive__["a" /* FormControlDirective */], __WEBPACK_IMPORTED_MODULE_12__directives_reactive_directives_form_group_directive__["a" /* FormGroupDirective */], __WEBPACK_IMPORTED_MODULE_11__directives_reactive_directives_form_control_name__["a" /* FormControlName */], __WEBPACK_IMPORTED_MODULE_13__directives_reactive_directives_form_group_name__["a" /* FormGroupName */], __WEBPACK_IMPORTED_MODULE_13__directives_reactive_directives_form_group_name__["b" /* FormArrayName */]];
/**
 * Internal module used for sharing directives between FormsModule and ReactiveFormsModule
 */
var InternalFormsSharedModule = (function () {
    function InternalFormsSharedModule() {
    }
    InternalFormsSharedModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                    declarations: SHARED_FORM_DIRECTIVES,
                    exports: SHARED_FORM_DIRECTIVES,
                },] },
    ];
    /** @nocollapse */
    InternalFormsSharedModule.ctorParameters = function () { return []; };
    return InternalFormsSharedModule;
}());
function InternalFormsSharedModule_tsickle_Closure_declarations() {
    /** @type {?} */
    InternalFormsSharedModule.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    InternalFormsSharedModule.ctorParameters;
}
//# sourceMappingURL=directives.js.map

/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ exports["a"] = normalizeValidator;
/* harmony export (immutable) */ exports["b"] = normalizeAsyncValidator;
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @param {?} validator
 * @return {?}
 */
function normalizeValidator(validator) {
    if (((validator)).validate) {
        return function (c) { return ((validator)).validate(c); };
    }
    else {
        return (validator);
    }
}
/**
 * @param {?} validator
 * @return {?}
 */
function normalizeAsyncValidator(validator) {
    if (((validator)).validate) {
        return function (c) { return ((validator)).validate(c); };
    }
    else {
        return (validator);
    }
}
//# sourceMappingURL=normalize_validator.js.map

/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives_radio_control_value_accessor__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_builder__ = __webpack_require__(392);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return FormsModule; });
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return ReactiveFormsModule; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */




/**
 * The ng module for forms.
 * \@stable
 */
var FormsModule = (function () {
    function FormsModule() {
    }
    FormsModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                    declarations: __WEBPACK_IMPORTED_MODULE_1__directives__["a" /* TEMPLATE_DRIVEN_DIRECTIVES */],
                    providers: [__WEBPACK_IMPORTED_MODULE_2__directives_radio_control_value_accessor__["b" /* RadioControlRegistry */]],
                    exports: [__WEBPACK_IMPORTED_MODULE_1__directives__["b" /* InternalFormsSharedModule */], __WEBPACK_IMPORTED_MODULE_1__directives__["a" /* TEMPLATE_DRIVEN_DIRECTIVES */]]
                },] },
    ];
    /** @nocollapse */
    FormsModule.ctorParameters = function () { return []; };
    return FormsModule;
}());
function FormsModule_tsickle_Closure_declarations() {
    /** @type {?} */
    FormsModule.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    FormsModule.ctorParameters;
}
/**
 * The ng module for reactive forms.
 * \@stable
 */
var ReactiveFormsModule = (function () {
    function ReactiveFormsModule() {
    }
    ReactiveFormsModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                    declarations: [__WEBPACK_IMPORTED_MODULE_1__directives__["c" /* REACTIVE_DRIVEN_DIRECTIVES */]],
                    providers: [__WEBPACK_IMPORTED_MODULE_3__form_builder__["a" /* FormBuilder */], __WEBPACK_IMPORTED_MODULE_2__directives_radio_control_value_accessor__["b" /* RadioControlRegistry */]],
                    exports: [__WEBPACK_IMPORTED_MODULE_1__directives__["b" /* InternalFormsSharedModule */], __WEBPACK_IMPORTED_MODULE_1__directives__["c" /* REACTIVE_DRIVEN_DIRECTIVES */]]
                },] },
    ];
    /** @nocollapse */
    ReactiveFormsModule.ctorParameters = function () { return []; };
    return ReactiveFormsModule;
}());
function ReactiveFormsModule_tsickle_Closure_declarations() {
    /** @type {?} */
    ReactiveFormsModule.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    ReactiveFormsModule.ctorParameters;
}
//# sourceMappingURL=form_providers.js.map

/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__directives_abstract_control_directive__ = __webpack_require__(261);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__directives_abstract_control_directive__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__directives_abstract_form_group_directive__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_abstract_form_group_directive__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives_checkbox_value_accessor__ = __webpack_require__(187);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__directives_checkbox_value_accessor__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__directives_control_container__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__directives_control_container__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__directives_control_value_accessor__ = __webpack_require__(42);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "f", function() { return __WEBPACK_IMPORTED_MODULE_4__directives_control_value_accessor__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "g", function() { return __WEBPACK_IMPORTED_MODULE_5__directives_default_value_accessor__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__directives_default_value_accessor__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__directives_ng_control__ = __webpack_require__(97);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "h", function() { return __WEBPACK_IMPORTED_MODULE_6__directives_ng_control__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "i", function() { return __WEBPACK_IMPORTED_MODULE_7__directives_ng_control_status__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives_ng_control_status__ = __webpack_require__(262);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "j", function() { return __WEBPACK_IMPORTED_MODULE_7__directives_ng_control_status__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__directives_ng_form__ = __webpack_require__(139);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "k", function() { return __WEBPACK_IMPORTED_MODULE_8__directives_ng_form__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "l", function() { return __WEBPACK_IMPORTED_MODULE_9__directives_ng_model__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__directives_ng_model__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__directives_ng_model_group__ = __webpack_require__(189);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "m", function() { return __WEBPACK_IMPORTED_MODULE_10__directives_ng_model_group__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "n", function() { return __WEBPACK_IMPORTED_MODULE_11__directives_radio_control_value_accessor__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__directives_radio_control_value_accessor__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__directives_reactive_directives_form_control_directive__ = __webpack_require__(266);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "o", function() { return __WEBPACK_IMPORTED_MODULE_12__directives_reactive_directives_form_control_directive__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__directives_reactive_directives_form_control_name__ = __webpack_require__(267);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "p", function() { return __WEBPACK_IMPORTED_MODULE_13__directives_reactive_directives_form_control_name__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__directives_reactive_directives_form_group_directive__ = __webpack_require__(141);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "q", function() { return __WEBPACK_IMPORTED_MODULE_14__directives_reactive_directives_form_group_directive__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__directives_reactive_directives_form_group_name__ = __webpack_require__(142);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "r", function() { return __WEBPACK_IMPORTED_MODULE_15__directives_reactive_directives_form_group_name__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "a", function() { return __WEBPACK_IMPORTED_MODULE_15__directives_reactive_directives_form_group_name__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "s", function() { return __WEBPACK_IMPORTED_MODULE_16__directives_select_control_value_accessor__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "t", function() { return __WEBPACK_IMPORTED_MODULE_16__directives_select_control_value_accessor__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__directives_select_control_value_accessor__ = __webpack_require__(191);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "u", function() { return __WEBPACK_IMPORTED_MODULE_17__directives_select_multiple_control_value_accessor__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__directives_select_multiple_control_value_accessor__ = __webpack_require__(192);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "v", function() { return __WEBPACK_IMPORTED_MODULE_18__directives_validators__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "w", function() { return __WEBPACK_IMPORTED_MODULE_18__directives_validators__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "x", function() { return __WEBPACK_IMPORTED_MODULE_18__directives_validators__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "y", function() { return __WEBPACK_IMPORTED_MODULE_18__directives_validators__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "z", function() { return __WEBPACK_IMPORTED_MODULE_18__directives_validators__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__directives_validators__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__form_builder__ = __webpack_require__(392);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "A", function() { return __WEBPACK_IMPORTED_MODULE_19__form_builder__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__model__ = __webpack_require__(193);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "C", function() { return __WEBPACK_IMPORTED_MODULE_20__model__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "D", function() { return __WEBPACK_IMPORTED_MODULE_20__model__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "E", function() { return __WEBPACK_IMPORTED_MODULE_20__model__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "B", function() { return __WEBPACK_IMPORTED_MODULE_20__model__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__validators__ = __webpack_require__(54);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "F", function() { return __WEBPACK_IMPORTED_MODULE_21__validators__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "G", function() { return __WEBPACK_IMPORTED_MODULE_21__validators__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "H", function() { return __WEBPACK_IMPORTED_MODULE_21__validators__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__version__ = __webpack_require__(600);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "I", function() { return __WEBPACK_IMPORTED_MODULE_22__version__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__form_providers__ = __webpack_require__(598);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "J", function() { return __WEBPACK_IMPORTED_MODULE_23__form_providers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "K", function() { return __WEBPACK_IMPORTED_MODULE_23__form_providers__["b"]; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @module
 * @description
 * This module is used for handling user input, by defining and building a {@link FormGroup} that
 * consists of {@link FormControl} objects, and mapping them onto the DOM. {@link FormControl}
 * objects can then be used to read information from the form DOM elements.
 *
 * Forms providers are not included in default providers; you must import these providers
 * explicitly.
 */

























//# sourceMappingURL=forms.js.map

/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return VERSION; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * @stable
 */
var /** @type {?} */ VERSION = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["Version"]('2.4.10');
//# sourceMappingURL=version.js.map

/***/ },
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_observable_from__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_observable_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_observable_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_observable_of__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_observable_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_catch__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_catch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_operator_catch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_concatAll__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_concatAll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_operator_concatAll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_operator_first__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_operator_first___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_rxjs_operator_first__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_map__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_operator_mergeMap__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_operator_mergeMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_rxjs_operator_mergeMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs_util_EmptyError__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs_util_EmptyError___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_rxjs_util_EmptyError__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__router_config_loader__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__url_tree__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_collection__ = __webpack_require__(61);
/* harmony export (immutable) */ exports["a"] = applyRedirects;
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */













var NoMatch = (function () {
    /**
     * @param {?=} segmentGroup
     */
    function NoMatch(segmentGroup) {
        if (segmentGroup === void 0) { segmentGroup = null; }
        this.segmentGroup = segmentGroup;
    }
    return NoMatch;
}());
function NoMatch_tsickle_Closure_declarations() {
    /** @type {?} */
    NoMatch.prototype.segmentGroup;
}
var AbsoluteRedirect = (function () {
    /**
     * @param {?} urlTree
     */
    function AbsoluteRedirect(urlTree) {
        this.urlTree = urlTree;
    }
    return AbsoluteRedirect;
}());
function AbsoluteRedirect_tsickle_Closure_declarations() {
    /** @type {?} */
    AbsoluteRedirect.prototype.urlTree;
}
/**
 * @param {?} segmentGroup
 * @return {?}
 */
function noMatch(segmentGroup) {
    return new __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"](function (obs) { return obs.error(new NoMatch(segmentGroup)); });
}
/**
 * @param {?} newTree
 * @return {?}
 */
function absoluteRedirect(newTree) {
    return new __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"](function (obs) { return obs.error(new AbsoluteRedirect(newTree)); });
}
/**
 * @param {?} redirectTo
 * @return {?}
 */
function namedOutletsRedirect(redirectTo) {
    return new __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"](function (obs) { return obs.error(new Error("Only absolute redirects can have named outlets. redirectTo: '" + redirectTo + "'")); });
}
/**
 * @param {?} route
 * @return {?}
 */
function canLoadFails(route) {
    return new __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"](function (obs) { return obs.error(new __WEBPACK_IMPORTED_MODULE_10__shared__["b" /* NavigationCancelingError */]("Cannot load children because the guard of the route \"path: '" + route.path + "'\" returned false")); });
}
/**
 * @param {?} injector
 * @param {?} configLoader
 * @param {?} urlSerializer
 * @param {?} urlTree
 * @param {?} config
 * @return {?}
 */
function applyRedirects(injector, configLoader, urlSerializer, urlTree, config) {
    return new ApplyRedirects(injector, configLoader, urlSerializer, urlTree, config).apply();
}
var ApplyRedirects = (function () {
    /**
     * @param {?} injector
     * @param {?} configLoader
     * @param {?} urlSerializer
     * @param {?} urlTree
     * @param {?} config
     */
    function ApplyRedirects(injector, configLoader, urlSerializer, urlTree, config) {
        this.injector = injector;
        this.configLoader = configLoader;
        this.urlSerializer = urlSerializer;
        this.urlTree = urlTree;
        this.config = config;
        this.allowRedirects = true;
    }
    /**
     * @return {?}
     */
    ApplyRedirects.prototype.apply = function () {
        var _this = this;
        var /** @type {?} */ expanded$ = this.expandSegmentGroup(this.injector, this.config, this.urlTree.root, __WEBPACK_IMPORTED_MODULE_10__shared__["a" /* PRIMARY_OUTLET */]);
        var /** @type {?} */ urlTrees$ = __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_map__["map"].call(expanded$, function (rootSegmentGroup) { return _this.createUrlTree(rootSegmentGroup, _this.urlTree.queryParams, _this.urlTree.fragment); });
        return __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_catch__["_catch"].call(urlTrees$, function (e) {
            if (e instanceof AbsoluteRedirect) {
                // after an absolute redirect we do not apply any more redirects!
                _this.allowRedirects = false;
                // we need to run matching, so we can fetch all lazy-loaded modules
                return _this.match(e.urlTree);
            }
            else if (e instanceof NoMatch) {
                throw _this.noMatchError(e);
            }
            else {
                throw e;
            }
        });
    };
    /**
     * @param {?} tree
     * @return {?}
     */
    ApplyRedirects.prototype.match = function (tree) {
        var _this = this;
        var /** @type {?} */ expanded$ = this.expandSegmentGroup(this.injector, this.config, tree.root, __WEBPACK_IMPORTED_MODULE_10__shared__["a" /* PRIMARY_OUTLET */]);
        var /** @type {?} */ mapped$ = __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_map__["map"].call(expanded$, function (rootSegmentGroup) {
            return _this.createUrlTree(rootSegmentGroup, tree.queryParams, tree.fragment);
        });
        return __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_catch__["_catch"].call(mapped$, function (e) {
            if (e instanceof NoMatch) {
                throw _this.noMatchError(e);
            }
            else {
                throw e;
            }
        });
    };
    /**
     * @param {?} e
     * @return {?}
     */
    ApplyRedirects.prototype.noMatchError = function (e) {
        return new Error("Cannot match any routes. URL Segment: '" + e.segmentGroup + "'");
    };
    /**
     * @param {?} rootCandidate
     * @param {?} queryParams
     * @param {?} fragment
     * @return {?}
     */
    ApplyRedirects.prototype.createUrlTree = function (rootCandidate, queryParams, fragment) {
        var /** @type {?} */ root = rootCandidate.segments.length > 0 ?
            new __WEBPACK_IMPORTED_MODULE_11__url_tree__["a" /* UrlSegmentGroup */]([], (_a = {}, _a[__WEBPACK_IMPORTED_MODULE_10__shared__["a" /* PRIMARY_OUTLET */]] = rootCandidate, _a)) :
            rootCandidate;
        return new __WEBPACK_IMPORTED_MODULE_11__url_tree__["b" /* UrlTree */](root, queryParams, fragment);
        var _a;
    };
    /**
     * @param {?} injector
     * @param {?} routes
     * @param {?} segmentGroup
     * @param {?} outlet
     * @return {?}
     */
    ApplyRedirects.prototype.expandSegmentGroup = function (injector, routes, segmentGroup, outlet) {
        if (segmentGroup.segments.length === 0 && segmentGroup.hasChildren()) {
            return __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_map__["map"].call(this.expandChildren(injector, routes, segmentGroup), function (children) { return new __WEBPACK_IMPORTED_MODULE_11__url_tree__["a" /* UrlSegmentGroup */]([], children); });
        }
        else {
            return this.expandSegment(injector, segmentGroup, routes, segmentGroup.segments, outlet, true);
        }
    };
    /**
     * @param {?} injector
     * @param {?} routes
     * @param {?} segmentGroup
     * @return {?}
     */
    ApplyRedirects.prototype.expandChildren = function (injector, routes, segmentGroup) {
        var _this = this;
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_collection__["e" /* waitForMap */])(segmentGroup.children, function (childOutlet, child) { return _this.expandSegmentGroup(injector, routes, child, childOutlet); });
    };
    /**
     * @param {?} injector
     * @param {?} segmentGroup
     * @param {?} routes
     * @param {?} segments
     * @param {?} outlet
     * @param {?} allowRedirects
     * @return {?}
     */
    ApplyRedirects.prototype.expandSegment = function (injector, segmentGroup, routes, segments, outlet, allowRedirects) {
        var _this = this;
        var /** @type {?} */ routes$ = __WEBPACK_IMPORTED_MODULE_2_rxjs_observable_of__["of"].apply(void 0, routes);
        var /** @type {?} */ processedRoutes$ = __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_map__["map"].call(routes$, function (r) {
            var /** @type {?} */ expanded$ = _this.expandSegmentAgainstRoute(injector, segmentGroup, routes, r, segments, outlet, allowRedirects);
            return __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_catch__["_catch"].call(expanded$, function (e) {
                if (e instanceof NoMatch)
                    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_of__["of"])(null);
                else
                    throw e;
            });
        });
        var /** @type {?} */ concattedProcessedRoutes$ = __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_concatAll__["concatAll"].call(processedRoutes$);
        var /** @type {?} */ first$ = __WEBPACK_IMPORTED_MODULE_5_rxjs_operator_first__["first"].call(concattedProcessedRoutes$, function (s) { return !!s; });
        return __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_catch__["_catch"].call(first$, function (e, _) {
            if (e instanceof __WEBPACK_IMPORTED_MODULE_8_rxjs_util_EmptyError__["EmptyError"]) {
                if (_this.noLeftoversInUrl(segmentGroup, segments, outlet)) {
                    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_of__["of"])(new __WEBPACK_IMPORTED_MODULE_11__url_tree__["a" /* UrlSegmentGroup */]([], {}));
                }
                else {
                    throw new NoMatch(segmentGroup);
                }
            }
            else {
                throw e;
            }
        });
    };
    /**
     * @param {?} segmentGroup
     * @param {?} segments
     * @param {?} outlet
     * @return {?}
     */
    ApplyRedirects.prototype.noLeftoversInUrl = function (segmentGroup, segments, outlet) {
        return segments.length === 0 && !segmentGroup.children[outlet];
    };
    /**
     * @param {?} injector
     * @param {?} segmentGroup
     * @param {?} routes
     * @param {?} route
     * @param {?} paths
     * @param {?} outlet
     * @param {?} allowRedirects
     * @return {?}
     */
    ApplyRedirects.prototype.expandSegmentAgainstRoute = function (injector, segmentGroup, routes, route, paths, outlet, allowRedirects) {
        if (getOutlet(route) !== outlet)
            return noMatch(segmentGroup);
        if (route.redirectTo !== undefined && !(allowRedirects && this.allowRedirects))
            return noMatch(segmentGroup);
        if (route.redirectTo === undefined) {
            return this.matchSegmentAgainstRoute(injector, segmentGroup, route, paths);
        }
        else {
            return this.expandSegmentAgainstRouteUsingRedirect(injector, segmentGroup, routes, route, paths, outlet);
        }
    };
    /**
     * @param {?} injector
     * @param {?} segmentGroup
     * @param {?} routes
     * @param {?} route
     * @param {?} segments
     * @param {?} outlet
     * @return {?}
     */
    ApplyRedirects.prototype.expandSegmentAgainstRouteUsingRedirect = function (injector, segmentGroup, routes, route, segments, outlet) {
        if (route.path === '**') {
            return this.expandWildCardWithParamsAgainstRouteUsingRedirect(injector, routes, route, outlet);
        }
        else {
            return this.expandRegularSegmentAgainstRouteUsingRedirect(injector, segmentGroup, routes, route, segments, outlet);
        }
    };
    /**
     * @param {?} injector
     * @param {?} routes
     * @param {?} route
     * @param {?} outlet
     * @return {?}
     */
    ApplyRedirects.prototype.expandWildCardWithParamsAgainstRouteUsingRedirect = function (injector, routes, route, outlet) {
        var _this = this;
        var /** @type {?} */ newTree = this.applyRedirectCommands([], route.redirectTo, {});
        if (route.redirectTo.startsWith('/')) {
            return absoluteRedirect(newTree);
        }
        else {
            return __WEBPACK_IMPORTED_MODULE_7_rxjs_operator_mergeMap__["mergeMap"].call(this.lineralizeSegments(route, newTree), function (newSegments) {
                var /** @type {?} */ group = new __WEBPACK_IMPORTED_MODULE_11__url_tree__["a" /* UrlSegmentGroup */](newSegments, {});
                return _this.expandSegment(injector, group, routes, newSegments, outlet, false);
            });
        }
    };
    /**
     * @param {?} injector
     * @param {?} segmentGroup
     * @param {?} routes
     * @param {?} route
     * @param {?} segments
     * @param {?} outlet
     * @return {?}
     */
    ApplyRedirects.prototype.expandRegularSegmentAgainstRouteUsingRedirect = function (injector, segmentGroup, routes, route, segments, outlet) {
        var _this = this;
        var _a = match(segmentGroup, route, segments), matched = _a.matched, consumedSegments = _a.consumedSegments, lastChild = _a.lastChild, positionalParamSegments = _a.positionalParamSegments;
        if (!matched)
            return noMatch(segmentGroup);
        var /** @type {?} */ newTree = this.applyRedirectCommands(consumedSegments, route.redirectTo, /** @type {?} */ (positionalParamSegments));
        if (route.redirectTo.startsWith('/')) {
            return absoluteRedirect(newTree);
        }
        else {
            return __WEBPACK_IMPORTED_MODULE_7_rxjs_operator_mergeMap__["mergeMap"].call(this.lineralizeSegments(route, newTree), function (newSegments) {
                return _this.expandSegment(injector, segmentGroup, routes, newSegments.concat(segments.slice(lastChild)), outlet, false);
            });
        }
    };
    /**
     * @param {?} injector
     * @param {?} rawSegmentGroup
     * @param {?} route
     * @param {?} segments
     * @return {?}
     */
    ApplyRedirects.prototype.matchSegmentAgainstRoute = function (injector, rawSegmentGroup, route, segments) {
        var _this = this;
        if (route.path === '**') {
            if (route.loadChildren) {
                return __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_map__["map"].call(this.configLoader.load(injector, route.loadChildren), function (r) {
                    ((route))._loadedConfig = r;
                    return new __WEBPACK_IMPORTED_MODULE_11__url_tree__["a" /* UrlSegmentGroup */](segments, {});
                });
            }
            else {
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_of__["of"])(new __WEBPACK_IMPORTED_MODULE_11__url_tree__["a" /* UrlSegmentGroup */](segments, {}));
            }
        }
        else {
            var _a = match(rawSegmentGroup, route, segments), matched = _a.matched, consumedSegments_1 = _a.consumedSegments, lastChild = _a.lastChild;
            if (!matched)
                return noMatch(rawSegmentGroup);
            var /** @type {?} */ rawSlicedSegments_1 = segments.slice(lastChild);
            var /** @type {?} */ childConfig$ = this.getChildConfig(injector, route);
            return __WEBPACK_IMPORTED_MODULE_7_rxjs_operator_mergeMap__["mergeMap"].call(childConfig$, function (routerConfig) {
                var /** @type {?} */ childInjector = routerConfig.injector;
                var /** @type {?} */ childConfig = routerConfig.routes;
                var _a = split(rawSegmentGroup, consumedSegments_1, rawSlicedSegments_1, childConfig), segmentGroup = _a.segmentGroup, slicedSegments = _a.slicedSegments;
                if (slicedSegments.length === 0 && segmentGroup.hasChildren()) {
                    var /** @type {?} */ expanded$ = _this.expandChildren(childInjector, childConfig, segmentGroup);
                    return __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_map__["map"].call(expanded$, function (children) { return new __WEBPACK_IMPORTED_MODULE_11__url_tree__["a" /* UrlSegmentGroup */](consumedSegments_1, children); });
                }
                else if (childConfig.length === 0 && slicedSegments.length === 0) {
                    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_of__["of"])(new __WEBPACK_IMPORTED_MODULE_11__url_tree__["a" /* UrlSegmentGroup */](consumedSegments_1, {}));
                }
                else {
                    var /** @type {?} */ expanded$ = _this.expandSegment(childInjector, segmentGroup, childConfig, slicedSegments, __WEBPACK_IMPORTED_MODULE_10__shared__["a" /* PRIMARY_OUTLET */], true);
                    return __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_map__["map"].call(expanded$, function (cs) { return new __WEBPACK_IMPORTED_MODULE_11__url_tree__["a" /* UrlSegmentGroup */](consumedSegments_1.concat(cs.segments), cs.children); });
                }
            });
        }
    };
    /**
     * @param {?} injector
     * @param {?} route
     * @return {?}
     */
    ApplyRedirects.prototype.getChildConfig = function (injector, route) {
        var _this = this;
        if (route.children) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_of__["of"])(new __WEBPACK_IMPORTED_MODULE_9__router_config_loader__["a" /* LoadedRouterConfig */](route.children, injector, null, null));
        }
        else if (route.loadChildren) {
            return __WEBPACK_IMPORTED_MODULE_7_rxjs_operator_mergeMap__["mergeMap"].call(runGuards(injector, route), function (shouldLoad) {
                if (shouldLoad) {
                    if (((route))._loadedConfig) {
                        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_of__["of"])(((route))._loadedConfig);
                    }
                    else {
                        return __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_map__["map"].call(_this.configLoader.load(injector, route.loadChildren), function (r) {
                            ((route))._loadedConfig = r;
                            return r;
                        });
                    }
                }
                else {
                    return canLoadFails(route);
                }
            });
        }
        else {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_of__["of"])(new __WEBPACK_IMPORTED_MODULE_9__router_config_loader__["a" /* LoadedRouterConfig */]([], injector, null, null));
        }
    };
    /**
     * @param {?} route
     * @param {?} urlTree
     * @return {?}
     */
    ApplyRedirects.prototype.lineralizeSegments = function (route, urlTree) {
        var /** @type {?} */ res = [];
        var /** @type {?} */ c = urlTree.root;
        while (true) {
            res = res.concat(c.segments);
            if (c.numberOfChildren === 0) {
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_of__["of"])(res);
            }
            else if (c.numberOfChildren > 1 || !c.children[__WEBPACK_IMPORTED_MODULE_10__shared__["a" /* PRIMARY_OUTLET */]]) {
                return namedOutletsRedirect(route.redirectTo);
            }
            else {
                c = c.children[__WEBPACK_IMPORTED_MODULE_10__shared__["a" /* PRIMARY_OUTLET */]];
            }
        }
    };
    /**
     * @param {?} segments
     * @param {?} redirectTo
     * @param {?} posParams
     * @return {?}
     */
    ApplyRedirects.prototype.applyRedirectCommands = function (segments, redirectTo, posParams) {
        var /** @type {?} */ t = this.urlSerializer.parse(redirectTo);
        return this.applyRedirectCreatreUrlTree(redirectTo, this.urlSerializer.parse(redirectTo), segments, posParams);
    };
    /**
     * @param {?} redirectTo
     * @param {?} urlTree
     * @param {?} segments
     * @param {?} posParams
     * @return {?}
     */
    ApplyRedirects.prototype.applyRedirectCreatreUrlTree = function (redirectTo, urlTree, segments, posParams) {
        var /** @type {?} */ newRoot = this.createSegmentGroup(redirectTo, urlTree.root, segments, posParams);
        return new __WEBPACK_IMPORTED_MODULE_11__url_tree__["b" /* UrlTree */](newRoot, this.createQueryParams(urlTree.queryParams, this.urlTree.queryParams), urlTree.fragment);
    };
    /**
     * @param {?} redirectToParams
     * @param {?} actualParams
     * @return {?}
     */
    ApplyRedirects.prototype.createQueryParams = function (redirectToParams, actualParams) {
        var /** @type {?} */ res = {};
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_collection__["d" /* forEach */])(redirectToParams, function (v, k) {
            if (v.startsWith(':')) {
                res[k] = actualParams[v.substring(1)];
            }
            else {
                res[k] = v;
            }
        });
        return res;
    };
    /**
     * @param {?} redirectTo
     * @param {?} group
     * @param {?} segments
     * @param {?} posParams
     * @return {?}
     */
    ApplyRedirects.prototype.createSegmentGroup = function (redirectTo, group, segments, posParams) {
        var _this = this;
        var /** @type {?} */ updatedSegments = this.createSegments(redirectTo, group.segments, segments, posParams);
        var /** @type {?} */ children = {};
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_collection__["d" /* forEach */])(group.children, function (child, name) {
            children[name] = _this.createSegmentGroup(redirectTo, child, segments, posParams);
        });
        return new __WEBPACK_IMPORTED_MODULE_11__url_tree__["a" /* UrlSegmentGroup */](updatedSegments, children);
    };
    /**
     * @param {?} redirectTo
     * @param {?} redirectToSegments
     * @param {?} actualSegments
     * @param {?} posParams
     * @return {?}
     */
    ApplyRedirects.prototype.createSegments = function (redirectTo, redirectToSegments, actualSegments, posParams) {
        var _this = this;
        return redirectToSegments.map(function (s) { return s.path.startsWith(':') ? _this.findPosParam(redirectTo, s, posParams) :
            _this.findOrReturn(s, actualSegments); });
    };
    /**
     * @param {?} redirectTo
     * @param {?} redirectToUrlSegment
     * @param {?} posParams
     * @return {?}
     */
    ApplyRedirects.prototype.findPosParam = function (redirectTo, redirectToUrlSegment, posParams) {
        var /** @type {?} */ pos = posParams[redirectToUrlSegment.path.substring(1)];
        if (!pos)
            throw new Error("Cannot redirect to '" + redirectTo + "'. Cannot find '" + redirectToUrlSegment.path + "'.");
        return pos;
    };
    /**
     * @param {?} redirectToUrlSegment
     * @param {?} actualSegments
     * @return {?}
     */
    ApplyRedirects.prototype.findOrReturn = function (redirectToUrlSegment, actualSegments) {
        var /** @type {?} */ idx = 0;
        for (var _i = 0, actualSegments_1 = actualSegments; _i < actualSegments_1.length; _i++) {
            var s = actualSegments_1[_i];
            if (s.path === redirectToUrlSegment.path) {
                actualSegments.splice(idx);
                return s;
            }
            idx++;
        }
        return redirectToUrlSegment;
    };
    return ApplyRedirects;
}());
function ApplyRedirects_tsickle_Closure_declarations() {
    /** @type {?} */
    ApplyRedirects.prototype.allowRedirects;
    /** @type {?} */
    ApplyRedirects.prototype.injector;
    /** @type {?} */
    ApplyRedirects.prototype.configLoader;
    /** @type {?} */
    ApplyRedirects.prototype.urlSerializer;
    /** @type {?} */
    ApplyRedirects.prototype.urlTree;
    /** @type {?} */
    ApplyRedirects.prototype.config;
}
/**
 * @param {?} injector
 * @param {?} route
 * @return {?}
 */
function runGuards(injector, route) {
    var /** @type {?} */ canLoad = route.canLoad;
    if (!canLoad || canLoad.length === 0)
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_of__["of"])(true);
    var /** @type {?} */ obs = __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_map__["map"].call(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_rxjs_observable_from__["from"])(canLoad), function (c) {
        var /** @type {?} */ guard = injector.get(c);
        if (guard.canLoad) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_collection__["b" /* wrapIntoObservable */])(guard.canLoad(route));
        }
        else {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_collection__["b" /* wrapIntoObservable */])(guard(route));
        }
    });
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_collection__["f" /* andObservables */])(obs);
}
/**
 * @param {?} segmentGroup
 * @param {?} route
 * @param {?} segments
 * @return {?}
 */
function match(segmentGroup, route, segments) {
    var /** @type {?} */ noMatch = { matched: false, consumedSegments: /** @type {?} */ ([]), lastChild: 0, positionalParamSegments: {} };
    if (route.path === '') {
        if ((route.pathMatch === 'full') && (segmentGroup.hasChildren() || segments.length > 0)) {
            return { matched: false, consumedSegments: [], lastChild: 0, positionalParamSegments: {} };
        }
        else {
            return { matched: true, consumedSegments: [], lastChild: 0, positionalParamSegments: {} };
        }
    }
    var /** @type {?} */ matcher = route.matcher || __WEBPACK_IMPORTED_MODULE_10__shared__["c" /* defaultUrlMatcher */];
    var /** @type {?} */ res = matcher(segments, segmentGroup, route);
    if (!res)
        return noMatch;
    return {
        matched: true,
        consumedSegments: res.consumed,
        lastChild: res.consumed.length,
        positionalParamSegments: res.posParams
    };
}
/**
 * @param {?} segmentGroup
 * @param {?} consumedSegments
 * @param {?} slicedSegments
 * @param {?} config
 * @return {?}
 */
function split(segmentGroup, consumedSegments, slicedSegments, config) {
    if (slicedSegments.length > 0 &&
        containsEmptyPathRedirectsWithNamedOutlets(segmentGroup, slicedSegments, config)) {
        var /** @type {?} */ s = new __WEBPACK_IMPORTED_MODULE_11__url_tree__["a" /* UrlSegmentGroup */](consumedSegments, createChildrenForEmptySegments(config, new __WEBPACK_IMPORTED_MODULE_11__url_tree__["a" /* UrlSegmentGroup */](slicedSegments, segmentGroup.children)));
        return { segmentGroup: mergeTrivialChildren(s), slicedSegments: [] };
    }
    else if (slicedSegments.length === 0 &&
        containsEmptyPathRedirects(segmentGroup, slicedSegments, config)) {
        var /** @type {?} */ s = new __WEBPACK_IMPORTED_MODULE_11__url_tree__["a" /* UrlSegmentGroup */](segmentGroup.segments, addEmptySegmentsToChildrenIfNeeded(segmentGroup, slicedSegments, config, segmentGroup.children));
        return { segmentGroup: mergeTrivialChildren(s), slicedSegments: slicedSegments };
    }
    else {
        return { segmentGroup: segmentGroup, slicedSegments: slicedSegments };
    }
}
/**
 * @param {?} s
 * @return {?}
 */
function mergeTrivialChildren(s) {
    if (s.numberOfChildren === 1 && s.children[__WEBPACK_IMPORTED_MODULE_10__shared__["a" /* PRIMARY_OUTLET */]]) {
        var /** @type {?} */ c = s.children[__WEBPACK_IMPORTED_MODULE_10__shared__["a" /* PRIMARY_OUTLET */]];
        return new __WEBPACK_IMPORTED_MODULE_11__url_tree__["a" /* UrlSegmentGroup */](s.segments.concat(c.segments), c.children);
    }
    else {
        return s;
    }
}
/**
 * @param {?} segmentGroup
 * @param {?} slicedSegments
 * @param {?} routes
 * @param {?} children
 * @return {?}
 */
function addEmptySegmentsToChildrenIfNeeded(segmentGroup, slicedSegments, routes, children) {
    var /** @type {?} */ res = {};
    for (var _i = 0, routes_1 = routes; _i < routes_1.length; _i++) {
        var r = routes_1[_i];
        if (emptyPathRedirect(segmentGroup, slicedSegments, r) && !children[getOutlet(r)]) {
            res[getOutlet(r)] = new __WEBPACK_IMPORTED_MODULE_11__url_tree__["a" /* UrlSegmentGroup */]([], {});
        }
    }
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_collection__["g" /* merge */])(children, res);
}
/**
 * @param {?} routes
 * @param {?} primarySegmentGroup
 * @return {?}
 */
function createChildrenForEmptySegments(routes, primarySegmentGroup) {
    var /** @type {?} */ res = {};
    res[__WEBPACK_IMPORTED_MODULE_10__shared__["a" /* PRIMARY_OUTLET */]] = primarySegmentGroup;
    for (var _i = 0, routes_2 = routes; _i < routes_2.length; _i++) {
        var r = routes_2[_i];
        if (r.path === '' && getOutlet(r) !== __WEBPACK_IMPORTED_MODULE_10__shared__["a" /* PRIMARY_OUTLET */]) {
            res[getOutlet(r)] = new __WEBPACK_IMPORTED_MODULE_11__url_tree__["a" /* UrlSegmentGroup */]([], {});
        }
    }
    return res;
}
/**
 * @param {?} segmentGroup
 * @param {?} slicedSegments
 * @param {?} routes
 * @return {?}
 */
function containsEmptyPathRedirectsWithNamedOutlets(segmentGroup, slicedSegments, routes) {
    return routes
        .filter(function (r) { return emptyPathRedirect(segmentGroup, slicedSegments, r) &&
        getOutlet(r) !== __WEBPACK_IMPORTED_MODULE_10__shared__["a" /* PRIMARY_OUTLET */]; })
        .length > 0;
}
/**
 * @param {?} segmentGroup
 * @param {?} slicedSegments
 * @param {?} routes
 * @return {?}
 */
function containsEmptyPathRedirects(segmentGroup, slicedSegments, routes) {
    return routes.filter(function (r) { return emptyPathRedirect(segmentGroup, slicedSegments, r); }).length > 0;
}
/**
 * @param {?} segmentGroup
 * @param {?} slicedSegments
 * @param {?} r
 * @return {?}
 */
function emptyPathRedirect(segmentGroup, slicedSegments, r) {
    if ((segmentGroup.hasChildren() || slicedSegments.length > 0) && r.pathMatch === 'full')
        return false;
    return r.path === '' && r.redirectTo !== undefined;
}
/**
 * @param {?} route
 * @return {?}
 */
function getOutlet(route) {
    return route.outlet ? route.outlet : __WEBPACK_IMPORTED_MODULE_10__shared__["a" /* PRIMARY_OUTLET */];
}
//# sourceMappingURL=apply_redirects.js.map

/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared__ = __webpack_require__(56);
/* harmony export (immutable) */ exports["a"] = validateConfig;
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * @param {?} config
 * @param {?=} parentPath
 * @return {?}
 */
function validateConfig(config, parentPath) {
    if (parentPath === void 0) { parentPath = ''; }
    // forEach doesn't iterate undefined values
    for (var /** @type {?} */ i = 0; i < config.length; i++) {
        var /** @type {?} */ route = config[i];
        var /** @type {?} */ fullPath = getFullPath(parentPath, route);
        validateNode(route, fullPath);
    }
}
/**
 * @param {?} route
 * @param {?} fullPath
 * @return {?}
 */
function validateNode(route, fullPath) {
    if (!route) {
        throw new Error("\n      Invalid configuration of route '" + fullPath + "': Encountered undefined route.\n      The reason might be an extra comma.\n       \n      Example: \n      const routes: Routes = [\n        { path: '', redirectTo: '/dashboard', pathMatch: 'full' },\n        { path: 'dashboard',  component: DashboardComponent },, << two commas\n        { path: 'detail/:id', component: HeroDetailComponent }\n      ];\n    ");
    }
    if (Array.isArray(route)) {
        throw new Error("Invalid configuration of route '" + fullPath + "': Array cannot be specified");
    }
    if (!route.component && (route.outlet && route.outlet !== __WEBPACK_IMPORTED_MODULE_0__shared__["a" /* PRIMARY_OUTLET */])) {
        throw new Error("Invalid configuration of route '" + fullPath + "': a componentless route cannot have a named outlet set");
    }
    if (route.redirectTo && route.children) {
        throw new Error("Invalid configuration of route '" + fullPath + "': redirectTo and children cannot be used together");
    }
    if (route.redirectTo && route.loadChildren) {
        throw new Error("Invalid configuration of route '" + fullPath + "': redirectTo and loadChildren cannot be used together");
    }
    if (route.children && route.loadChildren) {
        throw new Error("Invalid configuration of route '" + fullPath + "': children and loadChildren cannot be used together");
    }
    if (route.redirectTo && route.component) {
        throw new Error("Invalid configuration of route '" + fullPath + "': redirectTo and component cannot be used together");
    }
    if (route.path && route.matcher) {
        throw new Error("Invalid configuration of route '" + fullPath + "': path and matcher cannot be used together");
    }
    if (route.redirectTo === void 0 && !route.component && !route.children && !route.loadChildren) {
        throw new Error("Invalid configuration of route '" + fullPath + "'. One of the following must be provided: component, redirectTo, children or loadChildren");
    }
    if (route.path === void 0 && route.matcher === void 0) {
        throw new Error("Invalid configuration of route '" + fullPath + "': routes must have either a path or a matcher specified");
    }
    if (typeof route.path === 'string' && route.path.charAt(0) === '/') {
        throw new Error("Invalid configuration of route '" + fullPath + "': path cannot start with a slash");
    }
    if (route.path === '' && route.redirectTo !== void 0 && route.pathMatch === void 0) {
        var /** @type {?} */ exp = "The default value of 'pathMatch' is 'prefix', but often the intent is to use 'full'.";
        throw new Error("Invalid configuration of route '{path: \"" + fullPath + "\", redirectTo: \"" + route.redirectTo + "\"}': please provide 'pathMatch'. " + exp);
    }
    if (route.pathMatch !== void 0 && route.pathMatch !== 'full' && route.pathMatch !== 'prefix') {
        throw new Error("Invalid configuration of route '" + fullPath + "': pathMatch can only be set to 'prefix' or 'full'");
    }
    if (route.children) {
        validateConfig(route.children, fullPath);
    }
}
/**
 * @param {?} parentPath
 * @param {?} currentRoute
 * @return {?}
 */
function getFullPath(parentPath, currentRoute) {
    if (!currentRoute) {
        return parentPath;
    }
    if (!parentPath && !currentRoute.path) {
        return '';
    }
    else if (parentPath && !currentRoute.path) {
        return parentPath + "/";
    }
    else if (!parentPath && currentRoute.path) {
        return currentRoute.path;
    }
    else {
        return parentPath + "/" + currentRoute.path;
    }
}
//# sourceMappingURL=config.js.map

/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_BehaviorSubject__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_BehaviorSubject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_BehaviorSubject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_state__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_tree__ = __webpack_require__(281);
/* harmony export (immutable) */ exports["a"] = createRouterState;
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */



/**
 * @param {?} routeReuseStrategy
 * @param {?} curr
 * @param {?} prevState
 * @return {?}
 */
function createRouterState(routeReuseStrategy, curr, prevState) {
    var /** @type {?} */ root = createNode(routeReuseStrategy, curr._root, prevState ? prevState._root : undefined);
    return new __WEBPACK_IMPORTED_MODULE_1__router_state__["a" /* RouterState */](root, curr);
}
/**
 * @param {?} routeReuseStrategy
 * @param {?} curr
 * @param {?=} prevState
 * @return {?}
 */
function createNode(routeReuseStrategy, curr, prevState) {
    // reuse an activated route that is currently displayed on the screen
    if (prevState && routeReuseStrategy.shouldReuseRoute(curr.value, prevState.value.snapshot)) {
        var /** @type {?} */ value = prevState.value;
        value._futureSnapshot = curr.value;
        var /** @type {?} */ children = createOrReuseChildren(routeReuseStrategy, curr, prevState);
        return new __WEBPACK_IMPORTED_MODULE_2__utils_tree__["b" /* TreeNode */](value, children);
    }
    else if (routeReuseStrategy.retrieve(curr.value)) {
        var /** @type {?} */ tree = ((routeReuseStrategy.retrieve(curr.value))).route;
        setFutureSnapshotsOfActivatedRoutes(curr, tree);
        return tree;
    }
    else {
        var /** @type {?} */ value = createActivatedRoute(curr.value);
        var /** @type {?} */ children = curr.children.map(function (c) { return createNode(routeReuseStrategy, c); });
        return new __WEBPACK_IMPORTED_MODULE_2__utils_tree__["b" /* TreeNode */](value, children);
    }
}
/**
 * @param {?} curr
 * @param {?} result
 * @return {?}
 */
function setFutureSnapshotsOfActivatedRoutes(curr, result) {
    if (curr.value.routeConfig !== result.value.routeConfig) {
        throw new Error('Cannot reattach ActivatedRouteSnapshot created from a different route');
    }
    if (curr.children.length !== result.children.length) {
        throw new Error('Cannot reattach ActivatedRouteSnapshot with a different number of children');
    }
    result.value._futureSnapshot = curr.value;
    for (var /** @type {?} */ i = 0; i < curr.children.length; ++i) {
        setFutureSnapshotsOfActivatedRoutes(curr.children[i], result.children[i]);
    }
}
/**
 * @param {?} routeReuseStrategy
 * @param {?} curr
 * @param {?} prevState
 * @return {?}
 */
function createOrReuseChildren(routeReuseStrategy, curr, prevState) {
    return curr.children.map(function (child) {
        for (var _i = 0, _a = prevState.children; _i < _a.length; _i++) {
            var p = _a[_i];
            if (routeReuseStrategy.shouldReuseRoute(p.value.snapshot, child.value)) {
                return createNode(routeReuseStrategy, child, p);
            }
        }
        return createNode(routeReuseStrategy, child);
    });
}
/**
 * @param {?} c
 * @return {?}
 */
function createActivatedRoute(c) {
    return new __WEBPACK_IMPORTED_MODULE_1__router_state__["b" /* ActivatedRoute */](new __WEBPACK_IMPORTED_MODULE_0_rxjs_BehaviorSubject__["BehaviorSubject"](c.url), new __WEBPACK_IMPORTED_MODULE_0_rxjs_BehaviorSubject__["BehaviorSubject"](c.params), new __WEBPACK_IMPORTED_MODULE_0_rxjs_BehaviorSubject__["BehaviorSubject"](c.queryParams), new __WEBPACK_IMPORTED_MODULE_0_rxjs_BehaviorSubject__["BehaviorSubject"](c.fragment), new __WEBPACK_IMPORTED_MODULE_0_rxjs_BehaviorSubject__["BehaviorSubject"](c.data), c.outlet, c.component, c);
}
//# sourceMappingURL=create_router_state.js.map

/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__url_tree__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_collection__ = __webpack_require__(61);
/* harmony export (immutable) */ exports["a"] = createUrlTree;
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */



/**
 * @param {?} route
 * @param {?} urlTree
 * @param {?} commands
 * @param {?} queryParams
 * @param {?} fragment
 * @return {?}
 */
function createUrlTree(route, urlTree, commands, queryParams, fragment) {
    if (commands.length === 0) {
        return tree(urlTree.root, urlTree.root, urlTree, queryParams, fragment);
    }
    var /** @type {?} */ nav = computeNavigation(commands);
    if (nav.toRoot()) {
        return tree(urlTree.root, new __WEBPACK_IMPORTED_MODULE_1__url_tree__["a" /* UrlSegmentGroup */]([], {}), urlTree, queryParams, fragment);
    }
    var /** @type {?} */ startingPosition = findStartingPosition(nav, urlTree, route);
    var /** @type {?} */ segmentGroup = startingPosition.processChildren ?
        updateSegmentGroupChildren(startingPosition.segmentGroup, startingPosition.index, nav.commands) :
        updateSegmentGroup(startingPosition.segmentGroup, startingPosition.index, nav.commands);
    return tree(startingPosition.segmentGroup, segmentGroup, urlTree, queryParams, fragment);
}
/**
 * @param {?} command
 * @return {?}
 */
function isMatrixParams(command) {
    return typeof command === 'object' && command != null && !command.outlets && !command.segmentPath;
}
/**
 * @param {?} oldSegmentGroup
 * @param {?} newSegmentGroup
 * @param {?} urlTree
 * @param {?} queryParams
 * @param {?} fragment
 * @return {?}
 */
function tree(oldSegmentGroup, newSegmentGroup, urlTree, queryParams, fragment) {
    if (urlTree.root === oldSegmentGroup) {
        return new __WEBPACK_IMPORTED_MODULE_1__url_tree__["b" /* UrlTree */](newSegmentGroup, stringify(queryParams), fragment);
    }
    return new __WEBPACK_IMPORTED_MODULE_1__url_tree__["b" /* UrlTree */](replaceSegment(urlTree.root, oldSegmentGroup, newSegmentGroup), stringify(queryParams), fragment);
}
/**
 * @param {?} current
 * @param {?} oldSegment
 * @param {?} newSegment
 * @return {?}
 */
function replaceSegment(current, oldSegment, newSegment) {
    var /** @type {?} */ children = {};
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_collection__["d" /* forEach */])(current.children, function (c, outletName) {
        if (c === oldSegment) {
            children[outletName] = newSegment;
        }
        else {
            children[outletName] = replaceSegment(c, oldSegment, newSegment);
        }
    });
    return new __WEBPACK_IMPORTED_MODULE_1__url_tree__["a" /* UrlSegmentGroup */](current.segments, children);
}
var Navigation = (function () {
    /**
     * @param {?} isAbsolute
     * @param {?} numberOfDoubleDots
     * @param {?} commands
     */
    function Navigation(isAbsolute, numberOfDoubleDots, commands) {
        this.isAbsolute = isAbsolute;
        this.numberOfDoubleDots = numberOfDoubleDots;
        this.commands = commands;
        if (isAbsolute && commands.length > 0 && isMatrixParams(commands[0])) {
            throw new Error('Root segment cannot have matrix parameters');
        }
        var cmdWithOutlet = commands.find(function (c) { return typeof c === 'object' && c != null && c.outlets; });
        if (cmdWithOutlet && cmdWithOutlet !== __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_collection__["i" /* last */])(commands)) {
            throw new Error('{outlets:{}} has to be the last command');
        }
    }
    /**
     * @return {?}
     */
    Navigation.prototype.toRoot = function () {
        return this.isAbsolute && this.commands.length === 1 && this.commands[0] == '/';
    };
    return Navigation;
}());
function Navigation_tsickle_Closure_declarations() {
    /** @type {?} */
    Navigation.prototype.isAbsolute;
    /** @type {?} */
    Navigation.prototype.numberOfDoubleDots;
    /** @type {?} */
    Navigation.prototype.commands;
}
/**
 * Transforms commands to a normalized `Navigation`
 * @param {?} commands
 * @return {?}
 */
function computeNavigation(commands) {
    if ((typeof commands[0] === 'string') && commands.length === 1 && commands[0] === '/') {
        return new Navigation(true, 0, commands);
    }
    var /** @type {?} */ numberOfDoubleDots = 0;
    var /** @type {?} */ isAbsolute = false;
    var /** @type {?} */ res = commands.reduce(function (res, cmd, cmdIdx) {
        if (typeof cmd === 'object' && cmd != null) {
            if (cmd.outlets) {
                var /** @type {?} */ outlets_1 = {};
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_collection__["d" /* forEach */])(cmd.outlets, function (commands, name) {
                    outlets_1[name] = typeof commands === 'string' ? commands.split('/') : commands;
                });
                return res.concat([{ outlets: outlets_1 }]);
            }
            if (cmd.segmentPath) {
                return res.concat([cmd.segmentPath]);
            }
        }
        if (!(typeof cmd === 'string')) {
            return res.concat([cmd]);
        }
        if (cmdIdx === 0) {
            cmd.split('/').forEach(function (urlPart, partIndex) {
                if (partIndex == 0 && urlPart === '.') {
                }
                else if (partIndex == 0 && urlPart === '') {
                    isAbsolute = true;
                }
                else if (urlPart === '..') {
                    numberOfDoubleDots++;
                }
                else if (urlPart != '') {
                    res.push(urlPart);
                }
            });
            return res;
        }
        return res.concat([cmd]);
    }, []);
    return new Navigation(isAbsolute, numberOfDoubleDots, res);
}
var Position = (function () {
    /**
     * @param {?} segmentGroup
     * @param {?} processChildren
     * @param {?} index
     */
    function Position(segmentGroup, processChildren, index) {
        this.segmentGroup = segmentGroup;
        this.processChildren = processChildren;
        this.index = index;
    }
    return Position;
}());
function Position_tsickle_Closure_declarations() {
    /** @type {?} */
    Position.prototype.segmentGroup;
    /** @type {?} */
    Position.prototype.processChildren;
    /** @type {?} */
    Position.prototype.index;
}
/**
 * @param {?} nav
 * @param {?} tree
 * @param {?} route
 * @return {?}
 */
function findStartingPosition(nav, tree, route) {
    if (nav.isAbsolute) {
        return new Position(tree.root, true, 0);
    }
    if (route.snapshot._lastPathIndex === -1) {
        return new Position(route.snapshot._urlSegment, true, 0);
    }
    var /** @type {?} */ modifier = isMatrixParams(nav.commands[0]) ? 0 : 1;
    var /** @type {?} */ index = route.snapshot._lastPathIndex + modifier;
    return createPositionApplyingDoubleDots(route.snapshot._urlSegment, index, nav.numberOfDoubleDots);
}
/**
 * @param {?} group
 * @param {?} index
 * @param {?} numberOfDoubleDots
 * @return {?}
 */
function createPositionApplyingDoubleDots(group, index, numberOfDoubleDots) {
    var /** @type {?} */ g = group;
    var /** @type {?} */ ci = index;
    var /** @type {?} */ dd = numberOfDoubleDots;
    while (dd > ci) {
        dd -= ci;
        g = g.parent;
        if (!g) {
            throw new Error('Invalid number of \'../\'');
        }
        ci = g.segments.length;
    }
    return new Position(g, false, ci - dd);
}
/**
 * @param {?} command
 * @return {?}
 */
function getPath(command) {
    if (typeof command === 'object' && command != null && command.outlets) {
        return command.outlets[__WEBPACK_IMPORTED_MODULE_0__shared__["a" /* PRIMARY_OUTLET */]];
    }
    return "" + command;
}
/**
 * @param {?} commands
 * @return {?}
 */
function getOutlets(commands) {
    if (!(typeof commands[0] === 'object'))
        return (_a = {}, _a[__WEBPACK_IMPORTED_MODULE_0__shared__["a" /* PRIMARY_OUTLET */]] = commands, _a);
    if (commands[0].outlets === undefined)
        return (_b = {}, _b[__WEBPACK_IMPORTED_MODULE_0__shared__["a" /* PRIMARY_OUTLET */]] = commands, _b);
    return commands[0].outlets;
    var _a, _b;
}
/**
 * @param {?} segmentGroup
 * @param {?} startIndex
 * @param {?} commands
 * @return {?}
 */
function updateSegmentGroup(segmentGroup, startIndex, commands) {
    if (!segmentGroup) {
        segmentGroup = new __WEBPACK_IMPORTED_MODULE_1__url_tree__["a" /* UrlSegmentGroup */]([], {});
    }
    if (segmentGroup.segments.length === 0 && segmentGroup.hasChildren()) {
        return updateSegmentGroupChildren(segmentGroup, startIndex, commands);
    }
    var /** @type {?} */ m = prefixedWith(segmentGroup, startIndex, commands);
    var /** @type {?} */ slicedCommands = commands.slice(m.commandIndex);
    if (m.match && m.pathIndex < segmentGroup.segments.length) {
        var /** @type {?} */ g = new __WEBPACK_IMPORTED_MODULE_1__url_tree__["a" /* UrlSegmentGroup */](segmentGroup.segments.slice(0, m.pathIndex), {});
        g.children[__WEBPACK_IMPORTED_MODULE_0__shared__["a" /* PRIMARY_OUTLET */]] =
            new __WEBPACK_IMPORTED_MODULE_1__url_tree__["a" /* UrlSegmentGroup */](segmentGroup.segments.slice(m.pathIndex), segmentGroup.children);
        return updateSegmentGroupChildren(g, 0, slicedCommands);
    }
    else if (m.match && slicedCommands.length === 0) {
        return new __WEBPACK_IMPORTED_MODULE_1__url_tree__["a" /* UrlSegmentGroup */](segmentGroup.segments, {});
    }
    else if (m.match && !segmentGroup.hasChildren()) {
        return createNewSegmentGroup(segmentGroup, startIndex, commands);
    }
    else if (m.match) {
        return updateSegmentGroupChildren(segmentGroup, 0, slicedCommands);
    }
    else {
        return createNewSegmentGroup(segmentGroup, startIndex, commands);
    }
}
/**
 * @param {?} segmentGroup
 * @param {?} startIndex
 * @param {?} commands
 * @return {?}
 */
function updateSegmentGroupChildren(segmentGroup, startIndex, commands) {
    if (commands.length === 0) {
        return new __WEBPACK_IMPORTED_MODULE_1__url_tree__["a" /* UrlSegmentGroup */](segmentGroup.segments, {});
    }
    else {
        var /** @type {?} */ outlets_2 = getOutlets(commands);
        var /** @type {?} */ children_1 = {};
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_collection__["d" /* forEach */])(outlets_2, function (commands, outlet) {
            if (commands !== null) {
                children_1[outlet] = updateSegmentGroup(segmentGroup.children[outlet], startIndex, commands);
            }
        });
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_collection__["d" /* forEach */])(segmentGroup.children, function (child, childOutlet) {
            if (outlets_2[childOutlet] === undefined) {
                children_1[childOutlet] = child;
            }
        });
        return new __WEBPACK_IMPORTED_MODULE_1__url_tree__["a" /* UrlSegmentGroup */](segmentGroup.segments, children_1);
    }
}
/**
 * @param {?} segmentGroup
 * @param {?} startIndex
 * @param {?} commands
 * @return {?}
 */
function prefixedWith(segmentGroup, startIndex, commands) {
    var /** @type {?} */ currentCommandIndex = 0;
    var /** @type {?} */ currentPathIndex = startIndex;
    var /** @type {?} */ noMatch = { match: false, pathIndex: 0, commandIndex: 0 };
    while (currentPathIndex < segmentGroup.segments.length) {
        if (currentCommandIndex >= commands.length)
            return noMatch;
        var /** @type {?} */ path = segmentGroup.segments[currentPathIndex];
        var /** @type {?} */ curr = getPath(commands[currentCommandIndex]);
        var /** @type {?} */ next = currentCommandIndex < commands.length - 1 ? commands[currentCommandIndex + 1] : null;
        if (currentPathIndex > 0 && curr === undefined)
            break;
        if (curr && next && (typeof next === 'object') && next.outlets === undefined) {
            if (!compare(curr, next, path))
                return noMatch;
            currentCommandIndex += 2;
        }
        else {
            if (!compare(curr, {}, path))
                return noMatch;
            currentCommandIndex++;
        }
        currentPathIndex++;
    }
    return { match: true, pathIndex: currentPathIndex, commandIndex: currentCommandIndex };
}
/**
 * @param {?} segmentGroup
 * @param {?} startIndex
 * @param {?} commands
 * @return {?}
 */
function createNewSegmentGroup(segmentGroup, startIndex, commands) {
    var /** @type {?} */ paths = segmentGroup.segments.slice(0, startIndex);
    var /** @type {?} */ i = 0;
    while (i < commands.length) {
        if (typeof commands[i] === 'object' && commands[i].outlets !== undefined) {
            var /** @type {?} */ children = createNewSegmentChildren(commands[i].outlets);
            return new __WEBPACK_IMPORTED_MODULE_1__url_tree__["a" /* UrlSegmentGroup */](paths, children);
        }
        // if we start with an object literal, we need to reuse the path part from the segment
        if (i === 0 && isMatrixParams(commands[0])) {
            var /** @type {?} */ p = segmentGroup.segments[startIndex];
            paths.push(new __WEBPACK_IMPORTED_MODULE_1__url_tree__["c" /* UrlSegment */](p.path, commands[0]));
            i++;
            continue;
        }
        var /** @type {?} */ curr = getPath(commands[i]);
        var /** @type {?} */ next = (i < commands.length - 1) ? commands[i + 1] : null;
        if (curr && next && isMatrixParams(next)) {
            paths.push(new __WEBPACK_IMPORTED_MODULE_1__url_tree__["c" /* UrlSegment */](curr, stringify(next)));
            i += 2;
        }
        else {
            paths.push(new __WEBPACK_IMPORTED_MODULE_1__url_tree__["c" /* UrlSegment */](curr, {}));
            i++;
        }
    }
    return new __WEBPACK_IMPORTED_MODULE_1__url_tree__["a" /* UrlSegmentGroup */](paths, {});
}
/**
 * @param {?} outlets
 * @return {?}
 */
function createNewSegmentChildren(outlets) {
    var /** @type {?} */ children = {};
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_collection__["d" /* forEach */])(outlets, function (commands, outlet) {
        if (commands !== null) {
            children[outlet] = createNewSegmentGroup(new __WEBPACK_IMPORTED_MODULE_1__url_tree__["a" /* UrlSegmentGroup */]([], {}), 0, commands);
        }
    });
    return children;
}
/**
 * @param {?} params
 * @return {?}
 */
function stringify(params) {
    var /** @type {?} */ res = {};
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_collection__["d" /* forEach */])(params, function (v, k) { return res[k] = "" + v; });
    return res;
}
/**
 * @param {?} path
 * @param {?} params
 * @param {?} segment
 * @return {?}
 */
function compare(path, params, segment) {
    return path == segment.path && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_collection__["c" /* shallowEqual */])(params, segment.parameters);
}
//# sourceMappingURL=create_url_tree.js.map

/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__directives_router_link__ = __webpack_require__(279);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__directives_router_link__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__directives_router_link__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__directives_router_link_active__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_router_link_active__ = __webpack_require__(411);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__directives_router_outlet__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives_router_outlet__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__route_reuse_strategy__ = __webpack_require__(413);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__route_reuse_strategy__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "g", function() { return __WEBPACK_IMPORTED_MODULE_4__router__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "h", function() { return __WEBPACK_IMPORTED_MODULE_4__router__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "i", function() { return __WEBPACK_IMPORTED_MODULE_4__router__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "j", function() { return __WEBPACK_IMPORTED_MODULE_4__router__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(145);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "l", function() { return __WEBPACK_IMPORTED_MODULE_4__router__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "k", function() { return __WEBPACK_IMPORTED_MODULE_4__router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_module__ = __webpack_require__(414);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "m", function() { return __WEBPACK_IMPORTED_MODULE_5__router_module__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "n", function() { return __WEBPACK_IMPORTED_MODULE_5__router_module__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "o", function() { return __WEBPACK_IMPORTED_MODULE_5__router_module__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "p", function() { return __WEBPACK_IMPORTED_MODULE_5__router_module__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router_outlet_map__ = __webpack_require__(198);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "a", function() { return __WEBPACK_IMPORTED_MODULE_6__router_outlet_map__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router_preloader__ = __webpack_require__(415);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "q", function() { return __WEBPACK_IMPORTED_MODULE_7__router_preloader__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "r", function() { return __WEBPACK_IMPORTED_MODULE_7__router_preloader__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "s", function() { return __WEBPACK_IMPORTED_MODULE_7__router_preloader__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "t", function() { return __WEBPACK_IMPORTED_MODULE_7__router_preloader__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router_state__ = __webpack_require__(116);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "v", function() { return __WEBPACK_IMPORTED_MODULE_8__router_state__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "w", function() { return __WEBPACK_IMPORTED_MODULE_8__router_state__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "x", function() { return __WEBPACK_IMPORTED_MODULE_8__router_state__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "u", function() { return __WEBPACK_IMPORTED_MODULE_8__router_state__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared__ = __webpack_require__(56);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "y", function() { return __WEBPACK_IMPORTED_MODULE_9__shared__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__url_handling_strategy__ = __webpack_require__(280);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "z", function() { return __WEBPACK_IMPORTED_MODULE_10__url_handling_strategy__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__url_tree__ = __webpack_require__(98);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "A", function() { return __WEBPACK_IMPORTED_MODULE_11__url_tree__["i"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "B", function() { return __WEBPACK_IMPORTED_MODULE_11__url_tree__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "C", function() { return __WEBPACK_IMPORTED_MODULE_11__url_tree__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "D", function() { return __WEBPACK_IMPORTED_MODULE_11__url_tree__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "E", function() { return __WEBPACK_IMPORTED_MODULE_11__url_tree__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__version__ = __webpack_require__(632);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "F", function() { return __WEBPACK_IMPORTED_MODULE_12__version__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__private_export__ = __webpack_require__(628);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "G", function() { return __WEBPACK_IMPORTED_MODULE_13__private_export__["a"]; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */














//# sourceMappingURL=index.js.map

/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_config_loader__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_module__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_collection__ = __webpack_require__(61);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return __router_private__; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */



var /** @type {?} */ __router_private__ = {
    ROUTER_PROVIDERS: __WEBPACK_IMPORTED_MODULE_1__router_module__["a" /* ROUTER_PROVIDERS */],
    ROUTES: __WEBPACK_IMPORTED_MODULE_0__router_config_loader__["c" /* ROUTES */],
    flatten: __WEBPACK_IMPORTED_MODULE_2__utils_collection__["a" /* flatten */],
};
//# sourceMappingURL=private_export.js.map

/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return isPromise; });
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return isObservable; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

var /** @type {?} */ isPromise = __WEBPACK_IMPORTED_MODULE_0__angular_core__["__core_private__"].isPromise;
var /** @type {?} */ isObservable = __WEBPACK_IMPORTED_MODULE_0__angular_core__["__core_private__"].isObservable;
//# sourceMappingURL=private_import_core.js.map

/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_platform_browser__ = __webpack_require__(49);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return getDOM; });

var /** @type {?} */ getDOM = __WEBPACK_IMPORTED_MODULE_0__angular_platform_browser__["__platform_browser_private__"].getDOM;
//# sourceMappingURL=private_import_platform-browser.js.map

/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_observable_of__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_observable_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_observable_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_state__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__url_tree__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_collection__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_tree__ = __webpack_require__(281);
/* harmony export (immutable) */ exports["a"] = recognize;
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */







var NoMatch = (function () {
    function NoMatch() {
    }
    return NoMatch;
}());
/**
 * @param {?} rootComponentType
 * @param {?} config
 * @param {?} urlTree
 * @param {?} url
 * @return {?}
 */
function recognize(rootComponentType, config, urlTree, url) {
    return new Recognizer(rootComponentType, config, urlTree, url).recognize();
}
var Recognizer = (function () {
    /**
     * @param {?} rootComponentType
     * @param {?} config
     * @param {?} urlTree
     * @param {?} url
     */
    function Recognizer(rootComponentType, config, urlTree, url) {
        this.rootComponentType = rootComponentType;
        this.config = config;
        this.urlTree = urlTree;
        this.url = url;
    }
    /**
     * @return {?}
     */
    Recognizer.prototype.recognize = function () {
        try {
            var /** @type {?} */ rootSegmentGroup = split(this.urlTree.root, [], [], this.config).segmentGroup;
            var /** @type {?} */ children = this.processSegmentGroup(this.config, rootSegmentGroup, __WEBPACK_IMPORTED_MODULE_3__shared__["a" /* PRIMARY_OUTLET */]);
            var /** @type {?} */ root = new __WEBPACK_IMPORTED_MODULE_2__router_state__["c" /* ActivatedRouteSnapshot */]([], Object.freeze({}), Object.freeze(this.urlTree.queryParams), this.urlTree.fragment, {}, __WEBPACK_IMPORTED_MODULE_3__shared__["a" /* PRIMARY_OUTLET */], this.rootComponentType, null, this.urlTree.root, -1, {});
            var /** @type {?} */ rootNode = new __WEBPACK_IMPORTED_MODULE_6__utils_tree__["b" /* TreeNode */](root, children);
            var /** @type {?} */ routeState = new __WEBPACK_IMPORTED_MODULE_2__router_state__["d" /* RouterStateSnapshot */](this.url, rootNode);
            this.inheriteParamsAndData(routeState._root);
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_rxjs_observable_of__["of"])(routeState);
        }
        catch (e) {
            return new __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"](function (obs) { return obs.error(e); });
        }
    };
    /**
     * @param {?} routeNode
     * @return {?}
     */
    Recognizer.prototype.inheriteParamsAndData = function (routeNode) {
        var _this = this;
        var /** @type {?} */ route = routeNode.value;
        var /** @type {?} */ i = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__router_state__["e" /* inheritedParamsDataResolve */])(route);
        route.params = Object.freeze(i.params);
        route.data = Object.freeze(i.data);
        routeNode.children.forEach(function (n) { return _this.inheriteParamsAndData(n); });
    };
    /**
     * @param {?} config
     * @param {?} segmentGroup
     * @param {?} outlet
     * @return {?}
     */
    Recognizer.prototype.processSegmentGroup = function (config, segmentGroup, outlet) {
        if (segmentGroup.segments.length === 0 && segmentGroup.hasChildren()) {
            return this.processChildren(config, segmentGroup);
        }
        else {
            return this.processSegment(config, segmentGroup, segmentGroup.segments, outlet);
        }
    };
    /**
     * @param {?} config
     * @param {?} segmentGroup
     * @return {?}
     */
    Recognizer.prototype.processChildren = function (config, segmentGroup) {
        var _this = this;
        var /** @type {?} */ children = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__url_tree__["e" /* mapChildrenIntoArray */])(segmentGroup, function (child, childOutlet) { return _this.processSegmentGroup(config, child, childOutlet); });
        checkOutletNameUniqueness(children);
        sortActivatedRouteSnapshots(children);
        return children;
    };
    /**
     * @param {?} config
     * @param {?} segmentGroup
     * @param {?} segments
     * @param {?} outlet
     * @return {?}
     */
    Recognizer.prototype.processSegment = function (config, segmentGroup, segments, outlet) {
        for (var _i = 0, config_1 = config; _i < config_1.length; _i++) {
            var r = config_1[_i];
            try {
                return this.processSegmentAgainstRoute(r, segmentGroup, segments, outlet);
            }
            catch (e) {
                if (!(e instanceof NoMatch))
                    throw e;
            }
        }
        if (this.noLeftoversInUrl(segmentGroup, segments, outlet)) {
            return [];
        }
        else {
            throw new NoMatch();
        }
    };
    /**
     * @param {?} segmentGroup
     * @param {?} segments
     * @param {?} outlet
     * @return {?}
     */
    Recognizer.prototype.noLeftoversInUrl = function (segmentGroup, segments, outlet) {
        return segments.length === 0 && !segmentGroup.children[outlet];
    };
    /**
     * @param {?} route
     * @param {?} rawSegment
     * @param {?} segments
     * @param {?} outlet
     * @return {?}
     */
    Recognizer.prototype.processSegmentAgainstRoute = function (route, rawSegment, segments, outlet) {
        if (route.redirectTo)
            throw new NoMatch();
        if ((route.outlet ? route.outlet : __WEBPACK_IMPORTED_MODULE_3__shared__["a" /* PRIMARY_OUTLET */]) !== outlet)
            throw new NoMatch();
        if (route.path === '**') {
            var /** @type {?} */ params = segments.length > 0 ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_collection__["i" /* last */])(segments).parameters : {};
            var /** @type {?} */ snapshot_1 = new __WEBPACK_IMPORTED_MODULE_2__router_state__["c" /* ActivatedRouteSnapshot */](segments, params, Object.freeze(this.urlTree.queryParams), this.urlTree.fragment, getData(route), outlet, route.component, route, getSourceSegmentGroup(rawSegment), getPathIndexShift(rawSegment) + segments.length, getResolve(route));
            return [new __WEBPACK_IMPORTED_MODULE_6__utils_tree__["b" /* TreeNode */](snapshot_1, [])];
        }
        var _a = match(rawSegment, route, segments), consumedSegments = _a.consumedSegments, parameters = _a.parameters, lastChild = _a.lastChild;
        var /** @type {?} */ rawSlicedSegments = segments.slice(lastChild);
        var /** @type {?} */ childConfig = getChildConfig(route);
        var _b = split(rawSegment, consumedSegments, rawSlicedSegments, childConfig), segmentGroup = _b.segmentGroup, slicedSegments = _b.slicedSegments;
        var /** @type {?} */ snapshot = new __WEBPACK_IMPORTED_MODULE_2__router_state__["c" /* ActivatedRouteSnapshot */](consumedSegments, parameters, Object.freeze(this.urlTree.queryParams), this.urlTree.fragment, getData(route), outlet, route.component, route, getSourceSegmentGroup(rawSegment), getPathIndexShift(rawSegment) + consumedSegments.length, getResolve(route));
        if (slicedSegments.length === 0 && segmentGroup.hasChildren()) {
            var /** @type {?} */ children = this.processChildren(childConfig, segmentGroup);
            return [new __WEBPACK_IMPORTED_MODULE_6__utils_tree__["b" /* TreeNode */](snapshot, children)];
        }
        else if (childConfig.length === 0 && slicedSegments.length === 0) {
            return [new __WEBPACK_IMPORTED_MODULE_6__utils_tree__["b" /* TreeNode */](snapshot, [])];
        }
        else {
            var /** @type {?} */ children = this.processSegment(childConfig, segmentGroup, slicedSegments, __WEBPACK_IMPORTED_MODULE_3__shared__["a" /* PRIMARY_OUTLET */]);
            return [new __WEBPACK_IMPORTED_MODULE_6__utils_tree__["b" /* TreeNode */](snapshot, children)];
        }
    };
    return Recognizer;
}());
function Recognizer_tsickle_Closure_declarations() {
    /** @type {?} */
    Recognizer.prototype.rootComponentType;
    /** @type {?} */
    Recognizer.prototype.config;
    /** @type {?} */
    Recognizer.prototype.urlTree;
    /** @type {?} */
    Recognizer.prototype.url;
}
/**
 * @param {?} nodes
 * @return {?}
 */
function sortActivatedRouteSnapshots(nodes) {
    nodes.sort(function (a, b) {
        if (a.value.outlet === __WEBPACK_IMPORTED_MODULE_3__shared__["a" /* PRIMARY_OUTLET */])
            return -1;
        if (b.value.outlet === __WEBPACK_IMPORTED_MODULE_3__shared__["a" /* PRIMARY_OUTLET */])
            return 1;
        return a.value.outlet.localeCompare(b.value.outlet);
    });
}
/**
 * @param {?} route
 * @return {?}
 */
function getChildConfig(route) {
    if (route.children) {
        return route.children;
    }
    else if (route.loadChildren) {
        return ((route))._loadedConfig.routes;
    }
    else {
        return [];
    }
}
/**
 * @param {?} segmentGroup
 * @param {?} route
 * @param {?} segments
 * @return {?}
 */
function match(segmentGroup, route, segments) {
    if (route.path === '') {
        if (route.pathMatch === 'full' && (segmentGroup.hasChildren() || segments.length > 0)) {
            throw new NoMatch();
        }
        else {
            return { consumedSegments: [], lastChild: 0, parameters: {} };
        }
    }
    var /** @type {?} */ matcher = route.matcher || __WEBPACK_IMPORTED_MODULE_3__shared__["c" /* defaultUrlMatcher */];
    var /** @type {?} */ res = matcher(segments, segmentGroup, route);
    if (!res)
        throw new NoMatch();
    var /** @type {?} */ posParams = {};
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_collection__["d" /* forEach */])(res.posParams, function (v, k) { posParams[k] = v.path; });
    var /** @type {?} */ parameters = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_collection__["g" /* merge */])(posParams, res.consumed[res.consumed.length - 1].parameters);
    return { consumedSegments: res.consumed, lastChild: res.consumed.length, parameters: parameters };
}
/**
 * @param {?} nodes
 * @return {?}
 */
function checkOutletNameUniqueness(nodes) {
    var /** @type {?} */ names = {};
    nodes.forEach(function (n) {
        var /** @type {?} */ routeWithSameOutletName = names[n.value.outlet];
        if (routeWithSameOutletName) {
            var /** @type {?} */ p = routeWithSameOutletName.url.map(function (s) { return s.toString(); }).join('/');
            var /** @type {?} */ c = n.value.url.map(function (s) { return s.toString(); }).join('/');
            throw new Error("Two segments cannot have the same outlet name: '" + p + "' and '" + c + "'.");
        }
        names[n.value.outlet] = n.value;
    });
}
/**
 * @param {?} segmentGroup
 * @return {?}
 */
function getSourceSegmentGroup(segmentGroup) {
    var /** @type {?} */ s = segmentGroup;
    while (s._sourceSegment) {
        s = s._sourceSegment;
    }
    return s;
}
/**
 * @param {?} segmentGroup
 * @return {?}
 */
function getPathIndexShift(segmentGroup) {
    var /** @type {?} */ s = segmentGroup;
    var /** @type {?} */ res = (s._segmentIndexShift ? s._segmentIndexShift : 0);
    while (s._sourceSegment) {
        s = s._sourceSegment;
        res += (s._segmentIndexShift ? s._segmentIndexShift : 0);
    }
    return res - 1;
}
/**
 * @param {?} segmentGroup
 * @param {?} consumedSegments
 * @param {?} slicedSegments
 * @param {?} config
 * @return {?}
 */
function split(segmentGroup, consumedSegments, slicedSegments, config) {
    if (slicedSegments.length > 0 &&
        containsEmptyPathMatchesWithNamedOutlets(segmentGroup, slicedSegments, config)) {
        var /** @type {?} */ s = new __WEBPACK_IMPORTED_MODULE_4__url_tree__["a" /* UrlSegmentGroup */](consumedSegments, createChildrenForEmptyPaths(segmentGroup, consumedSegments, config, new __WEBPACK_IMPORTED_MODULE_4__url_tree__["a" /* UrlSegmentGroup */](slicedSegments, segmentGroup.children)));
        s._sourceSegment = segmentGroup;
        s._segmentIndexShift = consumedSegments.length;
        return { segmentGroup: s, slicedSegments: [] };
    }
    else if (slicedSegments.length === 0 &&
        containsEmptyPathMatches(segmentGroup, slicedSegments, config)) {
        var /** @type {?} */ s = new __WEBPACK_IMPORTED_MODULE_4__url_tree__["a" /* UrlSegmentGroup */](segmentGroup.segments, addEmptyPathsToChildrenIfNeeded(segmentGroup, slicedSegments, config, segmentGroup.children));
        s._sourceSegment = segmentGroup;
        s._segmentIndexShift = consumedSegments.length;
        return { segmentGroup: s, slicedSegments: slicedSegments };
    }
    else {
        var /** @type {?} */ s = new __WEBPACK_IMPORTED_MODULE_4__url_tree__["a" /* UrlSegmentGroup */](segmentGroup.segments, segmentGroup.children);
        s._sourceSegment = segmentGroup;
        s._segmentIndexShift = consumedSegments.length;
        return { segmentGroup: s, slicedSegments: slicedSegments };
    }
}
/**
 * @param {?} segmentGroup
 * @param {?} slicedSegments
 * @param {?} routes
 * @param {?} children
 * @return {?}
 */
function addEmptyPathsToChildrenIfNeeded(segmentGroup, slicedSegments, routes, children) {
    var /** @type {?} */ res = {};
    for (var _i = 0, routes_1 = routes; _i < routes_1.length; _i++) {
        var r = routes_1[_i];
        if (emptyPathMatch(segmentGroup, slicedSegments, r) && !children[getOutlet(r)]) {
            var /** @type {?} */ s = new __WEBPACK_IMPORTED_MODULE_4__url_tree__["a" /* UrlSegmentGroup */]([], {});
            s._sourceSegment = segmentGroup;
            s._segmentIndexShift = segmentGroup.segments.length;
            res[getOutlet(r)] = s;
        }
    }
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_collection__["g" /* merge */])(children, res);
}
/**
 * @param {?} segmentGroup
 * @param {?} consumedSegments
 * @param {?} routes
 * @param {?} primarySegment
 * @return {?}
 */
function createChildrenForEmptyPaths(segmentGroup, consumedSegments, routes, primarySegment) {
    var /** @type {?} */ res = {};
    res[__WEBPACK_IMPORTED_MODULE_3__shared__["a" /* PRIMARY_OUTLET */]] = primarySegment;
    primarySegment._sourceSegment = segmentGroup;
    primarySegment._segmentIndexShift = consumedSegments.length;
    for (var _i = 0, routes_2 = routes; _i < routes_2.length; _i++) {
        var r = routes_2[_i];
        if (r.path === '' && getOutlet(r) !== __WEBPACK_IMPORTED_MODULE_3__shared__["a" /* PRIMARY_OUTLET */]) {
            var /** @type {?} */ s = new __WEBPACK_IMPORTED_MODULE_4__url_tree__["a" /* UrlSegmentGroup */]([], {});
            s._sourceSegment = segmentGroup;
            s._segmentIndexShift = consumedSegments.length;
            res[getOutlet(r)] = s;
        }
    }
    return res;
}
/**
 * @param {?} segmentGroup
 * @param {?} slicedSegments
 * @param {?} routes
 * @return {?}
 */
function containsEmptyPathMatchesWithNamedOutlets(segmentGroup, slicedSegments, routes) {
    return routes
        .filter(function (r) { return emptyPathMatch(segmentGroup, slicedSegments, r) &&
        getOutlet(r) !== __WEBPACK_IMPORTED_MODULE_3__shared__["a" /* PRIMARY_OUTLET */]; })
        .length > 0;
}
/**
 * @param {?} segmentGroup
 * @param {?} slicedSegments
 * @param {?} routes
 * @return {?}
 */
function containsEmptyPathMatches(segmentGroup, slicedSegments, routes) {
    return routes.filter(function (r) { return emptyPathMatch(segmentGroup, slicedSegments, r); }).length > 0;
}
/**
 * @param {?} segmentGroup
 * @param {?} slicedSegments
 * @param {?} r
 * @return {?}
 */
function emptyPathMatch(segmentGroup, slicedSegments, r) {
    if ((segmentGroup.hasChildren() || slicedSegments.length > 0) && r.pathMatch === 'full')
        return false;
    return r.path === '' && r.redirectTo === undefined;
}
/**
 * @param {?} route
 * @return {?}
 */
function getOutlet(route) {
    return route.outlet ? route.outlet : __WEBPACK_IMPORTED_MODULE_3__shared__["a" /* PRIMARY_OUTLET */];
}
/**
 * @param {?} route
 * @return {?}
 */
function getData(route) {
    return route.data ? route.data : {};
}
/**
 * @param {?} route
 * @return {?}
 */
function getResolve(route) {
    return route.resolve ? route.resolve : {};
}
//# sourceMappingURL=recognize.js.map

/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return VERSION; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * @stable
 */
var /** @type {?} */ VERSION = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["Version"]('3.4.10');
//# sourceMappingURL=version.js.map

/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* unused harmony export compose */
var compose = function () {
    var functions = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        functions[_i - 0] = arguments[_i];
    }
    return function (arg) {
        if (functions.length === 0) {
            return arg;
        }
        var last = functions[functions.length - 1];
        var rest = functions.slice(0, -1);
        return rest.reduceRight(function (composed, fn) { return fn(composed); }, last(arg));
    };
};
//# sourceMappingURL=compose.js.map

/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Subscriber__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Subscriber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Subscriber__);
/* unused harmony export enterZone */
/* unused harmony export EnterZoneOperator */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

function enterZone(zone) {
    return this.lift(new EnterZoneOperator(zone));
}
var EnterZoneOperator = (function () {
    function EnterZoneOperator(_zone) {
        this._zone = _zone;
    }
    EnterZoneOperator.prototype.call = function (subscriber, source) {
        return source._subscribe(new EnterZoneSubscriber(subscriber, this._zone));
    };
    return EnterZoneOperator;
}());
var EnterZoneSubscriber = (function (_super) {
    __extends(EnterZoneSubscriber, _super);
    function EnterZoneSubscriber(destination, _zone) {
        _super.call(this, destination);
        this._zone = _zone;
    }
    EnterZoneSubscriber.prototype._next = function (value) {
        var _this = this;
        this._zone.run(function () { return _this.destination.next(value); });
    };
    return EnterZoneSubscriber;
}(__WEBPACK_IMPORTED_MODULE_0_rxjs_Subscriber__["Subscriber"]));
//# sourceMappingURL=enterZone.js.map

/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Subscriber__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Subscriber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Subscriber__);
/* unused harmony export leaveZone */
/* unused harmony export LeaveZoneOperator */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

function leaveZone(zone) {
    return this.lift(new LeaveZoneOperator(zone));
}
var LeaveZoneOperator = (function () {
    function LeaveZoneOperator(_zone) {
        this._zone = _zone;
    }
    LeaveZoneOperator.prototype.call = function (subscriber, source) {
        return source._subscribe(new LeaveZoneSubscriber(subscriber, this._zone));
    };
    return LeaveZoneOperator;
}());
var LeaveZoneSubscriber = (function (_super) {
    __extends(LeaveZoneSubscriber, _super);
    function LeaveZoneSubscriber(destination, _zone) {
        _super.call(this, destination);
        this._zone = _zone;
    }
    LeaveZoneSubscriber.prototype._next = function (value) {
        var _this = this;
        this._zone.runOutsideAngular(function () { return _this.destination.next(value); });
    };
    return LeaveZoneSubscriber;
}(__WEBPACK_IMPORTED_MODULE_0_rxjs_Subscriber__["Subscriber"]));
//# sourceMappingURL=leaveZone.js.map

/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_operator_pluck__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_operator_pluck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_operator_pluck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_operator_map__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_operator_distinctUntilChanged__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_operator_distinctUntilChanged___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_operator_distinctUntilChanged__);
/* harmony export (immutable) */ exports["a"] = select;



function select(pathOrMapFn) {
    var paths = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        paths[_i - 1] = arguments[_i];
    }
    var mapped$;
    if (typeof pathOrMapFn === 'string') {
        mapped$ = __WEBPACK_IMPORTED_MODULE_0_rxjs_operator_pluck__["pluck"].call.apply(__WEBPACK_IMPORTED_MODULE_0_rxjs_operator_pluck__["pluck"], [this, pathOrMapFn].concat(paths));
    }
    else if (typeof pathOrMapFn === 'function') {
        mapped$ = __WEBPACK_IMPORTED_MODULE_1_rxjs_operator_map__["map"].call(this, pathOrMapFn);
    }
    else {
        throw new TypeError(("Unexpected type " + typeof pathOrMapFn + " in select operator,")
            + " expected 'string' or 'function'");
    }
    return __WEBPACK_IMPORTED_MODULE_2_rxjs_operator_distinctUntilChanged__["distinctUntilChanged"].call(mapped$);
}
//# sourceMappingURL=select.js.map

/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_actions__ = __webpack_require__(282);
Object.defineProperty(exports, "__esModule", { value: true });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "routerActions", function() { return __WEBPACK_IMPORTED_MODULE_0__src_actions__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "routerActionTypes", function() { return __WEBPACK_IMPORTED_MODULE_0__src_actions__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "go", function() { return __WEBPACK_IMPORTED_MODULE_0__src_actions__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "replace", function() { return __WEBPACK_IMPORTED_MODULE_0__src_actions__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "search", function() { return __WEBPACK_IMPORTED_MODULE_0__src_actions__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "show", function() { return __WEBPACK_IMPORTED_MODULE_0__src_actions__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "back", function() { return __WEBPACK_IMPORTED_MODULE_0__src_actions__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "forward", function() { return __WEBPACK_IMPORTED_MODULE_0__src_actions__["h"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_reducer__ = __webpack_require__(639);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "initialState", function() { return __WEBPACK_IMPORTED_MODULE_1__src_reducer__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "routerReducer", function() { return __WEBPACK_IMPORTED_MODULE_1__src_reducer__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_router_store_module__ = __webpack_require__(640);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "setupRouterStore", function() { return __WEBPACK_IMPORTED_MODULE_2__src_router_store_module__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "provideRouterConnector", function() { return __WEBPACK_IMPORTED_MODULE_2__src_router_store_module__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "RouterStoreModule", function() { return __WEBPACK_IMPORTED_MODULE_2__src_router_store_module__["c"]; });



//# sourceMappingURL=index.js.map

/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_router__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_operator_filter__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_operator_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_operator_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_operator_map__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_withLatestFrom__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_withLatestFrom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_operator_withLatestFrom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ngrx_core__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(282);
/* harmony export (immutable) */ exports["a"] = listenForRouterMethodActions;
/* unused harmony export selectRouter */
/* unused harmony export getLatestUrl */
/* harmony export (immutable) */ exports["b"] = connectRouterActions;
/* harmony export (immutable) */ exports["c"] = listenForStoreChanges;






function listenForRouterMethodActions(router, location, actions$) {
    __WEBPACK_IMPORTED_MODULE_1_rxjs_operator_filter__["filter"].call(actions$, function (action) { return __WEBPACK_IMPORTED_MODULE_5__actions__["b" /* routerActionTypes */].indexOf(action.type) > -1; })
        .subscribe(function (action) {
        var _a = action.payload, path = _a.path, queryParams = _a.query, _b = _a.extras, extras = _b === void 0 ? {} : _b;
        var commands = Array.isArray(path) ? path : [path];
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_5__actions__["a" /* routerActions */].GO:
                router.navigate(commands, Object.assign({}, extras, { queryParams: queryParams }));
                break;
            case __WEBPACK_IMPORTED_MODULE_5__actions__["a" /* routerActions */].REPLACE:
                router.navigate(commands, Object.assign({}, extras, { queryParams: queryParams, replaceUrl: true }));
                break;
            case __WEBPACK_IMPORTED_MODULE_5__actions__["a" /* routerActions */].SEARCH:
                var urlTree = router.parseUrl(router.url);
                urlTree.queryParams = queryParams;
                router.navigateByUrl(urlTree, extras);
                break;
            case __WEBPACK_IMPORTED_MODULE_5__actions__["a" /* routerActions */].SHOW:
                router.navigate(commands, Object.assign({}, extras, { queryParams: queryParams, skipLocationChange: true }));
                break;
            case __WEBPACK_IMPORTED_MODULE_5__actions__["a" /* routerActions */].BACK:
                location.back();
                break;
            case __WEBPACK_IMPORTED_MODULE_5__actions__["a" /* routerActions */].FORWARD:
                location.forward();
                break;
        }
    });
}
function selectRouter(store) {
    return __WEBPACK_IMPORTED_MODULE_4__ngrx_core__["a" /* select */].call(store, function (state) { return state.router; });
}
function getLatestUrl(router) {
    var navigationEnd$ = __WEBPACK_IMPORTED_MODULE_1_rxjs_operator_filter__["filter"].call(router.events, function (event) { return event instanceof __WEBPACK_IMPORTED_MODULE_0__angular_router__["NavigationEnd"]; });
    var navigationEndUrl$ = __WEBPACK_IMPORTED_MODULE_4__ngrx_core__["a" /* select */].call(navigationEnd$, function () { return router.url; });
    return navigationEndUrl$;
}
function connectRouterActions(router, store) {
    var routerAndStore$ = __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_withLatestFrom__["withLatestFrom"].call(getLatestUrl(router), selectRouter(store));
    var mismatchUrl$ = __WEBPACK_IMPORTED_MODULE_1_rxjs_operator_filter__["filter"].call(routerAndStore$, function (_a) {
        var url = _a[0], rs = _a[1];
        return (rs && rs.path !== url || !rs);
    });
    var updateLocation$ = __WEBPACK_IMPORTED_MODULE_2_rxjs_operator_map__["map"].call(mismatchUrl$, function (_a) {
        var path = _a[0];
        return { type: __WEBPACK_IMPORTED_MODULE_5__actions__["a" /* routerActions */].UPDATE_LOCATION, payload: { path: path } };
    });
    updateLocation$.subscribe(store);
}
function listenForStoreChanges(router, store) {
    var storeAndRouter$ = __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_withLatestFrom__["withLatestFrom"].call(selectRouter(store), getLatestUrl(router));
    var mismatch$ = __WEBPACK_IMPORTED_MODULE_1_rxjs_operator_filter__["filter"].call(storeAndRouter$, function (_a) {
        var rs = _a[0], url = _a[1];
        return rs.path !== url;
    });
    var newPath$ = __WEBPACK_IMPORTED_MODULE_2_rxjs_operator_map__["map"].call(mismatch$, function (_a) {
        var rs = _a[0];
        return rs.path;
    });
    newPath$.subscribe(function (url) { return router.navigateByUrl(url); });
}
//# sourceMappingURL=connect.js.map

/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(282);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return initialState; });
/* harmony export (immutable) */ exports["b"] = routerReducer;

var initialState = {
    path: ''
};
function routerReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* routerActions */].UPDATE_LOCATION:
            return action.payload;
        default:
            return state;
    }
}
//# sourceMappingURL=reducer.js.map

/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_common__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ngrx_store__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__connect__ = __webpack_require__(638);
/* harmony export (immutable) */ exports["a"] = setupRouterStore;
/* harmony export (immutable) */ exports["b"] = provideRouterConnector;
/* harmony export (binding) */ __webpack_require__.d(exports, "c", function() { return RouterStoreModule; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





function setupRouterStore(router, location, dispatcher, store) {
    return function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__connect__["a" /* listenForRouterMethodActions */])(router, location, dispatcher);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__connect__["b" /* connectRouterActions */])(router, store);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__connect__["c" /* listenForStoreChanges */])(router, store);
    };
}
function provideRouterConnector() {
    return {
        provide: __WEBPACK_IMPORTED_MODULE_0__angular_core__["APP_BOOTSTRAP_LISTENER"],
        deps: [__WEBPACK_IMPORTED_MODULE_2__angular_router__["Router"], __WEBPACK_IMPORTED_MODULE_1__angular_common__["Location"], __WEBPACK_IMPORTED_MODULE_3__ngrx_store__["Dispatcher"], __WEBPACK_IMPORTED_MODULE_3__ngrx_store__["Store"]],
        useFactory: setupRouterStore,
        multi: true
    };
}
var RouterStoreModule = RouterStoreModule_1 = (function () {
    function RouterStoreModule() {
    }
    RouterStoreModule.connectRouter = function () {
        return {
            ngModule: RouterStoreModule_1,
            providers: [
                provideRouterConnector()
            ]
        };
    };
    return RouterStoreModule;
}());
RouterStoreModule = RouterStoreModule_1 = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"])({})
], RouterStoreModule);

var RouterStoreModule_1;
//# sourceMappingURL=router-store-module.js.map

/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_instrument__ = __webpack_require__(642);
Object.defineProperty(exports, "__esModule", { value: true });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "StoreDevtoolsModule", function() { return __WEBPACK_IMPORTED_MODULE_0__src_instrument__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_devtools__ = __webpack_require__(418);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "StoreDevtools", function() { return __WEBPACK_IMPORTED_MODULE_1__src_devtools__["a"]; });


//# sourceMappingURL=index.js.map

/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ngrx_store__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__devtools__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__extension__ = __webpack_require__(419);
/* unused harmony export _createReduxDevtoolsExtension */
/* unused harmony export _createState */
/* unused harmony export _createReducer */
/* unused harmony export _createStateIfExtension */
/* unused harmony export _createReducerIfExtension */
/* unused harmony export noMonitor */
/* unused harmony export _createOptions */
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return StoreDevtoolsModule; });





function _createReduxDevtoolsExtension() {
    var legacyExtensionKey = 'devToolsExtension';
    var extensionKey = '__REDUX_DEVTOOLS_EXTENSION__';
    if (typeof window === 'object' && typeof window[legacyExtensionKey] !== 'undefined') {
        return window[legacyExtensionKey];
    }
    else if (typeof window === 'object' && typeof window[extensionKey] !== 'undefined') {
        return window[extensionKey];
    }
    else {
        return null;
    }
}
function _createState(devtools) {
    return devtools.state;
}
function _createReducer(dispatcher, reducer) {
    return new __WEBPACK_IMPORTED_MODULE_1__ngrx_store__["Reducer"](dispatcher, reducer);
}
function _createStateIfExtension(extension, injector, initialState) {
    if (!!extension) {
        var devtools = injector.get(__WEBPACK_IMPORTED_MODULE_2__devtools__["a" /* StoreDevtools */]);
        return _createState(devtools);
    }
    else {
        var dispatcher = injector.get(__WEBPACK_IMPORTED_MODULE_1__ngrx_store__["Dispatcher"]);
        var reducer = injector.get(__WEBPACK_IMPORTED_MODULE_1__ngrx_store__["Reducer"]);
        return new __WEBPACK_IMPORTED_MODULE_1__ngrx_store__["State"](initialState, dispatcher, reducer);
    }
}
function _createReducerIfExtension(extension, injector, reducer) {
    if (!!extension) {
        var devtoolsDispatcher = injector.get(__WEBPACK_IMPORTED_MODULE_2__devtools__["b" /* DevtoolsDispatcher */]);
        return _createReducer(devtoolsDispatcher, reducer);
    }
    else {
        var dispatcher = injector.get(__WEBPACK_IMPORTED_MODULE_1__ngrx_store__["Dispatcher"]);
        return new __WEBPACK_IMPORTED_MODULE_1__ngrx_store__["Reducer"](dispatcher, reducer);
    }
}
function noMonitor() {
    return null;
}
function _createOptions(_options) {
    var DEFAULT_OPTIONS = { monitor: noMonitor };
    var options = typeof _options === 'function' ? _options() : _options;
    options = Object.assign({}, DEFAULT_OPTIONS, options);
    if (options.maxAge && options.maxAge < 2) {
        throw new Error("Devtools 'maxAge' cannot be less than 2, got " + options.maxAge);
    }
    return options;
}
var StoreDevtoolsModule = (function () {
    function StoreDevtoolsModule() {
    }
    StoreDevtoolsModule.instrumentStore = function (_options) {
        if (_options === void 0) { _options = {}; }
        return {
            ngModule: StoreDevtoolsModule,
            providers: [
                {
                    provide: __WEBPACK_IMPORTED_MODULE_1__ngrx_store__["State"],
                    deps: [__WEBPACK_IMPORTED_MODULE_2__devtools__["a" /* StoreDevtools */]],
                    useFactory: _createState
                },
                {
                    provide: __WEBPACK_IMPORTED_MODULE_3__config__["b" /* INITIAL_OPTIONS */],
                    useValue: _options
                },
                {
                    provide: __WEBPACK_IMPORTED_MODULE_1__ngrx_store__["Reducer"],
                    deps: [__WEBPACK_IMPORTED_MODULE_2__devtools__["b" /* DevtoolsDispatcher */], __WEBPACK_IMPORTED_MODULE_1__ngrx_store__["INITIAL_REDUCER"]],
                    useFactory: _createReducer
                },
                {
                    provide: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* STORE_DEVTOOLS_CONFIG */],
                    deps: [__WEBPACK_IMPORTED_MODULE_3__config__["b" /* INITIAL_OPTIONS */]],
                    useFactory: _createOptions
                }
            ]
        };
    };
    StoreDevtoolsModule.instrumentOnlyWithExtension = function (_options) {
        if (_options === void 0) { _options = {}; }
        return {
            ngModule: StoreDevtoolsModule,
            providers: [
                {
                    provide: __WEBPACK_IMPORTED_MODULE_1__ngrx_store__["State"],
                    deps: [__WEBPACK_IMPORTED_MODULE_4__extension__["b" /* REDUX_DEVTOOLS_EXTENSION */], __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injector"], __WEBPACK_IMPORTED_MODULE_1__ngrx_store__["INITIAL_STATE"]],
                    useFactory: _createStateIfExtension
                },
                {
                    provide: __WEBPACK_IMPORTED_MODULE_1__ngrx_store__["Reducer"],
                    deps: [__WEBPACK_IMPORTED_MODULE_4__extension__["b" /* REDUX_DEVTOOLS_EXTENSION */], __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injector"], __WEBPACK_IMPORTED_MODULE_1__ngrx_store__["INITIAL_REDUCER"]],
                    useFactory: _createReducerIfExtension
                },
                {
                    provide: __WEBPACK_IMPORTED_MODULE_3__config__["b" /* INITIAL_OPTIONS */],
                    useValue: _options
                },
                {
                    provide: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* STORE_DEVTOOLS_CONFIG */],
                    deps: [__WEBPACK_IMPORTED_MODULE_3__config__["b" /* INITIAL_OPTIONS */]],
                    useFactory: _createOptions
                }
            ]
        };
    };
    return StoreDevtoolsModule;
}());

StoreDevtoolsModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                imports: [
                    __WEBPACK_IMPORTED_MODULE_1__ngrx_store__["StoreModule"]
                ],
                providers: [
                    __WEBPACK_IMPORTED_MODULE_4__extension__["a" /* DevtoolsExtension */],
                    __WEBPACK_IMPORTED_MODULE_2__devtools__["b" /* DevtoolsDispatcher */],
                    __WEBPACK_IMPORTED_MODULE_2__devtools__["a" /* StoreDevtools */],
                    {
                        provide: __WEBPACK_IMPORTED_MODULE_4__extension__["b" /* REDUX_DEVTOOLS_EXTENSION */],
                        useFactory: _createReduxDevtoolsExtension
                    }
                ]
            },] },
];
/** @nocollapse */
StoreDevtoolsModule.ctorParameters = function () { return []; };
//# sourceMappingURL=instrument.js.map

/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ngrx_store__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(283);
/* unused harmony export INIT_ACTION */
/* harmony export (immutable) */ exports["a"] = liftInitialState;
/* harmony export (immutable) */ exports["b"] = liftReducerWith;



var INIT_ACTION = { type: __WEBPACK_IMPORTED_MODULE_0__ngrx_store__["Dispatcher"].INIT };
/**
* Computes the next entry in the log by applying an action.
*/
function computeNextEntry(reducer, action, state, error) {
    if (error) {
        return {
            state: state,
            error: 'Interrupted by an error up the chain'
        };
    }
    var nextState = state;
    var nextError;
    try {
        nextState = reducer(state, action);
    }
    catch (err) {
        nextError = err.toString();
        console.error(err.stack || err);
    }
    return {
        state: nextState,
        error: nextError
    };
}
/**
* Runs the reducer on invalidated actions to get a fresh computation log.
*/
function recomputeStates(computedStates, minInvalidatedStateIndex, reducer, committedState, actionsById, stagedActionIds, skippedActionIds) {
    // Optimization: exit early and return the same reference
    // if we know nothing could have changed.
    if (minInvalidatedStateIndex >= computedStates.length &&
        computedStates.length === stagedActionIds.length) {
        return computedStates;
    }
    var nextComputedStates = computedStates.slice(0, minInvalidatedStateIndex);
    for (var i = minInvalidatedStateIndex; i < stagedActionIds.length; i++) {
        var actionId = stagedActionIds[i];
        var action = actionsById[actionId].action;
        var previousEntry = nextComputedStates[i - 1];
        var previousState = previousEntry ? previousEntry.state : committedState;
        var previousError = previousEntry ? previousEntry.error : undefined;
        var shouldSkip = skippedActionIds.indexOf(actionId) > -1;
        var entry = shouldSkip ?
            previousEntry :
            computeNextEntry(reducer, action, previousState, previousError);
        nextComputedStates.push(entry);
    }
    return nextComputedStates;
}
function liftInitialState(initialCommittedState, monitorReducer) {
    return {
        monitorState: monitorReducer(undefined, {}),
        nextActionId: 1,
        actionsById: { 0: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["b" /* liftAction */])(INIT_ACTION) },
        stagedActionIds: [0],
        skippedActionIds: [],
        committedState: initialCommittedState,
        currentStateIndex: 0,
        computedStates: []
    };
}
/**
* Creates a history state reducer from an app's reducer.
*/
function liftReducerWith(initialCommittedState, initialLiftedState, monitorReducer, options) {
    if (options === void 0) { options = {}; }
    /**
    * Manages how the history actions modify the history state.
    */
    return function (reducer) { return function (liftedState, liftedAction) {
        var _a = liftedState || initialLiftedState, monitorState = _a.monitorState, actionsById = _a.actionsById, nextActionId = _a.nextActionId, stagedActionIds = _a.stagedActionIds, skippedActionIds = _a.skippedActionIds, committedState = _a.committedState, currentStateIndex = _a.currentStateIndex, computedStates = _a.computedStates;
        if (!liftedState) {
            // Prevent mutating initialLiftedState
            actionsById = Object.create(actionsById);
        }
        function commitExcessActions(n) {
            // Auto-commits n-number of excess actions.
            var excess = n;
            var idsToDelete = stagedActionIds.slice(1, excess + 1);
            for (var i = 0; i < idsToDelete.length; i++) {
                if (computedStates[i + 1].error) {
                    // Stop if error is found. Commit actions up to error.
                    excess = i;
                    idsToDelete = stagedActionIds.slice(1, excess + 1);
                    break;
                }
                else {
                    delete actionsById[idsToDelete[i]];
                }
            }
            skippedActionIds = skippedActionIds.filter(function (id) { return idsToDelete.indexOf(id) === -1; });
            stagedActionIds = [0].concat(stagedActionIds.slice(excess + 1));
            committedState = computedStates[excess].state;
            computedStates = computedStates.slice(excess);
            currentStateIndex = currentStateIndex > excess
                ? currentStateIndex - excess
                : 0;
        }
        // By default, agressively recompute every state whatever happens.
        // This has O(n) performance, so we'll override this to a sensible
        // value whenever we feel like we don't have to recompute the states.
        var minInvalidatedStateIndex = 0;
        switch (liftedAction.type) {
            case __WEBPACK_IMPORTED_MODULE_2__actions__["b" /* ActionTypes */].RESET: {
                // Get back to the state the store was created with.
                actionsById = { 0: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["b" /* liftAction */])(INIT_ACTION) };
                nextActionId = 1;
                stagedActionIds = [0];
                skippedActionIds = [];
                committedState = initialCommittedState;
                currentStateIndex = 0;
                computedStates = [];
                break;
            }
            case __WEBPACK_IMPORTED_MODULE_2__actions__["b" /* ActionTypes */].COMMIT: {
                // Consider the last committed state the new starting point.
                // Squash any staged actions into a single committed state.
                actionsById = { 0: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["b" /* liftAction */])(INIT_ACTION) };
                nextActionId = 1;
                stagedActionIds = [0];
                skippedActionIds = [];
                committedState = computedStates[currentStateIndex].state;
                currentStateIndex = 0;
                computedStates = [];
                break;
            }
            case __WEBPACK_IMPORTED_MODULE_2__actions__["b" /* ActionTypes */].ROLLBACK: {
                // Forget about any staged actions.
                // Start again from the last committed state.
                actionsById = { 0: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["b" /* liftAction */])(INIT_ACTION) };
                nextActionId = 1;
                stagedActionIds = [0];
                skippedActionIds = [];
                currentStateIndex = 0;
                computedStates = [];
                break;
            }
            case __WEBPACK_IMPORTED_MODULE_2__actions__["b" /* ActionTypes */].TOGGLE_ACTION: {
                // Toggle whether an action with given ID is skipped.
                // Being skipped means it is a no-op during the computation.
                var actionId_1 = liftedAction.id;
                var index = skippedActionIds.indexOf(actionId_1);
                if (index === -1) {
                    skippedActionIds = [actionId_1].concat(skippedActionIds);
                }
                else {
                    skippedActionIds = skippedActionIds.filter(function (id) { return id !== actionId_1; });
                }
                // Optimization: we know history before this action hasn't changed
                minInvalidatedStateIndex = stagedActionIds.indexOf(actionId_1);
                break;
            }
            case __WEBPACK_IMPORTED_MODULE_2__actions__["b" /* ActionTypes */].SET_ACTIONS_ACTIVE: {
                // Toggle whether an action with given ID is skipped.
                // Being skipped means it is a no-op during the computation.
                var start = liftedAction.start, end = liftedAction.end, active = liftedAction.active;
                var actionIds = [];
                for (var i = start; i < end; i++)
                    actionIds.push(i);
                if (active) {
                    skippedActionIds = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["c" /* difference */])(skippedActionIds, actionIds);
                }
                else {
                    skippedActionIds = skippedActionIds.concat(actionIds);
                }
                // Optimization: we know history before this action hasn't changed
                minInvalidatedStateIndex = stagedActionIds.indexOf(start);
                break;
            }
            case __WEBPACK_IMPORTED_MODULE_2__actions__["b" /* ActionTypes */].JUMP_TO_STATE: {
                // Without recomputing anything, move the pointer that tell us
                // which state is considered the current one. Useful for sliders.
                currentStateIndex = liftedAction.index;
                // Optimization: we know the history has not changed.
                minInvalidatedStateIndex = Infinity;
                break;
            }
            case __WEBPACK_IMPORTED_MODULE_2__actions__["b" /* ActionTypes */].SWEEP: {
                // Forget any actions that are currently being skipped.
                stagedActionIds = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["c" /* difference */])(stagedActionIds, skippedActionIds);
                skippedActionIds = [];
                currentStateIndex = Math.min(currentStateIndex, stagedActionIds.length - 1);
                break;
            }
            case __WEBPACK_IMPORTED_MODULE_2__actions__["b" /* ActionTypes */].PERFORM_ACTION: {
                // Auto-commit as new actions come in.
                if (options.maxAge && stagedActionIds.length === options.maxAge) {
                    commitExcessActions(1);
                }
                if (currentStateIndex === stagedActionIds.length - 1) {
                    currentStateIndex++;
                }
                var actionId = nextActionId++;
                // Mutation! This is the hottest path, and we optimize on purpose.
                // It is safe because we set a new key in a cache dictionary.
                actionsById[actionId] = liftedAction;
                stagedActionIds = stagedActionIds.concat([actionId]);
                // Optimization: we know that only the new action needs computing.
                minInvalidatedStateIndex = stagedActionIds.length - 1;
                break;
            }
            case __WEBPACK_IMPORTED_MODULE_2__actions__["b" /* ActionTypes */].IMPORT_STATE: {
                // Completely replace everything.
                (_b = liftedAction.nextLiftedState, monitorState = _b.monitorState, actionsById = _b.actionsById, nextActionId = _b.nextActionId, stagedActionIds = _b.stagedActionIds, skippedActionIds = _b.skippedActionIds, committedState = _b.committedState, currentStateIndex = _b.currentStateIndex, computedStates = _b.computedStates);
                break;
            }
            case __WEBPACK_IMPORTED_MODULE_0__ngrx_store__["Reducer"].REPLACE:
            case __WEBPACK_IMPORTED_MODULE_0__ngrx_store__["Dispatcher"].INIT: {
                // Always recompute states on hot reload and init.
                minInvalidatedStateIndex = 0;
                if (options.maxAge && stagedActionIds.length > options.maxAge) {
                    // States must be recomputed before committing excess.
                    computedStates = recomputeStates(computedStates, minInvalidatedStateIndex, reducer, committedState, actionsById, stagedActionIds, skippedActionIds);
                    commitExcessActions(stagedActionIds.length - options.maxAge);
                    // Avoid double computation.
                    minInvalidatedStateIndex = Infinity;
                }
                break;
            }
            default: {
                // If the action is not recognized, it's a monitor action.
                // Optimization: a monitor action can't change history.
                minInvalidatedStateIndex = Infinity;
                break;
            }
        }
        computedStates = recomputeStates(computedStates, minInvalidatedStateIndex, reducer, committedState, actionsById, stagedActionIds, skippedActionIds);
        monitorState = monitorReducer(monitorState, liftedAction);
        return {
            monitorState: monitorState,
            actionsById: actionsById,
            nextActionId: nextActionId,
            stagedActionIds: stagedActionIds,
            skippedActionIds: skippedActionIds,
            committedState: committedState,
            currentStateIndex: currentStateIndex,
            computedStates: computedStates
        };
        var _b;
    }; };
}
//# sourceMappingURL=reducer.js.map

/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dispatcher__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(424);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return INITIAL_REDUCER; });
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return INITIAL_STATE; });
/* harmony export (binding) */ __webpack_require__.d(exports, "c", function() { return _INITIAL_REDUCER; });
/* harmony export (binding) */ __webpack_require__.d(exports, "d", function() { return _INITIAL_STATE; });
/* harmony export (immutable) */ exports["e"] = _initialReducerFactory;
/* harmony export (immutable) */ exports["f"] = _initialStateFactory;
/* harmony export (immutable) */ exports["g"] = _storeFactory;
/* harmony export (immutable) */ exports["h"] = _stateFactory;
/* harmony export (immutable) */ exports["i"] = _reducerFactory;
/* harmony export (immutable) */ exports["j"] = provideStore;
/* harmony export (binding) */ __webpack_require__.d(exports, "k", function() { return StoreModule; });






var INITIAL_REDUCER = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["OpaqueToken"]('Token ngrx/store/reducer');
var INITIAL_STATE = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["OpaqueToken"]('Token ngrx/store/initial-state');
var _INITIAL_REDUCER = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["OpaqueToken"]('Token _ngrx/store/reducer');
var _INITIAL_STATE = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["OpaqueToken"]('Token _ngrx/store/initial-state');
function _initialReducerFactory(reducer) {
    if (typeof reducer === 'function') {
        return reducer;
    }
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* combineReducers */])(reducer);
}
function _initialStateFactory(initialState, reducer) {
    if (!initialState) {
        return reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_2__dispatcher__["a" /* Dispatcher */].INIT });
    }
    return initialState;
}
function _storeFactory(dispatcher, reducer, state$) {
    return new __WEBPACK_IMPORTED_MODULE_3__store__["a" /* Store */](dispatcher, reducer, state$);
}
function _stateFactory(initialState, dispatcher, reducer) {
    return new __WEBPACK_IMPORTED_MODULE_4__state__["a" /* State */](initialState, dispatcher, reducer);
}
function _reducerFactory(dispatcher, reducer) {
    return new __WEBPACK_IMPORTED_MODULE_1__reducer__["a" /* Reducer */](dispatcher, reducer);
}
;
/**
 * @deprecated, use StoreModule.provideStore instead!
 */
function provideStore(_reducer, _initialState) {
    return [
        __WEBPACK_IMPORTED_MODULE_2__dispatcher__["a" /* Dispatcher */],
        { provide: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* Store */], useFactory: _storeFactory, deps: [__WEBPACK_IMPORTED_MODULE_2__dispatcher__["a" /* Dispatcher */], __WEBPACK_IMPORTED_MODULE_1__reducer__["a" /* Reducer */], __WEBPACK_IMPORTED_MODULE_4__state__["a" /* State */]] },
        { provide: __WEBPACK_IMPORTED_MODULE_1__reducer__["a" /* Reducer */], useFactory: _reducerFactory, deps: [__WEBPACK_IMPORTED_MODULE_2__dispatcher__["a" /* Dispatcher */], INITIAL_REDUCER] },
        { provide: __WEBPACK_IMPORTED_MODULE_4__state__["a" /* State */], useFactory: _stateFactory, deps: [INITIAL_STATE, __WEBPACK_IMPORTED_MODULE_2__dispatcher__["a" /* Dispatcher */], __WEBPACK_IMPORTED_MODULE_1__reducer__["a" /* Reducer */]] },
        { provide: INITIAL_REDUCER, useFactory: _initialReducerFactory, deps: [_INITIAL_REDUCER] },
        { provide: INITIAL_STATE, useFactory: _initialStateFactory, deps: [_INITIAL_STATE, INITIAL_REDUCER] },
        { provide: _INITIAL_STATE, useValue: _initialState },
        { provide: _INITIAL_REDUCER, useValue: _reducer }
    ];
}
var StoreModule = (function () {
    function StoreModule() {
    }
    StoreModule.provideStore = function (_reducer, _initialState) {
        return {
            ngModule: StoreModule,
            providers: provideStore(_reducer, _initialState)
        };
    };
    StoreModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{},] },
    ];
    /** @nocollapse */
    StoreModule.ctorParameters = [];
    return StoreModule;
}());
//# sourceMappingURL=ng2.js.map

/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var app_service_1 = __webpack_require__(23);
var app_catalog_service_1 = __webpack_require__(62);
var mock_product_categories_api_1 = __webpack_require__(431);
var mock_products_api_1 = __webpack_require__(432);
var navigation_service_1 = __webpack_require__(81);
var logs_service_1 = __webpack_require__(285);
var debug, debugOff = function () {
    var any = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        any[_i] = arguments[_i];
    }
};
"production" !== 'production' && (debug = __webpack_require__(4)('app:AppCmp'));
var AppCmp = (function () {
    function AppCmp(_appService, _productCategoriesMockApi, _appCatalogService, _productsMockApi, _navigationService, _logsService) {
        this._appService = _appService;
        this._productCategoriesMockApi = _productCategoriesMockApi;
        this._appCatalogService = _appCatalogService;
        this._productsMockApi = _productsMockApi;
        this._navigationService = _navigationService;
        this._logsService = _logsService;
    }
    AppCmp.prototype.ngOnInit = function () {
        this._appService.init();
    };
    return AppCmp;
}());
AppCmp = __decorate([
    core_1.Component({
        selector: 'app-cmp',
        template: __webpack_require__(842),
        styles: [String(__webpack_require__(1131))],
        host: { 'class': 'app' }
    }),
    __metadata("design:paramtypes", [app_service_1.AppService,
        mock_product_categories_api_1.ProductCategoriesMockApi,
        app_catalog_service_1.AppCatalogService,
        mock_products_api_1.ProductsMockApi,
        navigation_service_1.NavigationService,
        logs_service_1.LogsService])
], AppCmp);
exports.AppCmp = AppCmp;


/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var platform_browser_1 = __webpack_require__(49);
var forms_1 = __webpack_require__(260);
var shared_module_1 = __webpack_require__(438);
var app_catalog_service_1 = __webpack_require__(62);
var catalog_service_1 = __webpack_require__(28);
var product_categories_service_1 = __webpack_require__(433);
var products_service_1 = __webpack_require__(435);
var products_packages_service_1 = __webpack_require__(434);
var dynamic_properties_service_1 = __webpack_require__(430);
var cart_service_1 = __webpack_require__(35);
var scene_service_1 = __webpack_require__(199);
var generators_service_1 = __webpack_require__(99);
var testing_1 = __webpack_require__(268);
var http_1 = __webpack_require__(43);
var mock_product_categories_api_1 = __webpack_require__(431);
var mock_products_api_1 = __webpack_require__(432);
var summary_cmp_1 = __webpack_require__(426);
var catalog_cmp_1 = __webpack_require__(425);
var product_categories_cmp_1 = __webpack_require__(651);
var product_category_cmp_1 = __webpack_require__(652);
var products_list_cmp_1 = __webpack_require__(655);
var product_options_dropdown_cmp_1 = __webpack_require__(654);
var product_details_cmp_1 = __webpack_require__(653);
var generator_configurator_cmp_1 = __webpack_require__(647);
var summary_cmp_2 = __webpack_require__(659);
var print_summary_cmp_1 = __webpack_require__(649);
var email_summary_cmp_1 = __webpack_require__(648);
var scene_tooltip_cmp_1 = __webpack_require__(657);
var scene_cmp_1 = __webpack_require__(658);
var http_2 = __webpack_require__(43);
var ng2_bs3_modal_1 = __webpack_require__(471);
var ng2_page_scroll_1 = __webpack_require__(309);
var debug, debugOff = function () {
    var any = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        any[_i] = arguments[_i];
    }
};
"production" !== 'production' && (debug = __webpack_require__(4)('app:CatalogModule'));
var CatalogModule = (function () {
    function CatalogModule() {
    }
    return CatalogModule;
}());
CatalogModule = __decorate([
    core_1.NgModule({
        imports: [
            platform_browser_1.BrowserModule,
            forms_1.FormsModule,
            shared_module_1.SharedModule,
            http_2.HttpModule,
            ng2_bs3_modal_1.Ng2Bs3ModalModule,
            ng2_page_scroll_1.Ng2PageScrollModule.forRoot()
        ],
        providers: [
            app_catalog_service_1.AppCatalogService,
            catalog_service_1.CatalogService,
            product_categories_service_1.ProductCategoriesService,
            products_service_1.ProductsService,
            products_packages_service_1.ProductsPackagesService,
            dynamic_properties_service_1.DynamicPropertiesService,
            cart_service_1.CartService,
            scene_service_1.SceneService,
            generators_service_1.GeneratorsService,
            http_1.BaseRequestOptions,
            testing_1.MockBackend,
            {
                provide: http_1.Http,
                deps: [testing_1.MockBackend, http_1.BaseRequestOptions],
                useFactory: function (backend, options) { return new http_1.Http(backend, options); }
            },
            mock_product_categories_api_1.ProductCategoriesMockApi,
            mock_products_api_1.ProductsMockApi
        ],
        declarations: [
            summary_cmp_1.SummaryPageCmp,
            catalog_cmp_1.CatalogPageCmp,
            product_categories_cmp_1.ProductCategoriesCmp,
            product_category_cmp_1.ProductCategoryCmp,
            products_list_cmp_1.ProductsListCmp,
            product_options_dropdown_cmp_1.ProductOptionsDropdownCmp,
            product_details_cmp_1.ProductDetailsCmp,
            generator_configurator_cmp_1.GeneratorConfiguratorCmp,
            summary_cmp_2.SummaryCmp,
            print_summary_cmp_1.PrintSummaryCmp,
            email_summary_cmp_1.EmailSummaryCmp,
            scene_tooltip_cmp_1.SceneTooltipCmp,
            scene_cmp_1.SceneCmp
        ],
        exports: [
            summary_cmp_1.SummaryPageCmp,
            catalog_cmp_1.CatalogPageCmp,
            product_categories_cmp_1.ProductCategoriesCmp,
            product_details_cmp_1.ProductDetailsCmp,
            print_summary_cmp_1.PrintSummaryCmp,
            email_summary_cmp_1.EmailSummaryCmp,
            scene_cmp_1.SceneCmp
        ]
    }),
    __metadata("design:paramtypes", [])
], CatalogModule);
exports.CatalogModule = CatalogModule;


/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var catalog_service_1 = __webpack_require__(28);
var app_catalog_service_1 = __webpack_require__(62);
var generators_service_1 = __webpack_require__(99);
var app_service_1 = __webpack_require__(23);
var debug, debugOff = function () {
    var any = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        any[_i] = arguments[_i];
    }
};
"production" !== 'production' && (debug = __webpack_require__(4)('app:GeneratorConfiguratorCmp'));
var GeneratorConfiguratorCmp = (function () {
    function GeneratorConfiguratorCmp(_catalogService, _appCatalogService, _generatorsService, _appService, _elementRef) {
        this._catalogService = _catalogService;
        this._appCatalogService = _appCatalogService;
        this._generatorsService = _generatorsService;
        this._appService = _appService;
        this._elementRef = _elementRef;
        this._imgPaths = null;
        this._generators = null;
        this._mutationObserver = null;
        this._materialsDropdownIsRendered = false;
        this._materialsDropdownIsVisible = false;
        this._currentTab = 1;
        this._dic = {
            stone: 'Natural Stone',
            ceramic: 'Ceramic, Porcelain, Glass Tile',
            acrylic: 'Acrylic, Fiberglass, Composite'
        };
        this._dom = {
            catalog: null,
            generators: null,
            generatorsTitleLabel: null,
            generatorLengthIn: null,
            generatorWidthIn: null,
            generatorHeightIn: null
        };
        this._imgPaths = this._catalogService.imgPaths;
        this._dom.generators = _elementRef.nativeElement;
        this._generatorCfg = this._generatorsService.state.generatorCfg;
        this._roomDimensions = this._generatorsService.state.roomDimensions;
    }
    GeneratorConfiguratorCmp.prototype.onResize = function (event) {
        this._resetTitleLabelHeight();
    };
    GeneratorConfiguratorCmp.prototype.ngOnInit = function () {
        var self = this;
        this._dom.catalog = document.getElementById('catalog-host');
        this._dom.generatorsTitleLabel = document.getElementById('generators-title-label');
        this._dom.generatorLengthIn = document.getElementById('generator-length-in');
        this._dom.generatorWidthIn = document.getElementById('generator-width-in');
        this._dom.generatorHeightIn = document.getElementById('generator-height-in');
        this._mutationObserver = new MutationObserver(function (mutation) { return self._resetTitleLabelHeight(); });
        this._mutationObserver.observe(this._dom.catalog, { childList: true, subtree: true });
        this._generators = this._catalogService.getProductsByCategoryId('generators');
        this._appService.roomDimensions = this._roomDimensions;
        this._appService.generatorCfg = this._generatorCfg;
    };
    GeneratorConfiguratorCmp.prototype.ngOnDestroy = function () {
        this._mutationObserver.disconnect();
    };
    GeneratorConfiguratorCmp.prototype._openDropdown = function () {
        var self = this;
        this._materialsDropdownIsRendered = true;
        setTimeout(function () { return self._materialsDropdownIsVisible = true; }, 0);
    };
    GeneratorConfiguratorCmp.prototype._closeDropdown = function () {
        var self = this;
        this._materialsDropdownIsVisible = false;
        setTimeout(function () { return self._materialsDropdownIsRendered = false; }, 200);
    };
    GeneratorConfiguratorCmp.prototype._selectOption = function (type) {
        this._roomDimensions.wallType = type;
        this._closeDropdown();
        this._updateConfiguratorVars();
    };
    GeneratorConfiguratorCmp.prototype._updateConfiguratorVars = function () {
        this._validateFields();
        this._calculateRoomVolume();
        this._roomDimensions.lengthIn > 11 && (this._roomDimensions.lengthIn = 11);
        this._roomDimensions.widthIn > 11 && (this._roomDimensions.widthIn = 11);
        this._roomDimensions.heightIn > 11 && (this._roomDimensions.heightIn = 11);
        this._dom.generatorLengthIn.value = this._roomDimensions.lengthIn;
        this._dom.generatorWidthIn.value = this._roomDimensions.widthIn;
        this._dom.generatorHeightIn.value = this._roomDimensions.heightIn;
        if (this._generatorCfg.lengthFtIsValid === true &&
            this._generatorCfg.widthFtIsValid === true &&
            this._generatorCfg.heightFtIsValid === true &&
            this._roomDimensions.wallType === null) {
            this._openDropdown();
        }
    };
    ;
    GeneratorConfiguratorCmp.prototype._validateFields = function () {
        debugOff('Validate fields');
        var length = parseInt(this._roomDimensions.lengthFt), width = parseInt(this._roomDimensions.widthFt), height = parseInt(this._roomDimensions.heightFt), material = parseInt(this._roomDimensions.wallType);
        this._generatorCfg.lengthFtIsValid =
            this._generatorCfg.widthFtIsValid =
                this._generatorCfg.heightFtIsValid =
                    this._generatorCfg.materialIsValid = false;
        if (typeof length === 'number' && length > 0) {
            this._generatorCfg.lengthFtIsValid = true;
        }
        if (typeof width === 'number' && width > 0) {
            this._generatorCfg.widthFtIsValid = true;
        }
        if (typeof height === 'number' && height > 0) {
            this._generatorCfg.heightFtIsValid = true;
        }
        if (material !== null) {
            this._generatorCfg.materialIsValid = true;
        }
    };
    GeneratorConfiguratorCmp.prototype._calculateRoomVolume = function () {
        var size = [71, 107, 161, 257, 339, 411, 482, 678, 822, 964, 0], model = [
            'MS90EC1', 'MS150EC1', 'MS225EC1', 'MS400EC1',
            'MSSUPER1EC1', 'MSSUPER2EC1', 'MSSUPER3EC1',
            'MX4EC1', 'MX5EC1', 'MX6EC1',
            '0'
        ], walltype = this._roomDimensions.wallType, decLengthFt = parseFloat(this._roomDimensions.lengthFt), decWidthFt = parseFloat(this._roomDimensions.widthFt), decHeightFt = parseFloat(this._roomDimensions.heightFt), decLengthIn = this._roomDimensions.lengthIn / 12, decWidthIn = this._roomDimensions.widthIn / 12, decHeightIn = this._roomDimensions.heightIn / 12, lenght = decLengthFt + decLengthIn, width = decWidthFt + decWidthIn, height = decHeightFt + decHeightIn, cubicFeet = null, cubicFeetAdjusted, addPercent = 0;
        if (isNaN(decLengthFt) || decLengthFt === 0 ||
            isNaN(decWidthFt) || decWidthFt === 0 ||
            isNaN(decHeightFt) || decHeightFt === 0) {
            cubicFeet = 0;
        }
        else {
            cubicFeet = lenght * width * height;
        }
        walltype === 'stone' && (addPercent += 50);
        walltype === 'ceramic' && (addPercent += 0);
        walltype === 'acrylic' && (addPercent -= 40);
        var materialAdjusted = cubicFeet + cubicFeet * addPercent / 100;
        height > 8 && height <= 9 && (addPercent = 15);
        height > 9 && height <= 10 && (addPercent = 30);
        height <= 8 && (addPercent = 0);
        cubicFeetAdjusted = materialAdjusted + materialAdjusted * addPercent / 100;
        this._roomDimensions.cubicFeet = cubicFeet;
        this._roomDimensions.cubicFeetAdjusted = cubicFeetAdjusted;
        if (cubicFeetAdjusted > 0 && walltype !== null) {
            var sizeIndex = 0, sizeIndexCalculated = false;
            for (var i = 0; i < size.length; i++) {
                if (cubicFeetAdjusted <= size[i] && height <= 10) {
                    sizeIndex = i;
                    sizeIndexCalculated = true;
                    break;
                }
            }
            if (sizeIndexCalculated === true) {
                var generatorId = model[sizeIndex];
                debugOff('Recommended generator id:', generatorId);
                var generator = this._catalogService.getProductById(generatorId);
                debugOff('Recommended generator:', generator);
                if (generator !== undefined) {
                    this._generatorCfg.selectedGenerator !== null && this._deselectGenerator();
                    this._selectGenerator(generator);
                    this._generatorCfg.showerDimensionsExceeded = false;
                }
                else {
                    console.error('Could not find product with requested "' + generatorId + '" generator id');
                }
            }
            else {
                this._generatorCfg.selectedGenerator !== null && this._deselectGenerator();
                this._generatorCfg.showerDimensionsExceeded = true;
            }
        }
        else {
            this._generatorCfg.selectedGenerator !== null && this._deselectGenerator();
        }
    };
    GeneratorConfiguratorCmp.prototype._selectGenerator = function (generator) {
        debugOff('Selected Generator:', generator);
        this._generatorCfg.selectedGenerator = generator;
        this._generatorCfg.selectedGenerator.addToCart('generators');
        this._generatorCfg.selectedGenerator.displayTooltip();
    };
    GeneratorConfiguratorCmp.prototype._deselectGenerator = function () {
        var genReference = this._generatorCfg.selectedGenerator;
        this._generatorCfg.selectedGenerator = null;
        genReference.removeFromCart();
    };
    GeneratorConfiguratorCmp.prototype._skipGeneratorSelection = function () {
        if (this._generatorCfg.selectedGenerator !== null) {
            this._deselectGenerator();
        }
        this._generatorsService.resetCalculatorInputs();
        this._appCatalogService.selectCategory({ category: 'steam-shower-controls' });
    };
    GeneratorConfiguratorCmp.prototype._resetTitleLabelHeight = function () {
        debugOff('Reset title label height');
        var height;
        this._dom.generatorsTitleLabel.style.removeProperty('height');
        height = this._dom.generatorsTitleLabel.clientHeight;
        this._dom.generatorsTitleLabel.style.height = height + 'px';
    };
    GeneratorConfiguratorCmp.prototype._roundRoomVolume = function (volume) {
        debugOff('Round room volume');
        return Math.ceil(volume);
    };
    return GeneratorConfiguratorCmp;
}());
__decorate([
    core_1.HostListener('window:resize', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], GeneratorConfiguratorCmp.prototype, "onResize", null);
GeneratorConfiguratorCmp = __decorate([
    core_1.Component({
        selector: 'generator-configurator-cmp',
        template: __webpack_require__(845),
        styles: [String(__webpack_require__(1134))],
        host: { class: 'generator-configurator' }
    }),
    __metadata("design:paramtypes", [catalog_service_1.CatalogService,
        app_catalog_service_1.AppCatalogService,
        generators_service_1.GeneratorsService,
        app_service_1.AppService,
        core_1.ElementRef])
], GeneratorConfiguratorCmp);
exports.GeneratorConfiguratorCmp = GeneratorConfiguratorCmp;


/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(43);
var app_service_1 = __webpack_require__(23);
var catalog_service_1 = __webpack_require__(28);
var navigation_service_1 = __webpack_require__(81);
var cart_service_1 = __webpack_require__(35);
var generators_service_1 = __webpack_require__(99);
var debug, debugOff = function () {
    var any = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        any[_i] = arguments[_i];
    }
};
"production" !== 'production' && (debug = __webpack_require__(4)('app:EmailSummaryCmp'));
var EmailSummaryCmp = (function () {
    function EmailSummaryCmp(_cartService, _elementRef, _http, _appService, _generatorsService, _catalogService, _navigationService) {
        this._cartService = _cartService;
        this._elementRef = _elementRef;
        this._http = _http;
        this._appService = _appService;
        this._generatorsService = _generatorsService;
        this._catalogService = _catalogService;
        this._navigationService = _navigationService;
        this.emailForm = {
            txtName: null,
            txtEmail: null,
            txtAddresses: null,
            txtNotes: null,
            selHsPersona: null
        };
        this.emailModalElement = null;
        this.dom = {};
        this.show = true;
        this._summaryElement = null;
        this._globals = null;
        this._dic = {
            stone: 'Natural Stone',
            ceramic: 'Ceramic, Porcelain, Glass Tile',
            acrylic: 'Acrylic, Fiberglass, Composite'
        };
        var self = this;
        this.emailModalElement = _elementRef.nativeElement;
        this._generatorCfg = this._generatorsService.state.generatorCfg;
        this._roomDimensions = this._generatorsService.state.roomDimensions;
        this._imgPaths = this._catalogService.imgPaths;
        this._summaryElement = _elementRef.nativeElement;
        this._globals = this._catalogService.getGlobals();
    }
    EmailSummaryCmp.prototype.ngOnInit = function () {
        var _this = this;
        this._cartService.productEvent.subscribe(function () {
            console.log(_this._cartService.cartProducts, 111);
            _this.pruducts = _this._cartService.cartProducts;
        });
        this.dom.txtName = document.getElementById('txtName');
        this.dom.txtEmail = document.getElementById('txtEmail');
        this.dom.txtAddresses = document.getElementById('txtAddresses');
        this.dom.txtNotes = document.getElementById('txtNotes');
        this.dom.lblEmailMessage = document.getElementById('lblEmailMessage');
        this.dom.lblSentMessage = document.getElementById('lblSentMessage');
        this.dom.divSelection = document.getElementById('products-selection');
        this.dom.selHsPersona = document.getElementById('selHsPersona');
        this.dom.divSelectionEmail = document.getElementById('content-email');
        document.getElementById('content-email').style.display = "none";
    };
    EmailSummaryCmp.prototype.ngOnDestroy = function () {
    };
    EmailSummaryCmp.prototype.clearTextarea = function () {
        var txtAddresses = this.dom.txtAddresses.value;
        if (txtAddresses === 'Enter up to 10 emails separated by commas...') {
            this.dom.txtAddresses.value = '';
            return;
        }
    };
    EmailSummaryCmp.prototype.setTextarea = function () {
        var textareaMessage = 'Enter up to 10 emails separated by commas...';
        var txtAddresses = this.dom.txtAddresses.value;
        if (txtAddresses === '') {
            this.dom.txtAddresses.value = textareaMessage;
            return;
        }
        else {
            var n = txtAddresses.indexOf(';');
            if (n != -1) {
                this.dom.txtAddresses.style.backgroundColor = '#FFE6E6';
            }
            else {
                this.dom.txtAddresses.style.backgroundColor = '#FFFFFF';
            }
        }
    };
    EmailSummaryCmp.prototype.emailSelectionToAddresses = function () {
        var self = this, txtName = this.dom.txtName.value;
        if (txtName === '') {
            this.dom.txtName.style.backgroundColor = '#FFE6E6';
        }
        else {
            this.dom.txtName.style.backgroundColor = '#FFFFFF';
        }
        var txtEmail = this.dom.txtEmail.value;
        if (txtEmail === '') {
            this.dom.txtEmail.style.backgroundColor = '#FFE6E6';
        }
        else {
            this.dom.txtEmail.style.backgroundColor = '#FFFFFF';
        }
        var txtAddresses = this.dom.txtAddresses.value;
        if (txtAddresses === '') {
            this.dom.txtAddresses.style.backgroundColor = '#FFE6E6';
        }
        else {
            this.dom.txtAddresses.style.backgroundColor = '#FFFFFF';
        }
        if (txtName === '' || txtEmail === '') {
            this.dom.lblSentMessage.innerHTML = '';
            return;
        }
        var cust = {
            Name: txtName,
            Email: txtEmail
        };
        var strRecipients;
        strRecipients = this.dom.txtAddresses.value;
        var arrRecipients = strRecipients.split(',');
        var recipients = [];
        for (var e in arrRecipients) {
            var email = arrRecipients[e];
            if (email !== null && email !== "" && email.trim() !== "") {
                var recipient = { 'Email': email.trim() };
                recipients.push(recipient);
            }
        }
        if (recipients.length === 0) {
            this.dom.txtAddresses.style.backgroundColor = '#FFE6E6';
        }
        else {
            this.dom.txtAddresses.style.backgroundColor = '#FFFFFF';
        }
        var notes = this.dom.txtNotes.value, content = this.dom.divSelection.innerHTML;
        content = this.dom.divSelectionEmail.innerHTML;
        content = content.replace("media/", "http://virtualspa.mrsteam.com/media/");
        var persona_value = this.dom.selHsPersona.value;
        var persona = '';
        if (persona_value != 'persona_0') {
            persona = this.dom.selHsPersona.options[this.dom.selHsPersona.selectedIndex].text;
        }
        var data = {
            Customer: cust,
            Recipients: recipients,
            EmailContent: notes + '<br /><br />' + content,
            Persona: persona
        };
        var body = JSON.stringify(data);
        var baseURL = 'https://mailsmtp.mrsteam.com';
        this._appService.hideEmailSummaryModal();
        this._appService.displayAlertModal();
        $.ajax({
            type: "POST",
            data: body,
            url: baseURL + '/mail',
            contentType: "application/json; charset=utf-8",
            dataType: 'json'
        }).done(function (res) {
        }).fail(function (jqXHR, status, exception) {
            var msg = '';
            if (jqXHR.status === 0) {
                msg = 'Not connect.\n Verify Network.';
            }
            else if (jqXHR.status == 404) {
                msg = 'Requested page not found. [404]';
            }
            else if (jqXHR.status == 500) {
                msg = 'Internal Server Error [500].';
            }
            else if (exception === 'parsererror') {
                msg = 'Requested JSON parse failed.';
            }
            else if (exception === 'timeout') {
                msg = 'Time out error.';
            }
            else if (exception === 'abort') {
                msg = 'Ajax request aborted.';
            }
            else {
                msg = 'Uncaught Error.\n' + jqXHR.responseText;
            }
            alert("Error  - errorThrown: " + exception + " -  jqXHR.responseText: " + jqXHR.responseText + " -  jqXHR.status: " + jqXHR.status + " -  textStatus: " + status);
            handleError(exception);
        });
        function handleSuccess() {
            self.dom.lblSentMessage.innerHTML = 'Email sent successfully!';
            self.dom.txtName.style.backgroundColor = '#E8F4FF';
            self.dom.txtEmail.style.backgroundColor = '#E8F4FF';
            self.dom.txtAddresses.style.backgroundColor = '#E8F4FF';
            self.dom.txtNotes.style.backgroundColor = '#E8F4FF';
            self.dom.selHsPersona.style.backgroundColor = '#E8F4FF';
            self.dom.products.style.visibility = "hidden";
            self.dom.btnsend.style.visibility = "hidden";
        }
        function handleError(error) {
            console.log('Error  occurred', error);
            self.dom.lblSentMessage.innerHTML = 'Error  occurred!';
            self.dom.txtName.style.backgroundColor = '#FFE6E6';
            self.dom.txtEmail.style.backgroundColor = '#FFE6E6';
            self.dom.txtAddresses.style.backgroundColor = '#FFE6E6';
            self.dom.txtNotes.style.backgroundColor = '#FFE6E6';
            self.dom.selHsPersona.style.backgroundColor = '#FFE6E6';
        }
        this.emailForm = {
            txtName: null,
            txtEmail: null,
            txtAddresses: null,
            txtNotes: null,
            selHsPersona: null
        };
        this.emailModalElement = null;
        self.dom.lblSentMessage.innerHTML = '';
        self.dom.txtName = document.getElementById('txtName');
        self.dom.txtEmail = document.getElementById('txtEmail');
        self.dom.txtAddresses = document.getElementById('txtAddresses');
        self.dom.txtNotes = document.getElementById('txtNotes');
        self.dom.lblEmailMessage = document.getElementById('lblEmailMessage');
        self.dom.lblSentMessage = document.getElementById('lblSentMessage');
        self.dom.divSelection = document.getElementById('products-selection');
        self.dom.selHsPersona = document.getElementById('selHsPersona');
        self.dom.divSelectionEmail = document.getElementById('content-email');
    };
    EmailSummaryCmp.prototype._roundRoomVolume = function (volume) {
        debugOff('Round room volume');
        return Math.ceil(volume);
    };
    EmailSummaryCmp.prototype.validateForm = function () { };
    EmailSummaryCmp.prototype.close = function () {
        this.show = true;
        this._appService.hideEmailSummaryModal();
    };
    return EmailSummaryCmp;
}());
EmailSummaryCmp = __decorate([
    core_1.Component({
        selector: 'email-summary-cmp',
        template: __webpack_require__(846),
        styles: [String(__webpack_require__(1135))],
        host: { class: 'email-summary' }
    }),
    __metadata("design:paramtypes", [cart_service_1.CartService,
        core_1.ElementRef,
        http_1.Http,
        app_service_1.AppService,
        generators_service_1.GeneratorsService,
        catalog_service_1.CatalogService,
        navigation_service_1.NavigationService])
], EmailSummaryCmp);
exports.EmailSummaryCmp = EmailSummaryCmp;


/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var cart_service_1 = __webpack_require__(35);
var catalog_service_1 = __webpack_require__(28);
var app_service_1 = __webpack_require__(23);
var generators_service_1 = __webpack_require__(99);
var debug, debugOff = function () {
    var any = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        any[_i] = arguments[_i];
    }
};
"production" !== 'production' && (debug = __webpack_require__(4)('app:PrintSummaryCmp'));
var PrintSummaryCmp = (function () {
    function PrintSummaryCmp(_elementRef, _appService, _cartService, _catalogService, _generatorsService) {
        this._elementRef = _elementRef;
        this._appService = _appService;
        this._cartService = _cartService;
        this._catalogService = _catalogService;
        this._generatorsService = _generatorsService;
        this._dic = {
            stone: 'Natural Stone',
            ceramic: 'Ceramic, Porcelain, Glass Tile',
            acrylic: 'Acrylic, Fiberglass, Composite'
        };
        this._printSummaryElem = _elementRef.nativeElement;
        this._generatorCfg = this._generatorsService.state.generatorCfg;
        this._roomDimensions = this._generatorsService.state.roomDimensions;
        this._imgPaths = this._catalogService.imgPaths;
    }
    PrintSummaryCmp.prototype._roundRoomVolume = function (volume) {
        debugOff('Round room volume');
        return Math.ceil(volume);
    };
    PrintSummaryCmp.prototype.ngOnInit = function () {
    };
    PrintSummaryCmp.prototype.ngOnDestroy = function () {
    };
    PrintSummaryCmp.prototype._printDiv = function () {
        var printContents = this._printSummaryElem.innerHTML;
        var popupWin = window.open('', '_blank', 'width=300,height=300');
        popupWin.document.open();
        popupWin.document.write('<html>' +
            '<head>' +
            '<base href="/">' +
            '<link rel="stylesheet" type="text/css" href="assets/css/print.css" />' +
            '<link href="https://fonts.googleapis.com/css?family=Open+Sans:400,300,600,700" rel="stylesheet" type="text/css">' +
            '</head>' +
            '<body onload="window.print()">' +
            printContents +
            '</html>');
        popupWin.document.close();
    };
    return PrintSummaryCmp;
}());
PrintSummaryCmp = __decorate([
    core_1.Component({
        selector: 'print-summary-cmp',
        template: __webpack_require__(847),
        styles: [String(__webpack_require__(1136))],
        host: { class: 'print-summary' }
    }),
    __metadata("design:paramtypes", [core_1.ElementRef,
        app_service_1.AppService,
        cart_service_1.CartService,
        catalog_service_1.CatalogService,
        generators_service_1.GeneratorsService])
], PrintSummaryCmp);
exports.PrintSummaryCmp = PrintSummaryCmp;


/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var catalog_service_1 = __webpack_require__(28);
var animate_service_1 = __webpack_require__(147);
var debug, debugOff = function () {
    var any = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        any[_i] = arguments[_i];
    }
};
"production" !== 'production' && (debug = __webpack_require__(4)('app:ProductCategoriesListCmp'));
var ProductCategoriesListCmp = (function () {
    function ProductCategoriesListCmp(_elementRef, _catalogService, _animateService) {
        this._elementRef = _elementRef;
        this._catalogService = _catalogService;
        this._animateService = _animateService;
        this.categorySelected = new core_1.EventEmitter();
        this._rootCategory = [];
        this._subscriptions = {};
        this._timeouts = {};
        this._prodCategsListElem = null;
        this._indicatorElem = null;
        this._mutationObserver = null;
        this._currentCategoryId = null;
        this._domIsRendered = false;
        this._getProductCategories();
    }
    ProductCategoriesListCmp.prototype.ngOnInit = function () {
        var _this = this;
        this._cacheDomElements();
        this._onCategoriesListRendered(function () {
            if (_this._domIsRendered === true) {
                return;
            }
            _this._domIsRendered === false && (_this._domIsRendered = true);
            _this._slideIndicatorToCategoryId(800, _this._currentCategoryId);
        });
    };
    ProductCategoriesListCmp.prototype.ngOnChanges = function (changes) {
        var currentCategoryId = this._catalogService.checkCurrentCategoryChanged(changes);
        if (currentCategoryId !== false) {
            this._currentCategoryId = currentCategoryId;
            this._domIsRendered === true && this._slideIndicatorToCategoryId(800, currentCategoryId);
        }
    };
    ProductCategoriesListCmp.prototype.ngOnDestroy = function () {
        for (var subId in this._subscriptions) {
            this._subscriptions[subId].unsubscribe();
        }
        this._mutationObserver.disconnect();
    };
    ProductCategoriesListCmp.prototype._cacheDomElements = function () {
        this._prodCategsListElem = this._elementRef.nativeElement;
        debugOff('Product categories list element:', this._prodCategsListElem);
        this._indicatorElem = this._prodCategsListElem.querySelector('.indicator');
        debugOff('Indicator element:', this._indicatorElem);
    };
    ProductCategoriesListCmp.prototype._getProductCategories = function () {
        var _this = this;
        var catalogDataIsLoaded = this._catalogService.checkCatalogDataIsLoaded();
        if (catalogDataIsLoaded === true) {
            debugOff('Get catalog cached product categories');
            this._rootCategory = this._catalogService.getRootCategory();
            debugOff('Root category:', this._rootCategory);
        }
        else {
            debugOff('Subscribe for product categories');
            this._subscriptions.catalogDataLoadedAsync = this._catalogService.events.catalogDataLoadedAsync.subscribe(function (event) {
                debugOff('Subscription for product categories response');
                _this._rootCategory = event.rootCategory;
                debugOff('Root category async:', _this._rootCategory);
            });
        }
    };
    ProductCategoriesListCmp.prototype._selectCategory = function (category) {
        this.categorySelected.emit({
            category: category
        });
    };
    ProductCategoriesListCmp.prototype._slideIndicatorToCategoryId = function (interval, categoryId) {
        var category = this._catalogService.getProductCategoryById(categoryId);
        debugOff('Current category:', category);
        if (category === undefined) {
            console.error('Could not retrieve "' + categoryId + '" category');
            return;
        }
        this._slideIndicatorToCategory(interval, category);
    };
    ProductCategoriesListCmp.prototype._slideIndicatorToCategory = function (interval, category) {
        if (interval !== null && isNaN(interval)) {
            console.error('"interval" is not a number');
            return;
        }
        if (this._indicatorElem === null) {
            console.error('Could not find "indicator" element');
            return;
        }
        if (category === undefined) {
            console.error('"category" is undefined');
            return;
        }
        debugOff('Category id:', category.id);
        debugOff('Category:', category);
        var self = this;
        var linkContainer = document.querySelector('#' + category.id + '-link-container');
        debugOff('Link container:', linkContainer);
        if (linkContainer === null) {
            console.error('Could not find "#' + category.id + '-link-container" element');
            return;
        }
        var linkElement = document.querySelector('#' + category.id + '-link');
        debugOff('Link element:', linkElement);
        if (linkElement === null) {
            console.error('Could not find "#' + category.id + '-link" element');
            return;
        }
        var indicatorOffset = this._indicatorElem.offsetTop;
        debugOff('Indicator offset:', indicatorOffset);
        var targetOffset = linkContainer.offsetTop + linkElement.offsetTop;
        debugOff('Target offset:', targetOffset);
        interval === null && (interval = 800);
        this._animateService.start(indicatorOffset, targetOffset, interval, 'easeInOutQuad', function (curr, count, max) {
            self._indicatorElem.style.top = curr + 'px';
        }, this._timeouts, 'slideIndicatorToCategory');
    };
    ProductCategoriesListCmp.prototype._onCategoriesListRendered = function (callback) {
        this._mutationObserver = new MutationObserver(function () {
            callback();
        });
        this._mutationObserver.observe(this._prodCategsListElem, { childList: true, subtree: true });
    };
    return ProductCategoriesListCmp;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], ProductCategoriesListCmp.prototype, "catalogState", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", Object)
], ProductCategoriesListCmp.prototype, "categorySelected", void 0);
ProductCategoriesListCmp = __decorate([
    core_1.Component({
        selector: 'product-categories-list-cmp',
        template: __webpack_require__(848),
        styles: [String(__webpack_require__(1137))],
        host: { class: 'product-categories-list' }
    }),
    __metadata("design:paramtypes", [core_1.ElementRef,
        catalog_service_1.CatalogService,
        animate_service_1.AnimateService])
], ProductCategoriesListCmp);
exports.ProductCategoriesListCmp = ProductCategoriesListCmp;


/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var catalog_service_1 = __webpack_require__(28);
var utils_service_1 = __webpack_require__(286);
var animate_service_1 = __webpack_require__(147);
var debug, debugOff = function () {
    var any = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        any[_i] = arguments[_i];
    }
};
"production" !== 'production' && (debug = __webpack_require__(4)('app:ProductCategoriesCmp'));
var ProductCategoriesCmp = (function () {
    function ProductCategoriesCmp(_elementRef, _catalogService, _utilsService, _renderer, _animateService) {
        this._elementRef = _elementRef;
        this._catalogService = _catalogService;
        this._utilsService = _utilsService;
        this._renderer = _renderer;
        this._animateService = _animateService;
        this.categorySelected = new core_1.EventEmitter();
        this._prevCategory = null;
        this._currTopCategory = null;
        this._categoriesElems = null;
        this._rootSubcategs = null;
        this._rootCategory = null;
        this._renderCategory = null;
        this._subscriptions = {};
        this._timeouts = {};
        this._listeners = {};
        this._prodCategsElem = null;
        this._mutationObserver = null;
        this._currentCategoryId = null;
        this._domIsRendered = false;
        this._selectCategByScrollIsEnabled = true;
        this._scrollToSelectedCategIsEnabled = true;
        this._getProductCategories();
    }
    ProductCategoriesCmp.prototype.ngOnInit = function () {
        var _this = this;
        var self = this;
        this._cacheDomElements();
        this._onCategoriesRendered(function () {
            _this._cacheTopCategsElems();
            if (_this._domIsRendered === true) {
                return;
            }
            _this._domIsRendered === false && (_this._domIsRendered = true);
            self.catalogState.renderMode === 'expanded' &&
                setTimeout(function () {
                    self._scrollToCategory(self._currentCategoryId, 800);
                }, 400);
        });
        this._listeners.catalogScroll = this._renderer.listen(this.scrollContainerElem, 'scroll', function (event) { return self.catalogState.renderMode !== 'compact' && self._selectTopCategoryByScroll(event); });
        this._catalogService.events.categorySelected.subscribe(function (event) {
            setTimeout(function () {
                _this._scrollToCategory(event.category.id, 300);
            }, 0);
        });
    };
    ProductCategoriesCmp.prototype.ngOnChanges = function (changes) {
        var currentCategoryId = this._catalogService.checkCurrentCategoryChanged(changes);
        currentCategoryId !== false && this._handleCurrentCategChanged(currentCategoryId);
        var renderMode = this._catalogService.checkRenderModeChanged(changes);
        renderMode !== false && this._handleCatalogRenderModeChanged(renderMode);
    };
    ProductCategoriesCmp.prototype.ngOnDestroy = function () {
        for (var subId in this._subscriptions) {
            this._subscriptions[subId].unsubscribe();
        }
        this._mutationObserver.disconnect();
        this._listeners.catalogScroll();
    };
    ProductCategoriesCmp.prototype._handleCurrentCategChanged = function (currentCategoryId) {
        debugOff('Handle current category changed');
        this._currentCategoryId = currentCategoryId;
        if (this._domIsRendered === true) {
            if (this.catalogState.renderMode === 'expanded') {
                this._scrollToCategory(this._currentCategoryId, 800);
            }
            else if (this.catalogState.renderMode === 'compact') {
                this.scrollContainerElem.scrollTop = 0;
                this._renderSelectedCategory(currentCategoryId);
            }
        }
        this._currTopCategory = this._catalogService.getProductCategoryById(this.catalogState.currentCategoryId);
        debugOff('Current top Category:', this._currTopCategory);
    };
    ProductCategoriesCmp.prototype._handleCatalogRenderModeChanged = function (renderMode) {
        debugOff('Handle render mode changed');
        debugOff('Render mode:', renderMode);
        this._renderCategory = null;
        this._renderCategory = this._rootCategory;
    };
    ProductCategoriesCmp.prototype._renderSelectedCategory = function (currentCategoryId) {
        var selectedCategory = this._catalogService.getProductCategoryById(currentCategoryId);
    };
    ProductCategoriesCmp.prototype._cacheDomElements = function () {
        this._prodCategsElem = this._elementRef.nativeElement;
        debugOff('Product categories list element:', this._prodCategsElem);
    };
    ProductCategoriesCmp.prototype._getProductCategories = function () {
        var _this = this;
        var catalogDataIsLoaded = this._catalogService.checkCatalogDataIsLoaded();
        if (catalogDataIsLoaded === true) {
            debugOff('Get catalog cached product categories');
            this._rootCategory = this._catalogService.getRootCategory();
            this._renderCategory = this._catalogService.getRootCategory();
            debugOff('Root category:', this._rootCategory);
        }
        else {
            debugOff('Subscribe for product categories');
            this._subscriptions.catalogDataLoadedAsync = this._catalogService.events.catalogDataLoadedAsync.subscribe(function (event) {
                debugOff('Subscription for product categories response');
                _this._rootCategory = event.rootCategory;
                _this._renderCategory = event.rootCategory;
                debugOff('Root category async:', _this._rootCategory);
            });
        }
    };
    ProductCategoriesCmp.prototype._scrollToCategory = function (categId, duration) {
        if (this._scrollToSelectedCategIsEnabled === false) {
            return;
        }
        var self = this, startPosition, endPosition, targetElement, targetElemWindowOffset, scrollDistance;
        startPosition = this.scrollContainerElem.scrollTop;
        debugOff('Starting position:', startPosition);
        targetElement = document.querySelector('#' + categId + '-product-category');
        debugOff('Target element:', targetElement);
        targetElemWindowOffset = this._utilsService.getElementToWindowOffset(targetElement);
        debugOff('Target element offset:', targetElemWindowOffset);
        scrollDistance = targetElemWindowOffset.y;
        debugOff('Scroll distance:', scrollDistance);
        endPosition = startPosition + scrollDistance;
        debugOff('End position:', endPosition);
        this._animateService.start(startPosition, endPosition, duration, 'easeInOutQuad', function (curr, count, max) {
            self.scrollContainerElem.scrollTop = curr;
            self._selectCategByScrollIsEnabled = false;
            count >= max && setTimeout(function () { return self._selectCategByScrollIsEnabled = true; }, 50);
        }, this._timeouts, '_scrollToCategory');
    };
    ProductCategoriesCmp.prototype._cacheTopCategsElems = function () {
        var _this = this;
        this._rootSubcategs = this._catalogService.getRootCategory().subcategories;
        debugOff('Root subcategories:', this._rootSubcategs);
        this._categoriesElems = {};
        this._rootSubcategs.forEach(function (category) {
            _this._categoriesElems[category.id] = document.querySelector('#' + category.id + '-product-category');
        });
        debugOff('Cached subcategories elements:', this._categoriesElems);
    };
    ProductCategoriesCmp.prototype._selectTopCategoryByScroll = function (event) {
        debugOff('Select top category by scroll');
        debugOff('Event:', event);
        if (this._selectCategByScrollIsEnabled === false) {
            return;
        }
        var offset = -200, self = this;
        this._prevCategory = this._currTopCategory;
        this._rootSubcategs.forEach(function (category) {
            if (self._categoriesElems[category.id] !== null &&
                event.srcElement.scrollTop > self._categoriesElems[category.id].offsetTop + offset) {
                self._currTopCategory = category;
            }
        });
        if (this._prevCategory.id !== this._currTopCategory.id) {
            debugOff('Selected category:', this._currTopCategory);
            this._scrollToSelectedCategIsEnabled = false;
            var self_1 = this;
            clearTimeout(this._timeouts.blockScrollToAnimation);
            this._timeouts.blockScrollToAnimation = setTimeout(function () {
                self_1._scrollToSelectedCategIsEnabled = true;
            }, 100);
            this.categorySelected.emit({
                category: self_1._currTopCategory
            });
        }
    };
    ProductCategoriesCmp.prototype._onCategoriesRendered = function (callback) {
        this._mutationObserver = new MutationObserver(function () {
            callback();
        });
        this._mutationObserver.observe(this._prodCategsElem, { childList: true, subtree: true });
    };
    return ProductCategoriesCmp;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], ProductCategoriesCmp.prototype, "catalogState", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], ProductCategoriesCmp.prototype, "scrollContainerElem", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", Object)
], ProductCategoriesCmp.prototype, "categorySelected", void 0);
ProductCategoriesCmp = __decorate([
    core_1.Component({
        selector: 'product-categories-cmp',
        template: __webpack_require__(849),
        styles: [String(__webpack_require__(1138))],
        host: { class: 'product-categories' }
    }),
    __metadata("design:paramtypes", [core_1.ElementRef,
        catalog_service_1.CatalogService,
        utils_service_1.UtilsService,
        core_1.Renderer,
        animate_service_1.AnimateService])
], ProductCategoriesCmp);
exports.ProductCategoriesCmp = ProductCategoriesCmp;


/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var core_1 = __webpack_require__(0);
var utils_service_1 = __webpack_require__(286);
var catalog_service_1 = __webpack_require__(28);
var app_service_1 = __webpack_require__(23);
var platform_browser_1 = __webpack_require__(49);
var ng2_page_scroll_1 = __webpack_require__(309);
var animate_service_1 = __webpack_require__(147);
var Ps = __webpack_require__(106);
var debug, debugOff = function () {
    var any = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        any[_i] = arguments[_i];
    }
};
"production" !== 'production' && (debug = __webpack_require__(4)('app:ProductCategoryCmp'));
var ProductCategoryCmp = (function () {
    function ProductCategoryCmp(_elementRef, _catalogService, _appService, _animateService, pageScrollService, _utilsService, document) {
        this._elementRef = _elementRef;
        this._catalogService = _catalogService;
        this._appService = _appService;
        this._animateService = _animateService;
        this.pageScrollService = pageScrollService;
        this._utilsService = _utilsService;
        this.document = document;
        this._subscriptions = {};
        this._subcategories = null;
        this._compactSubcategories = null;
        this._expandedSubcategories = null;
        this._categoryElem = null;
        this._subscribeToEvents();
    }
    ProductCategoryCmp.prototype.ngOnInit = function () {
        debugOff('Category:', this.category);
        this._shallowCloneSubcategories();
        this._cacheDomElements();
    };
    ProductCategoryCmp.prototype.ngOnDestroy = function () {
        for (var subId in this._subscriptions) {
            this._subscriptions[subId].unsubscribe();
        }
    };
    ProductCategoryCmp.prototype._cacheDomElements = function () {
        this._categoryElem = this._elementRef.nativeElement;
        debugOff('Product categories list element:', this._categoryElem);
    };
    ProductCategoryCmp.prototype._selectCategory = function (category) {
        if (this._catalogService.prevSelectedCategory !== undefined) {
            this._catalogService.prevSelectedCategory.isSelected = false;
        }
        category.isSelected = true;
        this._catalogService.prevSelectedCategory = category;
        this._catalogService.events.categorySelected.emit({
            category: category
        });
    };
    ProductCategoryCmp.prototype._subscribeToEvents = function () {
        var _this = this;
        debugOff('Subscribe to events');
        this._subscriptions.categorySelected = this._catalogService.events.categorySelected.subscribe(function (event) {
            event.category.parentCategoryId === _this.category.id &&
                _this._renderSelectedSubcategory(event.category);
        });
    };
    ProductCategoryCmp.prototype._shallowCloneSubcategories = function () {
        debugOff('Shallow clone "' + this.category.id + '" subcategories list');
        var self = this;
        this._subcategories = this._catalogService.shallowCloneSubcategories(this.category)
            .filter(function (subcategory) { return true; });
        debugOff('Subcategories:', this._subcategories);
        this._compactSubcategories = [];
        this._expandedSubcategories = [];
        this._subcategories.forEach(function (subcategory) {
            if (subcategory.renderMode === 'compact' ||
                self.catalogState.renderMode === 'compact') {
                self._compactSubcategories.push(subcategory);
            }
            else if (subcategory.renderMode === 'expanded') {
                self._expandedSubcategories.push(subcategory);
            }
        });
        debugOff('Compact subcategories:', this._compactSubcategories);
        debugOff('Expanded subcategories:', this._expandedSubcategories);
    };
    ProductCategoryCmp.prototype._renderSelectedSubcategory = function (subcategory) {
        debugOff('Render selected subcategory');
        this._shallowCloneSubcategories();
        var selectedSubcategory = this._catalogService.shallowCloneCategory(subcategory);
        selectedSubcategory.renderMode = 'expanded';
        this._expandedSubcategories.splice(0, 0, selectedSubcategory);
    };
    ProductCategoryCmp.prototype.displayCategoryDetails = function (category) {
        console.log('displayCategoryDetails(), category:', category);
        var product = {
            name: category.title,
            images: {
                folder: false,
                thumbnail: category.image
            },
            descriptions: {
                long: category.longDescription,
                tech: null
            }
        };
        this._appService.displayProductDetailsModal(product);
    };
    return ProductCategoryCmp;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], ProductCategoryCmp.prototype, "catalogState", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], ProductCategoryCmp.prototype, "category", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], ProductCategoryCmp.prototype, "level", void 0);
ProductCategoryCmp = __decorate([
    core_1.Component({
        selector: 'product-category-cmp',
        template: __webpack_require__(850),
        styles: [String(__webpack_require__(1139))],
        host: { class: 'product-category' }
    }),
    __param(6, core_1.Inject(platform_browser_1.DOCUMENT)),
    __metadata("design:paramtypes", [core_1.ElementRef,
        catalog_service_1.CatalogService,
        app_service_1.AppService,
        animate_service_1.AnimateService,
        ng2_page_scroll_1.PageScrollService,
        utils_service_1.UtilsService, Object])
], ProductCategoryCmp);
exports.ProductCategoryCmp = ProductCategoryCmp;


/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var catalog_service_1 = __webpack_require__(28);
var app_service_1 = __webpack_require__(23);
var debug, debugOff = function () {
    var any = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        any[_i] = arguments[_i];
    }
};
"production" !== 'production' && (debug = __webpack_require__(4)('app:ProductDetailsCmp'));
var ProductDetailsCmp = (function () {
    function ProductDetailsCmp(_elementRef, _catalogService, _appService) {
        this._elementRef = _elementRef;
        this._catalogService = _catalogService;
        this._appService = _appService;
        this._imgPaths = null;
        this._productElem = null;
        this._imgPaths = this._catalogService.imgPaths;
        this._productElem = _elementRef.nativeElement;
    }
    ProductDetailsCmp.prototype.ngOnInit = function () {
    };
    return ProductDetailsCmp;
}());
ProductDetailsCmp = __decorate([
    core_1.Component({
        selector: 'product-details-cmp',
        template: __webpack_require__(851),
        styles: [String(__webpack_require__(1140))],
        host: { class: 'product-details' }
    }),
    __metadata("design:paramtypes", [core_1.ElementRef,
        catalog_service_1.CatalogService,
        app_service_1.AppService])
], ProductDetailsCmp);
exports.ProductDetailsCmp = ProductDetailsCmp;


/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var catalog_service_1 = __webpack_require__(28);
var app_service_1 = __webpack_require__(23);
var cart_service_1 = __webpack_require__(35);
var product_1 = __webpack_require__(428);
var product_category_1 = __webpack_require__(427);
var debug, debugOff = function () {
    var any = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        any[_i] = arguments[_i];
    }
};
"production" !== 'production' && (debug = __webpack_require__(4)('app:ProductOptionsDropdownCmp'));
var ProductOptionsDropdownCmp = (function () {
    function ProductOptionsDropdownCmp(_elementRef, _catalogService, _appService, _cartService) {
        this._elementRef = _elementRef;
        this._catalogService = _catalogService;
        this._appService = _appService;
        this._cartService = _cartService;
        this._optionsDropdownIsActive = false;
        this._imgPaths = null;
        this._selectedOption = null;
        this._dropdownElement = null;
        this._optionsDropdownIsRendered = false;
        debugOff('Construct products options dropdown component');
        this._imgPaths = this._catalogService.imgPaths;
        this._dropdownElement = _elementRef.nativeElement;
    }
    ProductOptionsDropdownCmp.prototype.ngOnInit = function () {
        debugOff('Initialise products options dropdown component');
    };
    ProductOptionsDropdownCmp.prototype.openOptionDropdown = function () {
        var _this = this;
        if (this._optionsDropdownIsRendered === true) {
            return;
        }
        this._selectedOption = this.product.options.selected[this.optionsListId];
        if (this.product.options) {
            this.product.options.dropdownIsActive = true;
            this._appService.state.prodOptionsDropdownIsOpened = true;
        }
        this.product.addToScene();
        this._optionsDropdownIsRendered = true;
        setTimeout(function () { return _this._optionsDropdownIsActive = true; }, 0);
    };
    ProductOptionsDropdownCmp.prototype.selectOption = function (option) {
        option !== null && (this.product.options.selected[this.optionsListId] = option);
        this.product.refreshState();
        if (this.product.isAddedToCart === true) {
            this._cartService.updateTotalPrice();
        }
    };
    ProductOptionsDropdownCmp.prototype.closeOptionDropdown = function () {
        var _this = this;
        if (this._optionsDropdownIsRendered === false) {
            return;
        }
        if (this.product.options) {
            this.product.options.dropdownIsActive = false;
            this._appService.state.prodOptionsDropdownIsOpened = false;
        }
        this.product.removeFromScene();
        this._optionsDropdownIsActive = false;
        setTimeout(function () { return _this._optionsDropdownIsRendered = false; }, 300);
    };
    ProductOptionsDropdownCmp.prototype._onOptionClick = function () {
        debugOff('Product option clicked');
        this.closeOptionDropdown();
        this.product.isAddedToCart !== true && this.product.addToCart(this.category.id);
    };
    ProductOptionsDropdownCmp.prototype._onClick = function (event) {
        if (this._optionsDropdownIsRendered === false) {
            return;
        }
        if (!this._dropdownElement.contains(event.target)) {
            this.product.options.selected[this.optionsListId] = this._selectedOption;
            this.product.refreshState();
            this.closeOptionDropdown();
        }
    };
    return ProductOptionsDropdownCmp;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", product_1.Product)
], ProductOptionsDropdownCmp.prototype, "product", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", product_category_1.ProductCategory)
], ProductOptionsDropdownCmp.prototype, "category", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], ProductOptionsDropdownCmp.prototype, "optionsListId", void 0);
__decorate([
    core_1.HostBinding('class.active'),
    __metadata("design:type", Boolean)
], ProductOptionsDropdownCmp.prototype, "_optionsDropdownIsActive", void 0);
ProductOptionsDropdownCmp = __decorate([
    core_1.Component({
        selector: 'product-options-dropdown-cmp',
        template: __webpack_require__(852),
        styles: [String(__webpack_require__(1141))],
        host: {
            '(document:click)': '_onClick($event)',
            class: 'product-options-dropdown'
        }
    }),
    __metadata("design:paramtypes", [core_1.ElementRef,
        catalog_service_1.CatalogService,
        app_service_1.AppService,
        cart_service_1.CartService])
], ProductOptionsDropdownCmp);
exports.ProductOptionsDropdownCmp = ProductOptionsDropdownCmp;


/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var catalog_service_1 = __webpack_require__(28);
var cart_service_1 = __webpack_require__(35);
var app_service_1 = __webpack_require__(23);
var debug, debugOff = function () {
    var any = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        any[_i] = arguments[_i];
    }
};
"production" !== 'production' && (debug = __webpack_require__(4)('app:ProductsListCmp'));
var ProductsListCmp = (function () {
    function ProductsListCmp(_catalogService, _cartService, _elementRef, _appService) {
        this._catalogService = _catalogService;
        this._cartService = _cartService;
        this._elementRef = _elementRef;
        this._appService = _appService;
        this._imgPaths = this._catalogService.imgPaths;
        this._prodsPerLine = 4;
        this._productsRows = null;
        this._productListElement = true;
        this._subscriptions = {};
    }
    ProductsListCmp.prototype.ngOnInit = function () {
        this._sortProductsInRows();
        this._cacheDomElements();
        this._subscribeToEvents();
    };
    ProductsListCmp.prototype.ngOnDestroy = function () {
        for (var subscriptionId in this._subscriptions) {
            this._subscriptions[subscriptionId].unsubscribe();
        }
    };
    ProductsListCmp.prototype._cacheDomElements = function () {
        debugOff('Cache dom elements');
        this._productListElement = this._elementRef.nativeElement;
        debugOff('Product element:', this._productListElement);
    };
    ProductsListCmp.prototype._subscribeToEvents = function () {
        debugOff('Subscribe to events');
        var self = this;
        this._productListElement = this._cartService.events.cartUpdated.subscribe(function () {
            self._sortProductsInRows();
        });
        debugOff('Product element:', this._productListElement);
    };
    ProductsListCmp.prototype._sortProductsInRows = function () {
        var _this = this;
        var self = this, index = 0, numOfRows = 0, visibleProducts, newRow;
        this._productsRows = [];
        if (this.category.products === undefined ||
            this.category.products === null) {
            console.warn('Category "' + this.category.id + '" has no products');
            return;
        }
        visibleProducts = this.category.products.filter(function (product) {
            return product.isVisible;
        });
        visibleProducts.forEach(function (product) {
            if (index === 0) {
                newRow = [];
                self._productsRows.push(newRow);
            }
            newRow.push(product);
            index++;
            if (index === _this._prodsPerLine) {
                numOfRows++;
                index = 0;
            }
        });
        debugOff('Category product rows:', this._productsRows);
    };
    return ProductsListCmp;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], ProductsListCmp.prototype, "category", void 0);
ProductsListCmp = __decorate([
    core_1.Component({
        selector: 'products-list-cmp',
        template: __webpack_require__(853),
        styles: [String(__webpack_require__(1142))],
        host: { 'class': 'clearfix products-list' }
    }),
    __metadata("design:paramtypes", [catalog_service_1.CatalogService,
        cart_service_1.CartService,
        core_1.ElementRef,
        app_service_1.AppService])
], ProductsListCmp);
exports.ProductsListCmp = ProductsListCmp;


/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var catalog_service_1 = __webpack_require__(28);
var cart_service_1 = __webpack_require__(35);
var debug, debugOff = function () {
    var any = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        any[_i] = arguments[_i];
    }
};
"production" !== 'production' && (debug = __webpack_require__(4)('app:ProductsTinyListCmp'));
var ProductsTinyListCmp = (function () {
    function ProductsTinyListCmp(_catalogService, _cartService, _elementRef) {
        this._catalogService = _catalogService;
        this._cartService = _cartService;
        this._elementRef = _elementRef;
        this._catProdsInCart = [];
        this._productTinyListElem = true;
        this._subscriptions = {};
    }
    ProductsTinyListCmp.prototype.ngOnInit = function () {
        this._cacheDomElements();
        this._filterCartProducts();
        this._handleCartUpdate();
    };
    ProductsTinyListCmp.prototype.ngOnDestroy = function () {
        for (var subscriptionId in this._subscriptions) {
            this._subscriptions[subscriptionId].unsubscribe();
        }
    };
    ProductsTinyListCmp.prototype._cacheDomElements = function () {
        debugOff('Cache dom elements');
        this._productTinyListElem = this._elementRef.nativeElement;
        debugOff('Product element:', this._productTinyListElem);
    };
    ProductsTinyListCmp.prototype._handleCartUpdate = function () {
        debugOff('Handle Cart Update');
        var self = this;
        this._subscriptions.cartUpdated = this._cartService.events.cartUpdated.subscribe(function () {
            self._filterCartProducts();
        });
    };
    ProductsTinyListCmp.prototype._filterCartProducts = function () {
        debugOff('Filter cart products');
        var catProdsInCart = this.products.filter(function (product) {
            return product.isAddedToCart;
        });
        debugOff('Category cart products:', catProdsInCart);
        this._catProdsInCart = catProdsInCart;
    };
    return ProductsTinyListCmp;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], ProductsTinyListCmp.prototype, "products", void 0);
ProductsTinyListCmp = __decorate([
    core_1.Component({
        selector: 'products-tiny-list-cmp',
        template: __webpack_require__(854),
        styles: [String(__webpack_require__(1143))],
        host: { 'class': 'clearfix products-tiny-list' }
    }),
    __metadata("design:paramtypes", [catalog_service_1.CatalogService,
        cart_service_1.CartService,
        core_1.ElementRef])
], ProductsTinyListCmp);
exports.ProductsTinyListCmp = ProductsTinyListCmp;


/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var debug, debugOff = function () {
    var any = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        any[_i] = arguments[_i];
    }
};
"production" !== 'production' && (debug = __webpack_require__(4)('app:SceneTooltipCmp'));
var SceneTooltipCmp = (function () {
    function SceneTooltipCmp() {
        this.clickMapIsVisible = false;
        debugOff('Construct scene tooltip component');
    }
    SceneTooltipCmp.prototype.ngOnInit = function () {
        debugOff('Initialise scene tooltip component');
        debugOff('Tooltips: ', this.product.tooltips);
    };
    SceneTooltipCmp.prototype.ngOnDestroy = function () {
        debugOff('Destruct scene tooltip component');
    };
    SceneTooltipCmp.prototype.mouseOverTooltip = function (tooltip) {
        debugOff('Mouse over tooltip');
    };
    SceneTooltipCmp.prototype.mouseOutTooltip = function (tooltip) {
        debugOff('Mouse out of tooltip');
    };
    return SceneTooltipCmp;
}());
__decorate([
    core_1.HostBinding('class.view-regions'),
    __metadata("design:type", Boolean)
], SceneTooltipCmp.prototype, "clickMapIsVisible", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], SceneTooltipCmp.prototype, "product", void 0);
SceneTooltipCmp = __decorate([
    core_1.Component({
        selector: 'scene-tooltip-cmp',
        template: __webpack_require__(855),
        styles: [String(__webpack_require__(1144))],
        host: { 'class': 'scene-tooltip' }
    }),
    __metadata("design:paramtypes", [])
], SceneTooltipCmp);
exports.SceneTooltipCmp = SceneTooltipCmp;


/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var catalog_service_1 = __webpack_require__(28);
var app_service_1 = __webpack_require__(23);
var cart_service_1 = __webpack_require__(35);
var scene_service_1 = __webpack_require__(199);
var animate_service_1 = __webpack_require__(147);
var product_options_1 = __webpack_require__(429);
var debug, debugOff = function () {
    var any = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        any[_i] = arguments[_i];
    }
};
"production" !== 'production' && (debug = __webpack_require__(4)('app:SceneCmp'));
var SceneCmp = (function () {
    function SceneCmp(_catalogService, _cartService, _appService, _sceneService, _elementRef, _animateService) {
        this._catalogService = _catalogService;
        this._cartService = _cartService;
        this._appService = _appService;
        this._sceneService = _sceneService;
        this._elementRef = _elementRef;
        this._animateService = _animateService;
        this._cartProducts = {};
        this._sceneProducts = {};
        this._timeouts = {};
        this._imgPaths = null;
        this.graphicsLayersElement = null;
        this.layersContainer = null;
        this.cancelHorizMouseScroll = null;
        this.overflowX = false;
        this.overflowY = false;
        this.scrollbarXisVisible = false;
        this.scrollbarYisVisible = false;
        this.scrollFocusPoint = 0.5;
        this.timeouts = {
            scrollToFocusPoint: null
        };
        this._imgPaths = this._catalogService.imgPaths;
        this._cartProducts = this._cartService.getCartProducts();
        this._sceneProducts = this._sceneService.getSceneProducts();
        this.graphicsLayersElement = _elementRef.nativeElement;
    }
    SceneCmp.prototype.onResize = function (event) {
        var self = this;
        self.resizeLayersContainer();
        setTimeout(function () { return self.resizeLayersContainer(); }, 300);
        this.scrollToFocusPoint();
    };
    SceneCmp.prototype.ngOnInit = function () {
        var self = this, graphicsLayers = this._elementRef.nativeElement;
        this.layersContainer = document.getElementById('layers-container');
        this.resizeLayersContainer();
        this.scrollToFocusPoint();
    };
    SceneCmp.prototype._getSpaFrameImg = function () {
        if (this._appService.state.selectedControl === null) {
            return null;
        }
        debugOff('Get spa frame scene image path');
        var selectedColor, selectedFinish, imageName;
        if (this._appService.state.selectedControl.vSpa.spaFrameSourceOption === 'color') {
            selectedColor = this._appService.state.selectedControl.options.selected.color;
            if (product_options_1.productOptions.color[selectedColor]) {
                imageName = product_options_1.productOptions.color[selectedColor].spaFrame;
            }
        }
        else if (this._appService.state.selectedControl.vSpa.spaFrameSourceOption === 'finish') {
            selectedFinish = this._appService.state.selectedControl.options.selected.finish;
            debugOff('Selected finish:', selectedFinish);
            if (product_options_1.productOptions.finish[selectedFinish]) {
                imageName = product_options_1.productOptions.finish[selectedFinish].spaFrame;
            }
        }
        debugOff("Spa frame image:", imageName);
        var spaFrameImgPath = 'url(' + this._imgPaths.scene + 'SpaFrame-' + imageName + ')';
        debugOff('Path:', spaFrameImgPath);
        return spaFrameImgPath;
    };
    SceneCmp.prototype.resizeLayersContainer = function () {
        var bgrH = 455, bgrW = 700, tolerance = 0.05, graphicsLayers = this.graphicsLayersElement, containRatioHeight = Math.ceil(this.graphicsLayersElement.offsetWidth * bgrH / bgrW), coverRatioWidth = Math.ceil(window.innerHeight * bgrW / bgrH);
        if (containRatioHeight < window.innerHeight) {
            this.layersContainer.style.width = coverRatioWidth + 'px';
            if (window.innerWidth <= 680) {
                this.layersContainer.style.height = window.innerHeight - 60 + 'px';
            }
            else {
                this.layersContainer.style.height = window.innerHeight + 'px';
            }
            if (this.overflowX === false) {
                this.overflowX = true;
                this.overflowY = false;
            }
        }
        else {
            this.layersContainer.style.width = graphicsLayers.offsetWidth + 'px';
            this.layersContainer.style.height = containRatioHeight + 'px';
            if (this.overflowY === false) {
                this.overflowX = false;
                this.overflowY = true;
            }
        }
        if (containRatioHeight < window.innerHeight - window.innerHeight * tolerance) {
            if (this.scrollbarXisVisible === false) {
                this.scrollbarXisVisible = true;
                this.scrollbarYisVisible = false;
                graphicsLayers.classList.remove('overflow-y');
                graphicsLayers.classList.add('overflow-x');
            }
        }
        else if (containRatioHeight > window.innerHeight + window.innerHeight * tolerance) {
            if (this.scrollbarYisVisible === false) {
                this.scrollbarXisVisible = false;
                this.scrollbarYisVisible = true;
                graphicsLayers.classList.remove('overflow-x');
                graphicsLayers.classList.add('overflow-y');
            }
        }
        else {
            if (this.scrollbarXisVisible !== false || this.scrollbarYisVisible !== false) {
                this.scrollbarXisVisible = false;
                this.scrollbarYisVisible = false;
                graphicsLayers.classList.remove('overflow-x', 'overflow-y');
            }
        }
    };
    SceneCmp.prototype.centerScrollOnTooltips = function (tooltips) {
        var prevMin, prevMax, min, max, position, dimension, total = 100;
        if (this.overflowX === true) {
            position = 'DistLeft';
            dimension = 'Width';
        }
        else {
            position = 'DistTop';
            dimension = 'Height';
        }
        if (typeof tooltips !== 'undefined' &&
            tooltips !== null &&
            tooltips.length !== 0) {
            min = tooltips[0][position];
            max = tooltips[0][position] + tooltips[0][dimension];
            prevMin = min;
            prevMax = max;
        }
        else {
            return;
        }
        tooltips.forEach(function (tooltip) {
            tooltip[position] < prevMin && (min = tooltip[position]);
            tooltip[position] + tooltip[dimension] > prevMax && (max = tooltip[position] + tooltip[dimension]);
            prevMin = min;
            prevMax = max;
        });
        this.scrollFocusPoint = ((max - min) / 2 + min) / 100;
        this.scrollToFocusPoint();
    };
    SceneCmp.prototype.scrollToFocusPoint = function () {
        if (this.scrollbarXisVisible === false && this.scrollbarYisVisible === false) {
            return;
        }
        var self = this, scrollPosition, scrollFinalPosition;
        if (this.overflowX === true) {
            scrollPosition = this.graphicsLayersElement.scrollLeft;
            scrollFinalPosition = calcFocusPoint(this.layersContainer.offsetWidth, this.graphicsLayersElement.offsetWidth);
        }
        else {
            scrollPosition = this.graphicsLayersElement.scrollTop;
            scrollFinalPosition = calcFocusPoint(this.layersContainer.offsetHeight, window.innerHeight);
        }
        function calcFocusPoint(total, dimension) {
            return Math.ceil(total * self.scrollFocusPoint - dimension / 2);
        }
        this.timeouts.scrollToFocusPoint !== null && clearTimeout(this.timeouts.scrollToFocusPoint);
        this.timeouts.scrollToFocusPoint = setTimeout(animateScroll, 100);
        function animateScroll() {
            self._animateService.start(scrollPosition, scrollFinalPosition, 300, 'easeInOutQuad', function (curr, count, max) {
                if (self.overflowX === true) {
                    self.graphicsLayersElement.scrollLeft = curr;
                }
                else {
                    self.graphicsLayersElement.scrollTop = curr;
                }
            }, this._timeouts, 'scrollToFocusPoint');
        }
    };
    return SceneCmp;
}());
__decorate([
    core_1.HostListener('window:resize', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SceneCmp.prototype, "onResize", null);
SceneCmp = __decorate([
    core_1.Component({
        selector: 'scene-cmp',
        template: __webpack_require__(856),
        styles: [String(__webpack_require__(1145))],
        host: { id: 'graphics', class: 'scene' }
    }),
    __metadata("design:paramtypes", [catalog_service_1.CatalogService,
        cart_service_1.CartService,
        app_service_1.AppService,
        scene_service_1.SceneService,
        core_1.ElementRef,
        animate_service_1.AnimateService])
], SceneCmp);
exports.SceneCmp = SceneCmp;


/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var catalog_service_1 = __webpack_require__(28);
var cart_service_1 = __webpack_require__(35);
var app_service_1 = __webpack_require__(23);
var debug, debugOff = function () {
    var any = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        any[_i] = arguments[_i];
    }
};
"production" !== 'production' && (debug = __webpack_require__(4)('app:SummaryCmp'));
var SummaryCmp = (function () {
    function SummaryCmp(_catalogService, _cartService, _elementRef, _appService) {
        this._catalogService = _catalogService;
        this._cartService = _cartService;
        this._elementRef = _elementRef;
        this._appService = _appService;
        this._imgPaths = this._catalogService.imgPaths;
        this._summaryElement = true;
        this._subscriptions = {};
    }
    SummaryCmp.prototype.ngOnInit = function () {
        this._cacheDomElements();
    };
    SummaryCmp.prototype.ngOnDestroy = function () {
        for (var subscriptionId in this._subscriptions) {
            this._subscriptions[subscriptionId].unsubscribe();
        }
    };
    SummaryCmp.prototype._cacheDomElements = function () {
        debugOff('Cache dom elements');
        this._summaryElement = this._elementRef.nativeElement;
        debugOff('Product element:', this._summaryElement);
    };
    return SummaryCmp;
}());
SummaryCmp = __decorate([
    core_1.Component({
        selector: 'summary-cmp',
        template: __webpack_require__(857),
        styles: [String(__webpack_require__(1146))],
        host: { 'class': 'summary clearfix' }
    }),
    __metadata("design:paramtypes", [catalog_service_1.CatalogService,
        cart_service_1.CartService,
        core_1.ElementRef,
        app_service_1.AppService])
], SummaryCmp);
exports.SummaryCmp = SummaryCmp;


/***/ },
/* 660 */
/***/ function(module, exports) {

"use strict";
"use strict";
exports.productCategories = [
    {
        id: 'generators',
        parentCategoryId: null,
        menuName: 'Generators',
        title: 'SmartSizingTM',
        subtitle: null,
        shortDescription: 'Please enter shower size and material in order to select the correct generator model for your spa.',
        longDescription: null,
        image: null,
        renderMode: 'expanded',
        customRenderer: 'generator-configurator-cmp',
        isVisible: true,
        allowInCartMultipleProds: false,
        sortOrder: 1,
        zIndex: 1
    },
    {
        id: 'steam-shower-controls',
        parentCategoryId: null,
        menuName: 'Controls',
        title: 'Steam Shower Controls',
        subtitle: 'Select the right Control Series for you.',
        shortDescription: null,
        longDescription: null,
        image: null,
        renderMode: 'expanded',
        customRenderer: null,
        isVisible: true,
        allowInCartMultipleProds: false,
        sortOrder: 2,
        zIndex: 2
    },
    {
        id: 'isteamx-touch-screen-controls',
        parentCategoryId: 'steam-shower-controls',
        menuName: 'iSteamX Touch Screen Control',
        title: 'iSteamX Touch Screen Control',
        subtitle: 'MrSteam’s complete control packages simplify your choices and save you money! You can select a steam control and options à la carte, but our Control Packages make it so simple.',
        shortDescription: null,
        longDescription: 'If swipe screen functionality (like a smart phone), is what you want along with the ability to add music, chroma and aroma therapies, then the iSteam controls is for you',
        image: 'ISTEAMXBKPC.jpg',
        renderMode: 'compact',
        customRenderer: null,
        isVisible: true,
        allowInCartMultipleProds: false,
        sortOrder: 3,
        zIndex: 3
    },
    {
        id: 'airtempo-wireless-controls',
        parentCategoryId: 'steam-shower-controls',
        menuName: 'AirTempo Wireless Control',
        title: 'AirTempo Wireless Control',
        subtitle: 'MrSteam’s complete control packages simplify your choices and save you money! You can select a steam control and options à la carte, but our Control Packages make it so simple.',
        shortDescription: null,
        longDescription: 'If wireless, surface mount (on any surface, even glass), easy installation and LCD display suits your home spa needs, then AirTempo is the right choice',
        image: 'AirTempo-Black.jpg',
        renderMode: 'compact',
        customRenderer: null,
        isVisible: true,
        allowInCartMultipleProds: false,
        sortOrder: 3,
        zIndex: 3
    },
    {
        id: 'itempo-plus-controls',
        parentCategoryId: 'steam-shower-controls',
        menuName: 'iTempo Plus',
        title: 'iTempo Plus Control',
        subtitle: 'MrSteam’s complete control packages simplify your choices and save you money! You can select a steam control and options à la carte, but our Control Packages make it so simple.',
        shortDescription: null,
        longDescription: 'If you want to activate your steam shower with the press of button and a wide variety of finishes, iTempo is for you',
        image: 'iTempo-Square.jpg',
        renderMode: 'compact',
        customRenderer: null,
        isVisible: true,
        allowInCartMultipleProds: false,
        sortOrder: 3,
        zIndex: 3
    },
    {
        id: 'itempo-controls',
        parentCategoryId: 'steam-shower-controls',
        menuName: 'iTempo',
        title: 'iTempo Control',
        subtitle: 'MrSteam’s complete control packages simplify your choices and save you money! You can select a steam control and options à la carte, but our Control Packages make it so simple.',
        shortDescription: null,
        longDescription: 'If you want to activate your steam shower with the press of button and a wide variety of finishes, iTempo is for you',
        image: 'itempopc.jpg',
        renderMode: 'compact',
        customRenderer: null,
        isVisible: true,
        allowInCartMultipleProds: false,
        sortOrder: 4,
        zIndex: 4
    },
    {
        id: 'controls-accessories',
        parentCategoryId: 'steam-shower-controls',
        menuName: 'Control Accessories',
        title: 'Control Accessories',
        subtitle: 'Steam Bath Accessories à la Carte',
        shortDescription: null,
        longDescription: null,
        image: null,
        renderMode: 'expanded',
        customRenderer: null,
        isVisible: false,
        allowInCartMultipleProds: true,
        sortOrder: 4,
        zIndex: 4
    },
    {
        id: 'controls-accessories-2',
        parentCategoryId: 'steam-shower-controls',
        menuName: 'Control Accessories',
        title: 'Control Accessories',
        subtitle: 'Steam Bath Accessories à la Carte',
        shortDescription: null,
        longDescription: null,
        image: null,
        renderMode: 'expanded',
        customRenderer: null,
        isVisible: false,
        allowInCartMultipleProds: true,
        sortOrder: 5,
        zIndex: 5
    },
    {
        id: 'options-and-accessories',
        parentCategoryId: null,
        menuName: 'Accessories',
        title: null,
        subtitle: null,
        shortDescription: null,
        longDescription: null,
        image: null,
        renderMode: 'expanded',
        customRenderer: null,
        isVisible: true,
        allowInCartMultipleProds: true,
        sortOrder: 6,
        zIndex: 6
    },
    {
        id: 'spa-therapies',
        parentCategoryId: 'options-and-accessories',
        menuName: 'Spa Therapies',
        title: 'Spa Therapies',
        subtitle: 'Individual Spa Upgrades',
        shortDescription: null,
        longDescription: null,
        image: null,
        renderMode: 'expanded',
        customRenderer: null,
        isVisible: true,
        allowInCartMultipleProds: true,
        sortOrder: 7,
        zIndex: 7
    },
    {
        id: 'accessories',
        parentCategoryId: 'options-and-accessories',
        menuName: 'Accessories',
        title: 'Accessories',
        subtitle: 'Select accessories',
        shortDescription: 'Enhance your spa like shower by adding customized light fixtures, shower seats and essential chakra oils.',
        longDescription: null,
        image: null,
        renderMode: 'expanded',
        customRenderer: null,
        isVisible: true,
        allowInCartMultipleProds: true,
        sortOrder: 8,
        zIndex: 8
    },
    {
        id: 'towel-warmers',
        parentCategoryId: null,
        menuName: 'Towel Warmers',
        title: 'Towel Warmers',
        subtitle: 'Select Towel Warmer Series',
        shortDescription: null,
        longDescription: null,
        image: null,
        renderMode: 'expanded',
        customRenderer: null,
        isVisible: true,
        allowInCartMultipleProds: true,
        sortOrder: 10,
        zIndex: 10
    },
    {
        id: 'towel-warmers-200',
        parentCategoryId: 'towel-warmers',
        menuName: 'Broadway',
        title: 'Broadway',
        subtitle: 'Series 200 Electric Heated Towel Warmers',
        shortDescription: 'Broadway Collection is unique and affordable, combining beautiful aesthetic curves with built in aromatherapy oil well and innovative accessories to enhance your spa experience',
        longDescription: 'Broadway Collection is unique and affordable, combining beautiful aesthetic curves with built in aromatherapy oil well and innovative accessories to enhance your spa experience',
        image: "Towel-Warmers-200.jpg",
        renderMode: 'compact',
        customRenderer: null,
        isVisible: true,
        allowInCartMultipleProds: false,
        sortOrder: 11,
        zIndex: 11
    },
    {
        id: 'towel-warmers-300',
        parentCategoryId: 'towel-warmers',
        menuName: 'Metro',
        title: 'Metro',
        subtitle: 'Stainless Steel Series 300 Towel Warmers',
        shortDescription: 'Metro Collection offers a minimalistic design in Stainless Steel Finish with Aromathearpy Oil Well',
        longDescription: 'Metro Collection offers a minimalistic design in Stainless Steel Finish with Aromathearpy Oil Well',
        image: "Towel-Warmers-300.jpg",
        renderMode: 'compact',
        customRenderer: null,
        isVisible: true,
        allowInCartMultipleProds: false,
        sortOrder: 12,
        zIndex: 12
    },
    {
        id: 'towel-warmers-800',
        parentCategoryId: 'towel-warmers',
        menuName: 'Tribeca',
        title: 'Tribeca',
        subtitle: '800 series towel warmers',
        shortDescription: 'This towel warmer collection is properly named after the very hip and trendy art inspired streets of Tribeca NYC. This inspired collection will catch the eye, warm the heart, soothe the body, and leave you in a warm embrace.',
        longDescription: 'This towel warmer collection is properly named after the very hip and trendy art inspired streets of Tribeca NYC. This inspired collection will catch the eye, warm the heart, soothe the body, and leave you in a warm embrace.',
        image: "Towel-Warmers-800.jpg",
        renderMode: 'compact',
        customRenderer: null,
        isVisible: true,
        allowInCartMultipleProds: false,
        sortOrder: 13,
        zIndex: 13
    },
    {
        id: 'towel-warmers-500',
        parentCategoryId: 'towel-warmers',
        menuName: 'Lexington',
        title: 'Lexington',
        subtitle: '500-600 series towel warmers',
        shortDescription: 'Lexington Collection Wall Mounted Electric Towel Warmer with Digital Timer in Stainless Steel Polished and Brushed Stainless Steel ',
        longDescription: 'Lexington Collection Wall Mounted Electric Towel Warmer with Digital Timer in Stainless Steel Polished and Brushed Stainless Steel  ',
        image: "WX41.jpg",
        renderMode: 'compact',
        customRenderer: null,
        isVisible: false,
        allowInCartMultipleProds: false,
        sortOrder: 14,
        zIndex: 14
    },
    {
        id: 'towel-warmers-accessories',
        parentCategoryId: 'towel-warmers',
        menuName: 'Towel Warmers Accessories',
        title: 'Towel Warmers Accessories',
        subtitle: 'Select towel Warmers Accessories',
        longDescription: null,
        shortDescription: null,
        image: null,
        renderMode: 'expanded',
        customRenderer: null,
        isVisible: false,
        allowInCartMultipleProds: true,
        sortOrder: 14,
        zIndex: 14
    }
];


/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var catalog_actions_1 = __webpack_require__(436);
var debug, debugOff = function () {
    var any = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        any[_i] = arguments[_i];
    }
};
"production" !== 'production' && (debug = __webpack_require__(4)('app:SummaryPageCmp'));
exports.CatalogReducer = function (state, action) {
    var newState;
    switch (action.type) {
        case catalog_actions_1.SELECT_PRODUCT_CATEGORY:
            var payload = action.payload;
            if (payload.id !== undefined) {
                payload = payload.id;
            }
            newState = Object.assign({}, state, { currentCategoryId: payload });
            return newState;
        case catalog_actions_1.SELECT_PRODUCT:
            newState = state;
            return newState;
        case catalog_actions_1.SELECT_RENDER_MODE:
            newState = Object.assign({}, state, { renderMode: action.payload });
            return newState;
        default:
            return state;
    }
};


/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var Ps = __webpack_require__(106);
var debug, debugOff = function () {
    var any = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        any[_i] = arguments[_i];
    }
};
"production" !== 'production' && (debug = __webpack_require__(4)('app:ModalCmp'));
var AlertCmp = (function () {
    function AlertCmp(_elementRef) {
        this._elementRef = _elementRef;
        this.modalElemIsVisible = false;
        this.modalElemIsRendered = false;
        this.modalClosed = new core_1.EventEmitter();
        this._modalElement = null;
        this._modalElement = _elementRef.nativeElement;
    }
    AlertCmp.prototype.onResize = function (event) {
        this._modalElement !== null && Ps.update(this._modalElement);
    };
    AlertCmp.prototype.ngOnInit = function () {
    };
    AlertCmp.prototype.ngOnChanges = function (changes) {
        if (changes.modalIsVisible.currentValue === true) {
            this._fadeInModal();
        }
        else {
            this._fadeOutModal();
        }
    };
    AlertCmp.prototype.ngOnDestroy = function () {
        Ps.destroy(this._modalElement);
    };
    AlertCmp.prototype._openModal = function () {
        var self = this;
        Ps.initialize(self._modalElement, {
            minScrollbarLength: 30
        });
    };
    AlertCmp.prototype._closeModal = function () {
        this._fadeOutModal();
    };
    AlertCmp.prototype._fadeInModal = function () {
        debugOff('Fade in modal');
        var self = this;
        this.modalElemIsRendered = true;
        setTimeout(function () { return self.modalElemIsVisible = true; }, 0);
    };
    AlertCmp.prototype._fadeOutModal = function () {
        debugOff('Fade out modal');
        var self = this;
        this.modalElemIsVisible = false;
        setTimeout(function () {
            self.modalElemIsRendered = false;
        }, 300);
    };
    return AlertCmp;
}());
__decorate([
    core_1.HostBinding('class.visible'),
    __metadata("design:type", Boolean)
], AlertCmp.prototype, "modalElemIsVisible", void 0);
__decorate([
    core_1.HostBinding('class.rendered'),
    __metadata("design:type", Boolean)
], AlertCmp.prototype, "modalElemIsRendered", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], AlertCmp.prototype, "modalIsVisible", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", Object)
], AlertCmp.prototype, "modalClosed", void 0);
__decorate([
    core_1.HostListener('window:resize', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AlertCmp.prototype, "onResize", null);
AlertCmp = __decorate([
    core_1.Component({
        selector: 'alert-cmp',
        template: __webpack_require__(858),
        styles: [String(__webpack_require__(1147))],
        host: { class: 'modal-alert' }
    }),
    __metadata("design:paramtypes", [core_1.ElementRef])
], AlertCmp);
exports.AlertCmp = AlertCmp;


/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var app_service_1 = __webpack_require__(23);
var app_catalog_service_1 = __webpack_require__(62);
var cart_service_1 = __webpack_require__(35);
var navigation_service_1 = __webpack_require__(81);
var debug, debugOff = function () {
    var any = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        any[_i] = arguments[_i];
    }
};
"production" !== 'production' && (debug = __webpack_require__(4)('app:NavigationMenuCmp'));
var Ps = __webpack_require__(106);
var NavigationMenuCmp = (function () {
    function NavigationMenuCmp(_elementRef, _appCatalogService, _cartService, _navigationService, _appService) {
        this._elementRef = _elementRef;
        this._appCatalogService = _appCatalogService;
        this._cartService = _cartService;
        this._navigationService = _navigationService;
        this._appService = _appService;
        this._state = {
            catalog: {},
            app: {}
        };
        this._navigationMenuElement = _elementRef.nativeElement;
    }
    NavigationMenuCmp.prototype.onResize = function (event) {
        Ps.update(this._navigationMenuElement);
    };
    NavigationMenuCmp.prototype.ngOnInit = function () {
        Ps.initialize(this._navigationMenuElement, {
            minScrollbarLength: 30
        });
    };
    NavigationMenuCmp.prototype.onClick = function (event) {
        if (!this._navigationMenuElement.contains(event.target) &&
            !event.target.classList.contains('navigation-cart')) {
            this._appService.hideNavigationMenu();
        }
    };
    return NavigationMenuCmp;
}());
__decorate([
    core_1.HostListener('window:resize', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], NavigationMenuCmp.prototype, "onResize", null);
NavigationMenuCmp = __decorate([
    core_1.Component({
        selector: 'navigation-menu-cmp',
        template: __webpack_require__(859),
        styles: [String(__webpack_require__(1148))],
        host: {
            id: 'navigation-menu',
            class: 'navigation-menu',
            '(document:click)': 'onClick($event)'
        }
    }),
    __metadata("design:paramtypes", [core_1.ElementRef,
        app_catalog_service_1.AppCatalogService,
        cart_service_1.CartService,
        navigation_service_1.NavigationService,
        app_service_1.AppService])
], NavigationMenuCmp);
exports.NavigationMenuCmp = NavigationMenuCmp;


/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var app_service_1 = __webpack_require__(23);
var cart_service_1 = __webpack_require__(35);
var generators_service_1 = __webpack_require__(99);
var navigation_service_1 = __webpack_require__(81);
var app_catalog_service_1 = __webpack_require__(62);
var debug, debugOff = function () {
    var any = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        any[_i] = arguments[_i];
    }
};
"production" !== 'production' && (debug = __webpack_require__(4)('app:OptionsMenuCmp'));
var Ps = __webpack_require__(106);
var OptionsMenuCmp = (function () {
    function OptionsMenuCmp(_elementRef, _appService, _cartService, _navigationService, _generatorsService, _appCatalogService) {
        this._elementRef = _elementRef;
        this._appService = _appService;
        this._cartService = _cartService;
        this._navigationService = _navigationService;
        this._generatorsService = _generatorsService;
        this._appCatalogService = _appCatalogService;
        this._optionsMenuElement = null;
        this._optionsMenuElement = _elementRef.nativeElement;
    }
    OptionsMenuCmp.prototype.onResize = function (event) {
        Ps.update(this._optionsMenuElement);
    };
    OptionsMenuCmp.prototype.ngOnInit = function () {
        Ps.initialize(this._optionsMenuElement, {
            minScrollbarLength: 30
        });
    };
    OptionsMenuCmp.prototype.onClick = function (event) {
        if (!this._optionsMenuElement.contains(event.target) &&
            !event.target.classList.contains('options-menu')) {
            this._appService.hideOptionsMenu();
        }
    };
    return OptionsMenuCmp;
}());
__decorate([
    core_1.HostListener('window:resize', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], OptionsMenuCmp.prototype, "onResize", null);
OptionsMenuCmp = __decorate([
    core_1.Component({
        selector: 'options-menu-cmp',
        template: __webpack_require__(860),
        styles: [String(__webpack_require__(1149))],
        host: {
            id: 'options-menu',
            class: 'options-menu',
            '(document:click)': 'onClick($event)'
        }
    }),
    __metadata("design:paramtypes", [core_1.ElementRef,
        app_service_1.AppService,
        cart_service_1.CartService,
        navigation_service_1.NavigationService,
        generators_service_1.GeneratorsService,
        app_catalog_service_1.AppCatalogService])
], OptionsMenuCmp);
exports.OptionsMenuCmp = OptionsMenuCmp;


/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var app_service_1 = __webpack_require__(23);
var navigation_service_1 = __webpack_require__(81);
var app_catalog_service_1 = __webpack_require__(62);
var debug, debugOff = function () {
    var any = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        any[_i] = arguments[_i];
    }
};
"production" !== 'production' && (debug = __webpack_require__(4)('app:QuickMenuCmp'));
var QuickMenuCmp = (function () {
    function QuickMenuCmp(_appService, _navigationService, _appCatalogService) {
        this._appService = _appService;
        this._navigationService = _navigationService;
        this._appCatalogService = _appCatalogService;
        this.quickMenuIsHidden = false;
    }
    QuickMenuCmp.prototype.prevTopCategory = function () {
    };
    QuickMenuCmp.prototype.nextTopCategory = function () {
    };
    QuickMenuCmp.prototype.openNavigationCart = function () {
    };
    QuickMenuCmp.prototype.openOptionsMenu = function () {
    };
    return QuickMenuCmp;
}());
__decorate([
    core_1.HostBinding('class.hidden'),
    __metadata("design:type", Boolean)
], QuickMenuCmp.prototype, "quickMenuIsHidden", void 0);
QuickMenuCmp = __decorate([
    core_1.Component({
        selector: 'quick-menu-cmp',
        template: __webpack_require__(861),
        styles: [String(__webpack_require__(1150))],
        host: { id: 'quick-menu', class: 'quick-menu' }
    }),
    __metadata("design:paramtypes", [app_service_1.AppService,
        navigation_service_1.NavigationService,
        app_catalog_service_1.AppCatalogService])
], QuickMenuCmp);
exports.QuickMenuCmp = QuickMenuCmp;


/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var app_service_1 = __webpack_require__(23);
var debug, debugOff = function () {
    var any = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        any[_i] = arguments[_i];
    }
};
"production" !== 'production' && (debug = __webpack_require__(4)('app:StartArrowCmp'));
var StartArrowCmp = (function () {
    function StartArrowCmp(_appService) {
        this._appService = _appService;
    }
    StartArrowCmp.prototype.ngOnInit = function () {
    };
    StartArrowCmp.prototype.onClick = function (event) {
        debugOff('Start arrow onClick');
        this._appService.hideStartArrow();
    };
    return StartArrowCmp;
}());
StartArrowCmp = __decorate([
    core_1.Component({
        selector: 'start-arrow-cmp',
        template: __webpack_require__(862),
        styles: [String(__webpack_require__(1151))],
        host: {
            class: 'start-arrow',
            '(document:click)': 'onClick($event)'
        }
    }),
    __metadata("design:paramtypes", [app_service_1.AppService])
], StartArrowCmp);
exports.StartArrowCmp = StartArrowCmp;


/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var Ps = __webpack_require__(106);
var debug, debugOff = function () {
    var any = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        any[_i] = arguments[_i];
    }
};
"production" !== 'production' && (debug = __webpack_require__(4)('app:ModalCmp'));
var ModalCmp = (function () {
    function ModalCmp(_elementRef) {
        this._elementRef = _elementRef;
        this.modalElemIsVisible = false;
        this.modalElemIsRendered = false;
        this.modalClosed = new core_1.EventEmitter();
        this._modalElement = null;
        this._modalElement = _elementRef.nativeElement;
    }
    ModalCmp.prototype.onResize = function (event) {
        this._modalElement !== null && Ps.update(this._modalElement);
    };
    ModalCmp.prototype.ngOnInit = function () {
    };
    ModalCmp.prototype.ngOnChanges = function (changes) {
        if (changes.modalIsVisible.currentValue === true) {
            this._fadeInModal();
        }
        else {
            this._fadeOutModal();
        }
    };
    ModalCmp.prototype.ngOnDestroy = function () {
        Ps.destroy(this._modalElement);
    };
    ModalCmp.prototype._openModal = function () {
        var self = this;
        Ps.initialize(self._modalElement, {
            minScrollbarLength: 30
        });
    };
    ModalCmp.prototype._closeModal = function () {
        this._fadeOutModal();
    };
    ModalCmp.prototype._fadeInModal = function () {
        debugOff('Fade in modal');
        var self = this;
        this.modalElemIsRendered = true;
        setTimeout(function () { return self.modalElemIsVisible = true; }, 0);
    };
    ModalCmp.prototype._fadeOutModal = function () {
        debugOff('Fade out modal');
        var self = this;
        this.modalElemIsVisible = false;
        setTimeout(function () {
            self.modalElemIsRendered = false;
        }, 300);
    };
    return ModalCmp;
}());
__decorate([
    core_1.HostBinding('class.visible'),
    __metadata("design:type", Boolean)
], ModalCmp.prototype, "modalElemIsVisible", void 0);
__decorate([
    core_1.HostBinding('class.rendered'),
    __metadata("design:type", Boolean)
], ModalCmp.prototype, "modalElemIsRendered", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], ModalCmp.prototype, "modalIsVisible", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", Object)
], ModalCmp.prototype, "modalClosed", void 0);
__decorate([
    core_1.HostListener('window:resize', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ModalCmp.prototype, "onResize", null);
ModalCmp = __decorate([
    core_1.Component({
        selector: 'modal-cmp',
        template: __webpack_require__(863),
        styles: [String(__webpack_require__(1152))],
        host: { class: 'modal' }
    }),
    __metadata("design:paramtypes", [core_1.ElementRef])
], ModalCmp);
exports.ModalCmp = ModalCmp;


/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var not_found_404_page_cmp_1 = __webpack_require__(437);
var catalog_cmp_1 = __webpack_require__(425);
var summary_cmp_1 = __webpack_require__(426);
exports.ROUTES = [
    {
        path: '',
        redirectTo: '/catalog',
        pathMatch: 'full'
    },
    {
        path: 'catalog',
        component: catalog_cmp_1.CatalogPageCmp
    },
    {
        path: 'catalog/:topCategory',
        component: catalog_cmp_1.CatalogPageCmp
    },
    {
        path: 'summary',
        component: summary_cmp_1.SummaryPageCmp
    },
    {
        path: '**',
        component: not_found_404_page_cmp_1.NotFound404PageCmp
    }
];


/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var ng2_translate_1 = __webpack_require__(161);
var debug, debugOff = function () {
    var any = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        any[_i] = arguments[_i];
    }
};
"production" !== 'production' && (debug = __webpack_require__(4)('app:TranslateService'));
var TranslateService = (function () {
    function TranslateService(_ng2TranslateService) {
        this._ng2TranslateService = _ng2TranslateService;
        this._setupTranslation();
    }
    TranslateService.prototype.instant = function (key, interpolateParams) {
        return this._ng2TranslateService.instant(key, interpolateParams);
    };
    TranslateService.prototype.get = function (key, interpolateParams) {
        return this._ng2TranslateService.get(key, interpolateParams);
    };
    TranslateService.prototype._setupTranslation = function () {
        this._ng2TranslateService.addLangs(['en', 'de']);
        this._ng2TranslateService.setDefaultLang('en');
    };
    return TranslateService;
}());
TranslateService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [ng2_translate_1.TranslateService])
], TranslateService);
exports.TranslateService = TranslateService;


/***/ },
/* 670 */
/***/ function(module, exports) {

"use strict";
"use strict";
exports.appInitialState = {
    app: {
        navigationMenuIsVisible: false,
        startArrowIsVisible: false,
        productDetailsModalIsVisible: false,
        printSummaryModalIsVisible: false,
        emailSummaryModalIsVisible: false,
        alertModalIsVisible: false,
        onlyDropdownIsVisible: false,
        optionsMenuIsVisible: false,
        previewIsVisible: false,
        scrollDownTooltipIsVisible: true,
    },
    catalog: {
        currentCategoryId: 'generators',
        renderMode: 'expanded',
        cartProductsIds: []
    },
    router: {
        path: window.location.pathname + window.location.search
    }
};


/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var app_actions_1 = __webpack_require__(439);
var debug, debugOff = function () {
    var any = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        any[_i] = arguments[_i];
    }
};
"production" !== 'production' && (debug = __webpack_require__(4)('app:SummaryPageCmp'));
exports.AppReducer = function (state, action) {
    var newState;
    switch (action.type) {
        case app_actions_1.DISPLAY_NAVIGATION_MENU:
            newState = Object.assign({}, state, { navigationMenuIsVisible: true });
            return newState;
        case app_actions_1.HIDE_NAVIGATION_MENU:
            newState = Object.assign({}, state, { navigationMenuIsVisible: false });
            return newState;
        case app_actions_1.DISPLAY_START_ARROW:
            newState = Object.assign({}, state, { startArrowIsVisible: true });
            return newState;
        case app_actions_1.HIDE_START_ARROW:
            newState = Object.assign({}, state, { startArrowIsVisible: false });
            return newState;
        case app_actions_1.DISPLAY_PRODUCT_DETAILS_MODAL:
            newState = Object.assign({}, state, { productDetailsModalIsVisible: true });
            return newState;
        case app_actions_1.HIDE_PRODUCT_DETAILS_MODAL:
            newState = Object.assign({}, state, { productDetailsModalIsVisible: false });
            return newState;
        case app_actions_1.DISPLAY_PRINT_SUMMARY_MODAL:
            newState = Object.assign({}, state, { printSummaryModalIsVisible: true });
            return newState;
        case app_actions_1.HIDE_PRINT_SUMMARY_MODAL:
            newState = Object.assign({}, state, { printSummaryModalIsVisible: false });
            return newState;
        case app_actions_1.DISPLAY_EMAIL_SUMMARY_MODAL:
            newState = Object.assign({}, state, { emailSummaryModalIsVisible: true });
            return newState;
        case app_actions_1.HIDE_EMAIL_SUMMARY_MODAL:
            newState = Object.assign({}, state, { emailSummaryModalIsVisible: false });
            return newState;
        case app_actions_1.DISPLAY_ALERT_MODAL:
            newState = Object.assign({}, state, { alertModalIsVisible: true });
            return newState;
        case app_actions_1.HIDE_ALERT_MODAL:
            newState = Object.assign({}, state, { alertModalIsVisible: false });
            return newState;
        case app_actions_1.DISPLAY_ONLY_DROPDOWN:
            newState = Object.assign({}, state, { onlyDropdownIsVisible: true });
            return newState;
        case app_actions_1.DISPLAY_ALL_CONTENT:
            newState = Object.assign({}, state, { onlyDropdownIsVisible: false });
            return newState;
        case app_actions_1.DISPLAY_OPTIONS_MENU:
            newState = Object.assign({}, state, { optionsMenuIsVisible: true });
            return newState;
        case app_actions_1.HIDE_OPTIONS_MENU:
            newState = Object.assign({}, state, { optionsMenuIsVisible: false });
            return newState;
        case app_actions_1.DISPLAY_PREVIEW:
            newState = Object.assign({}, state, { previewIsVisible: true });
            return newState;
        case app_actions_1.HIDE_PREVIEW:
            newState = Object.assign({}, state, { previewIsVisible: false });
            return newState;
        default:
            return state;
    }
};


/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var router_store_1 = __webpack_require__(637);
var app_reducer_1 = __webpack_require__(671);
var catalog_reducer_1 = __webpack_require__(661);
exports.AppReducers = {
    router: router_store_1.routerReducer,
    app: app_reducer_1.AppReducer,
    catalog: catalog_reducer_1.CatalogReducer,
};


/***/ },
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(14)();
// imports


// module
exports.push([module.i, ".ps-container{-ms-touch-action:auto;touch-action:auto;overflow:hidden!important;-ms-overflow-style:none}@supports (-ms-overflow-style:none){.ps-container{overflow:auto!important}}@media (-ms-high-contrast:none),screen and (-ms-high-contrast:active){.ps-container{overflow:auto!important}}.ps-container.ps-active-x>.ps-scrollbar-x-rail,.ps-container.ps-active-y>.ps-scrollbar-y-rail{display:block;background-color:transparent}.ps-container.ps-in-scrolling.ps-x>.ps-scrollbar-x-rail{background-color:#eee;opacity:.9}.ps-container.ps-in-scrolling.ps-x>.ps-scrollbar-x-rail>.ps-scrollbar-x{background-color:#999;height:11px}.ps-container.ps-in-scrolling.ps-y>.ps-scrollbar-y-rail{background-color:#eee;opacity:.9}.ps-container.ps-in-scrolling.ps-y>.ps-scrollbar-y-rail>.ps-scrollbar-y{background-color:#999;width:11px}.ps-container>.ps-scrollbar-x-rail{display:none;position:absolute;opacity:0;-webkit-transition:background-color .2s linear,opacity .2s linear;-o-transition:background-color .2s linear,opacity .2s linear;-moz-transition:background-color .2s linear,opacity .2s linear;transition:background-color .2s linear,opacity .2s linear;bottom:0;height:15px}.ps-container>.ps-scrollbar-x-rail>.ps-scrollbar-x{position:absolute;background-color:#aaa;-webkit-border-radius:6px;-moz-border-radius:6px;border-radius:6px;-webkit-transition:background-color .2s linear,height .2s linear,width .2s ease-in-out,-webkit-border-radius .2s ease-in-out;transition:background-color .2s linear,height .2s linear,width .2s ease-in-out,-webkit-border-radius .2s ease-in-out;-o-transition:background-color .2s linear,height .2s linear,width .2s ease-in-out,border-radius .2s ease-in-out;-moz-transition:background-color .2s linear,height .2s linear,width .2s ease-in-out,border-radius .2s ease-in-out,-moz-border-radius .2s ease-in-out;transition:background-color .2s linear,height .2s linear,width .2s ease-in-out,border-radius .2s ease-in-out;transition:background-color .2s linear,height .2s linear,width .2s ease-in-out,border-radius .2s ease-in-out,-webkit-border-radius .2s ease-in-out,-moz-border-radius .2s ease-in-out;bottom:2px;height:6px}.ps-container>.ps-scrollbar-x-rail:active>.ps-scrollbar-x,.ps-container>.ps-scrollbar-x-rail:hover>.ps-scrollbar-x{height:11px}.ps-container>.ps-scrollbar-y-rail{display:none;position:absolute;opacity:0;-webkit-transition:background-color .2s linear,opacity .2s linear;-o-transition:background-color .2s linear,opacity .2s linear;-moz-transition:background-color .2s linear,opacity .2s linear;transition:background-color .2s linear,opacity .2s linear;right:0;width:15px}.ps-container>.ps-scrollbar-y-rail>.ps-scrollbar-y{position:absolute;background-color:#aaa;-webkit-border-radius:6px;-moz-border-radius:6px;border-radius:6px;-webkit-transition:background-color .2s linear,height .2s linear,width .2s ease-in-out,-webkit-border-radius .2s ease-in-out;transition:background-color .2s linear,height .2s linear,width .2s ease-in-out,-webkit-border-radius .2s ease-in-out;-o-transition:background-color .2s linear,height .2s linear,width .2s ease-in-out,border-radius .2s ease-in-out;-moz-transition:background-color .2s linear,height .2s linear,width .2s ease-in-out,border-radius .2s ease-in-out,-moz-border-radius .2s ease-in-out;transition:background-color .2s linear,height .2s linear,width .2s ease-in-out,border-radius .2s ease-in-out;transition:background-color .2s linear,height .2s linear,width .2s ease-in-out,border-radius .2s ease-in-out,-webkit-border-radius .2s ease-in-out,-moz-border-radius .2s ease-in-out;right:2px;width:6px}.ps-container>.ps-scrollbar-y-rail:active>.ps-scrollbar-y,.ps-container>.ps-scrollbar-y-rail:hover>.ps-scrollbar-y{width:11px}.ps-container:hover.ps-in-scrolling.ps-x>.ps-scrollbar-x-rail{background-color:#eee;opacity:.9}.ps-container:hover.ps-in-scrolling.ps-x>.ps-scrollbar-x-rail>.ps-scrollbar-x{background-color:#999;height:11px}.ps-container:hover.ps-in-scrolling.ps-y>.ps-scrollbar-y-rail{background-color:#eee;opacity:.9}.ps-container:hover.ps-in-scrolling.ps-y>.ps-scrollbar-y-rail>.ps-scrollbar-y{background-color:#999;width:11px}.ps-container:hover>.ps-scrollbar-x-rail,.ps-container:hover>.ps-scrollbar-y-rail{opacity:.6}.ps-container:hover>.ps-scrollbar-x-rail:hover{background-color:#eee;opacity:.9}.ps-container:hover>.ps-scrollbar-x-rail:hover>.ps-scrollbar-x{background-color:#999}.ps-container:hover>.ps-scrollbar-y-rail:hover{background-color:#eee;opacity:.9}.ps-container:hover>.ps-scrollbar-y-rail:hover>.ps-scrollbar-y{background-color:#999}", ""]);

// exports


/***/ },
/* 817 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(14)();
// imports


// module
exports.push([module.i, "#content{top:0;left:338px;width:calc(100% - 338px);height:100vh;overflow:hidden;transform:translateZ(0)}#content,#content .return{position:absolute;transition:.3s}#content .return{top:30px;left:90px;color:#fff;font-weight:700;padding:3px 0 0 40px;opacity:0;pointer-events:none;cursor:pointer;height:27px;background:url(/assets/images/arrow-right-large.png) no-repeat;background-position:0 0;text-transform:uppercase}#content .return:hover{padding-left:60px;background-position:20px 0}#content .return.active{opacity:1;pointer-events:all}.scroll-down{position:fixed;color:#fff;top:calc(100vh - 100px);left:calc(50vw - 338px / 2);width:50px;height:50px;opacity:0;transition:.3s;font-size:.9em;text-align:center;background-image:url(/assets/images/arrow-down-big.png);background-repeat:no-repeat;z-index:10;cursor:pointer}.scroll-down.active{opacity:1}@media (min-width:1800px){#content{width:calc(100% - 418px);left:418px}}@media (min-width:1600px) and (max-width:1799px){#content{width:calc(100% - 398px);left:398px}}@media (max-width:900px){#content{left:0;width:100%}.scroll-down{left:50vw}}@media (max-width:680px){#content{height:calc(100vh - 60px);top:60px}}", ""]);

// exports


/***/ },
/* 818 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(14)();
// imports


// module
exports.push([module.i, ".catalog-page{position:absolute;height:100%;width:100%;top:0;left:0;opacity:0;display:none;pointer-events:none;transition:.3s;transform:translateZ(0)}.catalog-page.rendered{display:block}.catalog-page.visible{opacity:1;pointer-events:all}.catalog-page .content .summary-link-div{text-align:center;background:hsla(0,0%,100%,.5);padding:120px 90px}@media (max-width:680px){.catalog-page #products{padding:30px 10px}.catalog-page .button.big{font-size:1.3em;background-position:30px 17px}}", ""]);

// exports


/***/ },
/* 819 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(14)();
// imports


// module
exports.push([module.i, ".summary-page{position:absolute;overflow:hidden;height:100%;width:100%;top:0;left:0;background:hsla(0,0%,100%,.9);padding:60px 90px;box-sizing:border-box;opacity:0;pointer-events:none;transition:opacity .3s;display:none;transform:translateZ(0)/*!* GENERATOR *!*/}.summary-page.rendered{display:block}.summary-page.visible{opacity:1;pointer-events:all}.summary-page .return{position:absolute!important;top:30px!important;left:90px!important;color:#4ec2ff!important;font-weight:700!important;padding:3px 0 0 40px!important;transition:.3s!important;cursor:pointer!important;height:27px!important;background:url(/assets/images/arrow-right-large-hover.png) no-repeat!important;background-position:0 0!important}.summary-page .return:hover{padding-left:60px!important;background-position:20px 0!important;color:#4ec2ff!important}.summary-page .return .title{font-size:2.4em;margin:80px 0 10px;line-height:1em}.summary-page #generator{margin:0 0 30px}.summary-page #generator .title{font-size:2.4em;margin:10px 0;line-height:1em}.summary-page .title.labeled{margin:0}.summary-page .title-label{font-size:.9em;font-weight:300;padding:0;margin:0}.summary-page .title-label .link{font-weight:500}.summary-page .title#generator-title{font-size:2.8em;margin:0 0 18px}.summary-page .title sup{font-size:.5em}.summary-page .subtitle{font-size:1.25em;font-weight:300;border-top:1px solid rgba(0,0,0,.2);margin:0;padding:4px 0}.summary-page .half{width:50%}.summary-page #generator .subtitle{font-size:1.25em;font-weight:300;border-top:none;margin:0;padding:4px 0}.summary-page .divider{border-top:1px solid hsla(0,0%,100%,.2)}.summary-page #generator .subtitle-label,.summary-page .subtitle-label{margin:0 0 20px;padding:0;font-size:.9em;font-weight:300;color:#555}.summary-page #summary-title{font-size:2.8em;margin:0 0 18px}.summary-page .subtitle.spaced{padding:20px 0 0;margin:20px 0}.summary-page .header .subtitle{margin:0 0 20px;border:none}.summary-page .header .column{width:50%;box-sizing:border-box;padding:20px 10px}.summary-page .specs .row{border-top:1px solid rgba(0,0,0,.2);margin:4px 0;padding:4px 0 0}.summary-page .specs .label{width:50%;text-transform:uppercase;font-weight:600;font-size:.9em;color:#999}.summary-page .specs .value{width:50%}.summary-page .divider{border:0;border-top:1px solid rgba(0,0,0,.2);margin:30px 0}.summary-page .link{cursor:pointer;transition:.2s;color:#1496d8;display:block}.summary-page .link:hover{color:#4ec2ff}.summary-page .menu{font-weight:300;margin:0;padding-top:0!important;padding-left:50px!important}.summary-page .menu .link{margin:20px 0 0;padding:0 0 0 40px;background-repeat:no-repeat;background-position:0 0}.summary-page .print{background-image:url(/assets/images/print-black.png)}.summary-page .save{background-image:url(/assets/images/save-black.png)}.summary-page .email{background-image:url(/assets/images/email-black.png)}.summary-page .dealer{background-image:url(/assets/images/locator-black.png)}.summary-page .restart{background-image:url(/assets/images/restart-black.png)}.summary-page .print:hover{background-image:url(/assets/images/print-hover.png)}.summary-page .save:hover{background-image:url(/assets/images/save-hover.png)}.summary-page .email:hover{background-image:url(/assets/images/email-hover.png)}.summary-page .dealer:hover{background-image:url(/assets/images/locator-hover.png)}.summary-page .restart:hover{background-image:url(/assets/images/restart-hover.png)}.summary-page .tagline{font-size:.9em;font-weight:400}.summary-page .phone{font-size:1.3em;font-weight:400}.summary-page .subscribe{font-size:.8em;font-weight:400;padding:0 0 0 20px;margin:10px 0 0;color:#04a4cc}.summary-page .subscribe,.summary-page .subscribe:hover{background:url(/assets/images/arrow-right.png) no-repeat 0 2px}.summary-page .price-label{text-transform:uppercase;font-weight:300;font-size:1.1em;margin:0}.summary-page .price{font-weight:600;font-size:2.8em}.summary-page #contact-dealer{margin:80px 0 100px}.summary-page #generator{opacity:0;transition:.3s}.summary-page #generator.active{opacity:1}.summary-page #generator .details{margin:20px 0 0}.summary-page #generator .column{width:50%}.summary-page #generator .image{text-align:center}.summary-page #generator .image img{height:300px;width:auto}.summary-page .ps-container>.ps-scrollbar-y-rail>.ps-scrollbar-y{width:11px}.summary-page .ps-container.ps-in-scrolling.ps-x>.ps-scrollbar-x-rail>.ps-scrollbar-x,.summary-page .ps-container.ps-in-scrolling.ps-y>.ps-scrollbar-y-rail>.ps-scrollbar-y,.summary-page .ps-container:hover.ps-in-scrolling.ps-x>.ps-scrollbar-x-rail>.ps-scrollbar-x,.summary-page .ps-container:hover.ps-in-scrolling.ps-y>.ps-scrollbar-y-rail>.ps-scrollbar-y,.summary-page .ps-container:hover>.ps-scrollbar-x-rail:hover>.ps-scrollbar-x,.summary-page .ps-container:hover>.ps-scrollbar-y-rail:hover>.ps-scrollbar-y,.summary-page .ps-container>.ps-scrollbar-y-rail>.ps-scrollbar-y{background-color:#7e7e7e}.summary-page>*>*>ul{padding:0 10px 0 0;list-style:none;font-size:.9em}.summary-page>*>*>ul li{padding:10px 0 0 20px;list-style:none;background:url(/assets/images/arrow-right-black.png) no-repeat 7px 15px}@media (min-width:901px) and (max-width:1200px){.summary-page .half{width:100%}}@media (min-width:681px) and (max-width:900px){.summary-page .half{width:100%}}@media (max-width:900px){.summary-page .return{opacity:1!important;pointer-events:all!important}}@media (max-width:680px){.summary-page{padding:30px 10px}.summary-page .half{width:100%}.summary-page .options{display:none}.summary-page .return{top:20px;left:20px}}@media (max-width:480px){.summary-page .button.big{font-size:1.5em;background-position:30px 19px}.summary-page .half .column{width:100%}}", ""]);

// exports


/***/ },
/* 820 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(14)();
// imports


// module
exports.push([module.i, ".generator-configurator{display:block;color:#fff;min-height:100vh;background:rgba(52,129,170,.8);background:rgba(52,129,170,.3);padding:60px 90px;box-sizing:border-box;transform:translateZ(0)}.generator-configurator .tooltip:after,.generator-configurator [data-tooltip]:after{width:300px}.generator-configurator .tooltip-top:after,.generator-configurator .tooltip:after,.generator-configurator [data-tooltip]:after{margin-left:-150px;text-align:justify}.generator-configurator #generators-title-label{overflow:hidden;opacity:1;transition:.3s}.generator-configurator #generators-title-label.collapsed{height:0!important;margin:0;padding:0;opacity:0}.generator-configurator #generators-subtitle{height:48px;overflow:hidden;transition:.3s}.generator-configurator #generators-subtitle.collapsed{height:0;margin:0;padding:0;opacity:0;border-top:1px solid hsla(0,0%,100%,0)}.generator-configurator .title{font-size:2.7em;margin:20px 0;line-height:1em;padding-bottom:0;border-bottom:0 solid transparent}.generator-configurator .title.labeled{margin:0}.generator-configurator .title-label{font-size:.9em;font-weight:300;padding:0;margin:0}.generator-configurator .title#generator-title{font-size:2.8em;margin:0 0 18px}.generator-configurator .title sup{font-size:.5em}.generator-configurator .subtitle{font-size:1.25em;font-weight:300;border-top:1px solid rgba(0,0,0,.2);padding:20px 0 0;margin:20px 0;border-top:1px solid hsla(0,0%,100%,.2)}.generator-configurator .subtitle.labeled{margin-bottom:0}.generator-configurator .subtitle-label{font-size:.8em;font-weight:300;padding:0;margin:0}.generator-configurator .divider{border:0;border-top:1px solid hsla(0,0%,100%,.2);margin:30px 0}.generator-configurator .calculator-inputs{margin:40px 0 0}.generator-configurator .calculator-inputs.collapsed{margin:0}.generator-configurator .input-group{margin:0 30px 8px 0;float:left;height:100px}.generator-configurator .input-label{font-size:1.1em;font-weight:700;text-transform:uppercase;margin:0 0 7px}.generator-configurator .input-label.valid{color:#d5f9ba}.generator-configurator .input-label.error{color:#e35e5e}.generator-configurator .collapsed .input-label{font-size:.9em;font-weight:300;text-transform:none}.generator-configurator .dimensions{font-size:1.2em;background:transparent;border-radius:4px;border:3px solid #fff;height:55px;width:45px;color:#fff;padding:0 10px;outline:none}.generator-configurator .collapsed .dimensions{border:1px solid hsla(0,0%,100%,.3);height:45px}.generator-configurator .input-wrapper.left>.dimensions{border-right-width:1px;border-top-right-radius:0;border-bottom-right-radius:0}.generator-configurator .input-wrapper.right>.dimensions{border-left-width:0!important;border-top-left-radius:0;border-bottom-left-radius:0}.generator-configurator .dimensions::-webkit-input-placeholder{color:hsla(0,0%,100%,.7)}.generator-configurator .dimensions:-moz-placeholder,.generator-configurator .dimensions::-moz-placeholder{color:hsla(0,0%,100%,.7)}.generator-configurator .dimensions:-ms-input-placeholder{color:hsla(0,0%,100%,.7)}.generator-configurator .measurement-system{margin:35px 0 0}.generator-configurator .description{opacity:0;transition:.3s;pointer-events:none}.generator-configurator .description.active{opacity:1;pointer-events:all}.generator-configurator .description .details{margin:20px 0 0}.generator-configurator .description .column{width:50%}.generator-configurator .description .image{text-align:center}.generator-configurator .dimensions-exceeded{text-align:center;margin:50px 0 0}.generator-configurator .dimensions-exceeded .text{font-weight:300;font-size:1.1em;text-align:center}.generator-configurator .dimensions-exceeded .phone{font-weight:600;font-size:1.5em;text-align:center}.generator-configurator .dimensions-exceeded .pho-num-label{font-weight:400;font-size:.9em}.generator-configurator .skip .button{background-color:#135b80}.generator-configurator .skip .button:hover{background-color:#4ec2ff}.generator-configurator .material .dimensions{width:270px;overflow:hidden;white-space:nowrap;font-size:1em;padding:16px 0 0 10px;height:39px;cursor:pointer;background-image:url(/assets/images/arrow-down-medium.png);background-repeat:no-repeat;background-position:245px 22px}.generator-configurator .collapsed .material .dimensions{padding-top:10px;height:35px;background-position:245px 18px}.generator-configurator .dropdown{position:relative}.generator-configurator .dropdown .options{position:absolute;top:0;left:0;opacity:0;pointer-events:none;transition:.2s;background:#fff;border-radius:4px;color:#333;width:100%}.generator-configurator .dropdown .options.active{opacity:1;pointer-events:all}.generator-configurator .dropdown .option{padding:10px;cursor:pointer;border-bottom:1px solid #eee}.generator-configurator .dropdown .option:last-of-type{border:0}.generator-configurator .dropdown .option:hover{background:#f7f7f7;color:#4ec2ff}.generator-configurator .tabs .tab{height:20px;width:100px;padding:10px;cursor:pointer;border-bottom:1px solid #fff;border-top:1px solid transparent;border-left:0 solid transparent;border-right:0 solid transparent;color:#fff;transition:background .2s}.generator-configurator .tabs .tab:hover{background:#fff;color:#4ec2ff}.generator-configurator .tabs .underline{border-bottom:1px solid #fff;height:41px}.generator-configurator .tabs .underline.u1,.generator-configurator .tabs .underline.u2{width:10px}.generator-configurator .tabs .underline.u3{width:10px;width:calc(100% - 262px)}.generator-configurator .tabs .tab.active{border-top:1px solid #fff;border-left:1px solid #fff;border-right:1px solid #fff;border-bottom:1px solid transparent}.generator-configurator .tab-specs{margin-top:20px}.generator-configurator .download-specs{margin-top:25px;background:#135b80}.generator-configurator .input-ft,.generator-configurator .input-in{position:relative}.generator-configurator .input-ft:after,.generator-configurator .input-in:after{display:block;position:absolute;color:#fff;top:17px;right:10px;font-size:1.2em;opacity:.6;pointer-events:none}.generator-configurator .collapsed .input-ft:after,.generator-configurator .collapsed .input-in:after{top:10px}.generator-configurator .input-ft:after{content:\"ft\"}.generator-configurator .input-in:after{content:\"in\"}.generator-configurator>*>*>.details ul{padding:0 10px 0 0;list-style:none;font-size:.9em}.generator-configurator>*>*>.details ul li{padding:10px 0 0 20px;list-style:none;background:url(/assets/images/arrow-right-white.png) no-repeat 7px 15px}@media (min-width:1800px){.generator-configurator .tabs .tab{width:140px;height:27px;padding:10px 20px}.generator-configurator .tabs .underline{height:48px}.generator-configurator .tabs .underline.u3{width:calc(100% - 387px)}.generator-configurator .dimensions{width:65px}.generator-configurator .material .dimensions{width:370px;background-position:345px 22px}.generator-configurator .scroll-down{font-size:.8em;background-position:10px 13px}}@media (min-width:1600px) and (max-width:1799px){.generator-configurator .tabs .tab{width:130px;height:25px;padding:10px 20px}.generator-configurator .tabs .underline{height:46px}.generator-configurator .tabs .underline.u3{width:calc(100% - 372px)}.generator-configurator .dimensions{width:55px}.generator-configurator .material .dimensions{width:320px;background-position:295px 22px}}@media (min-width:901px) and (max-width:1200px){.generator-configurator .description .column{width:100%}.generator-configurator .description .image{margin-bottom:30px}}@media (min-width:681px) and (max-width:900px){.generator-configurator .scroll-down{left:50vw}}@media (max-width:680px){.generator-configurator{padding:30px 10px}.generator-configurator .scroll-down{left:25vw}.generator-configurator .input-group{margin:10px auto;width:calc(100% - 60px);float:none}.generator-configurator .dimensions{width:100%;box-sizing:border-box}.generator-configurator .material .dropdown{width:100%}.generator-configurator .material .dropdown .selected{height:55px;box-sizing:border-box;width:100%;background-position:right 19px top 19px}.generator-configurator .input-wrapper{width:50%}.generator-configurator .description .column{width:100%}.generator-configurator .description .image{margin-bottom:30px}}", ""]);

// exports


/***/ },
/* 821 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(14)();
// imports


// module
exports.push([module.i, ".email-summary{height:100%;width:100%;transition:opacity .3s;transform:translateZ(0)}.email-summary .black-bgr{position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,.75);z-index:1}.email-summary .modal{position:fixed;top:5%;left:12.5%;height:90%;width:75%;z-index:2;background:#fff;padding:60px 90px;box-sizing:border-box;overflow:hidden}.email-summary .close{position:fixed;top:calc(5% + 30px);right:calc(12.5% + 40px);width:40px;height:40px;background-image:url(/assets/images/close-slim-black.png);background-repeat:no-repeat;background-position:50%;z-index:4}.email-summary .close:hover{background-image:url(/assets/images/close-slim-hover.png)}.email-summary .title{font-size:2.4em;margin:80px 0 10px;line-height:1em}.email-summary #generator{margin:0 0 30px}.email-summary #generator .title{font-size:2.4em;margin:10px 0;line-height:1em}.email-summary .title.labeled{margin:0}.email-summary .title-label{font-size:.9em;font-weight:300;padding:0;margin:0}.email-summary .title-label .link{font-weight:500}.email-summary .title#generator-title{font-size:2.8em;margin:0 0 18px}.email-summary .title sup{font-size:.5em}.email-summary .subtitle{font-size:1.25em;font-weight:300;border-top:1px solid rgba(0,0,0,.2);margin:0;padding:4px 0}.email-summary #generator .subtitle{font-size:1.25em;font-weight:300;border-top:none;margin:0;padding:4px 0}.email-summary .divider{border-top:1px solid hsla(0,0%,100%,.2)}.email-summary #generator .subtitle-label,.email-summary .subtitle-label{margin:0 0 20px;padding:0;font-size:.9em;font-weight:300;color:#555}.email-summary #summary-title{font-size:2.8em;margin:0 0 18px}.email-summary .subtitle.spaced{padding:20px 0 0;margin:20px 0}.email-summary .header .subtitle{margin:0 0 20px;border:none}.email-summary .header .column{width:50%;box-sizing:border-box;padding:20px 10px}.email-summary .product .remove,.email-summary .product .remove:hover{visibility:hidden}.email-summary product-options-dropdown-cmp{position:static;display:inline-block;width:auto;padding:0;margin:0}.email-summary .product product-options-dropdown-cmp .selected-option{background-image:none}.email-summary .specs .row{border-top:1px solid rgba(0,0,0,.2);margin:4px 0;padding:4px 0 0}.email-summary .specs .label{width:50%;text-transform:uppercase;font-weight:600;font-size:.9em;color:#999}.email-summary .specs .value{width:50%}.email-summary .divider{border:0;border-top:1px solid rgba(0,0,0,.2);margin:30px 0}.email-summary .link{cursor:pointer;transition:.2s;color:#1496d8}.email-summary .link:hover{color:#4ec2ff}.email-summary .price-label{text-transform:uppercase;font-weight:300;font-size:1.1em;margin:0}.email-summary .price{font-weight:600;font-size:2.8em}.email-summary #contact-dealer{margin:80px 0 100px}.email-summary #generator{opacity:0;transition:.3s}.email-summary #generator.active{opacity:1}.email-summary #generator .details{margin:20px 0 0}.email-summary #generator .column{width:50%}.email-summary #generator .image{text-align:center}.email-summary #generator .image img{height:300px;width:auto}.email-summary .ps-container>.ps-scrollbar-y-rail>.ps-scrollbar-y{width:11px}.email-summary .ps-container.ps-in-scrolling.ps-x>.ps-scrollbar-x-rail>.ps-scrollbar-x,.email-summary .ps-container.ps-in-scrolling.ps-y>.ps-scrollbar-y-rail>.ps-scrollbar-y,.email-summary .ps-container:hover.ps-in-scrolling.ps-x>.ps-scrollbar-x-rail>.ps-scrollbar-x,.email-summary .ps-container:hover.ps-in-scrolling.ps-y>.ps-scrollbar-y-rail>.ps-scrollbar-y,.email-summary .ps-container:hover>.ps-scrollbar-x-rail:hover>.ps-scrollbar-x,.email-summary .ps-container:hover>.ps-scrollbar-y-rail:hover>.ps-scrollbar-y,.email-summary .ps-container>.ps-scrollbar-y-rail>.ps-scrollbar-y{background-color:#7e7e7e}.email-summary .title-clean{font-size:2.4em;margin:0 0 10px;line-height:1em;transform:translateZ(0)}.email-summary .subtitle-clean{font-size:1.25em;font-weight:300;border-top:1px solid rgba(0,0,0,.2);margin:0;padding:4px 0}.email-summary .input,.email-summary .text-area{display:block;margin:10px;padding:10px;border:1px solid rgba(0,0,0,.2);border-radius:4px}.email-summary .text-area{height:150px}.email-summary .text-area.emails{width:calc(30% - 42px)}.email-summary .text-area.note{width:calc(70% - 42px)}.email-summary .button{margin:20px 10px 30px}.email-summary>*>*>ul{padding:0 10px 0 0;list-style:none;font-size:.9em}.email-summary>*>*>ul li{padding:10px 0 0 20px;list-style:none;background:url(/assets/images/arrow-right-black.png) no-repeat 7px 15px}@media (max-width:680px){.email-summary .modal{width:100vw;height:calc(100vh - 60px);top:60px;left:0;transform:translate(0);padding:30px 10px}.email-summary .close{top:70px;right:20px}}", ""]);

// exports


/***/ },
/* 822 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(14)();
// imports


// module
exports.push([module.i, ".print-summary{height:100%;width:100%;transition:opacity .3s;transform:translateZ(0)}.print-summary .black-bgr{position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,.75);z-index:1}.print-summary .modal{position:fixed;top:5%;left:12.5%;height:90%;width:75%;z-index:2;background:#fff;padding:60px 90px;box-sizing:border-box;overflow:hidden}.print-summary .close{position:fixed;top:calc(5% + 30px);right:calc(12.5% + 40px);width:40px;height:40px;background-image:url(/assets/images/close-slim-black.png);background-repeat:no-repeat;background-position:50%;z-index:4}.print-summary .close:hover{background-image:url(/assets/images/close-slim-hover.png)}.print-summary .title{font-size:2.4em;margin:80px 0 10px;line-height:1em}.print-summary #generator{margin:0 0 30px}.print-summary #generator .title{font-size:2.4em;margin:10px 0;line-height:1em}.print-summary .title.labeled{margin:0}.print-summary .title-label{font-size:.9em;font-weight:300;padding:0;margin:0}.print-summary .title-label .link{font-weight:500}.print-summary .title#generator-title{font-size:2.8em;margin:0 0 18px}.print-summary .title sup{font-size:.5em}.print-summary .subtitle{font-size:1.25em;font-weight:300;border-top:1px solid rgba(0,0,0,.2);margin:0;padding:4px 0}.print-summary #generator .subtitle{font-size:1.25em;font-weight:300;border-top:none;margin:0;padding:4px 0}.print-summary .divider{border-top:1px solid hsla(0,0%,100%,.2)}.print-summary #generator .subtitle-label,.print-summary .subtitle-label{margin:0 0 20px;padding:0;font-size:.9em;font-weight:300;color:#555}.print-summary #summary-title{font-size:2.8em;margin:0 0 18px}.print-summary .subtitle.spaced{padding:20px 0 0;margin:20px 0}.print-summary .header .subtitle{margin:0 0 20px;border:none}.print-summary .header .column{width:50%;box-sizing:border-box;padding:20px 10px}.print-summary .product .remove,.print-summary .product .remove:hover{visibility:hidden}.print-summary product-options-dropdown-cmp{position:static;display:inline-block;width:auto;padding:0;margin:0}.print-summary .product product-options-dropdown-cmp .selected-option{background-image:none}.print-summary .specs .row{border-top:1px solid rgba(0,0,0,.2);margin:4px 0;padding:4px 0 0}.print-summary .specs .label{width:49%;text-transform:uppercase;font-weight:600;font-size:.9em;color:#999}.print-summary .specs .value{width:50%}.print-summary .divider{border:0;border-top:1px solid rgba(0,0,0,.2);margin:30px 0}.print-summary .link{cursor:pointer;transition:.2s;color:#1496d8}.print-summary .link:hover{color:#4ec2ff}.print-summary .price-label{text-transform:uppercase;font-weight:300;font-size:1.1em;margin:0}.print-summary .price{font-weight:600;font-size:2.8em}.print-summary #contact-dealer{margin:80px 0 100px}.print-summary #generator{opacity:0;transition:.3s}.print-summary #generator.active{opacity:1}.print-summary #generator .details{margin:20px 0 0}.print-summary #generator .column{width:50%}.print-summary #generator .image{text-align:center}.print-summary #generator .image img{height:300px;width:auto}.print-summary .ps-container>.ps-scrollbar-y-rail>.ps-scrollbar-y{width:11px}.print-summary .ps-container.ps-in-scrolling.ps-x>.ps-scrollbar-x-rail>.ps-scrollbar-x,.print-summary .ps-container.ps-in-scrolling.ps-y>.ps-scrollbar-y-rail>.ps-scrollbar-y,.print-summary .ps-container:hover.ps-in-scrolling.ps-x>.ps-scrollbar-x-rail>.ps-scrollbar-x,.print-summary .ps-container:hover.ps-in-scrolling.ps-y>.ps-scrollbar-y-rail>.ps-scrollbar-y,.print-summary .ps-container:hover>.ps-scrollbar-x-rail:hover>.ps-scrollbar-x,.print-summary .ps-container:hover>.ps-scrollbar-y-rail:hover>.ps-scrollbar-y,.print-summary .ps-container>.ps-scrollbar-y-rail>.ps-scrollbar-y{background-color:#7e7e7e}.print-summary>*>*>ul{padding:0 10px 0 0;list-style:none;font-size:.9em}.print-summary>*>*>ul li{padding:10px 0 0 20px;list-style:none;background:url(/assets/images/arrow-right-black.png) no-repeat 7px 15px}@media (max-width:680px){.print-summary .modal{width:100vw;height:calc(100vh - 60px);top:60px;left:0;transform:translate(0);padding:30px 10px}.print-summary .close{top:70px;right:20px}}", ""]);

// exports


/***/ },
/* 823 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(14)();
// imports


// module
exports.push([module.i, ".product-categories-list{position:relative}.product-categories-list .indicator{fill:#4ec2ff;position:absolute;top:10px;left:0;opacity:0;transition:opacity .3s}.product-categories-list .indicator.active{opacity:1}.product-categories-list .categs-list{list-style:none;padding:0}@media (min-width:1800px){.product-categories-list .categs-list{min-height:calc(100% - 111px - 134px - 80px - 130px - 50px)}}@media (min-width:1600px) and (max-width:1799px){.product-categories-list .categs-list{min-height:calc(100% - 111px - 128px - 80px - 90px - 50px)}}", ""]);

// exports


/***/ },
/* 824 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(14)();
// imports


// module
exports.push([module.i, ".product-categories{display:block}", ""]);

// exports


/***/ },
/* 825 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(14)();
// imports


// module
exports.push([module.i, ".product-category{display:block;transform:translateZ(0);box-sizing:border-box;transition:background .3s}.product-category.expanded{width:100%}.product-category.level-0.compact{background:hsla(0,0%,100%,.5);padding:40px 90px;width:100%}.product-category.level-1.expanded{background:hsla(0,0%,100%,.5);padding:0 90px}.product-category.level-1.expanded:first-of-type{padding-top:40px}.product-category.level-1.expanded:last-of-type{padding-bottom:40px}.product-category#generators-product-category,.product-category.expanded.custom-renderer{background:transparent;padding:0}.product-category .subcategory-row{display:flex;align-items:stretch}.product-category .subcategory-wrapper{width:33.33333%;display:flex}.product-category .subcategory-wrapper:hover .actions{opacity:1}.product-category .thumbnail{display:flex;text-align:center;float:left;cursor:pointer;flex-direction:column;width:100%;position:relative}.product-category .thumbnail .actions{position:absolute;top:71px;left:50%;transform:translate(-50%);border-radius:4px;box-shadow:0 0 20px rgba(0,0,0,.3);width:60px;opacity:0}.product-category .thumbnail .action{width:60px;height:60px;transition:.2s;cursor:pointer;border-radius:4px;background-repeat:no-repeat;background-position:50%;background-color:#fff}.product-category .thumbnail .action:hover{color:#fff;background-color:#1496d8}.product-category .thumbnail .read-more{background-image:url(/assets/images/info-black.png)}.product-category .thumbnail .read-more:hover{background-image:url(/assets/images/info-white.png)}.product-category .thumbnail.active .link{background:#1496d8;color:#fff}.product-category .thumbnail:hover .link{background:#4ec2ff;color:#fff}.product-category .categ-thumbnail{margin:20px 10px}.product-category .image{background-size:contain;background-repeat:no-repeat;background-position:50%;background-color:#fff;width:100%;height:300px;border-radius:6px 6px 0 0}.product-category .link{display:inline-block;font-weight:300;font-size:1.2em;padding:15px;margin:0;width:100%;transition:.3s;border-radius:0 0 6px 6px;color:#1496d8;background:#fff;box-sizing:border-box;height:calc(100% - 300px)}.product-category .title{display:block;font-size:2.4em;margin:40px 0 0;padding:0 0 10px;line-height:1em;border-bottom:1px solid rgba(0,0,0,.2)}.product-category .title.no-margin{margin:0}.product-category .title sup{font-size:.5em}.product-category .subtitle{font-size:1.25em;font-weight:300;margin:0;padding:4px 0}.product-category .subtitle.spaced{margin-top:60px}.product-category .subtitle.no-margin{margin:0}.product-category .subtitle.underline{border-bottom:1px solid rgba(0,0,0,.2)}.product-category .short-description{font-size:.9em;font-weight:300;padding:2px 0;margin:0}.product-category .divider{border:0;border-top:1px solid hsla(0,0%,100%,.2);margin:30px 0}@media (min-width:1800px){.product-category .image{height:380px}}@media (min-width:1600px) and (max-width:1799px){.product-category .image{height:340px}}@media (min-width:1101px) and (max-width:1200px){.product-category .subcategory-wrapper{width:49.5%}}@media (min-width:901px) and (max-width:1100px){.product-category .subcategory-wrapper{width:100%}}@media (max-width:900px){.product-category .subcategory-wrapper{width:49.5%}.product-category.level-0.compact{padding:40px 45px}.product-category.level-1.expanded{padding:0 45px}}@media (min-width:681px) and (max-width:900px){.product-category .subcategory-wrapper{width:33%}}@media (max-width:680px){.product-category .title{margin:30px 0 10px}.product-category.level-0.compact{padding:40px 20px}.product-category.level-1.expanded{padding:0 20px}}@media (max-width:480px){.product-category .subcategory-wrapper{width:100%}}", ""]);

// exports


/***/ },
/* 826 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(14)();
// imports


// module
exports.push([module.i, ".product-details{background:#fff;width:100%;height:0;border-radius:4px;border:1px solid rgba(0,0,0,.05);position:relative;overflow:hidden;margin:-1px 0;transition:.3s;transform:translateZ(0);z-index:2}.product-details .title{padding-bottom:10px}.product-details #product-description{position:relative;float:left}.product-details .column{width:33.33333%;font-size:.85em}.product-details .description{width:calc(100% - 400px);padding:20px;box-sizing:border-box;overflow-y:auto}@media (max-width:1200px){.product-details .description{float:none;width:100%}}.product-details .short-description{padding:15px 0 0;border-top:1px solid rgba(0,0,0,.1);margin:15px 0 0}.product-details .image{width:400px;height:400px;float:right}@media (max-width:1200px){.product-details .image{float:none;margin:0 auto}}.product-details .image img{width:100%;height:100%}.product-details .close{position:absolute;top:20px;right:20px;z-index:1;width:20px;height:20px;background-image:url(/assets/images/close-slim-black.png);background-repeat:no-repeat;background-position:0 0;transition:.2s;cursor:pointer}.product-details .close:hover{background-image:url(/assets/images/close-slim-hover.png)}@media (max-width:680px){.product-details.visible{height:calc(100% - 60px);margin:0;top:60px}.product-details #product-description{float:none;width:100%}.product-details .image{float:none;width:100%;max-width:400px;height:auto;margin:0 auto}}", ""]);

// exports


/***/ },
/* 827 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(14)();
// imports


// module
exports.push([module.i, ".product-options-dropdown{position:relative;font-weight:400;color:#666;font-size:.85em;width:100%;border-bottom-left-radius:4px;border-bottom-right-radius:4px;display:block;transform:translateZ(0);cursor:pointer}.product-options-dropdown.active{z-index:2}.product-options-dropdown .selected-option{padding:12px 33px 12px 10px;overflow:hidden;background-position:right 10px top 18px;background-repeat:no-repeat;transition:.2s;line-height:1.5em}.product-options-dropdown:hover .selected-option.disabled{background-image:none}.product-options-dropdown .options-list{padding:30px 0;position:absolute;left:-1px;top:4px;width:calc(100% + 2px);opacity:0;transition:.15s;pointer-events:none;background:#fff;border-bottom-left-radius:4px;border-bottom-right-radius:4px;cursor:pointer;z-index:1;line-height:1.5em}.product-options-dropdown .icon{width:20px;height:20px;float:left;border-radius:5px;margin:0 10px 0 0;background-position:50%}.product-options-dropdown .options-list.active{opacity:1;pointer-events:all;box-shadow:0 0 30px rgba(0,0,0,.2)}.product-options-dropdown .option{border-top:1px solid rgba(0,0,0,.06);padding:8px 25px 8px 11px;transition:.15s;overflow:hidden}.product-options-dropdown .option:hover{background:#4ec2ff;color:#fff}.product-options-dropdown .option:first-of-type{border-top:none}@media (min-width:1800px){.product-options-dropdown .option{padding:14px 25px 14px 11px}}@media (min-width:1600px) and (max-width:1799px){.product-options-dropdown .option{padding:12px 25px 12px 11px}}", ""]);

// exports


/***/ },
/* 828 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(14)();
// imports


// module
exports.push([module.i, ".products-list{display:block;transform:translateZ(0)}.products-list .product{width:calc(25% - 10px);float:left;margin:20px 5px;transition:.2s;border-radius:4px;box-sizing:border-box;border:1px solid rgba(0,0,0,.05);position:relative;background:#f8f9f8;padding:0 0 50px}.products-list .product:hover .actions{opacity:1}.products-list .row{display:flex;align-items:stretch;flex-wrap:wrap}.products-list .product.is-in-cart{border:1px solid #c0c9ce;background-color:#d7dfe2}.products-list .thumbnail{width:100%;display:block;height:auto;border-radius:4px;transition:.2s;border-bottom-right-radius:0;border-bottom-left-radius:0;min-height:200px;margin:0 0 10px}.products-list .caption{padding:12px 10px;font-size:.9em;font-weight:600;color:#666}.products-list .target-area{cursor:pointer}.products-list .actions{position:absolute;top:71px;left:50%;transform:translate(-50%);border-radius:4px;box-shadow:0 0 20px rgba(0,0,0,.3);width:120px;opacity:0;z-index:1}.products-list .action{width:60px;height:60px;transition:.2s;cursor:pointer;border-radius:4px;background-repeat:no-repeat;background-position:50%;background-color:#fff}.products-list .action:hover{color:#fff;background-color:#1496d8}.products-list .read-more{border-bottom-right-radius:0;border-top-right-radius:0;background-image:url(/assets/images/info-black.png)}.products-list .read-more:hover{background-image:url(/assets/images/info-white.png)}.products-list .preview{border-bottom-left-radius:0;border-top-left-radius:0;background-image:url(/assets/images/preview-medium-black.png)}.products-list .preview:hover{background-image:url(/assets/images/preview-medium-white.png)}.products-list .add-to-cart{position:absolute;bottom:0;left:0;width:100%;color:#fff;background:#1496d8;padding:8px 16px;border-radius:0 0 4px 4px;box-sizing:border-box;cursor:pointer}.products-list .product.is-in-cart .add-to-cart{background:#135b80}@media (max-width:1200px){.products-list .actions{opacity:1;position:static;left:auto;top:auto;box-shadow:none;width:100%;transform:translate(0)}.products-list .action{width:50%}.products-list .product .remove{top:80px;right:20px;opacity:1}}@media (min-width:901px) and (max-width:1200px){.products-list .product{width:calc(99% / 2 - 10px)}}@media (min-width:681px) and (max-width:900px){.products-list .product{width:calc(99% / 2 - 10px)}}@media (max-width:680px){.products-list .product{width:calc(99% / 2 - 10px)}}@media (max-width:480px){.products-list .product{width:100%}}", ""]);

// exports


/***/ },
/* 829 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(14)();
// imports


// module
exports.push([module.i, ".products-tiny-list{display:block;transform:translateZ(0)}.products-tiny-list .product{opacity:0;position:relative;top:10px;cursor:pointer;transition:.3s;overflow:visible;pointer-events:none;box-sizing:border-box;padding:0 50px 0 0;width:calc(100% + 50px)}.products-tiny-list .product.is-in-cart{opacity:1;pointer-events:all}.products-tiny-list .product.highlighted .info{background:#4ec2ff;color:#fff!important}.products-tiny-list .product.highlighted .price{color:#fff!important}.products-tiny-list .product.is-in-cart.highlighted .info{background:#4ec2ff}.products-tiny-list .product .info{font-size:.9em;color:#999;padding:2px 5px 0;border-top:1px solid #eee;transition:.3s;box-sizing:border-box}.products-tiny-list .product .info:hover{background:#f5f8f9}.products-tiny-list .product .price{color:#44b5f1}.products-tiny-list .product .desc{font-size:.75em;color:#999}.products-tiny-list .product .remove{position:absolute;top:-5px;right:8px;width:30px;height:30px;z-index:1;transition:.2s;cursor:pointer;opacity:0;pointer-events:none;background-image:url(/assets/images/remove-faded.png);background-repeat:no-repeat;background-position:50%}.products-tiny-list .product:hover .remove{opacity:1;pointer-events:all}.products-tiny-list .product .remove:hover{background-image:url(/assets/images/remove-hover.png)}@media (max-width:680px){.products-tiny-list .product .remove{opacity:1;pointer-events:all}}", ""]);

// exports


/***/ },
/* 830 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(14)();
// imports


// module
exports.push([module.i, ".scene-tooltip{width:100%;height:100%;position:absolute;top:0;left:0;transform:translateZ(0)}.scene-tooltip .click-region{position:absolute;pointer-events:all;cursor:pointer}.scene-tooltip .click-region.active .tooltip{opacity:1}.scene-tooltip .tooltip{background:#0071ad;color:#fff;opacity:0;transition:.3s;padding:6px 16px;box-sizing:border-box;position:absolute;top:-45px;left:50%;transform:translate(-50%);white-space:nowrap;font-size:.85em;font-weight:300;pointer-events:none}.scene-tooltip .click-region:hover .tooltip{opacity:1}.scene-tooltip .price{font-weight:400}.scene-tooltip .tooltip svg{position:absolute;bottom:-12px;left:50%;fill:#0071ad;transform:translate(-50%)}.scene-tooltip.preview-closed .tooltip.bottom{bottom:-45px;top:auto}.scene-tooltip.preview-closed .tooltip.bottom svg{top:-12px;left:50%;transform:rotate(180deg)}.scene-tooltip .tooltip.right{transform:translate(0);left:calc(50% - 20px)}.scene-tooltip .tooltip.right svg{left:20px}.scene-tooltip .tooltip.left{transform:translate(-100%);left:calc(50% + 20px)}.scene-tooltip .tooltip.left svg{left:calc(100% - 20px)}", ""]);

// exports


/***/ },
/* 831 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(14)();
// imports


// module
exports.push([module.i, ".scene{display:block;pointer-events:none;position:relative;overflow:hidden;width:100%;height:100%;transform:translateZ(0)}.scene #layers-container{position:relative;background-image:url(/assets/images/background.png);background-repeat:no-repeat}.scene #layers-container,.scene .layer{width:100%;height:100%;background-size:cover;background-position:50%}.scene .layer{position:absolute;top:0;left:0;transition:.3s;pointer-events:none}.scene .preview-closed.ps-container>.ps-scrollbar-x-rail,.scene .preview-closed.ps-container>.ps-scrollbar-y-rail{opacity:0;pointer-events:none}.scene .ps-container.ps-in-scrolling.ps-x>.ps-scrollbar-x-rail>.ps-scrollbar-x,.scene .ps-container.ps-in-scrolling.ps-y>.ps-scrollbar-y-rail>.ps-scrollbar-y,.scene .ps-container:hover.ps-in-scrolling.ps-x>.ps-scrollbar-x-rail>.ps-scrollbar-x,.scene .ps-container:hover.ps-in-scrolling.ps-y>.ps-scrollbar-y-rail>.ps-scrollbar-y,.scene .ps-container:hover>.ps-scrollbar-x-rail:hover>.ps-scrollbar-x,.scene .ps-container:hover>.ps-scrollbar-y-rail:hover>.ps-scrollbar-y,.scene .ps-container>.ps-scrollbar-x-rail>.ps-scrollbar-x,.scene .ps-container>.ps-scrollbar-y-rail>.ps-scrollbar-y{background-color:#fff}.scene .ps-container:hover.ps-in-scrolling.ps-x>.ps-scrollbar-x-rail,.scene .ps-container:hover.ps-in-scrolling.ps-y>.ps-scrollbar-y-rail,.scene .ps-container:hover>.ps-scrollbar-x-rail:hover,.scene .ps-container:hover>.ps-scrollbar-y-rail:hover{background-color:transparent!important}", ""]);

// exports


/***/ },
/* 832 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(14)();
// imports


// module
exports.push([module.i, ".summary{display:block;transform:translateZ(0)}.summary .product{float:left;margin:0;transition:.2s;border-bottom:1px solid rgba(0,0,0,.05);position:relative;background:#fff;width:100%;height:auto;padding:10px 50px 10px 120px;box-sizing:border-box;min-height:120px}.summary .product:hover .actions{opacity:1}.summary .row{display:flex;align-items:stretch;flex-wrap:wrap}.summary .product.is-in-cart{border:1px solid #c0c9ce;background-color:#d7dfe2}.summary .product .remove{position:absolute;top:10px;right:10px;width:30px;height:30px;z-index:1;transition:.2s;cursor:pointer;opacity:0;pointer-events:none;background-image:url(/assets/images/remove-faded.png);background-repeat:no-repeat;background-position:50%}.summary .product:hover .remove{opacity:1;pointer-events:all}.summary .product .remove:hover{background-image:url(/assets/images/remove-hover.png)}.summary .thumbnail{width:100px;display:block;height:auto;border-radius:4px;transition:.2s;border-bottom-right-radius:0;border-bottom-left-radius:0;padding:0;position:absolute;top:10px;left:10px}.summary .caption{padding:12px 10px;font-size:.9em;font-weight:600;color:#666}.summary .price{pointer-events:none;padding:4px 8px 4px 0;font-weight:600;color:#333;font-size:1.1em;margin:0}.summary .read-more{border-bottom-right-radius:0;border-top-right-radius:0;background-image:url(/assets/images/info-black.png)}.summary .read-more:hover{background-image:url(/assets/images/info-white.png)}.summary .preview{border-bottom-left-radius:0;border-top-left-radius:0;background-image:url(/assets/images/preview-medium-black.png)}.summary .preview:hover{background-image:url(/assets/images/preview-medium-white.png)}.summary .product .download{padding:5px 0 5px 18px;font-weight:300;font-size:.8em;transition:.2s;background:url(/assets/images/arrow-right-hover.png) no-repeat 2px 5px}.summary .product.selected{border:none;border-top:1px solid rgba(0,0,0,.05);margin:0;background:#fff}.summary product-options-dropdown-cmp{position:static;display:inline-block;width:auto;padding:0;margin:0}.summary .caption,.summary product-options-dropdown-cmp .selected-dropdown-option{padding:5px 70px 5px 0}.summary .selected-finish{padding:0}.summary .target-area{height:auto}.summary .top-cat .title{padding:10px 0;margin:0;background:#f7f7f7;border:0}.summary #body #summary-title{font-size:2.4em;border:0}.summary .title{font-size:1.2em;margin:30px 0 10px;line-height:1em;border-bottom:1px solid rgba(0,0,0,.2)}.summary .subtitle{font-size:.8em;font-weight:300;border-top:1px solid rgba(0,0,0,.2);margin:0;padding:4px 0}.summary .header .subtitle{font-size:1.25em;font-weight:300;border-top:none;margin:0;padding:4px 0}.summary .subtitle-label{margin:0 0 10px;padding:0;font-size:.8em}@media (max-width:1200px){.summary .actions{opacity:1;top:0;box-shadow:none;width:100%;left:0;transform:translate(0)}.summary .action{width:50%}}@media (min-width:901px) and (max-width:1200px){.summary .product{width:100%}}@media (min-width:681px) and (max-width:900px){.summary .product{width:100%}}@media (max-width:680px){.summary .product{width:100%}}@media (max-width:480px){.summary .product{width:100%;padding:120px 50px 10px 10px}.summary .product .price{margin:0;padding:5px 0;position:static;top:auto;right:auto}}", ""]);

// exports


/***/ },
/* 833 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(14)();
// imports
exports.i(__webpack_require__(816), "");

// module
exports.push([module.i, "a:hover{text-decoration:none}.tooltip,[data-tooltip]{position:relative;cursor:pointer;box-sizing:border-box}.tooltip:after,.tooltip:before,[data-tooltip]:after,[data-tooltip]:before{box-sizing:border-box;position:absolute;visibility:hidden;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=0);opacity:0;-webkit-transition:opacity .2s ease-in-out,visibility .2s ease-in-out,-webkit-transform .2s cubic-bezier(.71,1.7,.77,1.24);-moz-transition:opacity .2s ease-in-out,visibility .2s ease-in-out,-moz-transform .2s cubic-bezier(.71,1.7,.77,1.24);transition:opacity .2s ease-in-out,visibility .2s ease-in-out,transform .2s cubic-bezier(.71,1.7,.77,1.24);-webkit-transform:translateZ(0);-moz-transform:translateZ(0);transform:translateZ(0);pointer-events:none}.tooltip:focus:after,.tooltip:focus:before,.tooltip:hover:after,.tooltip:hover:before,[data-tooltip]:focus:after,[data-tooltip]:focus:before,[data-tooltip]:hover:after,[data-tooltip]:hover:before{visibility:visible;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=100)\";filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);opacity:1}.tooltip:before,[data-tooltip]:before{z-index:1001;border:6px solid transparent;background:transparent;content:\"\"}.tooltip:after,[data-tooltip]:after{z-index:1000;padding:18px 10px;width:160px;background-color:#000;background-color:rgba(51,51,51,.9);color:#fff;content:attr(data-tooltip);font-size:14px;line-height:1.2}.tooltip-top:after,.tooltip-top:before,.tooltip:after,.tooltip:before,[data-tooltip]:after,[data-tooltip]:before{bottom:100%;left:50%}.tooltip-top:before,.tooltip:before,[data-tooltip]:before{margin-left:-6px;margin-bottom:-12px;border-top-color:#000;border-top-color:rgba(51,51,51,.9)}.tooltip-top:after,.tooltip:after,[data-tooltip]:after{margin-left:-80px}.tooltip-top:focus:after,.tooltip-top:focus:before,.tooltip-top:hover:after,.tooltip-top:hover:before,.tooltip:focus:after,.tooltip:focus:before,.tooltip:hover:after,.tooltip:hover:before,[data-tooltip]:focus:after,[data-tooltip]:focus:before,[data-tooltip]:hover:after,[data-tooltip]:hover:before{-webkit-transform:translateY(-12px);-moz-transform:translateY(-12px);transform:translateY(-12px)}.tooltip-left:after,.tooltip-left:before{right:100%;bottom:50%;left:auto}.tooltip-left:before{margin-left:0;margin-right:-12px;margin-bottom:0;border-top-color:transparent;border-left-color:#000;border-left-color:rgba(51,51,51,.9)}.tooltip-left:focus:after,.tooltip-left:focus:before,.tooltip-left:hover:after,.tooltip-left:hover:before{-webkit-transform:translateX(-12px);-moz-transform:translateX(-12px);transform:translateX(-12px)}.tooltip-bottom:after,.tooltip-bottom:before{top:100%;bottom:auto;left:50%}.tooltip-bottom:before{margin-top:-12px;margin-bottom:0;border-top-color:transparent;border-bottom-color:#000;border-bottom-color:rgba(51,51,51,.9)}.tooltip-bottom:focus:after,.tooltip-bottom:focus:before,.tooltip-bottom:hover:after,.tooltip-bottom:hover:before{-webkit-transform:translateY(12px);-moz-transform:translateY(12px);transform:translateY(12px)}.tooltip-right:after,.tooltip-right:before{bottom:50%;left:100%}.tooltip-right:before{margin-bottom:0;margin-left:-12px;border-top-color:transparent;border-right-color:#000;border-right-color:rgba(51,51,51,.9)}.tooltip-right:focus:after,.tooltip-right:focus:before,.tooltip-right:hover:after,.tooltip-right:hover:before{-webkit-transform:translateX(12px);-moz-transform:translateX(12px);transform:translateX(12px)}.tooltip-left:before,.tooltip-right:before{top:3px}.tooltip-left:after,.tooltip-right:after{margin-left:0;margin-bottom:-16px}body,html{width:100%;height:100%}body{margin:0;color:#333;overflow:hidden;background-image:url(/assets/images/background.png);background-repeat:no-repeat;background-size:cover;background-position:50%;transform:translateZ(0)}body,input{font-family:Open Sans,sans-serif;font-size:1em}a{text-decoration:none;color:#04a4cc;cursor:pointer}a:hover{color:#4ec2ff}.clearfix:after,.clearfix:before{content:\" \";display:table}.clearfix:after{clear:both}.clearfix{*zoom:1}.left{float:left}.right{float:right}::selection{background:#04a4cc;color:#fff;text-shadow:none}::-webkit-selection{background:#04a4cc;color:#fff;text-shadow:none}::-moz-selection{background:#04a4cc;color:#fff;text-shadow:none}h1,h2,h3{font-weight:500}.no-select{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.button-email{float:right}.button-email,body .button{background-color:#1496d8;padding:8px 16px;border-radius:4px;color:#fff;display:inline-block;cursor:pointer;transition:.2s;margin:0 20px 0 0}.button.active,.button:hover{background-color:#4ec2ff}.button.big{font-size:2em;padding:15px 25px;border-radius:8px}.button.arrow{padding:8px 16px 8px 30px;background-image:url(/assets/images/arrow-right.png);background-repeat:no-repeat;background-position:2px 6px}.button.big.arrow{padding:15px 35px 15px 70px;background-image:url(/assets/images/arrow-right-large.png);background-repeat:no-repeat;background-position:30px 20px}a.button:hover{color:#fff;background-color:#4ec2ff}a.info{background-color:#135b80;color:#fff;width:20px;height:20px;border-radius:50%;text-align:center;display:inline-block;font-family:Open Sans,sans-serif;font-weight:400;text-transform:none}@media (min-width:1800px){body{font-size:1.3em}}@media (min-width:1600px) and (max-width:1799px){body{font-size:1.1em}}.intro-logo{position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);width:324px;height:23px;padding:30px;background-image:url(/assets/images/logo.png),url(/assets/images/ajax-loader.gif);background-repeat:no-repeat,no-repeat;background-position:50px 30px,300px 25px;background-color:#fff}.product product-options-dropdown-cmp .selected-option{background-image:url(/assets/images/arrow-down-black.png)}.product:hover product-options-dropdown-cmp .selected-option:hover{color:#1496d8;background-color:#fff;background-image:url(/assets/images/arrow-down.png)}#catalog .ps-scrollbar-y-rail{top:0!important}@media (max-width:900px){.product product-options-dropdown-cmp .selected-option{background-image:url(/assets/images/arrow-down.png)}}#quick-menu.selective-fade{opacity:0;pointer-events:none}.selective-fade #products,.selective-fade product-details-cmp{background:hsla(0,0%,100%,0)!important;pointer-events:none}.selective-fade #generator,.selective-fade #towel-series-select,.selective-fade .button,.selective-fade .categ-thumbnail,.selective-fade .towel-warmers-description,.selective-fade h1,.selective-fade h2,.selective-fade h3{opacity:0;transition:.3s;pointer-events:none}.selective-fade .product{opacity:0;pointer-events:none}.selective-fade .product-category{pointer-events:none}.selective-fade .product .actions{opacity:0!important;pointer-events:none}.selective-fade .product.prevent-opacity{opacity:1;pointer-events:none}.selective-fade product-category-cmp{background:transparent!important}#body .products-as-list .product{width:100%;height:auto;padding:10px 50px 10px 110px;box-sizing:border-box;font-size:1.2em;min-height:110px}#body .products-as-list .product.is-in-cart{border:none;border-top:1px solid rgba(0,0,0,.05);background:transparent;margin:0;background:#fff}#body .products-as-list .product .download{display:block}#body #print-modal .product .download{display:none!important}#body .products-as-list .product .actions{display:none}#body .products-as-list .product .remove{top:10px}#body .products-as-list .product .thumbnail{width:80px;padding:0;position:absolute;top:10px;left:10px}#body .products-as-list .product .caption{padding:5px 70px 5px 0}#body .products-as-list .product .selected-option{padding:0}#body .products-as-list .product .price{margin:0;position:absolute;top:10px;right:50px}#body .products-as-list .product .target-area{height:auto}#body .products-as-list .top-cat .title{padding:10px 0;margin:0;background:#f7f7f7;border:0}@media (max-width:480px){#body .products-as-list .product .price{margin:0;padding:5px 0;position:static;top:auto;right:auto}}navigation-menu-cmp .nav-link-container{padding:9px 0;position:relative;font-size:.95em}navigation-menu-cmp .nav-link-container.hidden{display:none}navigation-menu-cmp .nav-link-container a{color:#333}navigation-menu-cmp .nav-link-container a:hover{color:#4ec2ff}@media (min-width:1600px){navigation-menu-cmp .nav-link-container{padding:13px 0;position:relative;font-size:1em}}.ps-container>.ps-scrollbar-x-rail,.ps-container>.ps-scrollbar-y-rail{opacity:1}.ps-container.ps-in-scrolling.ps-x>.ps-scrollbar-x-rail>.ps-scrollbar-x,.ps-container.ps-in-scrolling.ps-y>.ps-scrollbar-y-rail>.ps-scrollbar-y,.ps-container>.ps-scrollbar-x-rail>.ps-scrollbar-x,.ps-container>.ps-scrollbar-y-rail>.ps-scrollbar-y{background-color:#4ec2ff}.ps-container:hover.ps-in-scrolling.ps-x>.ps-scrollbar-x-rail,.ps-container:hover.ps-in-scrolling.ps-y>.ps-scrollbar-y-rail,.ps-container:hover>.ps-scrollbar-x-rail:hover,.ps-container:hover>.ps-scrollbar-y-rail:hover{background-color:#fff;opacity:1}.ps-container:hover.ps-in-scrolling.ps-x>.ps-scrollbar-x-rail>.ps-scrollbar-x,.ps-container:hover.ps-in-scrolling.ps-y>.ps-scrollbar-y-rail>.ps-scrollbar-y,.ps-container:hover>.ps-scrollbar-x-rail:hover>.ps-scrollbar-x,.ps-container:hover>.ps-scrollbar-y-rail:hover>.ps-scrollbar-y{background-color:#4ec2ff}.ps-container:hover>.ps-scrollbar-x-rail,.ps-container:hover>.ps-scrollbar-y-rail{opacity:1}catalog-page-cmp .ps-scrollbar-y-rail{z-index:2}catalog-page-cmp .ps-container>.ps-scrollbar-y-rail>.ps-scrollbar-y{width:11px}catalog-page-cmp .ps-container.ps-in-scrolling.ps-y>.ps-scrollbar-y-rail>.ps-scrollbar-y,catalog-page-cmp .ps-container:hover.ps-in-scrolling.ps-y>.ps-scrollbar-y-rail>.ps-scrollbar-y,catalog-page-cmp .ps-container:hover>.ps-scrollbar-y-rail:hover>.ps-scrollbar-y,catalog-page-cmp .ps-container>.ps-scrollbar-y-rail>.ps-scrollbar-y{background-color:#fff}catalog-page-cmp .ps-container.ps-in-scrolling.ps-y>.ps-scrollbar-y-rail,catalog-page-cmp .ps-container:hover.ps-in-scrolling.ps-y>.ps-scrollbar-y-rail,catalog-page-cmp .ps-container:hover>.ps-scrollbar-y-rail:hover{background-color:#135b80}catalog-page-cmp.sbar-black .ps-container.ps-in-scrolling.ps-y>.ps-scrollbar-y-rail>.ps-scrollbar-y,catalog-page-cmp.sbar-black .ps-container:hover.ps-in-scrolling.ps-y>.ps-scrollbar-y-rail>.ps-scrollbar-y,catalog-page-cmp.sbar-black .ps-container:hover>.ps-scrollbar-y-rail:hover>.ps-scrollbar-y,catalog-page-cmp.sbar-black .ps-container>.ps-scrollbar-y-rail>.ps-scrollbar-y{background-color:#7e7e7e}catalog-page-cmp.sbar-black .ps-container.ps-in-scrolling.ps-y>.ps-scrollbar-y-rail,catalog-page-cmp.sbar-black .ps-container:hover.ps-in-scrolling.ps-y>.ps-scrollbar-y-rail,catalog-page-cmp.sbar-black .ps-container:hover>.ps-scrollbar-y-rail:hover{background-color:#eee}email-summary-cmp product-options-dropdown-cmp,print-summary-cmp product-options-dropdown-cmp,summary-page-cmp product-options-dropdown-cmp{cursor:default!important}email-summary-cmp .selected-option,print-summary-cmp .selected-option,summary-page-cmp .selected-option{pointer-events:none!important;background-image:none!important;background-color:transparent!important}body #towel-warmers-accessories-product-category .product-options-dropdown{cursor:default!important}body #towel-warmers-accessories-product-category .selected-dropdown-option{pointer-events:none!important;background-image:none!important}", ""]);

// exports


/***/ },
/* 834 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(14)();
// imports


// module
exports.push([module.i, ".modal-alert{position:fixed;top:0;left:0;height:100%;width:100%;z-index:2;pointer-events:none;transition:opacity .3s;opacity:0;display:none;transform:translateZ(0)}.modal-alert.rendered{display:block}.modal-alert.visible{opacity:1;pointer-events:all}.modal-alert .black-bgr{position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,.75);z-index:1}.modal-alert .body{text-align:-webkit-center;position:fixed;top:5%;left:26.5%;height:30%;width:32%;z-index:2;background:#f1f1f1;padding:60px 90px;box-sizing:border-box;overflow:auto}.modal-alert .close{position:fixed;top:calc(5% + 30px);right:calc(12.5% + 40px);width:40px;height:40px;background-image:url(/assets/images/close-slim-black.png);background-repeat:no-repeat;background-position:50%;z-index:4}.modal-alert .close:hover{background-image:url(/assets/images/close-slim-hover.png)}/*!* ADAPTIVE *!*/@media (max-width:680px){.modal .body{width:100vw;height:calc(100vh - 60px);top:60px;left:0;transform:translate(0);padding:30px 10px}.modal .close{top:70px;right:20px}}", ""]);

// exports


/***/ },
/* 835 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(14)();
// imports


// module
exports.push([module.i, ".navigation-menu{position:absolute;top:0;left:0;width:333px;height:100vh;background:#fff;border-left:5px solid #4ec2ff;transition:.3s;transform:translateZ(0)}.navigation-menu .content{height:100%}.navigation-menu .logo{width:224px;height:70px;background:url(/assets/images/logo.png) no-repeat 0 40px;margin:0 55px 6px;border-bottom:1px solid #eee;cursor:pointer}.navigation-menu .tagline{font-size:.7em;color:#666;margin:0 55px 10px;line-height:1.15em}.navigation-menu #nav-menu{position:relative;overflow:hidden}.navigation-menu .menu{height:100%}.navigation-menu product-categories-list-cmp{display:block;padding:0 55px;margin:40px 0 20px;min-height:calc(100% - 111px - 114px - 80px - 90px - 50px)}.navigation-menu .total{height:114px;margin:0 55px;position:relative}.navigation-menu .total .label{text-transform:uppercase;font-weight:300;font-size:.8em}.navigation-menu .total .price{font-weight:600;font-size:1.3em;width:224px;border-bottom:1px solid #eee;padding:0 0 10px}.navigation-menu .total .summary{display:block;padding:16px 0 0 18px;background:url(/assets/images/arrow-right.png) no-repeat 2px 18px;font-weight:500;font-size:.95em;transition:.2s}.navigation-menu .total .summary:hover{background:url(/assets/images/arrow-right-hover.png) no-repeat 2px 18px}.navigation-menu #summary-indicator{position:absolute;top:71px;left:-55px;fill:#4ec2ff;opacity:0;transition:.3s}.navigation-menu #summary-indicator.active{opacity:1}.navigation-menu .close{position:absolute;top:10px;right:10px;opacity:0;pointer-events:none;width:40px;height:40px;background-image:url(/assets/images/close-slim-black.png);background-repeat:no-repeat;background-position:50%;z-index:2;cursor:pointer}.navigation-menu .close:hover{background-image:url(/assets/images/close-slim-hover.png)}.navigation-menu .preview-img{position:relative;width:calc(100% - 110px);height:144px;margin:0 0 20px 55px;color:#fff;cursor:pointer;transition:.2s;background-image:url(/assets/images/background.png);background-size:cover;background-position:50%;background-repeat:no-repeat}.navigation-menu .preview-img .label{position:absolute;top:100px;left:20px;min-height:24px;text-transform:uppercase;font-weight:700;padding:3px 0 0 50px;opacity:0;transition:.2s;pointer-events:none;background-repeat:no-repeat}.navigation-menu .preview-img .label.active{opacity:1;pointer-events:all}.navigation-menu .preview-img .label.preview{background-image:url(/assets/images/preview-big-white.png);background-position:0}.navigation-menu .preview-img .label.catalog{background-image:url(/assets/images/arrow-right-large.png);background-position:10px 0}@media (min-width:1800px){.navigation-menu{width:413px}.navigation-menu .total{height:134px}}@media (min-width:1600px){.navigation-menu .preview-img{height:120px}.navigation-menu .preview-img:hover{height:150px}}@media (min-width:1600px) and (max-width:1799px){.navigation-menu{width:393px}.navigation-menu .total{height:128px}}@media (max-width:900px){.navigation-menu{left:-338px;z-index:2}.navigation-menu.active{left:0}.navigation-menu .close.active{opacity:1;pointer-events:all}}@media (max-width:680px){.navigation-menu{height:calc(100vh - 60px);top:60px}}@media (max-width:480px){.navigation-menu{width:calc(100vw - 5px);left:-100vw}}", ""]);

// exports


/***/ },
/* 836 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(14)();
// imports


// module
exports.push([module.i, ".options-menu{position:absolute;top:0;right:0;padding:24px 40px;width:290px;height:100vh;background:rgba(0,0,0,.9);color:#fff;box-sizing:border-box;z-index:2;transform:translateZ(0)}.options-menu .content{height:calc(100% - 48px)}.options-menu .link{cursor:pointer;transition:.2s;display:block;color:#fff}.options-menu .link:hover{color:#4ec2ff}.options-menu .close{padding:0 0 0 40px;background-image:url(/assets/images/close-slim.png);background-repeat:no-repeat;background-position:0 0}.options-menu .close:hover{background-image:url(/assets/images/close-slim-hover.png)}.options-menu .menu{margin:50px 0 0;font-size:.85em;font-weight:400;height:calc(100% - 204px);min-height:200px}.options-menu .menu .link{margin:20px 0 0;padding:0 0 0 40px;background-repeat:no-repeat;background-position:0 0}.options-menu .print{background-image:url(/assets/images/print.png)}.options-menu .save{background-image:url(/assets/images/save.png)}.options-menu .email{background-image:url(/assets/images/email.png)}.options-menu .dealer{background-image:url(/assets/images/locator.png)}.options-menu .restart{background-image:url(/assets/images/restart.png)}.options-menu .print:hover{background-image:url(/assets/images/print-hover.png)}.options-menu .save:hover{background-image:url(/assets/images/save-hover.png)}.options-menu .email:hover{background-image:url(/assets/images/email-hover.png)}.options-menu .dealer:hover{background-image:url(/assets/images/locator-hover.png)}.options-menu .restart:hover{background-image:url(/assets/images/restart-hover.png)}.options-menu .icon{background-repeat:no-repeat;background-position:0 0}.options-menu .social-links .icon{margin:0 0 0 16px;width:32px;height:32px}.options-menu .social-links .icon:first-of-type{margin:0}.options-menu .facebook{background-image:url(/assets/images/facebook.png)}.options-menu .linkedin{background-image:url(/assets/images/linkedin.png)}.options-menu .twitter{background-image:url(/assets/images/twitter.png)}.options-menu .google-plus{background-image:url(/assets/images/gplus.png)}.options-menu .facebook:hover{background-image:url(/assets/images/facebook-hover.png)}.options-menu .linkedin:hover{background-image:url(/assets/images/linkedin-hover.png)}.options-menu .twitter:hover{background-image:url(/assets/images/twitter-hover.png)}.options-menu .google-plus:hover{background-image:url(/assets/images/gplus-hover.png)}.options-menu .newsletter{margin:0 0 65px}.options-menu .tagline{font-size:.8em;font-weight:400;color:#4ec2ff}.options-menu .phone{font-size:1.3em;font-weight:400}.options-menu .subscribe{font-size:.8em;font-weight:400;padding:0 0 0 20px;margin:10px 0 0;background:url(/assets/images/arrow-right-white.png) no-repeat 0 2px}.options-menu .subscribe:hover{background:url(/assets/images/arrow-right.png) no-repeat 0 2px}@media (max-width:680px){.options-menu{height:calc(100vh - 60px);top:60px}}@media (max-width:480px){.options-menu{width:100vw}}", ""]);

// exports


/***/ },
/* 837 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(14)();
// imports


// module
exports.push([module.i, ".quick-menu{position:absolute;top:25px;right:17px;width:55px;opacity:1;pointer-events:all;transition:.3s;background:#fff;border-radius:6px}.quick-menu.hidden .icon.active{pointer-events:none}.quick-menu.dark-bgr .icon:hover{background-color:#135b80}.quick-menu .mobile-logo{display:none;width:110px;height:40px;background:url(/assets/images/logo-mobile.png) no-repeat 50%;float:left;cursor:pointer}.quick-menu .icon{height:0;pointer-events:none;padding:0 0 0 55px;color:#fff;transition:.2s;z-index:1;width:0;overflow:hidden;cursor:pointer;box-sizing:border-box;white-space:nowrap;background-repeat:no-repeat;background-position:10px 10px;float:right}.quick-menu .icon:hover{background-color:#1496d8;padding-right:10px}.quick-menu .icon.active{background-color:#fff;color:#333;opacity:1;pointer-events:all;height:40px;padding:10px 0 10px 55px}.quick-menu .icon.showcased{padding-right:10px;background-color:#135b80}.quick-menu .icon:nth-of-type(3){border-top-left-radius:6px;border-top-right-radius:6px}.quick-menu .icon:last-of-type{border-bottom-left-radius:6px;border-bottom-right-radius:6px}.quick-menu .navigation-cart{background-image:url(/assets/images/navigation.png)}.quick-menu .navigation-cart.active{height:0;pointer-events:none;padding:0}.quick-menu .navigation-cart:hover{width:216px}.quick-menu .options-menu{background-image:url(/assets/images/options.png);position:static;border-top-left-radius:6px;border-top-right-radius:6px}.quick-menu .options-menu:hover{width:132px}.quick-menu .preview{font-weight:500;font-size:.95em;background-image:url(/assets/images/preview-big-white.png);background-position:7px 10px}.quick-menu .preview.showcased,.quick-menu .preview:hover{width:197px;background-position:10px 10px}.quick-menu .add-generator{font-weight:500;font-size:.95em;background-image:url(/assets/images/start-btn-white.png)}.quick-menu .add-generator.showcased,.quick-menu .add-generator:hover{width:197px}.quick-menu .navigation-cart,.quick-menu .navigation-cart:hover{background-image:url(/assets/images/navigation-hover.png)}.quick-menu .options-menu,.quick-menu .options-menu:hover{background-image:url(/assets/images/options-hover.png)}.quick-menu .preview,.quick-menu .preview.showcased,.quick-menu .preview:hover{background-image:url(/assets/images/preview-big-hover.png)}.quick-menu .add-generator,.quick-menu .add-generator.showcased,.quick-menu .add-generator:hover{background-image:url(/assets/images/start-btn-hover.png)}.quick-menu .top-cat-nav{position:fixed;top:60px;width:60px;height:35px;z-index:2;pointer-events:none;transition:.3s;cursor:pointer;background-repeat:no-repeat;background-position:0 0}.quick-menu .top-cat-nav.active{opacity:1;pointer-events:all}.quick-menu #prev-top-cat{left:0;background-image:url(/assets/images/top-cat-prev.png)}.quick-menu #next-top-cat{right:0;background-image:url(/assets/images/top-cat-next.png)}@media (min-width:1800px){.quick-menu .options-menu:hover{width:155px}.quick-menu .icon.preview{background-position:7px 10px}.quick-menu .preview:hover{width:237px}.quick-menu .add-generator:hover{width:245px}.quick-menu .icon{background-position:10px 14px}.quick-menu .icon.active{height:51px}}@media (min-width:1600px) and (max-width:1799px){.quick-menu .options-menu:hover{width:142px}.quick-menu .icon.preview{background-position:7px 10px}.quick-menu .preview:hover{width:214px}.quick-menu .add-generator:hover{width:218px}.quick-menu .icon{background-position:10px 12px}.quick-menu .icon.active{height:47px}}@media (max-width:900px){.quick-menu .navigation-cart.active{opacity:1;height:40px;pointer-events:all;padding:10px 0 10px 55px}.quick-menu .icon:nth-of-type(2){border-top-left-radius:6px;border-top-right-radius:6px}.quick-menu .icon:nth-of-type(3){border-top-left-radius:0;border-top-right-radius:0}}@media (max-width:680px){.quick-menu{border-radius:0;top:0;left:0;height:40px;width:100%;padding:10px 0;background:#fff;z-index:10;box-shadow:0 0 30px rgba(0,0,0,.1)}.quick-menu .icon{float:left}.quick-menu .icon:hover{width:0!important}.quick-menu .mobile-logo,.quick-menu .top-cat-nav{display:block}}", ""]);

// exports


/***/ },
/* 838 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(14)();
// imports


// module
exports.push([module.i, ".start-arrow{position:absolute;bottom:140px;left:0;transition:.3s;transform:translate(-150px);opacity:0;cursor:pointer;pointer-events:none;transform:translateZ(0)}.start-arrow.active{transform:translate(-50px);opacity:1;pointer-events:all}.start-arrow .label{height:94px;background-color:rgba(52,129,170,.8);background-image:url(/assets/images/arrow-right-large.png);background-repeat:no-repeat;background-position:130px 34px;font-weight:300;color:#fff;font-size:2.7em;padding:17px 40px 15px 190px;box-sizing:border-box;float:left;transition:.3s}.start-arrow .arrow{height:94px;width:30px;fill:rgba(52,129,170,.8);transition:.3s}.start-arrow .arrow-big{display:none;height:120px;width:40px;fill:rgba(52,129,170,.8);transition:.3s}.start-arrow:hover{transform:translate(-20px)}.start-arrow:hover .label{background-color:rgba(0,0,0,.8)}.start-arrow:hover .arrow,.start-arrow:hover .arrow-big{fill:rgba(0,0,0,.8)}@media (min-width:1800px){.start-arrow{bottom:130px}.start-arrow .label{height:120px;background-position:130px 47px}.start-arrow .arrow{display:none}.start-arrow .arrow-big{display:block}}@media (min-width:1600px){.start-arrow{bottom:164px}}@media (min-width:1600px) and (max-width:1799px){.start-arrow{bottom:120px}.start-arrow .label{height:120px;background-position:130px 47px;font-size:2.3em;padding:29px 40px 15px 190px}.start-arrow .arrow{display:none}.start-arrow .arrow-big{display:block}}@media (max-width:680px){.start-arrow .label{font-size:1.7em;padding:27px 40px 15px 100px;background-position:65px 34px}}@media (max-width:480px){.start-arrow .label{width:270px;padding:10px 40px 15px 120px}}", ""]);

// exports


/***/ },
/* 839 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(14)();
// imports


// module
exports.push([module.i, ".modal{position:fixed;top:0;left:0;height:100%;width:100%;z-index:2;pointer-events:none;transition:opacity .3s;opacity:0;display:none;transform:translateZ(0)}.modal.rendered{display:block}.modal.visible{opacity:1;pointer-events:all}.modal .black-bgr{position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,.75);z-index:1}.modal .body{position:fixed;top:5%;left:12.5%;height:90%;width:75%;z-index:2;background:#fff;padding:60px 90px;box-sizing:border-box;overflow:auto}.modal .close{position:fixed;top:calc(5% + 30px);right:calc(12.5% + 40px);width:40px;height:40px;background-image:url(/assets/images/close-slim-black.png);background-repeat:no-repeat;background-position:50%;z-index:4}.modal .close:hover{background-image:url(/assets/images/close-slim-hover.png)}/*!* ADAPTIVE *!*/@media (max-width:680px){.modal .body{width:100vw;height:calc(100vh - 60px);top:60px;left:0;transform:translate(0);padding:30px 10px}.modal .close{top:70px;right:20px}}", ""]);

// exports


/***/ },
/* 840 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(14)();
// imports


// module
exports.push([module.i, ".not-found-404{display:block}.not-found-404 .title{font-weight:300;color:#999}", ""]);

// exports


/***/ },
/* 841 */,
/* 842 */
/***/ function(module, exports) {

module.exports = " <navigation-menu-cmp [ngClass]=\"{active: _appService.state.app.navigationMenuIsVisible === true}\"></navigation-menu-cmp> <modal-cmp [modalIsVisible]=\"_appService.state.app.productDetailsModalIsVisible\" (modalClosed)=\"_appService.hideProductDetailsModal( $event )\"> <product-details-cmp></product-details-cmp> </modal-cmp> <modal-cmp [modalIsVisible]=\"_appService.state.app.printSummaryModalIsVisible\" (modalClosed)=\"_appService.hidePrintSummaryModal( $event )\"> <print-summary-cmp></print-summary-cmp> </modal-cmp> {{_appService.state.app.emailSummaryModalIsVisible}} <modal-cmp [modalIsVisible]=\"_appService.state.app.emailSummaryModalIsVisible\" (modalClosed)=\"_appService.hideEmailSummaryModal( $event )\"> <email-summary-cmp></email-summary-cmp> </modal-cmp> <alert-cmp [modalIsVisible]=\"_appService.state.app.alertModalIsVisible\" (modalClosed)=\"_appService.hideAlertModal( $event )\"> <div> Email sent successfully! </div> <br> <button style=\"width:82px;height:30px\" (click)=\"_appService.state.app.alertModalIsVisible = false\">OK</button> </alert-cmp> <div id=\"content\" [ngClass]=\"{'selective-fade': _appService.state.prodOptionsDropdownIsOpened}\"> <scene-cmp></scene-cmp> <div class=\"return\" (click)=\"_appService.hidePreview();\" [ngClass]=\"{active: _appService.state.app.previewIsVisible === true}\"> Close Preview </div> <router-outlet></router-outlet> <div class=\"scroll-down\" [ngClass]=\"{active: \r\n        _appService.state.catalog.currentCategoryId === 'generators' &&\r\n        _navigationService.state.currentPage === 'catalog'}\" (click)=\"_appCatalogService.selectCategory({ category: 'steam-shower-controls' })\"> </div> </div> <options-menu-cmp *ngIf=\"_appService.state.app.optionsMenuIsVisible\"></options-menu-cmp> <quick-menu-cmp></quick-menu-cmp>";

/***/ },
/* 843 */
/***/ function(module, exports) {

module.exports = " <div class=\"content\"> <product-categories-cmp [catalogState]=\"_appService.state.catalog\" [scrollContainerElem]=\"catalogElem\" (categorySelected)=\"_appCatalogService.selectCategory( $event )\"> </product-categories-cmp> <div class=\"summary-link-div\"> <div class=\"button big arrow\" id=\"summary-link\" (click)=\"_navigationService.openSummaryPage()\"> View Summary </div> </div> </div>";

/***/ },
/* 844 */
/***/ function(module, exports) {

module.exports = " <div class=\"content\"> <div class=\"return\" (click)=\"_navigationService.openCatalogPage()\">Return to Catalog</div> <h1 id=\"summary-title\" class=\"title\">Full Summary</h1> <div class=\"header clearfix\"> <div class=\"half left clearfix\"> <div class=\"specs column left\"> <h2 class=\"subtitle\">Shower Dimensions</h2> <div class=\"row clearfix\"> <div class=\"label left\">Length:</div> <div class=\"value left\"> <b>{{_generatorsService.state.roomDimensions.lengthFt}}</b> ft - <b>{{_generatorsService.state.roomDimensions.lengthIn}}</b> in </div> </div> <div class=\"row clearfix\"> <div class=\"label left\">Width:</div> <div class=\"value left\"> <b>{{_generatorsService.state.roomDimensions.widthFt}}</b> ft - <b>{{_generatorsService.state.roomDimensions.widthIn}}</b> in </div> </div> <div class=\"row clearfix\"> <div class=\"label left\">Height:</div> <div class=\"value left\"> <b>{{_generatorsService.state.roomDimensions.heightFt}}</b> ft - <b>{{_generatorsService.state.roomDimensions.heightIn}}</b> in </div> </div> <div class=\"row clearfix\"> <div class=\"label left\">Adjusted Room Volume:</div> <div class=\"value left\"> <b>{{_roundRoomVolume( _generatorsService.state.roomDimensions.cubicFeetAdjusted )}}</b> Cubic ft </div> </div> </div> <div class=\"column left\"> <h2 class=\"subtitle\">Shower Material</h2> <b>{{_dic[_generatorsService.state.roomDimensions.wallType]}}</b> </div> </div> <div class=\"half options left clearfix\"> <div class=\"column left newsletter\"> <div class=\"tagline\">Talk to a Mr Steam representative</div> <div class=\"phone\">1-800-76-STEAM</div> <a href=\"http://blog.mrsteam.com/subscribe-to-mr-steams-steamtherapy-blog\" target=\"_blank\" class=\"link subscribe\">Subscribe to our Newsletter</a> </div> <div class=\"column left menu\"> <div class=\"link print\" (click)=\"_appService.hideOptionsMenu(); _appService.displayPrintSummaryModal();\">Print</div> <div class=\"link email\" (click)=\"_appService.hideOptionsMenu(); _appService.displayEmailSummaryModal();setProduct()\">Email</div> <a class=\"link dealer cta_button\" id=\"cta_button_197381_b1203cd0-e010-4b25-9fdb-3d6c2efca56e\" target=\"_blank\" href=\"https://www.mrsteam.com/find-a-dealer/?hsCtaTracking=fc10f4e6-aa29-4ec6-9ce4-257e7795e0f1%7Cbbd66452-5803-4fef-9749-963086b76bbf\" cta_dest_link=\"http://www.mrsteam.com/dealer-locator\" title=\"Dealer Locator\">Dealer Locator</a> <div class=\"link restart\" (click)=\"_appService.hideOptionsMenu(); _cartService.emptyCart();\r\n                      _navigationService.openCatalogPage();\r\n                      _generatorsService.resetCalculatorInputs();\r\n                      _appCatalogService.selectCategory({ category: 'generators' });\"> Start Over </div> </div> </div> </div> <div id=\"generator\" class=\"description active\" *ngIf=\"_globals.selectedGenerator === null\"> <h2 class=\"subtitle spaced\">No Generator selected</h2> <h1 class=\"title-label\"> Please enter shower room dimensions in: <div class=\"link\" (click)=\"_navigationService.openCatalogPage();\r\n     _appCatalogService.selectCategory({ category: 'generators' });\"> Generator Calculator </div> </h1> </div> <div id=\"products\" class=\"clearfix\"> <summary-cmp></summary-cmp> </div> <hr class=\"divider\"/> <h3 class=\"price-label\">Total Price USD</h3> <div class=\"price\">${{_cartService.state.totalPrice}}.00</div> <a href=\"http://www.mrsteam.com/dealer-locator\" target=\"_blank\" id=\"contact-dealer\" class=\"button big arrow\"> Contact a dealer </a> </div>";

/***/ },
/* 845 */
/***/ function(module, exports) {

module.exports = " <h1 id=\"generators-title\" class=\"title\">SmartSizing<sup>TM</sup></h1> <h3 id=\"generators-title-label\" class=\"title-label\" [ngClass]=\"{collapsed: _generatorCfg.selectedGenerator !== null}\"> The perfect amount of steam starts with selecting the right steam shower generator. </h3> <h2 id=\"generators-subtitle\" class=\"subtitle\" [ngClass]=\"{collapsed: _generatorCfg.selectedGenerator !== null}\"> Enter your steam shower dimensions and materials </h2> <div class=\"row clearfix calculator-inputs\" [ngClass]=\"{collapsed: _generatorCfg.selectedGenerator !== null}\"> <div class=\"input-group length clearfix\"> <h3 class=\"input-label\" [ngClass]=\"{error: !_generatorCfg.lengthFtIsValid,\r\n            valid: _generatorCfg.lengthFtIsValid}\"> Length: </h3> <div class=\"input-wrapper left input-ft\"> <input id=\"generator-length-ft\" class=\"dimensions\" type=\"text\" name=\"length_ft\" onClick=\"this.select();\" [(ngModel)]=\"_roomDimensions.lengthFt\" (ngModelChange)=\"_updateConfiguratorVars()\"> </div> <div class=\"input-wrapper right input-in\"> <input id=\"generator-length-in\" class=\"dimensions right input-in\" type=\"text\" name=\"length_in\" onClick=\"this.select();\" [(ngModel)]=\"_roomDimensions.lengthIn\" (ngModelChange)=\"_updateConfiguratorVars()\"> </div> </div> <div class=\"input-group width clearfix\"> <h3 class=\"input-label\" [ngClass]=\"{error: !_generatorCfg.widthFtIsValid,\r\n            valid: _generatorCfg.widthFtIsValid}\"> Width: </h3> <div class=\"input-wrapper left input-ft\"> <input id=\"generator-width-ft\" class=\"dimensions left input-ft\" type=\"text\" name=\"width_ft\" onClick=\"this.select();\" [(ngModel)]=\"_roomDimensions.widthFt\" (ngModelChange)=\"_updateConfiguratorVars()\"> </div> <div class=\"input-wrapper right input-in\"> <input id=\"generator-width-in\" class=\"dimensions right input-in\" type=\"text\" name=\"width_in\" onClick=\"this.select();\" [(ngModel)]=\"_roomDimensions.widthIn\" (ngModelChange)=\"_updateConfiguratorVars()\"> </div> </div> <div class=\"input-group height clearfix\"> <h3 class=\"input-label\" [ngClass]=\"{error: !_generatorCfg.heightFtIsValid,\r\n            valid: _generatorCfg.heightFtIsValid}\"> Height: </h3> <div class=\"input-wrapper left input-ft\"> <input id=\"generator-height-ft\" class=\"dimensions left input-ft\" type=\"text\" name=\"height_ft\" onClick=\"this.select();\" [(ngModel)]=\"_roomDimensions.heightFt\" (ngModelChange)=\"_updateConfiguratorVars()\"> </div> <div class=\"input-wrapper right input-in\"> <input id=\"generator-height-in\" class=\"dimensions right input-in\" type=\"text\" name=\"height_in\" onClick=\"this.select();\" [(ngModel)]=\"_roomDimensions.heightIn\" (ngModelChange)=\"_updateConfiguratorVars()\"> </div> </div> <div class=\"input-group left material\"> <h3 class=\"input-label\" [ngClass]=\"{error: !_generatorCfg.materialIsValid,\r\n            valid: _generatorCfg.materialIsValid}\"> Material: <a class=\"info\" data-tooltip=\"The material in your shower is important to consider when selecting your steam shower generator. The more porous a material (e.g., marble, shale, granite, glass block, or concrete), the more quickly it will dissipate heat.  A tile steam shower may need a different size steam generator than a marble steam shower of the same size. \r\n\">i</a> </h3> <div class=\"dropdown\"> <div class=\"selected dimensions\" (click)=\"_openDropdown()\"> {{_dic[_roomDimensions.wallType]}} </div> <div class=\"options\" *ngIf=\"_materialsDropdownIsRendered\" [ngClass]=\"{active: _materialsDropdownIsVisible}\"> <div class=\"option\" (click)=\"_selectOption('stone');\"> Natural Stone </div> <div class=\"option\" (click)=\"_selectOption('ceramic');\"> Ceramic, Porcelain, Glass Tile </div> <div class=\"option\" (click)=\"_selectOption('acrylic');\"> Acrylic, Fiberglass, Composite </div> </div> </div> </div> </div> <div class=\"dimensions-exceeded\" *ngIf=\"_generatorCfg.showerDimensionsExceeded\"> <div class=\"text\">Call or email us to help you make the right selection:</div> <div class=\"phone\">(800)767-8326 <span class=\"pho-num-label\">East Coast</span></div> <div class=\"phone\">(800)727-8326 <span class=\"pho-num-label\">West Coast</span></div> </div> <div id=\"recommended-generator\" class=\"description\" [ngClass]=\"{active: _generatorCfg.selectedGenerator !== null}\" *ngIf=\"_generatorCfg.selectedGenerator !== null\"> <div class=\"details clearfix\"> <div class=\"column right\"> <h1 class=\"title labeled\">{{_generatorCfg.selectedGenerator.name}}</h1> <h3 class=\"title-label\"> Recommended for steam bath with adjusted total volume of <b>{{_roundRoomVolume(_roomDimensions.cubicFeetAdjusted)}}</b> cubic feet </h3> <br/> <div class=\"tabs clearfix\"> <div class=\"underline u1 left\"></div> <div class=\"tab specs left\" (click)=\"_currentTab = 1\" [ngClass]=\"{active: _currentTab === 1}\">Specifications</div> <div class=\"underline u2 left\"></div> <div class=\"tab desc left\" (click)=\"_currentTab = 0\" [ngClass]=\"{active: _currentTab === 0}\">Description</div> <div class=\"underline u3 left\"></div> </div> <div class=\"text short-description\" *ngIf=\"_currentTab === 0\" [innerHTML]=\"_generatorCfg.selectedGenerator.descriptions.long\"></div> <div class=\"text short-description tab-specs\" *ngIf=\"_currentTab === 1\" [innerHTML]=\"_generatorCfg.selectedGenerator.descriptions.tech\"></div> <a class=\"download-specs button\" *ngIf=\"_currentTab === 1\" [href]=\"_generatorCfg.selectedGenerator.links.tech\" target=\"_blank\">Download Specs</a> </div> </div> </div> <div class=\"skip\" *ngIf=\"_generatorCfg.selectedGenerator === null\"> <br/> <div class=\"button\" (click)=\"_skipGeneratorSelection()\">Skip this step</div> </div>";

/***/ },
/* 846 */
/***/ function(module, exports) {

module.exports = " <h1 class=\"title-clean\">Email My Summary</h1> <input id=\"txtName\" class=\"input full-name\" type=\"text\" name=\"txtName\" onclick=\"this.select()\" [(ngModel)]=\"emailForm.txtName\" (ngModelChange)=\"validateForm()\" placeholder=\"Your name\"> <input id=\"txtEmail\" class=\"input email\" type=\"text\" name=\"txtEmail\" onclick=\"this.select()\" [(ngModel)]=\"emailForm.txtEmail\" (ngModelChange)=\"validateForm()\" placeholder=\"Email address\"> <div class=\"clearfix\"> <label id=\"lblHsPersona\">How would you describe your interest in MrSteam?</label> <br> <select id=\"selHsPersona\" class=\"input email\" name=\"selHsPersona\"> <option value=\"persona_0\">- Please Select -</option> <option value=\"persona_1\">It's for myself or a friend</option> <option value=\"persona_2\">I'm a MrSteam dealer (e.g., plumbing supply house or wholesaler)</option> <option value=\"persona_3\">I'm a specifier (e.g., architect, designer, remodeler)</option> <option value=\"persona_5\">Design/build or custom home building professional</option> <option value=\"persona_6\">Plumber, electrician or installer.</option> <option value=\"persona_7\">Spa/Hotel Purchaser</option> </select> </div> <label id=\"lblEmailMessage\"></label> <h2 class=\"subtitle-clean\">Send to multiple email addresses</h2> <div class=\"clearfix\"> <textarea id=\"txtAddresses\" class=\"text-area emails left\" type=\"text\" name=\"txtAddresses\" onclick=\"this.select()\" [(ngModel)]=\"emailForm.txtAddresses\" (ngModelChange)=\"validateForm()\" placeholder=\"Email addresses\" (mousedown)=\"clearTextarea();\" (blur)=\"setTextarea();\"></textarea> <textarea id=\"txtNotes\" class=\"text-area note left\" type=\"text\" name=\"txtNotes\" onclick=\"this.select()\" [(ngModel)]=\"emailForm.txtNotes\" (ngModelChange)=\"validateForm()\" placeholder=\"Description Notes\"></textarea> <label class=\"subtitle-clean\" id=\"lblSentMessage\"></label> </div> <div id=\"products\" class=\"clearfix\"> <summary-cmp></summary-cmp> <div id=\"content-email\" style=\"margin:0;padding:0\"> <table border=\"0\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\"> <tr> <td style=\"padding:20px 0 20px 0\"> <table align=\"center\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" style=\"border-collapse:collapse;max-width:600px\"> <tr> <td align=\"center\" bgcolor=\"#fdfcfc\" style=\"padding:30px 0 30px 0\"> <table border=\"0\" cellpadding=\"0\" cellspacing=\"0\" width=\"224\"> <tr> <td width=\"224\" align=\"center\" width=\"224\"> <table border=\"0\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\"> <tr> <td style=\"padding:0 0 10px 0\"> <img src=\"https://virtualspa.mrsteam.com/assets/images/logo.png\" alt=\"Mr.Steam\" width=\"224\" height=\"23\"/> </td> </tr> <tr> <td align=\"center\" bgcolor=\"#eeeeee\" style=\"font-size:0;line-height:0\" height=\"1\"> &nbsp; </td> </tr> <tr> <td align=\"left\" style=\"padding:10px 0 0 0;color:#153643;font-family:Arial,sans-serif;font-size:12px\"> <p>Plan and customize your steam shower with Virtual Spa System.</p> </td> </tr> </table> </td> </tr> </table> </td> </tr> <tr> <td align=\"center\" bgcolor=\"#4ec2ff\" style=\"font-size:0;line-height:0\" height=\"5\"> &nbsp; </td> </tr> <tr> <td bgcolor=\"#F6F6F6\" style=\"padding:25px 10px 30px 10px\"> <table border=\"0\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\"> <tr> <td style=\"padding:0 0 5px 0;color:#153643;font-family:Arial,sans-serif;font-size:24px\"> <b>Shower Dimensions</b> </td> </tr> <tr> <td> <table border=\"0\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\"> <tr> <td align=\"center\" bgcolor=\"#C7C7C7\" style=\"font-size:0;line-height:0\" height=\"1\" colspan=\"2\"> &nbsp; </td> </tr> <tr> <td align=\"left\" width=\"20%\"> <table border=\"0\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\"> <tr> <td style=\"padding:7px 0 7px 0;color:#999;font-family:Arial,sans-serif;font-size:15px;line-height:20px\"> <b>LENGHT:</b> </td> </tr> </table> </td> <td align=\"right\" width=\"80%\"> <table border=\"0\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" align=\"left\"> <tr> <td style=\"padding:7px 0 7px 0;color:#153643;font-family:Arial,sans-serif;font-size:16px;line-height:18px\"> <b>{{_generatorsService.state.roomDimensions.lengthFt}}</b> ft - <b>{{_generatorsService.state.roomDimensions.lengthIn}}</b> in </td> </tr> </table> </td> </tr> <tr> <td align=\"center\" bgcolor=\"#C7C7C7\" style=\"font-size:0;line-height:0\" height=\"1\" colspan=\"2\"> &nbsp; </td> </tr> <tr> <td align=\"left\" width=\"20%\"> <table border=\"0\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\"> <tr> <td style=\"padding:7px 0 7px 0;color:#999;font-family:Arial,sans-serif;font-size:15px;line-height:20px\"> <b>WIDTH:</b> </td> </tr> </table> </td> <td align=\"right\" width=\"80%\"> <table border=\"0\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" align=\"left\"> <tr> <td style=\"padding:7px 0 7px 0;color:#153643;font-family:Arial,sans-serif;font-size:16px;line-height:18px\"> <b>{{_generatorsService.state.roomDimensions.widthFt}}</b> ft - <b>{{_generatorsService.state.roomDimensions.widthIn}}</b> in </td> </tr> </table> </td> </tr> <tr> <td align=\"center\" bgcolor=\"#C7C7C7\" style=\"font-size:0;line-height:0\" height=\"1\" colspan=\"2\"> &nbsp; </td> </tr> <tr> <td align=\"left\" width=\"20%\"> <table border=\"0\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\"> <tr> <td style=\"padding:7px 0 7px 0;color:#999;font-family:Arial,sans-serif;font-size:15px;line-height:20px\"> <b>HEIGHT:</b> </td> </tr> </table> </td> <td align=\"right\" width=\"80%\"> <table border=\"0\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" align=\"left\"> <tr> <td style=\"padding:7px 0 7px 0;color:#153643;font-family:Arial,sans-serif;font-size:16px;line-height:18px\"> <b>{{_generatorsService.state.roomDimensions.heightFt}}</b> ft - <b>{{_generatorsService.state.roomDimensions.heightIn}}</b> in </td> </tr> </table> </td> </tr> <tr> <td align=\"center\" bgcolor=\"#C7C7C7\" style=\"font-size:0;line-height:0\" height=\"1\" colspan=\"2\"> &nbsp; </td> </tr> <tr> <td align=\"left\" width=\"20%\"> <table border=\"0\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\"> <tr> <td style=\"padding:7px 0 7px 0;color:#999;font-family:Arial,sans-serif;font-size:15px;line-height:20px\"> <b>ADJUSTED ROOM VOLUME:</b> </td> </tr> </table> </td> <td align=\"right\" width=\"80%\"> <table border=\"0\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" align=\"left\"> <tr> <td style=\"padding:7px 0 7px 0;color:#153643;font-family:Arial,sans-serif;font-size:16px;line-height:18px\"> <b>{{_roundRoomVolume(_roomDimensions.cubicFeetAdjusted)}}</b> Cubic ft </td> </tr> </table> </td> </tr> </table> </td> </tr> <tr> <td style=\"padding:20px 0 5px 0;color:#153643;font-family:Arial,sans-serif;font-size:24px\"> <div id=\"generator\" class=\"description active\" *ngIf=\"_globals.selectedGenerator === null\"> <b>No Generator selected</b> </div> </td> </tr> <tr> <td style=\"padding:20px 0 5px 0;color:#153643;font-family:Arial,sans-serif;font-size:24px\"> <b>Shower Material</b> </td> </tr> <tr> <td> <table border=\"0\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\"> <tr> <td align=\"center\" bgcolor=\"#C7C7C7\" style=\"font-size:0;line-height:0\" height=\"1\"> &nbsp; </td> </tr> <tr> <td valign=\"top\" style=\"padding:7px 0 30px 0;color:#153643;font-family:Arial,sans-serif;font-size:15px;line-height:20px\"> <b>{{_dic[_generatorsService.state.roomDimensions.wallType]}}</b> </td> </tr> </table> </td> </tr> <tr> <td bgcolor=\"#ffffff\"> <table *ngIf=\"pruducts\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\"> <tr *ngFor=\"let product of pruducts\"> <td width=\"100\" valign=\"top\" style=\"padding:20px 0 20px 20px\"> <img *ngIf=\"product && product.images\" src=\"https://virtualspa.mrsteam.com/{{_imgPaths.products}}{{product.images.folder}}{{product.images.thumbnail}}\" alt=\"{{product.name}}\" width=\"100\" height=\"100\" style=\"display:block\"/> </td> <td style=\"font-size:0;line-height:0\" width=\"20\"> &nbsp; </td> <td valign=\"top\" style=\"padding:20px 0 20px 0;color:#999;font-family:Arial,sans-serif;font-size:16px;line-height:18px\"> <b>{{product.partnumber}}{{product.getNameTags()}}</b><br/><br/> <div *ngIf=\"product.options\"> <product-options-dropdown-cmp class=\"dropdown\" *ngFor=\"let optionsListId of product.options.enabledListsIds\" [product]=\"product\" [optionsListId]=\"optionsListId\" [category]=\"category\"> </product-options-dropdown-cmp> </div> <a class=\"download\" target=\"_blank\" [href]=\"product.links.tech\" *ngIf=\"product.links && product.links.tech\">Download Specs</a> <br/><br/> <b>${{product.price}}</b> </td> </tr> </table> </td> </tr> <tr> <td align=\"center\" style=\"font-size:0;line-height:0\" height=\"35\"> &nbsp; </td> </tr> <tr> <td align=\"center\" bgcolor=\"#C7C7C7\" style=\"font-size:0;line-height:0\" height=\"1\"> &nbsp; </td> </tr> <tr> <td style=\"padding:30px 0 5px 0;color:#153643;font-family:Arial,sans-serif;font-size:24px\"> <b>Total Price USD</b> </td> </tr> <tr> <td style=\"color:#153643;font-family:Arial,sans-serif;font-size:32px\"> <b>${{_cartService.state.totalPrice}}.00</b> </td> </tr> </table> </td> </tr> </table> </td> </tr> </table> </div> <hr class=\"divider\"/> <h3 class=\"price-label\">Total Price USD</h3> <div class=\"price\"> ${{_cartService.state.totalPrice}}.00 </div> </div> <div id=\"btnsend\" class=\"link restart\" (click)=\"emailSelectionToAddresses()\">Send</div> ";

/***/ },
/* 847 */
/***/ function(module, exports) {

module.exports = " <div id=\"products-selection\"> <div class=\"header clearfix\"> <div class=\"specs column left\"> <h2 class=\"subtitle\">Shower Dimensions</h2> <div class=\"row clearfix\"> <div class=\"label left\">Lenght:</div> <div class=\"value left\"> <b>{{_roomDimensions.lengthFt}}</b> Ft - <b>{{_roomDimensions.lengthIn}}</b> In </div> </div> <div class=\"row clearfix\"> <div class=\"label left\">Width:</div> <div class=\"value left\"> <b>{{_roomDimensions.widthFt}}</b> Ft - <b>{{_roomDimensions.widthIn}}</b> In </div> </div> <div class=\"row clearfix\"> <div class=\"label left\">Height:</div> <div class=\"value left\"> <b>{{_roomDimensions.heightFt}}</b> Ft - <b>{{_roomDimensions.heightIn}}</b> In </div> </div> <div class=\"row clearfix\"> <div class=\"label left\">Adjusted Room Volume:</div> <div class=\"value left\"> <b>{{_roundRoomVolume(_roomDimensions.cubicFeetAdjusted)}}</b> Cubic ft </div> </div> </div> <div class=\"column left\"> <h2 class=\"subtitle\">Shower Material</h2> <b>{{_dic[_generatorsService.state.roomDimensions.wallType]}}</b> </div> </div> <div id=\"no-generator\" class=\"description active\" *ngIf=\"_generatorCfg.selectedGenerator === null\"> <h2 class=\"subtitle spaced\">No Generator selected</h2> <h2 class=\"title-label\"> Please enter shower room dimensions in: <div class=\"link\"> Generator Calculator </div> </h2> </div> <div id=\"products\" class=\"clearfix\"> <summary-cmp></summary-cmp> <hr class=\"divider\"/> <h3 class=\"price-label\">Total Price USD</h3> <div class=\"price\"> ${{_cartService.state.totalPrice}}.00 </div> </div> <div id=\"contact-dealer\" class=\"button\" (click)=\"_printDiv()\"> Print </div> </div> ";

/***/ },
/* 848 */
/***/ function(module, exports) {

module.exports = " <div class=\"indicator active\"> <svg height=\"24\" width=\"12\"> <polygon points=\"0,0 12,12 0,24\"/> </svg> </div> <ul class=\"categs-list\" *ngIf=\"_rootCategory !== null\"> <li id=\"{{category.id}}-link-container\" class=\"nav-link-container\" *ngFor=\"let category of _rootCategory.subcategories; let i = index;\"> {{i+1}}. <a id=\"{{category.id}}-link\" (click)=\"_selectCategory( category )\"> {{category.menuName}} </a> <products-tiny-list-cmp [products]=\"_catalogService.getAllProducts( category )\"></products-tiny-list-cmp> </li> </ul>";

/***/ },
/* 849 */
/***/ function(module, exports) {

module.exports = " <product-category-cmp id=\"{{_renderCategory.id}}-product-category\" class=\"product-category level-0 clearfix\" [ngClass]=\"{'compact': _renderCategory.renderMode === 'compact',\r\n        'expanded': _renderCategory.renderMode === 'expanded',\r\n        'custom-renderer': _renderCategory.customRenderer !== null }\" *ngIf=\"_renderCategory !== null\" [catalogState]=\"catalogState\" [category]=\"_renderCategory\" [level]=\"0\"> </product-category-cmp>";

/***/ },
/* 850 */
/***/ function(module, exports) {

module.exports = " <div class=\"heading\" *ngIf=\"category.customRenderer === null &&\r\n        category.isVisible === true\"> <h1 class=\"title\" id=\"control-packages-title\" *ngIf=\"category.title !== null\">{{category.title}}</h1> <h2 class=\"subtitle no-margin\" *ngIf=\"category.subtitle !== null\" [ngClass]=\"{underline: category.title === null}\"> {{category.subtitle}} </h2> <h3 class=\"short-description\" *ngIf=\"category.shortDescription !== null\">{{category.shortDescription}}</h3> </div> <div class=\"clearfix subcategory-row\" *ngIf=\"category.customRenderer === null &&\r\n        category.isVisible === true\"> <div *ngFor=\"let subcategory of _compactSubcategories\" class=\"subcategory-wrapper\"> <div class=\"thumbnail categ-thumbnail\" (click)=\"_selectCategory( subcategory )\" *ngIf=\"subcategory.isVisible === true\" [ngClass]=\"{active:subcategory.isSelected === true}\"> <div class=\"actions clearfix\"> <div class=\"action read-more left\" (click)=\"displayCategoryDetails(subcategory)\"> </div> </div> <div class=\"image\" [ngStyle]=\"{'background-image': 'url(' + _catalogService.getCategoryThumbnailPath( subcategory ) + ')'}\"> </div> <a class=\"link\">{{subcategory.menuName}}</a> </div> </div> </div> <products-list-cmp [category]=\"category\" *ngIf=\"category.products.length !== 0 &&\r\n        category.customRenderer === null &&\r\n        category.isVisible === true\"> </products-list-cmp> <div class=\"clearfix\" *ngIf=\"category.customRenderer === null\"> <div *ngFor=\"let subcategory of _expandedSubcategories\"> <product-category-cmp id=\"{{subcategory.id}}-product-category\" class=\"product-category level-{{level + 1}} clearfix\" [ngClass]=\"{'compact': category.renderMode === 'compact',\r\n                'expanded': category.renderMode === 'expanded',\r\n                'custom-renderer': category.customRenderer !== null }\" [catalogState]=\"catalogState\" [category]=\"subcategory\" [level]=\"level + 1\"> </product-category-cmp> </div> </div> <generator-configurator-cmp *ngIf=\"category.customRenderer !== null\"></generator-configurator-cmp>";

/***/ },
/* 851 */
/***/ function(module, exports) {

module.exports = " <div class=\"column image\" *ngIf=\"_appService.selectedProduct\"> <img *ngIf=\"_appService.selectedProduct.images.folder !== false\" src=\"{{_imgPaths.products}}{{_appService.selectedProduct.images.folder}}{{_appService.selectedProduct.images.thumbnail}}\"/> <img *ngIf=\"_appService.selectedProduct.images.folder === false\" src=\"{{_imgPaths.categories}}{{_appService.selectedProduct.images.thumbnail}}\"/> </div> <div *ngIf=\"_appService.selectedProduct\" id=\"product-description\" class=\"column description container\"> <div class=\"content\"> <h2 class=\"title\">{{_appService.selectedProduct.name}}</h2> <div class=\"text long-description\" *ngIf=\"_appService.selectedProduct.descriptions\" [innerHTML]=\"_appService.selectedProduct.descriptions.long\"> </div> <div class=\"text short-description\" *ngIf=\"_appService.selectedProduct.descriptions\" [innerHTML]=\"_appService.selectedProduct.descriptions.tech\"> </div> <br/> <h3 *ngIf=\"_appService.selectedProduct.package &&\r\n            _appService.selectedProduct.package.products.length !== 0\"> Package includes: </h3> <div class=\"text short-description\" *ngIf=\"_appService.selectedProduct.descriptions\" [innerHTML]=\"_appService.selectedProduct.descriptions.parts\"> </div> <br/> <a class=\"download button\" target=\"_blank\" [href]=\"_appService.selectedProduct.links.tech\" *ngIf=\"_appService.selectedProduct.links && _appService.selectedProduct.links.tech\">Download Specs</a> </div> </div>";

/***/ },
/* 852 */
/***/ function(module, exports) {

module.exports = " <div class=\"selected-option selected-dropdown-option\" (click)=\"openOptionDropdown()\"> <div class=\"icon\" [ngStyle]=\"{'background-image': 'url(' + _catalogService.getProductOptionImage( optionsListId, product.options.selected[optionsListId] ) + ')'}\"> </div> <span style=\"font-size:.9em\">{{optionsListId | uppercase}}:</span> {{_catalogService.getProductOptionName( optionsListId, product.options.selected[optionsListId] )}} </div> <div class=\"options-list\" id=\"dropdown-{{product.code}}\" *ngIf=\"_optionsDropdownIsRendered\" [ngClass]=\"{active: _optionsDropdownIsActive}\"> <div class=\"option\" *ngFor=\"let option of product.options.list[optionsListId]\" (mouseover)=\"selectOption( option )\" (click)=\"_onOptionClick()\" (tap)=\"selectOption(option); _onOptionClick()\"> <div class=\"icon\" [ngStyle]=\"{'background-image': 'url(' + _catalogService.getProductOptionImage( optionsListId, option ) + ')'}\"></div> {{_catalogService.getProductOptionName( optionsListId, option )}} </div> </div>";

/***/ },
/* 853 */
/***/ function(module, exports) {

module.exports = " <div id=\"prod-cat-{{category.id}}-row-{{rowIndex}}\" class=\"row clearfix\" *ngFor=\"let row of _productsRows; let rowIndex = index\"> <div id=\"product-{{product.code}}\" class=\"product\" [ngClass]=\"{'is-in-cart': product.isAddedToCart,\r\n            'prevent-opacity': product.options && product.options.dropdownIsActive}\" *ngFor=\"let product of row\"> <div class=\"actions clearfix\"> <div class=\"action read-more left\" (click)=\"product.refreshState();\r\n                    _appService.selectProduct( product );\r\n                    product.displayProductDetails()\"> </div> <div class=\"action preview left\" (click)=\"_appService.togglePreview(); product.addToScene(); product.displayTooltip();\"></div> </div> <div class=\"target-area\" (click)=\"product.toggleInCart( category.id );\"> <img class=\"thumbnail\" src=\"{{_imgPaths.products}}{{product.images.folder}}{{product.images.thumbnail}}\" alt=\"{{product.name}}\"/> <div class=\"caption\">{{product.name}}{{product.getNameTags()}}</div> </div> <div *ngIf=\"product.options\"> <product-options-dropdown-cmp class=\"dropdown\" *ngFor=\"let optionsListId of product.options.enabledListsIds\" [product]=\"product\" [optionsListId]=\"optionsListId\" [category]=\"category\"> </product-options-dropdown-cmp> </div> <div class=\"add-to-cart\" (click)=\"product.toggleInCart( category.id );\" *ngIf=\"product.isAddedToCart === false\"> Add </div> <div class=\"add-to-cart\" (click)=\"product.toggleInCart( category.id );\" *ngIf=\"product.isAddedToCart === true\"> Remove </div> </div> </div>";

/***/ },
/* 854 */
/***/ function(module, exports) {

module.exports = " <div class=\"product\" (click)=\"openScene(); product.displayTooltip()\" [ngClass]=\"{'is-in-cart': product.isAddedToCart, highlighted: product.tooltipIsVisible || product.tooltipIsHovered }\" *ngFor=\"let product of _catProdsInCart\"> <div class=\"info clearfix\"> <div class=\"name left\">{{product.name}}{{product.getNameTags()}}</div> <div class=\"price right\">${{product.getPrice()}}</div> </div> <div class=\"remove\" (click)=\"product.removeFromCart()\"></div> </div>";

/***/ },
/* 855 */
/***/ function(module, exports) {

module.exports = "<div *ngIf=\"product.tooltips && product.tooltips.list\"> <div class=\"click-region-{{product.code}} click-region\" *ngFor=\"let tooltip of product.tooltips.list\" [ngClass]=\"{active: product.tooltipIsVisible}\" [ngStyle]=\"{'top': ( tooltip.top + '%' ),\r\n            'left': ( tooltip.left + '%' ),\r\n            'height': ( tooltip.height + '%' ),\r\n            'width': ( tooltip.width + '%' )}\" (mouseover)=\"mouseOverTooltip( product )\" (mouseout)=\"mouseOutTooltip( product )\" (click)=\"product.displayProductDetails()\"> <div class=\"tooltip tooltip-{{product.code}} {{tooltip.orientation}}\"> {{product.previewname}} <svg height=\"12\" width=\"24\"> <polygon points=\"0,0 12,12 24,0\"></polygon> </svg> </div> </div> </div> ";

/***/ },
/* 856 */
/***/ function(module, exports) {

module.exports = " <div id=\"layers-container\" class=\"content\"> <div class=\"layer spa-frame\" id=\"layer-spa-frame\" *ngIf=\"_appService.state.selectedControl !== null\" [ngStyle]=\"{'background-image': _getSpaFrameImg()}\"> </div> <div class=\"layer generator\" id=\"layer-generator\" *ngIf=\"_appService.state.standardGeneratorIsVisible === true\" [ngStyle]=\"{'background-image': 'url(media/scene/MS-90-400.png)'}\"> </div> <div class=\"layer\" id=\"layer-{{product.code}}\" *ngFor=\"let product of _cartProducts\"> <div class=\"layer\" *ngIf=\"product.images.scene\" [ngStyle]=\"{'background-image': 'url(' + _imgPaths.products + product.images.folder + 'scene/' + product.images.scene + ')'}\"> </div> <div *ngIf=\"product.package && product.package.products\"> <div class=\"layer\" id=\"layer-{{packageProduct.id}}\" *ngFor=\"let packageProduct of product.package.products\" [ngStyle]=\"{'background-image': 'url(' + _imgPaths.products + packageProduct.images.folder + 'scene/' + packageProduct.images.scene + ')'}\"> </div> </div> </div> <div class=\"layer temporary\" id=\"layer-{{product.code}}-temporary\" *ngFor=\"let product of _sceneProducts\"> <div class=\"layer\" *ngIf=\"product.images.scene\" [ngStyle]=\"{'background-image': 'url(' + _imgPaths.products + product.images.folder + 'scene/' + product.images.scene + ')'}\"> </div> <div *ngIf=\"product.package && product.package.products\"> <div class=\"layer\" id=\"layer-{{packageProduct.id}}-temporary\" *ngFor=\"let packageProduct of product.package.products\" [ngStyle]=\"{'background-image': 'url(' + _imgPaths.products + packageProduct.images.folder + 'scene/' + packageProduct.images.scene + ')'}\"> </div> </div> </div> <scene-tooltip-cmp [product]=\"product\" *ngFor=\"let product of _cartProducts\"> </scene-tooltip-cmp> <div class=\"tooltips-container\" *ngFor=\"let product of _cartProducts\"> <div *ngIf=\"product.package && product.package.products\"> <scene-tooltip-cmp [product]=\"packageProduct\" *ngFor=\"let packageProduct of product.package.products\"> </scene-tooltip-cmp> </div> </div> <scene-tooltip-cmp [product]=\"product\" *ngFor=\"let product of _sceneProducts\"> </scene-tooltip-cmp> <div class=\"tooltips-container\" *ngFor=\"let product of _sceneProducts\"> <div *ngIf=\"product.package && product.package.products\"> <scene-tooltip-cmp [product]=\"packageProduct\" *ngFor=\"let packageProduct of product.package.products\"> </scene-tooltip-cmp> </div> </div> </div>";

/***/ },
/* 857 */
/***/ function(module, exports) {

module.exports = " <div id=\"product-{{product.code}}\" class=\"product {{product.taxonomy.currentCategoryId}}\" *ngFor=\"let product of _cartService.cartProducts\"> <img class=\"thumbnail\" src=\"{{_imgPaths.products}}{{product.images.folder}}{{product.images.thumbnail}}\" alt=\"{{product.name}}\"/> <div class=\"caption\">{{product.partnumber}}{{product.getNameTagsSummary()}}</div> <div *ngIf=\"product.options\" class=\"clearfix\"> <product-options-dropdown-cmp class=\"dropdown left\" *ngFor=\"let optionsListId of product.options.enabledListsIds\" [product]=\"product\" [optionsListId]=\"optionsListId\"> </product-options-dropdown-cmp> </div> <a class=\"download\" target=\"_blank\" [href]=\"product.links.tech\" *ngIf=\"product.links && product.links.tech\">Download Specs</a> <div class=\"price\">${{product.price}}</div> <div class=\"remove\" (click)=\"product.removeFromCart()\"></div> </div>";

/***/ },
/* 858 */
/***/ function(module, exports) {

module.exports = " <div class=\"black-bgr\" (click)=\"modalClosed.emit( null )\"></div> <div class=\"link close\" (click)=\"modalClosed.emit( null )\"></div> <div id=\"print-modal\" class=\"body summary\"> <ng-content></ng-content> </div> ";

/***/ },
/* 859 */
/***/ function(module, exports) {

module.exports = " <div class=\"link close\" (click)=\"_appService.hideNavigationMenu()\" [ngClass]=\"{active: _appService.state.app.navigationMenuIsVisible}\"></div> <div id=\"nav-menu\" class=\"menu container\"> <div class=\"content\"> <div class=\"header\"> <div class=\"logo\" (click)=\" _navigationService.openCatalogPage(); _appCatalogService.selectCategory( 'generators' );\"></div> <div class=\"tagline\"><p>Plan and customize your steam<br> shower with VIRTUAL SPA SYSTEM ®</p></div> </div> <product-categories-list-cmp [catalogState]=\"_appService.state.catalog\" (categorySelected)=\" _navigationService.openCatalogPage(); _appCatalogService.selectCategory( $event );\"> </product-categories-list-cmp> <div class=\"preview-img\" (click)=\"_appService.togglePreview()\"> <div class=\"label preview\" [ngClass]=\"{active: _appService.state.app.previewIsVisible === false}\"> Preview </div> <div class=\"label catalog\" [ngClass]=\"{active: _appService.state.app.previewIsVisible === true}\"> Close Preview </div> </div> <div class=\"total\"> <div class=\"label\">Total Suggested Retail Price</div> <div class=\"price\">${{_cartService.state.totalPrice}}.00</div> <a class=\"summary\" *ngIf=\"_navigationService.state.currentPage === 'catalog'\" (click)=\"_navigationService.openSummaryPage()\"> View Summary </a> <a class=\"summary\" *ngIf=\"_navigationService.state.currentPage === 'summary'\" (click)=\"_navigationService.openCatalogPage()\"> Return to Catalog </a> <div id=\"summary-indicator\"> <svg height=\"24\" width=\"12\"> <polygon points=\"0,0 12,12 0,24\"/> </svg> </div> </div> </div> </div> ";

/***/ },
/* 860 */
/***/ function(module, exports) {

module.exports = " <div class=\"content\"> <div class=\"link close\" (click)=\"_appService.hideOptionsMenu()\">Close</div> <div class=\"menu\"> <div class=\"link print\" (click)=\"_appService.hideOptionsMenu(); _appService.displayPrintSummaryModal();\">Print</div> <div class=\"link email\" (click)=\"_appService.hideOptionsMenu(); _appService.displayEmailSummaryModal();\">Email</div> <a class=\"link dealer cta_button\" id=\"cta_button_197381_b1203cd0-e010-4b25-9fdb-3d6c2efca56e\" target=\"_blank\" href=\"https://www.mrsteam.com/find-a-dealer/?hsCtaTracking=fc10f4e6-aa29-4ec6-9ce4-257e7795e0f1%7Cbbd66452-5803-4fef-9749-963086b76bbf\" title=\"Dealer Locator\" class=\"link dealer\">Dealer Locator</a> <div class=\"link restart\" (click)=\"_appService.hideOptionsMenu(); _cartService.emptyCart();\r\n                      _navigationService.openCatalogPage();\r\n                      _generatorsService.resetCalculatorInputs();\r\n                      _appCatalogService.selectCategory({ category: 'generators' });\"> Start Over </div> </div> <div class=\"newsletter\"> <div class=\"tagline\">Talk to a Mr Steam representative</div> <div class=\"phone\">1-800-76-STEAM</div> <a href=\"http://blog.mrsteam.com/subscribe-to-mr-steams-steamtherapy-blog\" target=\"_blank\" class=\"link subscribe\"> Subscribe to our Newsletter </a> </div> <div class=\"social-links clearfix\"> <a href=\"http://www.linkedin.com/company/mr.steam\" target=\"_blank\" class=\"link icon linkedin left\"></a> <a href=\"http://www.facebook.com/mrsteamtherapy\" target=\"_blank\" class=\"link icon facebook left\"></a> <a href=\"http://twitter.com/#!/steamtherapy\" target=\"_blank\" class=\"link icon twitter left\"></a> <a href=\"http://mrsteam.com\" target=\"_blank\" class=\"link icon google-plus left\"></a> </div> </div> ";

/***/ },
/* 861 */
/***/ function(module, exports) {

module.exports = " <div class=\"mobile-logo\" (click)=\"_appService.displayNavigationMenu()\"></div> <div class=\"icon navigation-cart active\" (click)=\"_appService.toggleNavigationMenu()\"> Product Categories </div> <div class=\"icon options-menu active\" (click)=\"_appService.displayOptionsMenu()\"> Options </div> <div class=\"icon add-generator\" (click)=\"_navigationService.openCatalogPage();\r\n     _appCatalogService.selectCategory({ category: 'generators' });\" [ngClass]=\"{active: _appCatalogService.globals.selectedGenerator === null &&\r\n        _appService.state.catalog.currentCategoryId !== 'generators'}\"> Select a generator </div> <div class=\"icon preview active\" (click)=\"_appService.togglePreview()\"> Preview Your Spa </div> ";

/***/ },
/* 862 */
/***/ function(module, exports) {

module.exports = " <div class=\"label left\"> Configure Generator </div> <svg class=\"arrow left\"> <polygon points=\"0,0 30,47 0,94\"/> </svg> <svg class=\"arrow-big left\"> <polygon points=\"0,0 40,60 0,120\"/> </svg>";

/***/ },
/* 863 */
/***/ function(module, exports) {

module.exports = " <div class=\"black-bgr\" (click)=\"modalClosed.emit( null )\"></div> <div class=\"link close\" (click)=\"modalClosed.emit( null )\"></div> <div id=\"print-modal\" class=\"body summary\"> <ng-content></ng-content> </div> ";

/***/ },
/* 864 */
/***/ function(module, exports) {

module.exports = " <div class=\"content\"> <div class=\"col-md-12\"> <h1 class=\"title\"> {{'shared.errorMessage.404NotFound' | translate}} </h1> </div> </div>";

/***/ },
/* 865 */,
/* 866 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var modal_1 = __webpack_require__(151);
var AutofocusDirective = (function () {
    function AutofocusDirective(el, modal) {
        var _this = this;
        this.el = el;
        this.modal = modal;
        if (modal) {
            this.modal.onOpen.subscribe(function () {
                _this.el.nativeElement.focus();
            });
        }
    }
    AutofocusDirective.decorators = [
        { type: core_1.Directive, args: [{
                    selector: '[autofocus]'
                },] },
    ];
    /** @nocollapse */
    AutofocusDirective.ctorParameters = [
        { type: core_1.ElementRef, },
        { type: modal_1.ModalComponent, decorators: [{ type: core_1.Optional },] },
    ];
    return AutofocusDirective;
}());
exports.AutofocusDirective = AutofocusDirective;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXV0b2ZvY3VzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL25nMi1iczMtbW9kYWwvZGlyZWN0aXZlcy9hdXRvZm9jdXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLHFCQUF3RCxlQUFlLENBQUMsQ0FBQTtBQUN4RSxzQkFBK0IscUJBQXFCLENBQUMsQ0FBQTtBQUdyRDtJQUNJLDRCQUFvQixFQUFjLEVBQVcsS0FBcUI7UUFEdEUsaUJBa0JDO1FBakJ1QixPQUFFLEdBQUYsRUFBRSxDQUFZO1FBQVcsVUFBSyxHQUFMLEtBQUssQ0FBZ0I7UUFDOUQsRUFBRSxDQUFDLENBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQztZQUNSLElBQUksQ0FBQyxLQUFLLENBQUMsTUFBTSxDQUFDLFNBQVMsQ0FBQztnQkFDeEIsS0FBSSxDQUFDLEVBQUUsQ0FBQyxhQUFhLENBQUMsS0FBSyxFQUFFLENBQUM7WUFDbEMsQ0FBQyxDQUFDLENBQUM7UUFDUCxDQUFDO0lBQ0wsQ0FBQztJQUNFLDZCQUFVLEdBQTBCO1FBQzNDLEVBQUUsSUFBSSxFQUFFLGdCQUFTLEVBQUUsSUFBSSxFQUFFLENBQUM7b0JBQ3RCLFFBQVEsRUFBRSxhQUFhO2lCQUMxQixFQUFHLEVBQUU7S0FDTCxDQUFDO0lBQ0Ysa0JBQWtCO0lBQ1gsaUNBQWMsR0FBNkQ7UUFDbEYsRUFBQyxJQUFJLEVBQUUsaUJBQVUsR0FBRztRQUNwQixFQUFDLElBQUksRUFBRSxzQkFBYyxFQUFFLFVBQVUsRUFBRSxDQUFDLEVBQUUsSUFBSSxFQUFFLGVBQVEsRUFBRSxFQUFHLEVBQUM7S0FDekQsQ0FBQztJQUNGLHlCQUFDO0FBQUQsQ0FBQyxBQWxCRCxJQWtCQztBQWxCWSwwQkFBa0IscUJBa0I5QixDQUFBIn0=

/***/ },
/* 867 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_common__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ng2_page_scroll_service__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ng2_page_scroll_directive__ = __webpack_require__(473);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return Ng2PageScrollModule; });
/**
 * Created by sebastianfuss on 03.09.16.
 */




var Ng2PageScrollModule = (function () {
    function Ng2PageScrollModule() {
    }
    Ng2PageScrollModule.forRoot = function () {
        return {
            ngModule: Ng2PageScrollModule,
            providers: [
                { provide: __WEBPACK_IMPORTED_MODULE_2__ng2_page_scroll_service__["a" /* PageScrollService */], useClass: __WEBPACK_IMPORTED_MODULE_2__ng2_page_scroll_service__["a" /* PageScrollService */] }
            ]
        };
    };
    return Ng2PageScrollModule;
}());

Ng2PageScrollModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModule"], args: [{
                imports: [__WEBPACK_IMPORTED_MODULE_0__angular_common__["CommonModule"]],
                declarations: [__WEBPACK_IMPORTED_MODULE_3__ng2_page_scroll_directive__["a" /* PageScroll */]],
                exports: [__WEBPACK_IMPORTED_MODULE_3__ng2_page_scroll_directive__["a" /* PageScroll */]]
            },] },
];
/** @nocollapse */
Ng2PageScrollModule.ctorParameters = function () { return []; };


/***/ },
/* 868 */
/***/ function(module, exports) {

"use strict";
'use strict';

var EventElement = function (element) {
  this.element = element;
  this.events = {};
};

EventElement.prototype.bind = function (eventName, handler) {
  if (typeof this.events[eventName] === 'undefined') {
    this.events[eventName] = [];
  }
  this.events[eventName].push(handler);
  this.element.addEventListener(eventName, handler, false);
};

EventElement.prototype.unbind = function (eventName, handler) {
  var isHandlerProvided = (typeof handler !== 'undefined');
  this.events[eventName] = this.events[eventName].filter(function (hdlr) {
    if (isHandlerProvided && hdlr !== handler) {
      return true;
    }
    this.element.removeEventListener(eventName, hdlr, false);
    return false;
  }, this);
};

EventElement.prototype.unbindAll = function () {
  for (var name in this.events) {
    this.unbind(name);
  }
};

var EventManager = function () {
  this.eventElements = [];
};

EventManager.prototype.eventElement = function (element) {
  var ee = this.eventElements.filter(function (eventElement) {
    return eventElement.element === element;
  })[0];
  if (typeof ee === 'undefined') {
    ee = new EventElement(element);
    this.eventElements.push(ee);
  }
  return ee;
};

EventManager.prototype.bind = function (element, eventName, handler) {
  this.eventElement(element).bind(eventName, handler);
};

EventManager.prototype.unbind = function (element, eventName, handler) {
  this.eventElement(element).unbind(eventName, handler);
};

EventManager.prototype.unbindAll = function () {
  for (var i = 0; i < this.eventElements.length; i++) {
    this.eventElements[i].unbindAll();
  }
};

EventManager.prototype.once = function (element, eventName, handler) {
  var ee = this.eventElement(element);
  var onceHandler = function (e) {
    ee.unbind(eventName, onceHandler);
    handler(e);
  };
  ee.bind(eventName, onceHandler);
};

module.exports = EventManager;


/***/ },
/* 869 */
/***/ function(module, exports) {

"use strict";
'use strict';

module.exports = (function () {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
               .toString(16)
               .substring(1);
  }
  return function () {
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
           s4() + '-' + s4() + s4() + s4();
  };
})();


/***/ },
/* 870 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var destroy = __webpack_require__(872);
var initialize = __webpack_require__(880);
var update = __webpack_require__(881);

module.exports = {
  initialize: initialize,
  update: update,
  destroy: destroy
};


/***/ },
/* 871 */
/***/ function(module, exports) {

"use strict";
'use strict';

module.exports = {
  handlers: ['click-rail', 'drag-scrollbar', 'keyboard', 'wheel', 'touch'],
  maxScrollbarLength: null,
  minScrollbarLength: null,
  scrollXMarginOffset: 0,
  scrollYMarginOffset: 0,
  suppressScrollX: false,
  suppressScrollY: false,
  swipePropagation: true,
  useBothWheelAxes: false,
  wheelPropagation: false,
  wheelSpeed: 1,
  theme: 'default'
};


/***/ },
/* 872 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _ = __webpack_require__(68);
var dom = __webpack_require__(107);
var instances = __webpack_require__(39);

module.exports = function (element) {
  var i = instances.get(element);

  if (!i) {
    return;
  }

  i.event.unbindAll();
  dom.remove(i.scrollbarX);
  dom.remove(i.scrollbarY);
  dom.remove(i.scrollbarXRail);
  dom.remove(i.scrollbarYRail);
  _.removePsClasses(element);

  instances.remove(element);
};


/***/ },
/* 873 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var instances = __webpack_require__(39);
var updateGeometry = __webpack_require__(69);
var updateScroll = __webpack_require__(87);

function bindClickRailHandler(element, i) {
  function pageOffset(el) {
    return el.getBoundingClientRect();
  }
  var stopPropagation = function (e) { e.stopPropagation(); };

  i.event.bind(i.scrollbarY, 'click', stopPropagation);
  i.event.bind(i.scrollbarYRail, 'click', function (e) {
    var positionTop = e.pageY - window.pageYOffset - pageOffset(i.scrollbarYRail).top;
    var direction = positionTop > i.scrollbarYTop ? 1 : -1;

    updateScroll(element, 'top', element.scrollTop + direction * i.containerHeight);
    updateGeometry(element);

    e.stopPropagation();
  });

  i.event.bind(i.scrollbarX, 'click', stopPropagation);
  i.event.bind(i.scrollbarXRail, 'click', function (e) {
    var positionLeft = e.pageX - window.pageXOffset - pageOffset(i.scrollbarXRail).left;
    var direction = positionLeft > i.scrollbarXLeft ? 1 : -1;

    updateScroll(element, 'left', element.scrollLeft + direction * i.containerWidth);
    updateGeometry(element);

    e.stopPropagation();
  });
}

module.exports = function (element) {
  var i = instances.get(element);
  bindClickRailHandler(element, i);
};


/***/ },
/* 874 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _ = __webpack_require__(68);
var dom = __webpack_require__(107);
var instances = __webpack_require__(39);
var updateGeometry = __webpack_require__(69);
var updateScroll = __webpack_require__(87);

function bindMouseScrollXHandler(element, i) {
  var currentLeft = null;
  var currentPageX = null;

  function updateScrollLeft(deltaX) {
    var newLeft = currentLeft + (deltaX * i.railXRatio);
    var maxLeft = Math.max(0, i.scrollbarXRail.getBoundingClientRect().left) + (i.railXRatio * (i.railXWidth - i.scrollbarXWidth));

    if (newLeft < 0) {
      i.scrollbarXLeft = 0;
    } else if (newLeft > maxLeft) {
      i.scrollbarXLeft = maxLeft;
    } else {
      i.scrollbarXLeft = newLeft;
    }

    var scrollLeft = _.toInt(i.scrollbarXLeft * (i.contentWidth - i.containerWidth) / (i.containerWidth - (i.railXRatio * i.scrollbarXWidth))) - i.negativeScrollAdjustment;
    updateScroll(element, 'left', scrollLeft);
  }

  var mouseMoveHandler = function (e) {
    updateScrollLeft(e.pageX - currentPageX);
    updateGeometry(element);
    e.stopPropagation();
    e.preventDefault();
  };

  var mouseUpHandler = function () {
    _.stopScrolling(element, 'x');
    i.event.unbind(i.ownerDocument, 'mousemove', mouseMoveHandler);
  };

  i.event.bind(i.scrollbarX, 'mousedown', function (e) {
    currentPageX = e.pageX;
    currentLeft = _.toInt(dom.css(i.scrollbarX, 'left')) * i.railXRatio;
    _.startScrolling(element, 'x');

    i.event.bind(i.ownerDocument, 'mousemove', mouseMoveHandler);
    i.event.once(i.ownerDocument, 'mouseup', mouseUpHandler);

    e.stopPropagation();
    e.preventDefault();
  });
}

function bindMouseScrollYHandler(element, i) {
  var currentTop = null;
  var currentPageY = null;

  function updateScrollTop(deltaY) {
    var newTop = currentTop + (deltaY * i.railYRatio);
    var maxTop = Math.max(0, i.scrollbarYRail.getBoundingClientRect().top) + (i.railYRatio * (i.railYHeight - i.scrollbarYHeight));

    if (newTop < 0) {
      i.scrollbarYTop = 0;
    } else if (newTop > maxTop) {
      i.scrollbarYTop = maxTop;
    } else {
      i.scrollbarYTop = newTop;
    }

    var scrollTop = _.toInt(i.scrollbarYTop * (i.contentHeight - i.containerHeight) / (i.containerHeight - (i.railYRatio * i.scrollbarYHeight)));
    updateScroll(element, 'top', scrollTop);
  }

  var mouseMoveHandler = function (e) {
    updateScrollTop(e.pageY - currentPageY);
    updateGeometry(element);
    e.stopPropagation();
    e.preventDefault();
  };

  var mouseUpHandler = function () {
    _.stopScrolling(element, 'y');
    i.event.unbind(i.ownerDocument, 'mousemove', mouseMoveHandler);
  };

  i.event.bind(i.scrollbarY, 'mousedown', function (e) {
    currentPageY = e.pageY;
    currentTop = _.toInt(dom.css(i.scrollbarY, 'top')) * i.railYRatio;
    _.startScrolling(element, 'y');

    i.event.bind(i.ownerDocument, 'mousemove', mouseMoveHandler);
    i.event.once(i.ownerDocument, 'mouseup', mouseUpHandler);

    e.stopPropagation();
    e.preventDefault();
  });
}

module.exports = function (element) {
  var i = instances.get(element);
  bindMouseScrollXHandler(element, i);
  bindMouseScrollYHandler(element, i);
};


/***/ },
/* 875 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _ = __webpack_require__(68);
var dom = __webpack_require__(107);
var instances = __webpack_require__(39);
var updateGeometry = __webpack_require__(69);
var updateScroll = __webpack_require__(87);

function bindKeyboardHandler(element, i) {
  var hovered = false;
  i.event.bind(element, 'mouseenter', function () {
    hovered = true;
  });
  i.event.bind(element, 'mouseleave', function () {
    hovered = false;
  });

  var shouldPrevent = false;
  function shouldPreventDefault(deltaX, deltaY) {
    var scrollTop = element.scrollTop;
    if (deltaX === 0) {
      if (!i.scrollbarYActive) {
        return false;
      }
      if ((scrollTop === 0 && deltaY > 0) || (scrollTop >= i.contentHeight - i.containerHeight && deltaY < 0)) {
        return !i.settings.wheelPropagation;
      }
    }

    var scrollLeft = element.scrollLeft;
    if (deltaY === 0) {
      if (!i.scrollbarXActive) {
        return false;
      }
      if ((scrollLeft === 0 && deltaX < 0) || (scrollLeft >= i.contentWidth - i.containerWidth && deltaX > 0)) {
        return !i.settings.wheelPropagation;
      }
    }
    return true;
  }

  i.event.bind(i.ownerDocument, 'keydown', function (e) {
    if ((e.isDefaultPrevented && e.isDefaultPrevented()) || e.defaultPrevented) {
      return;
    }

    var focused = dom.matches(i.scrollbarX, ':focus') ||
                  dom.matches(i.scrollbarY, ':focus');

    if (!hovered && !focused) {
      return;
    }

    var activeElement = document.activeElement ? document.activeElement : i.ownerDocument.activeElement;
    if (activeElement) {
      if (activeElement.tagName === 'IFRAME') {
        activeElement = activeElement.contentDocument.activeElement;
      } else {
        // go deeper if element is a webcomponent
        while (activeElement.shadowRoot) {
          activeElement = activeElement.shadowRoot.activeElement;
        }
      }
      if (_.isEditable(activeElement)) {
        return;
      }
    }

    var deltaX = 0;
    var deltaY = 0;

    switch (e.which) {
    case 37: // left
      if (e.metaKey) {
        deltaX = -i.contentWidth;
      } else if (e.altKey) {
        deltaX = -i.containerWidth;
      } else {
        deltaX = -30;
      }
      break;
    case 38: // up
      if (e.metaKey) {
        deltaY = i.contentHeight;
      } else if (e.altKey) {
        deltaY = i.containerHeight;
      } else {
        deltaY = 30;
      }
      break;
    case 39: // right
      if (e.metaKey) {
        deltaX = i.contentWidth;
      } else if (e.altKey) {
        deltaX = i.containerWidth;
      } else {
        deltaX = 30;
      }
      break;
    case 40: // down
      if (e.metaKey) {
        deltaY = -i.contentHeight;
      } else if (e.altKey) {
        deltaY = -i.containerHeight;
      } else {
        deltaY = -30;
      }
      break;
    case 33: // page up
      deltaY = 90;
      break;
    case 32: // space bar
      if (e.shiftKey) {
        deltaY = 90;
      } else {
        deltaY = -90;
      }
      break;
    case 34: // page down
      deltaY = -90;
      break;
    case 35: // end
      if (e.ctrlKey) {
        deltaY = -i.contentHeight;
      } else {
        deltaY = -i.containerHeight;
      }
      break;
    case 36: // home
      if (e.ctrlKey) {
        deltaY = element.scrollTop;
      } else {
        deltaY = i.containerHeight;
      }
      break;
    default:
      return;
    }

    updateScroll(element, 'top', element.scrollTop - deltaY);
    updateScroll(element, 'left', element.scrollLeft + deltaX);
    updateGeometry(element);

    shouldPrevent = shouldPreventDefault(deltaX, deltaY);
    if (shouldPrevent) {
      e.preventDefault();
    }
  });
}

module.exports = function (element) {
  var i = instances.get(element);
  bindKeyboardHandler(element, i);
};


/***/ },
/* 876 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var instances = __webpack_require__(39);
var updateGeometry = __webpack_require__(69);
var updateScroll = __webpack_require__(87);

function bindMouseWheelHandler(element, i) {
  var shouldPrevent = false;

  function shouldPreventDefault(deltaX, deltaY) {
    var scrollTop = element.scrollTop;
    if (deltaX === 0) {
      if (!i.scrollbarYActive) {
        return false;
      }
      if ((scrollTop === 0 && deltaY > 0) || (scrollTop >= i.contentHeight - i.containerHeight && deltaY < 0)) {
        return !i.settings.wheelPropagation;
      }
    }

    var scrollLeft = element.scrollLeft;
    if (deltaY === 0) {
      if (!i.scrollbarXActive) {
        return false;
      }
      if ((scrollLeft === 0 && deltaX < 0) || (scrollLeft >= i.contentWidth - i.containerWidth && deltaX > 0)) {
        return !i.settings.wheelPropagation;
      }
    }
    return true;
  }

  function getDeltaFromEvent(e) {
    var deltaX = e.deltaX;
    var deltaY = -1 * e.deltaY;

    if (typeof deltaX === "undefined" || typeof deltaY === "undefined") {
      // OS X Safari
      deltaX = -1 * e.wheelDeltaX / 6;
      deltaY = e.wheelDeltaY / 6;
    }

    if (e.deltaMode && e.deltaMode === 1) {
      // Firefox in deltaMode 1: Line scrolling
      deltaX *= 10;
      deltaY *= 10;
    }

    if (deltaX !== deltaX && deltaY !== deltaY/* NaN checks */) {
      // IE in some mouse drivers
      deltaX = 0;
      deltaY = e.wheelDelta;
    }

    if (e.shiftKey) {
      // reverse axis with shift key
      return [-deltaY, -deltaX];
    }
    return [deltaX, deltaY];
  }

  function shouldBeConsumedByChild(deltaX, deltaY) {
    var child = element.querySelector('textarea:hover, select[multiple]:hover, .ps-child:hover');
    if (child) {
      if (!window.getComputedStyle(child).overflow.match(/(scroll|auto)/)) {
        // if not scrollable
        return false;
      }

      var maxScrollTop = child.scrollHeight - child.clientHeight;
      if (maxScrollTop > 0) {
        if (!(child.scrollTop === 0 && deltaY > 0) && !(child.scrollTop === maxScrollTop && deltaY < 0)) {
          return true;
        }
      }
      var maxScrollLeft = child.scrollLeft - child.clientWidth;
      if (maxScrollLeft > 0) {
        if (!(child.scrollLeft === 0 && deltaX < 0) && !(child.scrollLeft === maxScrollLeft && deltaX > 0)) {
          return true;
        }
      }
    }
    return false;
  }

  function mousewheelHandler(e) {
    var delta = getDeltaFromEvent(e);

    var deltaX = delta[0];
    var deltaY = delta[1];

    if (shouldBeConsumedByChild(deltaX, deltaY)) {
      return;
    }

    shouldPrevent = false;
    if (!i.settings.useBothWheelAxes) {
      // deltaX will only be used for horizontal scrolling and deltaY will
      // only be used for vertical scrolling - this is the default
      updateScroll(element, 'top', element.scrollTop - (deltaY * i.settings.wheelSpeed));
      updateScroll(element, 'left', element.scrollLeft + (deltaX * i.settings.wheelSpeed));
    } else if (i.scrollbarYActive && !i.scrollbarXActive) {
      // only vertical scrollbar is active and useBothWheelAxes option is
      // active, so let's scroll vertical bar using both mouse wheel axes
      if (deltaY) {
        updateScroll(element, 'top', element.scrollTop - (deltaY * i.settings.wheelSpeed));
      } else {
        updateScroll(element, 'top', element.scrollTop + (deltaX * i.settings.wheelSpeed));
      }
      shouldPrevent = true;
    } else if (i.scrollbarXActive && !i.scrollbarYActive) {
      // useBothWheelAxes and only horizontal bar is active, so use both
      // wheel axes for horizontal bar
      if (deltaX) {
        updateScroll(element, 'left', element.scrollLeft + (deltaX * i.settings.wheelSpeed));
      } else {
        updateScroll(element, 'left', element.scrollLeft - (deltaY * i.settings.wheelSpeed));
      }
      shouldPrevent = true;
    }

    updateGeometry(element);

    shouldPrevent = (shouldPrevent || shouldPreventDefault(deltaX, deltaY));
    if (shouldPrevent) {
      e.stopPropagation();
      e.preventDefault();
    }
  }

  if (typeof window.onwheel !== "undefined") {
    i.event.bind(element, 'wheel', mousewheelHandler);
  } else if (typeof window.onmousewheel !== "undefined") {
    i.event.bind(element, 'mousewheel', mousewheelHandler);
  }
}

module.exports = function (element) {
  var i = instances.get(element);
  bindMouseWheelHandler(element, i);
};


/***/ },
/* 877 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var instances = __webpack_require__(39);
var updateGeometry = __webpack_require__(69);

function bindNativeScrollHandler(element, i) {
  i.event.bind(element, 'scroll', function () {
    updateGeometry(element);
  });
}

module.exports = function (element) {
  var i = instances.get(element);
  bindNativeScrollHandler(element, i);
};


/***/ },
/* 878 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _ = __webpack_require__(68);
var instances = __webpack_require__(39);
var updateGeometry = __webpack_require__(69);
var updateScroll = __webpack_require__(87);

function bindSelectionHandler(element, i) {
  function getRangeNode() {
    var selection = window.getSelection ? window.getSelection() :
                    document.getSelection ? document.getSelection() : '';
    if (selection.toString().length === 0) {
      return null;
    } else {
      return selection.getRangeAt(0).commonAncestorContainer;
    }
  }

  var scrollingLoop = null;
  var scrollDiff = {top: 0, left: 0};
  function startScrolling() {
    if (!scrollingLoop) {
      scrollingLoop = setInterval(function () {
        if (!instances.get(element)) {
          clearInterval(scrollingLoop);
          return;
        }

        updateScroll(element, 'top', element.scrollTop + scrollDiff.top);
        updateScroll(element, 'left', element.scrollLeft + scrollDiff.left);
        updateGeometry(element);
      }, 50); // every .1 sec
    }
  }
  function stopScrolling() {
    if (scrollingLoop) {
      clearInterval(scrollingLoop);
      scrollingLoop = null;
    }
    _.stopScrolling(element);
  }

  var isSelected = false;
  i.event.bind(i.ownerDocument, 'selectionchange', function () {
    if (element.contains(getRangeNode())) {
      isSelected = true;
    } else {
      isSelected = false;
      stopScrolling();
    }
  });
  i.event.bind(window, 'mouseup', function () {
    if (isSelected) {
      isSelected = false;
      stopScrolling();
    }
  });
  i.event.bind(window, 'keyup', function () {
    if (isSelected) {
      isSelected = false;
      stopScrolling();
    }
  });

  i.event.bind(window, 'mousemove', function (e) {
    if (isSelected) {
      var mousePosition = {x: e.pageX, y: e.pageY};
      var containerGeometry = {
        left: element.offsetLeft,
        right: element.offsetLeft + element.offsetWidth,
        top: element.offsetTop,
        bottom: element.offsetTop + element.offsetHeight
      };

      if (mousePosition.x < containerGeometry.left + 3) {
        scrollDiff.left = -5;
        _.startScrolling(element, 'x');
      } else if (mousePosition.x > containerGeometry.right - 3) {
        scrollDiff.left = 5;
        _.startScrolling(element, 'x');
      } else {
        scrollDiff.left = 0;
      }

      if (mousePosition.y < containerGeometry.top + 3) {
        if (containerGeometry.top + 3 - mousePosition.y < 5) {
          scrollDiff.top = -5;
        } else {
          scrollDiff.top = -20;
        }
        _.startScrolling(element, 'y');
      } else if (mousePosition.y > containerGeometry.bottom - 3) {
        if (mousePosition.y - containerGeometry.bottom + 3 < 5) {
          scrollDiff.top = 5;
        } else {
          scrollDiff.top = 20;
        }
        _.startScrolling(element, 'y');
      } else {
        scrollDiff.top = 0;
      }

      if (scrollDiff.top === 0 && scrollDiff.left === 0) {
        stopScrolling();
      } else {
        startScrolling();
      }
    }
  });
}

module.exports = function (element) {
  var i = instances.get(element);
  bindSelectionHandler(element, i);
};


/***/ },
/* 879 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _ = __webpack_require__(68);
var instances = __webpack_require__(39);
var updateGeometry = __webpack_require__(69);
var updateScroll = __webpack_require__(87);

function bindTouchHandler(element, i, supportsTouch, supportsIePointer) {
  function shouldPreventDefault(deltaX, deltaY) {
    var scrollTop = element.scrollTop;
    var scrollLeft = element.scrollLeft;
    var magnitudeX = Math.abs(deltaX);
    var magnitudeY = Math.abs(deltaY);

    if (magnitudeY > magnitudeX) {
      // user is perhaps trying to swipe up/down the page

      if (((deltaY < 0) && (scrollTop === i.contentHeight - i.containerHeight)) ||
          ((deltaY > 0) && (scrollTop === 0))) {
        return !i.settings.swipePropagation;
      }
    } else if (magnitudeX > magnitudeY) {
      // user is perhaps trying to swipe left/right across the page

      if (((deltaX < 0) && (scrollLeft === i.contentWidth - i.containerWidth)) ||
          ((deltaX > 0) && (scrollLeft === 0))) {
        return !i.settings.swipePropagation;
      }
    }

    return true;
  }

  function applyTouchMove(differenceX, differenceY) {
    updateScroll(element, 'top', element.scrollTop - differenceY);
    updateScroll(element, 'left', element.scrollLeft - differenceX);

    updateGeometry(element);
  }

  var startOffset = {};
  var startTime = 0;
  var speed = {};
  var easingLoop = null;
  var inGlobalTouch = false;
  var inLocalTouch = false;

  function globalTouchStart() {
    inGlobalTouch = true;
  }
  function globalTouchEnd() {
    inGlobalTouch = false;
  }

  function getTouch(e) {
    if (e.targetTouches) {
      return e.targetTouches[0];
    } else {
      // Maybe IE pointer
      return e;
    }
  }
  function shouldHandle(e) {
    if (e.targetTouches && e.targetTouches.length === 1) {
      return true;
    }
    if (e.pointerType && e.pointerType !== 'mouse' && e.pointerType !== e.MSPOINTER_TYPE_MOUSE) {
      return true;
    }
    return false;
  }
  function touchStart(e) {
    if (shouldHandle(e)) {
      inLocalTouch = true;

      var touch = getTouch(e);

      startOffset.pageX = touch.pageX;
      startOffset.pageY = touch.pageY;

      startTime = (new Date()).getTime();

      if (easingLoop !== null) {
        clearInterval(easingLoop);
      }

      e.stopPropagation();
    }
  }
  function touchMove(e) {
    if (!inLocalTouch && i.settings.swipePropagation) {
      touchStart(e);
    }
    if (!inGlobalTouch && inLocalTouch && shouldHandle(e)) {
      var touch = getTouch(e);

      var currentOffset = {pageX: touch.pageX, pageY: touch.pageY};

      var differenceX = currentOffset.pageX - startOffset.pageX;
      var differenceY = currentOffset.pageY - startOffset.pageY;

      applyTouchMove(differenceX, differenceY);
      startOffset = currentOffset;

      var currentTime = (new Date()).getTime();

      var timeGap = currentTime - startTime;
      if (timeGap > 0) {
        speed.x = differenceX / timeGap;
        speed.y = differenceY / timeGap;
        startTime = currentTime;
      }

      if (shouldPreventDefault(differenceX, differenceY)) {
        e.stopPropagation();
        e.preventDefault();
      }
    }
  }
  function touchEnd() {
    if (!inGlobalTouch && inLocalTouch) {
      inLocalTouch = false;

      clearInterval(easingLoop);
      easingLoop = setInterval(function () {
        if (!instances.get(element)) {
          clearInterval(easingLoop);
          return;
        }

        if (!speed.x && !speed.y) {
          clearInterval(easingLoop);
          return;
        }

        if (Math.abs(speed.x) < 0.01 && Math.abs(speed.y) < 0.01) {
          clearInterval(easingLoop);
          return;
        }

        applyTouchMove(speed.x * 30, speed.y * 30);

        speed.x *= 0.8;
        speed.y *= 0.8;
      }, 10);
    }
  }

  if (supportsTouch) {
    i.event.bind(window, 'touchstart', globalTouchStart);
    i.event.bind(window, 'touchend', globalTouchEnd);
    i.event.bind(element, 'touchstart', touchStart);
    i.event.bind(element, 'touchmove', touchMove);
    i.event.bind(element, 'touchend', touchEnd);
  } else if (supportsIePointer) {
    if (window.PointerEvent) {
      i.event.bind(window, 'pointerdown', globalTouchStart);
      i.event.bind(window, 'pointerup', globalTouchEnd);
      i.event.bind(element, 'pointerdown', touchStart);
      i.event.bind(element, 'pointermove', touchMove);
      i.event.bind(element, 'pointerup', touchEnd);
    } else if (window.MSPointerEvent) {
      i.event.bind(window, 'MSPointerDown', globalTouchStart);
      i.event.bind(window, 'MSPointerUp', globalTouchEnd);
      i.event.bind(element, 'MSPointerDown', touchStart);
      i.event.bind(element, 'MSPointerMove', touchMove);
      i.event.bind(element, 'MSPointerUp', touchEnd);
    }
  }
}

module.exports = function (element) {
  if (!_.env.supportsTouch && !_.env.supportsIePointer) {
    return;
  }

  var i = instances.get(element);
  bindTouchHandler(element, i, _.env.supportsTouch, _.env.supportsIePointer);
};


/***/ },
/* 880 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _ = __webpack_require__(68);
var cls = __webpack_require__(213);
var instances = __webpack_require__(39);
var updateGeometry = __webpack_require__(69);

// Handlers
var handlers = {
  'click-rail': __webpack_require__(873),
  'drag-scrollbar': __webpack_require__(874),
  'keyboard': __webpack_require__(875),
  'wheel': __webpack_require__(876),
  'touch': __webpack_require__(879),
  'selection': __webpack_require__(878)
};
var nativeScrollHandler = __webpack_require__(877);

module.exports = function (element, userSettings) {
  userSettings = typeof userSettings === 'object' ? userSettings : {};

  cls.add(element, 'ps-container');

  // Create a plugin instance.
  var i = instances.add(element);

  i.settings = _.extend(i.settings, userSettings);
  cls.add(element, 'ps-theme-' + i.settings.theme);

  i.settings.handlers.forEach(function (handlerName) {
    handlers[handlerName](element);
  });

  nativeScrollHandler(element);

  updateGeometry(element);
};


/***/ },
/* 881 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _ = __webpack_require__(68);
var dom = __webpack_require__(107);
var instances = __webpack_require__(39);
var updateGeometry = __webpack_require__(69);
var updateScroll = __webpack_require__(87);

module.exports = function (element) {
  var i = instances.get(element);

  if (!i) {
    return;
  }

  // Recalcuate negative scrollLeft adjustment
  i.negativeScrollAdjustment = i.isNegativeScroll ? element.scrollWidth - element.clientWidth : 0;

  // Recalculate rail margins
  dom.css(i.scrollbarXRail, 'display', 'block');
  dom.css(i.scrollbarYRail, 'display', 'block');
  i.railXMarginWidth = _.toInt(dom.css(i.scrollbarXRail, 'marginLeft')) + _.toInt(dom.css(i.scrollbarXRail, 'marginRight'));
  i.railYMarginHeight = _.toInt(dom.css(i.scrollbarYRail, 'marginTop')) + _.toInt(dom.css(i.scrollbarYRail, 'marginBottom'));

  // Hide scrollbars not to affect scrollWidth and scrollHeight
  dom.css(i.scrollbarXRail, 'display', 'none');
  dom.css(i.scrollbarYRail, 'display', 'none');

  updateGeometry(element);

  // Update top/left scroll to trigger events
  updateScroll(element, 'top', element.scrollTop);
  updateScroll(element, 'left', element.scrollLeft);

  dom.css(i.scrollbarXRail, 'display', '');
  dom.css(i.scrollbarYRail, 'display', '');
};


/***/ },
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */
/***/ function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(817);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(16)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../node_modules/css-loader/index.js!../node_modules/sass-loader/index.js!./app.cmp.scss", function() {
			var newContent = require("!!../node_modules/css-loader/index.js!../node_modules/sass-loader/index.js!./app.cmp.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ },
/* 1132 */
/***/ function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(818);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(16)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/index.js!./catalog.cmp.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/index.js!./catalog.cmp.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ },
/* 1133 */
/***/ function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(819);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(16)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/index.js!./summary.cmp.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/index.js!./summary.cmp.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ },
/* 1134 */
/***/ function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(820);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(16)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./generator-configurator.cmp.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./generator-configurator.cmp.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ },
/* 1135 */
/***/ function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(821);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(16)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./email-summary.cmp.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./email-summary.cmp.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ },
/* 1136 */
/***/ function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(822);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(16)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./print-summary.cmp.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./print-summary.cmp.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ },
/* 1137 */
/***/ function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(823);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(16)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./product-categories-list.cmp.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./product-categories-list.cmp.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ },
/* 1138 */
/***/ function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(824);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(16)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./product-categories.cmp.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./product-categories.cmp.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ },
/* 1139 */
/***/ function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(825);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(16)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./product-category.cmp.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./product-category.cmp.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ },
/* 1140 */
/***/ function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(826);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(16)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./product-details.cmp.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./product-details.cmp.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ },
/* 1141 */
/***/ function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(827);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(16)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./product-options-dropdown.cmp.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./product-options-dropdown.cmp.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ },
/* 1142 */
/***/ function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(828);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(16)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./products-list.cmp.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./products-list.cmp.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ },
/* 1143 */
/***/ function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(829);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(16)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./products-tiny-list.cmp.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./products-tiny-list.cmp.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ },
/* 1144 */
/***/ function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(830);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(16)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./scene-tooltip.cmp.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./scene-tooltip.cmp.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ },
/* 1145 */
/***/ function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(831);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(16)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./scene.cmp.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./scene.cmp.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ },
/* 1146 */
/***/ function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(832);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(16)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./summary.cmp.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./summary.cmp.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ },
/* 1147 */
/***/ function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(834);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(16)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./alert.cmp.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./alert.cmp.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ },
/* 1148 */
/***/ function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(835);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(16)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./navigation-menu.cmp.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./navigation-menu.cmp.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ },
/* 1149 */
/***/ function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(836);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(16)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./options-menu.cmp.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./options-menu.cmp.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ },
/* 1150 */
/***/ function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(837);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(16)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./quick-menu.cmp.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./quick-menu.cmp.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ },
/* 1151 */
/***/ function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(838);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(16)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./start-arrow.cmp.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./start-arrow.cmp.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ },
/* 1152 */
/***/ function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(839);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(16)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./modal.cmp.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./modal.cmp.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ },
/* 1153 */
/***/ function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(840);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(16)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/index.js!./not-found-404-page.cmp.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/index.js!./not-found-404-page.cmp.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ },
/* 1154 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var platform_browser_dynamic_1 = __webpack_require__(225);
var app_module_1 = __webpack_require__(514);
var hot_store_1 = __webpack_require__(329);
var ng_environment_1 = __webpack_require__(515);
__webpack_require__(518);
function main() {
    return platform_browser_dynamic_1.platformBrowserDynamic()
        .bootstrapModule(app_module_1.AppModule)
        .then(ng_environment_1.decorateModuleRef);
}
if (false) {
    hot_store_1.hotModuleReplacement(main, module);
}
else {
    platform_browser_dynamic_1.platformBrowserDynamic()
        .bootstrapModule(app_module_1.AppModule)
        .then(ng_environment_1.decorateModuleRef);
}


/***/ }
],[1154]);


// WEBPACK FOOTER //
// app.5667c9d8ab59b36c98aa.js